var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment14 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment2(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment14;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal2;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment2;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/prop-types/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (false) {
      module.exports = null;
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (true) {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location2, componentName2, getStack) {
      if (true) {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName2 || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName2, location2, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName2 || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location2 + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (true) {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (true) {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement4, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (true) {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName2, location2, propFullName, secret) {
          componentName2 = componentName2 || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (typeof console !== "undefined") {
              var cacheKey = componentName2 + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName2 + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName2 + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName2 + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName2, location2, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName2, location2, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName2 + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName2, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName2 + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName2 + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName2, location2, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName2, location2, propFullName) {
          var propValue = props[propName];
          if (!isValidElement4(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName2 + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName2, location2, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName2 + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName2, location2, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName2 + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (true) {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName2, location2, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName2 + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName2, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName2 + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName2 + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName2, location2, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          true ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName2, location2, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName2, location2, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName2 + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName2, location2, propFullName) {
          if (!isNode3(props[propName])) {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName2 + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName2, location2, propFullName, key, type) {
        return new PropTypeError(
          (componentName2 || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName2, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName2 + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName2, location2, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName2, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName2, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName2 + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName2, location2, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName2 + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName2, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode3(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode3);
            }
            if (propValue === null || isValidElement4(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode3(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode3(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    if (true) {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = null();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/@amzn/awsui-components-react-v3/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development2 = __commonJS({
  "../../node_modules/@amzn/awsui-components-react-v3/node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var REACT_ELEMENT_TYPE = Symbol.for("react.element");
        var REACT_PORTAL_TYPE = Symbol.for("react.portal");
        var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
        var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
        var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
        var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
        var REACT_CONTEXT_TYPE = Symbol.for("react.context");
        var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
        var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
        var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
        var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
        var REACT_MEMO_TYPE = Symbol.for("react.memo");
        var REACT_LAZY_TYPE = Symbol.for("react.lazy");
        var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
        var enableScopeAPI = false;
        var enableCacheElement = false;
        var enableTransitionTracing = false;
        var enableLegacyHidden = false;
        var enableDebugTracing = false;
        var REACT_MODULE_REFERENCE;
        {
          REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
        }
        function isValidElementType(type) {
          if (typeof type === "string" || typeof type === "function") {
            return true;
          }
          if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
            return true;
          }
          if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
              return true;
            }
          }
          return false;
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                  case REACT_SUSPENSE_LIST_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_SERVER_CONTEXT_TYPE:
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment14 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        var hasWarnedAboutDeprecatedIsConcurrentMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isConcurrentMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
              hasWarnedAboutDeprecatedIsConcurrentMode = true;
              console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment2(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        function isSuspenseList(object) {
          return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
        }
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment14;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal2;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.SuspenseList = SuspenseList;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment2;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isSuspenseList = isSuspenseList;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/@amzn/awsui-components-react-v3/node_modules/react-is/index.js
var require_react_is2 = __commonJS({
  "../../node_modules/@amzn/awsui-components-react-v3/node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (false) {
      module.exports = null;
    } else {
      module.exports = require_react_is_development2();
    }
  }
});

// ../../node_modules/@amzn/aws-arn-util/dist/lib/StringSizeInBytes.js
var require_StringSizeInBytes = __commonJS({
  "../../node_modules/@amzn/aws-arn-util/dist/lib/StringSizeInBytes.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.stringSizeInBytes = void 0;
    var root = typeof self !== "undefined" ? self : exports;
    var stringSizeInBytes;
    exports.stringSizeInBytes = stringSizeInBytes;
    if (root && "Buffer" in root) {
      exports.stringSizeInBytes = stringSizeInBytes = function(str) {
        return root.Buffer.from(str, "utf8").length;
      };
    } else if (root && "Blob" in root) {
      exports.stringSizeInBytes = stringSizeInBytes = function(str) {
        return new Blob([str], { type: "text/plain" }).size;
      };
    } else {
      exports.stringSizeInBytes = stringSizeInBytes = function(str) {
        var length = str.length;
        var bytes = length;
        for (var i = length - 1; i >= 0; i--) {
          var code = str.charCodeAt(i);
          if (code > 127 && code <= 2047) {
            bytes += 1;
          } else if (code > 2047 && code <= 65535) {
            bytes += 2;
          }
          if (code >= 56320 && code <= 57343) {
            i -= 1;
          }
        }
        return bytes;
      };
    }
  }
});

// ../../node_modules/@amzn/aws-arn-util/dist/lib/Arn.js
var require_Arn = __commonJS({
  "../../node_modules/@amzn/aws-arn-util/dist/lib/Arn.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Arn = void 0;
    var StringSizeInBytes_1 = require_StringSizeInBytes();
    var Arn2 = (
      /** @class */
      function() {
        function Arn3(partition, service, region, accountId, resourceInfo) {
          if (!service || !partition || !resourceInfo) {
            throw new Error("Service, partition or resource must be passed");
          }
          this.service = service;
          this.partition = partition;
          this.region = region || "";
          this.accountId = accountId || "";
          this.resourceInfo = resourceInfo;
          var _a3 = this.parseResourceInfo(), resource = _a3.resource, resourceType = _a3.resourceType;
          this.resource = resource;
          this.resourceType = resourceType;
          this.resourceId = this.parseResourceId();
        }
        Arn3.fromString = function(arnString, strictSizeCheck) {
          if (strictSizeCheck === void 0) {
            strictSizeCheck = false;
          }
          if (!arnString) {
            throw new Error("ARN should not be empty string or null or undefined");
          }
          if (strictSizeCheck && StringSizeInBytes_1.stringSizeInBytes(arnString) > Arn3.MAX_SIZE) {
            throw new Error("ARN should be at most " + Arn3.MAX_SIZE + " bytes");
          }
          if (!arnString.startsWith(Arn3.PREFIX + ":")) {
            throw new Error("ARN should be prefixed");
          }
          var parts = arnString.match(this.ARN_REG_EXP);
          if (!parts) {
            throw new Error("Invalid ARN format: " + arnString);
          }
          var partition = parts[1], service = parts[2], region = parts[3], accountId = parts[4], resourceInfo = parts[5];
          return new Arn3(partition, service, region, accountId, resourceInfo);
        };
        Arn3.prototype.toString = function() {
          return [
            Arn3.PREFIX,
            this.partition,
            this.service,
            this.region,
            this.accountId,
            this.resourceInfo
          ].join(Arn3.DELIMITER_COLON);
        };
        Arn3.prototype.isGlobal = function() {
          return !this.region;
        };
        Object.defineProperty(Arn3.prototype, "vendor", {
          get: function() {
            return this.service;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(Arn3.prototype, "awsAccountId", {
          get: function() {
            if (!Arn3.ACCOUNT_ID_REG_EXP.test(this.accountId)) {
              return "";
            }
            return this.accountId;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(Arn3.prototype, "relativeId", {
          get: function() {
            return this.resourceId.join(Arn3.DELIMITER_SLASH);
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(Arn3.prototype, "formattedResourceId", {
          get: function() {
            if (this.service === "ssm" && this.resourceType === "parameter") {
              if (this.resource.split("/").length > 1) {
                return "/" + this.resource;
              }
            }
            return this.resource;
          },
          enumerable: false,
          configurable: true
        });
        Arn3.prototype.equals = function(other) {
          return this === other ? true : this.toString() === other.toString();
        };
        Arn3.prototype.parseResourceInfo = function() {
          var parts = this.resourceInfo.match(Arn3.SPLIT_RESOURCE_INFO_REG_EXP);
          if (!parts || parts.length === 1) {
            return {
              resource: parts ? parts[1] : this.resourceInfo
            };
          }
          return {
            resourceType: parts[1],
            resource: parts[2]
          };
        };
        Arn3.prototype.parseResourceId = function() {
          var parts = this.resourceInfo.split(Arn3.DELIMITER_COLON);
          var resource = parts[0];
          if (parts.length === 1 && resource.includes(Arn3.DELIMITER_SLASH)) {
            return resource.split(Arn3.DELIMITER_SLASH);
          }
          return parts;
        };
        Arn3.MAX_SIZE = 1600;
        Arn3.PREFIX = "arn";
        Arn3.ACCOUNT_ID_REG_EXP = /^\d{12}$/;
        Arn3.ARN_REG_EXP = /^arn:([\s\S]*?):([\s\S]*?):([\s\S]*?):([\s\S]*?):([\s\S]*)$/;
        Arn3.SPLIT_RESOURCE_INFO_REG_EXP = /^(.*?)[/:](.*)$/;
        Arn3.DELIMITER_COLON = ":";
        Arn3.DELIMITER_SLASH = "/";
        return Arn3;
      }()
    );
    exports.Arn = Arn2;
  }
});

// ../../node_modules/@amzn/aws-arn-util/dist/lib/index.js
var require_lib = __commonJS({
  "../../node_modules/@amzn/aws-arn-util/dist/lib/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Arn = void 0;
    var Arn_1 = require_Arn();
    Object.defineProperty(exports, "Arn", { enumerable: true, get: function() {
      return Arn_1.Arn;
    } });
  }
});

// src/core/Message/Message.tsx
import SpaceBetween from "@cloudscape-design/components/space-between";
import Tabs from "@cloudscape-design/components/tabs";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import LoadingBar from "@cloudscape-design/chat-components/loading-bar";
import * as React from "react";
import { useAppTranslation } from "@amzn/awsmp-max-translations";
import { MessageRole, MessageStatus } from "@amzn/awsmp-max-model";

// src/core/Message/Message.module.scss
var Message_module_default = {
  fadeIn: "Message_module_fadeIn",
  fadeInExpand: "Message_module_fadeInExpand",
  fadeInContent: "Message_module_fadeInContent",
  message: "Message_module_message",
  tabContent: "Message_module_tabContent",
  messageAssistant: "Message_module_messageAssistant",
  contentBox: "Message_module_contentBox",
  messageUser: "Message_module_messageUser",
  stopButtonContainer: "Message_module_stopButtonContainer",
  stopButtonText: "Message_module_stopButtonText",
  loadingBarContainer: "Message_module_loadingBarContainer",
  undoButtonContainer: "Message_module_undoButtonContainer"
};

// src/core/Message/Message.tsx
import { Fragment as Fragment2, jsx, jsxs } from "react/jsx-runtime";
var Message = ({ data, children, onInterrupt, onUndo, feedbackComponent, isTurnActive }) => {
  const { t } = useAppTranslation();
  const { messageId, role, status } = data;
  const isAssistant = role === MessageRole.Assistant;
  const isStreaming = status === MessageStatus.Streaming;
  const isComplete = status === MessageStatus.Complete;
  const [userSelectedTab, setUserSelectedTab] = React.useState(false);
  const [initialTabSet, setInitialTabSet] = React.useState(false);
  const resultsBlocks = React.useMemo(() => children.filter((b) => b.category === "results"), [children]);
  const analysisBlocks = React.useMemo(() => children.filter((b) => b.category === "analysis"), [children]);
  const hasAnalysisContent = analysisBlocks.length > 0;
  const defaultActiveTabId = React.useMemo(() => {
    if (isStreaming) {
      return "analysis";
    }
    if (!hasAnalysisContent) {
      return "results";
    }
    if (isTurnActive) {
      return "analysis";
    }
    return "results";
  }, [isStreaming, isTurnActive, hasAnalysisContent]);
  const [activeTabId, setActiveTabId] = React.useState(defaultActiveTabId);
  const prevMessageIdRef = React.useRef(messageId);
  React.useEffect(() => {
    if (prevMessageIdRef.current !== messageId) {
      prevMessageIdRef.current = messageId;
      setUserSelectedTab(false);
      setInitialTabSet(false);
    }
  }, [messageId]);
  const prevStatusRef = React.useRef(status);
  const prevIsTurnActiveRef = React.useRef(isTurnActive);
  React.useEffect(() => {
    const prevStatus = prevStatusRef.current;
    prevStatusRef.current = status;
    if (prevStatus === MessageStatus.Streaming && status === MessageStatus.Complete) {
      setUserSelectedTab(false);
      setActiveTabId(defaultActiveTabId);
    }
  }, [status, defaultActiveTabId]);
  React.useEffect(() => {
    const prev = prevIsTurnActiveRef.current;
    prevIsTurnActiveRef.current = isTurnActive;
    if (prev && !isTurnActive && status === MessageStatus.Complete && !userSelectedTab) {
      setActiveTabId("results");
    }
  }, [isTurnActive, status, userSelectedTab]);
  React.useEffect(() => {
    if (!userSelectedTab && status === MessageStatus.Streaming && !initialTabSet) {
      setActiveTabId(defaultActiveTabId);
      setInitialTabSet(true);
    }
  }, [userSelectedTab, status, initialTabSet, defaultActiveTabId, messageId]);
  const handleTabChange = React.useCallback(({ detail }) => {
    setActiveTabId(detail.activeTabId);
    setUserSelectedTab(true);
  }, []);
  const tabs = React.useMemo(() => {
    return [
      {
        id: "results",
        label: t("results"),
        disabled: !isComplete || resultsBlocks.length === 0,
        content: /* @__PURE__ */ jsx(Box, { padding: { top: "m" }, className: Message_module_default.tabContent, children: /* @__PURE__ */ jsx(SpaceBetween, { size: "s", children: resultsBlocks.map((block) => /* @__PURE__ */ jsx(React.Fragment, { children: block.component }, block.blockId)) }) })
      },
      {
        id: "analysis",
        label: t("analysisSteps"),
        disabled: !hasAnalysisContent,
        content: /* @__PURE__ */ jsx(Box, { padding: { top: "m" }, className: Message_module_default.tabContent, children: /* @__PURE__ */ jsx(SpaceBetween, { size: "xxxs", children: analysisBlocks.map((block) => /* @__PURE__ */ jsx(React.Fragment, { children: block.component }, block.blockId)) }) })
      }
    ];
  }, [resultsBlocks, hasAnalysisContent, analysisBlocks, isComplete]);
  const effectiveActiveTabId = React.useMemo(() => {
    const active = tabs.find((tab) => tab.id === activeTabId);
    if (active && !active.disabled) {
      return activeTabId;
    }
    return tabs.find((tab) => !tab.disabled)?.id ?? activeTabId;
  }, [tabs, activeTabId]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      "data-component": "Message",
      "data-message-id": messageId,
      "data-role": role,
      className: `${Message_module_default.message} ${isAssistant ? Message_module_default.messageAssistant : Message_module_default.messageUser}`,
      children: /* @__PURE__ */ jsxs("div", { className: Message_module_default.contentBox, children: [
        isAssistant && isStreaming && onInterrupt && /* @__PURE__ */ jsxs("div", { className: Message_module_default.stopButtonContainer, children: [
          /* @__PURE__ */ jsxs(Box, { variant: "span", fontSize: "body-s", fontWeight: "light", className: Message_module_default.stopButtonText, children: [
            t("stopProcessing"),
            " (Esc)"
          ] }),
          /* @__PURE__ */ jsx(Button, { variant: "icon", iconName: "status-stopped", ariaLabel: t("stopProcessing"), onClick: onInterrupt })
        ] }),
        isAssistant ? /* @__PURE__ */ jsxs(Fragment2, { children: [
          /* @__PURE__ */ jsx(Tabs, { disableContentPaddings: true, activeTabId: effectiveActiveTabId, onChange: handleTabChange, tabs }),
          isStreaming && /* @__PURE__ */ jsx("div", { className: Message_module_default.loadingBarContainer, children: /* @__PURE__ */ jsx(LoadingBar, { variant: "gen-ai" }) }),
          isComplete && onUndo && /* @__PURE__ */ jsx("div", { className: Message_module_default.undoButtonContainer, children: /* @__PURE__ */ jsx(Button, { variant: "icon", iconName: "undo", ariaLabel: t("undoLastMessage"), onClick: onUndo }) }),
          isComplete && effectiveActiveTabId === "results" && feedbackComponent
        ] }) : /* @__PURE__ */ jsx(SpaceBetween, { size: "m", children: children.map((block) => /* @__PURE__ */ jsx(React.Fragment, { children: block.component }, block.blockId)) })
      ] })
    }
  );
};

// src/core/ContentBlock/ContentBlock.tsx
import * as React2 from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var ContentBlock = ({ data, children, layoutManager: _, navigationManager: __ }) => {
  const { contentBlockId, category = "display", type, role } = data;
  const childrenWithRole = React2.Children.map(children, (child) => {
    if (React2.isValidElement(child)) {
      return React2.cloneElement(child, { role });
    }
    return child;
  });
  return /* @__PURE__ */ jsx2("div", { "data-component": "ContentBlock", "data-content-block-id": contentBlockId, "data-category": category, "data-type": type, "data-role": role, children: childrenWithRole });
};

// src/core/Text/Text.tsx
import * as React3 from "react";
import { useCitations } from "@amzn/awsmp-max-ux-patterns/Citations";
import { MarkdownRenderer } from "@amzn/awsmp-max-ux-patterns/MarkdownRenderer";
import { MessageRole as MessageRole2 } from "@amzn/awsmp-max-model";
import { Fragment as Fragment4, jsx as jsx3 } from "react/jsx-runtime";
var Text = ({ data, messageRole }) => {
  const { content, citations, citationPattern } = data;
  const textValue = content?.text ?? "";
  const hasCitations = Boolean(citations && citations.length > 0);
  const emptyCitations = React3.useMemo(() => [], []);
  const { processText } = useCitations(citations || emptyCitations, {
    interactionMode: "popup",
    pattern: citationPattern,
    fontSize: "compact"
  });
  const processChildren = React3.useCallback(
    (children) => {
      if (!hasCitations) {
        return children;
      }
      if (typeof children === "string") {
        const processed = processText(children);
        if (Array.isArray(processed)) {
          return processed.length === 1 ? processed[0] : /* @__PURE__ */ jsx3(Fragment4, { children: processed });
        }
        return processed;
      }
      if (Array.isArray(children)) {
        return children.map((child, index) => /* @__PURE__ */ jsx3(React3.Fragment, { children: processChildren(child) }, index));
      }
      return children;
    },
    [hasCitations, processText]
  );
  return /* @__PURE__ */ jsx3(MarkdownRenderer, { variant: messageRole, processChildren, allowSanitizedHtml: messageRole !== MessageRole2.User, children: textValue });
};

// src/core/InlineThink/InlineThink.tsx
var InlineThink = () => {
  return null;
};

// src/core/NotificationBlock/NotificationBlock.tsx
import { useEffect as useEffect2, useRef as useRef2 } from "react";
import Alert from "@cloudscape-design/components/alert";
import { jsx as jsx4 } from "react/jsx-runtime";
var NotificationBlock = ({ data, logger }) => {
  const isInterrupt = "interrupt" in data.content;
  const isError = "error" in data.content;
  const message = isInterrupt ? data.content.interrupt?.message : isError ? data.content.error?.message : void 0;
  const type = isInterrupt ? "warning" : "error";
  const header = isInterrupt ? "Processing Interrupted" : "Error Occurred";
  const hasEmittedMetrics = useRef2(false);
  useEffect2(() => {
    hasEmittedMetrics.current = false;
  }, [data]);
  useEffect2(() => {
    if (!message || hasEmittedMetrics.current)
      return;
    hasEmittedMetrics.current = true;
    if (isInterrupt) {
      logger.warn("Notification: Processing interrupted", { message });
      logger.opsMetric({
        metricName: "NotificationBlockInterruptCount",
        unit: "Count",
        value: 1,
        dimensions: {
          NotificationType: "interrupt",
          Component: "NotificationBlock"
        }
      });
    } else {
      logger.error("Notification: Error occurred", void 0, { message });
      logger.opsMetric({
        metricName: "NotificationBlockErrorCount",
        unit: "Count",
        value: 1,
        dimensions: {
          Component: "NotificationBlock"
        }
      });
    }
  }, [isInterrupt, logger, message]);
  if (!message)
    return null;
  return /* @__PURE__ */ jsx4(Alert, { type, header, children: /* @__PURE__ */ jsx4("div", { children: message }) });
};

// src/results/LinkToArtifact/LinkToArtifact.tsx
import * as React7 from "react";
import ContentLayout from "@cloudscape-design/components/content-layout";
import SpaceBetween3 from "@cloudscape-design/components/space-between";
import Button2 from "@cloudscape-design/components/button";
import { ArtifactThumbnailContainer } from "@amzn/awsmp-max-ux-patterns/ArtifactThumbnailContainer";
import { ArtifactActions } from "@amzn/awsmp-max-ux-patterns/ArtifactActions";
import { exportAsPDF, exportAsCSV, createDownloadPDFHandler, createDownloadMarkdownHandler } from "@amzn/awsmp-max-ux-patterns/DocumentExporter";
import { useAppTranslation as useAppTranslation3 } from "@amzn/awsmp-max-translations";

// src/results/LinkToArtifact/ComparisonActions.tsx
import * as React5 from "react";
import SpaceBetween2 from "@cloudscape-design/components/space-between";
import Box2 from "@cloudscape-design/components/box";
import { ClickableOptions } from "@amzn/awsmp-max-ux-patterns/ClickableOptions";
import { ProductSelector } from "@amzn/awsmp-max-ux-patterns/ProductSelector";
import { useAppTranslation as useAppTranslation2 } from "@amzn/awsmp-max-translations";
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var ComparisonActions = ({
  artifact,
  searchArtifact,
  maxService,
  sendMessage,
  flashbar,
  promptInputActions,
  logger
}) => {
  const { t, currentLanguage } = useAppTranslation2();
  const [showProductSelector, setShowProductSelector] = React5.useState(false);
  const [selectedProducts, setSelectedProducts] = React5.useState([]);
  const artifactProducts = React5.useMemo(() => {
    if (!artifact || artifact.artifactType !== "comparison" || !artifact.products)
      return [];
    if (Array.isArray(artifact.products)) {
      return artifact.products.map((p) => ({
        productId: p.productId,
        productName: p.productName,
        vendorName: p.vendorName,
        productLogoUrl: p.productLogoUrl
      }));
    }
    return Object.entries(artifact.products).map(([productId, p]) => ({
      productId,
      productName: p.productName,
      vendorName: p.vendorName,
      productLogoUrl: p.productLogoUrl
    }));
  }, [artifact]);
  const recommendedProducts = React5.useMemo(() => {
    if (!searchArtifact || searchArtifact.artifactType !== "search")
      return [];
    const recommendations = searchArtifact.recommendations;
    if (!recommendations || !Array.isArray(recommendations))
      return [];
    return recommendations.map((r2) => ({
      productId: r2.productId,
      productName: r2.productName,
      vendorName: r2.vendorName,
      productLogoUrl: r2.logoUrl,
      pathType: r2.pathType
    }));
  }, [searchArtifact]);
  const otherConsideredProducts = React5.useMemo(() => {
    if (!searchArtifact || searchArtifact.artifactType !== "search")
      return [];
    const otherProducts = searchArtifact.otherProductsConsidered;
    if (!otherProducts || !Array.isArray(otherProducts))
      return [];
    return otherProducts.map((p) => ({
      productId: p.productId,
      productName: p.productName || "",
      vendorName: p.vendorName || "",
      productLogoUrl: void 0,
      // Other products don't have logo URLs
      pathType: p.pathType
    }));
  }, [searchArtifact]);
  const isMatchingExistingComparison = React5.useMemo(() => {
    if (selectedProducts.length === 0)
      return false;
    if (!artifact || artifact.artifactType !== "comparison" || !artifact.products)
      return false;
    const existingIds = (Array.isArray(artifact.products) ? artifact.products.map((p) => p.productId) : Object.keys(artifact.products)).sort();
    const selectedIds = selectedProducts.map((p) => p.productId).sort();
    return existingIds.length === selectedIds.length && existingIds.every((id, index) => id === selectedIds[index]);
  }, [selectedProducts, artifact]);
  const handleProductSelectorError = React5.useCallback(
    (errorMessage) => {
      flashbar.addItem({
        type: "error",
        header: t("searchFailed"),
        content: errorMessage,
        autoDismiss: true,
        dismissTimeout: 5e3
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (!artifact || artifact.artifactType !== "comparison") {
    return null;
  }
  const handleOptionClick = (option) => {
    if (option === t("editProducts")) {
      setShowProductSelector(true);
    } else if (option === t("addCriteria")) {
      promptInputActions.insertTemplate(t("addCriteriaTemplate"));
    }
  };
  const handleProductSelectionConfirm = (products) => {
    const removedProducts = artifactProducts.filter((original) => !products.some((p) => p.productId === original.productId));
    const addedProducts = products.filter((newProduct) => !artifactProducts.some((p) => p.productId === newProduct.productId));
    const formatProducts = (prods) => {
      const productNames = prods.map((p) => p.productName);
      const listFormatter = new Intl.ListFormat(currentLanguage, {
        style: "long",
        type: "conjunction"
      });
      return listFormatter.format(productNames);
    };
    let message;
    if (removedProducts.length > 0 && addedProducts.length > 0) {
      message = t("removeAndAddProducts", {
        removedProducts: formatProducts(removedProducts),
        addedProducts: formatProducts(addedProducts)
      });
    } else if (addedProducts.length > 0) {
      message = t("addProductsToComparison", { products: formatProducts(addedProducts) });
    } else if (removedProducts.length > 0) {
      message = t("removeProductsFromComparison", { products: formatProducts(removedProducts) });
    } else {
      message = t("updateComparisonWithProducts", { products: formatProducts(products) });
    }
    const listingIds = products.map((p) => p.productId);
    sendMessage({
      contentBlocks: [{ text: message }],
      agent: {
        agentId: "comparison",
        listingIds
      }
    });
    setShowProductSelector(false);
  };
  return /* @__PURE__ */ jsxs2(SpaceBetween2, { size: "m", children: [
    /* @__PURE__ */ jsxs2(SpaceBetween2, { size: "xs", children: [
      /* @__PURE__ */ jsx5(Box2, { variant: "h5", fontWeight: "bold", children: t("updateComparison") }),
      /* @__PURE__ */ jsx5(
        ClickableOptions,
        {
          options: [t("editProducts"), t("addCriteria")],
          onSelect: handleOptionClick,
          ariaLabel: t("artifactActions"),
          logger
        }
      )
    ] }),
    showProductSelector && /* @__PURE__ */ jsx5(
      ProductSelector,
      {
        maxService,
        initialProducts: artifactProducts,
        onChange: setSelectedProducts,
        disabled: isMatchingExistingComparison,
        onConfirm: handleProductSelectionConfirm,
        onCancel: () => setShowProductSelector(false),
        onError: handleProductSelectorError,
        recommendedProducts,
        otherConsideredProducts
      }
    )
  ] });
};

// src/results/LinkToArtifact/LinkToArtifact.module.scss
var LinkToArtifact_module_default = {
  titleContainer: "LinkToArtifact_module_titleContainer",
  title: "LinkToArtifact_module_title"
};

// src/results/LinkToArtifact/LinkToArtifact.tsx
import {
  ProductSearch,
  ProductSearchThumbnail,
  ProductComparison,
  ProductComparisonThumbnail,
  ProductComparisonAsStandaloneReport,
  ProductEvaluation,
  ProductEvaluationThumbnail,
  ArtifactFallback,
  convertToCSV
} from "@amzn/awsmp-max-agentic-ui-artifacts";
import {
  DEFAULT_FEATURE_SWITCH_CONFIG,
  detectStageFromHostname,
  isSearchV2MarkedSection
} from "@amzn/awsmp-max-model";
import {
  ArtifactWidgetStatus,
  getArtifactLabel,
  resolveArtifactLabel,
  useArtifactWidgets
} from "@amzn/awsmp-max-data";

// src/results/LinkToArtifact/RenderToDomWrapper.tsx
import * as React6 from "react";

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/metrics-constants.js
var CustomOpsMetricName;
(function(CustomOpsMetricName2) {
  CustomOpsMetricName2["ClientSide404"] = "ClientSide404";
  CustomOpsMetricName2["ClientSide500"] = "ClientSide500";
  CustomOpsMetricName2["ClientSide500Ignored"] = "ClientSide500Ignored";
  CustomOpsMetricName2["ClientSideNonFatalToolCallError"] = "ClientSideNonFatalToolCallError";
  CustomOpsMetricName2["ClientSideThrottled"] = "ClientSideThrottled";
  CustomOpsMetricName2["ClientSideReconnectionRateLimited"] = "ClientSideReconnectionRateLimited";
  CustomOpsMetricName2["ClientSidePatchDropped"] = "ClientSidePatchDropped";
  CustomOpsMetricName2["ClientSideConversationMismatch"] = "ClientSideConversationMismatch";
  CustomOpsMetricName2["ClientSidePatchRecoveryAttempt"] = "ClientSidePatchRecoveryAttempt";
  CustomOpsMetricName2["ClientSidePatchRecoverySuccess"] = "ClientSidePatchRecoverySuccess";
  CustomOpsMetricName2["ClientSidePatchRecoveryFailure"] = "ClientSidePatchRecoveryFailure";
  CustomOpsMetricName2["MintRefused"] = "MintRefused";
  CustomOpsMetricName2["SessionResetUnavailable"] = "SessionResetUnavailable";
  CustomOpsMetricName2["OriginGrantRecoveryNavigated"] = "OriginGrantRecoveryNavigated";
  CustomOpsMetricName2["OriginGrantRecoveryExhausted"] = "OriginGrantRecoveryExhausted";
  CustomOpsMetricName2["ArtifactFallbackRender"] = "ArtifactFallbackRender";
  CustomOpsMetricName2["FederatedArtifactRenderSuccess"] = "FederatedArtifactRenderSuccess";
  CustomOpsMetricName2["FederatedArtifactRenderError"] = "FederatedArtifactRenderError";
  CustomOpsMetricName2["FederatedArtifactRenderLatency"] = "FederatedArtifactRenderLatency";
  CustomOpsMetricName2["FederatedWidgetLoadFailure"] = "FederatedWidgetLoadFailure";
  CustomOpsMetricName2["EPOBuyerUnonboardedPageRender"] = "EPOBuyerUnonboardedPageRender";
  CustomOpsMetricName2["EPOBuyerLeadReferralValueInvalid"] = "EPOBuyerLeadReferralValueInvalid";
  CustomOpsMetricName2["EPOBuyerLeadFormLoadFailure"] = "EPOBuyerLeadFormLoadFailure";
  CustomOpsMetricName2["EPOBuyerLeadFormLoadSuccess"] = "EPOBuyerLeadFormLoadSuccess";
  CustomOpsMetricName2["EPOBuyerLeadSubmitFailure"] = "EPOBuyerLeadSubmitFailure";
  CustomOpsMetricName2["EPOBuyerLeadSubmitSuccess"] = "EPOBuyerLeadSubmitSuccess";
  CustomOpsMetricName2["EPOBuyerLeadValidationFailure"] = "EPOBuyerLeadValidationFailure";
  CustomOpsMetricName2["EPOBuyerLeadSubmitNotReady"] = "EPOBuyerLeadSubmitNotReady";
  CustomOpsMetricName2["EPOBuyerLeadTerminalSubmitFailure"] = "EPOBuyerLeadTerminalSubmitFailure";
  CustomOpsMetricName2["EPOBuyerRenewalPreviewDerivationFailure"] = "EPOBuyerRenewalPreviewDerivationFailure";
  CustomOpsMetricName2["RecommendUnitsError"] = "RecommendUnitsError";
  CustomOpsMetricName2["EPOSellerMultiplePublicOffers"] = "EPOSellerMultiplePublicOffers";
  CustomOpsMetricName2["EPOSellerUnexpectedEulaType"] = "EPOSellerUnexpectedEulaType";
  CustomOpsMetricName2["EPOSellerBatchDescribePartialFailure"] = "EPOSellerBatchDescribePartialFailure";
  CustomOpsMetricName2["EPOSellerBatchDescribeFailure"] = "EPOSellerBatchDescribeFailure";
  CustomOpsMetricName2["EPOSellerNoPublicOfferFound"] = "EPOSellerNoPublicOfferFound";
  CustomOpsMetricName2["EPOSellerNoPublicOfferFreeTrialOnly"] = "EPOSellerNoPublicOfferFreeTrialOnly";
  CustomOpsMetricName2["EPOSellerCreateChangeSetRejected"] = "EPOSellerCreateChangeSetRejected";
  CustomOpsMetricName2["EPOSellerCreateStatusCheckUnavailable"] = "EPOSellerCreateStatusCheckUnavailable";
  CustomOpsMetricName2["CapiThrottleRetry"] = "CapiThrottleRetry";
  CustomOpsMetricName2["CapiThrottleExhausted"] = "CapiThrottleExhausted";
  CustomOpsMetricName2["CapiTransientRetry"] = "CapiTransientRetry";
  CustomOpsMetricName2["CapiTransientExhausted"] = "CapiTransientExhausted";
})(CustomOpsMetricName || (CustomOpsMetricName = {}));
var CustomOpsSdkServiceName;
(function(CustomOpsSdkServiceName2) {
  CustomOpsSdkServiceName2["MARKETPLACE_DISCOVERY"] = "MarketplaceDiscovery";
  CustomOpsSdkServiceName2["MARKETPLACE_AGREEMENT"] = "MarketplaceAgreement";
  CustomOpsSdkServiceName2["MARKETPLACE_CATALOG"] = "MarketplaceCatalog";
})(CustomOpsSdkServiceName || (CustomOpsSdkServiceName = {}));

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/sdk-metrics/types.js
var STATUS_CODE_CLASS;
(function(STATUS_CODE_CLASS2) {
  STATUS_CODE_CLASS2["TWO_HUNDRED"] = "200";
  STATUS_CODE_CLASS2["FOUR_HUNDRED"] = "400";
  STATUS_CODE_CLASS2["FIVE_HUNDRED"] = "500";
})(STATUS_CODE_CLASS || (STATUS_CODE_CLASS = {}));

// src/results/LinkToArtifact/RenderToDomWrapper.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var RenderToDomWrapper = ({ renderToDom, data, ...api }) => {
  const containerRef = React6.useRef(null);
  const rendererRef = React6.useRef(null);
  const apiRef = React6.useRef(api);
  const isInitialMount = React6.useRef(true);
  apiRef.current = api;
  const emitMetric = React6.useCallback(
    (metricName, unit, value) => {
      api.logger?.opsMetric?.({ metricName, unit, value, dimensions: { artifactType: api.artifactType } });
    },
    [api.logger, api.artifactType]
  );
  React6.useEffect(() => {
    if (!containerRef.current)
      return;
    const startTime = performance.now();
    try {
      rendererRef.current = renderToDom({ container: containerRef.current, data, api: apiRef.current });
      const latency = performance.now() - startTime;
      emitMetric(CustomOpsMetricName.FederatedArtifactRenderSuccess, "Count", 1);
      emitMetric(CustomOpsMetricName.FederatedArtifactRenderLatency, "Milliseconds", latency);
    } catch (_error) {
      emitMetric(CustomOpsMetricName.FederatedArtifactRenderError, "Count", 1);
    }
    return () => {
      rendererRef.current?.unmount();
      rendererRef.current = null;
    };
  }, [renderToDom]);
  React6.useEffect(() => {
    try {
      rendererRef.current?.setStatus?.(api.status);
    } catch (_error) {
      emitMetric(CustomOpsMetricName.FederatedArtifactRenderError, "Count", 1);
    }
  }, [api.status]);
  React6.useLayoutEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    try {
      rendererRef.current?.setData(data);
    } catch (_error) {
      emitMetric(CustomOpsMetricName.FederatedArtifactRenderError, "Count", 1);
    }
  }, [data]);
  return /* @__PURE__ */ jsx6("div", { ref: containerRef });
};

// src/results/panelSizing.ts
var APP_LAYOUT_CONTENT_GAPS = 2 * 24;
var SPLIT_PANEL_MIN_WIDTH = 280;
var ARTIFACT_PRIMARY_BREAKPOINT_L = 1320;
var ARTIFACT_PRIMARY_BREAKPOINT_XL = 1840;
var ARTIFACT_PRIMARY_CHAT_WIDTH_BASE = 400;
var ARTIFACT_PRIMARY_CHAT_WIDTH_L = 440;
var ARTIFACT_PRIMARY_CHAT_WIDTH_XL = 520;
function artifactPrimaryChatWidth(viewport) {
  if (viewport >= ARTIFACT_PRIMARY_BREAKPOINT_XL)
    return ARTIFACT_PRIMARY_CHAT_WIDTH_XL;
  if (viewport >= ARTIFACT_PRIMARY_BREAKPOINT_L)
    return ARTIFACT_PRIMARY_CHAT_WIDTH_L;
  return ARTIFACT_PRIMARY_CHAT_WIDTH_BASE;
}
function panelSizeForViewport(mode, viewport) {
  switch (mode) {
    case "artifact-primary":
      return Math.max(SPLIT_PANEL_MIN_WIDTH, Math.floor(viewport - artifactPrimaryChatWidth(viewport) - APP_LAYOUT_CONTENT_GAPS));
    case "default":
      return Math.floor(viewport * 0.5);
  }
}

// src/results/LinkToArtifact/LinkToArtifact.tsx
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
function useSplitPanelSizeOnMount(splitPanel, mode) {
  React7.useEffect(() => {
    splitPanel.updateMetadata({ size: panelSizeForViewport(mode, window.innerWidth) });
  }, []);
}
var ProductSearchCompact = (props) => /* @__PURE__ */ jsx7(ProductSearchThumbnail, { data: props.data, logger: props.logger });
var ProductComparisonCompact = (props) => /* @__PURE__ */ jsx7(ProductComparisonThumbnail, { data: props.data });
var ProductEvaluationCompact = (props) => /* @__PURE__ */ jsx7(ProductEvaluationThumbnail, { data: props.data });
var SEARCH_V2_ARTIFACT_TYPE = "search-v2";
function chooseSearchRenderer(BuiltIn, Widget) {
  if (!Widget)
    return BuiltIn;
  const searchV2Stages = DEFAULT_FEATURE_SWITCH_CONFIG.searchV2Stages ?? [];
  if (searchV2Stages.includes(detectStageFromHostname(window.location.hostname)))
    return Widget;
  const SearchRenderer = (props) => isSearchV2MarkedSection(props.data) ? /* @__PURE__ */ jsx7(Widget, { ...props }) : /* @__PURE__ */ jsx7(BuiltIn, { ...props });
  return SearchRenderer;
}
function createArtifactThumbnailComponents(federatedAgentWidgets = []) {
  const federatedThumbnails = {};
  for (const mod of federatedAgentWidgets) {
    if (!mod.renderThumbnailToDom)
      continue;
    federatedThumbnails[mod.artifactType] = (props) => /* @__PURE__ */ jsx7(RenderToDomWrapper, { renderToDom: mod.renderThumbnailToDom, ...props });
  }
  return {
    ...federatedThumbnails,
    search: chooseSearchRenderer(ProductSearchCompact, federatedThumbnails[SEARCH_V2_ARTIFACT_TYPE]),
    comparison: ProductComparisonCompact,
    evaluation: ProductEvaluationCompact,
    fallback: ArtifactFallback
  };
}
function createSplitPanelArtifactComponents(t, federatedAgentWidgets = []) {
  const SearchWithActions = (props) => {
    const setTitle = React7.useCallback(
      (title) => {
        props.layoutManager.splitPanel.setContent({
          header: title
        });
      },
      [props.layoutManager]
    );
    useSplitPanelSizeOnMount(props.layoutManager.splitPanel, "default");
    return /* @__PURE__ */ jsxs3(ContentLayout, { children: [
      /* @__PURE__ */ jsx7("div", { style: { display: "flex", justifyContent: "flex-end", marginBottom: "16px" }, children: /* @__PURE__ */ jsx7(ArtifactActions, { onExpand: props.onExpand }) }),
      /* @__PURE__ */ jsx7(ProductSearch, { ...props, setTitle, variant: "compact", mode: "edit" })
    ] });
  };
  const ComparisonWithActions = (props) => {
    const { t: t2 } = useAppTranslation3();
    const handleDownloadCSV = async () => {
      await exportAsCSV(
        convertToCSV(props.data, t2, { complianceInsightsEnabled: props.complianceInsightsEnabled === true }),
        `product-comparison.csv`
      );
    };
    const handleDownloadPDF = async () => {
      await exportAsPDF(/* @__PURE__ */ jsx7(ProductComparisonAsStandaloneReport, { data: props.data, title: "Product Comparison" }), `product-comparison.pdf`);
    };
    useSplitPanelSizeOnMount(props.layoutManager.splitPanel, "default");
    return /* @__PURE__ */ jsxs3(ContentLayout, { children: [
      /* @__PURE__ */ jsx7("div", { style: { display: "flex", justifyContent: "flex-end", marginBottom: "16px" }, children: /* @__PURE__ */ jsx7(ArtifactActions, { onDownloadCSV: handleDownloadCSV, onDownloadPDF: handleDownloadPDF, onExpand: props.onExpand }) }),
      /* @__PURE__ */ jsx7(ProductComparison, { ...props })
    ] });
  };
  const EvaluationWithActions = (props) => {
    const handleDownloadPDF = async () => {
      await exportAsPDF(/* @__PURE__ */ jsx7(ProductEvaluation, { ...props }), `${props.data.metadata.reportTitle}.pdf`);
    };
    useSplitPanelSizeOnMount(props.layoutManager.splitPanel, "default");
    return /* @__PURE__ */ jsxs3(ContentLayout, { children: [
      /* @__PURE__ */ jsx7("div", { style: { display: "flex", justifyContent: "flex-end", marginBottom: "16px" }, children: /* @__PURE__ */ jsx7(ArtifactActions, { onDownloadPDF: handleDownloadPDF, onExpand: props.onExpand }) }),
      /* @__PURE__ */ jsx7(ProductEvaluation, { ...props })
    ] });
  };
  const federatedComponents = {};
  const settledWidgets = { status: ArtifactWidgetStatus.Loaded, widgets: federatedAgentWidgets };
  for (const mod of federatedAgentWidgets) {
    if (!mod.renderArtifactToDom)
      continue;
    const supportedActions = mod.supportedActions;
    const displayName = resolveArtifactLabel(getArtifactLabel(mod.artifactType, settledWidgets), t);
    const WrappedFederatedRenderer = (props) => {
      const containerRef = React7.useRef(null);
      useSplitPanelSizeOnMount(props.layoutManager.splitPanel, mod.artifactPresentation);
      const handleDownloadPDF = supportedActions?.downloadPDF ? createDownloadPDFHandler(
        supportedActions.downloadPDF,
        () => containerRef.current,
        () => props.data,
        displayName
      ) : void 0;
      const handleDownloadMarkdown = supportedActions?.downloadMarkdown ? createDownloadMarkdownHandler(
        supportedActions.downloadMarkdown,
        () => containerRef.current,
        () => props.data,
        displayName
      ) : void 0;
      return /* @__PURE__ */ jsxs3(ContentLayout, { children: [
        /* @__PURE__ */ jsx7("div", { style: { display: "flex", justifyContent: "flex-end", marginBottom: "16px" }, children: /* @__PURE__ */ jsx7(ArtifactActions, { onDownloadPDF: handleDownloadPDF, onExpand: props.onExpand, onDownloadMarkdown: handleDownloadMarkdown }) }),
        /* @__PURE__ */ jsx7("div", { ref: containerRef, children: /* @__PURE__ */ jsx7(RenderToDomWrapper, { renderToDom: mod.renderArtifactToDom, ...props }) })
      ] });
    };
    federatedComponents[mod.artifactType] = WrappedFederatedRenderer;
  }
  return {
    ...federatedComponents,
    search: chooseSearchRenderer(SearchWithActions, federatedComponents[SEARCH_V2_ARTIFACT_TYPE]),
    comparison: ComparisonWithActions,
    evaluation: EvaluationWithActions,
    fallback: ArtifactFallback
  };
}
var LinkToArtifact = ({ data, rendererAPI }) => {
  const { t } = useAppTranslation3();
  const {
    windowSize,
    projectId,
    renderArtifactInSplitPanel,
    renderArtifacts,
    getArtifact,
    navigationManager,
    maxService,
    sendMessage,
    layoutManager,
    promptInputActions,
    logger
  } = rendererAPI;
  const artifactWidgets = useArtifactWidgets();
  const SPLIT_PANEL_COMPONENTS = React7.useMemo(() => createSplitPanelArtifactComponents(t, artifactWidgets.widgets), [artifactWidgets.widgets, t]);
  const THUMBNAIL_COMPONENTS = React7.useMemo(() => createArtifactThumbnailComponents(artifactWidgets.widgets), [artifactWidgets.widgets]);
  const toolData = data.input;
  const artifactType = toolData?.artifactSection;
  const toolOutput = data.output;
  const toolSucceeded = toolOutput?.hasDisplayableContent ?? (toolOutput?.updatedSections && toolOutput.updatedSections.length > 0);
  const artifact = artifactType ? getArtifact(artifactType) : void 0;
  const searchArtifact = getArtifact("search");
  if (!toolData || !artifactType)
    return null;
  if (!toolSucceeded)
    return null;
  const builtInLabelKeys = {
    epoSellerCreateConfiguration: "artifactEpoSellerCreateConfigurationFull",
    epoBuyerRequest: "artifactEpoBuyerRequestFull",
    epoDiscount: "artifactEpoDiscountFull"
  };
  const handleOpenInSplitPanel = artifact ? () => {
    if (windowSize !== "l") {
      navigationManager.navigate("artifact", { projectId, artifactType });
    } else {
      const component = SPLIT_PANEL_COMPONENTS[artifactType] || SPLIT_PANEL_COMPONENTS.fallback;
      renderArtifactInSplitPanel({ [artifactType]: component });
    }
  } : void 0;
  const artifactToRender = artifact || {
    artifactId: `placeholder-${artifactType}`,
    artifactType,
    name: "",
    json: {}
  };
  const rendered = renderArtifacts([artifactToRender], THUMBNAIL_COMPONENTS);
  const artifactContent = rendered[artifactType];
  const isThisArtifactInPanel = windowSize === "l" && layoutManager.splitPanel.shown && layoutManager.splitPanel.metadata.artifactType === artifactType;
  const handleTogglePanel = artifact ? () => {
    logger.biMetric({
      metricName: "Click",
      unit: "Count",
      value: 1,
      dimensions: {
        ClickAct: "Click",
        ClickSelect: isThisArtifactInPanel ? "hide-artifact-button" : "view-artifact-button",
        ClickObj: "Button",
        ClickFeat: "LinkToArtifact"
      }
    });
    if (isThisArtifactInPanel) {
      layoutManager.splitPanel.hide();
    } else {
      handleOpenInSplitPanel?.();
    }
  } : void 0;
  const comparisonActions = data.output ? /* @__PURE__ */ jsx7(
    ComparisonActions,
    {
      artifact,
      searchArtifact,
      maxService,
      sendMessage,
      flashbar: layoutManager.flashbar,
      promptInputActions,
      logger
    }
  ) : null;
  const titleElement = /* @__PURE__ */ jsxs3("div", { className: LinkToArtifact_module_default.titleContainer, children: [
    /* @__PURE__ */ jsx7("div", { className: LinkToArtifact_module_default.title, children: resolveArtifactLabel(getArtifactLabel(artifactType, artifactWidgets, builtInLabelKeys), t) }),
    artifact && /* @__PURE__ */ jsx7(
      Button2,
      {
        variant: "normal",
        onClick: (event) => {
          event.stopPropagation();
          handleTogglePanel?.();
        },
        children: isThisArtifactInPanel ? t("hide") : t("view")
      }
    )
  ] });
  return /* @__PURE__ */ jsxs3(SpaceBetween3, { size: "m", children: [
    /* @__PURE__ */ jsx7(ArtifactThumbnailContainer, { title: titleElement, onClick: handleOpenInSplitPanel, artifactContent }),
    comparisonActions
  ] });
};

// src/results/WebSearch/WebSearch.tsx
import { useRef as useRef5 } from "react";

// ../../node_modules/motion/dist/es/motion-utils/dist/es/noop.mjs
var noop = /* @__NO_SIDE_EFFECTS__ */ (any) => any;

// ../../node_modules/motion/dist/es/motion-utils/dist/es/errors.mjs
var warning = noop;
var invariant = noop;
if (true) {
  warning = (check, message) => {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = (check, message) => {
    if (!check) {
      throw new Error(message);
    }
  };
}

// ../../node_modules/motion/dist/es/motion-utils/dist/es/memo.mjs
// @__NO_SIDE_EFFECTS__
function memo(callback) {
  let result;
  return () => {
    if (result === void 0)
      result = callback();
    return result;
  };
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/supports/scroll-timeline.mjs
var supportsScrollTimeline = memo(() => window.ScrollTimeline !== void 0);

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/controls/BaseGroup.mjs
var BaseGroupPlaybackControls = class {
  constructor(animations) {
    this.stop = () => this.runAll("stop");
    this.animations = animations.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((animation) => "finished" in animation ? animation.finished : animation));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(propName) {
    return this.animations[0][propName];
  }
  setAll(propName, newValue) {
    for (let i = 0; i < this.animations.length; i++) {
      this.animations[i][propName] = newValue;
    }
  }
  attachTimeline(timeline, fallback) {
    const subscriptions = this.animations.map((animation) => {
      if (supportsScrollTimeline() && animation.attachTimeline) {
        return animation.attachTimeline(timeline);
      } else if (typeof fallback === "function") {
        return fallback(animation);
      }
    });
    return () => {
      subscriptions.forEach((cancel, i) => {
        cancel && cancel();
        this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(time) {
    this.setAll("time", time);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(speed) {
    this.setAll("speed", speed);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let max = 0;
    for (let i = 0; i < this.animations.length; i++) {
      max = Math.max(max, this.animations[i].duration);
    }
    return max;
  }
  runAll(methodName) {
    this.animations.forEach((controls) => controls[methodName]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
};

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/controls/Group.mjs
var GroupPlaybackControls = class extends BaseGroupPlaybackControls {
  then(onResolve, onReject) {
    return Promise.all(this.animations).then(onResolve).catch(onReject);
  }
};

// ../../node_modules/motion/dist/es/motion-utils/dist/es/progress.mjs
var progress = /* @__NO_SIDE_EFFECTS__ */ (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

// ../../node_modules/motion/dist/es/motion-utils/dist/es/time-conversion.mjs
var secondsToMilliseconds = /* @__NO_SIDE_EFFECTS__ */ (seconds) => seconds * 1e3;
var millisecondsToSeconds = /* @__NO_SIDE_EFFECTS__ */ (milliseconds) => milliseconds / 1e3;

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/generators/utils/calc-duration.mjs
var maxGeneratorDuration = 2e4;
function calcGeneratorDuration(generator) {
  let duration = 0;
  const timeStep = 50;
  let state2 = generator.next(duration);
  while (!state2.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state2 = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/generators/utils/create-generator-easing.mjs
function createGeneratorEasing(options, scale = 100, createGenerator) {
  const generator = createGenerator({ ...options, keyframes: [0, scale] });
  const duration = Math.min(calcGeneratorDuration(generator), maxGeneratorDuration);
  return {
    type: "keyframes",
    ease: (progress2) => {
      return generator.next(duration * progress2).value / scale;
    },
    duration: millisecondsToSeconds(duration)
  };
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/generators/utils/is-generator.mjs
function isGenerator(type) {
  return typeof type === "function";
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/resolve-elements.mjs
function resolveElements(elementOrSelector, scope, selectorCache) {
  var _a3;
  if (elementOrSelector instanceof Element) {
    return [elementOrSelector];
  } else if (typeof elementOrSelector === "string") {
    let root = document;
    if (scope) {
      root = scope.current;
    }
    const elements = (_a3 = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a3 !== void 0 ? _a3 : root.querySelectorAll(elementOrSelector);
    return elements ? Array.from(elements) : [];
  }
  return Array.from(elementOrSelector);
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/utils/get-value-transition.mjs
function getValueTransition(transition, key) {
  return transition ? transition[key] || transition["default"] || transition : void 0;
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/waapi/utils/attach-timeline.mjs
function attachTimeline(animation, timeline) {
  animation.timeline = timeline;
  animation.onfinish = null;
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/waapi/NativeAnimationControls.mjs
var NativeAnimationControls = class {
  constructor(animation) {
    this.animation = animation;
  }
  get duration() {
    var _a3, _b, _c;
    const durationInMs = ((_b = (_a3 = this.animation) === null || _a3 === void 0 ? void 0 : _a3.effect) === null || _b === void 0 ? void 0 : _b.getComputedTiming().duration) || ((_c = this.options) === null || _c === void 0 ? void 0 : _c.duration) || 300;
    return millisecondsToSeconds(Number(durationInMs));
  }
  get time() {
    var _a3;
    if (this.animation) {
      return millisecondsToSeconds(((_a3 = this.animation) === null || _a3 === void 0 ? void 0 : _a3.currentTime) || 0);
    }
    return 0;
  }
  set time(newTime) {
    if (this.animation) {
      this.animation.currentTime = secondsToMilliseconds(newTime);
    }
  }
  get speed() {
    return this.animation ? this.animation.playbackRate : 1;
  }
  set speed(newSpeed) {
    if (this.animation) {
      this.animation.playbackRate = newSpeed;
    }
  }
  get state() {
    return this.animation ? this.animation.playState : "finished";
  }
  get startTime() {
    return this.animation ? this.animation.startTime : null;
  }
  get finished() {
    return this.animation ? this.animation.finished : Promise.resolve();
  }
  play() {
    this.animation && this.animation.play();
  }
  pause() {
    this.animation && this.animation.pause();
  }
  stop() {
    if (!this.animation || this.state === "idle" || this.state === "finished") {
      return;
    }
    if (this.animation.commitStyles) {
      this.animation.commitStyles();
    }
    this.cancel();
  }
  flatten() {
    var _a3;
    if (!this.animation)
      return;
    (_a3 = this.animation.effect) === null || _a3 === void 0 ? void 0 : _a3.updateTiming({ easing: "linear" });
  }
  attachTimeline(timeline) {
    if (this.animation)
      attachTimeline(this.animation, timeline);
    return noop;
  }
  complete() {
    this.animation && this.animation.finish();
  }
  cancel() {
    try {
      this.animation && this.animation.cancel();
    } catch (e) {
    }
  }
};

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/supports/flags.mjs
var supportsFlags = {
  linearEasing: void 0
};

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/supports/memo.mjs
function memoSupports(callback, supportsFlag) {
  const memoized = memo(callback);
  return () => {
    var _a3;
    return (_a3 = supportsFlags[supportsFlag]) !== null && _a3 !== void 0 ? _a3 : memoized();
  };
}

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/supports/linear-easing.mjs
var supportsLinearEasing = /* @__PURE__ */ memoSupports(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch (e) {
    return false;
  }
  return true;
}, "linearEasing");

// ../../node_modules/motion/dist/es/motion-dom/dist/es/utils/is-bezier-definition.mjs
var isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/waapi/utils/linear.mjs
var generateLinearEasing = (easing, duration, resolution = 10) => {
  let points = "";
  const numPoints = Math.max(Math.round(duration / resolution), 2);
  for (let i = 0; i < numPoints; i++) {
    points += easing(progress(0, numPoints - 1, i)) + ", ";
  }
  return `linear(${points.substring(0, points.length - 2)})`;
};

// ../../node_modules/motion/dist/es/motion-dom/dist/es/animation/waapi/utils/easing.mjs
var cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
var supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(easing, duration) {
  if (!easing) {
    return void 0;
  } else if (typeof easing === "function" && supportsLinearEasing()) {
    return generateLinearEasing(easing, duration);
  } else if (isBezierDefinition(easing)) {
    return cubicBezierAsString(easing);
  } else if (Array.isArray(easing)) {
    return easing.map((segmentEasing) => mapEasingToNativeEasing(segmentEasing, duration) || supportedWaapiEasing.easeOut);
  } else {
    return supportedWaapiEasing[easing];
  }
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/index.mjs
function startWaapiAnimation(element, valueName, keyframes, { delay = 0, duration = 300, repeat = 0, repeatType = "loop", ease = "easeInOut", times } = {}) {
  const keyframeOptions = { [valueName]: keyframes };
  if (times)
    keyframeOptions.offset = times;
  const easing = mapEasingToNativeEasing(ease, duration);
  if (Array.isArray(easing))
    keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay,
    duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/value/types/numbers/units.mjs
var createUnitType = (unit) => ({
  test: (v) => typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
  parse: parseFloat,
  transform: (v) => `${v}${unit}`
});
var percent = /* @__PURE__ */ createUnitType("%");
var px = /* @__PURE__ */ createUnitType("px");
var progressPercentage = {
  ...percent,
  parse: (v) => percent.parse(v) / 100,
  transform: (v) => percent.transform(v * 100)
};

// ../../node_modules/motion/dist/es/framer-motion/dist/es/render/dom/value-types/number-browser.mjs
var browserNumberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Misc
  backgroundPositionX: px,
  backgroundPositionY: px
};

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/utils/get-final-keyframe.mjs
var isNotNull = (value) => value !== null;
function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }, finalKeyframe) {
  const resolvedKeyframes = keyframes.filter(isNotNull);
  const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === void 0 ? resolvedKeyframes[index] : finalKeyframe;
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/utils/style.mjs
function setCSSVar(element, name, value) {
  element.style.setProperty(`--${name}`, value);
}
function setStyle(element, name, value) {
  element.style[name] = value;
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/utils/supports-partial-keyframes.mjs
var supportsPartialKeyframes = /* @__PURE__ */ memo(() => {
  try {
    document.createElement("div").animate({ opacity: [1] });
  } catch (e) {
    return false;
  }
  return true;
});

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/utils/supports-waapi.mjs
var supportsWaapi = /* @__PURE__ */ memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/NativeAnimation.mjs
var state = /* @__PURE__ */ new WeakMap();
function hydrateKeyframes(valueName, keyframes, read) {
  for (let i = 0; i < keyframes.length; i++) {
    if (keyframes[i] === null) {
      keyframes[i] = i === 0 ? read() : keyframes[i - 1];
    }
    if (typeof keyframes[i] === "number" && browserNumberValueTypes[valueName]) {
      keyframes[i] = browserNumberValueTypes[valueName].transform(keyframes[i]);
    }
  }
  if (!supportsPartialKeyframes() && keyframes.length < 2) {
    keyframes.unshift(read());
  }
}
var defaultEasing = "easeOut";
function getElementAnimationState(element) {
  const animationState = state.get(element) || /* @__PURE__ */ new Map();
  state.set(element, animationState);
  return state.get(element);
}
var NativeAnimation = class extends NativeAnimationControls {
  constructor(element, valueName, valueKeyframes, options) {
    const isCSSVar = valueName.startsWith("--");
    invariant(typeof options.type !== "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "framer-motion"?`);
    const existingAnimation = getElementAnimationState(element).get(valueName);
    existingAnimation && existingAnimation.stop();
    const readInitialKeyframe = () => {
      return valueName.startsWith("--") ? element.style.getPropertyValue(valueName) : window.getComputedStyle(element)[valueName];
    };
    if (!Array.isArray(valueKeyframes)) {
      valueKeyframes = [valueKeyframes];
    }
    hydrateKeyframes(valueName, valueKeyframes, readInitialKeyframe);
    if (isGenerator(options.type)) {
      const generatorOptions = createGeneratorEasing(options, 100, options.type);
      options.ease = supportsLinearEasing() ? generatorOptions.ease : defaultEasing;
      options.duration = secondsToMilliseconds(generatorOptions.duration);
      options.type = "keyframes";
    } else {
      options.ease = options.ease || defaultEasing;
    }
    const onFinish = () => {
      this.setValue(element, valueName, getFinalKeyframe(valueKeyframes, options));
      this.cancel();
      this.resolveFinishedPromise();
    };
    const init = () => {
      this.setValue = isCSSVar ? setCSSVar : setStyle;
      this.options = options;
      this.updateFinishedPromise();
      this.removeAnimation = () => {
        const elementState = state.get(element);
        elementState && elementState.delete(valueName);
      };
    };
    if (!supportsWaapi()) {
      super();
      init();
      onFinish();
    } else {
      super(startWaapiAnimation(element, valueName, valueKeyframes, options));
      init();
      if (options.autoplay === false) {
        this.animation.pause();
      }
      this.animation.onfinish = onFinish;
      getElementAnimationState(element).set(valueName, this);
    }
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(resolve, reject) {
    return this.currentFinishedPromise.then(resolve, reject);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((resolve) => {
      this.resolveFinishedPromise = resolve;
    });
  }
  play() {
    if (this.state === "finished") {
      this.updateFinishedPromise();
    }
    super.play();
  }
  cancel() {
    this.removeAnimation();
    super.cancel();
  }
};

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/animate-elements.mjs
function animateElements(elementOrSelector, keyframes, options, scope) {
  const elements = resolveElements(elementOrSelector, scope);
  const numElements = elements.length;
  invariant(Boolean(numElements), "No valid element provided.");
  const animations = [];
  for (let i = 0; i < numElements; i++) {
    const element = elements[i];
    const elementTransition = { ...options };
    if (typeof elementTransition.delay === "function") {
      elementTransition.delay = elementTransition.delay(i, numElements);
    }
    for (const valueName in keyframes) {
      const valueKeyframes = keyframes[valueName];
      const valueOptions = {
        ...getValueTransition(elementTransition, valueName)
      };
      valueOptions.duration = valueOptions.duration ? secondsToMilliseconds(valueOptions.duration) : valueOptions.duration;
      valueOptions.delay = secondsToMilliseconds(valueOptions.delay || 0);
      animations.push(new NativeAnimation(element, valueName, valueKeyframes, valueOptions));
    }
  }
  return animations;
}

// ../../node_modules/motion/dist/es/framer-motion/dist/es/animation/animators/waapi/animate-style.mjs
var createScopedWaapiAnimate = (scope) => {
  function scopedAnimate(elementOrSelector, keyframes, options) {
    return new GroupPlaybackControls(animateElements(elementOrSelector, keyframes, options, scope));
  }
  return scopedAnimate;
};
var animateMini = /* @__PURE__ */ createScopedWaapiAnimate();

// src/results/WebSearch/WebSearch.tsx
import { MarkdownRenderer as MarkdownRenderer3 } from "@amzn/awsmp-max-ux-patterns/MarkdownRenderer";
import { useCitations as useCitations3 } from "@amzn/awsmp-max-ux-patterns/Citations";
import { useAppTranslation as useAppTranslation4 } from "@amzn/awsmp-max-translations";

// src/results/WebSearch/WebSearchDocument.tsx
import { MarkdownRenderer as MarkdownRenderer2 } from "@amzn/awsmp-max-ux-patterns/MarkdownRenderer";
import { useCitations as useCitations2 } from "@amzn/awsmp-max-ux-patterns/Citations";

// src/results/WebSearch/WebSearch.module.scss
var WebSearch_module_default = {
  webSearchCard: "WebSearch_module_webSearchCard",
  cardHeader: "WebSearch_module_cardHeader",
  cardLabel: "WebSearch_module_cardLabel",
  citationBadge: "WebSearch_module_citationBadge",
  cardContent: "WebSearch_module_cardContent",
  documentContainer: "WebSearch_module_documentContainer",
  documentPage: "WebSearch_module_documentPage",
  documentContent: "WebSearch_module_documentContent"
};

// src/results/WebSearch/WebSearchDocument.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
function toStringValue(value) {
  return typeof value === "string" ? value : value.join("");
}
var WebSearchDocument = ({ data }) => {
  const content = toStringValue(data.content);
  const citations = data.citations;
  const normalizedCitations = citations.map((citation, idx) => ({
    id: idx + 1,
    title: toStringValue(citation.title),
    url: toStringValue(citation.url)
  }));
  const { processText } = useCitations2(normalizedCitations, {
    interactionMode: "popup",
    fontSize: "compact"
  });
  return /* @__PURE__ */ jsx8("div", { className: WebSearch_module_default.documentContainer, children: /* @__PURE__ */ jsx8("div", { className: WebSearch_module_default.documentPage, children: /* @__PURE__ */ jsx8("div", { className: WebSearch_module_default.documentContent, children: /* @__PURE__ */ jsx8(MarkdownRenderer2, { processChildren: (children) => typeof children === "string" ? processText(children) : children, children: content }) }) }) });
};

// src/results/WebSearch/WebSearch.tsx
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
function toStringValue2(value) {
  return typeof value === "string" ? value : value.join("");
}
function normalizeCitations(citations) {
  return citations.map((citation, index) => ({
    id: index + 1,
    title: toStringValue2(citation.title),
    url: toStringValue2(citation.url)
  }));
}
function truncateText(text, maxLength) {
  if (text.length <= maxLength)
    return text;
  return text.substring(0, maxLength).trim() + "...";
}
var WebSearch = ({ data, rendererAPI }) => {
  const { t } = useAppTranslation4();
  const cardRef = useRef5(null);
  const { layoutManager } = rendererAPI;
  const toolData = data.output;
  const normalizedCitations = toolData ? normalizeCitations(toolData.citations) : [];
  const { processText } = useCitations3(normalizedCitations, {
    interactionMode: "link",
    fontSize: "compact"
  });
  if (!toolData)
    return null;
  const { content, citations } = toolData;
  const textContent = toStringValue2(content);
  const citationCount = citations.length;
  const compactContent = truncateText(textContent, 150);
  const handleMouseEnter = () => {
    if (cardRef.current) {
      animateMini(cardRef.current, { transform: "translateY(-4px) scale(1.02)" }, { duration: 0.2, ease: "easeOut" });
    }
  };
  const handleMouseLeave = () => {
    if (cardRef.current) {
      animateMini(cardRef.current, { transform: "translateY(0px) scale(1)" }, { duration: 0.2, ease: "easeOut" });
    }
  };
  const handleClick = () => {
    layoutManager.splitPanel.setContent({
      header: t("webSearchResults", { count: citationCount }),
      content: /* @__PURE__ */ jsx9(WebSearchDocument, { data: toolData })
    });
    layoutManager.splitPanel.show();
    layoutManager.splitPanel.updateMetadata({ size: window.innerWidth * 0.5, artifactType: void 0 });
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  };
  return /* @__PURE__ */ jsxs4(
    "div",
    {
      ref: cardRef,
      className: WebSearch_module_default.webSearchCard,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      role: "button",
      tabIndex: 0,
      "aria-label": t("webSearchAriaLabel", { count: citationCount }),
      children: [
        /* @__PURE__ */ jsxs4("div", { className: WebSearch_module_default.cardHeader, children: [
          /* @__PURE__ */ jsx9("span", { className: WebSearch_module_default.cardLabel, children: t("webSearch") }),
          /* @__PURE__ */ jsx9("span", { className: WebSearch_module_default.citationBadge, children: t("sourcesCount", { count: citationCount }) })
        ] }),
        /* @__PURE__ */ jsx9("div", { className: WebSearch_module_default.cardContent, ...{ inert: "" }, children: /* @__PURE__ */ jsx9(MarkdownRenderer3, { processChildren: (children) => typeof children === "string" ? processText(children) : children, children: compactContent }) })
      ]
    }
  );
};

// src/results/WebSearch/SourcesList.tsx
import SpaceBetween4 from "@cloudscape-design/components/space-between";
import Link from "@cloudscape-design/components/link";
import Box3 from "@cloudscape-design/components/box";
import { spaceStaticXl, spaceStaticXs } from "@cloudscape-design/design-tokens";
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var SourcesList = ({ citations }) => {
  if (citations.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs5(SpaceBetween4, { size: "xs", children: [
    /* @__PURE__ */ jsx10(Box3, { variant: "h4", children: "Web Search Sources" }),
    /* @__PURE__ */ jsx10("ol", { style: { margin: 0, paddingLeft: spaceStaticXl }, children: citations.map((citation) => /* @__PURE__ */ jsx10("li", { style: { marginBottom: spaceStaticXs }, children: /* @__PURE__ */ jsx10(Link, { href: citation.url, external: true, fontSize: "body-m", children: citation.title }) }, citation.id)) })
  ] });
};

// src/results/PricingAnnotation/PricingAnnotation.tsx
import Alert2 from "@cloudscape-design/components/alert";
import Link2 from "@cloudscape-design/components/link";
import { useAppTranslation as useAppTranslation5 } from "@amzn/awsmp-max-translations";
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var PricingAnnotation = ({ data }) => {
  const { t } = useAppTranslation5();
  const { content } = data;
  if (!content.hasPricing) {
    return null;
  }
  const contentParts = t("pricingDisclaimerContent").split("AWS Pricing Calculator");
  return /* @__PURE__ */ jsxs6(Alert2, { type: "info", header: t("alwaysVerifyPricingEstimates"), children: [
    contentParts[0],
    /* @__PURE__ */ jsx11(Link2, { external: true, href: "https://calculator.aws/#/", children: t("awsPricingCalculator") }),
    contentParts[1]
  ] });
};

// src/results/ProvideRequirementsAnnotation/ProvideRequirementsAnnotation.tsx
import * as React8 from "react";
import Alert3 from "@cloudscape-design/components/alert";
import FileInput from "@cloudscape-design/components/file-input";
import Spinner from "@cloudscape-design/components/spinner";
import Box4 from "@cloudscape-design/components/box";
import SpaceBetween5 from "@cloudscape-design/components/space-between";
import FileTokenGroup from "@cloudscape-design/components/file-token-group";
import { useAppTranslation as useAppTranslation6 } from "@amzn/awsmp-max-translations";

// src/results/ProvideRequirementsAnnotation/ProvideRequirementsAnnotation.module.scss
var ProvideRequirementsAnnotation_module_default = {
  container: "ProvideRequirementsAnnotation_module_container",
  hiding: "ProvideRequirementsAnnotation_module_hiding"
};

// src/results/ProvideRequirementsAnnotation/ProvideRequirementsAnnotation.tsx
import { ACCEPTED_EXTENSIONS_STRING, validateFiles } from "@amzn/awsmp-max-model";
import { jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var ProvideRequirementsAnnotation = ({ uploadFiles, sendMessage }) => {
  const { t } = useAppTranslation6();
  const [files, setFiles] = React8.useState([]);
  const [uploading, setUploading] = React8.useState(false);
  const [processing, setProcessing] = React8.useState(false);
  const [uploadProgress, setUploadProgress] = React8.useState({});
  const [uploadErrors, setUploadErrors] = React8.useState({});
  const [generalError, setGeneralError] = React8.useState(null);
  const [alertType, setAlertType] = React8.useState("info");
  const [isHiding, setIsHiding] = React8.useState(false);
  const handleFileChange = async (selectedFiles) => {
    setFiles(selectedFiles);
    if (selectedFiles.length > 0) {
      const validation = validateFiles(selectedFiles);
      if (!validation.isValid) {
        setGeneralError(validation.errors.join(". "));
        setAlertType("error");
        return;
      }
      setUploading(true);
      setUploadProgress({});
      setUploadErrors({});
      setGeneralError(null);
      setAlertType("info");
      try {
        await uploadFiles(selectedFiles, {
          onProgress: (fileName, percent2) => {
            setUploadProgress((prev) => ({ ...prev, [fileName]: percent2 }));
          },
          onSuccess: (fileName) => {
            setUploadProgress((prev) => ({ ...prev, [fileName]: 100 }));
            setFiles((prev) => prev.filter((f) => f.name !== fileName));
          },
          onError: (fileName, error) => {
            setUploadErrors((prev) => ({ ...prev, [fileName]: error }));
            setAlertType("error");
          },
          onProcessing: () => {
            setUploading(false);
            setProcessing(true);
          },
          onComplete: () => {
            setProcessing(false);
            const fileNames = selectedFiles.map((f) => f.name);
            sendMessage(
              t("analyzeUploadedFiles", {
                plural: fileNames.length > 1 ? "s" : "",
                files: fileNames.join(", ")
              })
            );
            setIsHiding(true);
            setFiles([]);
            setUploadProgress({});
          }
        });
      } catch (_error) {
        setGeneralError(t("unexpectedError"));
        setAlertType("error");
      } finally {
        setUploading(false);
        setProcessing(false);
      }
    }
  };
  return /* @__PURE__ */ jsx12("div", { className: `${ProvideRequirementsAnnotation_module_default.container} ${isHiding ? ProvideRequirementsAnnotation_module_default.hiding : ""}`, children: /* @__PURE__ */ jsx12(
    Alert3,
    {
      type: alertType,
      header: t("getTailoredRecommendations"),
      action: !uploading && !processing ? /* @__PURE__ */ jsx12(
        FileInput,
        {
          ariaLabel: t("uploadRequirementsFiles"),
          multiple: true,
          value: files,
          onChange: ({ detail }) => handleFileChange(detail.value),
          accept: ACCEPTED_EXTENSIONS_STRING,
          children: "Upload files"
        }
      ) : void 0,
      children: /* @__PURE__ */ jsxs7(SpaceBetween5, { size: "s", children: [
        /* @__PURE__ */ jsx12(Box4, { children: t("uploadFilesToTellAboutRequirements") }),
        generalError && /* @__PURE__ */ jsx12(Box4, { color: "text-status-error", children: generalError }),
        files.length > 0 && /* @__PURE__ */ jsx12(
          FileTokenGroup,
          {
            items: files.map((file) => {
              const progress2 = uploadProgress[file.name];
              const error = uploadErrors[file.name];
              return {
                file,
                loading: progress2 !== void 0 && progress2 < 100,
                errorText: error
              };
            }),
            onDismiss: ({ detail }) => {
              const removedFile = files[detail.fileIndex];
              const newFiles = files.filter((_, index) => index !== detail.fileIndex);
              setFiles(newFiles);
              setUploadErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[removedFile.name];
                return newErrors;
              });
              if (Object.keys(uploadErrors).length === 1 && uploadErrors[removedFile.name]) {
                setAlertType("info");
              }
            },
            alignment: "horizontal",
            showFileSize: true,
            showFileLastModified: true,
            showFileThumbnail: true,
            i18nStrings: {
              removeFileAriaLabel: () => t("removeFile"),
              limitShowFewer: t("showFewerFiles"),
              limitShowMore: t("showMoreFiles"),
              errorIconAriaLabel: t("errorIconAriaLabel"),
              warningIconAriaLabel: t("warningIconAriaLabel")
            }
          }
        ),
        uploading && /* @__PURE__ */ jsx12(Box4, { children: /* @__PURE__ */ jsxs7(SpaceBetween5, { size: "xs", direction: "horizontal", alignItems: "center", children: [
          /* @__PURE__ */ jsx12(Spinner, { size: "normal" }),
          /* @__PURE__ */ jsx12(Box4, { children: t("uploadingFiles") })
        ] }) }),
        processing && /* @__PURE__ */ jsx12(Box4, { children: /* @__PURE__ */ jsxs7(SpaceBetween5, { size: "xs", direction: "horizontal", alignItems: "center", children: [
          /* @__PURE__ */ jsx12(Spinner, { size: "normal" }),
          /* @__PURE__ */ jsx12(Box4, { children: t("processingDocuments") })
        ] }) })
      ] })
    }
  ) });
};

// src/results/AskUser/AskUser.tsx
import RadioGroup from "@cloudscape-design/components/radio-group";
import SpaceBetween9 from "@cloudscape-design/components/space-between";
import Select from "@cloudscape-design/components/select";
import Multiselect from "@cloudscape-design/components/multiselect";
import Button5 from "@cloudscape-design/components/button";
import Box8 from "@cloudscape-design/components/box";
import Form from "@cloudscape-design/components/form";
import FormField from "@cloudscape-design/components/form-field";
import Input from "@cloudscape-design/components/input";
import Textarea from "@cloudscape-design/components/textarea";
import Checkbox from "@cloudscape-design/components/checkbox";
import * as React75 from "react";
import { MAX_ASKUSER_FIELD_LENGTH, MessageRole as MessageRole3 } from "@amzn/awsmp-max-model";
import { useAppTranslation as useAppTranslation8 } from "@amzn/awsmp-max-translations";
import { ClickableOptions as ClickableOptions2 } from "@amzn/awsmp-max-ux-patterns/ClickableOptions";
import { MarkdownRenderer as MarkdownRenderer4 } from "@amzn/awsmp-max-ux-patterns/MarkdownRenderer";

// src/results/AskUser/AskUser.module.scss
var AskUser_module_default = {
  checkboxOption: "AskUser_module_checkboxOption"
};

// src/results/bi-constants.ts
var BI_CLICK_FEAT = "chat-section";
var BI_CLICK_OBJ_ASK_USER = "ask-user";
var BI_CLICK_ACT_SUBMIT = "submit-button";
var BI_CLICK_ACT_RADIO = "radio-group";
var BI_CLICK_ACT_SIGN_IN = "sign-in-button";
var BI_CLICK_ACT_SESSION_RESET_SIGN_IN = "session-reset-sign-in-button";
var BI_CLICK_ACT_AUTHENTICATE_RETRY = "authenticate-retry-button";
var BI_CLICK_ACT_APPROVE = "approve-button";
var BI_CLICK_ACT_DENY = "deny-button";
var BI_CLICK_ACT_SIGN_IN_PROMPT_SHOWN = "sign-in-prompt-shown";
var BI_CLICK_ACT_SIGN_IN_COMPLETED = "sign-in-completed";
var BI_CLICK_ACT_TOOL_AUTH_PROMPT_SHOWN = "tool-auth-prompt-shown";
var BI_CLICK_ACT_AUTH_COMPLETED = "auth-completed";
var BI_CLICK_ACT_AUTH_PERMISSION_REQUIRED = "auth-permission-required";
var BI_CLICK_OBJ_PRIVATE_OFFER = "private-offer-through-leads";
var BI_CLICK_ACT_VENDOR_CONTACT_BUTTON = "vendor-contact-button";
var BI_CLICK_ACT_PRICING_CALCULATOR_LINK = "pricing-calculator-link";
var BI_CLICK_ACT_VENDOR_CONTACT_LINK = "vendor-contact-link";

// src/results/AskUser/bi.ts
var emitAskUserSubmit = (logger, clickAct, clickSelect) => {
  logger.biMetric({
    metricName: "Click",
    unit: "Count",
    value: 1,
    dimensions: {
      ClickFeat: BI_CLICK_FEAT,
      ClickObj: BI_CLICK_OBJ_ASK_USER,
      ClickAct: clickAct,
      ...clickSelect !== void 0 && { ClickSelect: clickSelect }
    }
  });
};
var emitAskUserRender = (logger, clickAct, clickSelect) => {
  logger.biMetric({
    metricName: "Render",
    unit: "Count",
    value: 1,
    dimensions: {
      ClickFeat: BI_CLICK_FEAT,
      ClickObj: BI_CLICK_OBJ_ASK_USER,
      ClickAct: clickAct,
      ...clickSelect !== void 0 && { ClickSelect: clickSelect }
    }
  });
};

// ../../node_modules/@amzn/access-denied-comp/dist/index.js
import * as React74 from "react";
import React__default, { useState as useState29, useEffect as useEffect37, createContext as createContext16 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/index.js
import React37 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/internal-do-not-use-core.js
import React36, { useEffect as useEffect28, useRef as useRef26 } from "react";

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/base-component/component-metadata.js
import { useEffect as useEffect5, useRef as useRef6 } from "react";
var COMPONENT_METADATA_KEY = "__awsuiMetadata__";
function useComponentMetadata(componentName2, packageMetadata, analyticsMetadata) {
  const elementRef = useRef6(null);
  useEffect5(() => {
    if (elementRef.current) {
      const pkgMetadata = typeof packageMetadata === "string" ? { version: packageMetadata } : packageMetadata;
      const node = elementRef.current;
      const metadata = {
        ...pkgMetadata,
        name: componentName2
      };
      if (analyticsMetadata && Object.keys(analyticsMetadata).length > 0) {
        metadata.analytics = analyticsMetadata;
      }
      Object.freeze(metadata);
      Object.defineProperty(node, COMPONENT_METADATA_KEY, { value: metadata, writable: false, configurable: true });
    }
  });
  return elementRef;
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/base-component/component-metrics.js
import { useEffect as useEffect6 } from "react";

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/base-component/metrics/log-clients.js
var AWSUI_EVENT = "awsui";
function validateLength(value, maxLength) {
  return !value || value.length <= maxLength;
}
var CLogClient = class {
  /**
   * Sends metric but only if Console Platform client logging JS API is present in the page.
   */
  sendMetric(metricName, value, detail) {
    if (!metricName || !/^[a-zA-Z0-9_-]+$/.test(metricName)) {
      console.error(`Invalid metric name: ${metricName}`);
      return;
    }
    if (!validateLength(metricName, 1e3)) {
      console.error(`Metric name ${metricName} is too long`);
      return;
    }
    if (!validateLength(detail, 4e3)) {
      console.error(`Detail for metric ${metricName} is too long: ${detail}`);
      return;
    }
    const wasSent = new PanoramaClient().sendMetric({
      eventContext: metricName,
      eventDetail: detail,
      eventValue: `${value}`,
      timestamp: Date.now()
    });
    if (wasSent) {
      return;
    }
    const AWSC = this.findAWSC(window);
    if (typeof AWSC === "object" && typeof AWSC.Clog === "object" && typeof AWSC.Clog.log === "function") {
      AWSC.Clog.log(metricName, value, detail);
    }
  }
  findAWSC(currentWindow) {
    try {
      if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC) === "object") {
        return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC;
      }
      if (!currentWindow || currentWindow.parent === currentWindow) {
        return void 0;
      }
      return this.findAWSC(currentWindow.parent);
    } catch {
      return void 0;
    }
  }
};
var PanoramaClient = class {
  /**
   * Sends metric but only if Console Platform client v2 logging JS API is present in the page.
   */
  sendMetric(metric) {
    const panorama = this.findPanorama(window);
    if (!panorama) {
      return false;
    }
    const payload = {
      eventType: AWSUI_EVENT,
      timestamp: Date.now(),
      ...metric,
      eventDetail: typeof metric.eventDetail === "object" ? JSON.stringify(metric.eventDetail) : metric.eventDetail,
      eventValue: typeof metric.eventValue === "object" ? JSON.stringify(metric.eventValue) : metric.eventValue
    };
    if (!validateLength(payload.eventDetail, 4e3)) {
      this.onMetricError(`Event detail for metric is too long: ${payload.eventDetail}`);
      return true;
    }
    if (!validateLength(payload.eventValue, 4e3)) {
      this.onMetricError(`Event value for metric is too long: ${payload.eventValue}`);
      return true;
    }
    if (!validateLength(payload.eventContext, 4e3)) {
      this.onMetricError(`Event context for metric is too long: ${payload.eventContext}`);
      return true;
    }
    panorama("trackCustomEvent", payload);
    return true;
  }
  onMetricError(message) {
    console.error(message);
    const panorama = this.findPanorama(window);
    if (panorama) {
      panorama("trackCustomEvent", {
        eventType: AWSUI_EVENT,
        eventContext: "awsui-metric-error",
        eventDetail: message.slice(0, 4e3),
        timestamp: Date.now()
      });
    }
  }
  findPanorama(currentWindow) {
    try {
      if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama) === "function") {
        return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama;
      }
      const panoramaSymbol = Symbol.for("panorama");
      const symbolProperty = currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow[panoramaSymbol];
      if (typeof symbolProperty === "function") {
        return symbolProperty;
      }
      if (!currentWindow || currentWindow.parent === currentWindow) {
        return void 0;
      }
      return this.findPanorama(currentWindow.parent);
    } catch {
      return void 0;
    }
  }
};

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/base-component/metrics/formatters.js
function buildMetricDetail(detail, context) {
  const metricOrigin = typeof AWSUI_METRIC_ORIGIN !== "undefined" ? AWSUI_METRIC_ORIGIN : "main";
  const detailObject = {
    o: metricOrigin,
    t: context.theme,
    // React is the only framework we're using.
    f: "react",
    // Remove spaces from the version string for compactness
    v: context.packageVersion.replace(/\s/g, ""),
    ...detail
  };
  return jsonStringify(detailObject);
}
function buildComponentMetricDetail({ componentName: componentName2, action, configuration, packageSource }, context) {
  return buildMetricDetail({
    a: action,
    s: componentName2,
    p: packageSource,
    c: configuration
  }, context);
}
function jsonStringify(detailObject) {
  return JSON.stringify(detailObject, detailSerializer);
}
function detailSerializer(key, value) {
  if (typeof value === "number" && !Number.isFinite(value)) {
    return `${value}`;
  }
  return value;
}
function getMajorVersion(versionString) {
  const majorVersionMatch = versionString.match(/^(\d+\.\d+)/);
  return majorVersionMatch ? majorVersionMatch[1].replace(".", "") : "";
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/base-component/metrics/metrics.js
var oneTimeMetrics = /* @__PURE__ */ new Set();
var Metrics = class {
  constructor(...args) {
    this.clog = new CLogClient();
    this.panorama = new PanoramaClient();
    if (args.length === 1) {
      this.context = args[0];
    } else {
      const [packageSource, packageVersion] = args;
      this.context = { packageSource, packageVersion, theme: "unknown" };
    }
  }
  sendComponentMetric(metric) {
    this.sendMetricOnce(`awsui_${metric.componentName}_${this.context.theme.charAt(0)}${getMajorVersion(this.context.packageVersion)}`, 1, buildComponentMetricDetail(metric, this.context));
  }
  /*
   * Calls Console Platform's client logging only the first time the provided metricName is used.
   * Subsequent calls with the same metricName are ignored.
   */
  sendMetricOnce(metricName, value, detail) {
    const key = [metricName + value + detail].join("|");
    if (!oneTimeMetrics.has(key)) {
      this.clog.sendMetric(metricName, value, detail);
      oneTimeMetrics.add(key);
    }
  }
  /**
   * Calls Console Platform's client v2 logging JS API with provided metric name and detail.
   * Does nothing if Console Platform client logging JS is not present in page.
   */
  sendPanoramaMetric(metric) {
    this.panorama.sendMetric(metric);
  }
  sendOpsMetricObject(metricName, detail) {
    this.sendMetricOnce(metricName, 1, buildMetricDetail(detail, this.context));
  }
  sendOpsMetricValue(metricName, value) {
    this.sendMetricOnce(metricName, value);
  }
  /*
   * Reports a metric value 1 to Console Platform's client logging service to indicate that the
   * component was loaded. The component load event will only be reported as used to client logging
   * service once per page view.
   */
  logComponentsLoaded() {
    this.sendComponentMetric({ componentName: this.context.packageSource, action: "loaded" });
  }
  /*
   * Reports a metric value 1 to Console Platform's client logging service to indicate that the
   * component was used in the page.  A component will only be reported as used to client logging
   * service once per page view.
   */
  logComponentUsed(componentName2, configuration) {
    this.sendComponentMetric({
      action: "used",
      componentName: componentName2,
      configuration,
      packageSource: this.context.packageSource
    });
  }
};

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/base-component/component-metrics.js
function useComponentMetrics(componentName2, settings, configuration = { props: {} }) {
  useEffect6(() => {
    const metrics2 = new Metrics(settings);
    if (typeof window !== "undefined") {
      metrics2.sendOpsMetricValue("awsui-viewport-width", window.innerWidth || 0);
      metrics2.sendOpsMetricValue("awsui-viewport-height", window.innerHeight || 0);
    }
    metrics2.logComponentsLoaded();
    metrics2.logComponentUsed(componentName2.toLowerCase(), configuration);
  }, []);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/base-component/init-awsui-versions.js
function initAwsUiVersions(source, packageVersion) {
  if (typeof window !== "undefined") {
    if (!window.awsuiVersions) {
      window.awsuiVersions = {};
    }
    if (!window.awsuiVersions[source]) {
      window.awsuiVersions[source] = [];
    }
    window.awsuiVersions[source].push(packageVersion);
  }
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/container-queries/use-resize-observer.js
import { unstable_batchedUpdates } from "react-dom";
import { useEffect as useEffect8, useLayoutEffect as useLayoutEffect2 } from "react";

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/stable-callback/index.js
import { useCallback as useCallback6, useEffect as useEffect7, useRef as useRef7 } from "react";
function useStableCallback(fn) {
  const ref = useRef7();
  useEffect7(() => {
    ref.current = fn;
  });
  return useCallback6((...args) => {
    var _a3;
    return (_a3 = ref.current) === null || _a3 === void 0 ? void 0 : _a3.call(ref, ...args);
  }, []);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/container-queries/use-resize-observer.js
function useResizeObserver(elementRef, onObserve) {
  const stableOnObserve = useStableCallback(onObserve);
  useLayoutEffect2(
    () => {
      const element = typeof elementRef === "function" ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
      if (element) {
        const rect = element.getBoundingClientRect();
        onObserve(convertElementToEntry(element, rect));
      }
    },
    // This effect is only needed for the first render to provide a synchronous update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  useEffect8(() => {
    const element = typeof elementRef === "function" ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
    if (element && typeof ResizeObserver !== "undefined") {
      let connected = true;
      const observer2 = new ResizeObserver((entries) => {
        if (connected) {
          unstable_batchedUpdates(() => {
            stableOnObserve(convertResizeObserverEntry(entries[0]));
          });
        }
      });
      observer2.observe(element, { box: "border-box" });
      return () => {
        connected = false;
        observer2.disconnect();
      };
    }
  }, [elementRef, stableOnObserve]);
}
function convertResizeObserverEntry(entry) {
  return {
    target: entry.target,
    contentBoxWidth: entry.contentBoxSize[0].inlineSize,
    contentBoxHeight: entry.contentBoxSize[0].blockSize,
    borderBoxWidth: entry.borderBoxSize[0].inlineSize,
    borderBoxHeight: entry.borderBoxSize[0].blockSize
  };
}
function convertElementToEntry(element, rect) {
  const computedStyle = window.getComputedStyle(element);
  const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
  const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
  const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
  const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
  const borderLeft = parseFloat(computedStyle.borderLeftWidth) || 0;
  const borderRight = parseFloat(computedStyle.borderRightWidth) || 0;
  const borderTop = parseFloat(computedStyle.borderTopWidth) || 0;
  const borderBottom = parseFloat(computedStyle.borderBottomWidth) || 0;
  return {
    target: element,
    contentBoxWidth: rect.width - paddingLeft - paddingRight - borderLeft - borderRight,
    contentBoxHeight: rect.height - paddingTop - paddingBottom - borderTop - borderBottom,
    borderBoxWidth: rect.width,
    borderBoxHeight: rect.height
  };
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/singleton-handler/index.js
import { useEffect as useEffect9, useState as useState4 } from "react";
import { unstable_batchedUpdates as unstable_batchedUpdates2 } from "react-dom";
function createSingletonHandler(factory) {
  const listeners = /* @__PURE__ */ new Set();
  const callback = (value) => {
    unstable_batchedUpdates2(() => {
      for (const listener of listeners) {
        listener(value);
      }
    });
  };
  let cleanup;
  return function useSingleton(listener) {
    useEffect9(() => {
      if (listeners.size === 0) {
        cleanup = factory(callback);
      }
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
          cleanup();
          cleanup = void 0;
        }
      };
    }, []);
  };
}
function createSingletonState({ factory, initialState }) {
  const useSingleton = createSingletonHandler(factory);
  return function useSingletonState() {
    const [state2, setState] = useState4(initialState);
    useSingleton(setState);
    return state2;
  };
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/visual-mode/index.js
import { useEffect as useEffect10, useState as useState5 } from "react";

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/dom/element-types.js
function isNode(target) {
  return target instanceof Node || target !== null && typeof target === "object" && "nodeType" in target && typeof target.nodeType === "number" && "nodeName" in target && typeof target.nodeName === "string" && "parentNode" in target && typeof target.parentNode === "object";
}
function isHTMLElement(target) {
  return target instanceof HTMLElement || isNode(target) && target.nodeType === Node.ELEMENT_NODE && "style" in target && typeof target.style === "object" && typeof target.ownerDocument === "object" && !isSVGElement(target);
}
function isSVGElement(target) {
  return target instanceof SVGElement || isNode(target) && target.nodeType === Node.ELEMENT_NODE && "ownerSVGElement" in target && typeof target.ownerSVGElement === "object";
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/dom/find-up-until.js
function findUpUntil(from, test) {
  let current = from;
  while (current && !test(current)) {
    current = current.parentElement;
    while (current && !isHTMLElement(current)) {
      current = current.parentElement;
    }
  }
  return current;
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/dom/node-contains.js
function nodeContains(parent, descendant) {
  if (!parent || !descendant || !isNode(descendant)) {
    return false;
  }
  return parent.contains(descendant);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/dom/node-belongs.js
function nodeBelongs(container, target) {
  var _a3;
  if (!isNode(target)) {
    return false;
  }
  const portal = findUpUntil(target, (node) => node === container || isHTMLElement(node) && !!node.dataset.awsuiReferrerId);
  if (portal && portal === container) {
    return true;
  }
  const referrer = isHTMLElement(portal) ? document.getElementById((_a3 = portal.dataset.awsuiReferrerId) !== null && _a3 !== void 0 ? _a3 : "") : null;
  return referrer ? nodeContains(container, referrer) : nodeContains(container, target);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/is-development.js
var isDevelopment = true;

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/logging.js
var messageCache = /* @__PURE__ */ new Set();
function warnOnce(component, message) {
  if (isDevelopment) {
    const warning2 = `[AwsUi] [${component}] ${message}`;
    if (!messageCache.has(warning2)) {
      messageCache.add(warning2);
      console.warn(warning2);
    }
  }
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/global-flags/index.js
var awsuiVisualRefreshFlag = Symbol.for("awsui-visual-refresh-flag");
var awsuiGlobalFlagsSymbol = Symbol.for("awsui-global-flags");
var getTopWindow = () => {
  return window.top;
};
function getGlobal() {
  return typeof window !== "undefined" ? window : globalThis;
}
function readFlag(holder, flagName) {
  var _a3;
  return (_a3 = holder === null || holder === void 0 ? void 0 : holder[awsuiGlobalFlagsSymbol]) === null || _a3 === void 0 ? void 0 : _a3[flagName];
}
var getGlobalFlag = (flagName) => {
  try {
    const ownFlag = readFlag(getGlobal(), flagName);
    if (ownFlag !== void 0) {
      return ownFlag;
    }
    return readFlag(getTopWindow(), flagName);
  } catch {
    return void 0;
  }
};

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/utils/safe-match-media.js
function safeMatchMedia(element, query) {
  var _a3, _b, _c, _d;
  try {
    const targetWindow = (_b = (_a3 = element.ownerDocument) === null || _a3 === void 0 ? void 0 : _a3.defaultView) !== null && _b !== void 0 ? _b : window;
    return (_d = (_c = targetWindow.matchMedia) === null || _c === void 0 ? void 0 : _c.call(targetWindow, query).matches) !== null && _d !== void 0 ? _d : false;
  } catch (error) {
    console.warn(error);
    return false;
  }
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/visual-mode/index.js
function isMotionDisabled(element) {
  return !!findUpUntil(element, (node) => node.classList.contains("awsui-motion-disabled")) || safeMatchMedia(element, "(prefers-reduced-motion: reduce)");
}
function useModeDetector(elementRef, detector, initialValue) {
  const [value, setValue] = useState5(initialValue);
  useMutationObserver(elementRef, (node) => {
    const newValue = detector(node);
    if (newValue !== value) {
      setValue(newValue);
    }
  });
  return value;
}
function detectCurrentMode(node) {
  const darkModeParent = findUpUntil(node, (node2) => node2.classList.contains("awsui-polaris-dark-mode") || node2.classList.contains("awsui-dark-mode"));
  return darkModeParent ? "dark" : "light";
}
function detectDensityMode(node) {
  const compactModeParent = findUpUntil(node, (node2) => node2.classList.contains("awsui-polaris-compact-mode") || node2.classList.contains("awsui-compact-mode"));
  return compactModeParent ? "compact" : "comfortable";
}
function useCurrentMode(elementRef) {
  return useModeDetector(elementRef, detectCurrentMode, "light");
}
function useDensityMode(elementRef) {
  return useModeDetector(elementRef, detectDensityMode, "comfortable");
}
function useReducedMotion(elementRef) {
  return useModeDetector(elementRef, isMotionDisabled, false);
}
var useMutationSingleton = createSingletonHandler((handler) => {
  const observer2 = new MutationObserver(() => handler());
  observer2.observe(document.body, { attributes: true, subtree: true });
  return () => observer2.disconnect();
});
function useMutationObserver(elementRef, onChange) {
  const handler = useStableCallback(() => {
    if (elementRef.current) {
      onChange(elementRef.current);
    }
  });
  useMutationSingleton(handler);
  useEffect10(() => {
    handler();
  }, [handler]);
}
var Theme;
(function(Theme2) {
  Theme2["VisualRefresh"] = "visual-refresh";
  Theme2["OneTheme"] = "one-theme";
})(Theme || (Theme = {}));
var themePrecedence = [Theme.OneTheme, Theme.VisualRefresh];
var themeDefinitions = {
  [Theme.VisualRefresh]: {
    className: "awsui-visual-refresh",
    isFlagActive: () => {
      var _a3, _b;
      return !!((_b = (_a3 = getGlobal()) === null || _a3 === void 0 ? void 0 : _a3[awsuiVisualRefreshFlag]) === null || _b === void 0 ? void 0 : _b.call(_a3));
    }
  },
  [Theme.OneTheme]: {
    className: "awsui-one-theme",
    isFlagActive: () => !!getGlobalFlag("oneTheme")
  }
};
var allThemes = Object.values(Theme);
function hasThemeClassName(theme) {
  return typeof document !== "undefined" && !!document.querySelector(`.${themeDefinitions[theme].className}`);
}
function isThemeActive(theme) {
  return hasThemeClassName(theme) || themeDefinitions[theme].isFlagActive();
}
function applyThemeClassName(theme) {
  if (typeof document !== "undefined" && !hasThemeClassName(theme) && themeDefinitions[theme].isFlagActive()) {
    document.body.classList.add(themeDefinitions[theme].className);
  }
}
function initThemes(options) {
  const flaggedThemes = themePrecedence.filter((theme) => {
    if ((options === null || options === void 0 ? void 0 : options.skipVisualRefresh) && theme === Theme.VisualRefresh) {
      return false;
    }
    return themeDefinitions[theme].isFlagActive();
  });
  if (isDevelopment && flaggedThemes.length > 1) {
    warnOnce("Theme", `Multiple theme flags are enabled (${flaggedThemes.join(", ")}). Only the highest-priority theme (${flaggedThemes[0]}) is applied.`);
  }
  if (flaggedThemes.length > 0) {
    applyThemeClassName(flaggedThemes[0]);
  }
}
var runtimeVisualRefresh = void 0;
function useRuntimeVisualRefresh() {
  if (runtimeVisualRefresh === void 0) {
    initThemes();
    runtimeVisualRefresh = isThemeActive(Theme.VisualRefresh) || isThemeActive(Theme.OneTheme);
  }
  if (isDevelopment) {
    const visualRefreshActive = isThemeActive(Theme.VisualRefresh) || isThemeActive(Theme.OneTheme);
    if (visualRefreshActive !== runtimeVisualRefresh) {
      warnOnce("Visual Refresh", "Dynamic theme change detected. This is not supported. Make sure the theme class (e.g. `awsui-visual-refresh` or `awsui-one-theme`) is attached to the `<body>` element before the initial React render.");
    }
  }
  return runtimeVisualRefresh;
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/direction/index.js
function getIsRtl(element) {
  if (!element) {
    return false;
  }
  return getComputedStyle(element).direction === "rtl";
}
function getLogicalBoundingClientRect(element) {
  const boundingClientRect = element.getBoundingClientRect();
  const blockSize = boundingClientRect.height;
  const inlineSize = boundingClientRect.width;
  const insetBlockStart = boundingClientRect.top;
  const insetBlockEnd = boundingClientRect.bottom;
  const insetInlineStart = getIsRtl(element) ? document.documentElement.clientWidth - boundingClientRect.right : boundingClientRect.left;
  const insetInlineEnd = insetInlineStart + inlineSize;
  return {
    blockSize,
    inlineSize,
    insetBlockStart,
    insetBlockEnd,
    insetInlineStart,
    insetInlineEnd
  };
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/focus-visible/index.js
import { useEffect as useEffect11 } from "react";

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/keycode.js
var KeyCode;
(function(KeyCode3) {
  KeyCode3[KeyCode3["pageUp"] = 33] = "pageUp";
  KeyCode3[KeyCode3["pageDown"] = 34] = "pageDown";
  KeyCode3[KeyCode3["end"] = 35] = "end";
  KeyCode3[KeyCode3["home"] = 36] = "home";
  KeyCode3[KeyCode3["backspace"] = 8] = "backspace";
  KeyCode3[KeyCode3["space"] = 32] = "space";
  KeyCode3[KeyCode3["down"] = 40] = "down";
  KeyCode3[KeyCode3["left"] = 37] = "left";
  KeyCode3[KeyCode3["right"] = 39] = "right";
  KeyCode3[KeyCode3["up"] = 38] = "up";
  KeyCode3[KeyCode3["escape"] = 27] = "escape";
  KeyCode3[KeyCode3["enter"] = 13] = "enter";
  KeyCode3[KeyCode3["tab"] = 9] = "tab";
  KeyCode3[KeyCode3["shift"] = 16] = "shift";
  KeyCode3[KeyCode3["control"] = 17] = "control";
  KeyCode3[KeyCode3["alt"] = 18] = "alt";
  KeyCode3[KeyCode3["meta"] = 91] = "meta";
})(KeyCode || (KeyCode = {}));
var modifierKeyCodes = /* @__PURE__ */ new Set([KeyCode.shift, KeyCode.alt, KeyCode.control, KeyCode.meta]);
function isModifierKey(event) {
  return modifierKeyCodes.has(event.keyCode);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/focus-visible/index.js
var frames = /* @__PURE__ */ new Map();
function setIsKeyboard(active) {
  if (active) {
    for (const currentDocument of frames.keys()) {
      currentDocument.body.setAttribute("data-awsui-focus-visible", "true");
    }
  } else {
    for (const currentDocument of frames.keys()) {
      currentDocument.body.removeAttribute("data-awsui-focus-visible");
    }
  }
}
function handleMousedown() {
  setIsKeyboard(false);
}
function handleKeydown(event) {
  if (!isModifierKey(event)) {
    setIsKeyboard(true);
  }
}
function addListeners(currentDocument) {
  const abortController = new AbortController();
  currentDocument.addEventListener("mousedown", handleMousedown, { signal: abortController.signal });
  currentDocument.addEventListener("keydown", handleKeydown, { signal: abortController.signal });
  return abortController;
}
function useFocusVisible(componentRef) {
  useEffect11(() => {
    var _a3, _b;
    const currentDocument = (_b = (_a3 = componentRef === null || componentRef === void 0 ? void 0 : componentRef.current) === null || _a3 === void 0 ? void 0 : _a3.ownerDocument) !== null && _b !== void 0 ? _b : document;
    let frame = frames.get(currentDocument);
    if (frame) {
      frame.componentsCount++;
    } else {
      const abortController = addListeners(currentDocument);
      frame = { componentsCount: 1, abortController };
      frames.set(currentDocument, frame);
    }
    return () => {
      frame.componentsCount--;
      if (frame.componentsCount === 0) {
        frame.abortController.abort();
        frames.delete(currentDocument);
      }
    };
  }, [componentRef]);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/single-tab-stop/index.js
import React9, { createContext, forwardRef, useContext, useImperativeHandle, useLayoutEffect as useLayoutEffect3, useRef as useRef9, useState as useState6 } from "react";

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/use-effect-on-update/index.js
import { useEffect as useEffect12, useRef as useRef8 } from "react";
function useEffectOnUpdate(callback, deps) {
  const isFirstRender = useRef8(true);
  useEffect12(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      return callback();
    }
  }, deps);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/single-tab-stop/index.js
var defaultValue = {
  navigationActive: false,
  registerFocusable: () => () => {
  },
  resetFocusTarget: () => {
  }
};
var SingleTabStopNavigationContext = createContext(defaultValue);
function useSingleTabStopNavigation(focusable, options) {
  var _a3;
  const { navigationActive: contextNavigationActive, registerFocusable } = useContext(SingleTabStopNavigationContext);
  const [focusTargetActive, setFocusTargetActive] = useState6(false);
  const navigationDisabled = (options === null || options === void 0 ? void 0 : options.tabIndex) && (options === null || options === void 0 ? void 0 : options.tabIndex) < 0;
  const navigationActive = contextNavigationActive && !navigationDisabled;
  useLayoutEffect3(() => {
    if (navigationActive && focusable && focusable.current) {
      const unregister = registerFocusable(focusable.current, (isFocusable2) => setFocusTargetActive(isFocusable2));
      return () => unregister();
    }
  });
  let tabIndex = options === null || options === void 0 ? void 0 : options.tabIndex;
  if (navigationActive) {
    tabIndex = !focusTargetActive ? -1 : (_a3 = options === null || options === void 0 ? void 0 : options.tabIndex) !== null && _a3 !== void 0 ? _a3 : 0;
  }
  return { navigationActive, tabIndex };
}
function SingleTabStopNavigationReset({ children }) {
  return React9.createElement(SingleTabStopNavigationContext.Provider, { value: defaultValue }, children);
}
var SingleTabStopNavigationProvider = forwardRef(({ navigationActive, children, getNextFocusTarget, isElementSuppressed, onRegisterFocusable, onUnregisterActive }, ref) => {
  const focusables = useRef9(/* @__PURE__ */ new Set());
  const focusHandlers = useRef9(/* @__PURE__ */ new Map());
  const focusablesState = useRef9(/* @__PURE__ */ new WeakMap());
  const focusTarget = useRef9(null);
  function onUnregisterFocusable(focusableElement) {
    const isUnregisteringFocusedNode = nodeBelongs(focusableElement, document.activeElement);
    if (isUnregisteringFocusedNode) {
      setTimeout(() => onUnregisterActive === null || onUnregisterActive === void 0 ? void 0 : onUnregisterActive(focusableElement), 0);
    }
  }
  function registerFocusable(focusableElement, changeHandler) {
    const parentUnregister = parentContext.registerFocusable(focusableElement, changeHandler);
    focusables.current.add(focusableElement);
    focusHandlers.current.set(focusableElement, changeHandler);
    const isFocusable2 = !!focusablesState.current.get(focusableElement);
    const newIsFocusable = focusTarget.current === focusableElement || !!(isElementSuppressed === null || isElementSuppressed === void 0 ? void 0 : isElementSuppressed(focusableElement));
    if (newIsFocusable !== isFocusable2) {
      focusablesState.current.set(focusableElement, newIsFocusable);
      changeHandler(newIsFocusable);
    }
    onRegisterFocusable === null || onRegisterFocusable === void 0 ? void 0 : onRegisterFocusable(focusableElement);
    return () => {
      parentUnregister();
      unregisterFocusable(focusableElement);
    };
  }
  function unregisterFocusable(focusableElement) {
    focusables.current.delete(focusableElement);
    focusHandlers.current.delete(focusableElement);
    onUnregisterFocusable === null || onUnregisterFocusable === void 0 ? void 0 : onUnregisterFocusable(focusableElement);
  }
  function updateFocusTarget(forceUpdate = false) {
    var _a3;
    focusTarget.current = getNextFocusTarget();
    for (const focusableElement of focusables.current) {
      const isFocusable2 = (_a3 = focusablesState.current.get(focusableElement)) !== null && _a3 !== void 0 ? _a3 : false;
      const newIsFocusable = focusTarget.current === focusableElement || !!(isElementSuppressed === null || isElementSuppressed === void 0 ? void 0 : isElementSuppressed(focusableElement));
      if (newIsFocusable !== isFocusable2 || forceUpdate) {
        focusablesState.current.set(focusableElement, newIsFocusable);
        focusHandlers.current.get(focusableElement)(newIsFocusable);
      }
    }
  }
  function resetFocusTarget() {
    updateFocusTarget(true);
  }
  function getFocusTarget() {
    return focusTarget.current;
  }
  function isRegistered(element) {
    return focusables.current.has(element);
  }
  useImperativeHandle(ref, () => ({ updateFocusTarget, getFocusTarget, isRegistered }));
  const parentContext = useContext(SingleTabStopNavigationContext);
  const value = parentContext.navigationActive ? parentContext : { navigationReset: false, navigationActive, registerFocusable, updateFocusTarget, resetFocusTarget };
  useEffectOnUpdate(() => {
    if (parentContext.navigationActive) {
      parentContext.resetFocusTarget();
    } else {
      resetFocusTarget();
    }
  }, [parentContext.navigationActive]);
  return React9.createElement(SingleTabStopNavigationContext.Provider, { value }, children);
});

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/focus-lock-utils/utils.js
var tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
].join(",");

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/portal/index.js
import React10, { useLayoutEffect as useLayoutEffect4, useState as useState7 } from "react";
import { createPortal } from "react-dom";
function manageDefaultContainer(ownerDocument, setState) {
  const newContainer = ownerDocument.createElement("div");
  ownerDocument.body.appendChild(newContainer);
  setState(newContainer);
  return () => {
    ownerDocument.body.removeChild(newContainer);
  };
}
function manageAsyncContainer(getContainer, removeContainer, setState) {
  let newContainer = null;
  const abortController = new AbortController();
  getContainer({ abortSignal: abortController.signal }).then((container) => {
    if (abortController.signal.aborted) {
      return;
    }
    newContainer = container;
    setState(container);
  }, (error) => {
    console.warn("[AwsUi] [portal]: failed to load portal root", error);
  });
  return () => {
    abortController.abort();
    removeContainer(newContainer);
  };
}
function Portal({ container, getContainer, removeContainer, children }) {
  const [activeContainer, setActiveContainer] = useState7(container !== null && container !== void 0 ? container : null);
  const ref = React10.useRef(null);
  useLayoutEffect4(() => {
    var _a3, _b;
    if (container) {
      setActiveContainer(container);
      return;
    }
    if (isDevelopment) {
      if (getContainer && !removeContainer) {
        warnOnce("portal", "`removeContainer` is required when `getContainer` is provided");
      }
      if (!getContainer && removeContainer) {
        warnOnce("portal", "`getContainer` is required when `removeContainer` is provided");
      }
    }
    if (getContainer && removeContainer) {
      return manageAsyncContainer(getContainer, removeContainer, setActiveContainer);
    }
    const ownerDocument = (_b = (_a3 = ref.current) === null || _a3 === void 0 ? void 0 : _a3.ownerDocument) !== null && _b !== void 0 ? _b : document;
    return manageDefaultContainer(ownerDocument, setActiveContainer);
  }, [container, getContainer, removeContainer]);
  if (!activeContainer) {
    return React10.createElement("span", { ref, style: { display: "none" } });
  }
  return activeContainer && createPortal(children, activeContainer);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/use-merge-refs/index.js
import { useMemo as useMemo5 } from "react";
function useMergeRefs(...refs) {
  return useMemo5(() => {
    if (refs.every((ref) => ref === null || ref === void 0)) {
      return null;
    }
    return (value) => {
      refs.forEach((ref) => {
        if (typeof ref === "function") {
          ref(value);
        } else if (ref !== null && ref !== void 0) {
          ref.current = value;
        }
      });
    };
  }, refs);
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/use-unique-id/index.js
import React11, { useRef as useRef10 } from "react";
var _a;
var counter = 0;
var useRandomId = () => {
  const idRef = useRef10(null);
  if (!idRef.current) {
    idRef.current = `${counter++}-${Date.now()}-${Math.round(Math.random() * 1e4)}`;
  }
  return idRef.current;
};
var useId = (_a = React11.useId) !== null && _a !== void 0 ? _a : useRandomId;
function useUniqueId(prefix) {
  return `${prefix ? prefix : ""}` + useId();
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/base-component/validate-props.js
function validateProps(componentName2, props, excludedProps, allowedEnums, systemName) {
  if (!isDevelopment) {
    return;
  }
  for (const [prop, value] of Object.entries(props)) {
    if (excludedProps.includes(prop)) {
      throw new Error(`${componentName2} does not support "${prop}" property when used in ${systemName} system`);
    }
    if (value && allowedEnums[prop] && !allowedEnums[prop].includes(value)) {
      throw new Error(`${componentName2} does not support "${prop}" with value "${value}" when used in ${systemName} system`);
    }
  }
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/selection-tree/index.js
var ROOT_KEY = Symbol("selection-tree-root");

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/internal/analytics-metadata/attributes.js
var METADATA_ATTRIBUTE = "data-awsui-analytics";
var LABEL_ATTRIBUTE = "data-awsui-analytics-label";
var activated = getGlobalFlag("analyticsMetadata");
var getAnalyticsMetadataAttribute = (metadata) => activated ? {
  [METADATA_ATTRIBUTE]: JSON.stringify(metadata)
} : {};
var getAnalyticsLabelAttribute = (labelIdentifierString) => activated ? {
  [LABEL_ATTRIBUTE]: labelIdentifierString
} : {};

// ../../node_modules/tslib/tslib.es6.mjs
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2)
      if (Object.prototype.hasOwnProperty.call(b2, p))
        d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
  __assign = Object.assign || function __assign3(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __classPrivateFieldGet(receiver, state2, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state2 === "function" ? receiver !== state2 || !f : !state2.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state2.get(receiver);
}
function __classPrivateFieldSet(receiver, state2, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state2 === "function" ? receiver !== state2 || !f : !state2.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state2.set(receiver, value), value;
}

// ../../node_modules/@amzn/awsui-analytics-client/lib/utils/custom-event.js
var getPanorama = () => {
  try {
    if (typeof window.panorama === "function") {
      return window.panorama;
    }
    const panoramaSymbol = Symbol.for("panorama");
    if (typeof window[panoramaSymbol] === "function") {
      return window[panoramaSymbol];
    }
    if (window.top && window.self !== window.top) {
      try {
        if (typeof window.top.panorama === "function") {
          return window.top.panorama;
        }
      } catch (crossOriginError) {
      }
    }
  } catch (e) {
  }
  return void 0;
};
var isPanoramaEnabled = () => {
  return !!getPanorama();
};
var checkIfCanEmptyBuffer = () => {
  if (isPanoramaEnabled()) {
    initialBuffer.forEach((metric) => {
      emitPanoramaCustomEvent(metric);
    });
  }
};
var initialBuffer = [];
var pushToBuffer = (metric) => {
  initialBuffer.push(metric);
  checkIfCanEmptyBuffer();
};
var emitPanoramaCustomEvent = (metric) => {
  if (!isPanoramaEnabled()) {
    pushToBuffer(Object.assign(Object.assign({}, metric), { timestamp: Date.now() }));
    return;
  }
  const panoramaWindow = getPanorama();
  if (panoramaWindow) {
    panoramaWindow("trackCustomEvent", Object.assign(Object.assign({}, metric), { timestamp: metric.timestamp || Date.now() }));
  }
};
var emitFunnelInteractionEvent = (metric) => {
  return emitPanoramaCustomEvent(Object.assign(Object.assign({}, metric), { eventType: "funnelInteraction" }));
};
var withErrorHandling = (fnName) => (func) => {
  return (...args) => {
    try {
      return func(...args);
    } catch (err) {
      try {
        emitPanoramaCustomEvent({
          eventContext: fnName,
          eventSource: "panoramaInternal",
          eventDetail: err ? err.toString() : ""
        });
      } catch (_a3) {
      }
    }
  };
};
var setFunnelInteractionId = (id) => {
  const panoramaWindow = getPanorama();
  if (panoramaWindow) {
    panoramaWindow("setFunnelInteractionId", id);
  }
};

// ../../node_modules/@amzn/awsui-analytics-client/lib/utils/dom.js
var isValidDocument = (currentDocument) => {
  return !!(currentDocument && typeof currentDocument === "object" && typeof currentDocument.querySelector === "function");
};
var extractText = withErrorHandling("extractText")((selector, currentDocument = document) => {
  if (!selector) {
    return "";
  }
  const documentToUse = isValidDocument(currentDocument) ? currentDocument : document;
  const element = documentToUse.querySelector(selector);
  return extractNestedTextContent(element).trim();
});
function extractNestedTextContent(node) {
  if (!node) {
    return "";
  }
  let text = "";
  const customNode = node;
  if (node.nodeType === Node.TEXT_NODE) {
    text += (node.textContent || "").replace(/\s+/g, " ").replace(/\n/g, " ");
  } else if (customNode.tagName !== "A") {
    const childNodes = node.childNodes;
    for (let i = 0; i < childNodes.length; i++) {
      text += extractNestedTextContent(childNodes[i]);
    }
  }
  return text;
}
var extractTextContent = withErrorHandling("extractTextContent")((selector, currentDocument = document) => {
  if (!selector) {
    return "";
  }
  const documentToUse = isValidDocument(currentDocument) ? currentDocument : document;
  const element = documentToUse.querySelector(selector);
  if (!element) {
    return "";
  }
  return element.textContent;
});
var extractNumberOfElements = withErrorHandling("extractNumberOfElements")((selector, currentDocument = document) => {
  if (!selector) {
    return 0;
  }
  const documentToUse = isValidDocument(currentDocument) ? currentDocument : document;
  const elements = documentToUse.querySelectorAll(selector);
  return elements === null || elements === void 0 ? void 0 : elements.length;
});
var extractSubStepNumberFromSelector = withErrorHandling("extractSubStepNumberFromSelector")((subStepSelector, subStepAllSelector, currentDocument = document) => {
  if (!subStepSelector || !subStepAllSelector) {
    return 0;
  }
  const documentToUse = isValidDocument(currentDocument) ? currentDocument : document;
  const allSubSteps = documentToUse.querySelectorAll(subStepAllSelector);
  const currentSubStep = documentToUse.querySelector(subStepSelector);
  let subStepNumber = 0;
  for (const [index, subStep] of allSubSteps.entries()) {
    if (subStep === currentSubStep) {
      subStepNumber = index + 1;
      break;
    }
  }
  return subStepNumber;
});

// ../../node_modules/@amzn/awsui-analytics-client/lib/utils/uuid.js
var hasRandomUuidSupport = () => {
  return !!window.crypto && !!crypto.randomUUID;
};
var uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r2 = Math.random() * 16 | 0;
    const v = c === "x" ? r2 : r2 & 3 | 8;
    return v.toString(16);
  });
};
var getUuid = () => {
  if (!hasRandomUuidSupport()) {
    return uuidv4();
  }
  return crypto.randomUUID();
};

// ../../node_modules/@amzn/awsui-analytics-client/lib/utils/dom-extractor.js
var widgetIdSelector = "data-analytics-widget-id";
var moduleIdSelector = "data-module-id";
var getElementInfo = (elementSelector, currentDocument = document) => {
  const documentToUse = isValidDocument(currentDocument) ? currentDocument : document;
  let element = documentToUse.querySelector(elementSelector);
  const widgetIds = [];
  for (; element && element.nodeType === 1; element = element.parentNode) {
    if ((element === null || element === void 0 ? void 0 : element.hasAttribute(widgetIdSelector)) || (element === null || element === void 0 ? void 0 : element.hasAttribute(moduleIdSelector))) {
      const key = element.getAttribute(widgetIdSelector) || element.getAttribute(moduleIdSelector);
      if (key && !widgetIds.includes(key)) {
        widgetIds.push(key);
      }
    }
  }
  return {
    widgetIds
  };
};

// ../../node_modules/@amzn/awsui-analytics-client/lib/utils/funnel-widget-ids.js
var FUNNEL_WIDGET_IDS_SYMBOL = Symbol.for("pano-funnel-widget-ids");
var setWidgetIds = (funnelInteractionId, widgetIds) => {
  if (!window[FUNNEL_WIDGET_IDS_SYMBOL]) {
    window[FUNNEL_WIDGET_IDS_SYMBOL] = /* @__PURE__ */ new Map();
  }
  window[FUNNEL_WIDGET_IDS_SYMBOL].set(funnelInteractionId, widgetIds);
};
var getWidgetIds = (funnelInteractionId) => {
  var _a3;
  return ((_a3 = window[FUNNEL_WIDGET_IDS_SYMBOL]) === null || _a3 === void 0 ? void 0 : _a3.get(funnelInteractionId)) || [];
};

// ../../node_modules/@amzn/awsui-analytics-client/lib/index.js
var currentFunnelInteractionId;
var FunnelMetrics = {
  funnelStart(_a3) {
    var { funnelNameSelector, funnelIdentifier, funnelInteractionId, componentTheme, currentDocument = document, stepConfiguration, funnelName, componentSelector } = _a3, props = __rest(_a3, ["funnelNameSelector", "funnelIdentifier", "funnelInteractionId", "componentTheme", "currentDocument", "stepConfiguration", "funnelName", "componentSelector"]);
    const generatedFunnelInteractionId = getUuid();
    const TASK_INTERACTION_ID_SYMBOL = Symbol.for("pano-task-interaction-id");
    if (window[TASK_INTERACTION_ID_SYMBOL]) {
      currentFunnelInteractionId = `${window[TASK_INTERACTION_ID_SYMBOL]}--${generatedFunnelInteractionId}`;
    } else {
      currentFunnelInteractionId = funnelInteractionId || generatedFunnelInteractionId;
    }
    const uxFunnelName = extractTextContent(funnelNameSelector, currentDocument);
    const computedFunnelName = funnelIdentifier || uxFunnelName || funnelName;
    const extractedStepConfiguration = stepConfiguration === null || stepConfiguration === void 0 ? void 0 : stepConfiguration.map((_a4) => {
      var { stepIdentifier, name } = _a4, rest = __rest(_a4, ["stepIdentifier", "name"]);
      return Object.assign({ name: stepIdentifier || name }, rest);
    });
    const widgetIdSelector2 = componentSelector || funnelNameSelector;
    const { widgetIds } = getElementInfo(widgetIdSelector2, currentDocument);
    setWidgetIds(currentFunnelInteractionId, widgetIds);
    const serviceProvidedName = funnelIdentifier ? true : false;
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({
        funnelEventType: "funnelStart",
        funnelInteractionId: currentFunnelInteractionId,
        funnelName: computedFunnelName,
        uxFunnelName,
        serviceProvidedName,
        theme: componentTheme,
        stepConfiguration: extractedStepConfiguration
      }, props),
      widgetIds
    });
    return currentFunnelInteractionId;
  },
  funnelError(_a3) {
    var { funnelInteractionId, errorContext } = _a3, props = __rest(_a3, ["funnelInteractionId", "errorContext"]);
    const interactionId = funnelInteractionId || currentFunnelInteractionId;
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign(Object.assign({ funnelEventType: "funnelError", funnelInteractionId: interactionId }, errorContext), props),
      widgetIds: getWidgetIds(interactionId)
    });
  },
  funnelComplete(_a3) {
    var { funnelInteractionId } = _a3, props = __rest(_a3, ["funnelInteractionId"]);
    const interactionId = funnelInteractionId || currentFunnelInteractionId;
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelComplete", funnelInteractionId: interactionId }, props),
      widgetIds: getWidgetIds(interactionId)
    });
    setFunnelInteractionId(interactionId);
  },
  funnelSuccessful(_a3) {
    var { funnelInteractionId } = _a3, props = __rest(_a3, ["funnelInteractionId"]);
    const interactionId = funnelInteractionId || currentFunnelInteractionId;
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelSuccessful", funnelInteractionId: interactionId }, props),
      widgetIds: getWidgetIds(interactionId)
    });
  },
  funnelCancelled(_a3) {
    var { funnelInteractionId } = _a3, props = __rest(_a3, ["funnelInteractionId"]);
    const interactionId = funnelInteractionId || currentFunnelInteractionId;
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelCancelled", funnelInteractionId: interactionId }, props),
      widgetIds: getWidgetIds(interactionId)
    });
  },
  funnelChange(_a3) {
    var { funnelInteractionId, stepConfiguration } = _a3, props = __rest(_a3, ["funnelInteractionId", "stepConfiguration"]);
    const extractedStepConfiguration = stepConfiguration === null || stepConfiguration === void 0 ? void 0 : stepConfiguration.map((_a4) => {
      var { stepIdentifier, name } = _a4, rest = __rest(_a4, ["stepIdentifier", "name"]);
      return Object.assign({ name: stepIdentifier || name }, rest);
    });
    const interactionId = funnelInteractionId || currentFunnelInteractionId;
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelChange", funnelInteractionId: interactionId, stepConfiguration: extractedStepConfiguration }, props),
      widgetIds: getWidgetIds(interactionId)
    });
  },
  funnelStepStart(_a3) {
    var { stepName, stepNameSelector, subStepAllSelector, totalSubSteps, funnelInteractionId, stepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["stepName", "stepNameSelector", "subStepAllSelector", "totalSubSteps", "funnelInteractionId", "stepIdentifier", "subStepConfiguration", "currentDocument"]);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const totalNoOfSubSteps = totalSubSteps || extractNumberOfElements(subStepAllSelector, currentDocument);
    const extractedStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier || name }, rest);
    });
    let widgetIds = [];
    if (stepNameSelector) {
      ({ widgetIds } = getElementInfo(stepNameSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepStart", stepName: extractedStepName, totalSubSteps: totalNoOfSubSteps, subStepConfiguration: extractedStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
      widgetIds
    });
  },
  funnelStepComplete(_a3) {
    var { stepName, stepNameSelector, subStepAllSelector, totalSubSteps, funnelInteractionId, stepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["stepName", "stepNameSelector", "subStepAllSelector", "totalSubSteps", "funnelInteractionId", "stepIdentifier", "subStepConfiguration", "currentDocument"]);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const totalNoOfSubSteps = totalSubSteps || extractNumberOfElements(subStepAllSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier || name }, rest);
    });
    let widgetIds = [];
    if (stepNameSelector) {
      ({ widgetIds } = getElementInfo(stepNameSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepComplete", totalSubSteps: totalNoOfSubSteps, stepName: extractedStepName, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
      widgetIds
    });
  },
  funnelStepError(_a3) {
    var { stepName, stepNameSelector, stepErrorSelector, funnelInteractionId, stepIdentifier, errorContext, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["stepName", "stepNameSelector", "stepErrorSelector", "funnelInteractionId", "stepIdentifier", "errorContext", "subStepConfiguration", "currentDocument"]);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const extractedStepError = extractText(stepErrorSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier || name }, rest);
    });
    let widgetIds = [];
    if (stepNameSelector) {
      ({ widgetIds } = getElementInfo(stepNameSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign(Object.assign({ funnelEventType: "funnelStepError", stepError: extractedStepError, stepName: extractedStepName, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, errorContext), props),
      widgetIds
    });
  },
  funnelStepNavigation(_a3) {
    var { stepNumber, stepNameSelector, stepName, subStepAllSelector, totalSubSteps, funnelInteractionId, stepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["stepNumber", "stepNameSelector", "stepName", "subStepAllSelector", "totalSubSteps", "funnelInteractionId", "stepIdentifier", "subStepConfiguration", "currentDocument"]);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const totalNoOfSubSteps = totalSubSteps || extractNumberOfElements(subStepAllSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier || name }, rest);
    });
    let widgetIds = [];
    if (stepNameSelector) {
      ({ widgetIds } = getElementInfo(stepNameSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepNavigation", originStepNumber: stepNumber, originStepName: extractedStepName, totalSubSteps: totalNoOfSubSteps, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
      widgetIds
    });
  },
  funnelStepChange(_a3) {
    var { stepName, stepNameSelector, subStepAllSelector = "", totalSubSteps, funnelInteractionId, stepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["stepName", "stepNameSelector", "subStepAllSelector", "totalSubSteps", "funnelInteractionId", "stepIdentifier", "subStepConfiguration", "currentDocument"]);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const totalNoOfSubSteps = totalSubSteps || extractNumberOfElements(subStepAllSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier || name }, rest);
    });
    let widgetIds = [];
    if (stepNameSelector) {
      ({ widgetIds } = getElementInfo(stepNameSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelStepChange", stepName: extractedStepName, totalSubSteps: totalNoOfSubSteps, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
      widgetIds
    });
  },
  funnelSubStepStart(_a3) {
    var { subStepNameSelector, stepNameSelector, stepName, subStepNumber, subStepName, subStepSelector, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["subStepNameSelector", "stepNameSelector", "stepName", "subStepNumber", "subStepName", "subStepSelector", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
    const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const extractedSubStepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier: subStepIdentifier2, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier2 || name }, rest);
    });
    let widgetIds = [];
    if (subStepNameSelector) {
      ({ widgetIds } = getElementInfo(subStepNameSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelSubStepStart", subStepName: extractedSubStepName, subStepNumber: extractedSubStepNumber, stepName: extractedStepName, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
      widgetIds
    });
  },
  funnelSubStepComplete(_a3) {
    var { subStepNumber, subStepNameSelector, subStepName, subStepSelector, stepNameSelector, stepName, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["subStepNumber", "subStepNameSelector", "subStepName", "subStepSelector", "stepNameSelector", "stepName", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
    const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const extractedSubstepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier: subStepIdentifier2, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier2 || name }, rest);
    });
    let widgetIds = [];
    if (subStepNameSelector) {
      ({ widgetIds } = getElementInfo(subStepNameSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "funnelSubStepComplete", subStepName: extractedSubStepName, subStepNumber: extractedSubstepNumber, stepName: extractedStepName, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
      widgetIds
    });
  },
  funnelSubStepError(_a3) {
    var { fieldIdentifier, errorContext, fieldLabelSelector, fieldErrorSelector, subStepNumber, subStepSelector, subStepNameSelector, subStepName, stepNameSelector, stepName, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["fieldIdentifier", "errorContext", "fieldLabelSelector", "fieldErrorSelector", "subStepNumber", "subStepSelector", "subStepNameSelector", "subStepName", "stepNameSelector", "stepName", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
    const fieldName = fieldIdentifier || extractText(fieldLabelSelector, currentDocument);
    const fieldError = extractText(fieldErrorSelector, currentDocument);
    const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const extractedSubStepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier: subStepIdentifier2, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier2 || name }, rest);
    });
    let widgetIds = [];
    if (fieldLabelSelector) {
      ({ widgetIds } = getElementInfo(fieldLabelSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign(Object.assign({
        funnelEventType: "funnelSubStepError",
        subStepName: extractedSubStepName,
        subStepNumber: extractedSubStepNumber,
        stepName: extractedStepName,
        fieldName,
        fieldError,
        subStepConfiguration: extractedSubStepConfiguration,
        funnelInteractionId: funnelInteractionId || currentFunnelInteractionId
      }, errorContext), props),
      widgetIds
    });
  },
  helpPanelInteracted(_a3) {
    var { elementSelector, stepNameSelector, stepName, subStepNumber, subStepSelector, subStepNameSelector, subStepName, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["elementSelector", "stepNameSelector", "stepName", "subStepNumber", "subStepSelector", "subStepNameSelector", "subStepName", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
    const extractedHelpContent = extractTextContent(elementSelector, currentDocument);
    const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const extractedSubStepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier: subStepIdentifier2, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier2 || name }, rest);
    });
    let widgetIds = [];
    if (elementSelector) {
      ({ widgetIds } = getElementInfo(elementSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "helpPanelInteracted", stepName: extractedStepName, subStepNumber: extractedSubStepNumber, subStepName: extractedSubStepName, helpContent: extractedHelpContent, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
      widgetIds
    });
  },
  externalLinkInteracted(_a3) {
    var { elementSelector, stepNameSelector, stepName, subStepNumber, subStepSelector, subStepNameSelector, subStepName, subStepAllSelector, funnelInteractionId, stepIdentifier, subStepIdentifier, subStepConfiguration, currentDocument = document } = _a3, props = __rest(_a3, ["elementSelector", "stepNameSelector", "stepName", "subStepNumber", "subStepSelector", "subStepNameSelector", "subStepName", "subStepAllSelector", "funnelInteractionId", "stepIdentifier", "subStepIdentifier", "subStepConfiguration", "currentDocument"]);
    const extractedLinkText = extractTextContent(elementSelector, currentDocument);
    const extractedSubStepName = subStepIdentifier || subStepName || extractText(subStepNameSelector, currentDocument);
    const extractedStepName = stepIdentifier || stepName || extractText(stepNameSelector, currentDocument);
    const extractedSubStepNumber = subStepNumber || extractSubStepNumberFromSelector(subStepSelector, subStepAllSelector, currentDocument);
    const extractedSubStepConfiguration = subStepConfiguration === null || subStepConfiguration === void 0 ? void 0 : subStepConfiguration.map((_a4) => {
      var { subStepIdentifier: subStepIdentifier2, name } = _a4, rest = __rest(_a4, ["subStepIdentifier", "name"]);
      return Object.assign({ name: subStepIdentifier2 || name }, rest);
    });
    let widgetIds = [];
    if (elementSelector) {
      ({ widgetIds } = getElementInfo(elementSelector, currentDocument));
    }
    emitFunnelInteractionEvent({
      eventInteractionMetaData: Object.assign({ funnelEventType: "externalLinkInteracted", stepName: extractedStepName, subStepNumber: extractedSubStepNumber, subStepName: extractedSubStepName, linkText: extractedLinkText, subStepConfiguration: extractedSubStepConfiguration, funnelInteractionId: funnelInteractionId || currentFunnelInteractionId }, props),
      widgetIds
    });
  }
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/analytics/hooks/use-funnel.js
import { useContext as useContext2, useRef as useRef11 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/dom.js
function isContainingBlock(element) {
  var _a3;
  const computedStyle = getComputedStyle(element);
  return !!computedStyle.transform && computedStyle.transform !== "none" || !!computedStyle.perspective && computedStyle.perspective !== "none" || ((_a3 = computedStyle.contain) === null || _a3 === void 0 ? void 0 : _a3.split(" ").some((s) => ["layout", "paint", "strict", "content"].includes(s)));
}
function findUpUntilMultiple({ startElement, tests }) {
  const keys = Object.keys(tests);
  const elements = {};
  let current = startElement;
  while (current && Object.keys(elements).length < keys.length) {
    current = current.parentElement;
    while (current && !isHTMLElement2(current)) {
      current = current.parentElement;
    }
    for (const key of keys) {
      if (!elements[key] && current && tests[key](current)) {
        elements[key] = current;
      }
    }
  }
  return elements;
}
function isNode2(target) {
  return target instanceof Node || target !== null && typeof target === "object" && // eslint-disable-next-line no-restricted-syntax -- Cross-window duck typing: instanceof fails across iframes
  "nodeType" in target && typeof target.nodeType === "number" && // eslint-disable-next-line no-restricted-syntax -- Cross-window duck typing: instanceof fails across iframes
  "nodeName" in target && typeof target.nodeName === "string" && // eslint-disable-next-line no-restricted-syntax -- Cross-window duck typing: instanceof fails across iframes
  "parentNode" in target && typeof target.parentNode === "object";
}
function isHTMLElement2(target) {
  return target instanceof HTMLElement || isNode2(target) && target.nodeType === Node.ELEMENT_NODE && // eslint-disable-next-line no-restricted-syntax -- Cross-window HTMLElement detection
  "style" in target && typeof target.style === "object" && typeof target.ownerDocument === "object" && !isSVGElement2(target);
}
function isSVGElement2(target) {
  return target instanceof SVGElement || isNode2(target) && target.nodeType === Node.ELEMENT_NODE && // eslint-disable-next-line no-restricted-syntax -- Cross-window SVGElement detection
  "ownerSVGElement" in target && typeof target.ownerSVGElement === "object";
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/node-belongs.js
function nodeBelongs2(container, target) {
  var _a3;
  if (!isNode2(target)) {
    return false;
  }
  const portal = findUpUntil(target, (node) => node === container || isHTMLElement2(node) && !!node.dataset.awsuiReferrerId);
  if (portal && portal === container) {
    return true;
  }
  const referrer = isHTMLElement2(portal) ? document.getElementById((_a3 = portal.dataset.awsuiReferrerId) !== null && _a3 !== void 0 ? _a3 : "") : null;
  return referrer ? nodeContains(container, referrer) : nodeContains(container, target);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/analytics/context/analytics-context.js
import { createContext as createContext2 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/analytics/selectors.js
var DATA_ATTR_FUNNEL = "data-analytics-funnel";
var DATA_ATTR_FUNNEL_INTERACTION_ID = `${DATA_ATTR_FUNNEL}-interaction-id`;
var DATA_ATTR_FUNNEL_KEY = `${DATA_ATTR_FUNNEL}-key`;
var DATA_ATTR_FUNNEL_VALUE = `${DATA_ATTR_FUNNEL}-value`;
var DATA_ATTR_FUNNEL_STEP = `${DATA_ATTR_FUNNEL}-step`;
var DATA_ATTR_FUNNEL_SUBSTEP = `${DATA_ATTR_FUNNEL}-substep`;
var DATA_ATTR_RESOURCE_TYPE = `${DATA_ATTR_FUNNEL}-resource-type`;
var DATA_ATTR_ANALYTICS_ALERT = "data-analytics-alert";
var FUNNEL_KEY_FUNNEL_NAME = "funnel-name";
var FUNNEL_KEY_SUBSTEP_NAME = "substep-name";
var getFunnelNameSelector = () => `[${DATA_ATTR_FUNNEL_KEY}="${FUNNEL_KEY_FUNNEL_NAME}"]`;
var getFunnelValueSelector = (value) => `[${DATA_ATTR_FUNNEL_VALUE}="${value}"]`;
var getSubStepAllSelector = () => `[${DATA_ATTR_FUNNEL_SUBSTEP}]`;
var getSubStepSelector = (subStepId) => `[${DATA_ATTR_FUNNEL_SUBSTEP}="${subStepId}"]`;
var getSubStepNameSelector = (subStepId) => [subStepId ? getSubStepSelector(subStepId) : "", `[${DATA_ATTR_FUNNEL_KEY}="${FUNNEL_KEY_SUBSTEP_NAME}"]`].join(" ");
var getTextFromSelector = (selector) => {
  var _a3, _b;
  return selector ? (_b = (_a3 = document.querySelector(selector)) === null || _a3 === void 0 ? void 0 : _a3.textContent) === null || _b === void 0 ? void 0 : _b.trim() : void 0;
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/analytics/context/analytics-context.js
var FunnelContext = createContext2({
  funnelInteractionId: void 0,
  funnelNameSelector: getFunnelNameSelector(),
  setFunnelInteractionId: () => {
  },
  funnelType: "single-page",
  optionalStepNumbers: [],
  totalFunnelSteps: 0,
  funnelSubmit: () => {
  },
  funnelCancel: () => {
  },
  submissionAttempt: 0,
  funnelNextOrSubmitAttempt: () => {
  },
  funnelState: { current: "default" },
  errorCount: { current: 0 },
  loadingButtonCount: { current: 0 },
  latestFocusCleanupFunction: { current: void 0 },
  isInFunnel: false,
  wizardCount: { current: 0 }
});
var FunnelStepContext = createContext2({
  stepNameSelector: "",
  stepNumber: 0,
  subStepCount: { current: 0 },
  isInStep: false,
  funnelInteractionId: void 0,
  onStepChange: () => {
  },
  subStepConfiguration: { current: /* @__PURE__ */ new Map() }
});
var FunnelSubStepContext = createContext2({
  subStepId: "",
  subStepSelector: "",
  subStepNameSelector: "",
  subStepRef: { current: null },
  isNestedSubStep: false,
  mousePressed: { current: false },
  isFocusedSubStep: { current: false },
  focusCleanupFunction: { current: void 0 }
});
var FunnelNameSelectorContext = createContext2(void 0);

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/analytics/hooks/use-funnel.js
var useFunnelSubStep = () => {
  const context = useContext2(FunnelSubStepContext);
  const { funnelInteractionId, funnelIdentifier, funnelState, latestFocusCleanupFunction } = useFunnel();
  const { stepNumber, stepIdentifier, stepNameSelector, subStepConfiguration } = useFunnelStep();
  const { subStepIdentifier, subStepId, subStepSelector, subStepNameSelector, subStepRef, isNestedSubStep, mousePressed, isFocusedSubStep, focusCleanupFunction } = context;
  if (isNestedSubStep) {
    return context;
  }
  const onFocus = async (event) => {
    var _a3, _b, _c, _d;
    const element = event.target;
    await new Promise((r2) => setTimeout(r2, 1));
    if (document.activeElement !== element) {
      return;
    }
    if (isFocusedSubStep.current) {
      return;
    }
    isFocusedSubStep.current = true;
    if (funnelInteractionId && subStepId) {
      (_a3 = latestFocusCleanupFunction.current) === null || _a3 === void 0 ? void 0 : _a3.call(latestFocusCleanupFunction);
      const subStepName = getTextFromSelector(subStepNameSelector);
      const stepName = getTextFromSelector(stepNameSelector);
      const subStepNumber = (_d = (_c = (_b = subStepConfiguration.current) === null || _b === void 0 ? void 0 : _b.get(stepNumber)) === null || _c === void 0 ? void 0 : _c.find((step) => step.name === subStepName)) === null || _d === void 0 ? void 0 : _d.number;
      FunnelMetrics.funnelSubStepStart({
        funnelIdentifier,
        funnelInteractionId,
        subStepIdentifier,
        subStepSelector,
        subStepNameSelector,
        subStepName,
        subStepNumber,
        stepIdentifier,
        stepNumber,
        stepName,
        stepNameSelector,
        subStepAllSelector: getSubStepAllSelector()
      });
      let cleanupFunctionHasBeenRun = false;
      focusCleanupFunction.current = () => {
        var _a4, _b2, _c2;
        if (cleanupFunctionHasBeenRun) {
          return;
        }
        cleanupFunctionHasBeenRun = true;
        const subStepNumber2 = (_c2 = (_b2 = (_a4 = subStepConfiguration.current) === null || _a4 === void 0 ? void 0 : _a4.get(stepNumber)) === null || _b2 === void 0 ? void 0 : _b2.find((s) => s.name === subStepName)) === null || _c2 === void 0 ? void 0 : _c2.number;
        if (funnelState.current !== "cancelled") {
          FunnelMetrics.funnelSubStepComplete({
            funnelIdentifier,
            funnelInteractionId,
            subStepIdentifier,
            subStepSelector,
            subStepNameSelector,
            subStepName,
            subStepNumber: subStepNumber2,
            stepIdentifier,
            stepNumber,
            stepName,
            stepNameSelector,
            subStepAllSelector: getSubStepAllSelector()
          });
        }
      };
      latestFocusCleanupFunction.current = focusCleanupFunction.current;
    }
  };
  const onBlur = (event) => {
    var _a3;
    if (mousePressed.current) {
      return;
    }
    if (!subStepRef.current || !event.relatedTarget || !nodeBelongs2(subStepRef.current, event.relatedTarget)) {
      isFocusedSubStep.current = false;
      if (funnelInteractionId && subStepId && funnelState.current !== "cancelled") {
        (_a3 = focusCleanupFunction.current) === null || _a3 === void 0 ? void 0 : _a3.call(focusCleanupFunction);
      }
    }
  };
  const funnelSubStepProps = funnelInteractionId ? {
    [DATA_ATTR_FUNNEL_SUBSTEP]: subStepId,
    onFocus,
    onBlur
  } : {};
  return { funnelSubStepProps, ...context };
};
var useFunnelStep = () => {
  const context = useContext2(FunnelStepContext);
  return context;
};
var useFunnel = () => {
  const context = useContext2(FunnelContext);
  const funnelProps = context.funnelInteractionId ? {
    [DATA_ATTR_FUNNEL_INTERACTION_ID]: context.funnelInteractionId
  } : {};
  return { funnelProps, ...context };
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/environment.js
var PACKAGE_SOURCE = "components";
var PACKAGE_VERSION = "3.0.0 (8bbfddc2)";
var GIT_SHA = "8bbfddc2";
var THEME = "polaris";
var SYSTEM = "console";
var ALWAYS_VISUAL_REFRESH = false;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/base-component/index.js
initAwsUiVersions(PACKAGE_SOURCE, PACKAGE_VERSION);
function getBaseProps(props) {
  const baseProps = {};
  for (const prop in props) {
    if (prop === "id" || prop === "className" || prop.startsWith("data-")) {
      baseProps[prop] = props[prop];
    }
  }
  return baseProps;
}
function getAnalyticsMetadataProps(props) {
  return { ...props === null || props === void 0 ? void 0 : props.analyticsMetadata, ...props === null || props === void 0 ? void 0 : props.__analyticsMetadata };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/get-visual-theme.js
var getVisualTheme = (theme, isVR) => {
  if (theme === "polaris" && isVR) {
    return "vr";
  }
  return theme;
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-visual-mode/index.js
var useVisualRefresh = ALWAYS_VISUAL_REFRESH ? () => true : useRuntimeVisualRefresh;
var useOneTheme = () => isThemeActive(Theme.OneTheme);

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-base-component/styles-check.js
import { useEffect as useEffect13 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/metrics.js
var metrics = new Metrics({ packageSource: PACKAGE_SOURCE, packageVersion: PACKAGE_VERSION, theme: THEME });

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-base-component/styles-check.js
function checkMissingStyles(ownerDocument) {
  if (!ownerDocument.defaultView) {
    return;
  }
  const result = getComputedStyle(ownerDocument.body).getPropertyValue(`--awsui-version-info-${GIT_SHA}`);
  if (!result) {
    console.error(`Missing AWS-UI CSS for theme "${THEME}", version "${PACKAGE_VERSION}", and git sha "${GIT_SHA}".`);
    metrics.sendOpsMetricObject("awsui-missing-css-asset", {});
  }
}
function documentReady(document2, callback) {
  var _a3;
  if (document2.readyState === "complete") {
    callback();
  } else {
    (_a3 = document2.defaultView) === null || _a3 === void 0 ? void 0 : _a3.addEventListener("load", () => callback(), { once: true });
  }
}
async function documentReadyAndIdle(document2, signal) {
  await new Promise((resolve, reject) => {
    signal.addEventListener("abort", () => reject(new DOMException("Aborted", "AbortError")));
    documentReady(document2, () => {
      setTimeout(() => requestIdleCallback(() => resolve()), 1e3);
    });
  });
  const stylesheets = Array.from(document2.querySelectorAll('link[rel="stylesheet"]'));
  await Promise.all(stylesheets.map((link) => {
    if (link.sheet) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      function cleanup(done) {
        link.removeEventListener("load", onLoad);
        link.removeEventListener("error", onError);
        signal.removeEventListener("abort", onAbort);
        done();
      }
      const onLoad = () => cleanup(resolve);
      const onError = () => cleanup(resolve);
      const onAbort = () => cleanup(() => reject(new DOMException("Aborted", "AbortError")));
      link.addEventListener("load", onLoad);
      link.addEventListener("error", onError);
      signal.addEventListener("abort", onAbort);
    });
  }));
}
var checkedDocs = /* @__PURE__ */ new WeakMap();
var checkMissingStylesOnce = (document2) => {
  const checked = checkedDocs.get(document2);
  if (!checked) {
    checkMissingStyles(document2);
    checkedDocs.set(document2, true);
  }
};
function useMissingStylesCheck(elementRef) {
  useEffect13(() => {
    var _a3, _b;
    if (typeof requestIdleCallback !== "function") {
      return;
    }
    const ownerDocument = (_b = (_a3 = elementRef.current) === null || _a3 === void 0 ? void 0 : _a3.ownerDocument) !== null && _b !== void 0 ? _b : document;
    const abortController = new AbortController();
    documentReadyAndIdle(ownerDocument, abortController.signal).then(() => checkMissingStylesOnce(ownerDocument), (error) => {
      if (error.name !== "AbortError") {
        throw error;
      }
    });
    return () => abortController.abort();
  }, [elementRef]);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-base-component/index.js
var themesInitialized = false;
function useBaseComponent(componentName2, config, analyticsMetadata) {
  if (!themesInitialized) {
    initThemes({ skipVisualRefresh: ALWAYS_VISUAL_REFRESH });
    themesInitialized = true;
  }
  const isVisualRefresh = useVisualRefresh();
  const theme = getVisualTheme(THEME, isVisualRefresh);
  useComponentMetrics(componentName2, { packageSource: PACKAGE_SOURCE, packageVersion: PACKAGE_VERSION, theme }, config);
  const elementRef = useComponentMetadata(componentName2, { packageName: PACKAGE_SOURCE, version: PACKAGE_VERSION, theme }, analyticsMetadata);
  useMissingStylesCheck(elementRef);
  useFocusVisible(elementRef);
  return { __internalRootRef: elementRef };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/apply-display-name.js
function applyDisplayName(component, displayName) {
  component.displayName = displayName;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/internal.js
import React35, { useEffect as useEffect27, useImperativeHandle as useImperativeHandle5, useRef as useRef25, useState as useState21 } from "react";

// ../../node_modules/clsx/dist/clsx.m.js
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length; )
    (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_m_default = clsx;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/internal.js
import React31, { useEffect as useEffect23, useRef as useRef21, useState as useState14 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/i18n/context.js
import React12, { useContext as useContext3 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/debounce.js
var DEBOUNCE_DEFAULT_DELAY = 200;
function debounce(func, delay = DEBOUNCE_DEFAULT_DELAY) {
  let timeout2;
  return function(...args) {
    if (timeout2) {
      clearTimeout(timeout2);
    }
    timeout2 = setTimeout(() => {
      timeout2 = null;
      func(...args);
    }, delay);
  };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/helpers/utils.js
function sortByPriority(items) {
  return items.slice().sort((a, b) => {
    var _a3, _b;
    if (b.orderPriority !== a.orderPriority) {
      return Math.sign(((_a3 = b.orderPriority) !== null && _a3 !== void 0 ? _a3 : 0) - ((_b = a.orderPriority) !== null && _b !== void 0 ? _b : 0));
    }
    return b.id < a.id ? 1 : -1;
  });
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/controllers/action-buttons.js
var ActionButtonsController = class {
  constructor() {
    this.listeners = [];
    this.actions = [];
    this.scheduleUpdate = debounce(() => {
      this.listeners.forEach((listener) => listener(this.actions));
    }, 0);
    this.registerAction = (action) => {
      this.actions.push(action);
      this.actions = sortByPriority(this.actions);
      this.scheduleUpdate();
    };
    this.clearRegisteredActionsForTesting = () => {
      this.actions = [];
    };
    this.onActionRegistered = (listener) => {
      this.listeners.push(listener);
      this.scheduleUpdate();
      return () => {
        this.listeners = this.listeners.filter((item) => item !== listener);
      };
    };
  }
  installPublic(api = {}) {
    var _a3, _b;
    (_a3 = api.registerAction) !== null && _a3 !== void 0 ? _a3 : api.registerAction = this.registerAction;
    (_b = api.clearRegisteredActionsForTesting) !== null && _b !== void 0 ? _b : api.clearRegisteredActionsForTesting = this.clearRegisteredActionsForTesting;
    return api;
  }
  installInternal(internalApi = {}) {
    var _a3;
    (_a3 = internalApi.onActionRegistered) !== null && _a3 !== void 0 ? _a3 : internalApi.onActionRegistered = this.onActionRegistered;
    return internalApi;
  }
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/helpers/metrics.js
function reportRuntimeApiLoadMetric() {
  metrics.sendPanoramaMetric({ eventContext: "awsui-runtime-api-loaded", eventDetail: { version: PACKAGE_VERSION } });
}
function reportRuntimeApiWarning(component, message) {
  console.warn("[AwsUi]", `[${component}]`, message);
  metrics.sendPanoramaMetric({
    eventContext: "awsui-runtime-api-warning",
    eventDetail: { version: PACKAGE_VERSION, component, message }
  });
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/controllers/alert-flash-content.js
var _AlertFlashContentController_listeners;
var _AlertFlashContentController_cleanups;
var _AlertFlashContentController_provider;
var _AlertFlashContentController_scheduleUpdate;
var AlertFlashContentController = class {
  constructor() {
    _AlertFlashContentController_listeners.set(this, []);
    _AlertFlashContentController_cleanups.set(this, /* @__PURE__ */ new Map());
    _AlertFlashContentController_provider.set(this, void 0);
    _AlertFlashContentController_scheduleUpdate.set(this, debounce(() => __classPrivateFieldGet(this, _AlertFlashContentController_listeners, "f").forEach((listener) => {
      if (__classPrivateFieldGet(this, _AlertFlashContentController_provider, "f")) {
        const cleanup = listener(__classPrivateFieldGet(this, _AlertFlashContentController_provider, "f"));
        __classPrivateFieldGet(this, _AlertFlashContentController_cleanups, "f").set(listener, cleanup);
      }
    }), 0));
    this.registerContentReplacer = (content) => {
      if (__classPrivateFieldGet(this, _AlertFlashContentController_provider, "f")) {
        reportRuntimeApiWarning("alert-flash-content", `Cannot call \`registerContentReplacer\` with new provider: provider with id "${__classPrivateFieldGet(this, _AlertFlashContentController_provider, "f").id}" already registered.`);
        return;
      }
      __classPrivateFieldSet(this, _AlertFlashContentController_provider, content, "f");
      __classPrivateFieldGet(this, _AlertFlashContentController_scheduleUpdate, "f").call(this);
    };
    this.clearRegisteredReplacerForTesting = () => {
      __classPrivateFieldSet(this, _AlertFlashContentController_provider, void 0, "f");
    };
    this.initialCheck = (context) => {
      var _a3;
      if ((_a3 = __classPrivateFieldGet(this, _AlertFlashContentController_provider, "f")) === null || _a3 === void 0 ? void 0 : _a3.initialCheck) {
        return __classPrivateFieldGet(this, _AlertFlashContentController_provider, "f").initialCheck(context);
      }
      return false;
    };
    this.onContentRegistered = (listener) => {
      if (__classPrivateFieldGet(this, _AlertFlashContentController_provider, "f")) {
        const cleanup = listener(__classPrivateFieldGet(this, _AlertFlashContentController_provider, "f"));
        __classPrivateFieldGet(this, _AlertFlashContentController_listeners, "f").push(listener);
        __classPrivateFieldGet(this, _AlertFlashContentController_cleanups, "f").set(listener, cleanup);
      } else {
        __classPrivateFieldGet(this, _AlertFlashContentController_listeners, "f").push(listener);
      }
      return () => {
        var _a3;
        (_a3 = __classPrivateFieldGet(this, _AlertFlashContentController_cleanups, "f").get(listener)) === null || _a3 === void 0 ? void 0 : _a3();
        __classPrivateFieldSet(this, _AlertFlashContentController_listeners, __classPrivateFieldGet(this, _AlertFlashContentController_listeners, "f").filter((item) => item !== listener), "f");
        __classPrivateFieldGet(this, _AlertFlashContentController_cleanups, "f").delete(listener);
      };
    };
  }
  installPublic(api = {}) {
    var _a3, _b;
    (_a3 = api.registerContentReplacer) !== null && _a3 !== void 0 ? _a3 : api.registerContentReplacer = this.registerContentReplacer;
    (_b = api.clearRegisteredReplacerForTesting) !== null && _b !== void 0 ? _b : api.clearRegisteredReplacerForTesting = this.clearRegisteredReplacerForTesting;
    return api;
  }
  installInternal(internalApi = {}) {
    var _a3, _b;
    (_a3 = internalApi.onContentRegistered) !== null && _a3 !== void 0 ? _a3 : internalApi.onContentRegistered = this.onContentRegistered;
    (_b = internalApi.initialCheck) !== null && _b !== void 0 ? _b : internalApi.initialCheck = this.initialCheck;
    return internalApi;
  }
};
_AlertFlashContentController_listeners = /* @__PURE__ */ new WeakMap(), _AlertFlashContentController_cleanups = /* @__PURE__ */ new WeakMap(), _AlertFlashContentController_provider = /* @__PURE__ */ new WeakMap(), _AlertFlashContentController_scheduleUpdate = /* @__PURE__ */ new WeakMap();

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/controllers/app-layout-widget.js
var _AppLayoutWidgetController_registrations;
var _AppLayoutWidgetController_findPrimary;
var _AppLayoutWidgetController_update;
var _AppLayoutWidgetController_scheduleUpdate;
var AppLayoutWidgetController = class {
  constructor() {
    _AppLayoutWidgetController_registrations.set(this, []);
    _AppLayoutWidgetController_findPrimary.set(this, () => {
      const forcedPrimary = __classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f").find((registration) => registration.forceType === "primary");
      if (forcedPrimary) {
        return forcedPrimary;
      }
      for (const registration of __classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f").slice()) {
        if (registration.forceType !== "secondary") {
          return registration;
        }
      }
      return void 0;
    });
    _AppLayoutWidgetController_update.set(this, () => {
      const primary = __classPrivateFieldGet(this, _AppLayoutWidgetController_findPrimary, "f").call(this);
      const discoveredProps = __classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f").filter((registration) => registration !== primary).map((registration) => registration.props);
      for (const registration of __classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f")) {
        if (registration === primary) {
          registration.onChange({
            type: "primary",
            discoveredProps
          });
        } else {
          registration.onChange(registration.secondaryInstance);
        }
      }
    });
    _AppLayoutWidgetController_scheduleUpdate.set(this, debounce(() => __classPrivateFieldGet(this, _AppLayoutWidgetController_update, "f").call(this), 0));
    this.register = (forceType, onRegistrationChange) => {
      const hasForcedPrimary = __classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f").some((instance) => instance.forceType === "primary");
      if (forceType === "primary" && hasForcedPrimary) {
        throw new Error("Double primary registration attempt");
      }
      const registration = {
        forceType,
        onChange: onRegistrationChange,
        props: {},
        secondaryInstance: {
          type: "secondary",
          update: (props) => {
            registration.props = props;
            __classPrivateFieldGet(this, _AppLayoutWidgetController_scheduleUpdate, "f").call(this);
          }
        }
      };
      __classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f").push(registration);
      __classPrivateFieldGet(this, _AppLayoutWidgetController_update, "f").call(this);
      return () => {
        __classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f").splice(__classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f").indexOf(registration), 1);
        __classPrivateFieldGet(this, _AppLayoutWidgetController_scheduleUpdate, "f").call(this);
      };
    };
    this.getStateForTesting = () => {
      return {
        registrations: __classPrivateFieldGet(this, _AppLayoutWidgetController_registrations, "f")
      };
    };
    this.installInternal = (internalApi = {}) => {
      var _a3, _b;
      (_a3 = internalApi.register) !== null && _a3 !== void 0 ? _a3 : internalApi.register = this.register;
      (_b = internalApi.getStateForTesting) !== null && _b !== void 0 ? _b : internalApi.getStateForTesting = this.getStateForTesting;
      return internalApi;
    };
  }
};
_AppLayoutWidgetController_registrations = /* @__PURE__ */ new WeakMap(), _AppLayoutWidgetController_findPrimary = /* @__PURE__ */ new WeakMap(), _AppLayoutWidgetController_update = /* @__PURE__ */ new WeakMap(), _AppLayoutWidgetController_scheduleUpdate = /* @__PURE__ */ new WeakMap();

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/controllers/breadcrumbs.js
var _BreadcrumbsController_appLayoutUpdateCallback;
var _BreadcrumbsController_breadcrumbInstances;
var _BreadcrumbsController_breadcrumbRegistrations;
var _BreadcrumbsController_notifyAppLayout;
var _BreadcrumbsController_notifyBreadcrumbs;
var BreadcrumbsController = class {
  constructor() {
    _BreadcrumbsController_appLayoutUpdateCallback.set(this, null);
    _BreadcrumbsController_breadcrumbInstances.set(this, []);
    _BreadcrumbsController_breadcrumbRegistrations.set(this, []);
    _BreadcrumbsController_notifyAppLayout.set(this, debounce(() => {
      var _a3;
      if (!__classPrivateFieldGet(this, _BreadcrumbsController_appLayoutUpdateCallback, "f")) {
        return;
      }
      const latestBreadcrumb = __classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbInstances, "f")[__classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbInstances, "f").length - 1];
      __classPrivateFieldGet(this, _BreadcrumbsController_appLayoutUpdateCallback, "f").call(this, (_a3 = latestBreadcrumb === null || latestBreadcrumb === void 0 ? void 0 : latestBreadcrumb.props) !== null && _a3 !== void 0 ? _a3 : null);
    }, 0));
    _BreadcrumbsController_notifyBreadcrumbs.set(this, debounce(() => {
      __classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbRegistrations, "f").forEach((listener) => listener(!!__classPrivateFieldGet(this, _BreadcrumbsController_appLayoutUpdateCallback, "f")));
    }, 0));
    this.registerAppLayout = (changeCallback) => {
      if (__classPrivateFieldGet(this, _BreadcrumbsController_appLayoutUpdateCallback, "f")) {
        return;
      }
      __classPrivateFieldSet(this, _BreadcrumbsController_appLayoutUpdateCallback, changeCallback, "f");
      __classPrivateFieldGet(this, _BreadcrumbsController_notifyBreadcrumbs, "f").call(this);
      return () => {
        __classPrivateFieldSet(this, _BreadcrumbsController_appLayoutUpdateCallback, null, "f");
        __classPrivateFieldGet(this, _BreadcrumbsController_notifyBreadcrumbs, "f").call(this);
      };
    };
    this.registerBreadcrumbs = (props, onRegistered) => {
      const instance = { props };
      __classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbInstances, "f").push(instance);
      __classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbRegistrations, "f").push(onRegistered);
      __classPrivateFieldGet(this, _BreadcrumbsController_notifyBreadcrumbs, "f").call(this);
      __classPrivateFieldGet(this, _BreadcrumbsController_notifyAppLayout, "f").call(this);
      return {
        update: (props2) => {
          instance.props = props2;
          __classPrivateFieldGet(this, _BreadcrumbsController_notifyAppLayout, "f").call(this);
        },
        cleanup: () => {
          __classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbInstances, "f").splice(__classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbInstances, "f").indexOf(instance), 1);
          __classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbRegistrations, "f").splice(__classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbRegistrations, "f").indexOf(onRegistered), 1);
          __classPrivateFieldGet(this, _BreadcrumbsController_notifyAppLayout, "f").call(this);
        }
      };
    };
    this.getStateForTesting = () => {
      return {
        appLayoutUpdateCallback: __classPrivateFieldGet(this, _BreadcrumbsController_appLayoutUpdateCallback, "f"),
        breadcrumbInstances: __classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbInstances, "f"),
        breadcrumbRegistrations: __classPrivateFieldGet(this, _BreadcrumbsController_breadcrumbRegistrations, "f")
      };
    };
  }
  installInternal(internalApi = {}) {
    var _a3, _b, _c;
    (_a3 = internalApi.registerBreadcrumbs) !== null && _a3 !== void 0 ? _a3 : internalApi.registerBreadcrumbs = this.registerBreadcrumbs;
    (_b = internalApi.registerAppLayout) !== null && _b !== void 0 ? _b : internalApi.registerAppLayout = this.registerAppLayout;
    (_c = internalApi.getStateForTesting) !== null && _c !== void 0 ? _c : internalApi.getStateForTesting = this.getStateForTesting;
    return internalApi;
  }
};
_BreadcrumbsController_appLayoutUpdateCallback = /* @__PURE__ */ new WeakMap(), _BreadcrumbsController_breadcrumbInstances = /* @__PURE__ */ new WeakMap(), _BreadcrumbsController_breadcrumbRegistrations = /* @__PURE__ */ new WeakMap(), _BreadcrumbsController_notifyAppLayout = /* @__PURE__ */ new WeakMap(), _BreadcrumbsController_notifyBreadcrumbs = /* @__PURE__ */ new WeakMap();

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/controllers/drawers.js
var updatableProperties = [
  "badge",
  "resizable",
  "defaultSize",
  "orderPriority",
  "defaultActive",
  "onResize"
];
var DrawersController = class {
  constructor() {
    this.drawers = [];
    this.drawersRegistrationListener = null;
    this.drawerOpenedListener = null;
    this.drawerClosedListener = null;
    this.drawersUpdateListeners = [];
    this.drawerResizeListener = null;
    this.scheduleUpdate = debounce(() => {
      var _a3;
      (_a3 = this.drawersRegistrationListener) === null || _a3 === void 0 ? void 0 : _a3.call(this, this.drawers);
      this.drawersUpdateListeners.forEach((drawersUpdateListeners) => {
        drawersUpdateListeners === null || drawersUpdateListeners === void 0 ? void 0 : drawersUpdateListeners(this.drawers);
      });
    }, 0);
    this.registerDrawer = (config) => {
      if (this.drawers.find((drawer) => drawer.id === config.id)) {
        reportRuntimeApiWarning("app-layout-drawers", `drawer with id "${config.id}" is already registered`);
      }
      this.drawers = this.drawers.concat(config);
      this.scheduleUpdate();
    };
    this.updateDrawer = ({ id: drawerId, ...rest }) => {
      var _a3;
      const drawerIndex = this.drawers.findIndex(({ id }) => id === drawerId);
      const oldDrawerConfig = (_a3 = this.drawers) === null || _a3 === void 0 ? void 0 : _a3[drawerIndex];
      if (!oldDrawerConfig) {
        throw new Error(`[AwsUi] [runtime drawers] drawer with id ${drawerId} not found`);
      }
      const drawers = this.drawers.slice();
      const updatedDrawer = { ...oldDrawerConfig };
      for (const key of updatableProperties) {
        if (key in rest) {
          updatedDrawer[key] = rest[key];
        }
      }
      drawers[drawerIndex] = updatedDrawer;
      this.drawers = drawers;
      this.scheduleUpdate();
    };
    this.onDrawersRegistered = (listener) => {
      if (this.drawersRegistrationListener !== null) {
        reportRuntimeApiWarning("app-layout-drawers", "multiple app layout instances detected when calling onDrawersRegistered");
      }
      this.drawersRegistrationListener = listener;
      this.scheduleUpdate();
      return () => {
        this.drawersRegistrationListener = null;
        this.drawersUpdateListeners = [];
      };
    };
    this.clearRegisteredDrawersForTesting = () => {
      this.drawers = [];
    };
    this.onDrawerOpened = (listener) => {
      if (this.drawerOpenedListener !== null) {
        reportRuntimeApiWarning("app-layout-drawers", "multiple app layout instances detected when calling onDrawerOpened");
      }
      this.drawerOpenedListener = listener;
      return () => {
        this.drawerOpenedListener = null;
      };
    };
    this.onDrawerClosed = (listener) => {
      if (this.drawerClosedListener !== null) {
        reportRuntimeApiWarning("app-layout-drawers", "multiple app layout instances detected when calling onDrawerClosed");
      }
      this.drawerClosedListener = listener;
      return () => {
        this.drawerClosedListener = null;
      };
    };
    this.openDrawer = (drawerId, params) => {
      var _a3;
      (_a3 = this.drawerOpenedListener) === null || _a3 === void 0 ? void 0 : _a3.call(this, drawerId, params);
    };
    this.closeDrawer = (drawerId, params) => {
      var _a3;
      (_a3 = this.drawerClosedListener) === null || _a3 === void 0 ? void 0 : _a3.call(this, drawerId, params);
    };
    this.onDrawersUpdated = (listener) => {
      this.drawersUpdateListeners.push(listener);
      return () => {
        this.drawersUpdateListeners = this.drawersUpdateListeners.filter((item) => item !== listener);
      };
    };
    this.onDrawerResize = (listener) => {
      if (this.drawerResizeListener !== null) {
        reportRuntimeApiWarning("app-layout-drawers", "multiple app layout instances detected when calling onDrawerResize");
      }
      this.drawerResizeListener = listener;
      return () => {
        this.drawerResizeListener = null;
      };
    };
    this.resizeDrawer = (drawerId, size) => {
      var _a3;
      (_a3 = this.drawerResizeListener) === null || _a3 === void 0 ? void 0 : _a3.call(this, drawerId, size);
    };
    this.getDrawersState = () => {
      return this.drawers;
    };
  }
  installPublic(api = {}) {
    var _a3, _b, _c, _d, _e, _f;
    (_a3 = api.registerDrawer) !== null && _a3 !== void 0 ? _a3 : api.registerDrawer = this.registerDrawer;
    (_b = api.updateDrawer) !== null && _b !== void 0 ? _b : api.updateDrawer = this.updateDrawer;
    (_c = api.openDrawer) !== null && _c !== void 0 ? _c : api.openDrawer = this.openDrawer;
    (_d = api.closeDrawer) !== null && _d !== void 0 ? _d : api.closeDrawer = this.closeDrawer;
    (_e = api.resizeDrawer) !== null && _e !== void 0 ? _e : api.resizeDrawer = this.resizeDrawer;
    (_f = api.clearRegisteredDrawersForTesting) !== null && _f !== void 0 ? _f : api.clearRegisteredDrawersForTesting = this.clearRegisteredDrawersForTesting;
    return api;
  }
  installInternal(internalApi = {}) {
    var _a3, _b, _c, _d, _e, _f;
    (_a3 = internalApi.onDrawersRegistered) !== null && _a3 !== void 0 ? _a3 : internalApi.onDrawersRegistered = this.onDrawersRegistered;
    (_b = internalApi.onDrawerOpened) !== null && _b !== void 0 ? _b : internalApi.onDrawerOpened = this.onDrawerOpened;
    (_c = internalApi.onDrawerClosed) !== null && _c !== void 0 ? _c : internalApi.onDrawerClosed = this.onDrawerClosed;
    (_d = internalApi.onDrawerResize) !== null && _d !== void 0 ? _d : internalApi.onDrawerResize = this.onDrawerResize;
    (_e = internalApi.onDrawersUpdated) !== null && _e !== void 0 ? _e : internalApi.onDrawersUpdated = this.onDrawersUpdated;
    (_f = internalApi.getDrawersState) !== null && _f !== void 0 ? _f : internalApi.getDrawersState = this.getDrawersState;
    return internalApi;
  }
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/controllers/shared-react-contexts.js
var _SharedReactContexts_registeredContexts;
var SharedReactContexts = class {
  constructor() {
    _SharedReactContexts_registeredContexts.set(this, /* @__PURE__ */ new WeakMap());
    this.createContext = (ReactInstance, contextName) => {
      let contexts = __classPrivateFieldGet(this, _SharedReactContexts_registeredContexts, "f").get(ReactInstance);
      if (!contexts) {
        contexts = /* @__PURE__ */ new Map();
        __classPrivateFieldGet(this, _SharedReactContexts_registeredContexts, "f").set(ReactInstance, contexts);
      }
      let cachedContext = contexts.get(contextName);
      if (!cachedContext) {
        cachedContext = ReactInstance.createContext(void 0);
        contexts.set(contextName, cachedContext);
      }
      return cachedContext;
    };
  }
  installInternal(internalApi = {}) {
    var _a3;
    (_a3 = internalApi.createContext) !== null && _a3 !== void 0 ? _a3 : internalApi.createContext = this.createContext;
    return internalApi;
  }
};
_SharedReactContexts_registeredContexts = /* @__PURE__ */ new WeakMap();

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/api.js
var storageKey = Symbol.for("awsui-plugin-api");
function findUpApi(currentWindow) {
  try {
    if (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow[storageKey]) {
      return currentWindow[storageKey];
    }
    if (!currentWindow || currentWindow.parent === currentWindow) {
      return void 0;
    }
    return findUpApi(currentWindow.parent);
  } catch {
    return void 0;
  }
}
function loadApi() {
  if (typeof window === "undefined") {
    return installApi({});
  }
  const win = window;
  const existingApi = findUpApi(win);
  if (!existingApi) {
    reportRuntimeApiLoadMetric();
  }
  win[storageKey] = installApi(existingApi !== null && existingApi !== void 0 ? existingApi : {});
  return win[storageKey];
}
var { awsuiPlugins, awsuiPluginsInternal } = loadApi();
function installApi(api) {
  var _a3, _b;
  (_a3 = api.awsuiPlugins) !== null && _a3 !== void 0 ? _a3 : api.awsuiPlugins = {};
  (_b = api.awsuiPluginsInternal) !== null && _b !== void 0 ? _b : api.awsuiPluginsInternal = {};
  const appLayoutDrawers = new DrawersController();
  api.awsuiPlugins.appLayout = appLayoutDrawers.installPublic(api.awsuiPlugins.appLayout);
  api.awsuiPluginsInternal.appLayout = appLayoutDrawers.installInternal(api.awsuiPluginsInternal.appLayout);
  const appLayoutController = new AppLayoutWidgetController();
  api.awsuiPluginsInternal.appLayoutWidget = appLayoutController.installInternal(api.awsuiPluginsInternal.appLayoutWidget);
  const alertActions = new ActionButtonsController();
  api.awsuiPlugins.alert = alertActions.installPublic(api.awsuiPlugins.alert);
  api.awsuiPluginsInternal.alert = alertActions.installInternal(api.awsuiPluginsInternal.alert);
  const alertContent = new AlertFlashContentController();
  api.awsuiPlugins.alertContent = alertContent.installPublic(api.awsuiPlugins.alertContent);
  api.awsuiPluginsInternal.alertContent = alertContent.installInternal(api.awsuiPluginsInternal.alertContent);
  const flashContent = new AlertFlashContentController();
  api.awsuiPlugins.flashContent = flashContent.installPublic(api.awsuiPlugins.flashContent);
  api.awsuiPluginsInternal.flashContent = flashContent.installInternal(api.awsuiPluginsInternal.flashContent);
  const flashbarActions = new ActionButtonsController();
  api.awsuiPlugins.flashbar = flashbarActions.installPublic(api.awsuiPlugins.flashbar);
  api.awsuiPluginsInternal.flashbar = flashbarActions.installInternal(api.awsuiPluginsInternal.flashbar);
  const breadcrumbs = new BreadcrumbsController();
  api.awsuiPluginsInternal.breadcrumbs = breadcrumbs.installInternal(api.awsuiPluginsInternal.breadcrumbs);
  const sharedReactContexts = new SharedReactContexts();
  api.awsuiPluginsInternal.sharedReactContexts = sharedReactContexts.installInternal(api.awsuiPluginsInternal.sharedReactContexts);
  return api;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/i18n/context.js
var namespace = "cloudscape-design-components";
var defaultContextValue = {
  locale: null,
  format: (_namespace, _component, _key, provided) => provided
};
var InternalI18nContext = awsuiPluginsInternal.sharedReactContexts.createContext(React12, "InternalI18nContext");
function useCustomI18n(namespace2, componentName2) {
  var _a3;
  const { format } = (_a3 = useContext3(InternalI18nContext)) !== null && _a3 !== void 0 ? _a3 : defaultContextValue;
  const formatFunction = (key, provided, customHandler) => format(namespace2, componentName2, key, provided, customHandler);
  return formatFunction;
}
function useInternalI18n(componentName2) {
  return useCustomI18n(namespace, componentName2);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon/internal.js
import React15, { useContext as useContext4, useLayoutEffect as useLayoutEffect5, useRef as useRef12, useState as useState8 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon/generated/icons.js
import React13 from "react";
var icons = {
  "add-plus": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M2.01 8h12M8 14l.01-12" })
  ),
  "anchor-link": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M5 8h6", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M7 12H5c-2.21 0-4-1.79-4-4s1.79-4 4-4h2", className: "stroke-linejoin-round awsui-icon-left" }),
    React13.createElement("path", { d: "M9 12h2c2.21 0 4-1.79 4-4s-1.79-4-4-4H9", className: "stroke-linejoin-round awsui-icon-right" })
  ),
  "angle-down": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m2 5 6 6 6-6", className: "stroke-linejoin-round" })
  ),
  "angle-left-double": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M8 2 2 8l6 6", className: "stroke-linejoin-round awsui-icon-glyph" }),
    React13.createElement("path", { d: "M13 2 7 8l6 6", className: "stroke-linejoin-round awsui-icon-glyph" })
  ),
  "angle-left": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M11 2 5 8l6 6", className: "stroke-linejoin-round" })
  ),
  "angle-right-double": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m8 2 6 6-6 6", className: "stroke-linejoin-round awsui-icon-glyph" }),
    React13.createElement("path", { d: "m3 2 6 6-6 6", className: "stroke-linejoin-round awsui-icon-glyph" })
  ),
  "angle-right": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m5 2 6 6-6 6", className: "stroke-linejoin-round" })
  ),
  "angle-up": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m2 11 6-6 6 6", className: "stroke-linejoin-round" })
  ),
  "announcement": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m7 4 7.324-2.747a.5.5 0 0 1 .676.469v11.556a.5.5 0 0 1-.676.469L7 11M1 6a2 2 0 0 1 2-2h4v7H3a2 2 0 0 1-2-2V6Z" }),
    React13.createElement("path", { d: "M9.936 12.147A2.851 2.851 0 0 1 4.352 11" })
  ),
  "arrow-down": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m3 9 5 5 5-5M8 14V1", className: "stroke-linejoin-round awsui-icon-glyph" })
  ),
  "arrow-left": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M7 3 2 8l5 5M2 8h13", className: "stroke-linejoin-round awsui-icon-glyph" })
  ),
  "arrow-right": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m9 3 5 5-5 5M14 8H1", className: "stroke-linejoin-round awsui-icon-glyph" })
  ),
  "arrow-up": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M13 7 8 2 3 7M8 2v13", className: "stroke-linejoin-round awsui-icon-glyph" })
  ),
  "at-symbol": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M9.5 13.75c-1.992.734-6.434 1.013-7.5-3.25-1-4 1.927-6.904 3.697-7.848 1.841-.982 5.523-1.48 7.34.944 1.888 2.516.63 6.29-.628 6.92-1.259.628-1.95.25-2.202 0a.902.902 0 0 1-.145-.191c-.258-.45-.12-1.01-.022-1.52l.678-3.518", className: "stroke-linecap-round" }),
    React13.createElement("path", { d: "M10.718 6.643c-.315-.42-1.254-1.357-2.26-1.357-1.258 0-2.654 1.14-2.969 3.027-.314 1.888.63 2.643 1.573 2.643s2.202-.44 2.83-1.384" })
  ),
  "audio-full": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M6.47 13.707 4 10.997H1v-6h3l2.47-2.71c.54-.59 1.53-.21 1.53.59v10.23c0 .8-.99 1.19-1.53.59v.01Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M12 7.997c0 1.1-.9 2-2 2", pathLength: "1", className: "awsui-icon-wave-1" }),
    React13.createElement("path", { d: "M12 7.997c0-1.1-.9-2-2-2", pathLength: "1", className: "awsui-icon-wave-1" }),
    React13.createElement("path", { d: "M15 7.997c0 2.76-2.24 5-5 5", pathLength: "1", className: "awsui-icon-wave-2" }),
    React13.createElement("path", { d: "M15 7.997c0-2.76-2.24-5-5-5", pathLength: "1", className: "awsui-icon-wave-2" })
  ),
  "audio-half": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M7.47 13.41 5 10.7H2v-6h3l2.47-2.71C8.01 1.4 9 1.78 9 2.58v10.23c0 .8-.99 1.19-1.53.59v.01Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M13 7.71c0 1.1-.9 2-2 2", pathLength: "1", className: "awsui-icon-wave-1" }),
    React13.createElement("path", { d: "M13 7.71c0-1.1-.9-2-2-2", pathLength: "1", className: "awsui-icon-wave-1" })
  ),
  "audio-off": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M6.47 13.41 4 10.7H1v-6h3l2.47-2.71C7.01 1.4 8 1.78 8 2.58v10.23c0 .8-.99 1.19-1.53.59v.01Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M12.995 7.71 11 5.71", pathLength: "1", className: "stroke-linejoin-round awsui-icon-arm" }),
    React13.createElement("path", { d: "m12.995 7.71 1.995 2", pathLength: "1", className: "stroke-linejoin-round awsui-icon-arm" }),
    React13.createElement("path", { d: "m13 7.705 2-1.995", pathLength: "1", className: "stroke-linejoin-round awsui-icon-arm" }),
    React13.createElement("path", { d: "M13 7.705 11 9.7", pathLength: "1", className: "stroke-linejoin-round awsui-icon-arm" })
  ),
  "backward-10-seconds": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M5.95 14.01h-.96c-.56 0-1.02-.46-1.02-1.02v-2.96c0-.56.45-1.01 1.01-1.02h.96c.56 0 1.02.45 1.02 1.02v2.96c0 .56-.46 1.02-1.02 1.02h.01Z", className: "stroke-linejoin-round awsui-icon-zero" }),
    React13.createElement("path", { d: "M1 9v5", className: "stroke-linecap-square awsui-icon-one" }),
    React13.createElement("path", { d: "M1 0v5h5", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M9.976 15A7.154 7.154 0 0 0 15 8.164C15 4.204 11.804 1 7.852 1A7.148 7.148 0 0 0 1.5 4.875", className: "stroke-linejoin-round awsui-icon-arc" })
  ),
  "bug": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M12 5.71a4 4 0 0 0-8 0v4a4 4 0 1 0 8 0v-4Z" }),
    React13.createElement("path", { d: "M15 8.71h-3", className: "awsui-icon-leg-mr" }),
    React13.createElement("path", { d: "M4 8.71H1", className: "awsui-icon-leg-ml" }),
    React13.createElement("path", { d: "M12 6H4" }),
    React13.createElement("path", { d: "m15 3.63-3 2.08", className: "awsui-icon-leg-tr" }),
    React13.createElement("path", { d: "m15 13.78-3-2.07", className: "awsui-icon-leg-br" }),
    React13.createElement("path", { d: "m1 3.63 3 2.08", className: "awsui-icon-leg-tl" }),
    React13.createElement("path", { d: "m1 13.78 3-2.07", className: "awsui-icon-leg-bl" })
  ),
  "calendar": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M14 8V2H2v12h6", className: "stroke-linejoin-round" }),
    React13.createElement("rect", { x: "2", y: "2", width: "12", height: "12", className: "stroke-linejoin-round awsui-icon-corner", clipPath: "inset(50% 0 0 50%) view-box" }),
    React13.createElement("path", { d: "M4 6V4h2v2H4ZM7 6V4h2v2H7ZM10 6V4h2v2h-2ZM4 9V7h2v2H4ZM7 9V7h2v2H7ZM4 12v-2h2v2H4ZM7 12v-2h2v2H7ZM10 9V7h2v2h-2Z", className: "filled no-stroke" })
  ),
  "call": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M12.525 3.548a4.984 4.984 0 0 1 1.465 3.535", pathLength: "1", className: "stroke-linejoin-round awsui-icon-ring" }),
    React13.createElement("path", { d: "M12.525 3.548A4.984 4.984 0 0 0 8.99 2.083", pathLength: "1", className: "stroke-linejoin-round awsui-icon-ring" }),
    React13.createElement("path", { d: "M11.07 10.002c-.6.58-1.55.61-2.14.02l-2.88-2.88a1.49 1.49 0 0 1 0-2.12c.52-.52.52-1.36 0-1.88l-.85-.85a.996.996 0 0 0-1.41 0l-.38.38a4.83 4.83 0 0 0 0 6.82l3.17 3.17a4.83 4.83 0 0 0 6.82 0l.38-.38a.996.996 0 0 0 0-1.41l-.85-.85c-.51-.51-1.34-.52-1.86-.02Z", className: "stroke-linejoin-round awsui-icon-handset" })
  ),
  "caret-down-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m8 11 4-6H4l4 6Z", className: "filled stroke-linejoin-round" })
  ),
  "caret-down": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m8 11 4-6H4l4 6Z", className: "stroke-linejoin-round" })
  ),
  "caret-left-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m5 8 6 4V4L5 8Z", className: "filled stroke-linejoin-round" })
  ),
  "caret-right-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m11 8-6 4V4l6 4Z", className: "filled stroke-linejoin-round" })
  ),
  "caret-up-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m8 5 4 6H4l4-6Z", className: "filled stroke-linejoin-round" })
  ),
  "caret-up": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m8 5 4 6H4l4-6Z", className: "stroke-linejoin-round" })
  ),
  "check": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m1 9 4 4L15 2", className: "stroke-linejoin-round" })
  ),
  "close": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m2 1.71 12 12M2 13.71l12-12", className: "stroke-linejoin-round" })
  ),
  "closed-caption-unavailable": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 1H1v14h14V1Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M7.51 10H5c-.55 0-.99-.44-.99-.99V7c0-.55.44-.99.99-.99h1.01M13 10h-2.51c-.55 0-.99-.44-.99-.99V7c0-.55.44-.99.99-.99H13M1 1l14 14", className: "stroke-linejoin-round" })
  ),
  "closed-caption": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 1H1v14h14V1Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M7.51 10H5c-.55 0-.99-.44-.99-.99V7c0-.55.44-.99.99-.99h2.51M13 10h-2.51c-.55 0-.99-.44-.99-.99V7c0-.55.44-.99.99-.99H13", className: "stroke-linejoin-round" })
  ),
  "command-prompt": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 1H1v14h14V1Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M12 11H9", className: "stroke-linejoin-round awsui-icon-cursor" }),
    React13.createElement("path", { d: "M4.71 11.3 8 8 4.71 4.71", className: "stroke-linejoin-round" })
  ),
  "contact": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M14 12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1", className: "stroke-linejoin-round stroke-linecap-round" }),
    React13.createElement("path", { d: "M2 12h4", className: "awsui-icon-edge-left" }),
    React13.createElement("path", { d: "M14 12h-4", className: "awsui-icon-edge-right" }),
    React13.createElement("path", { d: "M6 12v3", className: "stroke-linecap-round awsui-icon-tail-leg" }),
    React13.createElement("path", { d: "m10 12-4 3", className: "stroke-linecap-round awsui-icon-tail-diag" })
  ),
  "convert-code": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M10 15h6M15 8V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6" }),
    React13.createElement("path", { d: "M5 7.5 8.5 11 5 14.5", className: "awsui-icon-chevron" }),
    React13.createElement("rect", { x: "3", y: "3", width: "2", height: "2", className: "filled no-stroke awsui-icon-dot-1" }),
    React13.createElement("rect", { x: "6", y: "3", width: "2", height: "2", className: "filled no-stroke awsui-icon-dot-2" }),
    React13.createElement("rect", { x: "9", y: "3", width: "2", height: "2", className: "filled no-stroke awsui-icon-dot-3" })
  ),
  "copy": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 5H5v10h10V5Z", className: "stroke-linejoin-round awsui-icon-front" }),
    React13.createElement("path", { d: "M13 1H1v11", className: "stroke-linejoin-round awsui-icon-back" })
  ),
  "delete-marker": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M3 7V1h6l4 4v10h-3", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M8 1v5h5", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "m5 12-3 3", pathLength: "1", className: "stroke-linejoin-round awsui-icon-arm" }),
    React13.createElement("path", { d: "m5 12 3-3", pathLength: "1", className: "stroke-linejoin-round awsui-icon-arm" }),
    React13.createElement("path", { d: "M5.005 12.01 2 9.01", pathLength: "1", className: "stroke-linejoin-round awsui-icon-arm" }),
    React13.createElement("path", { d: "m5.005 12.01 3.005 3", pathLength: "1", className: "stroke-linejoin-round awsui-icon-arm" })
  ),
  "dot": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "1.5", className: "filled no-stroke" })
  ),
  "download": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M1 15h14", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "m13 6-5 5-5-5M8 10V1", className: "stroke-linejoin-round awsui-icon-arrow" })
  ),
  "drag-indicator": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "5.5", cy: "2.5", r: "1.5", className: "filled no-stroke awsui-icon-dot-tl" }),
    React13.createElement("circle", { cx: "5.5", cy: "13.5", r: "1.5", className: "filled no-stroke awsui-icon-dot-bl" }),
    React13.createElement("circle", { cx: "5.5", cy: "8", r: "1.5", className: "filled no-stroke awsui-icon-dot-ml" }),
    React13.createElement("circle", { cx: "10.5", cy: "2.5", r: "1.5", className: "filled no-stroke awsui-icon-dot-tr" }),
    React13.createElement("circle", { cx: "10.5", cy: "13.5", r: "1.5", className: "filled no-stroke awsui-icon-dot-br" }),
    React13.createElement("circle", { cx: "10.5", cy: "8", r: "1.5", className: "filled no-stroke awsui-icon-dot-mr" })
  ),
  "edit-gen-ai": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m5.19 12.275-4.19.7", className: "stroke-linecap-round awsui-icon-nib-b" }),
    React13.createElement("path", { d: "m1 12.975.7-4.19", className: "stroke-linecap-round awsui-icon-nib-a" }),
    React13.createElement("path", { d: "m1.7 8.785 7.2-7.2c.78-.78 2.05-.78 2.83 0l.66.66c.78.78.78 2.05 0 2.83l-1.865 1.85", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "m10.99 5.975-3-3", className: "stroke-linejoin-round stroke-linecap-round awsui-icon-eraser" }),
    React13.createElement("path", { d: "m13.888 12.329-2.296-.921-.924-2.303c-.056-.14-.28-.14-.336 0l-.924 2.303-2.296.921S7 12.427 7 12.496c0 .07.042.14.112.168l.07.028 2.226.893.924 2.303s.098.112.168.112.14-.042.168-.112l.924-2.303 2.296-.921s.112-.098.112-.168-.042-.14-.112-.167Z", className: "filled no-stroke awsui-icon-sparkle" })
  ),
  "edit": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m6.19 13.275-4.19.7", className: "stroke-linecap-round awsui-icon-nib-b" }),
    React13.createElement("path", { d: "m2 13.975.7-4.19", className: "stroke-linecap-round awsui-icon-nib-a" }),
    React13.createElement("path", { d: "m2.7 9.785 7.2-7.2c.78-.78 2.05-.78 2.83 0l.66.66c.78.78.78 2.05 0 2.83l-7.2 7.2", className: "stroke-linejoin-round stroke-linecap-round" }),
    React13.createElement("path", { d: "m9 3.995 3 3", className: "stroke-linejoin-round stroke-linecap-round awsui-icon-eraser" })
  ),
  "ellipsis": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "2.5", r: "1.5", className: "filled no-stroke awsui-icon-dot-1" }),
    React13.createElement("circle", { cx: "8", cy: "13.5", r: "1.5", className: "filled no-stroke awsui-icon-dot-3" }),
    React13.createElement("circle", { cx: "8", cy: "8", r: "1.5", className: "filled no-stroke" })
  ),
  "envelope": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m1 3 7 6", className: "stroke-linejoin-round stroke-linecap-round awsui-icon-flap-left" }),
    React13.createElement("path", { d: "M15 3 8 9", className: "stroke-linejoin-round stroke-linecap-round awsui-icon-flap-right" }),
    React13.createElement("path", { d: "M15 3H1v10h14V3Z", className: "stroke-linejoin-round" })
  ),
  "exit-full-screen": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M1 10.01h5V15", className: "stroke-linejoin-round awsui-icon-corner-bl" }),
    React13.createElement("path", { d: "M10 15v-5h5", className: "stroke-linejoin-round awsui-icon-corner-br" }),
    React13.createElement("path", { d: "M6 1v5H1", className: "stroke-linejoin-round awsui-icon-corner-tl" }),
    React13.createElement("path", { d: "M15 6h-5V1", className: "stroke-linejoin-round awsui-icon-corner-tr" })
  ),
  "expand": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M14 7V2H9M10 6l4-4", className: "stroke-linejoin-round awsui-icon-corner-tr" }),
    React13.createElement("path", { d: "M6.99 14H2V9M6 10l-4 4", className: "stroke-linejoin-round awsui-icon-corner-bl" }),
    React13.createElement("path", { d: "M9 14h5V9M10 10l4 4", className: "stroke-linejoin-round awsui-icon-corner-br" }),
    React13.createElement("path", { d: "M2 6.99V2h5M6 6 2 2", className: "stroke-linejoin-round awsui-icon-corner-tl" })
  ),
  "external": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M13 9.012v-6H7M13.02 3 7 9.01", className: "stroke-linejoin-round awsui-icon-arrow" }),
    React13.createElement("path", { d: "M3 5.012v8h8.01", className: "stroke-linejoin-round" })
  ),
  "face-happy-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M7.995 1.103a6.887 6.887 0 0 0-6.892 6.892 6.887 6.887 0 0 0 6.892 6.892 6.887 6.887 0 0 0 6.892-6.892 6.887 6.887 0 0 0-6.892-6.892Zm-2.002 7.61A2.148 2.148 0 0 0 8 10.134c.914 0 1.706-.592 2.007-1.423l1.646.596c-.54 1.489-1.966 2.577-3.653 2.577-1.686 0-3.114-1.088-3.653-2.577l1.646-.596ZM7.148 6.03a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm3.95 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M8 .5A7.495 7.495 0 0 0 .5 8c0 4.146 3.354 7.5 7.5 7.5s7.5-3.354 7.5-7.5S12.146.5 8 .5Zm0 1.559c3.61 0 6.008 2.566 6.008 5.941 0 2.404-2.044 6.014-6.008 6.014-3.818 0-6.01-2.9-6.01-6.014 0-2.603 1.712-5.941 6.01-5.941Z", className: "filled no-stroke" })
  ),
  "face-happy": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10.01 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M10.83 9.01c-.42 1.16-1.53 2-2.83 2s-2.41-.84-2.83-2", className: "stroke-linejoin-round awsui-icon-mouth" })
  ),
  "face-neutral-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M7.995 1.103a6.887 6.887 0 0 0-6.892 6.892 6.887 6.887 0 0 0 6.892 6.892 6.887 6.887 0 0 0 6.892-6.892 6.887 6.887 0 0 0-6.892-6.892ZM11 10.875H5v-1.75h6v1.75ZM7.148 6.03a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm3.95 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M8 .5A7.495 7.495 0 0 0 .5 8c0 4.146 3.354 7.5 7.5 7.5s7.5-3.354 7.5-7.5S12.146.5 8 .5Zm0 1.559c3.61 0 6.008 2.566 6.008 5.941 0 2.404-2.044 6.014-6.008 6.014-3.818 0-6.01-2.9-6.01-6.014 0-2.603 1.712-5.941 6.01-5.941Z", className: "filled no-stroke" })
  ),
  "face-neutral": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10.01 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M5 10h6", className: "stroke-linejoin-round awsui-icon-mouth" })
  ),
  "face-sad-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M7.995 1.103a6.887 6.887 0 0 0-6.892 6.892 6.887 6.887 0 0 0 6.892 6.892 6.887 6.887 0 0 0 6.892-6.892 6.887 6.887 0 0 0-6.892-6.892Zm-3.648 9.6C4.887 9.212 6.314 8.124 8 8.124c1.687 0 3.114 1.088 3.653 2.577l-1.646.596A2.148 2.148 0 0 0 8 9.875c-.913 0-1.706.592-2.007 1.423l-1.646-.596ZM7.148 6.03a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm3.95 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M8 .5A7.495 7.495 0 0 0 .5 8c0 4.146 3.354 7.5 7.5 7.5s7.5-3.354 7.5-7.5S12.146.5 8 .5Zm0 1.559c3.61 0 6.008 2.566 6.008 5.941 0 2.404-2.044 6.014-6.008 6.014-3.818 0-6.01-2.9-6.01-6.014 0-2.603 1.712-5.941 6.01-5.941Z", className: "filled no-stroke" })
  ),
  "face-sad": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10.01 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M10.83 11C10.41 9.84 9.3 9 8 9s-2.41.84-2.83 2", className: "stroke-linejoin-round awsui-icon-mouth" })
  ),
  "file-open": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M13 15H3V1h6l4 4v10Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M8 1v5h5M3 8l7 7", className: "stroke-linejoin-round" })
  ),
  "file": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M13 15H3V1h6l4 4v10Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M8 1v5h5", className: "stroke-linejoin-round" })
  ),
  "filter": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m1 3 5 5v7l4-2V8l5-5V1H1v2Z", className: "stroke-linejoin-round" })
  ),
  "flag": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M1.99 16V1M2 2.14c4 2.71 8-2.99 12-.28v7.28c-4-2.89-8 2.61-12-.28", className: "stroke-linejoin-round" })
  ),
  "folder-open": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M2 7V2h6l1 2h5c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1h-1", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M1 7h10", className: "awsui-icon-flap-top" }),
    React13.createElement("path", { d: "M3 14h11", className: "awsui-icon-flap-bottom" }),
    React13.createElement("path", { d: "m1 7 2 7", className: "stroke-linecap-round awsui-icon-flap-left" }),
    React13.createElement("path", { d: "m11 7 3 7", className: "stroke-linecap-round awsui-icon-flap-right" })
  ),
  "folder": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 5v9H2V2h6l1 2h5c.55 0 1 .45 1 1Z", className: "stroke-linejoin-round" })
  ),
  "forward-10-seconds": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M13.95 14.01h-.96c-.56 0-1.02-.46-1.02-1.02v-2.96c0-.56.45-1.01 1.01-1.02h.96c.56 0 1.02.45 1.02 1.02v2.96c0 .56-.46 1.02-1.02 1.02h.01Z", className: "stroke-linejoin-round awsui-icon-zero" }),
    React13.createElement("path", { d: "M9 9v5", className: "stroke-linecap-square awsui-icon-one" }),
    React13.createElement("path", { d: "M15 0v5h-5", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M6.024 15A7.154 7.154 0 0 1 1 8.164C1 4.204 4.196 1 8.148 1A7.148 7.148 0 0 1 14.5 4.875", className: "stroke-linejoin-round awsui-icon-arc" })
  ),
  "full-screen": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M6 15H1v-5", className: "stroke-linejoin-round awsui-icon-corner-bl" }),
    React13.createElement("path", { d: "M15 10v5h-5", className: "stroke-linejoin-round awsui-icon-corner-br" }),
    React13.createElement("path", { d: "M1 6V1h5", className: "stroke-linejoin-round awsui-icon-corner-tl" }),
    React13.createElement("path", { d: "M10 1h5v5", className: "stroke-linejoin-round awsui-icon-corner-tr" })
  ),
  "gen-ai-token": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M8 4c.15 0 .283.092.338.23l.97 2.461 2.462.971a.363.363 0 0 1 0 .676l-2.461.97-.971 2.462a.363.363 0 0 1-.676 0l-.97-2.461-2.462-.971a.363.363 0 0 1 0-.676l2.461-.97.971-2.462A.363.363 0 0 1 8 4Z", className: "filled no-stroke" })
  ),
  "gen-ai": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M6.15 10.365 8 15.005l1.86-4.64 4.64-1.86-4.64-1.85L8 2.005l-1.85 4.65-4.65 1.85 4.65 1.86Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M2.38 4.915c.02.05.07.08.12.08.05 0 .12-.08.12-.08l.66-1.64 1.64-.66a.13.13 0 0 0 .08-.12c0-.05-.08-.12-.08-.12l-1.64-.66-.66-1.64c-.04-.1-.2-.1-.24 0l-.66 1.64-1.64.66a.13.13 0 0 0-.08.12c0 .05.08.12.08.12l1.64.66.66 1.64Z", className: "filled no-stroke awsui-icon-sparkle" })
  ),
  "globe": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("ellipse", { cx: "8", cy: "8", rx: "3", ry: "7", className: "awsui-icon-meridian" }),
    React13.createElement("path", { d: "M1 8h14", className: "stroke-linejoin-round" })
  ),
  "grid-view": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M6 10H2v4h4v-4Z", className: "stroke-linejoin-round awsui-icon-cell-bl" }),
    React13.createElement("path", { d: "M14 10h-4v4h4v-4Z", className: "stroke-linejoin-round awsui-icon-cell-br" }),
    React13.createElement("path", { d: "M6 2H2v4h4V2Z", className: "stroke-linejoin-round awsui-icon-cell-tl" }),
    React13.createElement("path", { d: "M14 2h-4v4h4V2Z", className: "stroke-linejoin-round awsui-icon-cell-tr" })
  ),
  "group-active": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "11", cy: "7", r: "3", className: "filled no-stroke" }),
    React13.createElement("circle", { cx: "4.25", cy: "4.25", r: "2.75", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M6 14a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v2H6v-2Z", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M7.126 8H3a3 3 0 0 0-3 3v3h5a4 4 0 0 1 3.405-3.956A4 4 0 0 1 7.126 8Z", className: "filled no-stroke" })
  ),
  "group": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 16v-2a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2" }),
    React13.createElement("circle", { cx: "11.25", cy: "6.75", r: "2.25" }),
    React13.createElement("path", { d: "M6.254 8.99H3a2.005 2.005 0 0 0-2.005 2.005v2h.01v-2C1.005 9.893 1.898 9 3 9h3.261a8.678 8.678 0 0 1-.007-.01Z", className: "filled" }),
    React13.createElement("circle", { cx: "4.25", cy: "4.25", r: "2.25" })
  ),
  "heart-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M13.49 3.546C12.124 2.31 10.312 2.689 9 4L8 5 7 4c-1.301-1.302-3.114-1.69-4.491-.454a3.409 3.409 0 0 0-.133 4.95L7.952 14s.067.028.086 0l5.576-5.505a3.409 3.409 0 0 0-.133-4.95h.01Z", className: "filled stroke-linejoin-round" })
  ),
  "heart": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M13.752 2.873c-1.44-1.3-3.7-1.1-5.08.28l-.7.7-.7-.7c-1.37-1.37-3.63-1.58-5.08-.28a3.588 3.588 0 0 0-.14 5.21l5.87 5.87s.07.03.09 0l5.87-5.87a3.588 3.588 0 0 0-.14-5.21h.01Z", className: "stroke-linejoin-round" })
  ),
  "history": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M1 0v5l5-.04", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M1 8c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7C5.21 1 2.8 2.63 1.67 5" }),
    React13.createElement("path", { d: "M9 4v5", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M9 9H5", className: "stroke-linejoin-round awsui-icon-hand" }),
    React13.createElement("path", { d: "M9 9h.01", className: "stroke-linecap-round" })
  ),
  "insert-row": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M6 11H1V2h14v4", className: "stroke-linejoin-round awsui-icon-frame" }),
    React13.createElement("path", { d: "M12 7v8", className: "stroke-linejoin-round awsui-icon-plus-v" }),
    React13.createElement("path", { d: "M8 11h8", className: "stroke-linejoin-round awsui-icon-plus-h" })
  ),
  "internal-link": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m6.5 4 4 4-4 4", className: "stroke-linejoin-round awsui-icon-glyph" }),
    React13.createElement("path", { d: "M2 8h8.5", className: "awsui-icon-glyph" })
  ),
  "key": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M10 1a5.002 5.002 0 0 0-4.6 6.96L1 12.36v2.65h4v-2h3v-2.42c.61.27 1.29.42 2 .42 2.76 0 5-2.24 5-5s-2.24-5-5-5V1Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M10.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", className: "filled no-stroke" })
  ),
  "keyboard": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 2H1v12h14V2Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M4 5h2", className: "awsui-icon-key-tl" }),
    React13.createElement("path", { d: "M7 5h2", className: "awsui-icon-key-tc" }),
    React13.createElement("path", { d: "M10 5h2", className: "awsui-icon-key-tr" }),
    React13.createElement("path", { d: "M4 8h2", className: "awsui-icon-key-ml" }),
    React13.createElement("path", { d: "M7 8h2", className: "awsui-icon-key-mc" }),
    React13.createElement("path", { d: "M10 8h2", className: "awsui-icon-key-mr" }),
    React13.createElement("path", { d: "M4 11h8", className: "awsui-icon-space" })
  ),
  "light-dark": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M8 15A7 7 0 1 0 8 1v14Z", className: "filled no-stroke awsui-icon-half" })
  ),
  "list-view": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M5 3h10" }),
    React13.createElement("path", { d: "M5 8h10", className: "awsui-icon-line-middle" }),
    React13.createElement("path", { d: "M5 13h10", className: "awsui-icon-line-bottom" }),
    React13.createElement("path", { d: "M2.01 3.01H2V3h.01v.01ZM2.01 8.01H2V8h.01v.01ZM2.01 13.01H2V13h.01v.01Z", className: "filled" })
  ),
  "location-pin": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", className: "stroke-linejoin-round awsui-icon-dot" }),
    React13.createElement("path", { d: "M12.01 9c.63-.83 1-1.87 1-3 0-2.76-2.24-5-5-5a5.002 5.002 0 0 0-4 8", className: "stroke-linejoin-round stroke-linecap-round awsui-icon-head" }),
    React13.createElement("path", { d: "m4.01 9 4 6", className: "stroke-linecap-round awsui-icon-leg-left" }),
    React13.createElement("path", { d: "m12.01 9-4 6", className: "stroke-linecap-round awsui-icon-leg-right" })
  ),
  "lock-private": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M12 7H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Z", className: "stroke-linejoin-round" }),
    React13.createElement(
      "g",
      { className: "awsui-icon-clip" },
      React13.createElement("path", { d: "M5 7V4c0-1.65 1.35-3 3-3s3 1.35 3 3v3", className: "stroke-linejoin-round awsui-icon-shackle" })
    )
  ),
  "map": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M2 12.8V2l3.61 1.21V14L2 12.8ZM10.4 12.8V2L14 3.05V14l-3.6-1.2ZM5.61 14l4.79-1.2M5.61 3.21 10.4 2", className: "stroke-linejoin-round" })
  ),
  "menu": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 3H1", className: "stroke-linejoin-round awsui-icon-line-top" }),
    React13.createElement("path", { d: "M15 8H1", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M15 13H1", className: "stroke-linejoin-round awsui-icon-line-bottom" })
  ),
  "microphone-off": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M3 15.01h10M8 15v-3" }),
    React13.createElement("path", { d: "M6.6 8.43c.36.36.86.59 1.41.59 1.1 0 2-.9 2-2v-2L6.6 8.43Z", className: "filled" }),
    React13.createElement("path", { d: "M13 7.01c0 2.76-2.24 5-5 5-1.28 0-2.45-.48-3.33-1.28M3 12.01l10-10" }),
    React13.createElement("path", { d: "M8.01 1.01c-1.1 0-2 .9-2 2v1.67l3.23-3.23c-.34-.27-.77-.44-1.23-.44Z", className: "filled" }),
    React13.createElement("path", { d: "M3.01 7.01c0 .482-.162 1.263.33 1.75" })
  ),
  "microphone": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M3 15h10M8 15v-3M10 3a2 2 0 1 0-4 0v4a2 2 0 1 0 4 0V3Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M13 7c0 2.76-2.24 5-5 5S3 9.76 3 7", className: "stroke-linejoin-round" })
  ),
  "mini-player": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M2 2v12h3", pathLength: "1", className: "stroke-linejoin-round awsui-icon-frame", strokeDasharray: "1" }),
    React13.createElement("path", { d: "M2 2h12v5", pathLength: "1", className: "stroke-linejoin-round awsui-icon-frame", strokeDasharray: "1" }),
    React13.createElement("path", { d: "M2 2h.001", className: "stroke-linecap-round" }),
    React13.createElement("path", { d: "M14 14.01H6", pathLength: "1", className: "stroke-linecap-round awsui-icon-screen-bottom", strokeDasharray: "1", strokeDashoffset: ".25" }),
    React13.createElement("path", { d: "M14 14.01V8", pathLength: "1", className: "stroke-linecap-round awsui-icon-screen-right", strokeDasharray: "1", strokeDashoffset: ".333" }),
    React13.createElement("path", { d: "M8 14.01V8", pathLength: "1", className: "stroke-linecap-round awsui-icon-screen-left", strokeDasharray: "1", strokeDashoffset: ".333" }),
    React13.createElement("path", { d: "M14 10.01H6", pathLength: "1", className: "stroke-linecap-round awsui-icon-screen-top", strokeDasharray: "1", strokeDashoffset: ".25" })
  ),
  "multiscreen": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 5H5v7h10V5Z", className: "stroke-linejoin-round awsui-icon-front" }),
    React13.createElement("path", { d: "M11 3V1.01L1.01 1 1 8h1.998", className: "stroke-linejoin-round awsui-icon-back" }),
    React13.createElement("path", { d: "M10 12v3M7 15h6", className: "stroke-linejoin-round awsui-icon-front" })
  ),
  "notification": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M14 12H2c-.39 0-.63-.44-.41-.76L4 8V5c0-2.21 1.79-4 4-4s4 1.79 4 4v3l2.41 3.24c.22.33-.02.76-.41.76Z", className: "stroke-linejoin-round awsui-icon-bell" }),
    React13.createElement("path", { d: "M6 13c0 1.1.9 2 2 2s2-.9 2-2", className: "stroke-linejoin-round awsui-icon-ringer" })
  ),
  "pause": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M5 2v12M11 2v12", className: "stroke-linejoin-round" })
  ),
  "play": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m4 13.03 8-5-8-5v10Z", className: "stroke-linejoin-round filled" })
  ),
  "redo": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m11 2 4 4-4 4", className: "stroke-linejoin-round awsui-icon-arrow" }),
    React13.createElement("path", { d: "M15 6H5.5C3.01 6 1 8.01 1 10.5S3.01 15 5.5 15H8", pathLength: "1", className: "stroke-linejoin-round awsui-icon-line" })
  ),
  "refresh": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 0v5l-5-.04", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M15 8c0 3.87-3.13 7-7 7s-7-3.13-7-7 3.13-7 7-7c2.79 0 5.2 1.63 6.33 4" })
  ),
  "remove": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M1 5h14", className: "stroke-linejoin-round awsui-icon-lid" }),
    React13.createElement("path", { d: "m13 5-1 10H4L3 5", className: "stroke-linejoin-round awsui-icon-side" }),
    React13.createElement("path", { d: "M5 5V2h6v3", className: "stroke-linejoin-round awsui-icon-lid" })
  ),
  "resize-area": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M14 4 4 14M10 14l4-4", className: "stroke-linejoin-round" })
  ),
  "script": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M5 4 1 8l4 4M11 4l4 4-4 4", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M7 13 9 3" })
  ),
  "search-gen-ai": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M12.332 6.888c.028.07.098.112.168.112s.168-.112.168-.112l.924-2.298 2.296-.925A.182.182 0 0 0 16 3.497c0-.07-.112-.169-.112-.169l-2.296-.925-.924-2.298c-.056-.14-.28-.14-.336 0l-.924 2.298-2.296.925A.182.182 0 0 0 9 3.497c0 .07.112.168.112.168l2.296.925.924 2.298Z", className: "filled no-stroke awsui-icon-sparkle" }),
    React13.createElement("path", { d: "m11 11.005 4 4M11.9 8a5.002 5.002 0 1 1-8.36-4.605A4.996 4.996 0 0 1 8 2.105", className: "stroke-linejoin-round" })
  ),
  "search": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m11 11 4 4M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10Z", className: "stroke-linejoin-round" })
  ),
  "security": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M8 1C6.29 2.53 4.13 3.32 2 3.48v3.48c0 2.05.76 3.88 1.71 5.14.92 1.22 2.32 2.21 4.29 2.9 1.97-.69 3.37-1.68 4.29-2.9A8.684 8.684 0 0 0 14 6.96V3.48C11.87 3.32 9.71 2.52 8 1Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M8 4v5M8 10v2" })
  ),
  "send": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m1 1 14 6.92L1 15l3-7-3-7ZM4 8h11", className: "stroke-linejoin-round" })
  ),
  "settings": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M6.11 1.729c.07-.42.44-.729.86-.729h2.02c.43 0 .79.31.86.729l.17.999c.05.29.24.529.5.679.06.03.11.06.17.1.25.15.56.2.84.1l.95-.35c.4-.15.85 0 1.07.38l1.01 1.747c.21.37.13.839-.2 1.108l-.78.64c-.23.189-.34.479-.33.768v.2c0 .29.11.579.33.769l.78.639c.33.27.42.739.2 1.108l-1.01 1.748c-.21.37-.66.529-1.06.38l-.95-.35a.966.966 0 0 0-.84.1c-.06.03-.11.07-.17.1-.26.14-.45.389-.5.679l-.17.998A.878.878 0 0 1 9 15H6.98a.87.87 0 0 1-.86-.729l-.17-.998a.988.988 0 0 0-.5-.68c-.06-.03-.11-.06-.17-.1a.996.996 0 0 0-.84-.1l-.95.35c-.4.15-.85 0-1.06-.38l-1.01-1.747a.873.873 0 0 1 .2-1.108l.78-.64c.23-.189.34-.479.33-.768v-.2c0-.3-.11-.579-.33-.769l-.78-.639a.861.861 0 0 1-.2-1.108l1.01-1.748c.21-.37.66-.529 1.07-.38l.95.35c.28.1.58.06.84-.1.06-.03.11-.07.17-.1.26-.14.45-.379.5-.678l.15-1Z", className: "stroke-linecap-round stroke-linejoin-round" }),
    React13.createElement("path", { d: "M10 8c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Z", className: "stroke-linecap-round stroke-linejoin-round" })
  ),
  "share": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M3.5 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM12.5 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM12.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM10.326 4.7 5.678 7.293M10.223 11.483l-4.448-1.96" })
  ),
  "shrink": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M10 1v5h5M10.71 5.29 15 1", className: "stroke-linejoin-round awsui-icon-corner-tr" }),
    React13.createElement("path", { d: "M1 10h5v5M5.3 10.7 1 15", className: "stroke-linejoin-round awsui-icon-corner-bl" })
  ),
  "side-bar": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("rect", { x: "1", y: "3", width: "14", height: "10", rx: "1" }),
    React13.createElement(
      "svg",
      { x: "1", y: "3", width: "14", height: "10", viewBox: "1 3 14 10", overflow: "hidden" },
      React13.createElement("path", { d: "M6 3v10", className: "awsui-icon-bar" })
    )
  ),
  "sign-out": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M7 2H2v12h5", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M13.98 8.018 5.5 8.01m4.241 4.244 4.243-4.242-4.243-4.243", className: "stroke-linejoin-round awsui-icon-arrow" })
  ),
  "slash-divider": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M10 2 6 14", className: "stroke-linejoin-round" })
  ),
  "slash": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m10 4.5-4 7" }),
    React13.createElement("rect", { x: "1", y: "1", width: "14", height: "14", rx: "1" })
  ),
  "star-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m8 1 2.16 4.38 4.84.71-3.5 3.41.83 4.81L8 12.04l-4.33 2.27.83-4.81L1 6.09l4.84-.71L8 1Z", className: "filled stroke-linejoin-round" })
  ),
  "star-half": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M8 1v11.04l-4.33 2.27.83-4.81L1 6.09l4.84-.71L8 1Z", className: "filled no-stroke" }),
    React13.createElement("path", { d: "m8 1 2.16 4.38 4.84.71-3.5 3.41.83 4.81L8 12.04l-4.33 2.27.83-4.81L1 6.09l4.84-.71L8 1Z", className: "stroke-linejoin-round" })
  ),
  "star": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m8 1 2.16 4.38 4.84.71-3.5 3.41.83 4.81L8 12.04l-4.33 2.27.83-4.81L1 6.09l4.84-.71L8 1Z", className: "stroke-linejoin-round" })
  ),
  "status-in-progress": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M9 7H7v2h2V7ZM6 7H4v2h2V7ZM12 7h-2v2h2V7Z", className: "filled no-stroke" })
  ),
  "status-info": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M8 12V7M8 6V4" })
  ),
  "status-negative": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "m5.5 5.5 5 5M10.5 5.5l-5 5" })
  ),
  "status-not-started": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" })
  ),
  "status-pending": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M8 4v5H4", className: "stroke-linejoin-round" })
  ),
  "status-positive": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M4.5 7.5 7 10l4-5", className: "stroke-linejoin-round" })
  ),
  "status-stopped": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M5 8h6" })
  ),
  "status-warning": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M8 5v4M8 10v2M6.52 1.88l-5.33 9.76c-.13.23-.19.5-.19.76 0 .88.71 1.59 1.59 1.59H13.4c.88 0 1.59-.71 1.59-1.59 0-.27-.07-.53-.19-.76L9.48 1.88C9.18 1.34 8.62 1 8 1s-1.18.34-1.48.88Z", className: "stroke-linejoin-round" })
  ),
  "stop-circle": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("rect", { x: "5", y: "5", width: "6", height: "6", rx: ".5", className: "filled no-stroke" })
  ),
  "subtract-minus": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M2 8h12", className: "stroke-linejoin-round" })
  ),
  "suggestions-gen-ai": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m15.888 3.329-2.296-.921-.924-2.303c-.056-.14-.28-.14-.336 0l-.924 2.303-2.296.921S9 3.427 9 3.497s.042.14.112.167l.07.028 2.226.893.924 2.303S12.43 7 12.5 7s.14-.042.168-.112l.924-2.303 2.296-.921S16 3.566 16 3.497c0-.07-.042-.14-.112-.168Z", className: "filled no-stroke awsui-icon-sparkle" }),
    React13.createElement("path", { d: "M12.348 8.45a5.09 5.09 0 0 1-1.358 1.53L10 15H6l-.99-5.02C3.8 9.07 3 7.63 3 6c0-2.76 2.24-5 5-5M10.5 12.005h-5", className: "stroke-linejoin-round" })
  ),
  "suggestions": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M8.12 15h-2l-.99-5.02C3.92 9.07 3.12 7.63 3.12 6c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.07-2.01 3.98L10.12 15h-2ZM11.12 12h-6", className: "stroke-linejoin-round" })
  ),
  "support": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "8", r: "7" }),
    React13.createElement("path", { d: "M5.75 6.338c.13-1.178.811-2.339 2.37-2.339 1.472 0 2.435 1.312 2.042 2.468-.215.633-.916 1.132-1.385 1.578C8.162 8.631 8 9.2 8 10" }),
    React13.createElement("path", { d: "M8 12.01h.01V12H8v.01Z", className: "filled" })
  ),
  "thumbs-down-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M1 1h2.01v9H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1Zm14.14 6.22-1.69-5.03C13.21 1.48 12.54 1 11.79 1H4.01v9l3.23 3.88c.6.72 1.77.29 1.77-.64V9h4.86c.92 0 1.57-.91 1.28-1.78h-.01Z", className: "filled no-stroke" })
  ),
  "thumbs-down": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M9 13.13V9h4.12c.6 0 1.02-.59.83-1.16l-1.6-4.77A1.58 1.58 0 0 0 10.86 2H1v8h4l2.41 3.61c.48.72 1.59.38 1.59-.48ZM5 2v8", className: "stroke-linejoin-round" })
  ),
  "thumbs-up-filled": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M3 15.001H1c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h2v9Zm10.86-8H9v-4.24c0-.93-1.17-1.36-1.77-.64L4 6.001v9h7.78c.75 0 1.42-.48 1.66-1.19l1.69-5.03c.29-.87-.36-1.78-1.28-1.78h.01Z", className: "filled no-stroke" })
  ),
  "thumbs-up": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M9 2.871v4.13h4.12c.6 0 1.02.59.83 1.16l-1.6 4.77a1.58 1.58 0 0 1-1.49 1.07H1v-8h4l2.41-3.61c.48-.72 1.59-.38 1.59.48ZM5 14.001v-8", className: "stroke-linejoin-round" })
  ),
  "ticket": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M13 8c0-1.1.9-2 2-2V3H1v3c1.1 0 2 .9 2 2s-.9 2-2 2v3h14v-3c-1.1 0-2-.9-2-2Z", className: "stroke-linejoin-round" })
  ),
  "transcript": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 1H1v14h14V1Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M9 10H4", className: "stroke-linejoin-round awsui-icon-line-bottom" }),
    React13.createElement("path", { d: "M12 6H4", className: "stroke-linejoin-round awsui-icon-line-top" })
  ),
  "treeview-collapse": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M14 2H2v12h12V2Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M8 8H5", pathLength: "1", className: "awsui-icon-arm", strokeDasharray: "1" }),
    React13.createElement("path", { d: "M8 8h3", pathLength: "1", className: "awsui-icon-arm", strokeDasharray: "1" })
  ),
  "treeview-expand": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M14 2H2v12h12V2Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M8 8V4.25", pathLength: "1", className: "awsui-icon-arm", strokeDasharray: "1", strokeDashoffset: ".2" }),
    React13.createElement("path", { d: "M8 8v3.75", pathLength: "1", className: "awsui-icon-arm", strokeDasharray: "1", strokeDashoffset: ".2" }),
    React13.createElement("path", { d: "M8 8H4.25", pathLength: "1", className: "awsui-icon-arm", strokeDasharray: "1", strokeDashoffset: ".2" }),
    React13.createElement("path", { d: "M8 8h3.75", pathLength: "1", className: "awsui-icon-arm", strokeDasharray: "1", strokeDashoffset: ".2" })
  ),
  "undo": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M5 2 1 6l4 4", className: "stroke-linejoin-round awsui-icon-arrow" }),
    React13.createElement("path", { d: "M1 6h9.5c2.49 0 4.5 2.01 4.5 4.5S12.99 15 10.5 15H8", pathLength: "1", className: "stroke-linejoin-round awsui-icon-line" })
  ),
  "unlocked": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M11 7H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Z", className: "stroke-linejoin-round" }),
    React13.createElement(
      "g",
      { className: "awsui-icon-clip" },
      React13.createElement("path", { d: "M9 7V4c0-1.65 1.35-3 3-3s3 1.35 3 3", className: "stroke-linejoin-round awsui-icon-shackle" })
    )
  ),
  "upload-download": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m7 7-3 3-3-3M4 9V1", className: "stroke-linejoin-round awsui-icon-down" }),
    React13.createElement("path", { d: "m15 9-3-3-3 3M12 7v8", className: "stroke-linejoin-round awsui-icon-up" }),
    React13.createElement("path", { d: "M0 14h8M8 2h8", className: "stroke-linejoin-round" })
  ),
  "upload": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M1 1h14", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M13 10 8 5l-5 5M8 6v9", className: "stroke-linejoin-round awsui-icon-arrow" })
  ),
  "user-profile-active": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M8 6a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0 5ZM2 15.5v-3c0-1.66 1.34-3 3-3h6c1.66 0 3 1.34 3 3v3", className: "filled" }),
    React13.createElement("path", { d: "M2 15.5v-3c0-1.66 1.34-3 3-3h6c1.66 0 3 1.34 3 3v3", className: "stroke-linejoin-round" })
  ),
  "user-profile": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M8 7c1.66 0 3-1.34 3-3S9.66 1 8 1 5 2.34 5 4s1.34 3 3 3Z" }),
    React13.createElement("path", { d: "M2 16v-3c0-1.66 1.34-3 3-3h6c1.66 0 3 1.34 3 3v3", className: "stroke-linejoin-round" })
  ),
  "video-camera-off": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M11 6V3H1v9.97h10V9.98L15 13V3.04L11 6ZM4 6l4 4M8 6.01 4 10", className: "stroke-linejoin-round" })
  ),
  "video-camera-on": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M11 6V3H1v9.97L11 13v-3l4 3V3.04L11 6Z", className: "stroke-linejoin-round" })
  ),
  "video-camera-unavailable": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M11 5.99V3H1v9.97h10V9.98L15 13V3.04l-4 2.95ZM4 8h4", className: "stroke-linejoin-round" })
  ),
  "video-off": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "7", r: "5" }),
    React13.createElement("path", { d: "M3 15h10M8 15v-3M6.01 5.01 10 9M10 5 6 9", className: "stroke-linejoin-round" })
  ),
  "video-on": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "7", r: "5" }),
    React13.createElement("circle", { cx: "8", cy: "7", r: "2", className: "filled no-stroke" }),
    React13.createElement("path", { d: "M3 15h10M8 15v-3" })
  ),
  "video-unavailable": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "8", cy: "7", r: "5" }),
    React13.createElement("path", { d: "M3 15h10M6 7h4M8 15v-3" })
  ),
  "view-full": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 1H1v14h14V1Z", className: "stroke-linejoin-round" }),
    React13.createElement("path", { d: "M11.5 4h-7a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z", className: "filled no-stroke awsui-icon-panel" })
  ),
  "view-horizontal": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 15V1H1v14h14Z", className: "stroke-linejoin-round" }),
    React13.createElement(
      "svg",
      { x: "1", y: "1", width: "14", height: "14", viewBox: "1 1 14 14", overflow: "hidden" },
      React13.createElement("path", { d: "M11.5 7h-7a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Z", className: "filled no-stroke awsui-icon-panel" })
    )
  ),
  "view-vertical": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M15 1H1v14h14V1Z", className: "stroke-linejoin-round" }),
    React13.createElement(
      "svg",
      { x: "1", y: "1", width: "14", height: "14", viewBox: "1 1 14 14", overflow: "hidden" },
      React13.createElement("path", { d: "M11.5 4h-4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z", className: "filled no-stroke awsui-icon-panel" })
    )
  ),
  "zoom-in": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("circle", { cx: "7", cy: "7", r: "6" }),
    React13.createElement("path", { d: "m11 11 4 4" }),
    React13.createElement("path", { d: "M7 4v6M4 7l6 .01", className: "awsui-icon-arm" })
  ),
  "zoom-out": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "m11 11 4 4" }),
    React13.createElement("circle", { cx: "7", cy: "7", r: "6" }),
    React13.createElement("path", { d: "m4 7 6 .01", className: "awsui-icon-arm" })
  ),
  "zoom-to-fit": React13.createElement(
    "svg",
    { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-awsui-icon-animated": "true" },
    React13.createElement("path", { d: "M11 5H5v6h6V5Z", className: "stroke-linejoin-round awsui-icon-square" }),
    React13.createElement("path", { d: "M6 1H1v5M10 1h5v5M6 15H1v-5M10 15h5v-5", className: "stroke-linejoin-round" })
  )
};
var icons_default = icons;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon-provider/context.js
import { createContext as createContext3 } from "react";
var InternalIconContext = createContext3(icons_default);
var InternalComponentIconsContext = createContext3({});

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/with-native-attributes.js
import React14 from "react";
function processAttributes(rest, componentName2, nativeAttributes, skipWarnings) {
  return Object.entries(nativeAttributes || {}).reduce((acc, [key, value]) => {
    if (key === "className") {
      acc[key] = clsx_m_default(rest.className, value);
    } else if (key === "style") {
      acc[key] = { ...rest.style, ...value };
    } else if (key.match(/^on[A-Z]/) && typeof value === "function" && key in rest) {
      acc[key] = (event) => {
        value(event);
        if (!event.defaultPrevented) {
          rest[key](event);
        }
      };
    } else {
      if (key in rest && (!skipWarnings || skipWarnings !== true && !skipWarnings.includes(key))) {
        warnOnce(componentName2, `Overriding native attribute [${key}] which has a Cloudscape-provided value`);
      }
      acc[key] = value;
    }
    return acc;
  }, { ...rest });
}
var with_native_attributes_default = React14.forwardRef(({ tag, nativeAttributes, children, skipWarnings, componentName: componentName2, ...rest }, ref) => {
  const Tag = tag;
  const mergedRef = useMergeRefs(ref, nativeAttributes === null || nativeAttributes === void 0 ? void 0 : nativeAttributes.ref);
  const processedAttributes = processAttributes(rest, componentName2, nativeAttributes, skipWarnings);
  return React14.createElement(Tag, { ...processedAttributes, ref: mergedRef }, children);
});

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon/styles.css.js
var styles_css_default = {
  "icon": "awsui_icon_h11ix_1r9qm_13",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_1r9qm_21",
  "size-x-small": "awsui_size-x-small_h11ix_1r9qm_53",
  "size-x-small-mapped-height": "awsui_size-x-small-mapped-height_h11ix_1r9qm_56",
  "size-small": "awsui_size-small_h11ix_1r9qm_73",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_1r9qm_76",
  "size-normal": "awsui_size-normal_h11ix_1r9qm_93",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_1r9qm_96",
  "size-medium": "awsui_size-medium_h11ix_1r9qm_113",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_1r9qm_116",
  "size-big": "awsui_size-big_h11ix_1r9qm_133",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_1r9qm_136",
  "size-large": "awsui_size-large_h11ix_1r9qm_153",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_1r9qm_156",
  "variant-normal": "awsui_variant-normal_h11ix_1r9qm_173",
  "variant-disabled": "awsui_variant-disabled_h11ix_1r9qm_176",
  "variant-inverted": "awsui_variant-inverted_h11ix_1r9qm_179",
  "variant-subtle": "awsui_variant-subtle_h11ix_1r9qm_182",
  "variant-warning": "awsui_variant-warning_h11ix_1r9qm_185",
  "variant-error": "awsui_variant-error_h11ix_1r9qm_188",
  "variant-success": "awsui_variant-success_h11ix_1r9qm_191",
  "variant-link": "awsui_variant-link_h11ix_1r9qm_194",
  "variant-info": "awsui_variant-info_h11ix_1r9qm_197",
  "name-angle-left-double": "awsui_name-angle-left-double_h11ix_1r9qm_200",
  "name-angle-left": "awsui_name-angle-left_h11ix_1r9qm_200",
  "name-angle-right-double": "awsui_name-angle-right-double_h11ix_1r9qm_202",
  "name-angle-right": "awsui_name-angle-right_h11ix_1r9qm_202",
  "name-arrow-left": "awsui_name-arrow-left_h11ix_1r9qm_204",
  "name-arrow-right": "awsui_name-arrow-right_h11ix_1r9qm_205",
  "name-caret-left-filled": "awsui_name-caret-left-filled_h11ix_1r9qm_206",
  "name-caret-right-filled": "awsui_name-caret-right-filled_h11ix_1r9qm_207",
  "name-audio-full": "awsui_name-audio-full_h11ix_1r9qm_208",
  "name-audio-half": "awsui_name-audio-half_h11ix_1r9qm_209",
  "name-audio-off": "awsui_name-audio-off_h11ix_1r9qm_210",
  "name-external": "awsui_name-external_h11ix_1r9qm_211",
  "name-redo": "awsui_name-redo_h11ix_1r9qm_212",
  "name-resize-area": "awsui_name-resize-area_h11ix_1r9qm_213",
  "name-send": "awsui_name-send_h11ix_1r9qm_214",
  "name-shrink": "awsui_name-shrink_h11ix_1r9qm_215",
  "name-undo": "awsui_name-undo_h11ix_1r9qm_216",
  "name-view-vertical": "awsui_name-view-vertical_h11ix_1r9qm_217",
  "name-gen-ai": "awsui_name-gen-ai_h11ix_1r9qm_593",
  "name-search-gen-ai": "awsui_name-search-gen-ai_h11ix_1r9qm_593",
  "name-edit-gen-ai": "awsui_name-edit-gen-ai_h11ix_1r9qm_593",
  "name-suggestions-gen-ai": "awsui_name-suggestions-gen-ai_h11ix_1r9qm_593",
  "name-copy": "awsui_name-copy_h11ix_1r9qm_593",
  "name-upload": "awsui_name-upload_h11ix_1r9qm_593",
  "name-download": "awsui_name-download_h11ix_1r9qm_593",
  "name-upload-download": "awsui_name-upload-download_h11ix_1r9qm_593",
  "name-sign-out": "awsui_name-sign-out_h11ix_1r9qm_593",
  "name-expand": "awsui_name-expand_h11ix_1r9qm_593",
  "name-full-screen": "awsui_name-full-screen_h11ix_1r9qm_593",
  "name-exit-full-screen": "awsui_name-exit-full-screen_h11ix_1r9qm_593",
  "name-remove": "awsui_name-remove_h11ix_1r9qm_593",
  "name-zoom-to-fit": "awsui_name-zoom-to-fit_h11ix_1r9qm_593",
  "name-multiscreen": "awsui_name-multiscreen_h11ix_1r9qm_593",
  "name-lock-private": "awsui_name-lock-private_h11ix_1r9qm_593",
  "name-unlocked": "awsui_name-unlocked_h11ix_1r9qm_593",
  "name-notification": "awsui_name-notification_h11ix_1r9qm_593",
  "name-history": "awsui_name-history_h11ix_1r9qm_593",
  "name-backward-10-seconds": "awsui_name-backward-10-seconds_h11ix_1r9qm_593",
  "name-forward-10-seconds": "awsui_name-forward-10-seconds_h11ix_1r9qm_593",
  "name-view-horizontal": "awsui_name-view-horizontal_h11ix_1r9qm_593",
  "name-zoom-in": "awsui_name-zoom-in_h11ix_1r9qm_593",
  "name-zoom-out": "awsui_name-zoom-out_h11ix_1r9qm_593",
  "name-menu": "awsui_name-menu_h11ix_1r9qm_593",
  "name-anchor-link": "awsui_name-anchor-link_h11ix_1r9qm_593",
  "name-convert-code": "awsui_name-convert-code_h11ix_1r9qm_593",
  "name-mini-player": "awsui_name-mini-player_h11ix_1r9qm_593",
  "name-treeview-expand": "awsui_name-treeview-expand_h11ix_1r9qm_593",
  "name-treeview-collapse": "awsui_name-treeview-collapse_h11ix_1r9qm_593",
  "name-view-full": "awsui_name-view-full_h11ix_1r9qm_593",
  "name-side-bar": "awsui_name-side-bar_h11ix_1r9qm_593",
  "name-bug": "awsui_name-bug_h11ix_1r9qm_593",
  "name-arrow-up": "awsui_name-arrow-up_h11ix_1r9qm_593",
  "name-arrow-down": "awsui_name-arrow-down_h11ix_1r9qm_593",
  "name-internal-link": "awsui_name-internal-link_h11ix_1r9qm_593",
  "name-delete-marker": "awsui_name-delete-marker_h11ix_1r9qm_593",
  "name-calendar": "awsui_name-calendar_h11ix_1r9qm_593",
  "name-call": "awsui_name-call_h11ix_1r9qm_593",
  "name-command-prompt": "awsui_name-command-prompt_h11ix_1r9qm_593",
  "name-contact": "awsui_name-contact_h11ix_1r9qm_593",
  "name-drag-indicator": "awsui_name-drag-indicator_h11ix_1r9qm_593",
  "name-edit": "awsui_name-edit_h11ix_1r9qm_593",
  "name-ellipsis": "awsui_name-ellipsis_h11ix_1r9qm_593",
  "name-envelope": "awsui_name-envelope_h11ix_1r9qm_593",
  "name-folder-open": "awsui_name-folder-open_h11ix_1r9qm_593",
  "name-globe": "awsui_name-globe_h11ix_1r9qm_593",
  "name-grid-view": "awsui_name-grid-view_h11ix_1r9qm_593",
  "name-insert-row": "awsui_name-insert-row_h11ix_1r9qm_593",
  "name-keyboard": "awsui_name-keyboard_h11ix_1r9qm_593",
  "name-light-dark": "awsui_name-light-dark_h11ix_1r9qm_593",
  "name-list-view": "awsui_name-list-view_h11ix_1r9qm_593",
  "name-location-pin": "awsui_name-location-pin_h11ix_1r9qm_593",
  "name-transcript": "awsui_name-transcript_h11ix_1r9qm_593",
  "name-announcement": "awsui_name-announcement_h11ix_1r9qm_597",
  "name-heart": "awsui_name-heart_h11ix_1r9qm_606",
  "icon-pulse-soft": "awsui_icon-pulse-soft_h11ix_1r9qm_1",
  "name-heart-filled": "awsui_name-heart-filled_h11ix_1r9qm_612",
  "icon-pulse-strong": "awsui_icon-pulse-strong_h11ix_1r9qm_1",
  "name-settings": "awsui_name-settings_h11ix_1r9qm_618",
  "name-thumbs-up": "awsui_name-thumbs-up_h11ix_1r9qm_627",
  "name-thumbs-up-filled": "awsui_name-thumbs-up-filled_h11ix_1r9qm_636",
  "name-thumbs-down": "awsui_name-thumbs-down_h11ix_1r9qm_645",
  "name-thumbs-down-filled": "awsui_name-thumbs-down-filled_h11ix_1r9qm_654",
  "name-face-happy-filled": "awsui_name-face-happy-filled_h11ix_1r9qm_663",
  "name-face-happy": "awsui_name-face-happy_h11ix_1r9qm_663",
  "icon-mouth-smile-grow": "awsui_icon-mouth-smile-grow_h11ix_1r9qm_1",
  "name-face-neutral": "awsui_name-face-neutral_h11ix_1r9qm_691",
  "icon-mouth-tilt": "awsui_icon-mouth-tilt_h11ix_1r9qm_1",
  "name-face-neutral-filled": "awsui_name-face-neutral-filled_h11ix_1r9qm_709",
  "name-face-sad": "awsui_name-face-sad_h11ix_1r9qm_718",
  "icon-mouth-frown-deepen": "awsui_icon-mouth-frown-deepen_h11ix_1r9qm_1",
  "name-face-sad-filled": "awsui_name-face-sad-filled_h11ix_1r9qm_737",
  "icon-sparkle-pinch": "awsui_icon-sparkle-pinch_h11ix_1r9qm_1",
  "icon-nudge-up": "awsui_icon-nudge-up_h11ix_1r9qm_1",
  "icon-nudge-down": "awsui_icon-nudge-down_h11ix_1r9qm_1",
  "icon-nudge-up-once": "awsui_icon-nudge-up-once_h11ix_1r9qm_1",
  "icon-nudge-down-once": "awsui_icon-nudge-down-once_h11ix_1r9qm_1",
  "icon-nudge-back": "awsui_icon-nudge-back_h11ix_1r9qm_1",
  "icon-shaft-retract": "awsui_icon-shaft-retract_h11ix_1r9qm_1",
  "icon-nudge-forward": "awsui_icon-nudge-forward_h11ix_1r9qm_1",
  "icon-nudge-up-right": "awsui_icon-nudge-up-right_h11ix_1r9qm_1",
  "icon-nudge-in": "awsui_icon-nudge-in_h11ix_1r9qm_1",
  "icon-nudge-down-left": "awsui_icon-nudge-down-left_h11ix_1r9qm_1",
  "icon-bell-rotate": "awsui_icon-bell-rotate_h11ix_1r9qm_1",
  "icon-ringer-bounce": "awsui_icon-ringer-bounce_h11ix_1r9qm_1",
  "icon-panel-slide-down": "awsui_icon-panel-slide-down_h11ix_1r9qm_1",
  "icon-panel-slide-right": "awsui_icon-panel-slide-right_h11ix_1r9qm_1",
  "icon-dot-blink": "awsui_icon-dot-blink_h11ix_1r9qm_1",
  "icon-nudge-right": "awsui_icon-nudge-right_h11ix_1r9qm_1",
  "icon-bar-slide-left": "awsui_icon-bar-slide-left_h11ix_1r9qm_1",
  "icon-gait-a": "awsui_icon-gait-a_h11ix_1r9qm_1",
  "icon-gait-b": "awsui_icon-gait-b_h11ix_1r9qm_1",
  "icon-glyph-nudge-up": "awsui_icon-glyph-nudge-up_h11ix_1r9qm_1",
  "icon-glyph-nudge-down": "awsui_icon-glyph-nudge-down_h11ix_1r9qm_1",
  "icon-glyph-nudge-left": "awsui_icon-glyph-nudge-left_h11ix_1r9qm_1",
  "icon-glyph-nudge-right": "awsui_icon-glyph-nudge-right_h11ix_1r9qm_1",
  "icon-handset-ring": "awsui_icon-handset-ring_h11ix_1r9qm_1",
  "icon-cursor-blink": "awsui_icon-cursor-blink_h11ix_1r9qm_1",
  "icon-meridian-turn": "awsui_icon-meridian-turn_h11ix_1r9qm_1",
  "icon-key-press": "awsui_icon-key-press_h11ix_1r9qm_1",
  "badge": "awsui_badge_h11ix_1r9qm_1995",
  "custom-icon": "awsui_custom-icon_h11ix_1r9qm_2009"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon/internal.js
function iconSizeMap(height, fontSize) {
  if (height === null) {
    return "normal";
  }
  if (height >= 50) {
    return "large";
  } else if (height >= 36) {
    return "big";
  } else if (height >= 24 && !!fontSize && fontSize >= 20) {
    return "medium";
  } else if (height <= 16) {
    return !!fontSize && fontSize <= 12 ? "x-small" : "small";
  } else {
    return "normal";
  }
}
var InternalIcon = ({ name, override, size = "normal", variant = "normal", url, alt, ariaLabel, svg, badge, nativeAttributes, __internalRootRef, ...props }) => {
  const icons2 = useContext4(InternalIconContext);
  const iconRef = useRef12(null);
  useVisualRefresh();
  const [parentHeight, setParentHeight] = useState8(null);
  const [parentFontSize, setParentFontSize] = useState8(null);
  const contextualSize = size === "inherit";
  const iconSize = contextualSize ? iconSizeMap(parentHeight, parentFontSize) : size;
  const inlineStyles = contextualSize && parentHeight !== null ? { height: `${parentHeight}px` } : {};
  const baseProps = getBaseProps(props);
  baseProps.className = clsx_m_default(baseProps.className, styles_css_default.icon, contextualSize && styles_css_default["icon-flex-height"], badge && styles_css_default.badge, !contextualSize && styles_css_default[`size-${iconSize}-mapped-height`], styles_css_default[`size-${iconSize}`], styles_css_default[`variant-${variant}`], styles_css_default[`name-${name}`]);
  useLayoutEffect5(() => {
    if (!contextualSize || !iconRef.current) {
      return;
    }
    const computedStyle = getComputedStyle(iconRef.current);
    const { lineHeight, fontSize } = computedStyle;
    const newParentHeight = parseInt(lineHeight, 10);
    const newParentFontSize = parseInt(fontSize, 10);
    setParentHeight(newParentHeight);
    setParentFontSize(newParentFontSize);
  });
  const mergedRef = useMergeRefs(iconRef, __internalRootRef);
  const hasAriaLabel = typeof ariaLabel === "string";
  const labelAttributes = hasAriaLabel ? { role: "img", "aria-label": ariaLabel } : {};
  if (svg) {
    if (url) {
      warnOnce("Icon", "You have specified both `url` and `svg`. `svg` will take precedence and `url` will be ignored.");
    }
    return React15.createElement(with_native_attributes_default, { ...baseProps, ...labelAttributes, tag: "span", componentName: "Icon", nativeAttributes, ref: mergedRef, "aria-hidden": !hasAriaLabel, style: inlineStyles }, svg);
  }
  if (url) {
    return React15.createElement(
      with_native_attributes_default,
      { ...baseProps, tag: "span", componentName: "Icon", nativeAttributes, ref: mergedRef, style: inlineStyles },
      React15.createElement("img", { src: url, alt: ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : alt })
    );
  }
  const validIcon = name && Object.prototype.hasOwnProperty.call(icons2, name);
  function iconMap(name2) {
    if (name2 === "gen-ai" && (iconSize === "small" || iconSize === "x-small")) {
      return React15.createElement(
        "svg",
        { width: "12", height: "12", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", focusable: "false", "aria-hidden": "true", "data-testid": "gen-ai-filled" },
        React15.createElement("path", { d: "m8 4.4 1.018 2.582L11.6 8 9.018 9.018 8 11.6 6.982 9.018 4.4 8l2.582-1.018L8 4.4ZM2.405 2.41l.002-.003.003-.002-.003-.002-.002-.003-.002.003-.003.002.003.002.002.003Z", className: "filled" })
      );
    } else {
      const icon = icons2[name2];
      if (!icon) {
        warnOnce("Icon", `You have specified \`name="${name2}"\` but no icon with that name was found in the current IconProvider context. If this is a custom icon, ensure your app is wrapped in an \`IconProvider\` with the icon defined via \`defineIcons\`.`);
      }
      return icon;
    }
  }
  let content = override !== null && override !== void 0 ? override : validIcon ? iconMap(name) : void 0;
  const isOverridden = override !== null && override !== void 0 ? override : validIcon ? icons2[name] !== icons_default[name] : false;
  if (content !== void 0 && isOverridden) {
    content = React15.createElement("span", { className: clsx_m_default(styles_css_default.icon, styles_css_default["custom-icon"], styles_css_default[`size-${iconSize}`]) }, content);
  }
  return React15.createElement(with_native_attributes_default, { ...baseProps, ...labelAttributes, tag: "span", componentName: "Icon", nativeAttributes, ref: mergedRef, style: inlineStyles }, content);
};
var internal_default = InternalIcon;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/button-context.js
import { createContext as createContext4, useContext as useContext5 } from "react";
var ButtonContext = createContext4({
  onClick: () => {
  }
});
function useButtonContext() {
  return useContext5(ButtonContext);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/events/index.js
var CustomEventStub = class {
  constructor(cancelable = false, detail = null) {
    this.cancelable = cancelable;
    this.detail = detail;
    this.defaultPrevented = false;
    this.cancelBubble = false;
  }
  preventDefault() {
    this.defaultPrevented = true;
  }
  stopPropagation() {
    this.cancelBubble = true;
  }
};
function createCustomEvent({ cancelable, detail }) {
  return new CustomEventStub(cancelable, detail);
}
function fireNonCancelableEvent(handler, detail) {
  if (!handler) {
    return;
  }
  const event = createCustomEvent({ cancelable: false, detail });
  handler(event);
}
function fireCancelableEvent(handler, detail, sourceEvent) {
  if (!handler) {
    return false;
  }
  const event = createCustomEvent({ cancelable: true, detail });
  handler(event);
  if (event.defaultPrevented && sourceEvent) {
    sourceEvent.preventDefault();
  }
  if (event.cancelBubble && sourceEvent) {
    sourceEvent.stopPropagation();
  }
  return event.defaultPrevented;
}
var isMouseEvent = (e) => {
  return e.button !== void 0;
};
function hasModifierKeys(event) {
  return event.ctrlKey || event.altKey || event.shiftKey || event.metaKey;
}
function isPlainLeftClick(event) {
  return event && (!isMouseEvent(event) || event.button === 0) && !hasModifierKeys(event);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/forward-focus/index.js
import { useImperativeHandle as useImperativeHandle2 } from "react";
function useForwardFocus(mainRef, controlRef) {
  useImperativeHandle2(mainRef, () => ({
    focus(...args) {
      var _a3;
      (_a3 = controlRef.current) === null || _a3 === void 0 ? void 0 : _a3.focus(...args);
    }
  }), [controlRef]);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-hidden-description/index.js
import React16 from "react";
function useHiddenDescription(description) {
  const id = useUniqueId();
  return {
    targetProps: {
      "aria-describedby": description ? id : void 0
    },
    descriptionEl: description ? React16.createElement("span", { id, hidden: true }, description) : null,
    descriptionId: id
  };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-modal-component-analytics/index.js
import { useEffect as useEffect14 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/modal-context.js
import { createContext as createContext5, useContext as useContext6 } from "react";
var ModalContext = createContext5({
  isInModal: false,
  componentLoadingCount: { current: 0 },
  emitTimeToContentReadyInModal: () => {
  }
});
var useModalContext = () => {
  const modalContext = useContext6(ModalContext);
  return modalContext;
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-modal-component-analytics/index.js
var useModalContextLoadingButtonComponent = (isPrimaryButton, loading) => {
  const modalContext = useModalContext();
  useEffect14(() => {
    if (!isPrimaryButton || !modalContext.isInModal) {
      return;
    }
    if (loading) {
      modalContext.componentLoadingCount.current++;
      return () => {
        modalContext.componentLoadingCount.current--;
        modalContext.emitTimeToContentReadyInModal(performance.now());
      };
    }
  }, [loading]);
};
var useModalContextLoadingComponent = () => {
  const modalContext = useModalContext();
  useEffect14(() => {
    if (!modalContext.isInModal) {
      return;
    }
    modalContext.componentLoadingCount.current++;
    return () => {
      modalContext.componentLoadingCount.current--;
      modalContext.emitTimeToContentReadyInModal(performance.now());
    };
  }, []);
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-performance-marks/index.js
import { useEffect as useEffect17, useState as useState9 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-dom-attribute/index.js
import { useEffect as useEffect15, useRef as useRef13 } from "react";
function useDOMAttribute(elementRef, attributeName, value) {
  const attributeValueRef = useRef13();
  useEffect15(() => {
    var _a3;
    attributeValueRef.current = value;
    (_a3 = elementRef.current) === null || _a3 === void 0 ? void 0 : _a3.setAttribute(attributeName, value);
  }, [attributeName, value, elementRef]);
  return {
    [attributeName]: attributeValueRef.current
  };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-effect-on-update/index.js
import { useEffect as useEffect16, useRef as useRef14 } from "react";
function useEffectOnUpdate2(callback, deps) {
  const previousDepsRef = useRef14(null);
  useEffect16(() => {
    const previousDeps = previousDepsRef.current;
    previousDepsRef.current = deps;
    if (previousDeps === null) {
      return;
    }
    if (isDepsEqual(previousDeps, deps)) {
      return;
    }
    return callback();
  }, deps);
}
function isDepsEqual(prev, next) {
  for (let i = 0; i < Math.max(prev.length, next.length); i++) {
    if (!Object.is(prev[i], next[i])) {
      return false;
    }
  }
  return true;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-performance-marks/is-in-viewport.js
var map = /* @__PURE__ */ new WeakMap();
var MANUAL_TRIGGER_DELAY = 150;
function isInViewport(element, callback) {
  let resolve = (value) => {
    resolve = () => {
    };
    callback(value);
  };
  map.set(element, (inViewport) => resolve(inViewport));
  observer.observe(element);
  const timeoutHandle = setTimeout(() => resolve(false), MANUAL_TRIGGER_DELAY);
  return () => {
    clearTimeout(timeoutHandle);
    map.delete(element);
    observer.unobserve(element);
  };
}
function createIntersectionObserver(callback) {
  if (typeof IntersectionObserver === "undefined") {
    return {
      observe: () => {
      },
      unobserve: () => {
      }
    };
  }
  return new IntersectionObserver(callback);
}
var observer = createIntersectionObserver(function isInViewportObserver(entries) {
  var _a3;
  for (const entry of entries) {
    observer.unobserve(entry.target);
    (_a3 = map.get(entry.target)) === null || _a3 === void 0 ? void 0 : _a3(entry.isIntersecting);
    map.delete(entry.target);
  }
});

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-performance-marks/index.js
var EVALUATE_COMPONENT_VISIBILITY_EVENT = "awsui-evaluate-component-visibility";
var useEvaluateComponentVisibility = () => {
  const [evaluateComponentVisibility, setEvaluateComponentVisibility] = useState9(false);
  useEffect17(() => {
    const handleEvaluateComponentVisibility = () => {
      setEvaluateComponentVisibility((prev) => !prev);
    };
    document.addEventListener(EVALUATE_COMPONENT_VISIBILITY_EVENT, handleEvaluateComponentVisibility);
    return () => {
      document.removeEventListener(EVALUATE_COMPONENT_VISIBILITY_EVENT, handleEvaluateComponentVisibility);
    };
  }, []);
  return evaluateComponentVisibility;
};
function usePerformanceMarks(name, enabled, elementRef, getDetails, dependencies) {
  const id = useRandomId();
  const { isInModal } = useModalContext();
  const attributes = useDOMAttribute(elementRef, "data-analytics-performance-mark", id);
  const evaluateComponentVisibility = useEvaluateComponentVisibility();
  useEffect17(() => {
    if (!enabled() || !elementRef.current || isInModal) {
      return;
    }
    const elementVisible = elementRef.current.offsetWidth > 0 && elementRef.current.offsetHeight > 0 && getComputedStyle(elementRef.current).visibility !== "hidden";
    if (!elementVisible) {
      return;
    }
    const timestamp = performance.now();
    const cleanup = isInViewport(elementRef.current, (inViewport) => {
      performance.mark(`${name}Rendered`, {
        startTime: timestamp,
        detail: {
          source: "awsui",
          instanceIdentifier: id,
          inViewport,
          ...getDetails()
        }
      });
    });
    return cleanup;
  }, []);
  useEffectOnUpdate2(() => {
    if (!enabled() || !elementRef.current || isInModal) {
      return;
    }
    const elementVisible = elementRef.current.offsetWidth > 0 && elementRef.current.offsetHeight > 0 && getComputedStyle(elementRef.current).visibility !== "hidden";
    if (!elementVisible) {
      return;
    }
    const timestamp = performance.now();
    const cleanup = isInViewport(elementRef.current, (inViewport) => {
      performance.mark(`${name}Updated`, {
        startTime: timestamp,
        detail: {
          source: "awsui",
          instanceIdentifier: id,
          inViewport,
          ...getDetails()
        }
      });
    });
    return cleanup;
  }, [evaluateComponentVisibility, ...dependencies]);
  return attributes;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/check-safe-url.js
var allowedJavascriptUrls = ["javascript:void(0)", "javascript:void(0);", "javascript:;"];
function checkSafeUrl(component, url) {
  if (!url) {
    return;
  }
  if (allowedJavascriptUrls.indexOf(url.toLowerCase()) !== -1) {
    return;
  }
  let parsedUrl;
  try {
    parsedUrl = new URL(url);
  } catch {
    return;
  }
  if (parsedUrl.protocol === "javascript:") {
    warnOnce(component, `A javascript: URL was blocked as a security precaution. The URL was "${url}".`);
    throw new Error(`A javascript: URL was blocked as a security precaution.`);
  }
  return;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/live-region/internal.js
import React17, { useEffect as useEffect18, useImperativeHandle as useImperativeHandle3, useRef as useRef15 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/live-region/styles.css.js
var styles_css_default2 = {
  "root": "awsui_root_1iee7_xs2fj_9",
  "announcer": "awsui_announcer_1iee7_xs2fj_17"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/live-region/test-classes/styles.css.js
var styles_css_default3 = {
  "root": "awsui_root_1pc7b_1k8pp_5",
  "announcer": "awsui_announcer_1pc7b_1k8pp_9"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/live-region/controller.js
var LiveRegionController = class _LiveRegionController {
  constructor(politeness, delay = _LiveRegionController.defaultDelay) {
    this.politeness = politeness;
    this.delay = delay;
    this._contentChangedSinceLastAnnouncement = false;
    this._addedTerminalPeriod = false;
    this._nextAnnouncement = "";
    this._element = document.createElement("div");
    this._element.className = `${styles_css_default2.announcer} ${styles_css_default3.announcer}`;
    this._element.setAttribute("aria-live", this.politeness);
    this._element.setAttribute("aria-atomic", "true");
    document.body.appendChild(this._element);
  }
  /**
   * Reset the state of the controller and clear any active announcements.
   */
  destroy() {
    var _a3;
    (_a3 = this._element) === null || _a3 === void 0 ? void 0 : _a3.remove();
    if (this._timeoutId !== void 0) {
      clearTimeout(this._timeoutId);
      this._timeoutId = void 0;
    }
  }
  announce({ message, forceReannounce = false }) {
    var _a3;
    const trimmedMessage = (_a3 = message === null || message === void 0 ? void 0 : message.trim()) !== null && _a3 !== void 0 ? _a3 : "";
    if (trimmedMessage !== this._lastAnnouncement) {
      this._contentChangedSinceLastAnnouncement = true;
    }
    this._nextAnnouncement = trimmedMessage;
    if (!message) {
      return;
    }
    if (this.delay === 0 || forceReannounce) {
      return this._updateElement(forceReannounce);
    }
    if (this._timeoutId === void 0) {
      this._timeoutId = setTimeout(() => this._updateElement(false), this.delay * 1e3);
    }
  }
  _updateElement(forceReannounce) {
    if (this._nextAnnouncement !== this._lastAnnouncement) {
      this._element.textContent = this._nextAnnouncement;
      this._addedTerminalPeriod = false;
    } else if (forceReannounce || this._contentChangedSinceLastAnnouncement) {
      this._element.textContent = this._nextAnnouncement + (this._addedTerminalPeriod ? "" : ".");
      this._addedTerminalPeriod = !this._addedTerminalPeriod;
    }
    this._lastAnnouncement = this._nextAnnouncement;
    this._contentChangedSinceLastAnnouncement = false;
    this._timeoutId = void 0;
  }
};
LiveRegionController.defaultDelay = 1;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/live-region/internal.js
var internal_default2 = React17.forwardRef(function InternalLiveRegion({ assertive = false, hidden = false, tagName: TagName = "div", delay, sources, preventInitialAnnouncement, children, __internalRootRef, className, ...restProps }, ref) {
  const baseProps = getBaseProps(restProps);
  const childrenRef = useRef15(null);
  const mergedRef = useMergeRefs(childrenRef, __internalRootRef);
  useEffect18(() => {
    if (childrenRef.current) {
      childrenRef.current.inert = hidden;
    }
  }, [hidden]);
  const liveRegionControllerRef = useRef15();
  useEffect18(() => {
    const liveRegionController = new LiveRegionController(assertive ? "assertive" : "polite", delay);
    liveRegionControllerRef.current = liveRegionController;
    return () => {
      liveRegionController.destroy();
      liveRegionControllerRef.current = void 0;
    };
  }, [assertive, delay]);
  const getContent = () => {
    if (sources) {
      return getSourceContent(sources);
    }
    if (childrenRef.current) {
      return extractTextContent2(childrenRef.current);
    }
  };
  const initialAnnouncementContent = useRef15();
  useEffect18(() => {
    var _a3;
    const message = getContent();
    if (initialAnnouncementContent.current === void 0) {
      initialAnnouncementContent.current = message;
    }
    if (preventInitialAnnouncement && initialAnnouncementContent.current === message) {
      return;
    }
    (_a3 = liveRegionControllerRef.current) === null || _a3 === void 0 ? void 0 : _a3.announce({ message });
  });
  useImperativeHandle3(ref, () => ({
    reannounce() {
      var _a3;
      (_a3 = liveRegionControllerRef.current) === null || _a3 === void 0 ? void 0 : _a3.announce({ message: getContent(), forceReannounce: true });
    }
  }));
  return React17.createElement(TagName, { ref: mergedRef, ...baseProps, className: clsx_m_default(styles_css_default2.root, styles_css_default3.root, className), hidden }, children);
});
var processNode = (childNode) => {
  if (childNode.nodeType === Node.TEXT_NODE) {
    return childNode.textContent || "";
  }
  if (childNode.nodeType === Node.ELEMENT_NODE) {
    return extractTextContent2(childNode);
  }
  return "";
};
function extractTextContent2(node) {
  var _a3;
  if (!node || !((_a3 = node === null || node === void 0 ? void 0 : node.childNodes) === null || _a3 === void 0 ? void 0 : _a3.length)) {
    return "";
  }
  return Array.from(node.childNodes, processNode).join(" ").replace(/\s+/g, " ").trim();
}
function getSourceContent(source) {
  return source.map((item) => {
    if (!item || typeof item === "string") {
      return item;
    }
    if (item.current) {
      return extractTextContent2(item.current);
    }
  }).filter(Boolean).join(" ");
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/tooltip/internal.js
import React28, { useEffect as useEffect22 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/transition/index.js
import React20, { useState as useState10 } from "react";
import { useCallback as useCallback7, useRef as useRef16 } from "react";

// ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r2, e) {
  if (null == r2)
    return {};
  var t = {};
  for (var n in r2)
    if ({}.hasOwnProperty.call(r2, n)) {
      if (-1 !== e.indexOf(n))
        continue;
      t[n] = r2[n];
    }
  return t;
}

// ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}

// ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

// ../../node_modules/react-transition-group/esm/Transition.js
var import_prop_types2 = __toESM(require_prop_types());
import React19 from "react";
import ReactDOM from "react-dom";

// ../../node_modules/react-transition-group/esm/config.js
var config_default = {
  disabled: false
};

// ../../node_modules/react-transition-group/esm/utils/PropTypes.js
var import_prop_types = __toESM(require_prop_types());
var timeoutsShape = true ? import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.shape({
  enter: import_prop_types.default.number,
  exit: import_prop_types.default.number,
  appear: import_prop_types.default.number
}).isRequired]) : null;
var classNamesShape = true ? import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.shape({
  enter: import_prop_types.default.string,
  exit: import_prop_types.default.string,
  active: import_prop_types.default.string
}), import_prop_types.default.shape({
  enter: import_prop_types.default.string,
  enterDone: import_prop_types.default.string,
  enterActive: import_prop_types.default.string,
  exit: import_prop_types.default.string,
  exitDone: import_prop_types.default.string,
  exitActive: import_prop_types.default.string
})]) : null;

// ../../node_modules/react-transition-group/esm/TransitionGroupContext.js
import React18 from "react";
var TransitionGroupContext_default = React18.createContext(null);

// ../../node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow2(node) {
  return node.scrollTop;
};

// ../../node_modules/react-transition-group/esm/Transition.js
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition3, _React$Component);
  function Transition3(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition3.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition3.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          if (node)
            forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config_default.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!exit || config_default.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React19.createElement(TransitionGroupContext_default.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : React19.cloneElement(React19.Children.only(children), childProps))
    );
  };
  return Transition3;
}(React19.Component);
Transition.contextType = TransitionGroupContext_default;
Transition.propTypes = true ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: import_prop_types2.default.shape({
    current: typeof Element === "undefined" ? import_prop_types2.default.any : function(propValue, key, componentName2, location2, propFullName, secret) {
      var value = propValue[key];
      return import_prop_types2.default.instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName2, location2, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: import_prop_types2.default.oneOfType([import_prop_types2.default.func.isRequired, import_prop_types2.default.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: import_prop_types2.default.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: import_prop_types2.default.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: import_prop_types2.default.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: import_prop_types2.default.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: import_prop_types2.default.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: import_prop_types2.default.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener)
      pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: import_prop_types2.default.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: import_prop_types2.default.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: import_prop_types2.default.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: import_prop_types2.default.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: import_prop_types2.default.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: import_prop_types2.default.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: import_prop_types2.default.func
} : {};
function noop2() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop2,
  onEntering: noop2,
  onEntered: noop2,
  onExit: noop2,
  onExiting: noop2,
  onExited: noop2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition_default = Transition;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/transition/index.js
function Transition2({ in: isIn, children, exit = true, onStatusChange = () => void 0, disabled = false, transitionChangeDelay, exitTimeout, ...rest }) {
  const transitionRootElement = useRef16(null);
  const [transitionState, setTransitionState] = useState10(isIn ? "entered" : "exited");
  const motionDisabled = useReducedMotion(transitionRootElement) || disabled;
  const addTransitionEndListener = useCallback7((done) => {
    const node = transitionRootElement.current;
    if (node === null) {
      return;
    }
    const controller = new AbortController();
    const listener = (e) => {
      if (e.target === node) {
        controller.abort();
        done();
      }
    };
    node.addEventListener("transitionend", listener, { signal: controller.signal });
    node.addEventListener("animationend", listener, { signal: controller.signal });
  }, []);
  return React20.createElement(Transition_default, { addEndListener: addTransitionEndListener, timeout: motionDisabled ? 0 : exitTimeout, in: isIn, nodeRef: transitionRootElement, exit, onEnter: (isAppearing) => {
    if (!isAppearing) {
      setTransitionState("enter");
      onStatusChange("enter");
    }
  }, onEntering: (isAppearing) => {
    var _a3;
    if (!isAppearing) {
      void ((_a3 = transitionRootElement.current) === null || _a3 === void 0 ? void 0 : _a3.offsetHeight);
      if (transitionChangeDelay === null || transitionChangeDelay === void 0 ? void 0 : transitionChangeDelay.entering) {
        setTimeout(() => {
          setTransitionState("entering");
          onStatusChange("entering");
        }, transitionChangeDelay === null || transitionChangeDelay === void 0 ? void 0 : transitionChangeDelay.entering);
      } else {
        setTransitionState("entering");
        onStatusChange("entering");
      }
    }
  }, onEntered: (isAppearing) => {
    if (!isAppearing) {
      setTransitionState("entered");
      onStatusChange("entered");
    }
  }, onExit: () => {
    setTransitionState("exit");
    onStatusChange("exit");
  }, onExiting: () => {
    setTransitionState("exiting");
    onStatusChange("exiting");
  }, onExited: () => {
    setTransitionState("exited");
    onStatusChange("exited");
  }, ...rest }, () => children(transitionState, transitionRootElement, motionDisabled));
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/arrow.js
import React21 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/styles.css.js
var styles_css_default4 = {
  "arrow": "awsui_arrow_xjuzf_2qlei_13",
  "arrow-outer": "awsui_arrow-outer_xjuzf_2qlei_17",
  "arrow-inner": "awsui_arrow-inner_xjuzf_2qlei_17",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_2qlei_59",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_2qlei_59",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_2qlei_62",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_2qlei_62",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_2qlei_65",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_2qlei_65",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_2qlei_65",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_2qlei_65",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_2qlei_68",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_2qlei_68",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_2qlei_68",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_2qlei_68",
  "arrow-variant-info": "awsui_arrow-variant-info_xjuzf_2qlei_72",
  "body": "awsui_body_xjuzf_2qlei_83",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_2qlei_119",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_2qlei_122",
  "has-dismiss": "awsui_has-dismiss_xjuzf_2qlei_127",
  "dismiss": "awsui_dismiss_xjuzf_2qlei_132",
  "dismiss-control": "awsui_dismiss-control_xjuzf_2qlei_140",
  "header-row": "awsui_header-row_xjuzf_2qlei_144",
  "header": "awsui_header_xjuzf_2qlei_144",
  "content": "awsui_content_xjuzf_2qlei_173",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_2qlei_182",
  "container": "awsui_container_xjuzf_2qlei_190",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_2qlei_201",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_2qlei_201",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_2qlei_201",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_2qlei_206",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_2qlei_206",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_2qlei_206",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_2qlei_211",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_2qlei_211",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_2qlei_216",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_2qlei_216",
  "container-body": "awsui_container-body_xjuzf_2qlei_222",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_2qlei_262",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_2qlei_267",
  "fixed-width": "awsui_fixed-width_xjuzf_2qlei_270",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_2qlei_274",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_2qlei_281",
  "container-arrow": "awsui_container-arrow_xjuzf_2qlei_201",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_2qlei_331",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_2qlei_1",
  "refresh": "awsui_refresh_xjuzf_2qlei_385",
  "awsui-popover-settle-down": "awsui_awsui-popover-settle-down_xjuzf_2qlei_1",
  "awsui-popover-settle-up": "awsui_awsui-popover-settle-up_xjuzf_2qlei_1",
  "awsui-popover-settle-end": "awsui_awsui-popover-settle-end_xjuzf_2qlei_1",
  "awsui-popover-settle-start": "awsui_awsui-popover-settle-start_xjuzf_2qlei_1",
  "root": "awsui_root_xjuzf_2qlei_495",
  "no-wrap": "awsui_no-wrap_xjuzf_2qlei_527",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_2qlei_530",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_2qlei_530",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_2qlei_530",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_2qlei_552",
  "trigger": "awsui_trigger_xjuzf_2qlei_530",
  "in-inline-token": "awsui_in-inline-token_xjuzf_2qlei_594",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_2qlei_642",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_2qlei_646",
  "hover-area": "awsui_hover-area_xjuzf_2qlei_650"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/arrow.js
var Arrow = ({ position, variant }) => {
  const isVisualRefresh = useVisualRefresh();
  return React21.createElement(
    "div",
    { className: clsx_m_default(styles_css_default4.arrow, styles_css_default4[`arrow-position-${position}`], styles_css_default4[`arrow-variant-${variant}`]) },
    React21.createElement("div", { className: styles_css_default4["arrow-outer"] }),
    React21.createElement("div", { className: clsx_m_default(styles_css_default4["arrow-inner"], isVisualRefresh && styles_css_default4.refresh) })
  );
};
var arrow_default = React21.memo(Arrow);

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/body.js
import React26, { useCallback as useCallback9, useEffect as useEffect20, useRef as useRef18 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/error-boundary/internal.js
import React23, { Component, createContext as createContext6, useContext as useContext7, useState as useState11 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/error-boundary/fallback.js
import React22 from "react";

// ../../node_modules/@formatjs/fast-memoize/lib/index.js
function memoize(fn, options) {
  var cache = options && options.cache ? options.cache : cacheDefault;
  var serializer = options && options.serializer ? options.serializer : serializerDefault;
  var strategy = options && options.strategy ? options.strategy : strategyDefault;
  return strategy(fn, {
    cache,
    serializer
  });
}
function isPrimitive(value) {
  return value == null || typeof value === "number" || typeof value === "boolean";
}
function monadic(fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === "undefined") {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function variadic(fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);
  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === "undefined") {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
  return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic;
  return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
  return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
  return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
var serializerDefault = function() {
  return JSON.stringify(arguments);
};
var ObjectWithoutPrototypeCache = (
  /** @class */
  function() {
    function ObjectWithoutPrototypeCache4() {
      this.cache = /* @__PURE__ */ Object.create(null);
    }
    ObjectWithoutPrototypeCache4.prototype.get = function(key) {
      return this.cache[key];
    };
    ObjectWithoutPrototypeCache4.prototype.set = function(key, value) {
      this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache4;
  }()
);
var cacheDefault = {
  create: function create() {
    return new ObjectWithoutPrototypeCache();
  }
};
var strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
};

// ../../node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function(ErrorKind4) {
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
  ErrorKind4[ErrorKind4["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
  ErrorKind4[ErrorKind4["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
  ErrorKind4[ErrorKind4["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
  ErrorKind4[ErrorKind4["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
  ErrorKind4[ErrorKind4["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
  ErrorKind4[ErrorKind4["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
  ErrorKind4[ErrorKind4["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
  ErrorKind4[ErrorKind4["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
  ErrorKind4[ErrorKind4["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
  ErrorKind4[ErrorKind4["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
  ErrorKind4[ErrorKind4["INVALID_TAG"] = 23] = "INVALID_TAG";
  ErrorKind4[ErrorKind4["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
  ErrorKind4[ErrorKind4["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
  ErrorKind4[ErrorKind4["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

// ../../node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function(TYPE3) {
  TYPE3[TYPE3["literal"] = 0] = "literal";
  TYPE3[TYPE3["argument"] = 1] = "argument";
  TYPE3[TYPE3["number"] = 2] = "number";
  TYPE3[TYPE3["date"] = 3] = "date";
  TYPE3[TYPE3["time"] = 4] = "time";
  TYPE3[TYPE3["select"] = 5] = "select";
  TYPE3[TYPE3["plural"] = 6] = "plural";
  TYPE3[TYPE3["pound"] = 7] = "pound";
  TYPE3[TYPE3["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function(SKELETON_TYPE2) {
  SKELETON_TYPE2[SKELETON_TYPE2["number"] = 0] = "number";
  SKELETON_TYPE2[SKELETON_TYPE2["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
function isLiteralElement(el) {
  return el.type === TYPE.literal;
}
function isArgumentElement(el) {
  return el.type === TYPE.argument;
}
function isNumberElement(el) {
  return el.type === TYPE.number;
}
function isDateElement(el) {
  return el.type === TYPE.date;
}
function isTimeElement(el) {
  return el.type === TYPE.time;
}
function isSelectElement(el) {
  return el.type === TYPE.select;
}
function isPluralElement(el) {
  return el.type === TYPE.plural;
}
function isPoundElement(el) {
  return el.type === TYPE.pound;
}
function isTagElement(el) {
  return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
  return !!(el && typeof el === "object" && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
  return !!(el && typeof el === "object" && el.type === SKELETON_TYPE.dateTime);
}

// ../../node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

// ../../node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton(skeleton) {
  var result = {};
  skeleton.replace(DATE_TIME_REGEX, function(match) {
    var len = match.length;
    switch (match[0]) {
      case "G":
        result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
        break;
      case "y":
        result.year = len === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        result.month = ["numeric", "2-digit", "short", "long", "narrow"][len - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        result.day = ["numeric", "2-digit"][len - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
        break;
      case "e":
        if (len < 4) {
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        }
        result.weekday = ["short", "long", "narrow", "short"][len - 4];
        break;
      case "c":
        if (len < 4) {
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        }
        result.weekday = ["short", "long", "narrow", "short"][len - 4];
        break;
      case "a":
        result.hour12 = true;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        result.hourCycle = "h12";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "H":
        result.hourCycle = "h23";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "K":
        result.hourCycle = "h11";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "k":
        result.hourCycle = "h24";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        result.minute = ["numeric", "2-digit"][len - 1];
        break;
      case "s":
        result.second = ["numeric", "2-digit"][len - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        result.timeZoneName = len < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  });
  return result;
}

// ../../node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

// ../../node_modules/@formatjs/icu-skeleton-parser/lib/number.js
function parseNumberSkeletonFromString(skeleton) {
  if (skeleton.length === 0) {
    throw new Error("Number skeleton cannot be empty");
  }
  var stringTokens = skeleton.split(WHITE_SPACE_REGEX).filter(function(x) {
    return x.length > 0;
  });
  var tokens = [];
  for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
    var stringToken = stringTokens_1[_i];
    var stemAndOptions = stringToken.split("/");
    if (stemAndOptions.length === 0) {
      throw new Error("Invalid number skeleton");
    }
    var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
    for (var _a3 = 0, options_1 = options; _a3 < options_1.length; _a3++) {
      var option = options_1[_a3];
      if (option.length === 0) {
        throw new Error("Invalid number skeleton");
      }
    }
    tokens.push({ stem, options });
  }
  return tokens;
}
function icuUnitToEcma(unit) {
  return unit.replace(/^(.*?)-/, "");
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
  var result = {};
  if (str[str.length - 1] === "r") {
    result.roundingPriority = "morePrecision";
  } else if (str[str.length - 1] === "s") {
    result.roundingPriority = "lessPrecision";
  }
  str.replace(SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
    if (typeof g2 !== "string") {
      result.minimumSignificantDigits = g1.length;
      result.maximumSignificantDigits = g1.length;
    } else if (g2 === "+") {
      result.minimumSignificantDigits = g1.length;
    } else if (g1[0] === "#") {
      result.maximumSignificantDigits = g1.length;
    } else {
      result.minimumSignificantDigits = g1.length;
      result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
    }
    return "";
  });
  return result;
}
function parseSign(str) {
  switch (str) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function parseConciseScientificAndEngineeringStem(stem) {
  var result;
  if (stem[0] === "E" && stem[1] === "E") {
    result = {
      notation: "engineering"
    };
    stem = stem.slice(2);
  } else if (stem[0] === "E") {
    result = {
      notation: "scientific"
    };
    stem = stem.slice(1);
  }
  if (result) {
    var signDisplay = stem.slice(0, 2);
    if (signDisplay === "+!") {
      result.signDisplay = "always";
      stem = stem.slice(2);
    } else if (signDisplay === "+?") {
      result.signDisplay = "exceptZero";
      stem = stem.slice(2);
    }
    if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
      throw new Error("Malformed concise eng/scientific notation");
    }
    result.minimumIntegerDigits = stem.length;
  }
  return result;
}
function parseNotationOptions(opt) {
  var result = {};
  var signOpts = parseSign(opt);
  if (signOpts) {
    return signOpts;
  }
  return result;
}
function parseNumberSkeleton(tokens) {
  var result = {};
  for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
    var token = tokens_1[_i];
    switch (token.stem) {
      case "percent":
      case "%":
        result.style = "percent";
        continue;
      case "%x100":
        result.style = "percent";
        result.scale = 100;
        continue;
      case "currency":
        result.style = "currency";
        result.currency = token.options[0];
        continue;
      case "group-off":
      case ",_":
        result.useGrouping = false;
        continue;
      case "precision-integer":
      case ".":
        result.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        result.style = "unit";
        result.unit = icuUnitToEcma(token.options[0]);
        continue;
      case "compact-short":
      case "K":
        result.notation = "compact";
        result.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        result.notation = "compact";
        result.compactDisplay = "long";
        continue;
      case "scientific":
        result = __assign(__assign(__assign({}, result), { notation: "scientific" }), token.options.reduce(function(all, opt2) {
          return __assign(__assign({}, all), parseNotationOptions(opt2));
        }, {}));
        continue;
      case "engineering":
        result = __assign(__assign(__assign({}, result), { notation: "engineering" }), token.options.reduce(function(all, opt2) {
          return __assign(__assign({}, all), parseNotationOptions(opt2));
        }, {}));
        continue;
      case "notation-simple":
        result.notation = "standard";
        continue;
      case "unit-width-narrow":
        result.currencyDisplay = "narrowSymbol";
        result.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        result.currencyDisplay = "code";
        result.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        result.currencyDisplay = "name";
        result.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        result.currencyDisplay = "symbol";
        continue;
      case "scale":
        result.scale = parseFloat(token.options[0]);
        continue;
      case "rounding-mode-floor":
        result.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        result.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        result.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        result.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        result.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        result.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        result.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (token.options.length > 1) {
          throw new RangeError("integer-width stems only accept a single optional option");
        }
        token.options[0].replace(INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
          if (g1) {
            result.minimumIntegerDigits = g2.length;
          } else if (g3 && g4) {
            throw new Error("We currently do not support maximum integer digits");
          } else if (g5) {
            throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
      result.minimumIntegerDigits = token.stem.length;
      continue;
    }
    if (FRACTION_PRECISION_REGEX.test(token.stem)) {
      if (token.options.length > 1) {
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      }
      token.stem.replace(FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
        if (g2 === "*") {
          result.minimumFractionDigits = g1.length;
        } else if (g3 && g3[0] === "#") {
          result.maximumFractionDigits = g3.length;
        } else if (g4 && g5) {
          result.minimumFractionDigits = g4.length;
          result.maximumFractionDigits = g4.length + g5.length;
        } else {
          result.minimumFractionDigits = g1.length;
          result.maximumFractionDigits = g1.length;
        }
        return "";
      });
      var opt = token.options[0];
      if (opt === "w") {
        result = __assign(__assign({}, result), { trailingZeroDisplay: "stripIfInteger" });
      } else if (opt) {
        result = __assign(__assign({}, result), parseSignificantPrecision(opt));
      }
      continue;
    }
    if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
      result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
      continue;
    }
    var signOpts = parseSign(token.stem);
    if (signOpts) {
      result = __assign(__assign({}, result), signOpts);
    }
    var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
    if (conciseScientificAndEngineeringOpts) {
      result = __assign(__assign({}, result), conciseScientificAndEngineeringOpts);
    }
  }
  return result;
}

// ../../node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
var timeData = {
  "001": [
    "H",
    "h"
  ],
  "419": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "AC": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "AD": [
    "H",
    "hB"
  ],
  "AE": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "AF": [
    "H",
    "hb",
    "hB",
    "h"
  ],
  "AG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "AI": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "AL": [
    "h",
    "H",
    "hB"
  ],
  "AM": [
    "H",
    "hB"
  ],
  "AO": [
    "H",
    "hB"
  ],
  "AR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "AS": [
    "h",
    "H"
  ],
  "AT": [
    "H",
    "hB"
  ],
  "AU": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "AW": [
    "H",
    "hB"
  ],
  "AX": [
    "H"
  ],
  "AZ": [
    "H",
    "hB",
    "h"
  ],
  "BA": [
    "H",
    "hB",
    "h"
  ],
  "BB": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BD": [
    "h",
    "hB",
    "H"
  ],
  "BE": [
    "H",
    "hB"
  ],
  "BF": [
    "H",
    "hB"
  ],
  "BG": [
    "H",
    "hB",
    "h"
  ],
  "BH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "BI": [
    "H",
    "h"
  ],
  "BJ": [
    "H",
    "hB"
  ],
  "BL": [
    "H",
    "hB"
  ],
  "BM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BN": [
    "hb",
    "hB",
    "h",
    "H"
  ],
  "BO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "BQ": [
    "H"
  ],
  "BR": [
    "H",
    "hB"
  ],
  "BS": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BT": [
    "h",
    "H"
  ],
  "BW": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "BY": [
    "H",
    "h"
  ],
  "BZ": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CA": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "CC": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CD": [
    "hB",
    "H"
  ],
  "CF": [
    "H",
    "h",
    "hB"
  ],
  "CG": [
    "H",
    "hB"
  ],
  "CH": [
    "H",
    "hB",
    "h"
  ],
  "CI": [
    "H",
    "hB"
  ],
  "CK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CL": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CM": [
    "H",
    "h",
    "hB"
  ],
  "CN": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "CO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CP": [
    "H"
  ],
  "CR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CU": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CV": [
    "H",
    "hB"
  ],
  "CW": [
    "H",
    "hB"
  ],
  "CX": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CY": [
    "h",
    "H",
    "hb",
    "hB"
  ],
  "CZ": [
    "H"
  ],
  "DE": [
    "H",
    "hB"
  ],
  "DG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "DJ": [
    "h",
    "H"
  ],
  "DK": [
    "H"
  ],
  "DM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "DO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "DZ": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "EA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "EC": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "EE": [
    "H",
    "hB"
  ],
  "EG": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "EH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ER": [
    "h",
    "H"
  ],
  "ES": [
    "H",
    "hB",
    "h",
    "hb"
  ],
  "ET": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "FI": [
    "H"
  ],
  "FJ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "FK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "FM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "FO": [
    "H",
    "h"
  ],
  "FR": [
    "H",
    "hB"
  ],
  "GA": [
    "H",
    "hB"
  ],
  "GB": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GD": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GE": [
    "H",
    "hB",
    "h"
  ],
  "GF": [
    "H",
    "hB"
  ],
  "GG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GH": [
    "h",
    "H"
  ],
  "GI": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GL": [
    "H",
    "h"
  ],
  "GM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GN": [
    "H",
    "hB"
  ],
  "GP": [
    "H",
    "hB"
  ],
  "GQ": [
    "H",
    "hB",
    "h",
    "hb"
  ],
  "GR": [
    "h",
    "H",
    "hb",
    "hB"
  ],
  "GT": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "GU": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GW": [
    "H",
    "hB"
  ],
  "GY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "HK": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "HN": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "HR": [
    "H",
    "hB"
  ],
  "HU": [
    "H",
    "h"
  ],
  "IC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ID": [
    "H"
  ],
  "IE": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IL": [
    "H",
    "hB"
  ],
  "IM": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IN": [
    "h",
    "H"
  ],
  "IO": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IQ": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "IR": [
    "hB",
    "H"
  ],
  "IS": [
    "H"
  ],
  "IT": [
    "H",
    "hB"
  ],
  "JE": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "JM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "JO": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "JP": [
    "H",
    "K",
    "h"
  ],
  "KE": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "KG": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "KH": [
    "hB",
    "h",
    "H",
    "hb"
  ],
  "KI": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KM": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "KN": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KP": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "KR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "KW": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "KY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KZ": [
    "H",
    "hB"
  ],
  "LA": [
    "H",
    "hb",
    "hB",
    "h"
  ],
  "LB": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "LC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "LI": [
    "H",
    "hB",
    "h"
  ],
  "LK": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "LR": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "LS": [
    "h",
    "H"
  ],
  "LT": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "LU": [
    "H",
    "h",
    "hB"
  ],
  "LV": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "LY": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "MC": [
    "H",
    "hB"
  ],
  "MD": [
    "H",
    "hB"
  ],
  "ME": [
    "H",
    "hB",
    "h"
  ],
  "MF": [
    "H",
    "hB"
  ],
  "MG": [
    "H",
    "h"
  ],
  "MH": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "ML": [
    "H"
  ],
  "MM": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "MN": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "MO": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MP": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MQ": [
    "H",
    "hB"
  ],
  "MR": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MS": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "MT": [
    "H",
    "h"
  ],
  "MU": [
    "H",
    "h"
  ],
  "MV": [
    "H",
    "h"
  ],
  "MW": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MX": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "MY": [
    "hb",
    "hB",
    "h",
    "H"
  ],
  "MZ": [
    "H",
    "hB"
  ],
  "NA": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "NC": [
    "H",
    "hB"
  ],
  "NE": [
    "H"
  ],
  "NF": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NI": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "NL": [
    "H",
    "hB"
  ],
  "NO": [
    "H",
    "h"
  ],
  "NP": [
    "H",
    "h",
    "hB"
  ],
  "NR": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NU": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NZ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "OM": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PA": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PE": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PF": [
    "H",
    "h",
    "hB"
  ],
  "PG": [
    "h",
    "H"
  ],
  "PH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PK": [
    "h",
    "hB",
    "H"
  ],
  "PL": [
    "H",
    "h"
  ],
  "PM": [
    "H",
    "hB"
  ],
  "PN": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "PR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PS": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PT": [
    "H",
    "hB"
  ],
  "PW": [
    "h",
    "H"
  ],
  "PY": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "QA": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "RE": [
    "H",
    "hB"
  ],
  "RO": [
    "H",
    "hB"
  ],
  "RS": [
    "H",
    "hB",
    "h"
  ],
  "RU": [
    "H"
  ],
  "RW": [
    "H",
    "h"
  ],
  "SA": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SB": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SC": [
    "H",
    "h",
    "hB"
  ],
  "SD": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SE": [
    "H"
  ],
  "SG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SH": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "SI": [
    "H",
    "hB"
  ],
  "SJ": [
    "H"
  ],
  "SK": [
    "H"
  ],
  "SL": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SM": [
    "H",
    "h",
    "hB"
  ],
  "SN": [
    "H",
    "h",
    "hB"
  ],
  "SO": [
    "h",
    "H"
  ],
  "SR": [
    "H",
    "hB"
  ],
  "SS": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "ST": [
    "H",
    "hB"
  ],
  "SV": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "SX": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "SY": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SZ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TA": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "TC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TD": [
    "h",
    "H",
    "hB"
  ],
  "TF": [
    "H",
    "h",
    "hB"
  ],
  "TG": [
    "H",
    "hB"
  ],
  "TH": [
    "H",
    "h"
  ],
  "TJ": [
    "H",
    "h"
  ],
  "TL": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "TM": [
    "H",
    "h"
  ],
  "TN": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "TO": [
    "h",
    "H"
  ],
  "TR": [
    "H",
    "hB"
  ],
  "TT": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TW": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "TZ": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "UA": [
    "H",
    "hB",
    "h"
  ],
  "UG": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "UM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "US": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "UY": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "UZ": [
    "H",
    "hB",
    "h"
  ],
  "VA": [
    "H",
    "h",
    "hB"
  ],
  "VC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VE": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "VG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VI": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VN": [
    "H",
    "h"
  ],
  "VU": [
    "h",
    "H"
  ],
  "WF": [
    "H",
    "hB"
  ],
  "WS": [
    "h",
    "H"
  ],
  "XK": [
    "H",
    "hB",
    "h"
  ],
  "YE": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "YT": [
    "H",
    "hB"
  ],
  "ZA": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "ZM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "ZW": [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-HK": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-IL": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "en-MY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};

// ../../node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js
function getBestPattern(skeleton, locale) {
  var skeletonCopy = "";
  for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
    var patternChar = skeleton.charAt(patternPos);
    if (patternChar === "j") {
      var extraLength = 0;
      while (patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar) {
        extraLength++;
        patternPos++;
      }
      var hourLen = 1 + (extraLength & 1);
      var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
      var dayPeriodChar = "a";
      var hourChar = getDefaultHourSymbolFromLocale(locale);
      if (hourChar == "H" || hourChar == "k") {
        dayPeriodLen = 0;
      }
      while (dayPeriodLen-- > 0) {
        skeletonCopy += dayPeriodChar;
      }
      while (hourLen-- > 0) {
        skeletonCopy = hourChar + skeletonCopy;
      }
    } else if (patternChar === "J") {
      skeletonCopy += "H";
    } else {
      skeletonCopy += patternChar;
    }
  }
  return skeletonCopy;
}
function getDefaultHourSymbolFromLocale(locale) {
  var hourCycle = locale.hourCycle;
  if (hourCycle === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  locale.hourCycles && // @ts-ignore
  locale.hourCycles.length) {
    hourCycle = locale.hourCycles[0];
  }
  if (hourCycle) {
    switch (hourCycle) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  }
  var languageTag = locale.language;
  var regionTag;
  if (languageTag !== "root") {
    regionTag = locale.maximize().region;
  }
  var hourCycles = timeData[regionTag || ""] || timeData[languageTag || ""] || timeData["".concat(languageTag, "-001")] || timeData["001"];
  return hourCycles[0];
}

// ../../node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a2;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
  return { start, end };
}
var hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
  return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 9007199254740991;
};
var REGEX_SUPPORTS_U_AND_Y = true;
try {
  re = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  REGEX_SUPPORTS_U_AND_Y = ((_a2 = re.exec("a")) === null || _a2 === void 0 ? void 0 : _a2[0]) === "a";
} catch (_) {
  REGEX_SUPPORTS_U_AND_Y = false;
}
var re;
var startsWith = hasNativeStartsWith ? (
  // Native
  function startsWith2(s, search, position) {
    return s.startsWith(search, position);
  }
) : (
  // For IE11
  function startsWith3(s, search, position) {
    return s.slice(position, position + search.length) === search;
  }
);
var fromCodePoint = hasNativeFromCodePoint ? String.fromCodePoint : (
  // IE11
  function fromCodePoint2() {
    var codePoints = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      codePoints[_i] = arguments[_i];
    }
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while (length > i) {
      code = codePoints[i++];
      if (code > 1114111)
        throw RangeError(code + " is not a valid code point");
      elements += code < 65536 ? String.fromCharCode(code) : String.fromCharCode(((code -= 65536) >> 10) + 55296, code % 1024 + 56320);
    }
    return elements;
  }
);
var fromEntries = (
  // native
  hasNativeFromEntries ? Object.fromEntries : (
    // Ponyfill
    function fromEntries2(entries) {
      var obj = {};
      for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _a3 = entries_1[_i], k = _a3[0], v = _a3[1];
        obj[k] = v;
      }
      return obj;
    }
  )
);
var codePointAt = hasNativeCodePointAt ? (
  // Native
  function codePointAt2(s, index) {
    return s.codePointAt(index);
  }
) : (
  // IE 11
  function codePointAt3(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) {
      return void 0;
    }
    var first = s.charCodeAt(index);
    var second;
    return first < 55296 || first > 56319 || index + 1 === size || (second = s.charCodeAt(index + 1)) < 56320 || second > 57343 ? first : (first - 55296 << 10) + (second - 56320) + 65536;
  }
);
var trimStart = hasTrimStart ? (
  // Native
  function trimStart2(s) {
    return s.trimStart();
  }
) : (
  // Ponyfill
  function trimStart3(s) {
    return s.replace(SPACE_SEPARATOR_START_REGEX, "");
  }
);
var trimEnd = hasTrimEnd ? (
  // Native
  function trimEnd2(s) {
    return s.trimEnd();
  }
) : (
  // Ponyfill
  function trimEnd3(s) {
    return s.replace(SPACE_SEPARATOR_END_REGEX, "");
  }
);
function RE(s, flag) {
  return new RegExp(s, flag);
}
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
  IDENTIFIER_PREFIX_RE_1 = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  matchIdentifierAtIndex = function matchIdentifierAtIndex4(s, index) {
    var _a3;
    IDENTIFIER_PREFIX_RE_1.lastIndex = index;
    var match = IDENTIFIER_PREFIX_RE_1.exec(s);
    return (_a3 = match[1]) !== null && _a3 !== void 0 ? _a3 : "";
  };
} else {
  matchIdentifierAtIndex = function matchIdentifierAtIndex4(s, index) {
    var match = [];
    while (true) {
      var c = codePointAt(s, index);
      if (c === void 0 || _isWhiteSpace(c) || _isPatternSyntax(c)) {
        break;
      }
      match.push(c);
      index += c >= 65536 ? 2 : 1;
    }
    return fromCodePoint.apply(void 0, match);
  };
}
var IDENTIFIER_PREFIX_RE_1;
var Parser = (
  /** @class */
  function() {
    function Parser4(message, options) {
      if (options === void 0) {
        options = {};
      }
      this.message = message;
      this.position = { offset: 0, line: 1, column: 1 };
      this.ignoreTag = !!options.ignoreTag;
      this.locale = options.locale;
      this.requiresOtherClause = !!options.requiresOtherClause;
      this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser4.prototype.parse = function() {
      if (this.offset() !== 0) {
        throw Error("parser can only be used once");
      }
      return this.parseMessage(0, "", false);
    };
    Parser4.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
      var elements = [];
      while (!this.isEOF()) {
        var char = this.char();
        if (char === 123) {
          var result = this.parseArgument(nestingLevel, expectingCloseTag);
          if (result.err) {
            return result;
          }
          elements.push(result.val);
        } else if (char === 125 && nestingLevel > 0) {
          break;
        } else if (char === 35 && (parentArgType === "plural" || parentArgType === "selectordinal")) {
          var position = this.clonePosition();
          this.bump();
          elements.push({
            type: TYPE.pound,
            location: createLocation(position, this.clonePosition())
          });
        } else if (char === 60 && !this.ignoreTag && this.peek() === 47) {
          if (expectingCloseTag) {
            break;
          } else {
            return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
          }
        } else if (char === 60 && !this.ignoreTag && _isAlpha(this.peek() || 0)) {
          var result = this.parseTag(nestingLevel, parentArgType);
          if (result.err) {
            return result;
          }
          elements.push(result.val);
        } else {
          var result = this.parseLiteral(nestingLevel, parentArgType);
          if (result.err) {
            return result;
          }
          elements.push(result.val);
        }
      }
      return { val: elements, err: null };
    };
    Parser4.prototype.parseTag = function(nestingLevel, parentArgType) {
      var startPosition = this.clonePosition();
      this.bump();
      var tagName = this.parseTagName();
      this.bumpSpace();
      if (this.bumpIf("/>")) {
        return {
          val: {
            type: TYPE.literal,
            value: "<".concat(tagName, "/>"),
            location: createLocation(startPosition, this.clonePosition())
          },
          err: null
        };
      } else if (this.bumpIf(">")) {
        var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
        if (childrenResult.err) {
          return childrenResult;
        }
        var children = childrenResult.val;
        var endTagStartPosition = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !_isAlpha(this.char())) {
            return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
          }
          var closingTagNameStartPosition = this.clonePosition();
          var closingTagName = this.parseTagName();
          if (tagName !== closingTagName) {
            return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
          }
          this.bumpSpace();
          if (!this.bumpIf(">")) {
            return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
          }
          return {
            val: {
              type: TYPE.tag,
              value: tagName,
              children,
              location: createLocation(startPosition, this.clonePosition())
            },
            err: null
          };
        } else {
          return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
        }
      } else {
        return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
      }
    };
    Parser4.prototype.parseTagName = function() {
      var startOffset = this.offset();
      this.bump();
      while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
        this.bump();
      }
      return this.message.slice(startOffset, this.offset());
    };
    Parser4.prototype.parseLiteral = function(nestingLevel, parentArgType) {
      var start = this.clonePosition();
      var value = "";
      while (true) {
        var parseQuoteResult = this.tryParseQuote(parentArgType);
        if (parseQuoteResult) {
          value += parseQuoteResult;
          continue;
        }
        var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
        if (parseUnquotedResult) {
          value += parseUnquotedResult;
          continue;
        }
        var parseLeftAngleResult = this.tryParseLeftAngleBracket();
        if (parseLeftAngleResult) {
          value += parseLeftAngleResult;
          continue;
        }
        break;
      }
      var location2 = createLocation(start, this.clonePosition());
      return {
        val: { type: TYPE.literal, value, location: location2 },
        err: null
      };
    };
    Parser4.prototype.tryParseLeftAngleBracket = function() {
      if (!this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !_isAlphaOrSlash(this.peek() || 0))) {
        this.bump();
        return "<";
      }
      return null;
    };
    Parser4.prototype.tryParseQuote = function(parentArgType) {
      if (this.isEOF() || this.char() !== 39) {
        return null;
      }
      switch (this.peek()) {
        case 39:
          this.bump();
          this.bump();
          return "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (parentArgType === "plural" || parentArgType === "selectordinal") {
            break;
          }
          return null;
        default:
          return null;
      }
      this.bump();
      var codePoints = [this.char()];
      this.bump();
      while (!this.isEOF()) {
        var ch = this.char();
        if (ch === 39) {
          if (this.peek() === 39) {
            codePoints.push(39);
            this.bump();
          } else {
            this.bump();
            break;
          }
        } else {
          codePoints.push(ch);
        }
        this.bump();
      }
      return fromCodePoint.apply(void 0, codePoints);
    };
    Parser4.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
      if (this.isEOF()) {
        return null;
      }
      var ch = this.char();
      if (ch === 60 || ch === 123 || ch === 35 && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 && nestingLevel > 0) {
        return null;
      } else {
        this.bump();
        return fromCodePoint(ch);
      }
    };
    Parser4.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
      var openingBracePosition = this.clonePosition();
      this.bump();
      this.bumpSpace();
      if (this.isEOF()) {
        return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
      }
      if (this.char() === 125) {
        this.bump();
        return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
      }
      var value = this.parseIdentifierIfPossible().value;
      if (!value) {
        return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
      }
      this.bumpSpace();
      if (this.isEOF()) {
        return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
      }
      switch (this.char()) {
        case 125: {
          this.bump();
          return {
            val: {
              type: TYPE.argument,
              // value does not include the opening and closing braces.
              value,
              location: createLocation(openingBracePosition, this.clonePosition())
            },
            err: null
          };
        }
        case 44: {
          this.bump();
          this.bumpSpace();
          if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
          }
          return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
        }
        default:
          return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
      }
    };
    Parser4.prototype.parseIdentifierIfPossible = function() {
      var startingPosition = this.clonePosition();
      var startOffset = this.offset();
      var value = matchIdentifierAtIndex(this.message, startOffset);
      var endOffset = startOffset + value.length;
      this.bumpTo(endOffset);
      var endPosition = this.clonePosition();
      var location2 = createLocation(startingPosition, endPosition);
      return { value, location: location2 };
    };
    Parser4.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
      var _a3;
      var typeStartPosition = this.clonePosition();
      var argType = this.parseIdentifierIfPossible().value;
      var typeEndPosition = this.clonePosition();
      switch (argType) {
        case "":
          return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var styleAndLocation = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var styleStartPosition = this.clonePosition();
            var result = this.parseSimpleArgStyleIfPossible();
            if (result.err) {
              return result;
            }
            var style = trimEnd(result.val);
            if (style.length === 0) {
              return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var styleLocation = createLocation(styleStartPosition, this.clonePosition());
            styleAndLocation = { style, styleLocation };
          }
          var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
          if (argCloseResult.err) {
            return argCloseResult;
          }
          var location_1 = createLocation(openingBracePosition, this.clonePosition());
          if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
            var skeleton = trimStart(styleAndLocation.style.slice(2));
            if (argType === "number") {
              var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
              if (result.err) {
                return result;
              }
              return {
                val: { type: TYPE.number, value, location: location_1, style: result.val },
                err: null
              };
            } else {
              if (skeleton.length === 0) {
                return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
              }
              var dateTimePattern = skeleton;
              if (this.locale) {
                dateTimePattern = getBestPattern(skeleton, this.locale);
              }
              var style = {
                type: SKELETON_TYPE.dateTime,
                pattern: dateTimePattern,
                location: styleAndLocation.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? parseDateTimeSkeleton(dateTimePattern) : {}
              };
              var type = argType === "date" ? TYPE.date : TYPE.time;
              return {
                val: { type, value, location: location_1, style },
                err: null
              };
            }
          }
          return {
            val: {
              type: argType === "number" ? TYPE.number : argType === "date" ? TYPE.date : TYPE.time,
              value,
              location: location_1,
              style: (_a3 = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a3 !== void 0 ? _a3 : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var typeEndPosition_1 = this.clonePosition();
          this.bumpSpace();
          if (!this.bumpIf(",")) {
            return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign({}, typeEndPosition_1)));
          }
          this.bumpSpace();
          var identifierAndLocation = this.parseIdentifierIfPossible();
          var pluralOffset = 0;
          if (argType !== "select" && identifierAndLocation.value === "offset") {
            if (!this.bumpIf(":")) {
              return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
            }
            this.bumpSpace();
            var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (result.err) {
              return result;
            }
            this.bumpSpace();
            identifierAndLocation = this.parseIdentifierIfPossible();
            pluralOffset = result.val;
          }
          var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
          if (optionsResult.err) {
            return optionsResult;
          }
          var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
          if (argCloseResult.err) {
            return argCloseResult;
          }
          var location_2 = createLocation(openingBracePosition, this.clonePosition());
          if (argType === "select") {
            return {
              val: {
                type: TYPE.select,
                value,
                options: fromEntries(optionsResult.val),
                location: location_2
              },
              err: null
            };
          } else {
            return {
              val: {
                type: TYPE.plural,
                value,
                options: fromEntries(optionsResult.val),
                offset: pluralOffset,
                pluralType: argType === "plural" ? "cardinal" : "ordinal",
                location: location_2
              },
              err: null
            };
          }
        }
        default:
          return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
      }
    };
    Parser4.prototype.tryParseArgumentClose = function(openingBracePosition) {
      if (this.isEOF() || this.char() !== 125) {
        return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
      }
      this.bump();
      return { val: true, err: null };
    };
    Parser4.prototype.parseSimpleArgStyleIfPossible = function() {
      var nestedBraces = 0;
      var startPosition = this.clonePosition();
      while (!this.isEOF()) {
        var ch = this.char();
        switch (ch) {
          case 39: {
            this.bump();
            var apostrophePosition = this.clonePosition();
            if (!this.bumpUntil("'")) {
              return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
            }
            this.bump();
            break;
          }
          case 123: {
            nestedBraces += 1;
            this.bump();
            break;
          }
          case 125: {
            if (nestedBraces > 0) {
              nestedBraces -= 1;
            } else {
              return {
                val: this.message.slice(startPosition.offset, this.offset()),
                err: null
              };
            }
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(startPosition.offset, this.offset()),
        err: null
      };
    };
    Parser4.prototype.parseNumberSkeletonFromString = function(skeleton, location2) {
      var tokens = [];
      try {
        tokens = parseNumberSkeletonFromString(skeleton);
      } catch (e) {
        return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location2);
      }
      return {
        val: {
          type: SKELETON_TYPE.number,
          tokens,
          location: location2,
          parsedOptions: this.shouldParseSkeletons ? parseNumberSkeleton(tokens) : {}
        },
        err: null
      };
    };
    Parser4.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
      var _a3;
      var hasOtherClause = false;
      var options = [];
      var parsedSelectors = /* @__PURE__ */ new Set();
      var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
      while (true) {
        if (selector.length === 0) {
          var startPosition = this.clonePosition();
          if (parentArgType !== "select" && this.bumpIf("=")) {
            var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (result.err) {
              return result;
            }
            selectorLocation = createLocation(startPosition, this.clonePosition());
            selector = this.message.slice(startPosition.offset, this.offset());
          } else {
            break;
          }
        }
        if (parsedSelectors.has(selector)) {
          return this.error(parentArgType === "select" ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
        }
        if (selector === "other") {
          hasOtherClause = true;
        }
        this.bumpSpace();
        var openingBracePosition = this.clonePosition();
        if (!this.bumpIf("{")) {
          return this.error(parentArgType === "select" ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
        }
        var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
        if (fragmentResult.err) {
          return fragmentResult;
        }
        var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
        if (argCloseResult.err) {
          return argCloseResult;
        }
        options.push([
          selector,
          {
            value: fragmentResult.val,
            location: createLocation(openingBracePosition, this.clonePosition())
          }
        ]);
        parsedSelectors.add(selector);
        this.bumpSpace();
        _a3 = this.parseIdentifierIfPossible(), selector = _a3.value, selectorLocation = _a3.location;
      }
      if (options.length === 0) {
        return this.error(parentArgType === "select" ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
      }
      if (this.requiresOtherClause && !hasOtherClause) {
        return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
      }
      return { val: options, err: null };
    };
    Parser4.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
      var sign = 1;
      var startingPosition = this.clonePosition();
      if (this.bumpIf("+")) {
      } else if (this.bumpIf("-")) {
        sign = -1;
      }
      var hasDigits = false;
      var decimal = 0;
      while (!this.isEOF()) {
        var ch = this.char();
        if (ch >= 48 && ch <= 57) {
          hasDigits = true;
          decimal = decimal * 10 + (ch - 48);
          this.bump();
        } else {
          break;
        }
      }
      var location2 = createLocation(startingPosition, this.clonePosition());
      if (!hasDigits) {
        return this.error(expectNumberError, location2);
      }
      decimal *= sign;
      if (!isSafeInteger(decimal)) {
        return this.error(invalidNumberError, location2);
      }
      return { val: decimal, err: null };
    };
    Parser4.prototype.offset = function() {
      return this.position.offset;
    };
    Parser4.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    };
    Parser4.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    };
    Parser4.prototype.char = function() {
      var offset = this.position.offset;
      if (offset >= this.message.length) {
        throw Error("out of bound");
      }
      var code = codePointAt(this.message, offset);
      if (code === void 0) {
        throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
      }
      return code;
    };
    Parser4.prototype.error = function(kind, location2) {
      return {
        val: null,
        err: {
          kind,
          message: this.message,
          location: location2
        }
      };
    };
    Parser4.prototype.bump = function() {
      if (this.isEOF()) {
        return;
      }
      var code = this.char();
      if (code === 10) {
        this.position.line += 1;
        this.position.column = 1;
        this.position.offset += 1;
      } else {
        this.position.column += 1;
        this.position.offset += code < 65536 ? 1 : 2;
      }
    };
    Parser4.prototype.bumpIf = function(prefix) {
      if (startsWith(this.message, prefix, this.offset())) {
        for (var i = 0; i < prefix.length; i++) {
          this.bump();
        }
        return true;
      }
      return false;
    };
    Parser4.prototype.bumpUntil = function(pattern) {
      var currentOffset = this.offset();
      var index = this.message.indexOf(pattern, currentOffset);
      if (index >= 0) {
        this.bumpTo(index);
        return true;
      } else {
        this.bumpTo(this.message.length);
        return false;
      }
    };
    Parser4.prototype.bumpTo = function(targetOffset) {
      if (this.offset() > targetOffset) {
        throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
      }
      targetOffset = Math.min(targetOffset, this.message.length);
      while (true) {
        var offset = this.offset();
        if (offset === targetOffset) {
          break;
        }
        if (offset > targetOffset) {
          throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
        }
        this.bump();
        if (this.isEOF()) {
          break;
        }
      }
    };
    Parser4.prototype.bumpSpace = function() {
      while (!this.isEOF() && _isWhiteSpace(this.char())) {
        this.bump();
      }
    };
    Parser4.prototype.peek = function() {
      if (this.isEOF()) {
        return null;
      }
      var code = this.char();
      var offset = this.offset();
      var nextCode = this.message.charCodeAt(offset + (code >= 65536 ? 2 : 1));
      return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser4;
  }()
);
function _isAlpha(codepoint) {
  return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function _isAlphaOrSlash(codepoint) {
  return _isAlpha(codepoint) || codepoint === 47;
}
function _isPotentialElementNameChar(c) {
  return c === 45 || c === 46 || c >= 48 && c <= 57 || c === 95 || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 183 || c >= 192 && c <= 214 || c >= 216 && c <= 246 || c >= 248 && c <= 893 || c >= 895 && c <= 8191 || c >= 8204 && c <= 8205 || c >= 8255 && c <= 8256 || c >= 8304 && c <= 8591 || c >= 11264 && c <= 12271 || c >= 12289 && c <= 55295 || c >= 63744 && c <= 64975 || c >= 65008 && c <= 65533 || c >= 65536 && c <= 983039;
}
function _isWhiteSpace(c) {
  return c >= 9 && c <= 13 || c === 32 || c === 133 || c >= 8206 && c <= 8207 || c === 8232 || c === 8233;
}
function _isPatternSyntax(c) {
  return c >= 33 && c <= 35 || c === 36 || c >= 37 && c <= 39 || c === 40 || c === 41 || c === 42 || c === 43 || c === 44 || c === 45 || c >= 46 && c <= 47 || c >= 58 && c <= 59 || c >= 60 && c <= 62 || c >= 63 && c <= 64 || c === 91 || c === 92 || c === 93 || c === 94 || c === 96 || c === 123 || c === 124 || c === 125 || c === 126 || c === 161 || c >= 162 && c <= 165 || c === 166 || c === 167 || c === 169 || c === 171 || c === 172 || c === 174 || c === 176 || c === 177 || c === 182 || c === 187 || c === 191 || c === 215 || c === 247 || c >= 8208 && c <= 8213 || c >= 8214 && c <= 8215 || c === 8216 || c === 8217 || c === 8218 || c >= 8219 && c <= 8220 || c === 8221 || c === 8222 || c === 8223 || c >= 8224 && c <= 8231 || c >= 8240 && c <= 8248 || c === 8249 || c === 8250 || c >= 8251 && c <= 8254 || c >= 8257 && c <= 8259 || c === 8260 || c === 8261 || c === 8262 || c >= 8263 && c <= 8273 || c === 8274 || c === 8275 || c >= 8277 && c <= 8286 || c >= 8592 && c <= 8596 || c >= 8597 && c <= 8601 || c >= 8602 && c <= 8603 || c >= 8604 && c <= 8607 || c === 8608 || c >= 8609 && c <= 8610 || c === 8611 || c >= 8612 && c <= 8613 || c === 8614 || c >= 8615 && c <= 8621 || c === 8622 || c >= 8623 && c <= 8653 || c >= 8654 && c <= 8655 || c >= 8656 && c <= 8657 || c === 8658 || c === 8659 || c === 8660 || c >= 8661 && c <= 8691 || c >= 8692 && c <= 8959 || c >= 8960 && c <= 8967 || c === 8968 || c === 8969 || c === 8970 || c === 8971 || c >= 8972 && c <= 8991 || c >= 8992 && c <= 8993 || c >= 8994 && c <= 9e3 || c === 9001 || c === 9002 || c >= 9003 && c <= 9083 || c === 9084 || c >= 9085 && c <= 9114 || c >= 9115 && c <= 9139 || c >= 9140 && c <= 9179 || c >= 9180 && c <= 9185 || c >= 9186 && c <= 9254 || c >= 9255 && c <= 9279 || c >= 9280 && c <= 9290 || c >= 9291 && c <= 9311 || c >= 9472 && c <= 9654 || c === 9655 || c >= 9656 && c <= 9664 || c === 9665 || c >= 9666 && c <= 9719 || c >= 9720 && c <= 9727 || c >= 9728 && c <= 9838 || c === 9839 || c >= 9840 && c <= 10087 || c === 10088 || c === 10089 || c === 10090 || c === 10091 || c === 10092 || c === 10093 || c === 10094 || c === 10095 || c === 10096 || c === 10097 || c === 10098 || c === 10099 || c === 10100 || c === 10101 || c >= 10132 && c <= 10175 || c >= 10176 && c <= 10180 || c === 10181 || c === 10182 || c >= 10183 && c <= 10213 || c === 10214 || c === 10215 || c === 10216 || c === 10217 || c === 10218 || c === 10219 || c === 10220 || c === 10221 || c === 10222 || c === 10223 || c >= 10224 && c <= 10239 || c >= 10240 && c <= 10495 || c >= 10496 && c <= 10626 || c === 10627 || c === 10628 || c === 10629 || c === 10630 || c === 10631 || c === 10632 || c === 10633 || c === 10634 || c === 10635 || c === 10636 || c === 10637 || c === 10638 || c === 10639 || c === 10640 || c === 10641 || c === 10642 || c === 10643 || c === 10644 || c === 10645 || c === 10646 || c === 10647 || c === 10648 || c >= 10649 && c <= 10711 || c === 10712 || c === 10713 || c === 10714 || c === 10715 || c >= 10716 && c <= 10747 || c === 10748 || c === 10749 || c >= 10750 && c <= 11007 || c >= 11008 && c <= 11055 || c >= 11056 && c <= 11076 || c >= 11077 && c <= 11078 || c >= 11079 && c <= 11084 || c >= 11085 && c <= 11123 || c >= 11124 && c <= 11125 || c >= 11126 && c <= 11157 || c === 11158 || c >= 11159 && c <= 11263 || c >= 11776 && c <= 11777 || c === 11778 || c === 11779 || c === 11780 || c === 11781 || c >= 11782 && c <= 11784 || c === 11785 || c === 11786 || c === 11787 || c === 11788 || c === 11789 || c >= 11790 && c <= 11798 || c === 11799 || c >= 11800 && c <= 11801 || c === 11802 || c === 11803 || c === 11804 || c === 11805 || c >= 11806 && c <= 11807 || c === 11808 || c === 11809 || c === 11810 || c === 11811 || c === 11812 || c === 11813 || c === 11814 || c === 11815 || c === 11816 || c === 11817 || c >= 11818 && c <= 11822 || c === 11823 || c >= 11824 && c <= 11833 || c >= 11834 && c <= 11835 || c >= 11836 && c <= 11839 || c === 11840 || c === 11841 || c === 11842 || c >= 11843 && c <= 11855 || c >= 11856 && c <= 11857 || c === 11858 || c >= 11859 && c <= 11903 || c >= 12289 && c <= 12291 || c === 12296 || c === 12297 || c === 12298 || c === 12299 || c === 12300 || c === 12301 || c === 12302 || c === 12303 || c === 12304 || c === 12305 || c >= 12306 && c <= 12307 || c === 12308 || c === 12309 || c === 12310 || c === 12311 || c === 12312 || c === 12313 || c === 12314 || c === 12315 || c === 12316 || c === 12317 || c >= 12318 && c <= 12319 || c === 12320 || c === 12336 || c === 64830 || c === 64831 || c >= 65093 && c <= 65094;
}

// ../../node_modules/@formatjs/icu-messageformat-parser/lib/index.js
function pruneLocation(els) {
  els.forEach(function(el) {
    delete el.location;
    if (isSelectElement(el) || isPluralElement(el)) {
      for (var k in el.options) {
        delete el.options[k].location;
        pruneLocation(el.options[k].value);
      }
    } else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
      delete el.style.location;
    } else if ((isDateElement(el) || isTimeElement(el)) && isDateTimeSkeleton(el.style)) {
      delete el.style.location;
    } else if (isTagElement(el)) {
      pruneLocation(el.children);
    }
  });
}
function parse(message, opts) {
  if (opts === void 0) {
    opts = {};
  }
  opts = __assign({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
  var result = new Parser(message, opts).parse();
  if (result.err) {
    var error = SyntaxError(ErrorKind[result.err.kind]);
    error.location = result.err.location;
    error.originalMessage = result.err.message;
    throw error;
  }
  if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
    pruneLocation(result.val);
  }
  return result.val;
}

// ../../node_modules/intl-messageformat/lib/src/error.js
var ErrorCode;
(function(ErrorCode3) {
  ErrorCode3["MISSING_VALUE"] = "MISSING_VALUE";
  ErrorCode3["INVALID_VALUE"] = "INVALID_VALUE";
  ErrorCode3["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = (
  /** @class */
  function(_super) {
    __extends(FormatError4, _super);
    function FormatError4(msg, code, originalMessage) {
      var _this = _super.call(this, msg) || this;
      _this.code = code;
      _this.originalMessage = originalMessage;
      return _this;
    }
    FormatError4.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError4;
  }(Error)
);
var InvalidValueError = (
  /** @class */
  function(_super) {
    __extends(InvalidValueError4, _super);
    function InvalidValueError4(variableId, value, options, originalMessage) {
      return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError4;
  }(FormatError)
);
var InvalidValueTypeError = (
  /** @class */
  function(_super) {
    __extends(InvalidValueTypeError4, _super);
    function InvalidValueTypeError4(value, type, originalMessage) {
      return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError4;
  }(FormatError)
);
var MissingValueError = (
  /** @class */
  function(_super) {
    __extends(MissingValueError4, _super);
    function MissingValueError4(variableId, originalMessage) {
      return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError4;
  }(FormatError)
);

// ../../node_modules/intl-messageformat/lib/src/formatters.js
var PART_TYPE;
(function(PART_TYPE2) {
  PART_TYPE2[PART_TYPE2["literal"] = 0] = "literal";
  PART_TYPE2[PART_TYPE2["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
  if (parts.length < 2) {
    return parts;
  }
  return parts.reduce(function(all, part) {
    var lastPart = all[all.length - 1];
    if (!lastPart || lastPart.type !== PART_TYPE.literal || part.type !== PART_TYPE.literal) {
      all.push(part);
    } else {
      lastPart.value += part.value;
    }
    return all;
  }, []);
}
function isFormatXMLElementFn(el) {
  return typeof el === "function";
}
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, originalMessage) {
  if (els.length === 1 && isLiteralElement(els[0])) {
    return [
      {
        type: PART_TYPE.literal,
        value: els[0].value
      }
    ];
  }
  var result = [];
  for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
    var el = els_1[_i];
    if (isLiteralElement(el)) {
      result.push({
        type: PART_TYPE.literal,
        value: el.value
      });
      continue;
    }
    if (isPoundElement(el)) {
      if (typeof currentPluralValue === "number") {
        result.push({
          type: PART_TYPE.literal,
          value: formatters.getNumberFormat(locales).format(currentPluralValue)
        });
      }
      continue;
    }
    var varName = el.value;
    if (!(values && varName in values)) {
      throw new MissingValueError(varName, originalMessage);
    }
    var value = values[varName];
    if (isArgumentElement(el)) {
      if (!value || typeof value === "string" || typeof value === "number") {
        value = typeof value === "string" || typeof value === "number" ? String(value) : "";
      }
      result.push({
        type: typeof value === "string" ? PART_TYPE.literal : PART_TYPE.object,
        value
      });
      continue;
    }
    if (isDateElement(el)) {
      var style = typeof el.style === "string" ? formats.date[el.style] : isDateTimeSkeleton(el.style) ? el.style.parsedOptions : void 0;
      result.push({
        type: PART_TYPE.literal,
        value: formatters.getDateTimeFormat(locales, style).format(value)
      });
      continue;
    }
    if (isTimeElement(el)) {
      var style = typeof el.style === "string" ? formats.time[el.style] : isDateTimeSkeleton(el.style) ? el.style.parsedOptions : formats.time.medium;
      result.push({
        type: PART_TYPE.literal,
        value: formatters.getDateTimeFormat(locales, style).format(value)
      });
      continue;
    }
    if (isNumberElement(el)) {
      var style = typeof el.style === "string" ? formats.number[el.style] : isNumberSkeleton(el.style) ? el.style.parsedOptions : void 0;
      if (style && style.scale) {
        value = value * (style.scale || 1);
      }
      result.push({
        type: PART_TYPE.literal,
        value: formatters.getNumberFormat(locales, style).format(value)
      });
      continue;
    }
    if (isTagElement(el)) {
      var children = el.children, value_1 = el.value;
      var formatFn = values[value_1];
      if (!isFormatXMLElementFn(formatFn)) {
        throw new InvalidValueTypeError(value_1, "function", originalMessage);
      }
      var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
      var chunks = formatFn(parts.map(function(p) {
        return p.value;
      }));
      if (!Array.isArray(chunks)) {
        chunks = [chunks];
      }
      result.push.apply(result, chunks.map(function(c) {
        return {
          type: typeof c === "string" ? PART_TYPE.literal : PART_TYPE.object,
          value: c
        };
      }));
    }
    if (isSelectElement(el)) {
      var opt = el.options[value] || el.options.other;
      if (!opt) {
        throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
      }
      result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
      continue;
    }
    if (isPluralElement(el)) {
      var opt = el.options["=".concat(value)];
      if (!opt) {
        if (!Intl.PluralRules) {
          throw new FormatError('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', ErrorCode.MISSING_INTL_API, originalMessage);
        }
        var rule = formatters.getPluralRules(locales, { type: el.pluralType }).select(value - (el.offset || 0));
        opt = el.options[rule] || el.options.other;
      }
      if (!opt) {
        throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
      }
      result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
      continue;
    }
  }
  return mergeLiteral(result);
}

// ../../node_modules/intl-messageformat/lib/src/core.js
function mergeConfig(c1, c2) {
  if (!c2) {
    return c1;
  }
  return __assign(__assign(__assign({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
    all[k] = __assign(__assign({}, c1[k]), c2[k] || {});
    return all;
  }, {}));
}
function mergeConfigs(defaultConfig, configs) {
  if (!configs) {
    return defaultConfig;
  }
  return Object.keys(defaultConfig).reduce(function(all, k) {
    all[k] = mergeConfig(defaultConfig[k], configs[k]);
    return all;
  }, __assign({}, defaultConfig));
}
function createFastMemoizeCache(store) {
  return {
    create: function() {
      return {
        get: function(key) {
          return store[key];
        },
        set: function(key, value) {
          store[key] = value;
        }
      };
    }
  };
}
function createDefaultFormatters(cache) {
  if (cache === void 0) {
    cache = {
      number: {},
      dateTime: {},
      pluralRules: {}
    };
  }
  return {
    getNumberFormat: memoize(function() {
      var _a3;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return new ((_a3 = Intl.NumberFormat).bind.apply(_a3, __spreadArray([void 0], args, false)))();
    }, {
      cache: createFastMemoizeCache(cache.number),
      strategy: strategies.variadic
    }),
    getDateTimeFormat: memoize(function() {
      var _a3;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return new ((_a3 = Intl.DateTimeFormat).bind.apply(_a3, __spreadArray([void 0], args, false)))();
    }, {
      cache: createFastMemoizeCache(cache.dateTime),
      strategy: strategies.variadic
    }),
    getPluralRules: memoize(function() {
      var _a3;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return new ((_a3 = Intl.PluralRules).bind.apply(_a3, __spreadArray([void 0], args, false)))();
    }, {
      cache: createFastMemoizeCache(cache.pluralRules),
      strategy: strategies.variadic
    })
  };
}
var IntlMessageFormat = (
  /** @class */
  function() {
    function IntlMessageFormat6(message, locales, overrideFormats, opts) {
      if (locales === void 0) {
        locales = IntlMessageFormat6.defaultLocale;
      }
      var _this = this;
      this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      };
      this.format = function(values) {
        var parts = _this.formatToParts(values);
        if (parts.length === 1) {
          return parts[0].value;
        }
        var result = parts.reduce(function(all, part) {
          if (!all.length || part.type !== PART_TYPE.literal || typeof all[all.length - 1] !== "string") {
            all.push(part.value);
          } else {
            all[all.length - 1] += part.value;
          }
          return all;
        }, []);
        if (result.length <= 1) {
          return result[0] || "";
        }
        return result;
      };
      this.formatToParts = function(values) {
        return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, void 0, _this.message);
      };
      this.resolvedOptions = function() {
        var _a4;
        return {
          locale: ((_a4 = _this.resolvedLocale) === null || _a4 === void 0 ? void 0 : _a4.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
        };
      };
      this.getAst = function() {
        return _this.ast;
      };
      this.locales = locales;
      this.resolvedLocale = IntlMessageFormat6.resolveLocale(locales);
      if (typeof message === "string") {
        this.message = message;
        if (!IntlMessageFormat6.__parse) {
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        }
        var _a3 = opts || {}, formatters = _a3.formatters, parseOpts = __rest(_a3, ["formatters"]);
        this.ast = IntlMessageFormat6.__parse(message, __assign(__assign({}, parseOpts), { locale: this.resolvedLocale }));
      } else {
        this.ast = message;
      }
      if (!Array.isArray(this.ast)) {
        throw new TypeError("A message must be provided as a String or AST.");
      }
      this.formats = mergeConfigs(IntlMessageFormat6.formats, overrideFormats);
      this.formatters = opts && opts.formatters || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat6, "defaultLocale", {
      get: function() {
        if (!IntlMessageFormat6.memoizedDefaultLocale) {
          IntlMessageFormat6.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
        }
        return IntlMessageFormat6.memoizedDefaultLocale;
      },
      enumerable: false,
      configurable: true
    });
    IntlMessageFormat6.memoizedDefaultLocale = null;
    IntlMessageFormat6.resolveLocale = function(locales) {
      if (typeof Intl.Locale === "undefined") {
        return;
      }
      var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
      if (supportedLocales.length > 0) {
        return new Intl.Locale(supportedLocales[0]);
      }
      return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat6.__parse = parse;
    IntlMessageFormat6.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    };
    return IntlMessageFormat6;
  }()
);

// ../../node_modules/intl-messageformat/lib/index.js
var lib_default = IntlMessageFormat;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/error-boundary/utils.js
function canUseRefresh() {
  try {
    void getTopWindow2().location.href;
    return true;
  } catch {
    return false;
  }
}
function refreshPage() {
  try {
    getTopWindow2().location.reload();
  } catch {
  }
}
function getTopWindow2() {
  var _a3;
  return (_a3 = window.top) !== null && _a3 !== void 0 ? _a3 : window;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/error-boundary/styles.css.js
var styles_css_default5 = {
  "error-boundary": "awsui_error-boundary_9pwoq_e6u2g_5",
  "header": "awsui_header_9pwoq_e6u2g_6",
  "description": "awsui_description_9pwoq_e6u2g_7",
  "action": "awsui_action_9pwoq_e6u2g_8",
  "app-layout-part-fallback": "awsui_app-layout-part-fallback_9pwoq_e6u2g_9"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/error-boundary/test-classes/styles.css.js
var styles_css_default6 = {
  "fallback": "awsui_fallback_11u4a_1e43p_5",
  "feedback-action": "awsui_feedback-action_11u4a_1e43p_6",
  "refresh-action": "awsui_refresh-action_11u4a_1e43p_7",
  "header": "awsui_header_11u4a_1e43p_8",
  "description": "awsui_description_11u4a_1e43p_9",
  "action": "awsui_action_11u4a_1e43p_10"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/error-boundary/fallback.js
function ErrorBoundaryFallback({ i18nStrings = {}, renderFallback, ...props }) {
  var _a3;
  const baseProps = getBaseProps(props);
  const defaultSlots = {
    header: React22.createElement(
      "div",
      { className: clsx_m_default(styles_css_default5.header, styles_css_default6.header) },
      React22.createElement(DefaultHeaderContent, { i18nStrings })
    ),
    description: React22.createElement(
      "div",
      { className: clsx_m_default(styles_css_default5.description, styles_css_default6.description) },
      React22.createElement(DefaultDescriptionContent, { i18nStrings })
    ),
    action: canUseRefresh() ? React22.createElement(
      "div",
      { className: clsx_m_default(styles_css_default5.action, styles_css_default6.action) },
      React22.createElement(DefaultActionContent, { i18nStrings })
    ) : null
  };
  return React22.createElement("div", { ...baseProps, className: clsx_m_default(baseProps.className, styles_css_default6.fallback) }, (_a3 = renderFallback === null || renderFallback === void 0 ? void 0 : renderFallback(defaultSlots)) !== null && _a3 !== void 0 ? _a3 : React22.createElement(internal_default3, { type: "error", header: defaultSlots.header, action: defaultSlots.action }, defaultSlots.description));
}
function DefaultHeaderContent({ i18nStrings }) {
  const i18n = useInternalI18n("error-boundary");
  return React22.createElement(React22.Fragment, null, i18n("i18nStrings.headerText", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.headerText));
}
function DefaultDescriptionContent({ i18nStrings: { descriptionText, components: { Feedback: Feedback2 } = {} } = {} }) {
  const i18n = useInternalI18n("error-boundary");
  const formatArgs = Feedback2 ? {
    hasFeedback: true,
    Feedback: (chunks) => {
      var _a3;
      return React22.createElement(
        "span",
        { className: styles_css_default6["feedback-action"] },
        React22.createElement(Feedback2, null, (_a3 = chunks[0]) !== null && _a3 !== void 0 ? _a3 : "")
      );
    }
  } : { hasFeedback: false, Feedback: () => React22.createElement(React22.Fragment, null) };
  function safeFormat(descriptionText2) {
    try {
      return descriptionText2 ? new lib_default(descriptionText2).format(formatArgs) : void 0;
    } catch {
      return descriptionText2;
    }
  }
  const message = i18n("i18nStrings.descriptionText", safeFormat(descriptionText), (format) => format(formatArgs));
  return React22.createElement(React22.Fragment, null, Array.isArray(message) ? message.map((chunk, i) => React22.createElement(React22.Fragment, { key: i }, chunk)) : message);
}
function DefaultActionContent({ i18nStrings }) {
  const i18n = useInternalI18n("error-boundary");
  return React22.createElement(internal_default4, { iconName: "refresh", onClick: refreshPage, className: styles_css_default6["refresh-action"] }, i18n("i18nStrings.refreshActionText", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.refreshActionText));
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/error-boundary/internal.js
var RootSuppressed = Symbol();
var ErrorBoundariesContext = createContext6({
  onError: () => {
  },
  suppressed: RootSuppressed
});
function BuiltInErrorBoundary({ wrapper, suppressNested = false, children }) {
  const context = useContext7(ErrorBoundariesContext);
  const thisSuppressed = context.suppressed === true || context.suppressed === RootSuppressed;
  const nextSuppressed = suppressNested || thisSuppressed;
  return !thisSuppressed ? React23.createElement(
    ErrorBoundaryImpl,
    { ...context, wrapper },
    React23.createElement(ErrorBoundariesContext.Provider, { value: { ...context, suppressed: nextSuppressed } }, children)
  ) : React23.createElement(React23.Fragment, null, children);
}
var ErrorBoundaryImpl = class extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    var _a3, _b;
    (_b = (_a3 = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a3, { error, errorInfo, errorBoundaryId: this.props.errorBoundaryId });
  }
  render() {
    var _a3, _b, _c;
    if (this.state.hasError || this.props.forcedError) {
      const fallback = React23.createElement(ErrorBoundaryFallback, { ...this.props });
      return (_c = (_b = (_a3 = this.props).wrapper) === null || _b === void 0 ? void 0 : _b.call(_a3, fallback)) !== null && _c !== void 0 ? _c : fallback;
    }
    return this.props.children;
  }
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/focus-lock/index.js
import React25, { useCallback as useCallback8, useEffect as useEffect19, useImperativeHandle as useImperativeHandle4, useRef as useRef17, useState as useState12 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/tab-trap/index.js
import React24 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/tab-trap/styles.css.js
var styles_css_default7 = {
  "root": "awsui_root_oip5a_160mh_5"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/tab-trap/index.js
function TabTrap({ focusNextCallback, disabled = false }) {
  return React24.createElement("div", { className: styles_css_default7.root, tabIndex: disabled ? -1 : 0, onFocus: focusNextCallback });
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/focus-lock/utils.js
var tabbables2 = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
].join(",");
function isVisible(element) {
  if (!("checkVisibility" in element)) {
    return true;
  }
  return element.checkVisibility({ visibilityProperty: true });
}
function getAllFocusables2(container) {
  return Array.from(container.querySelectorAll(tabbables2)).filter(isVisible);
}
function getAllTabbables(container) {
  return getAllFocusables2(container).filter((element) => element.tabIndex !== -1);
}
function getFirstFocusable2(container) {
  var _a3;
  const tabbables3 = getAllTabbables(container);
  return (_a3 = tabbables3[0]) !== null && _a3 !== void 0 ? _a3 : null;
}
function getLastFocusable2(container) {
  var _a3;
  const tabbables3 = getAllTabbables(container);
  return (_a3 = tabbables3[tabbables3.length - 1]) !== null && _a3 !== void 0 ? _a3 : null;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/focus-lock/index.js
function FocusLock({ className, disabled, autoFocus, restoreFocus, autoFocusTarget, children }, ref) {
  const restoreFocusTargetRef = useRef17(null);
  const containerRef = useRef17(null);
  const focusFirst = () => {
    var _a3;
    if (containerRef.current) {
      (_a3 = getFirstFocusable2(containerRef.current)) === null || _a3 === void 0 ? void 0 : _a3.focus();
    }
  };
  const focusLast = () => {
    var _a3;
    if (containerRef.current) {
      (_a3 = getLastFocusable2(containerRef.current)) === null || _a3 === void 0 ? void 0 : _a3.focus();
    }
  };
  useEffect19(() => {
    const assignRestoreFocusTarget = () => {
      var _a3;
      if (document.activeElement && !((_a3 = containerRef.current) === null || _a3 === void 0 ? void 0 : _a3.contains(document.activeElement))) {
        restoreFocusTargetRef.current = document.activeElement;
      }
    };
    if (autoFocus && !disabled) {
      assignRestoreFocusTarget();
      if (autoFocusTarget === null || autoFocusTarget === void 0 ? void 0 : autoFocusTarget.current) {
        autoFocusTarget.current.focus();
      } else {
        focusFirst();
      }
    }
  }, [autoFocus, disabled, autoFocusTarget]);
  const [previouslyDisabled, setPreviouslyDisabled] = useState12(!!disabled);
  useEffect19(() => {
    var _a3;
    if (previouslyDisabled !== !!disabled) {
      setPreviouslyDisabled(!!disabled);
      if (restoreFocus && disabled) {
        (_a3 = restoreFocusTargetRef.current) === null || _a3 === void 0 ? void 0 : _a3.focus();
        restoreFocusTargetRef.current = null;
      }
    }
  }, [previouslyDisabled, disabled, restoreFocus]);
  const restoreFocusHandler = useCallback8((elem) => {
    var _a3;
    if (elem === null && restoreFocus) {
      (_a3 = restoreFocusTargetRef.current) === null || _a3 === void 0 ? void 0 : _a3.focus();
      restoreFocusTargetRef.current = null;
    }
  }, [restoreFocus]);
  useImperativeHandle4(ref, () => ({ focusFirst }));
  const mergedRef = useMergeRefs(containerRef, restoreFocusHandler);
  const isFocusInside = (event) => nodeBelongs(containerRef.current, event.relatedTarget);
  return React25.createElement(
    React25.Fragment,
    null,
    React25.createElement(TabTrap, { disabled, focusNextCallback: (event) => isFocusInside(event) ? focusLast() : focusFirst() }),
    React25.createElement("div", { className, ref: mergedRef }, children),
    React25.createElement(TabTrap, { disabled, focusNextCallback: (event) => isFocusInside(event) ? focusFirst() : focusLast() })
  );
}
var focus_lock_default = React25.forwardRef(FocusLock);

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/keycode.js
var KeyCode2;
(function(KeyCode3) {
  KeyCode3[KeyCode3["pageUp"] = 33] = "pageUp";
  KeyCode3[KeyCode3["pageDown"] = 34] = "pageDown";
  KeyCode3[KeyCode3["end"] = 35] = "end";
  KeyCode3[KeyCode3["home"] = 36] = "home";
  KeyCode3[KeyCode3["backspace"] = 8] = "backspace";
  KeyCode3[KeyCode3["space"] = 32] = "space";
  KeyCode3[KeyCode3["down"] = 40] = "down";
  KeyCode3[KeyCode3["left"] = 37] = "left";
  KeyCode3[KeyCode3["right"] = 39] = "right";
  KeyCode3[KeyCode3["up"] = 38] = "up";
  KeyCode3[KeyCode3["escape"] = 27] = "escape";
  KeyCode3[KeyCode3["enter"] = 13] = "enter";
  KeyCode3[KeyCode3["tab"] = 9] = "tab";
})(KeyCode2 || (KeyCode2 = {}));

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/body.js
var PopoverBody = React26.forwardRef(({ dismissButton: showDismissButton, dismissAriaLabel, disableDismissAutoFocus = false, header, children, onDismiss, onBlur, variant, overflowVisible, className, ariaLabelledby, closeAnalyticsAction }, ref) => {
  const i18n = useInternalI18n("popover");
  const labelledById = useUniqueId("awsui-popover-");
  const dismissButtonFocused = useRef18(false);
  const dismissButtonRef = useRef18(null);
  const onKeyDown = useCallback9((event) => {
    if (event.keyCode === KeyCode2.escape) {
      event.stopPropagation();
      onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss("escape");
    }
  }, [onDismiss]);
  useEffect20(() => {
    var _a3;
    if (showDismissButton && !disableDismissAutoFocus && !dismissButtonFocused.current) {
      (_a3 = dismissButtonRef.current) === null || _a3 === void 0 ? void 0 : _a3.focus({ preventScroll: true });
    }
    dismissButtonFocused.current = showDismissButton;
  }, [showDismissButton, disableDismissAutoFocus]);
  const dismissButton = (showDismissButton !== null && showDismissButton !== void 0 ? showDismissButton : null) && React26.createElement(
    "div",
    { className: styles_css_default4.dismiss, ...closeAnalyticsAction ? getAnalyticsMetadataAttribute({ action: closeAnalyticsAction }) : {} },
    React26.createElement(InternalButton, { variant: "icon", formAction: "none", iconName: "close", __iconSize: isThemeActive(Theme.OneTheme) ? "x-small" : void 0, className: styles_css_default4["dismiss-control"], ariaLabel: i18n("dismissAriaLabel", dismissAriaLabel), onClick: () => onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss("close-button"), ref: dismissButtonRef })
  );
  const isDialog = showDismissButton;
  const shouldTrapFocus = showDismissButton && variant !== "annotation";
  const dialogProps = isDialog ? {
    role: "dialog",
    "aria-labelledby": ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : header ? labelledById : void 0
  } : {};
  return React26.createElement(
    "div",
    { className: clsx_m_default(styles_css_default4.body, styles_css_default4[`body-variant-${variant}`], className, {
      [styles_css_default4["body-overflow-visible"]]: overflowVisible === "both"
    }), onKeyDown, ref, onBlur, ...dialogProps },
    React26.createElement(
      BuiltInErrorBoundary,
      null,
      React26.createElement(
        focus_lock_default,
        { disabled: !shouldTrapFocus, autoFocus: false },
        header && React26.createElement(
          "div",
          { className: clsx_m_default(styles_css_default4["header-row"], showDismissButton && styles_css_default4["has-dismiss"]) },
          dismissButton,
          React26.createElement(
            "div",
            { className: styles_css_default4.header, id: labelledById },
            React26.createElement("h2", null, header)
          )
        ),
        React26.createElement(
          "div",
          { className: !header && showDismissButton ? styles_css_default4["has-dismiss"] : void 0 },
          !header && dismissButton,
          React26.createElement("div", { className: clsx_m_default(styles_css_default4.content, { [styles_css_default4["content-overflow-visible"]]: !!overflowVisible }) }, children)
        )
      )
    )
  );
});
var body_default = PopoverBody;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/container.js
import React27, { useLayoutEffect as useLayoutEffect6, useRef as useRef20 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/use-popover-position.js
import { useCallback as useCallback10, useRef as useRef19, useState as useState13 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/scrollable-containers.js
var getOverflowParents = (element) => {
  const parents = [];
  let node = element;
  while ((node = node.parentElement) && node !== element.ownerDocument.body) {
    if (getComputedStyle(node).overflow !== "visible") {
      parents.push(node);
    }
  }
  return parents;
};
function scrollElementIntoView(element, options = { block: "nearest", inline: "nearest" }) {
  var _a3;
  (_a3 = element === null || element === void 0 ? void 0 : element.scrollIntoView) === null || _a3 === void 0 ? void 0 : _a3.call(element, options);
}
function calculateScroll({ insetBlockStart, blockSize }) {
  if (insetBlockStart < 0) {
    return insetBlockStart;
  } else if (insetBlockStart + blockSize > window.innerHeight) {
    if (blockSize > window.innerHeight) {
      return insetBlockStart;
    } else {
      return insetBlockStart + blockSize - window.innerHeight;
    }
  }
  return 0;
}
function scrollRectangleIntoView(box, scrollableParent) {
  const scrollAmount = calculateScroll(box);
  if (scrollAmount) {
    (scrollableParent || window).scrollBy(0, scrollAmount);
  }
}
function getFirstScrollableParent(element) {
  return findUpUntil(element, (el) => {
    const overflows = el.scrollHeight > el.clientHeight;
    return overflows && ["scroll", "auto"].includes(getComputedStyle(el).overflowY);
  }) || void 0;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/utils/positions.js
var ARROW_OFFSET = 12;
var PRIORITY_MAPPING = {
  top: [
    "top-center",
    "top-right",
    "top-left",
    "bottom-center",
    "bottom-right",
    "bottom-left",
    "right-top",
    "right-bottom",
    "left-top",
    "left-bottom"
  ],
  bottom: [
    "bottom-center",
    "bottom-right",
    "bottom-left",
    "top-center",
    "top-right",
    "top-left",
    "right-top",
    "right-bottom",
    "left-top",
    "left-bottom"
  ],
  left: [
    "left-top",
    "left-bottom",
    "right-top",
    "right-bottom",
    "bottom-center",
    "top-center",
    "bottom-left",
    "top-left",
    "bottom-right",
    "top-right"
  ],
  right: [
    "right-top",
    "right-bottom",
    "left-top",
    "left-bottom",
    "bottom-center",
    "top-center",
    "bottom-right",
    "top-right",
    "bottom-left",
    "top-left"
  ]
};
var RECTANGLE_CALCULATIONS = {
  "top-center": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - body.inlineSize / 2,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "top-right": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - ARROW_OFFSET - arrow.inlineSize / 2,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "top-left": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 + ARROW_OFFSET + arrow.inlineSize / 2 - body.inlineSize,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "bottom-center": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - body.inlineSize / 2,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "bottom-right": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - ARROW_OFFSET - arrow.inlineSize / 2,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "bottom-left": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 + ARROW_OFFSET + arrow.inlineSize / 2 - body.inlineSize,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "right-top": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - ARROW_OFFSET - arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart + trigger.inlineSize + arrow.blockSize,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "right-bottom": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - body.blockSize + ARROW_OFFSET + arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart + trigger.inlineSize + arrow.blockSize,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "left-top": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - ARROW_OFFSET - arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart - body.inlineSize - arrow.blockSize,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  },
  "left-bottom": ({ body, trigger, arrow }) => {
    return {
      insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - body.blockSize + ARROW_OFFSET + arrow.blockSize,
      insetInlineStart: trigger.insetInlineStart - body.inlineSize - arrow.blockSize,
      inlineSize: body.inlineSize,
      blockSize: body.blockSize
    };
  }
};
function fitIntoContainer(inner, outer) {
  let { insetInlineStart, inlineSize, insetBlockStart, blockSize } = inner;
  if (insetInlineStart < outer.insetInlineStart) {
    inlineSize = insetInlineStart + inlineSize - outer.insetInlineStart;
    insetInlineStart = outer.insetInlineStart;
  } else if (insetInlineStart + inlineSize > outer.insetInlineStart + outer.inlineSize) {
    inlineSize = outer.insetInlineStart + outer.inlineSize - insetInlineStart;
  }
  if (insetBlockStart < outer.insetBlockStart) {
    blockSize = insetBlockStart + blockSize - outer.insetBlockStart;
    insetBlockStart = outer.insetBlockStart;
  } else if (insetBlockStart + blockSize > outer.insetBlockStart + outer.blockSize) {
    blockSize = outer.insetBlockStart + outer.blockSize - insetBlockStart;
  }
  return { insetInlineStart, inlineSize, insetBlockStart, blockSize };
}
function getTallestRect(rect1, rect2) {
  return rect1.blockSize >= rect2.blockSize ? rect1 : rect2;
}
function getIntersection(rectangles) {
  let boundingBox = null;
  for (const currentRect of rectangles) {
    if (!boundingBox) {
      boundingBox = currentRect;
      continue;
    }
    const insetInlineStart = Math.max(boundingBox.insetInlineStart, currentRect.insetInlineStart);
    const insetBlockStart = Math.max(boundingBox.insetBlockStart, currentRect.insetBlockStart);
    const insetInlineEnd = Math.min(boundingBox.insetInlineStart + boundingBox.inlineSize, currentRect.insetInlineStart + currentRect.inlineSize);
    const insetBlockEnd = Math.min(boundingBox.insetBlockStart + boundingBox.blockSize, currentRect.insetBlockStart + currentRect.blockSize);
    if (insetInlineEnd < insetInlineStart || insetBlockEnd < insetBlockStart) {
      return null;
    }
    boundingBox = {
      insetInlineStart,
      insetBlockStart,
      inlineSize: insetInlineEnd - insetInlineStart,
      blockSize: insetBlockEnd - insetBlockStart
    };
  }
  return boundingBox;
}
function calculatePosition({
  preferredPosition,
  fixedInternalPosition,
  trigger,
  arrow,
  body,
  container,
  viewport,
  // the popover is only bound by the viewport if it is rendered in a portal
  renderWithPortal,
  allowVerticalOverflow,
  minVisibleBlockSize
}) {
  let bestOption = null;
  const preferredInternalPositions = fixedInternalPosition ? [fixedInternalPosition] : PRIORITY_MAPPING[preferredPosition];
  for (const internalPosition2 of preferredInternalPositions) {
    const rect2 = RECTANGLE_CALCULATIONS[internalPosition2]({ body, trigger, arrow });
    const visibleArea = renderWithPortal ? getIntersection([rect2, viewport]) : getIntersection([rect2, viewport, container]);
    const fitsBlockSize = minVisibleBlockSize === void 0 ? visibleArea && visibleArea.blockSize === body.blockSize : visibleArea && visibleArea.blockSize >= Math.min(body.blockSize, minVisibleBlockSize);
    const fitsInlineSize = visibleArea && visibleArea.inlineSize === body.inlineSize;
    if (fitsBlockSize && fitsInlineSize) {
      const scrollable2 = visibleArea && visibleArea.blockSize < body.blockSize;
      return { internalPosition: internalPosition2, rect: scrollable2 ? fitIntoContainer(rect2, viewport) : rect2, scrollable: scrollable2 };
    }
    const newOption = { rect: rect2, internalPosition: internalPosition2, visibleArea };
    bestOption = getBestOption(newOption, bestOption);
  }
  const internalPosition = (bestOption === null || bestOption === void 0 ? void 0 : bestOption.internalPosition) || "right-top";
  const rect = RECTANGLE_CALCULATIONS[internalPosition]({ body, trigger, arrow });
  const tallestBoundingContainer = getTallestRect(viewport, container);
  const boundingContainer = allowVerticalOverflow && isTopOrBottom(internalPosition) ? {
    insetBlockStart: tallestBoundingContainer.insetBlockStart,
    blockSize: tallestBoundingContainer.blockSize,
    insetInlineStart: viewport.insetInlineStart,
    inlineSize: viewport.inlineSize
  } : viewport;
  const optimizedRect = fitIntoContainer(rect, boundingContainer);
  const scrollable = optimizedRect.blockSize < rect.blockSize;
  return { internalPosition, rect: optimizedRect, scrollable };
}
function getBestOption(option1, option2) {
  if (!(option2 === null || option2 === void 0 ? void 0 : option2.visibleArea)) {
    return option1;
  }
  if (!option1.visibleArea) {
    return option2;
  }
  if (option1.visibleArea.inlineSize === option2.visibleArea.inlineSize) {
    return option1.visibleArea.blockSize > option2.visibleArea.blockSize ? option1 : option2;
  }
  return option1.visibleArea.inlineSize > option2.visibleArea.inlineSize ? option1 : option2;
}
function getOffsetDimensions(element) {
  return { offsetHeight: element.offsetHeight, offsetWidth: element.offsetWidth };
}
function getDimensions(element) {
  const computedStyle = getComputedStyle(element);
  return {
    inlineSize: parseFloat(computedStyle.inlineSize),
    blockSize: parseFloat(computedStyle.blockSize)
  };
}
function isTopOrBottom(internalPosition) {
  return ["top", "bottom"].includes(internalPosition.split("-")[0]);
}
function clampRect(rect, bounds) {
  if (!bounds) {
    return rect;
  }
  const parentInlineEnd = bounds.insetInlineStart + bounds.inlineSize;
  const parentBlockEnd = bounds.insetBlockStart + bounds.blockSize;
  const clampedInsetInlineStart = Math.max(bounds.insetInlineStart, Math.min(rect.insetInlineStart, parentInlineEnd));
  const clampedInsetBlockStart = Math.max(bounds.insetBlockStart, Math.min(rect.insetBlockStart, parentBlockEnd));
  const maxInlineSize = parentInlineEnd - clampedInsetInlineStart;
  const maxBlockSize = parentBlockEnd - clampedInsetBlockStart;
  const clampedInlineSize = Math.min(rect.inlineSize, maxInlineSize);
  const clampedBlockSize = Math.min(rect.blockSize, maxBlockSize);
  return {
    insetInlineStart: clampedInsetInlineStart,
    insetBlockStart: clampedInsetBlockStart,
    inlineSize: clampedInlineSize,
    blockSize: clampedBlockSize,
    insetInlineEnd: clampedInsetInlineStart + clampedInlineSize,
    insetBlockEnd: clampedInsetBlockStart + clampedBlockSize
  };
}
function isCenterOutside(child, parent) {
  const childCenter = child.insetBlockStart + child.blockSize / 2;
  const overflowsBlockStart = childCenter < parent.insetBlockStart;
  const overflowsBlockEnd = childCenter > parent.insetBlockEnd;
  return overflowsBlockStart || overflowsBlockEnd;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/use-popover-position.js
function usePopoverPosition({ popoverRef, bodyRef, arrowRef, getTrack, triggerClampRef, contentRef, allowScrollToFit, allowVerticalOverflow, preferredPosition, renderWithPortal, keepPosition, hideOnOverscroll, minVisibleBlockSize }) {
  const previousInternalPositionRef = useRef19(null);
  const [popoverStyle, setPopoverStyle] = useState13({});
  const [internalPosition, setInternalPosition] = useState13(null);
  const [isOverscrolling, setIsOverscrolling] = useState13(false);
  const positionHandlerRef = useRef19(() => {
  });
  const scrollableContainerRectRef = useRef19(null);
  const updatePositionHandler = useCallback10((onContentResize = false) => {
    var _a3;
    const track = getTrack();
    if (!track || !popoverRef.current || !bodyRef.current || !contentRef.current || !arrowRef.current) {
      return;
    }
    const popover = popoverRef.current;
    const body = bodyRef.current;
    const arrow = arrowRef.current;
    const document2 = popover.ownerDocument;
    const { offsetWidth, offsetHeight } = getOffsetDimensions(popover);
    if (offsetWidth === 0 || offsetHeight === 0 || !nodeContains(document2.body, track)) {
      return;
    }
    const prevInsetBlockStart = popover.style.insetBlockStart;
    const prevInsetInlineStart = popover.style.insetInlineStart;
    popover.style.insetBlockStart = "0";
    popover.style.insetInlineStart = "0";
    body.style.maxBlockSize = "";
    body.style.overflowX = "";
    body.style.overflowY = "";
    const viewportRect = getViewportRect(document2.defaultView);
    const trackRect = getClampedTrackRect(track, triggerClampRef === null || triggerClampRef === void 0 ? void 0 : triggerClampRef.current);
    const arrowRect = getDimensions(arrow);
    const { containingBlock, boundary } = findUpUntilMultiple({
      startElement: popover,
      tests: {
        containingBlock: isContainingBlock,
        boundary: (element) => isContainingBlock(element) || isBoundary(element)
      }
    });
    const containingBlockRect = containingBlock ? getLogicalBoundingClientRect(containingBlock) : viewportRect;
    const boundaryRect = boundary ? getLogicalBoundingClientRect(boundary) : getDocumentRect(document2);
    const bodyBorderWidth = getBorderWidth(body);
    const contentRect = getLogicalBoundingClientRect(contentRef.current);
    const contentBoundingBox = {
      inlineSize: contentRect.inlineSize + 2 * bodyBorderWidth,
      blockSize: contentRect.blockSize + 2 * bodyBorderWidth
    };
    const shouldKeepPosition = keepPosition && onContentResize && !!previousInternalPositionRef.current;
    const fixedInternalPosition = (_a3 = shouldKeepPosition && previousInternalPositionRef.current) !== null && _a3 !== void 0 ? _a3 : void 0;
    const { scrollable, internalPosition: newInternalPosition, rect } = calculatePosition({
      preferredPosition,
      fixedInternalPosition,
      trigger: trackRect,
      arrow: arrowRect,
      body: contentBoundingBox,
      container: boundaryRect,
      viewport: viewportRect,
      renderWithPortal,
      allowVerticalOverflow,
      minVisibleBlockSize
    });
    const popoverOffset = toRelativePosition(rect, containingBlockRect);
    const trackRelativeOffset = toRelativePosition(popoverOffset, toRelativePosition(trackRect, containingBlockRect));
    popover.style.insetBlockStart = prevInsetBlockStart;
    popover.style.insetInlineStart = prevInsetInlineStart;
    if (scrollable) {
      body.style.maxBlockSize = rect.blockSize + "px";
      body.style.overflowX = "hidden";
      body.style.overflowY = "auto";
    }
    previousInternalPositionRef.current = newInternalPosition;
    setInternalPosition(newInternalPosition);
    const shouldScroll = allowScrollToFit && !shouldKeepPosition;
    const insetBlockStart = shouldScroll ? popoverOffset.insetBlockStart + calculateScroll(rect) : popoverOffset.insetBlockStart;
    setPopoverStyle({ insetBlockStart, insetInlineStart: popoverOffset.insetInlineStart });
    if (shouldScroll) {
      const scrollableParent = getFirstScrollableParent(popover);
      scrollRectangleIntoView(rect, scrollableParent);
    }
    if (hideOnOverscroll && track instanceof HTMLElement) {
      const scrollableContainer = getFirstScrollableParent(track);
      if (scrollableContainer) {
        scrollableContainerRectRef.current = getLogicalBoundingClientRect(scrollableContainer);
      }
    }
    positionHandlerRef.current = () => {
      const track2 = getTrack();
      if (!track2) {
        return;
      }
      const trackRect2 = getClampedTrackRect(track2, triggerClampRef === null || triggerClampRef === void 0 ? void 0 : triggerClampRef.current);
      const newTrackOffset = toRelativePosition(trackRect2, containingBlock ? getLogicalBoundingClientRect(containingBlock) : viewportRect);
      setPopoverStyle({
        insetBlockStart: newTrackOffset.insetBlockStart + trackRelativeOffset.insetBlockStart,
        insetInlineStart: newTrackOffset.insetInlineStart + trackRelativeOffset.insetInlineStart
      });
      if (hideOnOverscroll && scrollableContainerRectRef.current) {
        setIsOverscrolling(isCenterOutside(trackRect2, scrollableContainerRectRef.current));
      }
    };
  }, [
    getTrack,
    popoverRef,
    bodyRef,
    contentRef,
    arrowRef,
    triggerClampRef,
    keepPosition,
    preferredPosition,
    renderWithPortal,
    allowVerticalOverflow,
    minVisibleBlockSize,
    allowScrollToFit,
    hideOnOverscroll
  ]);
  return { updatePositionHandler, popoverStyle, internalPosition, positionHandlerRef, isOverscrolling };
}
function getBorderWidth(element) {
  return parseInt(getComputedStyle(element).borderWidth) || 0;
}
function toRelativePosition(element, parent) {
  return {
    insetBlockStart: element.insetBlockStart - parent.insetBlockStart,
    insetInlineStart: element.insetInlineStart - parent.insetInlineStart
  };
}
function getViewportRect(window2) {
  var _a3, _b, _c, _d;
  return {
    insetBlockStart: 0,
    insetInlineStart: 0,
    inlineSize: (_b = (_a3 = window2.visualViewport) === null || _a3 === void 0 ? void 0 : _a3.width) !== null && _b !== void 0 ? _b : window2.innerWidth,
    blockSize: (_d = (_c = window2.visualViewport) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : window2.innerHeight
  };
}
function getDocumentRect(document2) {
  const { insetBlockStart, insetInlineStart } = getLogicalBoundingClientRect(document2.documentElement);
  return {
    insetBlockStart,
    insetInlineStart,
    inlineSize: document2.documentElement.scrollWidth,
    blockSize: document2.documentElement.scrollHeight
  };
}
function isBoundary(element) {
  const computedStyle = getComputedStyle(element);
  return !!computedStyle.clipPath && computedStyle.clipPath !== "none";
}
function getClampedTrackRect(track, parentRef) {
  const rect = getLogicalBoundingClientRect(track);
  const bounds = parentRef ? getLogicalBoundingClientRect(parentRef) : void 0;
  return clampRect(rect, bounds);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/use-position-observer.js
import { useEffect as useEffect21 } from "react";
function usePositionObserver(getTrack, trackKey, callback) {
  const stableCallback = useStableCallback(callback);
  useEffect21(() => {
    const track = getTrack();
    if (!track) {
      return;
    }
    let lastTrackKey = trackKey;
    let lastPosition = {
      x: track.getBoundingClientRect().x,
      y: track.getBoundingClientRect().y
    };
    const observer2 = new MutationObserver(() => {
      const track2 = getTrack();
      if (!track2) {
        return;
      }
      const { x, y } = track2.getBoundingClientRect();
      if (x !== lastPosition.x || y !== lastPosition.y || trackKey !== lastTrackKey) {
        lastTrackKey = trackKey;
        lastPosition = { x, y };
        stableCallback();
      }
    });
    observer2.observe(track.ownerDocument, {
      attributes: true,
      subtree: true,
      childList: true
    });
    return () => observer2.disconnect();
  }, [getTrack, stableCallback]);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/container.js
function PopoverContainer({ position, trackRef, getTrack: externalGetTrack, trackKey, triggerClampRef, minVisibleBlockSize, arrow, children, zIndex, renderWithPortal, size, fixedWidth, variant, keepPosition, allowScrollToFit, allowVerticalOverflow, hideOnOverscroll, hoverArea, className }) {
  const bodyRef = useRef20(null);
  const contentRef = useRef20(null);
  const popoverRef = useRef20(null);
  const arrowRef = useRef20(null);
  const isRefresh = useVisualRefresh();
  const getTrack = useRef20(() => {
    if (trackRef) {
      return trackRef.current;
    }
    if (externalGetTrack) {
      return externalGetTrack();
    }
    throw new Error("Invariant violation: must provide either trackRef or getTrack.");
  });
  const { updatePositionHandler, popoverStyle, internalPosition, positionHandlerRef, isOverscrolling } = usePopoverPosition({
    popoverRef,
    bodyRef,
    arrowRef,
    triggerClampRef,
    getTrack: getTrack.current,
    contentRef,
    allowScrollToFit,
    allowVerticalOverflow,
    preferredPosition: position,
    renderWithPortal,
    keepPosition,
    hideOnOverscroll,
    minVisibleBlockSize
  });
  useLayoutEffect6(() => {
    updatePositionHandler();
  }, [updatePositionHandler, trackKey]);
  useResizeObserver(contentRef, () => {
    updatePositionHandler(true);
  });
  usePositionObserver(getTrack.current, trackKey, () => {
    const popoverOffset = popoverRef.current && getLogicalBoundingClientRect(popoverRef.current);
    if (!popoverOffset || popoverOffset.insetBlockStart < 0 || popoverOffset.insetBlockEnd > window.innerHeight) {
      return;
    }
    positionHandlerRef.current();
  });
  useLayoutEffect6(() => {
    const controller = new AbortController();
    const updatePositionOnResize = () => requestAnimationFrame(() => updatePositionHandler(true));
    const refreshPosition = () => requestAnimationFrame(() => positionHandlerRef.current());
    window.addEventListener("resize", updatePositionOnResize, { signal: controller.signal });
    window.addEventListener("scroll", refreshPosition, { capture: true, signal: controller.signal });
    return () => {
      controller.abort();
    };
  }, [hideOnOverscroll, keepPosition, positionHandlerRef, trackRef, updatePositionHandler]);
  return isOverscrolling ? null : React27.createElement(
    "div",
    { ref: popoverRef, style: { ...popoverStyle, zIndex }, className: clsx_m_default(styles_css_default4.container, isRefresh && styles_css_default4.refresh, className) },
    React27.createElement("div", { ref: arrowRef, className: clsx_m_default(styles_css_default4[`container-arrow`], styles_css_default4[`container-arrow-position-${internalPosition}`]), "aria-hidden": true }, arrow(internalPosition)),
    React27.createElement("div", { ref: bodyRef, className: clsx_m_default(styles_css_default4["container-body"], styles_css_default4[`container-body-size-${size}`], {
      [styles_css_default4["fixed-width"]]: fixedWidth,
      [styles_css_default4[`container-body-variant-${variant}`]]: variant
    }) }, hoverArea ? React27.createElement(
      "div",
      { className: styles_css_default4["hover-area"] },
      React27.createElement("div", { ref: contentRef }, children)
    ) : React27.createElement("div", { ref: contentRef }, children))
  );
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/tooltip/styles.css.js
var styles_css_default8 = {
  "root": "awsui_root_1r4p6_6i2pz_9",
  "awsui-motion-fade-in-tooltip": "awsui_awsui-motion-fade-in-tooltip_1r4p6_6i2pz_1"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/tooltip/test-classes/styles.css.js
var styles_css_default9 = {
  "root": "awsui_root_1u26h_im8v7_5"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/tooltip/internal.js
function InternalTooltip({ content, getTrack, className, position = "top", onEscape, referrerId, __internalRootRef, ...restProps }) {
  const baseProps = getBaseProps(restProps);
  const trackRef = React28.useRef(null);
  React28.useEffect(() => {
    const element = getTrack();
    trackRef.current = element;
  }, [getTrack]);
  useEffect22(() => {
    const controller = new AbortController();
    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        fireNonCancelableEvent(onEscape);
      }
    }, {
      // The tooltip is often activated on mouseover, which means the focus can
      // be anywhere else on the page. Capture also means that this gets called
      // before any wrapper modals or dialogs can detect it and act on it.
      capture: true,
      signal: controller.signal
    });
    return () => {
      controller.abort();
    };
  }, [onEscape]);
  return React28.createElement(
    Portal,
    null,
    React28.createElement(
      "div",
      { ...baseProps, className: clsx_m_default(styles_css_default9.root, styles_css_default8.root, baseProps.className), ref: __internalRootRef, "data-awsui-referrer-id": referrerId, role: "tooltip" },
      React28.createElement(Transition2, { in: true }, () => React28.createElement(
        PopoverContainer,
        { getTrack, size: "medium", fixedWidth: false, position, zIndex: 7e3, arrow: (position2) => React28.createElement(arrow_default, { position: position2 }), hideOnOverscroll: true, className },
        React28.createElement(body_default, { dismissButton: false, dismissAriaLabel: void 0, onDismiss: void 0, header: void 0 }, content)
      ))
    )
  );
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/icon-helper.js
import * as React30 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/spinner/internal.js
import React29 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/spinner/styles.css.js
var styles_css_default10 = {
  "root": "awsui_root_1612d_mu3st_43",
  "spinner-rotator": "awsui_spinner-rotator_1612d_mu3st_1",
  "size-x-small": "awsui_size-x-small_1612d_mu3st_58",
  "size-normal": "awsui_size-normal_1612d_mu3st_65",
  "size-big": "awsui_size-big_1612d_mu3st_72",
  "size-large": "awsui_size-large_1612d_mu3st_79",
  "variant-normal": "awsui_variant-normal_1612d_mu3st_86",
  "variant-disabled": "awsui_variant-disabled_1612d_mu3st_89",
  "variant-inverted": "awsui_variant-inverted_1612d_mu3st_92",
  "circle": "awsui_circle_1612d_mu3st_104",
  "circle-left": "awsui_circle-left_1612d_mu3st_132",
  "spinner-line-left": "awsui_spinner-line-left_1612d_mu3st_1",
  "circle-right": "awsui_circle-right_1612d_mu3st_137",
  "spinner-line-right": "awsui_spinner-line-right_1612d_mu3st_1"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/spinner/internal.js
function InternalSpinner({ size = "normal", variant = "normal", nativeAttributes, __internalRootRef, ...props }) {
  const baseProps = getBaseProps(props);
  useModalContextLoadingComponent();
  return React29.createElement(
    with_native_attributes_default,
    { ...baseProps, tag: "span", componentName: "Spinner", nativeAttributes, className: clsx_m_default(baseProps.className, styles_css_default10.root, styles_css_default10[`size-${size}`], styles_css_default10[`variant-${variant}`]), ref: __internalRootRef },
    React29.createElement("span", { className: clsx_m_default(styles_css_default10.circle, styles_css_default10["circle-left"]) }),
    React29.createElement("span", { className: clsx_m_default(styles_css_default10.circle, styles_css_default10["circle-right"]) })
  );
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/styles.css.js
var styles_css_default11 = {
  "content": "awsui_content_vjswe_lokum_13",
  "button": "awsui_button_vjswe_lokum_17",
  "variant-normal": "awsui_variant-normal_vjswe_lokum_66",
  "disabled": "awsui_disabled_vjswe_lokum_84",
  "variant-primary": "awsui_variant-primary_vjswe_lokum_91",
  "variant-link": "awsui_variant-link_vjswe_lokum_116",
  "variant-icon": "awsui_variant-icon_vjswe_lokum_141",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_lokum_166",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_lokum_193",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_lokum_218",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_lokum_243",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_lokum_272",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_lokum_297",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_lokum_322",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_lokum_352",
  "button-no-text": "awsui_button-no-text_vjswe_lokum_450",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_lokum_454",
  "full-width": "awsui_full-width_vjswe_lokum_457",
  "button-compact": "awsui_button-compact_vjswe_lokum_474",
  "icon-left": "awsui_icon-left_vjswe_lokum_497",
  "icon-right": "awsui_icon-right_vjswe_lokum_502",
  "icon": "awsui_icon_vjswe_lokum_497",
  "link": "awsui_link_vjswe_lokum_521",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_lokum_521"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/icon-helper.js
function getIconAlign(props) {
  const standalone = props.variant === "icon" || props.variant === "inline-icon";
  return standalone ? "left" : props.iconAlign;
}
function IconWrapper({ iconName, iconUrl, iconAlt, iconSvg, iconSize, badge, ...props }) {
  if (!iconName && !iconUrl && !iconSvg) {
    return null;
  }
  return React30.createElement(internal_default, { className: clsx_m_default(styles_css_default11.icon, styles_css_default11[`icon-${getIconAlign(props)}`], props.iconClass), name: iconName, url: iconUrl, svg: iconSvg, alt: iconAlt, size: iconSize, badge });
}
function LeftIcon(props) {
  if (props.loading) {
    return React30.createElement(InternalSpinner, { variant: "disabled", className: clsx_m_default(styles_css_default11.icon, styles_css_default11["icon-left"]) });
  } else if (getIconAlign(props) === "left") {
    return React30.createElement(IconWrapper, { ...props });
  }
  return null;
}
function RightIcon(props) {
  if (getIconAlign(props) === "right") {
    return React30.createElement(IconWrapper, { ...props });
  }
  return null;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/generated/custom-css-properties/index.js
var customCSSPropertiesMap = {
  "maxContentWidth": "--awsui-max-content-width-ka4djm",
  "minContentWidth": "--awsui-min-content-width-ka4djm",
  "breadcrumbsGap": "--awsui-breadcrumbs-gap-ka4djm",
  "contentGapLeft": "--awsui-content-gap-left-ka4djm",
  "contentGapRight": "--awsui-content-gap-right-ka4djm",
  "contentHeight": "--awsui-content-height-ka4djm",
  "contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-ka4djm",
  "contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-ka4djm",
  "contentLayoutMainGap": "--awsui-content-layout-main-gap-ka4djm",
  "defaultMaxContentWidth": "--awsui-default-max-content-width-ka4djm",
  "defaultMinContentWidth": "--awsui-default-min-content-width-ka4djm",
  "drawerSize": "--awsui-drawer-size-ka4djm",
  "drawerMinSize": "--awsui-drawer-min-size-ka4djm",
  "bottomDrawerSize": "--awsui-bottom-drawer-size-ka4djm",
  "footerHeight": "--awsui-footer-height-ka4djm",
  "headerGap": "--awsui-header-gap-ka4djm",
  "headerHeight": "--awsui-header-height-ka4djm",
  "layoutWidth": "--awsui-layout-width-ka4djm",
  "mainGap": "--awsui-main-gap-ka4djm",
  "mainOffsetLeft": "--awsui-main-offset-left-ka4djm",
  "mainTemplateRows": "--awsui-main-template-rows-ka4djm",
  "mobileBarHeight": "--awsui-mobile-bar-height-ka4djm",
  "notificationsHeight": "--awsui-notifications-height-ka4djm",
  "offsetTop": "--awsui-offset-top-ka4djm",
  "overlapHeight": "--awsui-overlap-height-ka4djm",
  "navigationWidth": "--awsui-navigation-width-ka4djm",
  "navigationCollapsedWidth": "--awsui-navigation-collapsed-width-ka4djm",
  "splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-ka4djm",
  "splitPanelReportedSize": "--awsui-split-panel-reported-size-ka4djm",
  "splitPanelHeight": "--awsui-split-panel-height-ka4djm",
  "splitPanelMinWidth": "--awsui-split-panel-min-width-ka4djm",
  "splitPanelMaxWidth": "--awsui-split-panel-max-width-ka4djm",
  "toolsMaxWidth": "--awsui-tools-max-width-ka4djm",
  "toolsWidth": "--awsui-tools-width-ka4djm",
  "toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-ka4djm",
  "contentScrollMargin": "--awsui-content-scroll-margin-ka4djm",
  "flashbarStackDepth": "--awsui-flashbar-stack-depth-ka4djm",
  "flashbarStackIndex": "--awsui-flashbar-stack-index-ka4djm",
  "flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-ka4djm",
  "stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-ka4djm",
  "stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-ka4djm",
  "dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-ka4djm",
  "dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-ka4djm",
  "dropdownContentBorderColor": "--awsui-dropdown-content-border-color-ka4djm",
  "dropdownContentBorderWidth": "--awsui-dropdown-content-border-width-ka4djm",
  "dropdownContentBorderRadius": "--awsui-dropdown-content-border-radius-ka4djm",
  "modalCustomWidth": "--awsui-modal-custom-width-ka4djm",
  "modalCustomHeight": "--awsui-modal-custom-height-ka4djm",
  "spinnerRotatorFrom": "--awsui-spinner-rotator-from-ka4djm",
  "spinnerRotatorTo": "--awsui-spinner-rotator-to-ka4djm",
  "spinnerLineLeftFrom": "--awsui-spinner-line-left-from-ka4djm",
  "spinnerLineLeftTo": "--awsui-spinner-line-left-to-ka4djm",
  "spinnerLineRightFrom": "--awsui-spinner-line-right-from-ka4djm",
  "spinnerLineRightTo": "--awsui-spinner-line-right-to-ka4djm",
  "sliderLabelCount": "--awsui-slider-label-count-ka4djm",
  "sliderTickCount": "--awsui-slider-tick-count-ka4djm",
  "sliderReferenceColumn": "--awsui-slider-reference-column-ka4djm",
  "sliderNextReferenceColumn": "--awsui-slider-next-reference-column-ka4djm",
  "sliderMaxStart": "--awsui-slider-max-start-ka4djm",
  "sliderMinEnd": "--awsui-slider-min-end-ka4djm",
  "sliderRangeInlineSize": "--awsui-slider-range-inline-size-ka4djm",
  "sliderTooltipPosition": "--awsui-slider-tooltip-position-ka4djm",
  "togglesLeftWidth": "--awsui-toggles-left-width-ka4djm",
  "togglesRightWidth": "--awsui-toggles-right-width-ka4djm",
  "promptInputMaxRows": "--awsui-prompt-input-max-rows-ka4djm",
  "promptInputScrollHeight": "--awsui-prompt-input-scroll-height-ka4djm",
  "dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-ka4djm",
  "dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-ka4djm",
  "styleBackgroundActive": "--awsui-style-background-active-ka4djm",
  "styleBackgroundDefault": "--awsui-style-background-default-ka4djm",
  "styleBackgroundDisabled": "--awsui-style-background-disabled-ka4djm",
  "styleBackgroundHover": "--awsui-style-background-hover-ka4djm",
  "styleBorderColorActive": "--awsui-style-border-color-active-ka4djm",
  "styleBorderColorDefault": "--awsui-style-border-color-default-ka4djm",
  "styleBorderColorDisabled": "--awsui-style-border-color-disabled-ka4djm",
  "styleBorderColorHover": "--awsui-style-border-color-hover-ka4djm",
  "styleColorActive": "--awsui-style-color-active-ka4djm",
  "styleColorDefault": "--awsui-style-color-default-ka4djm",
  "styleColorDisabled": "--awsui-style-color-disabled-ka4djm",
  "styleColorHover": "--awsui-style-color-hover-ka4djm",
  "styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-ka4djm",
  "styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-ka4djm",
  "styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-ka4djm",
  "styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-ka4djm",
  "styleBoxShadowActive": "--awsui-style-box-shadow-active-ka4djm",
  "styleBoxShadowDefault": "--awsui-style-box-shadow-default-ka4djm",
  "styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-ka4djm",
  "styleBoxShadowHover": "--awsui-style-box-shadow-hover-ka4djm",
  "styleBackgroundReadonly": "--awsui-style-background-readonly-ka4djm",
  "styleBorderColorReadonly": "--awsui-style-border-color-readonly-ka4djm",
  "styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-ka4djm",
  "styleColorReadonly": "--awsui-style-color-readonly-ka4djm",
  "styleBackgroundFocus": "--awsui-style-background-focus-ka4djm",
  "styleBorderColorFocus": "--awsui-style-border-color-focus-ka4djm",
  "styleBoxShadowFocus": "--awsui-style-box-shadow-focus-ka4djm",
  "styleColorFocus": "--awsui-style-color-focus-ka4djm",
  "stylePlaceholderColor": "--awsui-style-placeholder-color-ka4djm",
  "stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-ka4djm",
  "stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-ka4djm",
  "stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-ka4djm",
  "styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-ka4djm",
  "styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-ka4djm",
  "styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-ka4djm",
  "styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-ka4djm",
  "styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-ka4djm",
  "alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-ka4djm",
  "alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-ka4djm",
  "alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-ka4djm",
  "alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-ka4djm",
  "alertIconColor": "--awsui-alert-icon-color-ka4djm",
  "promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-ka4djm",
  "promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-ka4djm",
  "promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-ka4djm",
  "promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-ka4djm",
  "promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-ka4djm",
  "promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-ka4djm",
  "promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-ka4djm",
  "promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-ka4djm",
  "promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-ka4djm",
  "promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-ka4djm",
  "promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-ka4djm",
  "promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-ka4djm",
  "promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-ka4djm",
  "promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-ka4djm",
  "promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-ka4djm",
  "promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-ka4djm",
  "promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-ka4djm",
  "promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-ka4djm",
  "promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-ka4djm",
  "promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-ka4djm",
  "promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-ka4djm",
  "promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-ka4djm",
  "promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-ka4djm",
  "promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-ka4djm",
  "promptInputMenuStyleBackgroundColor": "--awsui-prompt-input-menu-style-background-color-ka4djm",
  "promptInputMenuStyleBorderColor": "--awsui-prompt-input-menu-style-border-color-ka4djm",
  "promptInputMenuStyleBorderRadius": "--awsui-prompt-input-menu-style-border-radius-ka4djm",
  "promptInputMenuStyleBorderWidth": "--awsui-prompt-input-menu-style-border-width-ka4djm",
  "optionBackgroundDefault": "--awsui-option-background-default-ka4djm",
  "optionBackgroundHighlighted": "--awsui-option-background-highlighted-ka4djm",
  "optionBackgroundSelected": "--awsui-option-background-selected-ka4djm",
  "optionColorDefault": "--awsui-option-color-default-ka4djm",
  "optionColorHighlighted": "--awsui-option-color-highlighted-ka4djm",
  "optionColorDisabled": "--awsui-option-color-disabled-ka4djm",
  "optionGroupLabelColor": "--awsui-option-group-label-color-ka4djm",
  "optionFilterMatchBackground": "--awsui-option-filter-match-background-ka4djm",
  "optionFilterMatchColor": "--awsui-option-filter-match-color-ka4djm",
  "progressBarBackgroundColor": "--awsui-progress-bar-background-color-ka4djm",
  "progressBarBorderRadius": "--awsui-progress-bar-border-radius-ka4djm",
  "progressBarHeight": "--awsui-progress-bar-height-ka4djm",
  "progressValueBackgroundColor": "--awsui-progress-value-background-color-ka4djm",
  "styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-ka4djm",
  "styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-ka4djm",
  "styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-ka4djm",
  "styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-ka4djm",
  "styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-ka4djm",
  "styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-ka4djm",
  "styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-ka4djm",
  "tokenStyleBackgroundDefault": "--awsui-token-style-background-default-ka4djm",
  "tokenStyleBackgroundDisabled": "--awsui-token-style-background-disabled-ka4djm",
  "tokenStyleBackgroundReadOnly": "--awsui-token-style-background-read-only-ka4djm",
  "tokenStyleBorderColorDefault": "--awsui-token-style-border-color-default-ka4djm",
  "tokenStyleBorderColorDisabled": "--awsui-token-style-border-color-disabled-ka4djm",
  "tokenStyleBorderColorReadOnly": "--awsui-token-style-border-color-read-only-ka4djm",
  "tokenStyleDismissColorDefault": "--awsui-token-style-dismiss-color-default-ka4djm",
  "tokenStyleDismissColorDisabled": "--awsui-token-style-dismiss-color-disabled-ka4djm",
  "tokenStyleDismissColorHover": "--awsui-token-style-dismiss-color-hover-ka4djm",
  "tokenStyleDismissColorReadOnly": "--awsui-token-style-dismiss-color-read-only-ka4djm",
  "styleItemCardBackgroundDefault": "--awsui-style-item-card-background-default-ka4djm",
  "styleItemCardBorderColorDefault": "--awsui-style-item-card-border-color-default-ka4djm",
  "styleItemCardBorderRadius": "--awsui-style-item-card-border-radius-ka4djm",
  "styleItemCardBorderWidthDefault": "--awsui-style-item-card-border-width-default-ka4djm",
  "styleItemCardBoxShadowDefault": "--awsui-style-item-card-box-shadow-default-ka4djm",
  "inlineLabelBackgroundColor": "--awsui-inline-label-background-color-ka4djm",
  "containerStyleBorderRadius": "--awsui-container-style-border-radius-ka4djm"
};
var custom_css_properties_default = customCSSPropertiesMap;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/style.js
function getButtonStyles(style) {
  var _a3, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
  if (SYSTEM !== "core" || !(style === null || style === void 0 ? void 0 : style.root)) {
    return void 0;
  }
  return {
    borderRadius: (_a3 = style === null || style === void 0 ? void 0 : style.root) === null || _a3 === void 0 ? void 0 : _a3.borderRadius,
    borderWidth: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderWidth,
    paddingBlock: (_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.paddingBlock,
    paddingInline: (_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.paddingInline,
    ...((_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.background) && {
      [custom_css_properties_default.styleBackgroundActive]: (_f = style.root.background) === null || _f === void 0 ? void 0 : _f.active,
      [custom_css_properties_default.styleBackgroundDefault]: (_g = style.root.background) === null || _g === void 0 ? void 0 : _g.default,
      [custom_css_properties_default.styleBackgroundDisabled]: (_h = style.root.background) === null || _h === void 0 ? void 0 : _h.disabled,
      [custom_css_properties_default.styleBackgroundHover]: (_j = style.root.background) === null || _j === void 0 ? void 0 : _j.hover
    },
    ...((_k = style === null || style === void 0 ? void 0 : style.root) === null || _k === void 0 ? void 0 : _k.borderColor) && {
      [custom_css_properties_default.styleBorderColorActive]: (_l = style.root.borderColor) === null || _l === void 0 ? void 0 : _l.active,
      [custom_css_properties_default.styleBorderColorDefault]: (_m = style.root.borderColor) === null || _m === void 0 ? void 0 : _m.default,
      [custom_css_properties_default.styleBorderColorDisabled]: (_o = style.root.borderColor) === null || _o === void 0 ? void 0 : _o.disabled,
      [custom_css_properties_default.styleBorderColorHover]: (_p = style.root.borderColor) === null || _p === void 0 ? void 0 : _p.hover
    },
    ...((_q = style === null || style === void 0 ? void 0 : style.root) === null || _q === void 0 ? void 0 : _q.boxShadow) && {
      [custom_css_properties_default.styleBoxShadowActive]: (_r = style.root.boxShadow) === null || _r === void 0 ? void 0 : _r.active,
      [custom_css_properties_default.styleBoxShadowDefault]: (_s = style.root.boxShadow) === null || _s === void 0 ? void 0 : _s.default,
      [custom_css_properties_default.styleBoxShadowDisabled]: (_t = style.root.boxShadow) === null || _t === void 0 ? void 0 : _t.disabled,
      [custom_css_properties_default.styleBoxShadowHover]: (_u = style.root.boxShadow) === null || _u === void 0 ? void 0 : _u.hover
    },
    ...((_v = style === null || style === void 0 ? void 0 : style.root) === null || _v === void 0 ? void 0 : _v.color) && {
      [custom_css_properties_default.styleColorActive]: (_w = style.root.color) === null || _w === void 0 ? void 0 : _w.active,
      [custom_css_properties_default.styleColorDefault]: (_x = style.root.color) === null || _x === void 0 ? void 0 : _x.default,
      [custom_css_properties_default.styleColorDisabled]: (_y = style.root.color) === null || _y === void 0 ? void 0 : _y.disabled,
      [custom_css_properties_default.styleColorHover]: (_z = style.root.color) === null || _z === void 0 ? void 0 : _z.hover
    },
    ...((_0 = style === null || style === void 0 ? void 0 : style.root) === null || _0 === void 0 ? void 0 : _0.focusRing) && {
      [custom_css_properties_default.styleFocusRingBorderColor]: (_1 = style.root.focusRing) === null || _1 === void 0 ? void 0 : _1.borderColor,
      [custom_css_properties_default.styleFocusRingBorderRadius]: (_2 = style.root.focusRing) === null || _2 === void 0 ? void 0 : _2.borderRadius,
      [custom_css_properties_default.styleFocusRingBorderWidth]: (_3 = style.root.focusRing) === null || _3 === void 0 ? void 0 : _3.borderWidth
    },
    ...((_5 = (_4 = style === null || style === void 0 ? void 0 : style.root) === null || _4 === void 0 ? void 0 : _4.focusRing) === null || _5 === void 0 ? void 0 : _5.borderRadius) && {
      [custom_css_properties_default.styleFocusRingBorderRadius]: style.root.focusRing.borderRadius
    }
  };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/analytics-metadata/styles.css.js
var styles_css_default12 = {
  "label": "awsui_label_1f1d4_ocied_5"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/test-classes/styles.css.js
var styles_css_default13 = {
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_1ueyk_ca6yt_5",
  "external-icon": "awsui_external-icon_1ueyk_ca6yt_9"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/internal.js
var InternalButton = React31.forwardRef(({ children, iconName, __iconClass, __iconSize, onClick, onFollow, iconAlign = "left", iconUrl, iconSvg, iconAlt, variant = "normal", loading = false, loadingText, disabled = false, disabledReason, wrapText = true, href, external, target: targetOverride, rel, download, formAction = "submit", ariaLabel, ariaDescribedby, ariaExpanded, ariaHaspopup, ariaControls, fullWidth, badge, i18nStrings, style, nativeButtonAttributes, nativeAnchorAttributes, __internalRootRef, __focusable = false, __injectAnalyticsComponentMetadata = false, __title, __emitPerformanceMarks = true, __skipNativeAttributesWarnings, __compact = false, analyticsAction = "click", styleClassNames, ...props }, ref) => {
  var _a3;
  const [showTooltip, setShowTooltip] = useState14(false);
  checkSafeUrl("Button", href);
  const isAnchor = Boolean(href);
  const target = targetOverride !== null && targetOverride !== void 0 ? targetOverride : external ? "_blank" : void 0;
  const isNotInteractive = loading || disabled;
  const isDisabledWithReason = (variant === "normal" || variant === "primary" || variant === "icon" || variant === "control-group-action" || variant === "inline-icon" || variant === "inline-link" || variant === "link") && !!disabledReason && disabled;
  const hasAriaDisabled = loading && !disabled || disabled && __focusable || isDisabledWithReason;
  const shouldHaveContent = children && [
    "icon",
    "control-group-action",
    "inline-icon",
    "flashbar-icon",
    "modal-dismiss",
    "inline-icon-pointer-target"
  ].indexOf(variant) === -1;
  if ((iconName || iconUrl || iconSvg) && iconAlign === "right" && external) {
    warnOnce("Button", "A right-aligned icon should not be combined with an external icon.");
  }
  const buttonRef = useRef21(null);
  useForwardFocus(ref, buttonRef);
  const buttonContext = useButtonContext();
  const i18n = useInternalI18n("button");
  const uniqueId = useUniqueId("button");
  const { funnelInteractionId } = useFunnel();
  const { stepNumber, stepNameSelector } = useFunnelStep();
  const { subStepSelector, subStepNameSelector } = useFunnelSubStep();
  const performanceMarkAttributes = usePerformanceMarks("primaryButton", () => variant === "primary" && __emitPerformanceMarks && !loading && !disabled, buttonRef, () => {
    var _a4;
    return {
      loading,
      disabled,
      text: (_a4 = buttonRef.current) === null || _a4 === void 0 ? void 0 : _a4.innerText
    };
  }, [loading, disabled]);
  useModalContextLoadingButtonComponent(variant === "primary", loading);
  const { targetProps, descriptionEl } = useHiddenDescription(disabledReason);
  const handleClick = (event) => {
    if (isNotInteractive) {
      return event.preventDefault();
    }
    if (isAnchor && isPlainLeftClick(event)) {
      fireCancelableEvent(onFollow, { href, target }, event);
      if ((iconName === "external" || target === "_blank") && funnelInteractionId) {
        const stepName = getTextFromSelector(stepNameSelector);
        const subStepName = getTextFromSelector(subStepNameSelector);
        FunnelMetrics.externalLinkInteracted({
          funnelInteractionId,
          stepNumber,
          stepName,
          stepNameSelector,
          subStepSelector,
          subStepName,
          subStepNameSelector,
          elementSelector: getFunnelValueSelector(uniqueId),
          subStepAllSelector: getSubStepAllSelector()
        });
      }
    }
    const { altKey, button, ctrlKey, metaKey, shiftKey } = event;
    fireCancelableEvent(onClick, { altKey, button, ctrlKey, metaKey, shiftKey }, event);
    buttonContext.onClick({ variant });
  };
  const stylingClassName = styleClassNames === null || styleClassNames === void 0 ? void 0 : styleClassNames.root;
  const buttonClass = clsx_m_default(props.className, stylingClassName, styles_css_default11.button, styles_css_default11[`variant-${variant}`], {
    [styles_css_default11.disabled]: isNotInteractive,
    [styles_css_default11["disabled-with-reason"]]: isDisabledWithReason,
    [styles_css_default11["button-no-wrap"]]: !wrapText,
    [styles_css_default11["button-no-text"]]: !shouldHaveContent,
    [styles_css_default11["full-width"]]: shouldHaveContent && fullWidth,
    [styles_css_default11["button-compact"]]: __compact,
    [styles_css_default11.link]: isAnchor
  });
  const explicitTabIndex = (_a3 = nativeButtonAttributes === null || nativeButtonAttributes === void 0 ? void 0 : nativeButtonAttributes.tabIndex) !== null && _a3 !== void 0 ? _a3 : nativeAnchorAttributes === null || nativeAnchorAttributes === void 0 ? void 0 : nativeAnchorAttributes.tabIndex;
  const { tabIndex } = useSingleTabStopNavigation(buttonRef, {
    tabIndex: isAnchor && isNotInteractive && !isDisabledWithReason ? -1 : explicitTabIndex
  });
  const analyticsMetadata = disabled ? {} : {
    action: analyticsAction,
    detail: { label: { root: "self" } }
  };
  if (__injectAnalyticsComponentMetadata) {
    analyticsMetadata.component = {
      name: "awsui.Button",
      label: { root: "self" },
      properties: { variant, disabled: `${disabled}` }
    };
  }
  const buttonProps = {
    ...props,
    ...performanceMarkAttributes,
    tabIndex,
    // https://github.com/microsoft/TypeScript/issues/36659
    ref: useMergeRefs(buttonRef, __internalRootRef),
    "aria-label": ariaLabel,
    "aria-describedby": ariaDescribedby,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": ariaHaspopup,
    "aria-controls": ariaControls,
    // add ariaLabel as `title` as visible hint text
    title: __title !== null && __title !== void 0 ? __title : ariaLabel,
    className: buttonClass,
    onClick: handleClick,
    "data-awsui-motion-trigger": "hover",
    "data-awsui-motion-target": "",
    [DATA_ATTR_FUNNEL_VALUE]: uniqueId,
    ...getAnalyticsMetadataAttribute(analyticsMetadata),
    ...getAnalyticsLabelAttribute(shouldHaveContent ? `.${styles_css_default12.label}` : "")
  };
  const iconProps = {
    loading,
    iconName,
    iconAlign,
    iconUrl,
    iconSvg,
    iconAlt,
    variant,
    badge,
    iconClass: __iconClass,
    iconSize: __iconSize !== null && __iconSize !== void 0 ? __iconSize : variant === "modal-dismiss" ? "medium" : "normal"
  };
  const buttonContent = React31.createElement(
    React31.Fragment,
    null,
    React31.createElement(LeftIcon, { ...iconProps }),
    shouldHaveContent && React31.createElement(
      React31.Fragment,
      null,
      React31.createElement("span", { className: clsx_m_default(styles_css_default11.content, styles_css_default12.label) }, children),
      external && React31.createElement(
        React31.Fragment,
        null,
        "\xA0",
        React31.createElement(internal_default, { name: "external", className: styles_css_default13["external-icon"], ariaLabel: i18n("i18nStrings.externalIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.externalIconAriaLabel) })
      )
    ),
    React31.createElement(RightIcon, { ...iconProps })
  );
  const { loadingButtonCount } = useFunnel();
  useEffect23(() => {
    if (loading) {
      loadingButtonCount.current++;
      return () => {
        loadingButtonCount.current--;
      };
    }
  }, [loading, loadingButtonCount]);
  const disabledReasonProps = {
    onFocus: isDisabledWithReason ? () => setShowTooltip(true) : void 0,
    onBlur: isDisabledWithReason ? () => setShowTooltip(false) : void 0,
    onMouseEnter: isDisabledWithReason ? () => setShowTooltip(true) : void 0,
    onMouseLeave: isDisabledWithReason ? () => setShowTooltip(false) : void 0,
    ...isDisabledWithReason ? targetProps : {}
  };
  const disabledReasonContent = React31.createElement(
    React31.Fragment,
    null,
    descriptionEl,
    showTooltip && React31.createElement(InternalTooltip, { className: styles_css_default13["disabled-reason-tooltip"], getTrack: () => buttonRef.current, content: disabledReason, onEscape: () => setShowTooltip(false) })
  );
  const stylePropertiesAndVariables = getButtonStyles(style);
  if (isAnchor) {
    const getAnchorTabIndex = () => {
      if (isNotInteractive) {
        return isDisabledWithReason ? 0 : buttonProps.tabIndex;
      }
      return buttonProps.tabIndex;
    };
    return React31.createElement(
      React31.Fragment,
      null,
      React31.createElement(
        with_native_attributes_default,
        {
          ...buttonProps,
          ...disabledReasonProps,
          tag: "a",
          componentName: "Button",
          nativeAttributes: nativeAnchorAttributes,
          skipWarnings: __skipNativeAttributesWarnings,
          href: isNotInteractive ? void 0 : href,
          role: isNotInteractive ? "link" : void 0,
          tabIndex: getAnchorTabIndex(),
          target,
          // security recommendation: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target
          rel: rel !== null && rel !== void 0 ? rel : target === "_blank" ? "noopener noreferrer" : void 0,
          "aria-disabled": isNotInteractive ? true : void 0,
          download,
          style: stylePropertiesAndVariables
        },
        buttonContent,
        isDisabledWithReason && disabledReasonContent
      ),
      loading && loadingText && React31.createElement(internal_default2, { tagName: "span", hidden: true }, loadingText)
    );
  }
  return React31.createElement(
    React31.Fragment,
    null,
    React31.createElement(
      with_native_attributes_default,
      { ...buttonProps, ...disabledReasonProps, tag: "button", componentName: "Button", nativeAttributes: nativeButtonAttributes, skipWarnings: __skipNativeAttributesWarnings, type: formAction === "none" ? "button" : "submit", disabled: disabled && !__focusable && !isDisabledWithReason, "aria-disabled": hasAriaDisabled ? true : void 0, style: stylePropertiesAndVariables },
      buttonContent,
      isDisabledWithReason && disabledReasonContent
    ),
    loading && loadingText && React31.createElement(internal_default2, { tagName: "span", hidden: true }, loadingText)
  );
});
var internal_default4 = InternalButton;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/visual-context/index.js
import React32, { useLayoutEffect as useLayoutEffect7, useState as useState15 } from "react";
var contextMatch = /awsui-context-([\w-]+)/;
function useVisualContext(elementRef) {
  const [value, setValue] = useState15("");
  useLayoutEffect7(() => {
    var _a3;
    if (elementRef.current) {
      const contextParent = findUpUntil(elementRef.current, (node) => !!node.className.match(contextMatch));
      setValue((_a3 = contextParent === null || contextParent === void 0 ? void 0 : contextParent.className.match(contextMatch)[1]) !== null && _a3 !== void 0 ? _a3 : "");
    }
  }, [elementRef]);
  return value;
}
function getVisualContextClassname(contextName) {
  return `awsui-context-${contextName}`;
}
function VisualContext({ contextName, className, children }) {
  return React32.createElement("div", { className: clsx_m_default(getVisualContextClassname(contextName), className) }, children);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/link-default-variant-context.js
import { createContext as createContext7 } from "react";
var defaultValue2 = {
  defaultVariant: "secondary"
};
var LinkDefaultVariantContext = createContext7(defaultValue2);

// ../../node_modules/@amzn/awsui-component-toolkit-internal/lib/vendor/index.js
var __defProp2 = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var TELEMETRY_CONFIG_MISSING_MSG = "[TangerineBox] Telemetry configuration is missing, events will not be emitted";
var TangerineBoxError = class extends Error {
  constructor(message, originalError) {
    super(message);
    this.message = message;
    this.originalError = originalError;
    this.name = this.constructor.name;
    if (originalError) {
      this.stack += "\nCaused by: " + originalError.stack;
    }
  }
};
var TelemetryBrokerNotAvailableError = class extends TangerineBoxError {
};
var MetaTagParsingError = class extends TangerineBoxError {
};
var TELEMETRY_BROKER_PROPERTY_NAME = "_internal_tb_telemetry_broker";
var TelemetryBrokerWindowProvider = class _TelemetryBrokerWindowProvider {
  constructor() {
    this.windowWithTelemetryBroker = this.findWindowWithTelemetryBroker();
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new _TelemetryBrokerWindowProvider();
    }
    return this.instance;
  }
  getWindow() {
    return this.windowWithTelemetryBroker;
  }
  findWindowWithTelemetryBroker() {
    let currentWindow = window;
    while (true) {
      if (currentWindow[TELEMETRY_BROKER_PROPERTY_NAME]) {
        return currentWindow;
      }
      if (currentWindow === currentWindow.parent) {
        return void 0;
      }
      currentWindow = currentWindow.parent;
    }
  }
};
var USER_INFO_COOKIE = "aws-userInfo";
var SESSION_CONTEXT_NAME_ATTRIBUTE = "awsc-session-data";
var SESSION_ID_COOKIE_PREFIX = "__Secure-aws-session-id";
var sessionIdCookie = (sessionDifferentiator) => `${SESSION_ID_COOKIE_PREFIX}-${sessionDifferentiator}`;
var DataParser = class _DataParser {
  constructor(metaTagContent) {
    this.windowWithTelemetryBroker = TelemetryBrokerWindowProvider.getInstance().getWindow();
    this.metaTagContentCache = metaTagContent;
    this.sessionDataCache = {
      ...this.parseSessionDataMetaTag(this.windowWithTelemetryBroker),
      ...this.parseMockAccountProperties()
    };
  }
  static getInstance(metaTagContent) {
    if (!this.metaDataProviderInstance) {
      this.metaDataProviderInstance = new _DataParser(metaTagContent);
    }
    return this.metaDataProviderInstance;
  }
  getTelemetryBrokerWindow() {
    return this.windowWithTelemetryBroker;
  }
  getMetaTagContent() {
    if (!this.metaTagContentCache) {
      this.metaTagContentCache = this.parseTangerineBoxMetaTag();
    }
    return this.metaTagContentCache;
  }
  getTelemetryMetaTagContent() {
    if (!this.telemetryMetaTagContentCache) {
      this.telemetryMetaTagContentCache = this.parseTangerineBoxTelemetryMetaTag();
    }
    return this.telemetryMetaTagContentCache;
  }
  getCredentialsConfig() {
    return {
      browserCredsFullPath: this.getMetaTagContent().browserCredsFullPath,
      csrfToken: this.getMetaTagContent().csrfToken
    };
  }
  parseTangerineBoxMetaTag() {
    const element = this.parseMetaTag("tb-data");
    if (!element) {
      throw new MetaTagParsingError("TangerineBox meta tag not found");
    }
    try {
      return JSON.parse(element);
    } catch (error) {
      throw new MetaTagParsingError("Unable to parse TangerineBox meta tag contents", error instanceof Error ? error : new Error(String(error)));
    }
  }
  parseTangerineBoxTelemetryMetaTag() {
    const element = this.parseMetaTag("tbt-data");
    if (!element) {
      throw new MetaTagParsingError("TangerineBox Telemetry meta tag not found");
    }
    try {
      return JSON.parse(element);
    } catch (error) {
      throw new MetaTagParsingError("Unable to parse TangerineBox Telemetry meta tag contents", error instanceof Error ? error : new Error(String(error)));
    }
  }
  parseMetaTag(metaTagName, windowObject) {
    const documentObject = windowObject ? windowObject.document : document;
    const element = documentObject.querySelector(`meta[name='${metaTagName}']`);
    if (!element) {
      return void 0;
    }
    return element.content;
  }
  parseCookie(cookieName, cookieString = document.cookie) {
    const cookie = cookieString.match(`${cookieName}=([^;]*)`);
    if (!cookie || !cookie[1]) {
      return void 0;
    }
    return cookie[1];
  }
  triggerLoggedOutDialog() {
    var _a3;
    const isUsingNav2 = this.parseMetaTag("awsc-widget-nav") !== void 0 || this.parseMetaTag("awsc-widget-next") !== void 0;
    const windowWithTelemetryBroker = (_a3 = this.windowWithTelemetryBroker) !== null && _a3 !== void 0 ? _a3 : window;
    if (windowWithTelemetryBroker !== void 0) {
      if (isUsingNav2) {
        windowWithTelemetryBroker.dispatchEvent(this.createCustomEvent("auth-change-detected"));
      } else {
        if (windowWithTelemetryBroker.AWSC && typeof this.windowWithTelemetryBroker.AWSC.jQuery === "function") {
          windowWithTelemetryBroker.AWSC.jQuery(windowWithTelemetryBroker.AWSC).trigger("auth-change-detected");
        }
      }
    }
  }
  createCustomEvent(name) {
    if (typeof window !== "undefined" && typeof window.CustomEvent === "function") {
      return new CustomEvent(name);
    } else {
      const params = {
        bubbles: false,
        cancelable: false,
        detail: null
      };
      const evt = document.createEvent("CustomEvent");
      evt.initCustomEvent(name, params.bubbles, params.cancelable, params.detail);
      return evt;
    }
  }
  // Temporary: reads account properties from the `aws-mock-identity-data` cookie.
  // Stopgap until PageLambda forwards accountProperties from Signin in the awsc-session-data meta tag.
  // Tracking: https://code.amazon.com/reviews/CR-272752949
  parseMockAccountProperties() {
    const raw = this.parseCookie("aws-mock-identity-data");
    if (!raw)
      return {};
    try {
      const decoded = decodeURIComponent(raw);
      const parsed = JSON.parse(decoded);
      return parsed.accountProperties ? { accountProperties: parsed.accountProperties } : {};
    } catch {
      return {};
    }
  }
  parseSessionDataMetaTag(windowObject) {
    const element = this.parseMetaTag(SESSION_CONTEXT_NAME_ATTRIBUTE, windowObject);
    if (!element) {
      throw new MetaTagParsingError("Session data meta tag not found");
    }
    try {
      return JSON.parse(element);
    } catch (error) {
      throw new MetaTagParsingError("Unable to parse session data meta tag content", error instanceof Error ? error : new Error(String(error)));
    }
  }
  async getSessionDataValue(attribute) {
    return this.sessionDataCache[attribute];
  }
  /** Returns the name of the logout detection cookie depending on the prism mode. */
  getLogoutDetectionCookieName() {
    if (this.isPrismModeEnabled()) {
      if (!this.sessionDataCache.sessionDifferentiator) {
        throw new MetaTagParsingError("sessionDifferentiator is not found in prism mode");
      }
      return sessionIdCookie(this.sessionDataCache.sessionDifferentiator);
    }
    return USER_INFO_COOKIE;
  }
  /**
   * Tries to find the property in tb-data metatag and if it's not present fallsback to awsc-session-data
   * this logic will be removed and it will be directly read from tb-data once the change is released
   * https://issues.amazon.com/issues/OrangeBox-13756
   *
   * @returns true if prism mode is enabled
   */
  isPrismModeEnabled() {
    const prismModeEnabled = this.getMetaTagContent().prismModeEnabled;
    if (typeof prismModeEnabled === "boolean") {
      return prismModeEnabled;
    }
    return !!this.sessionDataCache.prismModeEnabled;
  }
};
var BrokerWrapper = class _BrokerWrapper {
  constructor(windowObject) {
    this.telemetryBroker = windowObject[TELEMETRY_BROKER_PROPERTY_NAME];
  }
  register(props) {
    return this.telemetryBroker.register(props);
  }
  addEvent(props) {
    this.telemetryBroker.addEvent(props);
  }
  dangerouslyFlushEvents() {
    this.telemetryBroker.dangerouslyFlushEvents();
  }
  registerTenant(tenant, telemetryOptions) {
    var _a3, _b;
    (_b = (_a3 = this.telemetryBroker).registerTenant) === null || _b === void 0 ? void 0 : _b.call(_a3, tenant, telemetryOptions);
  }
  registerObserver(observer2) {
    return this.telemetryBroker.registerObserver(observer2);
  }
  getTenants() {
    if (this.telemetryBroker.getTenants) {
      return this.telemetryBroker.getTenants();
    } else {
      return {
        hash: "",
        tenants: []
      };
    }
  }
  static getInstance() {
    if (this.brokerWrapper) {
      return this.brokerWrapper;
    }
    const windowWithTelemetryBroker = TelemetryBrokerWindowProvider.getInstance().getWindow();
    if (windowWithTelemetryBroker === void 0) {
      throw new TelemetryBrokerNotAvailableError("Telemetry broker not found");
    }
    this.brokerWrapper = new _BrokerWrapper(windowWithTelemetryBroker);
    return this.brokerWrapper;
  }
};
var PACKAGE_VERSION2 = "2.0.555390.0#e9894fba";
var ScheduledEventTracker = class _ScheduledEventTracker {
  constructor(props, trackerProps) {
    this.props = props;
    const telemetryTokensForPublicEvents = (() => {
      const tokensForPublicEvents = trackerProps.tokensForPublicEvents;
      if (tokensForPublicEvents !== void 0) {
        return tokensForPublicEvents;
      }
      const parentToken = trackerProps.parentToken;
      if (parentToken !== void 0) {
        return [parentToken];
      }
      return void 0;
    })();
    this.id = this.props.broker.register({
      source: "weblib-v2",
      telemetryToken: trackerProps.token,
      telemetryTokensForPublicEvents
    });
  }
  static getInstance(trackerProps) {
    const props = trackerProps !== null && trackerProps !== void 0 ? trackerProps : {
      token: DataParser.getInstance().getTelemetryMetaTagContent().telemetryToken
    };
    return new _ScheduledEventTracker({
      broker: BrokerWrapper.getInstance()
    }, props);
  }
  getId() {
    return this.id;
  }
  addEvent(content, options) {
    const event = {
      type: "log",
      content,
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({ tenantId: this.id, event, ...options });
  }
  addError(error, content, options) {
    const event = {
      type: "error",
      content: { error, ...this.resolveContentErrorKey(content) },
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({ tenantId: this.id, event, ...options });
  }
  addFatalError(error, content, metadata, options) {
    const event = {
      type: "fatal-error",
      content: { error, ...this.resolveContentErrorKey(content) },
      fatalErrorMetadata: metadata,
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({ tenantId: this.id, event, ...options });
  }
  addAwsSdkEvent(content, options) {
    const event = {
      type: "aws-sdk-metric",
      awsSdkMetric: content,
      content: {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({ tenantId: this.id, event, ...options });
  }
  addFmsEvaluationEvent(event, content, options) {
    const trackerEvent = {
      type: "fms-evaluation",
      fmsEvaluation: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addAwsArachnidQueryEvent(event, content, options) {
    const trackerEvent = {
      type: "aws-arachnid-query",
      awsArachnidQuery: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addAwsArachnidCredentialEvent(event, content, options) {
    const trackerEvent = {
      type: "aws-arachnid-credential",
      awsArachnidCredential: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addAwsArachnidFallbackQueryEvent(event, content, options) {
    const trackerEvent = {
      type: "aws-arachnid-fallback-query",
      awsArachnidFallbackQuery: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addJanusApiEvent(event, content, options) {
    const trackerEvent = {
      type: "janus-api",
      janusApi: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addJanusCredentialEvent(event, content, options) {
    const trackerEvent = {
      type: "janus-credential",
      janusCredential: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addLotusCspEvent(event, content, options) {
    const trackerEvent = {
      type: "lotus-csp",
      lotusCsp: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addLotusIsolatedIFrameEvent(event, content, options) {
    const trackerEvent = {
      type: "lotus-isolated-iframe",
      lotusIsolatedIFrame: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addLotusImportPackageEvent(event, content, options) {
    const trackerEvent = {
      type: "lotus-import-package",
      lotusImportPackage: event.lotusImportPackage,
      lotusMetadata: event.lotusMetadata,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addModuleLifecycleEvent(event, content, options) {
    const trackerEvent = {
      type: "module-lifecycle",
      moduleLifecycle: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addModuleRegistryQueryModulesEvent(event, content, options) {
    const trackerEvent = {
      type: "module-registry-query-modules",
      moduleRegistryQueryModules: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addCloudEditorEvent(event, content, options) {
    const trackerEvent = {
      type: "cloud-editor",
      cloudEditor: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addCloudEditorLspEvent(event, content, options) {
    const trackerEvent = {
      type: "cloud-editor-lsp",
      cloudEditorLsp: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addPapiProxyEvent(event, content, options) {
    const trackerEvent = {
      type: "papi-proxy",
      papiProxy: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addPapiCredentialEvent(event, content, options) {
    const trackerEvent = {
      type: "papi-credential",
      papiCredential: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  addBootstrapEvent(event, content, options) {
    const trackerEvent = {
      type: "tb-bootstrap",
      tbBootstrap: event,
      content: content !== null && content !== void 0 ? content : {},
      version: PACKAGE_VERSION2,
      timestamp: /* @__PURE__ */ new Date()
    };
    this.props.broker.addEvent({
      tenantId: this.id,
      event: trackerEvent,
      ...options
    });
  }
  // For testing purposes only. PLEASE DO NOT USE THIS IN PRODUCTION!
  dangerouslyFlushEvents() {
    this.props.broker.dangerouslyFlushEvents();
  }
  resolveContentErrorKey(content) {
    const { error: contentErrorProp, ...remainingContentProps } = content !== null && content !== void 0 ? content : {};
    return typeof contentErrorProp === "string" ? { ...remainingContentProps, errorMessage: contentErrorProp } : remainingContentProps;
  }
};
var TenantTracker = class {
  static registerTenant(tenant, telemetryOptions) {
    this.getBrokerWrapper().registerTenant(tenant, telemetryOptions);
  }
  static getTenants() {
    return this.getBrokerWrapper().getTenants();
  }
  static getBrokerWrapper() {
    if (this.brokerWrapper) {
      return this.brokerWrapper;
    }
    this.brokerWrapper = BrokerWrapper.getInstance();
    return this.brokerWrapper;
  }
};
var rip_default = {
  "ap-isog-east-1": {
    websiteDomain: "csphome.adc-g.au",
    websiteDomainDualstack: "awshome.adc-g.au"
  },
  "ap-southeast-6": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-isof-south-1": {
    websiteDomain: "csphome.hci.ic.gov",
    websiteDomainDualstack: "awshome.hci.ic.gov"
  },
  "us-iso-west-1": {
    websiteDomain: "c2shome.ic.gov",
    websiteDomainDualstack: "awshome.ic.gov"
  },
  "eu-north-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "me-south-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "cn-north-1": {
    websiteDomain: "amazonaws.cn",
    websiteDomainDualstack: "amazonwebservices.cn"
  },
  "ap-southeast-7": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-south-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "eu-west-3": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-southeast-3": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-east-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "af-south-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-south-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-iso-east-1": {
    websiteDomain: "c2shome.ic.gov",
    websiteDomainDualstack: "awshome.ic.gov"
  },
  "eu-west-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "me-central-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-isob-west-1": {
    websiteDomain: "sc2shome.sgov.gov",
    websiteDomainDualstack: "awshome.scloud"
  },
  "eu-central-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "sa-east-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-east-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-south-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-east-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-northeast-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-northeast-3": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-southeast-5": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-isob-east-1": {
    websiteDomain: "sc2shome.sgov.gov",
    websiteDomainDualstack: "awshome.scloud"
  },
  "eu-west-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-isof-east-1": {
    websiteDomain: "csphome.hci.ic.gov",
    websiteDomainDualstack: "awshome.hci.ic.gov"
  },
  "us-northeast-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-southeast-4": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "eu-south-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "eu-isoe-west-1": {
    websiteDomain: "csphome.adc-e.uk",
    websiteDomainDualstack: "awshome.adc-e.uk"
  },
  "ap-northeast-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-gov-east-1": {
    websiteDomain: "amazonaws-us-gov.com",
    websiteDomainDualstack: "aws-us-gov.com"
  },
  "us-gov-west-1": {
    websiteDomain: "amazonaws-us-gov.com",
    websiteDomainDualstack: "aws-us-gov.com"
  },
  "us-west-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "mx-central-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "me-west-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "sa-west-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "us-west-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-southeast-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-southeast-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "eusc-de-east-1": {
    websiteDomain: "amazonaws-eusc.eu",
    websiteDomainDualstack: "aws.eu"
  },
  "il-central-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ap-east-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ca-central-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "ca-west-1": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "eu-south-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  },
  "cn-northwest-1": {
    websiteDomain: "amazonaws.cn",
    websiteDomainDualstack: "amazonwebservices.cn"
  },
  "eu-central-2": {
    websiteDomain: "aws.amazon.com",
    websiteDomainDualstack: "aws.com"
  }
};
function ripRegion(region) {
  return rip_default[region];
}
var MetaDataProvider = class _MetaDataProvider {
  constructor(dataParser) {
    this.dataParser = dataParser;
  }
  /*
   * Return MetaDataProvider instance for singleton class.
   */
  static getInstance() {
    if (!this.metaDataProviderInstance) {
      this.metaDataProviderInstance = new _MetaDataProvider(DataParser.getInstance());
    }
    return this.metaDataProviderInstance;
  }
  /**
   * Returns the base URL for a given asset ID
   *
   * @see https://hub.cx.aws.dev/build/how-to-guides/building-a-web-application-using-weblib-2/#_24-constructing-url-for-tangerinebox-cdn
   */
  getCdnUrl(assetId) {
    if (/^(http|https|ws|wss):\/\//.test(assetId)) {
      return assetId;
    }
    return `${this.dataParser.getMetaTagContent().cdn}${assetId}`;
  }
  /**
   * Returns a custom context value as specified in the console configuration.
   *
   * @see https://hub.cx.aws.dev/build/how-to-guides/building-a-web-application-using-weblib-2/#_21-providing-parameters-to-javascript
   */
  getCustomContext(key) {
    return this.dataParser.getMetaTagContent().custom[key];
  }
  /**
   * Returns the base URL for a given asset ID
   *
   * @see
   * https://hub.cx.aws.dev/build/how-to-guides/building-a-web-application-using-weblib-2/#_24-constructing-url-for-tangerinebox-cdn
   */
  getAssetUrl(key, assetPath) {
    const assetMainPath = this.getCustomContext(key) + `/${assetPath}`;
    return this.getCdnUrl(assetMainPath);
  }
  /**
   * Returns the console's telemetry token
   */
  getConsoleTelemetryToken() {
    return this.dataParser.getTelemetryMetaTagContent().telemetryToken;
  }
  /**
   * @returns sessionARN: Promise<string>
   */
  async getSessionARN() {
    return this.dataParser.getSessionDataValue("sessionARN");
  }
  /**
   * @returns accountId: Promise<string>
   */
  async getAccountId() {
    return this.dataParser.getSessionDataValue("accountId");
  }
  /**
   * @returns identityToken: Promise<string>
   */
  async getIdentityToken() {
    return this.dataParser.getSessionDataValue("identityToken");
  }
  /**
   * @returns sessionId: Promise<string>
   */
  async getSessionId() {
    return this.dataParser.getSessionDataValue("sessionId");
  }
  /**
   * This method provides the infrastructure region serving the page.
   *
   * @returns infrastructureRegion: Promise<string>
   */
  async getInfrastructureRegion() {
    return this.dataParser.getSessionDataValue("infrastructureRegion");
  }
  /**
   * This method provides the VPC if it exists.
   *
   * @returns vpc: Promise<VPC | undefined>
   */
  async getVpc() {
    return this.dataParser.getSessionDataValue("vpc");
  }
  /**
   * This method provides the accountAlias if it exists.
   *
   * @returns accountAlias: Promise<string | undefined>
   */
  async getAccountAlias() {
    return this.dataParser.getSessionDataValue("accountAlias");
  }
  /**
   * This method provides the displayName if it exists.
   *
   * @returns displayName: Promise<string | undefined>
   */
  async getDisplayName() {
    return this.dataParser.getSessionDataValue("displayName");
  }
  /**
   * This method provides the sessionDifferentiator if it exists.
   *
   * @returns sessionDifferentiator: Promise<string | undefined>
   */
  async getSessionDifferentiator() {
    return this.dataParser.getSessionDataValue("sessionDifferentiator");
  }
  /**
   * This method returns if multi session is enabled or not
   *
   * @returns isMultiSessionEnabled: Promise<boolean>
   */
  async isMultiSessionEnabled() {
    return !!await this.dataParser.getSessionDataValue("prismModeEnabled");
  }
  /**
   * Returns a custom service endpoint added via CDK with
   * `addCustomServiceEndpoint({key, ...args})`
   *
   */
  getCustomServiceEndpoint(key) {
    const endpoints = this.dataParser.getMetaTagContent().endpoints;
    return endpoints ? endpoints[`CUSTOM_${key}`] : void 0;
  }
  /**
   * Used to fetch standard endpoint for help panel. This function only returns a valid config
   * if you have added endpoints to your page in your cdk package using TangerineBoxCDKConstructs.
   *
   * @example
   * ```typescript
   * // CDK
   * page.addStandardEndpoint(StandardEndpoints.HelpPanel());
   *
   * // Frontend
   * const helpPanelEndpoint = metaDataProvider.getHelpPanelApiEndpoint();
   * if (helpPanelEndpoint) {
   *     // instantiate help panel widget with endpoint
   * }
   * ```
   *
   * Note: It is recommended to consume the Help Panel via the AWS-Widget-React-Wrappers package
   * This package will automatically handle the fallback logic required to support the new Private Access
   * Compliant domains.
   *
   * If you are not consuming the Help Panel from that package, you need to ensure your implementation
   * correctly supports falling back to the IPv4 domain (non console.api.aws) if a connection failure occurs.
   */
  getHelpPanelApiEndpoint() {
    const endpoints = this.dataParser.getMetaTagContent().endpoints || {};
    return endpoints.STANDARD_HelpPanelAPI;
  }
  getHelpPanelApiFallbackEndpoint() {
    const endpoints = this.dataParser.getMetaTagContent().endpoints || {};
    return endpoints.STANDARD_HelpPanelAPI_Fallback;
  }
  /**
   * @deprecated please use the TangerineBoxWebLib SdkClientProvider.getIamAdminStandardConfig() method instead.
   */
  getIamAdminStandardConfig() {
    const endpoints = this.dataParser.getMetaTagContent().endpoints || {};
    const iamAdminEndpoint = endpoints.STANDARD_iamadmin;
    const signingRegion = this.getCustomContext("STANDARD_iamadmin_signing_region");
    if (!iamAdminEndpoint || !signingRegion) {
      return void 0;
    }
    return {
      region: signingRegion,
      endpoint: iamAdminEndpoint
    };
  }
  /**
   * @deprecated please use the TangerineBoxWebLib SdkClientProvider.getUserPreferenceStandardConfig() method instead.
   */
  async getUserPreferenceServiceEndpoint() {
    const dualstackEnabledDomain = await this.dataParser.getSessionDataValue("dualstackEnabledDomain");
    const region = await this.getInfrastructureRegion();
    const regionConfig = ripRegion(region);
    const websiteDomain = dualstackEnabledDomain ? regionConfig.websiteDomainDualstack : regionConfig.websiteDomain;
    return `https://${region}.console.${websiteDomain}/p/pref/1`;
  }
  getDualstackEnabledDomain() {
    return this.dataParser.getSessionDataValue("dualstackEnabledDomain");
  }
  /**
   * Checks whether the account has a specific flag or property.
   *
   * Checks accountFlags first (from awsc-session-data meta tag), then falls
   * back to accountProperties for backward compatibility.
   *
   * @param flagName - The name of the account flag or property to check
   * @returns Whether the account has the specified flag/property
   */
  async hasAccountFlag(flagName) {
    const flags = await this.dataParser.getSessionDataValue("accountFlags");
    if ((flags === null || flags === void 0 ? void 0 : flags[flagName]) === "true") {
      return true;
    }
    const props = await this.dataParser.getSessionDataValue("accountProperties");
    return !!(props === null || props === void 0 ? void 0 : props[flagName]);
  }
  /**
   * Retrieves the value of a specific account property.
   *
   * @param propertyName - The name of the account property to retrieve
   * @returns The value of the property, or undefined if not present
   */
  async getAccountProperty(propertyName) {
    const props = await this.dataParser.getSessionDataValue("accountProperties");
    return props === null || props === void 0 ? void 0 : props[propertyName];
  }
  /**
   * Returns the IdC identity store for the current session, if available.
   *
   * @returns The session identity store containing userId and identityStoreId,
   *          or undefined if the session is not IdC-federated.
   */
  async getSessionIdentityStore() {
    return this.dataParser.getSessionDataValue("sessionIdentityStore");
  }
};
var TangerineBoxEventTrackerForLibrary = class _TangerineBoxEventTrackerForLibrary {
  constructor(scheduledEventTracker) {
    this.scheduledEventTracker = scheduledEventTracker;
  }
  /**
   * Returns a new EventTracker for Library instance for publishing logs and errors without AWS SDK.
   *
   * @see https://hub.cx.aws.dev/build/how-to-guides/building-a-web-application-using-weblib-2/#_22-capturing-aws-sdk-metrics-and-javascript-errors
   */
  static getInstance(trackerProps) {
    try {
      return new _TangerineBoxEventTrackerForLibrary(ScheduledEventTracker.getInstance(trackerProps));
    } catch {
      console.warn(TELEMETRY_CONFIG_MISSING_MSG);
      return new NoOpTrackerForLibrary();
    }
  }
  addEvent(content) {
    this.scheduledEventTracker.addEvent(content, {
      // Disable library sending public events
      publicEvent: false
    });
  }
  addError(error, content, options) {
    this.scheduledEventTracker.addError(error, content, options);
  }
  addFatalError(error, content, metadata, options) {
    this.scheduledEventTracker.addFatalError(error, content, metadata, options);
  }
  addFmsEvaluationEvent(event, content, options) {
    this.scheduledEventTracker.addFmsEvaluationEvent(event, content, options);
  }
  addAwsArachnidQueryEvent(event, content, options) {
    this.scheduledEventTracker.addAwsArachnidQueryEvent(event, content, options);
  }
  addAwsArachnidCredentialEvent(event, content, options) {
    this.scheduledEventTracker.addAwsArachnidCredentialEvent(event, content, options);
  }
  addAwsArachnidFallbackQueryEvent(event, content, options) {
    this.scheduledEventTracker.addAwsArachnidFallbackQueryEvent(event, content, options);
  }
  addJanusApiEvent(event, content, options) {
    this.scheduledEventTracker.addJanusApiEvent(event, content, options);
  }
  addJanusCredentialEvent(event, content, options) {
    this.scheduledEventTracker.addJanusCredentialEvent(event, content, options);
  }
  addLotusCspEvent(event, content, options) {
    this.scheduledEventTracker.addLotusCspEvent(event, content, options);
  }
  addLotusIsolatedIFrameEvent(event, content, options) {
    this.scheduledEventTracker.addLotusIsolatedIFrameEvent(event, content, options);
  }
  addLotusImportPackageEvent(event, content, options) {
    this.scheduledEventTracker.addLotusImportPackageEvent(event, content, options);
  }
  addModuleLifecycleEvent(event, content, options) {
    this.scheduledEventTracker.addModuleLifecycleEvent(event, content, options);
  }
  addModuleRegistryQueryModulesEvent(event, content, options) {
    this.scheduledEventTracker.addModuleRegistryQueryModulesEvent(event, content, options);
  }
  addCloudEditorEvent(event, content, options) {
    this.scheduledEventTracker.addCloudEditorEvent(event, content, options);
  }
  addCloudEditorLspEvent(event, content, options) {
    this.scheduledEventTracker.addCloudEditorLspEvent(event, content, options);
  }
  addPapiProxyEvent(event, content, options) {
    this.scheduledEventTracker.addPapiProxyEvent(event, content, options);
  }
  addPapiCredentialEvent(event, content, options) {
    this.scheduledEventTracker.addPapiCredentialEvent(event, content, options);
  }
  addBootstrapEvent(event, content, options) {
    this.scheduledEventTracker.addBootstrapEvent(event, content, options);
  }
};
var NoOpTrackerForLibrary = class {
  addEvent(_content, _options) {
  }
  addError(_error, _content, _options) {
  }
  addFatalError(_error, _content, _metadata, _options) {
  }
  addFmsEvaluationEvent(_event, _content, _options) {
  }
  addAwsArachnidQueryEvent(_event, _content, _options) {
  }
  addAwsArachnidCredentialEvent(_event, _content, _options) {
  }
  addAwsArachnidFallbackQueryEvent(_event, _content, _options) {
  }
  addJanusApiEvent(_event, _content, _options) {
  }
  addJanusCredentialEvent(_event, _content, _options) {
  }
  addLotusCspEvent(_event, _content, _options) {
  }
  addLotusIsolatedIFrameEvent(_event, _content, _options) {
  }
  addLotusImportPackageEvent(_event, _content, _options) {
  }
  addModuleLifecycleEvent(_event, _content, _options) {
  }
  addModuleRegistryQueryModulesEvent(_event, _content, _options) {
  }
  addCloudEditorEvent(_event, _content, _options) {
  }
  addCloudEditorLspEvent(_event, _content, _options) {
  }
  addPapiCredentialEvent(_event, _content, _options) {
  }
  addPapiProxyEvent(_event, _content, _options) {
  }
  addBootstrapEvent(_event, _content, _options) {
  }
};
var StorageScope = {
  ORIGIN: "origin"
  // uses Console Domain
};
var StoragePreference = {
  LOCAL_STORAGE: "localStorage",
  SESSION_STORAGE: "sessionStorage",
  INDEXED_DB: "indexedDB"
};
var SUPPORTED_REGIONS = [
  "ap-southeast-6",
  "us-isof-south-1",
  "us-iso-west-1",
  "eu-north-1",
  "me-south-1",
  "cn-north-1",
  "ap-southeast-7",
  "ap-south-1",
  "eu-west-3",
  "ap-southeast-3",
  "us-east-2",
  "af-south-1",
  "us-iso-east-1",
  "eu-west-1",
  "me-central-1",
  "us-isob-west-1",
  "eu-central-1",
  "sa-east-1",
  "ap-east-1",
  "ap-south-2",
  "us-east-1",
  "ap-northeast-2",
  "ap-northeast-3",
  "ap-southeast-5",
  "us-isob-east-1",
  "eu-west-2",
  "us-isof-east-1",
  "us-northeast-1",
  "ap-southeast-4",
  "eu-south-1",
  "eu-isoe-west-1",
  "ap-northeast-1",
  "us-gov-east-1",
  "us-gov-west-1",
  "us-west-2",
  "mx-central-1",
  "us-west-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "eusc-de-east-1",
  "il-central-1",
  "ap-east-2",
  "ca-central-1",
  "ca-west-1",
  "eu-south-2",
  "cn-northwest-1",
  "eu-central-2"
];
var REGIONAL_FEATURES = {
  "ap-southeast-6": { composite_alarm_creation: true, encryption: true },
  "us-isof-south-1": { composite_alarm_creation: false, encryption: false },
  "us-iso-west-1": { composite_alarm_creation: false, encryption: false },
  "eu-north-1": { composite_alarm_creation: true, encryption: true },
  "me-south-1": { composite_alarm_creation: true, encryption: true },
  "cn-north-1": { composite_alarm_creation: true, encryption: true },
  "ap-southeast-7": { composite_alarm_creation: true, encryption: true },
  "ap-south-1": { composite_alarm_creation: true, encryption: true },
  "eu-west-3": { composite_alarm_creation: true, encryption: true },
  "ap-southeast-3": { composite_alarm_creation: true, encryption: true },
  "us-east-2": { composite_alarm_creation: true, encryption: true },
  "af-south-1": { composite_alarm_creation: true, encryption: true },
  "us-iso-east-1": { composite_alarm_creation: false, encryption: false },
  "eu-west-1": { composite_alarm_creation: true, encryption: true },
  "me-central-1": { composite_alarm_creation: true, encryption: true },
  "us-isob-west-1": { composite_alarm_creation: false, encryption: false },
  "eu-central-1": { composite_alarm_creation: true, encryption: true },
  "sa-east-1": { composite_alarm_creation: true, encryption: true },
  "ap-east-1": { composite_alarm_creation: true, encryption: true },
  "ap-south-2": { composite_alarm_creation: true, encryption: true },
  "us-east-1": { composite_alarm_creation: true, encryption: true },
  "ap-northeast-2": { composite_alarm_creation: true, encryption: true },
  "ap-northeast-3": { composite_alarm_creation: true, encryption: true },
  "ap-southeast-5": { composite_alarm_creation: true, encryption: true },
  "us-isob-east-1": { composite_alarm_creation: false, encryption: false },
  "eu-west-2": { composite_alarm_creation: true, encryption: true },
  "us-isof-east-1": { composite_alarm_creation: false, encryption: false },
  "us-northeast-1": { composite_alarm_creation: true, encryption: true },
  "ap-southeast-4": { composite_alarm_creation: true, encryption: true },
  "eu-south-1": { composite_alarm_creation: true, encryption: true },
  "eu-isoe-west-1": { composite_alarm_creation: false, encryption: false },
  "ap-northeast-1": { composite_alarm_creation: true, encryption: true },
  "us-gov-east-1": { composite_alarm_creation: true, encryption: true },
  "us-gov-west-1": { composite_alarm_creation: true, encryption: true },
  "us-west-2": { composite_alarm_creation: true, encryption: true },
  "mx-central-1": { composite_alarm_creation: true, encryption: true },
  "us-west-1": { composite_alarm_creation: true, encryption: true },
  "ap-southeast-1": { composite_alarm_creation: true, encryption: true },
  "ap-southeast-2": { composite_alarm_creation: true, encryption: true },
  "eusc-de-east-1": { composite_alarm_creation: false, encryption: false },
  "il-central-1": { composite_alarm_creation: true, encryption: true },
  "ap-east-2": { composite_alarm_creation: true, encryption: true },
  "ca-central-1": { composite_alarm_creation: true, encryption: true },
  "ca-west-1": { composite_alarm_creation: true, encryption: true },
  "eu-south-2": { composite_alarm_creation: true, encryption: true },
  "cn-northwest-1": { composite_alarm_creation: true, encryption: true },
  "eu-central-2": { composite_alarm_creation: true, encryption: true }
};
var CONTINUUM_FEATURES = {
  ENCRYPTION: "encryption"
};
function isFeatureEnabled(featureName, region) {
  var _a3;
  return ((_a3 = REGIONAL_FEATURES[region]) == null ? void 0 : _a3[featureName]) === true;
}
function isEncryptionSupported(region) {
  return isFeatureEnabled(CONTINUUM_FEATURES.ENCRYPTION, region);
}
function isContinuumAvailable(region) {
  return SUPPORTED_REGIONS.includes(region);
}
var ExternalCspAssetName;
(function(ExternalCspAssetName2) {
  ExternalCspAssetName2["WebWorker"] = "worker.js";
  ExternalCspAssetName2["IFrame"] = "iFrame.html";
})(ExternalCspAssetName || (ExternalCspAssetName = {}));
var ErrorType;
(function(ErrorType3) {
  ErrorType3["FailedFetch"] = "FAILED_FETCH";
  ErrorType3["InvalidRequest"] = "INVALID_REQUEST";
  ErrorType3["FailedCsp"] = "FAILED_CSP";
})(ErrorType || (ErrorType = {}));
var PackageMetadataRequestQueryParams;
(function(PackageMetadataRequestQueryParams2) {
  PackageMetadataRequestQueryParams2["PackageName"] = "packageName";
  PackageMetadataRequestQueryParams2["MajorVersion"] = "majorVersion";
  PackageMetadataRequestQueryParams2["AliasName"] = "aliasName";
  PackageMetadataRequestQueryParams2["AccountId"] = "accountId";
  PackageMetadataRequestQueryParams2["Region"] = "region";
  PackageMetadataRequestQueryParams2["CacheInvalidator"] = "cacheInvalidator";
  PackageMetadataRequestQueryParams2["SucceedOnRetry"] = "succeedOnRetry";
  PackageMetadataRequestQueryParams2["TrafficCategory"] = "trafficCategory";
})(PackageMetadataRequestQueryParams || (PackageMetadataRequestQueryParams = {}));
var IsolatedIFrameRequestQueryParams;
(function(IsolatedIFrameRequestQueryParams2) {
  IsolatedIFrameRequestQueryParams2["PackageName"] = "packageName";
  IsolatedIFrameRequestQueryParams2["MajorVersion"] = "majorVersion";
  IsolatedIFrameRequestQueryParams2["AliasName"] = "aliasName";
  IsolatedIFrameRequestQueryParams2["AccountId"] = "accountId";
  IsolatedIFrameRequestQueryParams2["SessionDifferentiator"] = "sessionDifferentiator";
  IsolatedIFrameRequestQueryParams2["ConsoleRegion"] = "consoleRegion";
  IsolatedIFrameRequestQueryParams2["UnifiedConsoleLoaderPackageName"] = "unifiedConsoleLoaderPackageName";
  IsolatedIFrameRequestQueryParams2["ParentOrigin"] = "parentOrigin";
  IsolatedIFrameRequestQueryParams2["LayoutBackgroundColorToken"] = "layoutBackgroundColorToken";
  IsolatedIFrameRequestQueryParams2["AwsUiVisualRefresh"] = "awsuiVisualRefresh";
  IsolatedIFrameRequestQueryParams2["Modal"] = "modal";
  IsolatedIFrameRequestQueryParams2["TrafficCategory"] = "trafficCategory";
})(IsolatedIFrameRequestQueryParams || (IsolatedIFrameRequestQueryParams = {}));
var TBT_SINK_TYPE = "DEFAULT_WIDGET_2023_04_19";
var TelemetryTokenCreator = class {
  /**
   * Generate a Telemetry token using Lotus package name by hashing service principal, telemetry sink name, and sink type values.
   */
  static async createTenantToken(packageName) {
    const { servicePrincipal, telemetrySinkName } = this.generateTangerineBoxTelemetryBoxTokenResources(packageName);
    const base = `${servicePrincipal}-${telemetrySinkName}-${TBT_SINK_TYPE}`;
    const hash = await this.hash(base);
    return `${this.getPrefix()}${hash}`;
  }
  static getPrefix() {
    return "v1/";
  }
  /**
   * Generate the recommended values to use for servicePrincipal and telemetrySinkName during creation of a
   * TangerineBox Telemetry Sink for a UCAF module or Standalone experience.
   * @param packageName Lotus package name
   * @returns servicePrincipal and telemetrySinkName
   */
  static generateTangerineBoxTelemetryBoxTokenResources(packageName) {
    const telemetrySinkName = packageName.replace("@amzn/", "").toLowerCase();
    const servicePrincipal = `prod.telemetry.${telemetrySinkName}.aws.internal`;
    return {
      servicePrincipal,
      telemetrySinkName
    };
  }
  static async hash(message) {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
    return hashHex;
  }
};
var AWT_TELEMETRY_SINK_ID = "v1/38ab1eac59303aa74f95dc67b661869747f928f1e58cde3ff57f15806b4db643";
var Logger = class {
  constructor() {
    __publicField(this, "startTime");
    __publicField(this, "getElapsedTime", () => performance.now() - this.startTime);
  }
  /**
   * Initializes startTime which is used in getElapsedTime() to get elapsed time
   * @returns {number}
   */
  startTimer() {
    this.startTime = performance.now();
    return this.startTime;
  }
  /**
   * @returns TBT Event Tracker for lotus internal account, lotus package producer, and consumer logs
   */
  async getTBTEventTracker({ packageName, telemetryToken, parentTelemetryTokens = [] }) {
    const lotusPackageProducerToken = telemetryToken || await TelemetryTokenCreator.createTenantToken(packageName);
    const tokensForPublicEvents = [lotusPackageProducerToken, ...parentTelemetryTokens];
    return TangerineBoxEventTrackerForLibrary.getInstance({
      token: AWT_TELEMETRY_SINK_ID,
      tokensForPublicEvents
    });
  }
};
var regionPartitionMap = { "us-isof-south-1": "aws-iso-f", "us-iso-west-1": "aws-iso", "cn-north-1": "aws-cn", "us-iso-east-1": "aws-iso", "us-isob-west-1": "aws-iso-b", "us-isob-east-1": "aws-iso-b", "us-isof-east-1": "aws-iso-f", "eu-isoe-west-1": "aws-iso-e", "us-gov-east-1": "aws-us-gov", "us-gov-west-1": "aws-us-gov", "eusc-de-east-1": "aws-eusc", "cn-northwest-1": "aws-cn" };
var Partition;
(function(Partition2) {
  Partition2["Aws"] = "aws";
  Partition2["AwsCn"] = "aws-cn";
  Partition2["AwsUsGov"] = "aws-us-gov";
  Partition2["AwsIso"] = "aws-iso";
  Partition2["AwsIsoB"] = "aws-iso-b";
  Partition2["AwsIsoE"] = "aws-iso-e";
  Partition2["AwsIsoF"] = "aws-iso-f";
  Partition2["AwsEusc"] = "aws-eusc";
})(Partition || (Partition = {}));
var PARTITION_INFO = {
  [Partition.Aws]: {
    rootDomain: "amazon.com",
    defaultRegion: "us-east-1",
    regionlessSubDomain: "console.aws",
    globalSubDomain: "global.console.aws",
    dualstackRootDomain: "aws.com",
    // eslint-disable-next-line @amzn/awt-build-tools-internal/no-restricted-terms
    dualstackGlobalSubDomain: "lotus.widget.console"
  },
  [Partition.AwsCn]: {
    rootDomain: "amazonaws.cn",
    defaultRegion: "cn-north-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "amazonwebservices.cn"
  },
  [Partition.AwsUsGov]: {
    rootDomain: "amazonaws-us-gov.com",
    defaultRegion: "us-gov-west-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "aws-us-gov.com"
  },
  [Partition.AwsIso]: {
    rootDomain: "c2shome.ic.gov",
    defaultRegion: "us-iso-east-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "awshome.ic.gov"
  },
  [Partition.AwsIsoB]: {
    rootDomain: "sc2shome.sgov.gov",
    defaultRegion: "us-isob-east-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "awshome.scloud"
  },
  [Partition.AwsIsoE]: {
    rootDomain: "csphome.adc-e.uk",
    defaultRegion: "eu-isoe-west-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "awshome.adc-e.uk"
  },
  [Partition.AwsIsoF]: {
    rootDomain: "csphome.hci.ic.gov",
    defaultRegion: "us-isof-south-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "awshome.hci.ic.gov"
  },
  [Partition.AwsEusc]: {
    rootDomain: "amazonaws-eusc.eu",
    defaultRegion: "eusc-de-east-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "aws.eu"
  }
};
var AWSC_MEZZ_REGION_ID = "awsc-mezz-region";
async function getCurrentRegion() {
  const mezzRegionElement = document.getElementById(AWSC_MEZZ_REGION_ID);
  let region = mezzRegionElement == null ? void 0 : mezzRegionElement.getAttribute("content");
  if (!mezzRegionElement) {
    try {
      const topWindowMezzRegionElement = window.top.document.getElementById(AWSC_MEZZ_REGION_ID);
      region = topWindowMezzRegionElement == null ? void 0 : topWindowMezzRegionElement.getAttribute("content");
    } catch {
    }
  }
  if (region) {
    return region;
  }
  try {
    const metaDataProvider = MetaDataProvider.getInstance();
    const infrastructureRegion = await metaDataProvider.getInfrastructureRegion();
    if (infrastructureRegion) {
      return infrastructureRegion;
    }
  } catch (error) {
    console.warn("Lotus: TangerineBox MetaDataProvider.getInfrastructureRegion failed.", error);
  }
  console.warn("Lotus: awsc-mezz-region element is not available. Falling back to default region");
  for (const partitionInfo of Object.values(PARTITION_INFO)) {
    if (window.location.host.includes(partitionInfo.rootDomain)) {
      return partitionInfo.defaultRegion;
    }
  }
  return "us-east-1";
}
function getLotusHost(region) {
  const partition = regionPartitionMap[region] || Partition.Aws;
  const partitionInfo = PARTITION_INFO[partition];
  if (partitionInfo.globalSubDomain) {
    return `${PARTITION_INFO[partition].globalSubDomain}.${PARTITION_INFO[partition].rootDomain}`;
  }
  return `${region}.${PARTITION_INFO[partition].regionlessSubDomain}.${PARTITION_INFO[partition].rootDomain}`;
}
function getLotusDualstackHost(region) {
  const partition = regionPartitionMap[region] || Partition.Aws;
  const partitionInfo = PARTITION_INFO[partition];
  if (partitionInfo.dualstackGlobalSubDomain) {
    return `${PARTITION_INFO[partition].dualstackGlobalSubDomain}.${PARTITION_INFO[partition].dualstackRootDomain}`;
  }
  return `${region}.${PARTITION_INFO[partition].regionlessSubDomain}.${PARTITION_INFO[partition].dualstackRootDomain}`;
}
var getPackageMajorVersion = (packageName, majorVersion) => `${packageName}@${majorVersion}`;
var ImportPackageErrorCode = {
  InvalidPackageMetadata: "InvalidPackageMetadata",
  ResourceImportFailed: "ResourceImportFailed",
  GetPackageMetadataFailed: "GetPackageMetadataFailed",
  Unknown: "Unknown"
};
var createSucceededResult = (succeededData = /* @__PURE__ */ Object.create(null)) => ({
  succeeded: true,
  ...succeededData
});
var createFailedResult = (error) => ({
  succeeded: false,
  error
});
var exponentialBackoff = (attemptIndex, delayInMs) => {
  const delay = Math.random() * 2 ** attemptIndex * delayInMs;
  return new Promise((resolve) => setTimeout(resolve, delay));
};
var HtmlTag = {
  Script: "script",
  Link: "link"
};
var TagAppendLocation = {
  [HtmlTag.Link]: "head",
  [HtmlTag.Script]: "body"
};
var parseCookiesString = (cookieString) => {
  const allCookies = document.cookie.length > 0 ? cookieString.split(";") : [];
  const len = allCookies.length;
  const parsedCookiesMap = {};
  for (let i = 0; i < len; i++) {
    const cookieParts = allCookies[i].split("=");
    const cookieName = cookieParts[0].trim();
    const cookieValue = cookieParts[1];
    parsedCookiesMap[cookieName] = { raw: cookieValue };
  }
  return {
    getCookie: (cookieName) => {
      const entry = parsedCookiesMap[cookieName];
      if (!entry) {
        return null;
      }
      let unescapedValue = entry.unescaped;
      if (unescapedValue === void 0) {
        const rawValue = entry.raw;
        unescapedValue = entry.unescaped = unescape(rawValue.trim());
      }
      return unescapedValue;
    }
  };
};
var getCookie = (cookieName) => {
  const cookiesString = document.cookie;
  const parsedCookies = parseCookiesString(cookiesString);
  return parsedCookies.getCookie(cookieName);
};
var cachedValues = {};
var getCookieCached = (cookieName) => {
  let cachedValue = cachedValues[cookieName];
  if (cachedValue === void 0) {
    cachedValue = cachedValues[cookieName] = getCookie(cookieName) || null;
  }
  return cachedValue;
};
function getMetaTagContent(metaTagName) {
  var _a3;
  try {
    const selector = `meta[name='${metaTagName}']`;
    let element = document.querySelector(selector);
    if (!element) {
      element = (_a3 = window.top) == null ? void 0 : _a3.document.querySelector(selector);
    }
    return element == null ? void 0 : element.content;
  } catch (e) {
    return void 0;
  }
}
function parseMetaTag(metaTagName) {
  const content = getMetaTagContent(metaTagName);
  if (content) {
    return JSON.parse(content);
  } else {
    throw new Error(`failed to parse meta tag ${metaTagName}`);
  }
}
var regions_default = {
  "regions": {
    "ap-southeast-6": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-isof-south-1": {
      "websiteDomain": "csphome.hci.ic.gov",
      "websiteDomainDualstack": "awshome.hci.ic.gov",
      "devDomain": "aws-dev.csphome.hci.ic.gov"
    },
    "us-iso-west-1": {
      "websiteDomain": "c2shome.ic.gov",
      "websiteDomainDualstack": "awshome.ic.gov",
      "devDomain": "aws-dev.c2shome.ic.gov"
    },
    "eu-north-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "me-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "cn-north-1": {
      "websiteDomain": "amazonaws.cn",
      "websiteDomainDualstack": "amazonwebservices.cn",
      "devDomain": "aws-dev.amazonaws.cn"
    },
    "ap-southeast-7": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "eu-west-3": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-southeast-3": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-east-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "af-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-iso-east-1": {
      "websiteDomain": "c2shome.ic.gov",
      "websiteDomainDualstack": "awshome.ic.gov",
      "devDomain": "aws-dev.c2shome.ic.gov"
    },
    "eu-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "me-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-isob-west-1": {
      "websiteDomain": "sc2shome.sgov.gov",
      "websiteDomainDualstack": "awshome.scloud",
      "devDomain": "aws-dev.sc2shome.sgov.gov"
    },
    "eu-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "sa-east-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-east-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-south-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-east-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-northeast-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-northeast-3": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-southeast-5": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-isob-east-1": {
      "websiteDomain": "sc2shome.sgov.gov",
      "websiteDomainDualstack": "awshome.scloud",
      "devDomain": "aws-dev.sc2shome.sgov.gov"
    },
    "eu-west-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-isof-east-1": {
      "websiteDomain": "csphome.hci.ic.gov",
      "websiteDomainDualstack": "awshome.hci.ic.gov",
      "devDomain": "aws-dev.csphome.hci.ic.gov"
    },
    "us-northeast-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-southeast-4": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "eu-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "eu-isoe-west-1": {
      "websiteDomain": "csphome.adc-e.uk",
      "websiteDomainDualstack": "awshome.adc-e.uk",
      "devDomain": "aws-dev.csphome.adc-e.uk"
    },
    "ap-northeast-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-gov-east-1": {
      "websiteDomain": "amazonaws-us-gov.com",
      "websiteDomainDualstack": "aws-us-gov.com",
      "devDomain": "aws-dev.amazonaws-us-gov.com"
    },
    "us-gov-west-1": {
      "websiteDomain": "amazonaws-us-gov.com",
      "websiteDomainDualstack": "aws-us-gov.com",
      "devDomain": "aws-dev.amazonaws-us-gov.com"
    },
    "us-west-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "mx-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "me-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "sa-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "us-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-southeast-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-southeast-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "eusc-de-east-1": {
      "websiteDomain": "amazonaws-eusc.eu",
      "websiteDomainDualstack": "aws.eu",
      "devDomain": "aws-dev.amazonaws-eusc.eu"
    },
    "il-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ap-east-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ca-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "ca-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "eu-south-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    },
    "cn-northwest-1": {
      "websiteDomain": "amazonaws.cn",
      "websiteDomainDualstack": "amazonwebservices.cn",
      "devDomain": "aws-dev.amazonaws.cn"
    },
    "eu-central-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com",
      "devDomain": "aws-dev.amazon.com"
    }
  }
};
var SESSION_DATA_NAME_ATTRIBUTE = "awsc-session-data";
var MEZZ_REGION_NAME_ATTRIBUTE = "awsc-mezz-region";
var sessionDataTemplate = {
  accountId: void 0,
  sessionARN: void 0,
  sessionId: void 0,
  sessionDifferentiator: void 0,
  identityToken: void 0,
  accountAlias: void 0,
  displayName: void 0,
  infrastructureRegion: void 0,
  vpc: {
    vpcId: void 0,
    vpceId: void 0
  },
  prismModeEnabled: void 0,
  dualstackEnabledDomain: void 0,
  websiteDomainDualstack: void 0
};
function validateSessionDataFields(data, fields) {
  if (!data) {
    throw new Error("SessionData object is null or undefined");
  }
  const missingFieldsInSessionData = [];
  fields.forEach((sessionDataField) => {
    if (sessionDataField === "sessionDifferentiator" && !data.prismModeEnabled) {
      return;
    }
    if (sessionDataField === "websiteDomainDualstack" && !data.dualstackEnabledDomain) {
      return;
    }
    if (data[sessionDataField] == null) {
      missingFieldsInSessionData.push(sessionDataField);
    }
  });
  if (missingFieldsInSessionData.length) {
    const message = JSON.stringify({ missingFieldsInSessionData });
    throw new Error(message);
  }
  return true;
}
var _SessionDataParser = class _SessionDataParser2 {
  constructor() {
    __publicField(this, "sessionDataCache");
    this.sessionDataCache = this.parseSessionDataMetaTag();
  }
  /*
   * Return SessionDataProvider instance for singleton class.
   */
  static getInstance() {
    if (!this.sessionDataParserInstance) {
      this.sessionDataParserInstance = new _SessionDataParser2();
    }
    return this.sessionDataParserInstance;
  }
  /**
   * Validate an object to see if it contains the required keys for session data
   *
   * @param {any} data - an object that needs to be validated
   * @throws
   * @returns void
   */
  static validateSessionData(data) {
    validateSessionDataFields(data, [
      "sessionARN",
      "identityToken",
      "accountId",
      "infrastructureRegion",
      "sessionDifferentiator",
      "dualstackEnabledDomain",
      "websiteDomainDualstack"
    ]);
  }
  /**
   * Validate the session data in {@link SessionDataParser}
   *
   * @throws
   * @returns void
   */
  validateSessionData() {
    _SessionDataParser2.validateSessionData(this.sessionDataCache);
  }
  getSessionData() {
    if (this.sessionDataCache) {
      return this.sessionDataCache;
    }
    return this.parseSessionDataMetaTag();
  }
  /*
   * This is a stubbed version where we read account properties, account flags,
   * and session identity store from the cookie.
   */
  stubAccountAndIdentityFlagsAndProperties() {
    const cookieValue = getCookieCached("aws-mock-identity-data");
    if (!cookieValue) {
      return {};
    }
    try {
      const { accountProperties, accountFlags, sessionIdentityStore } = JSON.parse(cookieValue);
      const result = {};
      if (accountProperties) {
        result.accountProperties = accountProperties;
      }
      if (accountFlags) {
        result.accountFlags = accountFlags;
      }
      if (sessionIdentityStore) {
        result.sessionIdentityStore = sessionIdentityStore;
      }
      return result;
    } catch (e) {
      return {};
    }
  }
  parseSessionDataMetaTag() {
    let sessionData;
    let legacySessionData;
    try {
      sessionData = parseMetaTag(SESSION_DATA_NAME_ATTRIBUTE);
      if (!validateSessionDataFields(sessionData, [
        "sessionARN",
        "identityToken",
        "accountId",
        "infrastructureRegion",
        "sessionDifferentiator"
      ])) {
        legacySessionData = this.parseSessionDataLegacy();
      }
    } catch (error) {
      console.log(error);
      try {
        legacySessionData = this.parseSessionDataLegacy();
      } catch (e) {
      }
    }
    const region = (sessionData == null ? void 0 : sessionData.infrastructureRegion) || (legacySessionData == null ? void 0 : legacySessionData.infrastructureRegion);
    const stubbedIdentityData = this.stubAccountAndIdentityFlagsAndProperties();
    return {
      ...sessionDataTemplate,
      // ensure that all fields from session data template are returned, even if undefined
      // resolve missing session data fields (if any) from legacy session data
      ...this.getDualstackDomainData(region),
      ...legacySessionData,
      ...sessionData,
      ...stubbedIdentityData
    };
  }
  decryptUserInfoSignedCookie(userinfoSignedValue) {
    try {
      const encodedUserInfoValue = userinfoSignedValue.split(".")[1];
      const decodedUserInfoValue = atob(encodedUserInfoValue);
      return JSON.parse(decodedUserInfoValue);
    } catch (e) {
      console.warn("Unable to decrypt userInfoSigned cookie");
      return "";
    }
  }
  getSessionDataFromUserInfoCookie() {
    var _a3, _b;
    const cookieValue = getCookieCached("aws-userInfo");
    const cookieValueUserinfoSigned = getCookieCached("aws-userInfo-signed");
    const ARN_REGEX = /arn:([^:]*):([^:]*):([^:]*):([^:]*):([^:]*)/;
    if (cookieValue && cookieValueUserinfoSigned) {
      const { arn, alias, username } = JSON.parse(cookieValue);
      const match = ARN_REGEX.exec(arn);
      return {
        accountId: match ? match[4] : "",
        sessionARN: arn,
        accountAlias: alias,
        displayName: username,
        identityToken: cookieValueUserinfoSigned,
        sessionDifferentiator: (_b = (_a3 = this.decryptUserInfoSignedCookie(cookieValueUserinfoSigned)) == null ? void 0 : _a3.sessionDiff) != null ? _b : void 0
      };
    }
    throw new Error("No userinfo or userinfo-signed cookie found!");
  }
  getInfrastructureRegionFromMezzanineMetaTag() {
    return getMetaTagContent(MEZZ_REGION_NAME_ATTRIBUTE);
  }
  parseSessionDataLegacy() {
    try {
      return {
        ...this.getSessionDataFromUserInfoCookie(),
        infrastructureRegion: this.getInfrastructureRegionFromMezzanineMetaTag()
      };
    } catch (error) {
      console.warn("Unable to parse the data using legacy methods");
      throw error;
    }
  }
  getDualstackDomainData(region) {
    const ultimateFallbackData = {
      dualstackEnabledDomain: void 0,
      websiteDomainDualstack: void 0
    };
    if (!region || !Object.keys(regions_default.regions).includes(region)) {
      console.error("Couldn't determine console domain and dual-stack values.");
      return ultimateFallbackData;
    }
    const ripRegion2 = regions_default.regions[region];
    const { websiteDomain, websiteDomainDualstack } = ripRegion2;
    const { hostname } = window.location;
    if (!websiteDomainDualstack) {
      return {
        dualstackEnabledDomain: false,
        websiteDomainDualstack: websiteDomain
      };
    }
    let dualstackEnabledDomain;
    if (hostname.endsWith(`.${websiteDomainDualstack}`)) {
      dualstackEnabledDomain = true;
    } else if (hostname.endsWith(`.${websiteDomain}`)) {
      dualstackEnabledDomain = false;
    }
    return {
      dualstackEnabledDomain,
      websiteDomainDualstack: dualstackEnabledDomain ? websiteDomainDualstack : void 0
    };
  }
};
__publicField(_SessionDataParser, "sessionDataParserInstance");
var SessionDataParser = _SessionDataParser;
var { regions } = regions_default;
var isUserOptedIntoPrism = () => {
  const PRISM_OPT_IN_COOKIE = "aws-prism-opt-in";
  const isOptedIntoPrism = getCookie(PRISM_OPT_IN_COOKIE) || "";
  return !!isOptedIntoPrism && isOptedIntoPrism === "true";
};
var _SessionDataProvider = class _SessionDataProvider2 {
  constructor(instance) {
    __publicField(this, "dataParser");
    this.dataParser = instance;
  }
  /*
   * Return SessionDataProvider instance for singleton class.
   */
  static getInstance() {
    if (!this.sessionDataProviderInstance) {
      this.sessionDataProviderInstance = new _SessionDataProvider2(SessionDataParser.getInstance());
    }
    return this.sessionDataProviderInstance;
  }
  /**
   * @returns sessionARN: Promise<string>
   * returns empty string when falsy
   */
  async getSessionARN() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionARN"] || "";
  }
  /**
   * Checks whether the account has a specific flag or property.
   *
   * Checks accountFlags first (from awsc-session-data meta tag), then falls
   * back to accountProperties (from mock cookie or meta tag) for backward
   * compatibility with existing callers using property names.
   *
   * @param flagName - The name of the account flag or property to check
   * @returns Whether the account has the specified flag/property
   */
  async hasAccountFlag(flagName) {
    var _a3, _b;
    const sessionData = this.dataParser.getSessionData();
    return ((_a3 = sessionData.accountFlags) == null ? void 0 : _a3[flagName]) === "true" || !!((_b = sessionData.accountProperties) == null ? void 0 : _b[flagName]);
  }
  /**
   * Retrieves the value of a specific account property.
   *
   * @param propertyName - The name of the account property to retrieve
   * @returns The value of the property, or undefined if not present
   */
  async getAccountProperty(propertyName) {
    const sessionData = this.dataParser.getSessionData();
    const { accountProperties } = sessionData;
    if (!accountProperties) {
      return void 0;
    }
    return accountProperties[propertyName];
  }
  /**
   * @returns accountId: Promise<string>
   * returns empty string when falsy
   */
  async getAccountId() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["accountId"] || "";
  }
  /**
   * @returns identityToken: Promise<string>
   * returns empty string when falsy
   */
  async getIdentityToken() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["identityToken"] || "";
  }
  /**
   * @returns sessionId: Promise<string | undefined>
   */
  async getSessionId() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionId"];
  }
  /**
   * This method provides the region the page is served from.
   * returns empty string when falsy
   * @returns region: Promise<string>
   */
  async getInfrastructureRegion() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["infrastructureRegion"] || "";
  }
  /**
   * This method provides the VPC if it exists.
   *
   * @returns vpc: Promise<VPC | undefined>
   */
  async getVpc() {
    const sessionData = this.dataParser.getSessionData();
    let result;
    if (sessionData) {
      result = sessionData["vpc"];
    }
    return result;
  }
  /**
   * This method provides the accountAlias if it exists.
   *
   * @returns accountAlias: Promise<string | undefined>
   */
  async getAccountAlias() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["accountAlias"];
  }
  /**
   * This method provides the displayName if it exists.
   *
   * @returns displayName: Promise<string | undefined>
   */
  async getDisplayName() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["displayName"];
  }
  /**
   * This method provides the sessionDifferentiator if it exists.
   *
   * @returns sessionDifferentiator: Promise<string | undefined>
   */
  async getSessionDifferentiator() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionDifferentiator"];
  }
  /**
   * This method provides an object with current session information and some of the fields are optional
   * and may not be always present. If you only care about getting individual properties, use the respective function such as
   * getAccountId
   * @returns SessionData
   */
  async getSessionData() {
    const sessionData = this.dataParser.getSessionData();
    if (!sessionData["prismModeEnabled"]) {
      sessionData.prismModeEnabled = isUserOptedIntoPrism();
    }
    return sessionData;
  }
  /**
   * This method provides the state of prismModeEnabled if it exists
   *
   * @returns isMultiSessionEnabled: Promise<boolean | undefined>
   */
  async isMultiSessionEnabled() {
    const sessionData = this.dataParser.getSessionData();
    if (!sessionData["prismModeEnabled"]) {
      return isUserOptedIntoPrism();
    }
    return sessionData["prismModeEnabled"];
  }
  async getSessionIdentityStore() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionIdentityStore"];
  }
};
__publicField(_SessionDataProvider, "sessionDataProviderInstance");
__publicField(_SessionDataProvider, "isValidSessionData", (maybeSessionData) => {
  try {
    SessionDataParser.validateSessionData(maybeSessionData);
    return true;
  } catch (err) {
    return false;
  }
});
__publicField(_SessionDataProvider, "validateSessionData", (maybeSessionData) => {
  SessionDataParser.validateSessionData(maybeSessionData);
  return true;
});
var SessionDataProvider = _SessionDataProvider;
var SessionStorageKey = {
  PackageMetadataRequestConfig: "lotusPackageMetadataRequestConfig",
  PackageMetadataResponse: "lotusPackageMetadataResponse"
};
var getMetadataInfoFromStorage = (key, packageAttributes) => {
  const { packageName, majorVersion } = packageAttributes;
  try {
    const rawMetadataInfoMapping = sessionStorage.getItem(key);
    if (rawMetadataInfoMapping) {
      const metadataInfo = JSON.parse(rawMetadataInfoMapping)[getPackageMajorVersion(packageName, majorVersion)];
      if (typeof metadataInfo === "object") {
        return metadataInfo;
      }
    }
  } catch {
  }
};
var getPackageMetadataRequestConfigFromStorage = (packageAttributes) => getMetadataInfoFromStorage(SessionStorageKey.PackageMetadataRequestConfig, packageAttributes);
var getPackageMetadataResponseFromStorage = (packageAttributes) => {
  var _a3, _b;
  const { packageName, majorVersion } = packageAttributes;
  const packageMajorVersion = getPackageMajorVersion(packageName, majorVersion);
  const metadataResponse = getMetadataInfoFromStorage(SessionStorageKey.PackageMetadataResponse, packageAttributes);
  if (metadataResponse) {
    if (!metadataResponse.basePath) {
      return createFailedResult({
        code: ImportPackageErrorCode.InvalidPackageMetadata,
        message: `No base path found in metadata response for "${packageMajorVersion}" retrieved from session storage`
      });
    }
    const metadata = metadataResponse == null ? void 0 : metadataResponse.metadata;
    if (!((_a3 = metadata == null ? void 0 : metadata.module) == null ? void 0 : _a3.path) && !((_b = metadata == null ? void 0 : metadata.assets) == null ? void 0 : _b.length)) {
      return createFailedResult({
        code: ImportPackageErrorCode.InvalidPackageMetadata,
        message: `Neither entry script nor asset found in metadata response for "${packageMajorVersion}" retrieved from session storage`
      });
    }
  }
  return createSucceededResult({ metadataResponse });
};
var MetadataLogger = class extends Logger {
  /**
   * log multiple metrics from a finished request.
   * @param {string} packageName
   * @param {string} majorVersion
   * @param {number} statusCode
   * @param {number} elapsedTime
   * @param {Error} error - Optional
   * @param {ResponseHeaders} responseHeaders - Optional
   * @param {string} versionId - Optional
   * @param {string} telemetryToken - Optional
   * @param {string} parentTelemetryTokens - Optional
   */
  async logRequest(props) {
    await this.emitTBTMetric(props);
  }
  // Emit TBT logs to package producer and consumer accounts (if parentConsole TBT token given) and lotus internal accounts.
  async emitTBTMetric({ packageName, majorVersion, elapsedTime, statusCode, error, responseHeaders, versionId, telemetryToken, parentTelemetryTokens }) {
    const tbtEventTracker = await this.getTBTEventTracker({
      packageName,
      telemetryToken,
      parentTelemetryTokens
    });
    tbtEventTracker.addLotusImportPackageEvent({
      lotusMetadata: {
        packageName,
        majorVersion,
        versionId,
        latency: elapsedTime,
        statusCode,
        requestId: responseHeaders ? responseHeaders.apiGatewayRequestId : void 0,
        errorDetails: error ? { code: error.name, message: error.message } : void 0
      }
    }, void 0, { publicEvent: true });
  }
};
var SigninStage;
(function(SigninStage2) {
  SigninStage2["PROD"] = "prod";
  SigninStage2["PRODISH"] = "prodish";
})(SigninStage || (SigninStage = {}));
var AccessType;
(function(AccessType2) {
  AccessType2["AnyAccount"] = "ANY_ACCOUNT";
  AccessType2["AllowedAccounts"] = "ALLOWED_ACCOUNTS";
})(AccessType || (AccessType = {}));
var LotusMetadataClientError = class extends Error {
  constructor({ name, message, cause, status }) {
    super(message, cause);
    __publicField(this, "status");
    this.status = status;
    this.name = name;
  }
};
var ErrorType2;
(function(ErrorType3) {
  ErrorType3["NetworkError"] = "NetworkError";
  ErrorType3["InvalidParametersError"] = "InvalidParametersError";
  ErrorType3["InvalidResponseError"] = "InvalidResponseError";
  ErrorType3["ConsoleProxyWafError"] = "ConsoleProxyWAFError";
})(ErrorType2 || (ErrorType2 = {}));
var LOTUS_METADATA_PATH = "/lotus/metadata";
var getCookie2 = (cookieName) => {
  const cookie = Object.fromEntries(document.cookie.split(";").map((cookieDefinition) => cookieDefinition.split("=").map((data) => decodeURIComponent(data.trim()))));
  return cookie[cookieName];
};
var isValidMetadataStructure = (response) => {
  var _a3, _b, _c;
  return Boolean((response == null ? void 0 : response.basePath) && response.versionId && (((_a3 = response.metadata) == null ? void 0 : _a3.module) || ((_c = (_b = response.metadata) == null ? void 0 : _b.assets) == null ? void 0 : _c.length)));
};
var getRegionInIsolatedIframe = () => {
  const searchParams = new URLSearchParams(location.search);
  const region = searchParams.get(IsolatedIFrameRequestQueryParams.ConsoleRegion);
  return region || void 0;
};
var REQUEST_TIMEOUT = 1e4;
var CANARY_REQUEST_TIMEOUT = 5e3;
var MAX_TRIES = 4;
var RETRY_DELAY = 100;
var unretryableStatusCodes = /* @__PURE__ */ new Set([400, 401, 403, 404, 413, 415]);
var APIGW_V1_REQUEST_ID_RESP_HEADER = "X-Amz-Apigw-Id";
var APIGW_V2_REQUEST_ID_RESP_HEADER = "Apigw-Requestid";
var LOTUS_REGION_RESP_HEADER = "x-lotus-region";
var sendHttpGetRequest = async (url, headers, timeout2, requestHandler) => {
  const controller = new AbortController();
  setTimeout(() => {
    controller.abort();
  }, timeout2);
  const requestInit = {
    method: "GET",
    headers,
    credentials: "omit",
    signal: controller.signal
  };
  try {
    let status;
    let body;
    let apiGatewayRequestId;
    let lotusRegion;
    if (requestHandler) {
      const workerResponse = await requestHandler({
        url,
        options: requestInit,
        timeout: timeout2
      });
      status = workerResponse.status;
      body = workerResponse.body;
      apiGatewayRequestId = workerResponse.headers[APIGW_V2_REQUEST_ID_RESP_HEADER] || workerResponse.headers[APIGW_V1_REQUEST_ID_RESP_HEADER] || "null";
      lotusRegion = workerResponse.headers[LOTUS_REGION_RESP_HEADER] || "null";
    } else {
      const fetchResponse = await fetch(url, requestInit);
      status = fetchResponse.status;
      body = await fetchResponse.text();
      apiGatewayRequestId = fetchResponse.headers.get(APIGW_V2_REQUEST_ID_RESP_HEADER) || fetchResponse.headers.get(APIGW_V1_REQUEST_ID_RESP_HEADER) || "null";
      lotusRegion = fetchResponse.headers.get(LOTUS_REGION_RESP_HEADER) || "null";
    }
    return {
      status,
      body,
      responseHeaders: {
        apiGatewayRequestId,
        lotusRegion
      }
    };
  } catch (error) {
    throw new LotusMetadataClientError({
      name: ErrorType2.NetworkError,
      message: error.name === "AbortError" ? "Timed out" : `Fetch error: ${error.message}`,
      cause: error
    });
  }
};
var sendHttpGetRequestWithRetries = async (url, headers, requestConfig, requestHandler) => {
  const isCanary = getCookie2("metrics-req-cat") === "canary";
  const tries = (requestConfig == null ? void 0 : requestConfig.tries) || MAX_TRIES;
  const retryDelay = (requestConfig == null ? void 0 : requestConfig.retryDelay) || RETRY_DELAY;
  const timeout2 = (requestConfig == null ? void 0 : requestConfig.timeout) || (isCanary ? CANARY_REQUEST_TIMEOUT : REQUEST_TIMEOUT);
  let latestError = new Error("Error");
  let latestResponse;
  for (let attemptIndex = 0; attemptIndex < tries; attemptIndex += 1) {
    try {
      latestResponse = await sendHttpGetRequest(url, headers, timeout2, requestHandler);
      if (latestResponse.status === 200 || unretryableStatusCodes.has(latestResponse.status)) {
        break;
      }
    } catch (error) {
      latestError = error;
      if (error.name !== ErrorType2.NetworkError) {
        break;
      }
    }
    await exponentialBackoff(attemptIndex, retryDelay);
  }
  if (latestResponse !== void 0) {
    return latestResponse;
  }
  throw latestError;
};
var TangerineBoxError2 = class extends Error {
  constructor(message, originalError) {
    super(message);
    __publicField(this, "message");
    __publicField(this, "originalError");
    this.message = message;
    this.originalError = originalError;
    this.name = this.constructor.name;
    if (originalError) {
      this.stack += `
Caused by: ${originalError.stack}`;
    }
  }
};
var MetaTagParsingError2 = class extends TangerineBoxError2 {
};
function parseMetaTag2(metaTagName) {
  const element = document.querySelector(`meta[name='${metaTagName}']`);
  return element == null ? void 0 : element.content;
}
function parseTangerineBoxMetaTag() {
  const element = parseMetaTag2("tb-data");
  if (!element) {
    throw new MetaTagParsingError2("TangerineBox meta tag not found");
  }
  try {
    return JSON.parse(element);
  } catch (error) {
    throw new MetaTagParsingError2("Unable to parse TangerineBox meta tag contents", error instanceof Error ? error : new Error(String(error)));
  }
}
var _TangerineBox = class _TangerineBox2 {
  constructor(metaTagContent) {
    if (metaTagContent) {
      _TangerineBox2.metaTagContentCache = metaTagContent;
    }
  }
  /**
   * Returns the base URL for a given asset ID
   *
   * @see https://quip-amazon.com/xBRHARHS2ZZb/Documentation-04-Building-a-web-application#cDO9CAtNqxS
   */
  getCdnUrl(assetId) {
    return /^(http|https|ws|wss):\/\//.test(assetId) ? assetId : `${this.getMetaTagContent().cdn}${assetId}`;
  }
  /**
   * Returns parsed content of tb-data meta tag
   */
  getMetaTagContent() {
    if (!_TangerineBox2.metaTagContentCache) {
      _TangerineBox2.metaTagContentCache = parseTangerineBoxMetaTag();
    }
    return _TangerineBox2.metaTagContentCache;
  }
};
__publicField(_TangerineBox, "metaTagContentCache");
var TangerineBox = _TangerineBox;
function parseAndValidateMetadataHttpResponse({ status, parsedBody }) {
  if (status < 200 || status >= 300) {
    const { code, message } = parsedBody;
    throw new LotusMetadataClientError({
      name: code || ErrorType2.InvalidResponseError,
      message,
      status
    });
  }
  if (!isValidMetadataStructure(parsedBody)) {
    throw new LotusMetadataClientError({
      name: ErrorType2.InvalidResponseError,
      message: "Invalid metadata structure in response body",
      status
    });
  }
  const lotusCDNUrl = new URL(parsedBody.basePath);
  try {
    const tangerineBox = new TangerineBox();
    const tbCDNUrlString = tangerineBox.getCdnUrl("");
    const tbCDNUrl = new URL(tbCDNUrlString);
    lotusCDNUrl.hostname = tbCDNUrl.hostname;
    parsedBody.basePath = lotusCDNUrl.href;
  } catch {
  }
  return parsedBody;
}
function parseHttpResponse({ status, body }) {
  let parsedBody;
  try {
    parsedBody = JSON.parse(body);
  } catch (error) {
    if (status === 405) {
      throw new LotusMetadataClientError({
        name: ErrorType2.ConsoleProxyWafError,
        message: `Received 405 from Console Proxy WAF: ${body}`
      });
    }
    throw new LotusMetadataClientError({
      name: ErrorType2.InvalidResponseError,
      message: `Response body is not valid JSON: ${body}`,
      cause: error,
      status
    });
  }
  return parsedBody;
}
function registerTenant(input) {
  try {
    const { packageName, metadataResponse, telemetryToken } = input;
    TenantTracker.registerTenant({ name: packageName, version: metadataResponse.versionId, assetsLocations: [metadataResponse.basePath] }, telemetryToken ? {
      telemetryToken,
      receiveUnhandledErrors: true
      // Whether the tenant should receive unhandled errors attributed to them.
    } : void 0);
  } catch {
  }
}
var getPackageMetadata = async ({ packageName, majorVersion, host, aliasName, accessType, consoleRegion, onComplete, cacheInvalidator, telemetryToken, parentTelemetryTokens, experiments }) => {
  const startTime = performance.now();
  const onCompleteFunction = onComplete != null ? onComplete : (metrics2) => {
    new MetadataLogger().logRequest(metrics2);
  };
  let httpGetResponse;
  let telemetryTokenPromise = Promise.resolve(void 0);
  let responseTelemetryToken;
  let inputTelemetryToken;
  try {
    if (!packageName || !majorVersion) {
      throw new LotusMetadataClientError({
        name: ErrorType2.InvalidParametersError,
        message: "Missing package name or majorVersion."
      });
    }
    if (typeof telemetryToken === "string") {
      telemetryTokenPromise = Promise.resolve(telemetryToken);
    }
    if (typeof telemetryToken === "function") {
      telemetryTokenPromise = telemetryToken();
    }
    const responseFromStorageResult = getPackageMetadataResponseFromStorage({
      packageName,
      majorVersion
    });
    if (!responseFromStorageResult.succeeded) {
      inputTelemetryToken = await telemetryTokenPromise;
      const { message } = responseFromStorageResult.error;
      const storageResultError = new LotusMetadataClientError({
        name: ErrorType2.InvalidResponseError,
        message
      });
      onCompleteFunction({
        packageName,
        majorVersion,
        elapsedTime: performance.now() - startTime,
        error: storageResultError,
        statusCode: void 0,
        versionId: void 0,
        telemetryToken: responseTelemetryToken,
        parentTelemetryTokens: [
          ...inputTelemetryToken ? [inputTelemetryToken] : [],
          ...parentTelemetryTokens != null ? parentTelemetryTokens : []
        ]
      });
      throw storageResultError;
    }
    if (responseFromStorageResult.succeeded && responseFromStorageResult.metadataResponse) {
      const metadataResponse = responseFromStorageResult.metadataResponse;
      responseTelemetryToken = metadataResponse.telemetryToken;
      inputTelemetryToken = await telemetryTokenPromise;
      registerTenant({ packageName, metadataResponse, telemetryToken: responseTelemetryToken });
      onCompleteFunction({
        packageName,
        majorVersion,
        elapsedTime: performance.now() - startTime,
        statusCode: 200,
        versionId: metadataResponse.versionId,
        telemetryToken: responseTelemetryToken,
        parentTelemetryTokens: [
          ...inputTelemetryToken ? [inputTelemetryToken] : [],
          ...parentTelemetryTokens != null ? parentTelemetryTokens : []
        ]
      });
      return metadataResponse;
    }
    const packageMetadataRequestConfigFromStorage = getPackageMetadataRequestConfigFromStorage({
      packageName,
      majorVersion
    });
    const requestPackageName = (packageMetadataRequestConfigFromStorage == null ? void 0 : packageMetadataRequestConfigFromStorage.packageName) || packageName;
    const requestMajorVersion = (packageMetadataRequestConfigFromStorage == null ? void 0 : packageMetadataRequestConfigFromStorage.majorVersion) || majorVersion;
    const requestHost = (packageMetadataRequestConfigFromStorage == null ? void 0 : packageMetadataRequestConfigFromStorage.host) || host;
    const requestAliasName = (packageMetadataRequestConfigFromStorage == null ? void 0 : packageMetadataRequestConfigFromStorage.aliasName) || aliasName;
    const requestAccessType = (packageMetadataRequestConfigFromStorage == null ? void 0 : packageMetadataRequestConfigFromStorage.accessType) || accessType;
    const requestConsoleRegion = (packageMetadataRequestConfigFromStorage == null ? void 0 : packageMetadataRequestConfigFromStorage.consoleRegion) || consoleRegion;
    const requestCacheInvalidator = (packageMetadataRequestConfigFromStorage == null ? void 0 : packageMetadataRequestConfigFromStorage.cacheInvalidator) || cacheInvalidator;
    const metadataProvider = SessionDataProvider.getInstance();
    const accountId = await metadataProvider.getAccountId();
    const currentRegion = requestConsoleRegion || await metadataProvider.getInfrastructureRegion() || getRegionInIsolatedIframe() || await getCurrentRegion();
    if (!accountId || !currentRegion) {
      throw new LotusMetadataClientError({
        name: ErrorType2.InvalidParametersError,
        message: "Missing accountId or console region."
      });
    }
    let headers = {};
    const searchParams = new URLSearchParams({
      [PackageMetadataRequestQueryParams.PackageName]: requestPackageName,
      [PackageMetadataRequestQueryParams.MajorVersion]: requestMajorVersion,
      [PackageMetadataRequestQueryParams.AccountId]: accountId,
      [PackageMetadataRequestQueryParams.Region]: currentRegion,
      [PackageMetadataRequestQueryParams.SucceedOnRetry]: "true"
    });
    if (requestAliasName) {
      searchParams.append(PackageMetadataRequestQueryParams.AliasName, requestAliasName);
    }
    if (requestCacheInvalidator) {
      searchParams.append(PackageMetadataRequestQueryParams.CacheInvalidator, requestCacheInvalidator);
    }
    const testTrafficCookieValue = getCookie2("metrics-req-cat");
    if (testTrafficCookieValue) {
      searchParams.append(PackageMetadataRequestQueryParams.TrafficCategory, testTrafficCookieValue);
    }
    let lotusHost = getLotusHost(currentRegion);
    const sessionData = await metadataProvider.getSessionData();
    if (sessionData == null ? void 0 : sessionData.dualstackEnabledDomain) {
      lotusHost = getLotusDualstackHost(currentRegion);
    }
    const packageMetadataApiUrl = `https://${requestHost || lotusHost}${LOTUS_METADATA_PATH}?${searchParams.toString()}`;
    const missingIdentityTokenError = new LotusMetadataClientError({
      name: ErrorType2.InvalidParametersError,
      message: "Missing identity token."
    });
    if (requestAccessType === AccessType.AllowedAccounts) {
      const identityToken = await metadataProvider.getIdentityToken();
      if (!identityToken) {
        throw missingIdentityTokenError;
      }
      headers = {
        "x-userinfo-signed": identityToken
      };
    }
    httpGetResponse = await sendHttpGetRequestWithRetries(packageMetadataApiUrl, headers, void 0, experiments == null ? void 0 : experiments.requestHandler);
    let responseBody = parseHttpResponse(httpGetResponse);
    if (responseBody.retryWithIdentityToken) {
      const identityToken = await metadataProvider.getIdentityToken();
      if (!identityToken) {
        throw missingIdentityTokenError;
      }
      headers = {
        "x-userinfo-signed": identityToken
      };
      httpGetResponse = await sendHttpGetRequestWithRetries(packageMetadataApiUrl, headers, void 0, experiments == null ? void 0 : experiments.requestHandler);
      responseBody = parseHttpResponse(httpGetResponse);
    }
    const packageMetadataResponse = Object.freeze(parseAndValidateMetadataHttpResponse({
      status: httpGetResponse.status,
      parsedBody: responseBody
    }));
    inputTelemetryToken = await telemetryTokenPromise;
    responseTelemetryToken = packageMetadataResponse.telemetryToken;
    onCompleteFunction({
      packageName,
      majorVersion,
      elapsedTime: performance.now() - startTime,
      statusCode: 200,
      responseHeaders: httpGetResponse.responseHeaders,
      versionId: packageMetadataResponse.versionId,
      telemetryToken: responseTelemetryToken,
      parentTelemetryTokens: [...inputTelemetryToken ? [inputTelemetryToken] : [], ...parentTelemetryTokens != null ? parentTelemetryTokens : []]
    });
    registerTenant({ packageName, metadataResponse: packageMetadataResponse, telemetryToken: responseTelemetryToken });
    return packageMetadataResponse;
  } catch (error) {
    onCompleteFunction({
      packageName,
      majorVersion,
      elapsedTime: performance.now() - startTime,
      error,
      statusCode: httpGetResponse ? httpGetResponse.status : void 0,
      responseHeaders: httpGetResponse ? httpGetResponse.responseHeaders : void 0,
      versionId: void 0,
      telemetryToken: responseTelemetryToken,
      parentTelemetryTokens: [...inputTelemetryToken ? [inputTelemetryToken] : [], ...parentTelemetryTokens != null ? parentTelemetryTokens : []]
    });
    throw error;
  }
};
var continuumAPIGlobalSymbol = Symbol.for("continuum-api");
var getTopWindow3 = () => {
  try {
    return window.top || window;
  } catch (error) {
  }
  return window;
};
var getGlobalScopeImport = () => {
  const globalScope = getTopWindow3()[continuumAPIGlobalSymbol];
  return globalScope;
};
var setGlobalScopeImport = (deferred) => {
  getTopWindow3()[continuumAPIGlobalSymbol] = deferred;
};
var Deferred = class {
  constructor() {
    __publicField(this, "promise");
    __publicField(this, "resolve");
    __publicField(this, "reject");
    __publicField(this, "continuumInstance", null);
    this.resolve = () => {
      throw new Error("Race condition in deffered implementation");
    };
    this.reject = () => {
      throw new Error("Race condition in deffered implementation");
    };
    this.promise = new Promise((resolve, reject) => {
      this.resolve = (instance) => {
        this.continuum = instance;
        resolve(instance);
      };
      this.reject = reject;
    });
  }
  get continuum() {
    return this.continuumInstance;
  }
  set continuum(value) {
    this.continuumInstance = value;
  }
};
var ContinuumBase = class {
  constructor(config) {
    __publicField(this, "continuumCore");
    __publicField(this, "config");
    this.config = config;
    this.initializeCore().then(() => {
    }).catch((error) => {
      console.warn("Failed to initialize Continuum core", error);
    });
  }
  /**
   * Get data from storage
   */
  async get(options) {
    if (!this.continuumCore) {
      await this.initializeCore();
    }
    return this.continuumCore.get(options);
  }
  /**
   * Set data in storage
   */
  async set(value) {
    if (!this.continuumCore) {
      await this.initializeCore();
    }
    return this.continuumCore.set(value);
  }
  /**
   * Remove data from storage
   */
  async remove() {
    if (!this.continuumCore) {
      await this.initializeCore();
    }
    return this.continuumCore.remove();
  }
  /**
   * Initialize core by dynamically importing continuum-internal
   */
  async initializeCore(iteration = 0) {
    let deferred = getGlobalScopeImport();
    if (deferred && iteration === 0) {
      if (!this.continuumCore) {
        const ContinuumBaseStorageProvider = deferred.continuum || await deferred.promise;
        this.continuumCore = new ContinuumBaseStorageProvider(this.config);
      }
      return;
    }
    if (!deferred) {
      deferred = getGlobalScopeImport() || new Deferred();
      setGlobalScopeImport(deferred);
    }
    try {
      const result = await getPackageMetadata({
        packageName: "@amzn/awsc-continuum",
        majorVersion: "1"
      });
      if (!result.basePath) {
        throw new Error(`Failed to import package`);
      } else {
        const { ContinuumBaseStorageProvider } = await import(
          /* @vite-ignore */
          /* webpackIgnore: true */
          `${result.basePath}index.js`
        );
        deferred.resolve(ContinuumBaseStorageProvider);
        this.continuumCore = new ContinuumBaseStorageProvider(this.config);
      }
    } catch (err) {
      if (iteration < 3) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        return this.initializeCore(iteration + 1);
      }
      const error = new Error((err == null ? void 0 : err.message) || `Failed to initialize Continuum core: ${err instanceof Error ? err.message : "Unknown error"}`);
      deferred.reject(error);
      throw error;
    }
  }
};
var indexedDB = (config) => {
  const storageConfig = {
    ...config,
    storagePreference: StoragePreference.INDEXED_DB
  };
  return new ContinuumBase(storageConfig);
};
var localStorage = (config) => {
  const storageConfig = {
    ...config,
    storagePreference: StoragePreference.LOCAL_STORAGE
  };
  return new ContinuumBase(storageConfig);
};
var sessionStorage2 = (config) => {
  const storageConfig = {
    ...config,
    storagePreference: StoragePreference.SESSION_STORAGE
  };
  return new ContinuumBase(storageConfig);
};
var preload = () => {
  sessionStorage2({
    storageKey: "CS_preload_storage_provider",
    storageScope: StorageScope.ORIGIN
  });
};
var Continuum = Object.freeze({
  indexedDB,
  localStorage,
  sessionStorage: sessionStorage2,
  preload,
  isEncryptionSupported,
  isContinuumAvailable
});
var EMPTY_ARRAY = Object.freeze([]);
var { isArray } = Array;
var { isArray: isArray2 } = Array;
var isEmptyString = (str) => !str || str.trim().length === 0;
var WITHOUT_PAYLOAD_RESULT = { hasPayload: false, hasReply: false };
var WITH_PAYLOAD_RESULT = { hasPayload: true, hasReply: false };
var WITH_PAYLOAD_AND_REPLY_RESULT = { hasPayload: true, hasReply: true };
var WITH_REPLY_RESULT = { hasPayload: false, hasReply: true };
var DEFINE_MESSAGE_TYPES_HELPERS = {
  withPayload: () => WITH_PAYLOAD_RESULT,
  withoutPayload: () => WITHOUT_PAYLOAD_RESULT,
  withPayloadAndReply: () => WITH_PAYLOAD_AND_REPLY_RESULT,
  withReply: () => WITH_REPLY_RESULT
};
var REPLY_SUFFIX = ":REPLY";
var createMessageTypeDefinition = ({ namespace: namespace2, type, to, result }) => {
  const qualifiedType = `${namespace2}/${type}`;
  const qualifiedReplyType = result.hasReply ? `${qualifiedType}${REPLY_SUFFIX}` : void 0;
  const messageTypeDefinition = {
    type: qualifiedType,
    // @ts-expect-error We allow qualifiedReplyType to be undefined for non-replies
    replyType: qualifiedReplyType,
    create: (params) => {
      const outgoingMessage = {
        ...params,
        type: qualifiedType
      };
      if (to) {
        outgoingMessage.to = to;
      }
      if (!result.hasPayload) {
        outgoingMessage.payload = {};
      }
      return outgoingMessage;
    },
    createReply: (params) => {
      if (!result.hasReply) {
        throw new Error(`Message type (${qualifiedType}) does not support replies`);
      }
      const outgoingReply = {
        ...params,
        // @ts-expect-error Reply will always have a defined qualifiedReplyType
        type: qualifiedReplyType
      };
      if (outgoingReply.payload === void 0) {
        outgoingReply.payload = {};
      }
      return outgoingReply;
    },
    matches: (message) => (message == null ? void 0 : message.type) === qualifiedType,
    matchesReply: (reply) => (reply == null ? void 0 : reply.type) === qualifiedReplyType,
    createHandler: (handlerFunction) => handlerFunction
  };
  return messageTypeDefinition;
};
var defineMessageTypes = (namespace2, factory) => {
  if (isEmptyString(namespace2)) {
    throw new Error("Namespace is required");
  }
  const output = {};
  const defineMessagesInput = factory(DEFINE_MESSAGE_TYPES_HELPERS);
  for (const [type, result] of Object.entries(defineMessagesInput)) {
    output[type] = createMessageTypeDefinition({ namespace: namespace2, type, result });
  }
  return output;
};
var moduleId = "continuum";
var continuumMessageTypes = defineMessageTypes(moduleId, ({ withPayloadAndReply }) => ({
  set: withPayloadAndReply(),
  get: withPayloadAndReply(),
  remove: withPayloadAndReply()
}));
var ContinuumModuleBase = class {
  constructor({ moduleContext, ...config }) {
    __publicField(this, "moduleContext");
    __publicField(this, "config");
    this.moduleContext = moduleContext;
    this.config = config;
  }
  /** Stores a value */
  async set(value, options) {
    var _a3, _b, _c;
    const response = await this.moduleContext.sendAskMessage(continuumMessageTypes.set.create({
      to: moduleId,
      payload: {
        config: this.config,
        value,
        options
      }
    }));
    if (!((_a3 = response.payload) == null ? void 0 : _a3.succeeded)) {
      throw new Error(`${(_b = response.payload) == null ? void 0 : _b.errorCode}: ${(_c = response.payload) == null ? void 0 : _c.errorMessage}`);
    }
  }
  /** Retrieves a value */
  async get(options) {
    var _a3, _b, _c;
    const response = await this.moduleContext.sendAskMessage(continuumMessageTypes.get.create({
      to: moduleId,
      payload: {
        config: this.config,
        ...options
      }
    }));
    if ((_a3 = response.payload) == null ? void 0 : _a3.succeeded) {
      return response.payload.data;
    }
    throw new Error(`${(_b = response.payload) == null ? void 0 : _b.errorCode}: ${(_c = response.payload) == null ? void 0 : _c.errorMessage}`);
  }
  /** Removes the stored value */
  async remove() {
    var _a3, _b, _c;
    const response = await this.moduleContext.sendAskMessage(continuumMessageTypes.remove.create({
      to: moduleId,
      payload: {
        config: this.config
      }
    }));
    if (!((_a3 = response.payload) == null ? void 0 : _a3.succeeded)) {
      throw new Error(`${(_b = response.payload) == null ? void 0 : _b.errorCode}: ${(_c = response.payload) == null ? void 0 : _c.errorMessage}`);
    }
  }
};
var indexedDB2 = (config) => {
  const moduleConfig = {
    ...config,
    storagePreference: StoragePreference.INDEXED_DB
  };
  return new ContinuumModuleBase(moduleConfig);
};
var localStorage2 = (config) => {
  const moduleConfig = {
    ...config,
    storagePreference: StoragePreference.LOCAL_STORAGE
  };
  return new ContinuumModuleBase(moduleConfig);
};
var sessionStorage3 = (config) => {
  const moduleConfig = {
    ...config,
    storagePreference: StoragePreference.SESSION_STORAGE
  };
  return new ContinuumModuleBase(moduleConfig);
};
var ContinuumModule = Object.freeze({
  indexedDB: indexedDB2,
  localStorage: localStorage2,
  sessionStorage: sessionStorage3,
  isEncryptionSupported,
  isContinuumAvailable
});

// ../../node_modules/@amzn/awsui-component-toolkit-internal/lib/persistence/telemetry.js
function getTracker() {
  return TangerineBoxEventTrackerForLibrary.getInstance({
    // Comes from this stack: https://code.amazon.com/packages/AwsUi-Components-MonitoringCDK/blobs/72dd278237a7ce4ab5407b11c1feb969791f67d2/--/src/stacks/telemetry.ts#L22
    token: "v1/7117fdd0e21f31152a03b401c89c27faa73b4e19932292c7daadf27239772235"
  });
}
function addEvent(payload) {
  getTracker().addEvent({ payload: { ...payload, storageScope: "browser" } });
}
function addError(error, payload) {
  getTracker().addError(error, { payload: { ...payload, storageScope: "browser" } });
}
function sendErrorMetrics(error, component, persistenceKey, action) {
  console.warn(`Can not persist dismiss on ${component}: ${error}`);
  addError(error, {
    metricName: `PersistenceError-${component}-${action}`,
    persistenceKey,
    count: 1
  });
}
function sendConsentRequiredMetrics(component, persistenceKey, action) {
  console.warn(`Can not persist dismiss on ${component}: consent required`);
  addEvent({
    metricName: `PersistenceConsentRequired-${component}-${action}`,
    persistenceKey,
    count: 1
  });
}
function sendSaveSuccessMetrics(component, persistenceKey) {
  addEvent({
    metricName: `PersistenceSaved-${component}`,
    persistenceKey,
    count: 1
  });
}
function sendRetrieveSuccessMetrics(component, persistenceKey) {
  addEvent({
    metricName: `PersistenceRetrieved-${component}`,
    persistenceKey,
    count: 1
  });
}
function sendRetrieveLatencyMetrics(component, persistenceKey, latency) {
  addEvent({
    metricName: `PersistenceRetrieveLatency-${component}`,
    persistenceKey,
    value: latency
  });
}

// ../../node_modules/@amzn/awsui-component-toolkit-internal/lib/persistence/utils.js
var getTopWindow4 = () => {
  return window.top;
};
var continuumInstanceMap = /* @__PURE__ */ new Map();
var YEAR_MS = 365 * 24 * 60 * 60 * 1e3;
var TTL = 5 * YEAR_MS;
var FEATURE_NOTIFICATIONS_OVERRIDES = {
  storageScope: "origin",
  ttl: "1_year"
};
function getContinuum(persistenceKey, configOverrides) {
  let client = continuumInstanceMap.get(persistenceKey);
  if (!client) {
    client = Continuum.indexedDB({
      storageKey: persistenceKey,
      storageScope: "browser",
      ttl: TTL,
      encryption: false,
      consentCategory: "functional",
      ...configOverrides
    });
    continuumInstanceMap.set(persistenceKey, client);
  }
  return client;
}
function getNavId() {
  var _a3, _b, _c;
  try {
    return (_c = (_b = (_a3 = getTopWindow4()) === null || _a3 === void 0 ? void 0 : _a3.ConsoleNavService) === null || _b === void 0 ? void 0 : _b.Model.currentService.id) !== null && _c !== void 0 ? _c : "";
  } catch {
    throw new Error("Unable to retrieve navId");
  }
}
function isConsentRequiredError(error) {
  return error instanceof Error && error.message.includes("CONSENT_REQUIRED");
}
function getPersistenceKey(persistenceConfig) {
  const navId = persistenceConfig.crossServicePersistence ? "global" : getNavId();
  const persistenceKey = `CS_AWS-UI_${navId}_${persistenceConfig.uniqueKey}`;
  return persistenceKey;
}
async function persistValue(component, persistenceConfig, value) {
  try {
    const configOverrides = component === "feature-notifications" ? FEATURE_NOTIFICATIONS_OVERRIDES : {};
    const persistenceKey = getPersistenceKey(persistenceConfig);
    const client = getContinuum(persistenceKey, configOverrides);
    await client.set(value);
    sendSaveSuccessMetrics(component, persistenceKey);
  } catch (error) {
    if (isConsentRequiredError(error)) {
      sendConsentRequiredMetrics(component, persistenceConfig.uniqueKey, "set");
    } else {
      sendErrorMetrics(error instanceof Error ? error : new Error(String(error)), component, persistenceConfig.uniqueKey, "set");
    }
  }
}
async function retrieveValue(component, persistenceConfig, defaultValue4) {
  try {
    const configOverrides = component === "feature-notifications" ? FEATURE_NOTIFICATIONS_OVERRIDES : {};
    const persistenceKey = getPersistenceKey(persistenceConfig);
    const client = getContinuum(persistenceKey, configOverrides);
    const startTime = performance.now();
    const result = await client.get().then((result2) => {
      sendRetrieveSuccessMetrics(component, persistenceKey);
      return result2;
    }).finally(() => {
      const endTime = performance.now();
      const timeTaken = endTime - startTime;
      sendRetrieveLatencyMetrics(component, persistenceKey, timeTaken);
    });
    return result !== null && result !== void 0 ? result : defaultValue4;
  } catch (error) {
    if (isConsentRequiredError(error)) {
      sendConsentRequiredMetrics(component, persistenceConfig.uniqueKey, "get");
    } else {
      sendErrorMetrics(error instanceof Error ? error : new Error(String(error)), component, persistenceConfig.uniqueKey, "get");
    }
    return defaultValue4;
  }
}
async function retrieveValueWithLatencyLimit(component, persistenceConfig, defaultValue4) {
  try {
    let timeoutId;
    const persistenceKey = getPersistenceKey(persistenceConfig);
    const result = await Promise.race([
      retrieveValue(component, persistenceConfig, defaultValue4).then((result2) => {
        clearTimeout(timeoutId);
        return result2;
      }),
      new Promise((resolve) => {
        timeoutId = window.setTimeout(() => {
          sendErrorMetrics(new Error("PersistenceGetTimeout"), component, persistenceKey, "get");
          resolve(defaultValue4);
        }, 500);
      })
    ]);
    return result !== null && result !== void 0 ? result : defaultValue4;
  } catch (error) {
    if (isConsentRequiredError(error)) {
      sendConsentRequiredMetrics(component, persistenceConfig.uniqueKey, "get");
    } else {
      sendErrorMetrics(error instanceof Error ? error : new Error(String(error)), component, persistenceConfig.uniqueKey, "get");
    }
    return defaultValue4;
  }
}

// ../../node_modules/@amzn/awsui-component-toolkit-internal/lib/persistence/alert.js
async function persistAlertDismiss(persistenceConfig) {
  await persistValue("alert", persistenceConfig, true);
}
async function retrieveAlertDismiss(persistenceConfig) {
  return retrieveValueWithLatencyLimit("alert", persistenceConfig, false);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/helpers/use-discovered-action.js
import React33, { useEffect as useEffect24, useRef as useRef22, useState as useState16 } from "react";
function RuntimeActionWrapper({ mountContent, updateContent, unmountContent, context }) {
  const ref = useRef22(null);
  const mountedRef = useRef22(false);
  useEffect24(() => {
    if (mountedRef.current && ref.current) {
      updateContent === null || updateContent === void 0 ? void 0 : updateContent(ref.current, context);
    }
  });
  useEffect24(() => {
    const container = ref.current;
    mountContent(container, context);
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      unmountContent(container);
    };
  }, []);
  return React33.createElement("div", { ref });
}
function createUseDiscoveredAction(onActionRegistered) {
  return function useDiscoveredAction2(type) {
    const [actionConfigs, setActionConfigs] = useState16([]);
    const headerRef = useRef22(null);
    const contentRef = useRef22(null);
    useEffect24(() => {
      return onActionRegistered((actions) => setActionConfigs(actions));
    }, [type]);
    const discoveredActions = actionConfigs.map((action) => React33.createElement(RuntimeActionWrapper, { key: action.id + "-" + type, context: {
      type,
      headerRef,
      contentRef
    }, mountContent: action.mountContent, updateContent: action.updateContent, unmountContent: action.unmountContent }));
    return { discoveredActions, headerRef, contentRef };
  };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/plugins/helpers/use-discovered-content.js
import { useEffect as useEffect25, useRef as useRef23, useState as useState17 } from "react";
function createUseDiscoveredContent(componentName2, controller) {
  return function useDiscoveredContent2({ type, header, children }) {
    const instanceId = useUniqueId(`${componentName2}-discovered-content`);
    const headerRef = useRef23(null);
    const contentRef = useRef23(null);
    const replacementHeaderRef = useRef23(null);
    const replacementContentRef = useRef23(null);
    const [initialHidden, setInitialHidden] = useState17(() => controller.initialCheck({
      instanceId,
      type,
      header,
      content: children
    }));
    const [headerReplacementType, setFoundHeaderReplacement] = useState17("original");
    const [contentReplacementType, setFoundContentReplacement] = useState17("original");
    const mountedProvider = useRef23();
    useEffect25(() => {
      const context = { instanceId, type, headerRef, contentRef };
      setInitialHidden(false);
      return controller.onContentRegistered((provider) => {
        let mounted = true;
        function checkMounted(methodName) {
          if (!mounted) {
            reportRuntimeApiWarning(`${componentName2}-content-replacer`, `"${methodName}" called after component unmounted`);
            return false;
          }
          return true;
        }
        mountedProvider.current = provider.runReplacer(context, {
          hideHeader() {
            if (checkMounted("hideHeader")) {
              setFoundHeaderReplacement("remove");
            }
          },
          restoreHeader() {
            if (checkMounted("restoreHeader")) {
              setFoundHeaderReplacement("original");
            }
          },
          replaceHeader(replacer) {
            if (checkMounted("replaceHeader")) {
              replacer(replacementHeaderRef.current);
              setFoundHeaderReplacement("replaced");
            }
          },
          hideContent() {
            if (checkMounted("hideContent")) {
              setFoundContentReplacement("remove");
            }
          },
          restoreContent() {
            if (checkMounted("restoreContent")) {
              setFoundContentReplacement("original");
            }
          },
          replaceContent(replacer) {
            if (checkMounted("replaceContent")) {
              replacer(replacementContentRef.current);
              setFoundContentReplacement("replaced");
            }
          }
        });
        return () => {
          var _a3;
          (_a3 = mountedProvider.current) === null || _a3 === void 0 ? void 0 : _a3.unmount({
            replacementHeaderContainer: replacementHeaderRef.current,
            replacementContentContainer: replacementContentRef.current
          });
          mounted = false;
        };
      });
    }, [instanceId, type]);
    useEffect25(() => {
      var _a3;
      (_a3 = mountedProvider.current) === null || _a3 === void 0 ? void 0 : _a3.update();
    }, [type, header, children]);
    return {
      initialHidden,
      headerReplacementType,
      contentReplacementType,
      headerRef,
      replacementHeaderRef,
      contentRef,
      replacementContentRef
    };
  };
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/container-queries/use-container-query.js
import { useRef as useRef24, useState as useState18, useCallback as useCallback11 } from "react";
function useContainerQuery(mapFn, deps = []) {
  const elementRef = useRef24(null);
  const [state2, setState] = useState18(null);
  const getElement = useCallback11(() => elementRef.current, deps);
  useResizeObserver(getElement, (entry) => setState((prevState) => mapFn(entry, prevState)));
  return [state2, elementRef];
}

// ../../node_modules/@amzn/awsui-component-toolkit/mjs/use-controllable-state/use-controllable-state.js
import { useState as useState19, useEffect as useEffect26, useCallback as useCallback12 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/use-container-width.js
function useContainerWidth(defaultValue4 = 0, threshold = 1) {
  const [width, ref] = useContainerQuery((rect, prev) => {
    if (prev === null) {
      return rect.contentBoxWidth;
    }
    return Math.abs(prev - rect.contentBoxWidth) >= threshold ? rect.contentBoxWidth : prev;
  });
  return [width !== null && width !== void 0 ? width : defaultValue4, ref];
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/actions-wrapper/index.js
import React34, { useLayoutEffect as useLayoutEffect8, useState as useState20 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/actions-wrapper/styles.css.js
var styles_css_default14 = {
  "root": "awsui_root_37gf8_lt3vf_5"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/actions-wrapper/index.js
function createActionButton(testUtilClasses, action, buttonText, onButtonClick) {
  if (!action && buttonText) {
    action = React34.createElement(
      "span",
      { ...getAnalyticsMetadataAttribute({
        action: "buttonClick"
      }) },
      React34.createElement(internal_default4, { className: testUtilClasses.actionButton, onClick: onButtonClick, formAction: "none" }, buttonText)
    );
  }
  return action ? React34.createElement("div", { className: testUtilClasses.actionSlot }, action) : null;
}
var ActionsWrapper = ({ className, testUtilClasses, action, discoveredActions, buttonText, wrappedClass, containerWidth, onButtonClick }) => {
  const [wrapped, setWrapped] = useState20(false);
  const ref = React34.useRef(null);
  useLayoutEffect8(() => {
    if (!ref.current || !containerWidth || !wrappedClass) {
      return;
    }
    function check() {
      const isRtl = getIsRtl(ref.current);
      const { offsetWidth, offsetLeft } = ref.current;
      const start = isRtl ? containerWidth - offsetWidth - offsetLeft : offsetLeft;
      setWrapped(start < 100);
    }
    const observer2 = new MutationObserver(check);
    observer2.observe(ref.current, { attributes: false, childList: true, subtree: true });
    check();
    return () => observer2.disconnect();
  });
  const actionButton = createActionButton(testUtilClasses, action, buttonText, onButtonClick);
  if (!actionButton && discoveredActions.length === 0) {
    return null;
  }
  return React34.createElement(
    "div",
    { ref, className: clsx_m_default(styles_css_default14.root, className, wrapped && wrappedClass) },
    actionButton,
    discoveredActions
  );
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/style.js
function getAlertStyles(style) {
  var _a3, _b, _c, _d, _e, _f, _g, _h, _j;
  if (SYSTEM !== "core" || !(style === null || style === void 0 ? void 0 : style.root)) {
    return void 0;
  }
  return {
    background: (_a3 = style.root) === null || _a3 === void 0 ? void 0 : _a3.background,
    borderColor: (_b = style.root) === null || _b === void 0 ? void 0 : _b.borderColor,
    borderRadius: (_c = style.root) === null || _c === void 0 ? void 0 : _c.borderRadius,
    borderWidth: (_d = style.root) === null || _d === void 0 ? void 0 : _d.borderWidth,
    color: (_e = style.root) === null || _e === void 0 ? void 0 : _e.color,
    ...((_f = style.root) === null || _f === void 0 ? void 0 : _f.focusRing) && {
      [custom_css_properties_default.alertFocusRingBorderColor]: (_g = style.root.focusRing) === null || _g === void 0 ? void 0 : _g.borderColor,
      [custom_css_properties_default.alertFocusRingBorderRadius]: (_h = style.root.focusRing) === null || _h === void 0 ? void 0 : _h.borderRadius,
      [custom_css_properties_default.alertFocusRingBorderWidth]: (_j = style.root.focusRing) === null || _j === void 0 ? void 0 : _j.borderWidth
    }
  };
}
function getIconStyles(style) {
  var _a3;
  if (SYSTEM !== "core" || !((_a3 = style === null || style === void 0 ? void 0 : style.icon) === null || _a3 === void 0 ? void 0 : _a3.color)) {
    return void 0;
  }
  return {
    [custom_css_properties_default.alertIconColor]: style.icon.color
  };
}
function getDismissButtonStyles(style) {
  var _a3, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
  if (SYSTEM !== "core" || !(style === null || style === void 0 ? void 0 : style.dismissButton)) {
    return void 0;
  }
  return {
    root: {
      color: {
        active: (_b = (_a3 = style.dismissButton) === null || _a3 === void 0 ? void 0 : _a3.color) === null || _b === void 0 ? void 0 : _b.active,
        default: (_d = (_c = style.dismissButton) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.default,
        hover: (_f = (_e = style.dismissButton) === null || _e === void 0 ? void 0 : _e.color) === null || _f === void 0 ? void 0 : _f.hover
      },
      focusRing: {
        borderColor: (_h = (_g = style.dismissButton) === null || _g === void 0 ? void 0 : _g.focusRing) === null || _h === void 0 ? void 0 : _h.borderColor,
        borderRadius: (_k = (_j = style.dismissButton) === null || _j === void 0 ? void 0 : _j.focusRing) === null || _k === void 0 ? void 0 : _k.borderRadius,
        borderWidth: (_m = (_l = style.dismissButton) === null || _l === void 0 ? void 0 : _l.focusRing) === null || _m === void 0 ? void 0 : _m.borderWidth
      }
    }
  };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/analytics-metadata/styles.css.js
var styles_css_default15 = {
  "header": "awsui_header_17427_1ns0c_5"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/styles.css.js
var styles_css_default16 = {
  "alert": "awsui_alert_mx3cw_1gx9g_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1gx9g_1",
  "root": "awsui_root_mx3cw_1gx9g_35",
  "hidden": "awsui_hidden_mx3cw_1gx9g_70",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_1gx9g_121",
  "initial-hidden": "awsui_initial-hidden_mx3cw_1gx9g_133",
  "header": "awsui_header_mx3cw_1gx9g_138",
  "header-replacement": "awsui_header-replacement_mx3cw_1gx9g_139",
  "action": "awsui_action_mx3cw_1gx9g_143",
  "action-slot": "awsui_action-slot_mx3cw_1gx9g_147",
  "action-button": "awsui_action-button_mx3cw_1gx9g_148",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1gx9g_152",
  "text": "awsui_text_mx3cw_1gx9g_183",
  "icon": "awsui_icon_mx3cw_1gx9g_190",
  "message": "awsui_message_mx3cw_1gx9g_193",
  "action-wrapped": "awsui_action-wrapped_mx3cw_1gx9g_197",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_1gx9g_201",
  "icon-size-big": "awsui_icon-size-big_mx3cw_1gx9g_205",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_1gx9g_209",
  "content": "awsui_content_mx3cw_1gx9g_213",
  "content-replacement": "awsui_content-replacement_mx3cw_1gx9g_214",
  "dismiss": "awsui_dismiss_mx3cw_1gx9g_218",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1gx9g_223",
  "type-error": "awsui_type-error_mx3cw_1gx9g_227",
  "type-warning": "awsui_type-warning_mx3cw_1gx9g_235",
  "type-success": "awsui_type-success_mx3cw_1gx9g_243",
  "type-info": "awsui_type-info_mx3cw_1gx9g_251"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/internal.js
var typeToIcon = {
  error: "status-negative",
  warning: "status-warning",
  success: "status-positive",
  info: "status-info"
};
var useDiscoveredAction = createUseDiscoveredAction(awsuiPluginsInternal.alert.onActionRegistered);
var useDiscoveredContent = createUseDiscoveredContent("alert", awsuiPluginsInternal.alertContent);
var InternalAlert = React35.forwardRef(({ type, i18nStrings, visible = true, dismissible, children, header, buttonText, action, onDismiss, onButtonClick, __internalRootRef, statusIconAriaLabel: deprecatedStatusIconAriaLabel, dismissAriaLabel: deprecatedDismissAriaLabel, messageSlotId, style, persistenceConfig, styleClassNames, ...rest }, ref) => {
  var _a3, _b;
  const baseProps = getBaseProps(rest);
  const i18n = useInternalI18n("alert");
  const focusRef = useRef25(null);
  useImperativeHandle5(ref, () => ({
    focus: () => {
      if (focusRef.current) {
        focusRef.current.tabIndex = -1;
        focusRef.current.focus();
      }
    }
  }));
  const handleBlur = () => {
    if (focusRef.current) {
      focusRef.current.removeAttribute("tabindex");
    }
  };
  const { discoveredActions, headerRef: headerRefAction, contentRef: contentRefAction } = useDiscoveredAction(type);
  const { initialHidden, headerReplacementType, contentReplacementType, headerRef: headerRefContent, contentRef: contentRefContent, replacementHeaderRef, replacementContentRef } = useDiscoveredContent({ type, header, children });
  const [containerWidth, containerMeasureRef] = useContainerWidth();
  const containerRef = useMergeRefs(containerMeasureRef, __internalRootRef);
  const headerRef = useMergeRefs(headerRefAction, headerRefContent);
  const contentRef = useMergeRefs(contentRefAction, contentRefContent);
  const [isPersistentlyDismissed, setIsPersistentlyDismissed] = useState21(!!(persistenceConfig && persistenceConfig.uniqueKey));
  const isRefresh = useVisualRefresh();
  const size = isRefresh ? "normal" : headerReplacementType !== "remove" && header && contentReplacementType !== "remove" && children ? "big" : "normal";
  const hasAction = Boolean(action || buttonText || discoveredActions.length);
  const analyticsAttributes = {
    [DATA_ATTR_ANALYTICS_ALERT]: type
  };
  const statusIconAriaLabel = i18n(`i18nStrings.${type}IconAriaLabel`, (_a3 = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings[`${type}IconAriaLabel`]) !== null && _a3 !== void 0 ? _a3 : deprecatedStatusIconAriaLabel);
  const dismissAriaLabel = i18n("i18nStrings.dismissAriaLabel", (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.dismissAriaLabel) !== null && _b !== void 0 ? _b : i18n("dismissAriaLabel", deprecatedDismissAriaLabel));
  useEffect27(() => {
    let isMounted = true;
    if (persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.uniqueKey) {
      retrieveAlertDismiss(persistenceConfig).then((dismissed) => {
        if (isMounted) {
          setIsPersistentlyDismissed(!!dismissed);
        }
      }).catch(() => {
        if (isMounted) {
          setIsPersistentlyDismissed(false);
        }
      });
    }
    return () => {
      isMounted = false;
    };
  }, [persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.uniqueKey, persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.crossServicePersistence]);
  const dismiss = () => {
    fireNonCancelableEvent(onDismiss);
    if (persistenceConfig === null || persistenceConfig === void 0 ? void 0 : persistenceConfig.uniqueKey) {
      persistAlertDismiss(persistenceConfig);
    }
  };
  if (isPersistentlyDismissed) {
    return null;
  }
  return React35.createElement(
    "div",
    { ...baseProps, ...analyticsAttributes, "aria-hidden": !visible, className: clsx_m_default(styles_css_default16.root, { [styles_css_default16.hidden]: !visible, [styles_css_default16["initial-hidden"]]: initialHidden }, baseProps.className), ref: containerRef },
    React35.createElement(
      LinkDefaultVariantContext.Provider,
      { value: { defaultVariant: "primary" } },
      React35.createElement(
        VisualContext,
        { contextName: "alert" },
        React35.createElement(
          "div",
          { className: clsx_m_default(styleClassNames === null || styleClassNames === void 0 ? void 0 : styleClassNames.root, styles_css_default16.alert, styles_css_default16[`type-${type}`], styles_css_default16[`icon-size-${size}`], hasAction && styles_css_default16["with-action"], dismissible && styles_css_default16["with-dismiss"]), style: getAlertStyles(style) },
          React35.createElement(
            "div",
            { className: styles_css_default16["alert-wrapper"] },
            React35.createElement(
              "div",
              { className: styles_css_default16["alert-focus-wrapper"], ref: focusRef, role: "group", onBlur: handleBlur },
              React35.createElement(
                "div",
                { className: clsx_m_default(styleClassNames === null || styleClassNames === void 0 ? void 0 : styleClassNames.icon, styles_css_default16.icon, styles_css_default16.text), style: getIconStyles(style) },
                React35.createElement(internal_default, { name: typeToIcon[type], size, ariaLabel: statusIconAriaLabel })
              ),
              React35.createElement(
                "div",
                { className: clsx_m_default(styles_css_default16.message, styles_css_default16.text), id: messageSlotId },
                React35.createElement("div", { className: clsx_m_default(header && styles_css_default16.header, headerReplacementType !== "original" ? styles_css_default16.hidden : styles_css_default15.header), ref: headerRef }, header),
                React35.createElement("div", { className: clsx_m_default(styles_css_default16["header-replacement"], headerReplacementType !== "replaced" ? styles_css_default16.hidden : styles_css_default15.header), ref: replacementHeaderRef }),
                React35.createElement("div", { className: clsx_m_default(styles_css_default16.content, contentReplacementType !== "original" && styles_css_default16.hidden), ref: contentRef }, children),
                React35.createElement("div", { className: clsx_m_default(styles_css_default16["content-replacement"], contentReplacementType !== "replaced" && styles_css_default16.hidden), ref: replacementContentRef })
              )
            ),
            React35.createElement(ActionsWrapper, { className: styles_css_default16.action, testUtilClasses: {
              actionSlot: styles_css_default16["action-slot"],
              actionButton: styles_css_default16["action-button"]
            }, action, discoveredActions, buttonText, onButtonClick: () => fireNonCancelableEvent(onButtonClick), containerWidth, wrappedClass: styles_css_default16["action-wrapped"] })
          ),
          dismissible && React35.createElement(
            "div",
            { className: styles_css_default16.dismiss, ...getAnalyticsMetadataAttribute({
              action: "dismiss"
            }) },
            React35.createElement(InternalButton, { className: styles_css_default16["dismiss-button"], variant: "icon", iconName: "close", formAction: "none", ariaLabel: dismissAriaLabel, onClick: dismiss, style: getDismissButtonStyles(style), styleClassNames: { root: styleClassNames === null || styleClassNames === void 0 ? void 0 : styleClassNames.dismissButton } })
          )
        )
      )
    )
  );
});
var internal_default3 = InternalAlert;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/internal-do-not-use-core.js
var Alert4 = React36.forwardRef(({ type = "info", visible = true, style, ...props }, ref) => {
  var _a3, _b;
  const analyticsMetadata = getAnalyticsMetadataProps(props);
  const baseComponentProps = useBaseComponent("Alert", {
    props: { type, visible, dismissible: props.dismissible },
    metadata: {
      hasPersistenceConfig: !!((_a3 = props.persistenceConfig) === null || _a3 === void 0 ? void 0 : _a3.uniqueKey),
      crossServicePersistence: !!((_b = props.persistenceConfig) === null || _b === void 0 ? void 0 : _b.crossServicePersistence)
    }
  }, analyticsMetadata);
  const rootRef = useRef26(null);
  const __internalRootRef = useMergeRefs(rootRef, baseComponentProps.__internalRootRef);
  const { funnelIdentifier, funnelInteractionId, funnelErrorContext, submissionAttempt, funnelState, errorCount } = useFunnel();
  const { stepNumber, stepNameSelector, stepIdentifier, subStepCount, stepErrorContext, subStepConfiguration } = useFunnelStep();
  const { subStepSelector, subStepNameSelector, subStepIdentifier, subStepErrorContext } = useFunnelSubStep();
  const messageSlotId = useUniqueId("alert-");
  useEffect28(() => {
    var _a4, _b2, _c, _d, _e;
    if (funnelInteractionId && visible && type === "error" && funnelState.current !== "complete") {
      const stepName = getTextFromSelector(stepNameSelector);
      const subStepName = getTextFromSelector(subStepNameSelector);
      errorCount.current++;
      const errorIsVisible = ((_c = (_b2 = (_a4 = rootRef.current) === null || _a4 === void 0 ? void 0 : _a4.getBoundingClientRect()) === null || _b2 === void 0 ? void 0 : _b2.width) !== null && _c !== void 0 ? _c : 0) > 0;
      if (errorIsVisible) {
        if (subStepSelector) {
          FunnelMetrics.funnelSubStepError({
            funnelInteractionId,
            funnelIdentifier,
            stepIdentifier,
            subStepSelector,
            subStepName,
            subStepNameSelector,
            stepNumber,
            stepName,
            stepNameSelector,
            subStepAllSelector: getSubStepAllSelector(),
            subStepIdentifier,
            errorContext: analyticsMetadata.errorContext || subStepErrorContext
          });
        } else if (stepNameSelector) {
          FunnelMetrics.funnelStepError({
            funnelInteractionId,
            stepNumber,
            stepNameSelector,
            stepName,
            stepIdentifier,
            currentDocument: (_d = rootRef.current) === null || _d === void 0 ? void 0 : _d.ownerDocument,
            totalSubSteps: subStepCount.current,
            funnelIdentifier,
            subStepAllSelector: getSubStepAllSelector(),
            errorContext: analyticsMetadata.errorContext || stepErrorContext,
            subStepConfiguration: (_e = subStepConfiguration.current) === null || _e === void 0 ? void 0 : _e.get(stepNumber),
            stepErrorSelector: "#" + messageSlotId
          });
        } else {
          FunnelMetrics.funnelError({
            funnelIdentifier,
            funnelInteractionId,
            errorContext: analyticsMetadata.errorContext || funnelErrorContext
          });
        }
      }
      return () => {
        errorCount.current--;
      };
    }
  }, [funnelInteractionId, visible, submissionAttempt, errorCount]);
  const componentAnalyticsMetadata = {
    name: "awsui.Alert",
    label: `.${styles_css_default15.header}`,
    properties: {
      type
    }
  };
  return React36.createElement(internal_default3, { type, visible, ...props, ...baseComponentProps, __internalRootRef, ref, messageSlotId, style, ...getAnalyticsMetadataAttribute({ component: componentAnalyticsMetadata }) });
});
applyDisplayName(Alert4, "Alert");
var internal_do_not_use_core_default = Alert4;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/alert/index.js
var Alert5 = React37.forwardRef((props, ref) => {
  validateProps("Alert", props, ["style"], {}, "console");
  return React37.createElement(internal_do_not_use_core_default, { ref, ...props });
});
applyDisplayName(Alert5, "Alert");
var alert_default = Alert5;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/box/index.js
import React40 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/box/internal-do-not-use-core.js
import React39 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/box/internal.js
import React38 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/box/styles.css.js
var styles_css_default17 = {
  "box": "awsui_box_18wu0_sa0ys_24",
  "p-variant": "awsui_p-variant_18wu0_sa0ys_24",
  "color-default": "awsui_color-default_18wu0_sa0ys_24",
  "b-variant": "awsui_b-variant_18wu0_sa0ys_24",
  "strong-variant": "awsui_strong-variant_18wu0_sa0ys_24",
  "code-variant": "awsui_code-variant_18wu0_sa0ys_24",
  "pre-variant": "awsui_pre-variant_18wu0_sa0ys_24",
  "samp-variant": "awsui_samp-variant_18wu0_sa0ys_24",
  "h1-variant": "awsui_h1-variant_18wu0_sa0ys_28",
  "h2-variant": "awsui_h2-variant_18wu0_sa0ys_28",
  "h3-variant": "awsui_h3-variant_18wu0_sa0ys_28",
  "h4-variant": "awsui_h4-variant_18wu0_sa0ys_28",
  "h5-variant": "awsui_h5-variant_18wu0_sa0ys_28",
  "small-variant": "awsui_small-variant_18wu0_sa0ys_32",
  "a-variant": "awsui_a-variant_18wu0_sa0ys_36",
  "font-size-default": "awsui_font-size-default_18wu0_sa0ys_40",
  "font-weight-default": "awsui_font-weight-default_18wu0_sa0ys_81",
  "key-label-variant": "awsui_key-label-variant_18wu0_sa0ys_123",
  "gen-ai-label-variant": "awsui_gen-ai-label-variant_18wu0_sa0ys_130",
  "value-large-variant": "awsui_value-large-variant_18wu0_sa0ys_137",
  "inline-code-variant": "awsui_inline-code-variant_18wu0_sa0ys_147",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_sa0ys_161",
  "color-inverted": "awsui_color-inverted_18wu0_sa0ys_166",
  "color-text-label": "awsui_color-text-label_18wu0_sa0ys_169",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_sa0ys_172",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_sa0ys_175",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_sa0ys_178",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_sa0ys_181",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_sa0ys_184",
  "color-text-status-warning": "awsui_color-text-status-warning_18wu0_sa0ys_187",
  "color-inherit": "awsui_color-inherit_18wu0_sa0ys_190",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_sa0ys_193",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_sa0ys_198",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_sa0ys_202",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_sa0ys_207",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_sa0ys_212",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_sa0ys_217",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_sa0ys_222",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_sa0ys_227",
  "font-size-display-xl": "awsui_font-size-display-xl_18wu0_sa0ys_232",
  "font-weight-light": "awsui_font-weight-light_18wu0_sa0ys_237",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_sa0ys_240",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_sa0ys_243",
  "t-left": "awsui_t-left_18wu0_sa0ys_250",
  "t-right": "awsui_t-right_18wu0_sa0ys_254",
  "t-center": "awsui_t-center_18wu0_sa0ys_258",
  "p-n": "awsui_p-n_18wu0_sa0ys_267",
  "p-top-n": "awsui_p-top-n_18wu0_sa0ys_272",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_sa0ys_273",
  "p-right-n": "awsui_p-right-n_18wu0_sa0ys_277",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_sa0ys_278",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_sa0ys_282",
  "p-left-n": "awsui_p-left-n_18wu0_sa0ys_287",
  "p-xxxs": "awsui_p-xxxs_18wu0_sa0ys_292",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_sa0ys_297",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_sa0ys_298",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_sa0ys_302",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_sa0ys_303",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_sa0ys_307",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_sa0ys_312",
  "p-xxs": "awsui_p-xxs_18wu0_sa0ys_317",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_sa0ys_322",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_sa0ys_323",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_sa0ys_327",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_sa0ys_328",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_sa0ys_332",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_sa0ys_337",
  "p-xs": "awsui_p-xs_18wu0_sa0ys_342",
  "p-top-xs": "awsui_p-top-xs_18wu0_sa0ys_347",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_sa0ys_348",
  "p-right-xs": "awsui_p-right-xs_18wu0_sa0ys_352",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_sa0ys_353",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_sa0ys_357",
  "p-left-xs": "awsui_p-left-xs_18wu0_sa0ys_362",
  "p-s": "awsui_p-s_18wu0_sa0ys_367",
  "p-top-s": "awsui_p-top-s_18wu0_sa0ys_372",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_sa0ys_373",
  "p-right-s": "awsui_p-right-s_18wu0_sa0ys_377",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_sa0ys_378",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_sa0ys_382",
  "p-left-s": "awsui_p-left-s_18wu0_sa0ys_387",
  "p-m": "awsui_p-m_18wu0_sa0ys_392",
  "p-top-m": "awsui_p-top-m_18wu0_sa0ys_397",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_sa0ys_398",
  "p-right-m": "awsui_p-right-m_18wu0_sa0ys_402",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_sa0ys_403",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_sa0ys_407",
  "p-left-m": "awsui_p-left-m_18wu0_sa0ys_412",
  "p-l": "awsui_p-l_18wu0_sa0ys_287",
  "p-top-l": "awsui_p-top-l_18wu0_sa0ys_422",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_sa0ys_423",
  "p-right-l": "awsui_p-right-l_18wu0_sa0ys_427",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_sa0ys_428",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_sa0ys_432",
  "p-left-l": "awsui_p-left-l_18wu0_sa0ys_437",
  "p-xl": "awsui_p-xl_18wu0_sa0ys_442",
  "p-top-xl": "awsui_p-top-xl_18wu0_sa0ys_447",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_sa0ys_448",
  "p-right-xl": "awsui_p-right-xl_18wu0_sa0ys_452",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_sa0ys_453",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_sa0ys_457",
  "p-left-xl": "awsui_p-left-xl_18wu0_sa0ys_462",
  "p-xxl": "awsui_p-xxl_18wu0_sa0ys_467",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_sa0ys_472",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_sa0ys_473",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_sa0ys_477",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_sa0ys_478",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_sa0ys_482",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_sa0ys_487",
  "p-xxxl": "awsui_p-xxxl_18wu0_sa0ys_492",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_sa0ys_497",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_sa0ys_498",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_sa0ys_502",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_sa0ys_503",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_sa0ys_507",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_sa0ys_512",
  "m-n": "awsui_m-n_18wu0_sa0ys_517",
  "m-top-n": "awsui_m-top-n_18wu0_sa0ys_522",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_sa0ys_523",
  "m-right-n": "awsui_m-right-n_18wu0_sa0ys_527",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_sa0ys_528",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_sa0ys_532",
  "m-left-n": "awsui_m-left-n_18wu0_sa0ys_537",
  "m-xxxs": "awsui_m-xxxs_18wu0_sa0ys_542",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_sa0ys_547",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_sa0ys_548",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_sa0ys_552",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_sa0ys_553",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_sa0ys_557",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_sa0ys_562",
  "m-xxs": "awsui_m-xxs_18wu0_sa0ys_567",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_sa0ys_572",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_sa0ys_573",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_sa0ys_577",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_sa0ys_578",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_sa0ys_582",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_sa0ys_587",
  "m-xs": "awsui_m-xs_18wu0_sa0ys_592",
  "m-top-xs": "awsui_m-top-xs_18wu0_sa0ys_597",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_sa0ys_598",
  "m-right-xs": "awsui_m-right-xs_18wu0_sa0ys_602",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_sa0ys_603",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_sa0ys_607",
  "m-left-xs": "awsui_m-left-xs_18wu0_sa0ys_612",
  "m-s": "awsui_m-s_18wu0_sa0ys_617",
  "m-top-s": "awsui_m-top-s_18wu0_sa0ys_622",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_sa0ys_623",
  "m-right-s": "awsui_m-right-s_18wu0_sa0ys_627",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_sa0ys_628",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_sa0ys_632",
  "m-left-s": "awsui_m-left-s_18wu0_sa0ys_637",
  "m-m": "awsui_m-m_18wu0_sa0ys_642",
  "m-top-m": "awsui_m-top-m_18wu0_sa0ys_647",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_sa0ys_648",
  "m-right-m": "awsui_m-right-m_18wu0_sa0ys_652",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_sa0ys_653",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_sa0ys_657",
  "m-left-m": "awsui_m-left-m_18wu0_sa0ys_662",
  "m-l": "awsui_m-l_18wu0_sa0ys_537",
  "m-top-l": "awsui_m-top-l_18wu0_sa0ys_672",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_sa0ys_673",
  "m-right-l": "awsui_m-right-l_18wu0_sa0ys_677",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_sa0ys_678",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_sa0ys_682",
  "m-left-l": "awsui_m-left-l_18wu0_sa0ys_687",
  "m-xl": "awsui_m-xl_18wu0_sa0ys_692",
  "m-top-xl": "awsui_m-top-xl_18wu0_sa0ys_697",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_sa0ys_698",
  "m-right-xl": "awsui_m-right-xl_18wu0_sa0ys_702",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_sa0ys_703",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_sa0ys_707",
  "m-left-xl": "awsui_m-left-xl_18wu0_sa0ys_712",
  "m-xxl": "awsui_m-xxl_18wu0_sa0ys_717",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_sa0ys_722",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_sa0ys_723",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_sa0ys_727",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_sa0ys_728",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_sa0ys_732",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_sa0ys_737",
  "m-xxxl": "awsui_m-xxxl_18wu0_sa0ys_742",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_sa0ys_747",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_sa0ys_748",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_sa0ys_752",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_sa0ys_753",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_sa0ys_757",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_sa0ys_762",
  "d-block": "awsui_d-block_18wu0_sa0ys_767",
  "d-inline": "awsui_d-inline_18wu0_sa0ys_770",
  "d-inline-block": "awsui_d-inline-block_18wu0_sa0ys_773",
  "d-none": "awsui_d-none_18wu0_sa0ys_776",
  "f-left": "awsui_f-left_18wu0_sa0ys_780",
  "f-right": "awsui_f-right_18wu0_sa0ys_784",
  "visual-accent": "awsui_visual-accent_18wu0_sa0ys_788",
  "visual-accent-radius-xxxs": "awsui_visual-accent-radius-xxxs_18wu0_sa0ys_797",
  "visual-accent-radius-xxs": "awsui_visual-accent-radius-xxs_18wu0_sa0ys_804",
  "visual-accent-radius-xs": "awsui_visual-accent-radius-xs_18wu0_sa0ys_811",
  "visual-accent-radius-s": "awsui_visual-accent-radius-s_18wu0_sa0ys_818",
  "visual-accent-radius-m": "awsui_visual-accent-radius-m_18wu0_sa0ys_825",
  "visual-accent-radius-l": "awsui_visual-accent-radius-l_18wu0_sa0ys_832",
  "visual-accent-radius-xl": "awsui_visual-accent-radius-xl_18wu0_sa0ys_839",
  "visual-accent-radius-xxl": "awsui_visual-accent-radius-xxl_18wu0_sa0ys_846",
  "visual-accent-radius-xxxl": "awsui_visual-accent-radius-xxxl_18wu0_sa0ys_853",
  "visual-accent-radius-full": "awsui_visual-accent-radius-full_18wu0_sa0ys_860",
  "visual-accent-aspect-auto": "awsui_visual-accent-aspect-auto_18wu0_sa0ys_867",
  "visual-accent-aspect-equal": "awsui_visual-accent-aspect-equal_18wu0_sa0ys_872",
  "visual-accent-red": "awsui_visual-accent-red_18wu0_sa0ys_880",
  "visual-accent-yellow": "awsui_visual-accent-yellow_18wu0_sa0ys_885",
  "visual-accent-indigo": "awsui_visual-accent-indigo_18wu0_sa0ys_890",
  "visual-accent-green": "awsui_visual-accent-green_18wu0_sa0ys_895",
  "visual-accent-orange": "awsui_visual-accent-orange_18wu0_sa0ys_900",
  "visual-accent-purple": "awsui_visual-accent-purple_18wu0_sa0ys_905",
  "visual-accent-grey": "awsui_visual-accent-grey_18wu0_sa0ys_910",
  "visual-accent-teal": "awsui_visual-accent-teal_18wu0_sa0ys_915",
  "root": "awsui_root_18wu0_sa0ys_920"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/box/internal.js
function InternalBox({ variant = "div", tagOverride, margin = {}, padding = {}, display, textAlign, float, fontSize, fontWeight, color, visualAccent, children, nativeAttributes, __internalRootRef, ...props }) {
  var _a3;
  const baseProps = getBaseProps(props);
  const marginsClassNamesSuffices = getClassNamesSuffixes(margin);
  const paddingsClassNamesSuffices = getClassNamesSuffixes(padding);
  const accentAspectRatio = (_a3 = visualAccent === null || visualAccent === void 0 ? void 0 : visualAccent.aspectRatio) !== null && _a3 !== void 0 ? _a3 : "auto";
  const className = clsx_m_default(baseProps.className, styles_css_default17.root, styles_css_default17.box, styles_css_default17[`${variant.replace(/^awsui-/, "")}-variant`], visualAccent && styles_css_default17["visual-accent"], visualAccent && styles_css_default17[`visual-accent-${visualAccent.color}`], visualAccent && styles_css_default17[`visual-accent-aspect-${accentAspectRatio}`], (visualAccent === null || visualAccent === void 0 ? void 0 : visualAccent.borderRadius) && styles_css_default17[`visual-accent-radius-${visualAccent.borderRadius}`], marginsClassNamesSuffices.map((suffix) => styles_css_default17[`m-${suffix}`]), paddingsClassNamesSuffices.map((suffix) => styles_css_default17[`p-${suffix}`]), styles_css_default17[`d-${display}`], styles_css_default17[`f-${float}`], styles_css_default17[`color-${color || "default"}`], styles_css_default17[`font-size-${fontSize || "default"}`], styles_css_default17[`font-weight-${fontWeight || "default"}`], styles_css_default17[`t-${textAlign}`]);
  const tabindex = variant === "h1" ? -1 : void 0;
  return React38.createElement(with_native_attributes_default, { ...baseProps, tag: getTag(variant, tagOverride), componentName: "Box", tabIndex: tabindex, nativeAttributes, className, ref: __internalRootRef }, children);
}
var getClassNamesSuffixes = (value) => {
  if (typeof value === "string") {
    return [value];
  }
  const sides = ["top", "right", "bottom", "left", "horizontal", "vertical"];
  return sides.filter((side) => !!value[side]).map((side) => `${side}-${value[side]}`);
};
var getTag = (variant, tagOverride) => {
  if (tagOverride) {
    return tagOverride;
  }
  if (variant === "awsui-value-large") {
    return "span";
  }
  if (variant === "awsui-key-label" || variant === "awsui-gen-ai-label") {
    return "div";
  }
  if (variant === "awsui-inline-code") {
    return "code";
  }
  return variant;
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/box/internal-do-not-use-core.js
function Box5({ variant = "div", margin = {}, padding = {}, ...props }) {
  const baseComponentProps = useBaseComponent("Box", {
    props: {
      color: props.color,
      display: props.display,
      float: props.float,
      fontSize: props.fontSize,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign,
      variant
    }
  });
  return React39.createElement(InternalBox, { variant, margin, padding, ...props, ...baseComponentProps });
}
applyDisplayName(Box5, "Box");

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/box/index.js
var Box6 = (props) => {
  validateProps("Box", props, ["nativeAttributes", "visualAccent"], {}, "console");
  return React40.createElement(Box5, props);
};
applyDisplayName(Box6, "Box");
var box_default = Box6;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/grid/index.js
import React44 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/calculate-once.js
function calculateOnce(callback) {
  let result = void 0;
  return () => {
    if (result === void 0) {
      result = callback();
    }
    return result;
  };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/browser-scrollbar-size.js
var browserScrollbarSize = calculateOnce(() => {
  if (typeof document === "undefined") {
    return { width: 0, height: 0 };
  }
  const scrollDiv = document.createElement("div");
  scrollDiv.style.overflow = "scroll";
  scrollDiv.style.height = "100px";
  scrollDiv.style.width = "100px";
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px";
  scrollDiv.style.left = "-9999px";
  document.body.appendChild(scrollDiv);
  const width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  const height = scrollDiv.offsetHeight - scrollDiv.clientHeight;
  document.body.removeChild(scrollDiv);
  return { width, height };
});

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/breakpoints.js
var BREAKPOINT_MAPPING = [
  ["xl", 1840],
  ["l", 1320],
  ["m", 1120],
  ["s", 912],
  ["xs", 688],
  ["xxs", 465],
  ["default", -1]
];
var mobileBreakpoint = BREAKPOINT_MAPPING.filter((b) => b[0] === "xs")[0][1];
var BREAKPOINTS_DESCENDING = BREAKPOINT_MAPPING.map(([bp]) => bp);
function matchBreakpointMapping(subset, actual) {
  const qualifyingBreakpoints = BREAKPOINT_MAPPING.slice(BREAKPOINTS_DESCENDING.indexOf(actual));
  for (const [breakpoint] of qualifyingBreakpoints) {
    const breakpointValue = subset[breakpoint];
    if (breakpointValue !== void 0) {
      return breakpointValue;
    }
  }
  return null;
}
function getMatchingBreakpoint(width, breakpointFilter, previousBreakpoint) {
  const breakpointSwitchOffset = browserScrollbarSize().width;
  const previousBreakpointIndex = previousBreakpoint === void 0 || previousBreakpoint === null ? -1 : BREAKPOINTS_DESCENDING.indexOf(previousBreakpoint);
  for (let i = 0; i < BREAKPOINT_MAPPING.length; i++) {
    const [breakpoint, breakpointWidth] = BREAKPOINT_MAPPING[i];
    if (breakpointFilter && breakpointFilter.indexOf(breakpoint) === -1) {
      continue;
    }
    let stickyBreakpointWidth = breakpointWidth;
    if (previousBreakpointIndex !== -1) {
      stickyBreakpointWidth += previousBreakpointIndex <= i ? -breakpointSwitchOffset : breakpointSwitchOffset;
    }
    if (width > stickyBreakpointWidth) {
      return breakpoint;
    }
  }
  return "default";
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/container-queries/use-container-breakpoints.js
function useContainerBreakpoints(triggers) {
  const triggersDep = triggers === null || triggers === void 0 ? void 0 : triggers.join();
  return useContainerQuery(
    (rect, previousBreakpoint) => getMatchingBreakpoint(rect.contentBoxWidth, triggers, previousBreakpoint),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [triggersDep]
  );
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/grid/internal.js
import React43 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/is-development.js
var isDevelopment2 = true;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/flatten-children.js
import React42 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/vendor/react-keyed-flatten-children/index.js
var import_react_is = __toESM(require_react_is2());
import { Children as Children2, cloneElement as cloneElement2, isValidElement as isValidElement2 } from "react";
function isFragmentWithChildren(node) {
  return (0, import_react_is.isFragment)(node);
}
function flattenChildren(children, depth = 0, keys = [], componentName2) {
  return Children2.toArray(children).reduce((acc, node, nodeIndex) => {
    if (isFragmentWithChildren(node)) {
      warnOnce(componentName2, "React.Fragment children are flattened in React 18 but not in React 19+. Use arrays instead of fragments for consistent behavior.");
      acc.push(...flattenChildren(node.props.children, depth + 1, keys.concat(node.key || nodeIndex), componentName2));
    } else if (isValidElement2(node)) {
      acc.push(cloneElement2(node, {
        key: keys.concat(String(node.key)).join(".")
      }));
    } else if (typeof node === "string" || typeof node === "number") {
      acc.push(node);
    }
    return acc;
  }, []);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/react-version.js
import React41 from "react";
function getReactMajorVersion() {
  var _a3;
  const versionString = (_a3 = React41.version) === null || _a3 === void 0 ? void 0 : _a3.split(".")[0];
  return versionString ? parseInt(versionString, 10) : NaN;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/flatten-children.js
function flattenChildren2(children, componentName2) {
  const majorVersion = getReactMajorVersion();
  if (!Number.isNaN(majorVersion) && majorVersion < 19) {
    return flattenChildren(children, 0, [], componentName2);
  }
  return React42.Children.toArray(children);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/grid/styles.css.js
var styles_css_default18 = {
  "grid": "awsui_grid_14yj0_1bmt3_9",
  "no-gutters": "awsui_no-gutters_14yj0_1bmt3_45",
  "grid-column": "awsui_grid-column_14yj0_1bmt3_50",
  "colspan-1": "awsui_colspan-1_14yj0_1bmt3_61",
  "push-1": "awsui_push-1_14yj0_1bmt3_65",
  "pull-1": "awsui_pull-1_14yj0_1bmt3_68",
  "colspan-2": "awsui_colspan-2_14yj0_1bmt3_71",
  "push-2": "awsui_push-2_14yj0_1bmt3_75",
  "pull-2": "awsui_pull-2_14yj0_1bmt3_78",
  "colspan-3": "awsui_colspan-3_14yj0_1bmt3_81",
  "push-3": "awsui_push-3_14yj0_1bmt3_85",
  "pull-3": "awsui_pull-3_14yj0_1bmt3_88",
  "colspan-4": "awsui_colspan-4_14yj0_1bmt3_91",
  "push-4": "awsui_push-4_14yj0_1bmt3_95",
  "pull-4": "awsui_pull-4_14yj0_1bmt3_98",
  "colspan-5": "awsui_colspan-5_14yj0_1bmt3_101",
  "push-5": "awsui_push-5_14yj0_1bmt3_105",
  "pull-5": "awsui_pull-5_14yj0_1bmt3_108",
  "colspan-6": "awsui_colspan-6_14yj0_1bmt3_111",
  "push-6": "awsui_push-6_14yj0_1bmt3_115",
  "pull-6": "awsui_pull-6_14yj0_1bmt3_118",
  "colspan-7": "awsui_colspan-7_14yj0_1bmt3_121",
  "push-7": "awsui_push-7_14yj0_1bmt3_125",
  "pull-7": "awsui_pull-7_14yj0_1bmt3_128",
  "colspan-8": "awsui_colspan-8_14yj0_1bmt3_131",
  "push-8": "awsui_push-8_14yj0_1bmt3_135",
  "pull-8": "awsui_pull-8_14yj0_1bmt3_138",
  "colspan-9": "awsui_colspan-9_14yj0_1bmt3_141",
  "push-9": "awsui_push-9_14yj0_1bmt3_145",
  "pull-9": "awsui_pull-9_14yj0_1bmt3_148",
  "colspan-10": "awsui_colspan-10_14yj0_1bmt3_151",
  "push-10": "awsui_push-10_14yj0_1bmt3_155",
  "pull-10": "awsui_pull-10_14yj0_1bmt3_158",
  "colspan-11": "awsui_colspan-11_14yj0_1bmt3_161",
  "push-11": "awsui_push-11_14yj0_1bmt3_165",
  "pull-11": "awsui_pull-11_14yj0_1bmt3_168",
  "colspan-12": "awsui_colspan-12_14yj0_1bmt3_171",
  "push-12": "awsui_push-12_14yj0_1bmt3_175",
  "pull-12": "awsui_pull-12_14yj0_1bmt3_178",
  "push-0": "awsui_push-0_14yj0_1bmt3_181",
  "pull-0": "awsui_pull-0_14yj0_1bmt3_184",
  "offset-1": "awsui_offset-1_14yj0_1bmt3_187",
  "offset-2": "awsui_offset-2_14yj0_1bmt3_190",
  "offset-3": "awsui_offset-3_14yj0_1bmt3_193",
  "offset-4": "awsui_offset-4_14yj0_1bmt3_196",
  "offset-5": "awsui_offset-5_14yj0_1bmt3_199",
  "offset-6": "awsui_offset-6_14yj0_1bmt3_202",
  "offset-7": "awsui_offset-7_14yj0_1bmt3_205",
  "offset-8": "awsui_offset-8_14yj0_1bmt3_208",
  "offset-9": "awsui_offset-9_14yj0_1bmt3_211",
  "offset-10": "awsui_offset-10_14yj0_1bmt3_214",
  "offset-11": "awsui_offset-11_14yj0_1bmt3_217",
  "restore-pointer-events": "awsui_restore-pointer-events_14yj0_1bmt3_221"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/grid/internal.js
var InternalGrid = React43.forwardRef(({ __breakpoint, gridDefinition = [], disableGutters = false, children, __tagOverride, __responsiveClassName, __internalRootRef, ...restProps }, ref) => {
  let [defaultBreakpoint, defaultRef] = useContainerBreakpoints(void 0);
  if (__breakpoint !== void 0) {
    defaultBreakpoint = __breakpoint;
    defaultRef = ref;
  }
  const baseProps = getBaseProps(restProps);
  const flattenedChildren = flattenChildren2(children, "Grid");
  const Tag = __tagOverride !== null && __tagOverride !== void 0 ? __tagOverride : "div";
  if (isDevelopment2) {
    const columnCount = gridDefinition.length;
    const childCount = flattenedChildren.length;
    if (columnCount !== childCount) {
      warnOnce("Grid", `The number of children (${childCount}) does not match the number of columns defined (${columnCount}).`);
    }
  }
  const mergedRef = useMergeRefs(defaultRef, __internalRootRef);
  return React43.createElement(Tag, { ...baseProps, className: clsx_m_default(styles_css_default18.grid, baseProps.className, { [styles_css_default18["no-gutters"]]: disableGutters }, __responsiveClassName ? __responsiveClassName(defaultBreakpoint) : null), ref: mergedRef }, flattenedChildren.map((child, i) => {
    var _a3, _b, _c, _d;
    const key = child && typeof child === "object" ? child.key : void 0;
    return React43.createElement(
      "div",
      { key: key ? String(key) : void 0, className: clsx_m_default(styles_css_default18["grid-column"], getColumnClassNames("colspan", (_a3 = gridDefinition[i]) === null || _a3 === void 0 ? void 0 : _a3.colspan, defaultBreakpoint), getColumnClassNames("offset", (_b = gridDefinition[i]) === null || _b === void 0 ? void 0 : _b.offset, defaultBreakpoint), getColumnClassNames("pull", (_c = gridDefinition[i]) === null || _c === void 0 ? void 0 : _c.pull, defaultBreakpoint), getColumnClassNames("push", (_d = gridDefinition[i]) === null || _d === void 0 ? void 0 : _d.push, defaultBreakpoint)) },
      React43.createElement("div", { className: styles_css_default18["restore-pointer-events"] }, child)
    );
  }));
});
function getColumnClassNames(prop, mapping, breakpoint) {
  if (typeof mapping === "number") {
    return styles_css_default18[`${prop}-${mapping}`];
  }
  if (breakpoint === null || mapping === void 0) {
    return null;
  }
  return styles_css_default18[`${prop}-${matchBreakpointMapping(mapping, breakpoint)}`];
}
var internal_default5 = InternalGrid;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/grid/index.js
function Grid({ gridDefinition = [], disableGutters = false, children, ...restProps }) {
  const baseComponentProps = useBaseComponent("Grid", {
    props: { disableGutters }
  });
  const baseProps = getBaseProps(restProps);
  const [breakpoint, ref] = useContainerBreakpoints(void 0);
  return React44.createElement(internal_default5, { ...baseProps, ...baseComponentProps, ref, __breakpoint: breakpoint, gridDefinition, disableGutters }, children);
}
applyDisplayName(Grid, "Grid");

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/index.js
import React48 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/utils/external-props.js
var getExternalProps = (props) => {
  const externalProps = {};
  for (const propName in props) {
    if (!propName.startsWith("__")) {
      externalProps[propName] = props[propName];
    }
  }
  return externalProps;
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/internal.js
import React47, { useCallback as useCallback13, useEffect as useEffect29, useImperativeHandle as useImperativeHandle6, useRef as useRef27, useState as useState22 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/reset-contexts-for-modal.js
import React45 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/collection-label-context.js
import { createContext as createContext8 } from "react";
var CollectionLabelContext = createContext8({});

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/form-field-context.js
import { createContext as createContext9, useContext as useContext8 } from "react";
var FormFieldContext = createContext9({});

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/info-link-label-context.js
import { createContext as createContext10 } from "react";
var InfoLinkLabelContext = createContext10(void 0);

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/token-inline-context.js
import { createContext as createContext11, useContext as useContext9 } from "react";
var defaultValue3 = {
  isInlineToken: false
};
var TokenInlineContext = createContext11(defaultValue3);
function useTokenInlineContext() {
  return useContext9(TokenInlineContext);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/reset-contexts-for-modal.js
var ResetContextsForModal = ({ children }) => React45.createElement(
  ButtonContext.Provider,
  { value: { onClick: () => {
  } } },
  React45.createElement(
    CollectionLabelContext.Provider,
    { value: { assignId: () => {
    } } },
    React45.createElement(
      FormFieldContext.Provider,
      { value: {} },
      React45.createElement(
        InfoLinkLabelContext.Provider,
        { value: "" },
        React45.createElement(
          LinkDefaultVariantContext.Provider,
          { value: defaultValue2 },
          React45.createElement(
            TokenInlineContext.Provider,
            { value: defaultValue3 },
            React45.createElement(SingleTabStopNavigationReset, null, children)
          )
        )
      )
    )
  )
);
var reset_contexts_for_modal_default = ResetContextsForModal;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-portal-mode-classes/index.js
function usePortalModeClasses(ref, options) {
  const colorMode = useCurrentMode(ref);
  const densityMode = useDensityMode(ref);
  const context = useVisualContext(ref);
  const oneTheme = useOneTheme();
  const visualRefreshWithClass = useVisualRefresh() && !ALWAYS_VISUAL_REFRESH && !oneTheme;
  return clsx_m_default({
    "awsui-polaris-dark-mode awsui-dark-mode": colorMode === "dark",
    "awsui-polaris-compact-mode awsui-compact-mode": densityMode === "compact",
    "awsui-visual-refresh": visualRefreshWithClass,
    "awsui-one-theme": oneTheme,
    [`awsui-context-${context}`]: context && !(options === null || options === void 0 ? void 0 : options.resetVisualContext)
  });
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/conditional-live-region.js
import React46 from "react";
var ConditionalLiveRegion = ({ condition, children }) => {
  if (condition) {
    return React46.createElement(internal_default2, null, children);
  }
  return React46.createElement(React46.Fragment, null, children);
};
var conditional_live_region_default = ConditionalLiveRegion;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/internal.js
var internal_default6 = React47.forwardRef(InternalPopover);
function InternalPopover({ position = "right", size = "medium", fixedWidth = false, triggerType = "text", dismissButton = true, children, header, content, triggerAriaLabel, wrapTriggerText = true, isInline = false, renderWithPortal = false, __onOpen, __internalRootRef, __closeAnalyticsAction, __visible: controlledVisible, __onVisibleChange: onVisibleChange, ...restProps }, ref) {
  const baseProps = getBaseProps(restProps);
  const triggerRef = useRef27(null);
  const popoverRef = useRef27(null);
  const i18n = useInternalI18n("popover");
  const dismissAriaLabel = i18n("dismissAriaLabel", restProps.dismissAriaLabel);
  const [internalVisible, setInternalVisible] = useState22(false);
  const isControlled = controlledVisible !== void 0;
  const visible = isControlled ? controlledVisible : internalVisible;
  const updateVisible = useCallback13((newVisible) => {
    if (isControlled) {
      fireNonCancelableEvent(onVisibleChange, { visible: newVisible });
    } else {
      setInternalVisible(newVisible);
    }
  }, [isControlled, onVisibleChange]);
  const focusTrigger = useCallback13(() => {
    var _a3, _b;
    if (["text", "text-inline"].includes(triggerType)) {
      (_a3 = triggerRef.current) === null || _a3 === void 0 ? void 0 : _a3.focus();
    } else if (triggerRef.current) {
      (_b = getFirstFocusable2(triggerRef.current)) === null || _b === void 0 ? void 0 : _b.focus();
    }
  }, [triggerType]);
  const onTriggerClick = useCallback13(() => {
    fireNonCancelableEvent(__onOpen);
    updateVisible(true);
  }, [__onOpen, updateVisible]);
  const onDismiss = useCallback13(() => {
    updateVisible(false);
    focusTrigger();
  }, [focusTrigger, updateVisible]);
  const onTriggerKeyDown = useCallback13((event) => {
    const isEscapeKey = event.keyCode === KeyCode2.escape;
    const isTabKey = event.keyCode === KeyCode2.tab;
    if (isEscapeKey && visible) {
      event.stopPropagation();
    }
    if (isTabKey || isEscapeKey) {
      updateVisible(false);
    }
  }, [visible, updateVisible]);
  useImperativeHandle6(ref, () => ({
    dismiss: () => {
      updateVisible(false);
    },
    focus: () => {
      updateVisible(false);
      focusTrigger();
    }
  }), [updateVisible, focusTrigger]);
  const clickFrameId = useRef27(null);
  useEffect29(() => {
    if (!triggerRef.current) {
      return;
    }
    const document2 = triggerRef.current.ownerDocument;
    const onDocumentClick = () => {
      if (clickFrameId.current === null) {
        updateVisible(false);
      }
    };
    document2.addEventListener("mousedown", onDocumentClick);
    return () => {
      document2.removeEventListener("mousedown", onDocumentClick);
    };
  }, [updateVisible]);
  const popoverClasses = usePortalModeClasses(triggerRef, { resetVisualContext: true });
  const { isInlineToken } = useTokenInlineContext();
  const triggerProps = {
    // https://github.com/microsoft/TypeScript/issues/36659
    ref: triggerRef,
    onClick: onTriggerClick,
    onKeyDown: onTriggerKeyDown,
    className: clsx_m_default(styles_css_default4.trigger, styles_css_default4[`trigger-type-${triggerType}`], isInlineToken && styles_css_default4["in-inline-token"])
  };
  const { tabIndex: triggerTabIndex } = useSingleTabStopNavigation(triggerRef);
  const referrerId = useUniqueId();
  const popoverContent = React47.createElement(
    "div",
    { className: clsx_m_default(popoverClasses, !renderWithPortal && styles_css_default4["popover-inline-content"]), "data-awsui-referrer-id": referrerId },
    React47.createElement(
      PopoverContainer,
      { size, fixedWidth, position, trackRef: triggerRef, arrow: (position2) => React47.createElement(arrow_default, { position: position2 }), renderWithPortal, zIndex: renderWithPortal ? 7e3 : void 0 },
      React47.createElement(
        LinkDefaultVariantContext.Provider,
        { value: { defaultVariant: "primary" } },
        React47.createElement(
          body_default,
          { dismissButton, dismissAriaLabel, header, onDismiss, overflowVisible: "both", closeAnalyticsAction: __closeAnalyticsAction },
          React47.createElement(conditional_live_region_default, { condition: !dismissButton }, content)
        )
      )
    )
  );
  const mergedRef = useMergeRefs(popoverRef, __internalRootRef);
  return React47.createElement(
    "span",
    { ...baseProps, className: clsx_m_default(styles_css_default4.root, baseProps.className, triggerType === "filtering-token" && styles_css_default4["root-filtering-token"], isInline && styles_css_default4["no-wrap"]), ref: mergedRef, onMouseDown: () => {
      clickFrameId.current = requestAnimationFrame(() => {
        clickFrameId.current = null;
      });
    } },
    ["text", "text-inline"].includes(triggerType) ? React47.createElement("button", { ...triggerProps, className: clsx_m_default(triggerProps.className, wrapTriggerText === false && styles_css_default4["overflow-ellipsis"]), tabIndex: triggerTabIndex, type: "button", "aria-haspopup": "dialog", id: referrerId, "aria-label": triggerAriaLabel }, children) : React47.createElement("span", { ...triggerProps, id: referrerId }, children),
    visible && React47.createElement(reset_contexts_for_modal_default, null, renderWithPortal ? React47.createElement(Portal, null, popoverContent) : popoverContent)
  );
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/popover/index.js
var Popover = React48.forwardRef(({ position = "right", size = "medium", fixedWidth = false, triggerType = "text", dismissButton = true, renderWithPortal = false, wrapTriggerText = true, header, ...rest }, ref) => {
  if (isDevelopment2) {
    if (dismissButton && !header) {
      warnOnce("Popover", `You should provide a \`header\` when \`dismissButton\` is true.`);
    }
  }
  const baseComponentProps = useBaseComponent("Popover", {
    props: { dismissButton, fixedWidth, position, renderWithPortal, size, triggerType }
  });
  const externalProps = getExternalProps(rest);
  return React48.createElement(internal_default6, { ref, header, position, size, fixedWidth, triggerType, dismissButton, renderWithPortal, wrapTriggerText, ...externalProps, ...baseComponentProps });
});
applyDisplayName(Popover, "Popover");
var popover_default = Popover;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/status-indicator/index.js
import React51 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/status-indicator/internal-do-not-use-core.js
import React50 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/status-indicator/internal.js
import React49 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/status-indicator/styles.css.js
var styles_css_default19 = {
  "icon-shake": "awsui_icon-shake_1cbgc_195ll_13",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_195ll_1",
  "container-fade-in": "awsui_container-fade-in_1cbgc_195ll_41",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_195ll_1",
  "root": "awsui_root_1cbgc_195ll_63",
  "status-error": "awsui_status-error_1cbgc_195ll_72",
  "status-warning": "awsui_status-warning_1cbgc_195ll_75",
  "status-success": "awsui_status-success_1cbgc_195ll_78",
  "status-info": "awsui_status-info_1cbgc_195ll_81",
  "status-stopped": "awsui_status-stopped_1cbgc_195ll_84",
  "status-pending": "awsui_status-pending_1cbgc_195ll_87",
  "status-in-progress": "awsui_status-in-progress_1cbgc_195ll_90",
  "status-loading": "awsui_status-loading_1cbgc_195ll_93",
  "status-not-started": "awsui_status-not-started_1cbgc_195ll_96",
  "status-log": "awsui_status-log_1cbgc_195ll_99",
  "color-override-red": "awsui_color-override-red_1cbgc_195ll_102",
  "color-override-grey": "awsui_color-override-grey_1cbgc_195ll_105",
  "color-override-blue": "awsui_color-override-blue_1cbgc_195ll_108",
  "color-override-green": "awsui_color-override-green_1cbgc_195ll_111",
  "color-override-yellow": "awsui_color-override-yellow_1cbgc_195ll_114",
  "embedded": "awsui_embedded_1cbgc_195ll_117",
  "container": "awsui_container_1cbgc_195ll_41",
  "display-inline": "awsui_display-inline_1cbgc_195ll_175",
  "icon": "awsui_icon_1cbgc_195ll_13",
  "display-inline-block": "awsui_display-inline-block_1cbgc_195ll_186",
  "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_195ll_204"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/status-indicator/internal.js
var typeToIcon2 = (size) => {
  const spinnerSize = size === "x-small" ? "x-small" : "normal";
  return {
    error: React49.createElement(internal_default, { name: "status-negative", size }),
    warning: React49.createElement(internal_default, { name: "status-warning", size }),
    success: React49.createElement(internal_default, { name: "status-positive", size }),
    info: React49.createElement(internal_default, { name: "status-info", size }),
    stopped: React49.createElement(internal_default, { name: "status-stopped", size }),
    pending: React49.createElement(internal_default, { name: "status-pending", size }),
    "in-progress": React49.createElement(internal_default, { name: "status-in-progress", size }),
    loading: React49.createElement(InternalSpinner, { size: spinnerSize }),
    "not-started": React49.createElement(internal_default, { name: "status-not-started", size }),
    log: React49.createElement(internal_default, { name: "dot", size })
  };
};
function InternalStatusIcon({ type, iconAriaLabel, animate, display, size = "normal" }) {
  return React49.createElement(
    "span",
    { className: clsx_m_default(styles_css_default19.icon, animate && styles_css_default19["icon-shake"]), "aria-label": iconAriaLabel, role: iconAriaLabel ? "img" : void 0 },
    typeToIcon2(size)[type],
    display === "inline" && React49.createElement(React49.Fragment, null, "\xA0")
  );
}
function StatusIndicator({ type, children, iconAriaLabel, colorOverride, wrapText = true, nativeAttributes, __animate = false, __internalRootRef, __size = isThemeActive(Theme.OneTheme) ? "x-small" : "normal", __display = "inline-block", __embedded = false, ...rest }) {
  const baseProps = getBaseProps(rest);
  return React49.createElement(
    with_native_attributes_default,
    { ...baseProps, tag: "span", componentName: "StatusIndicator", nativeAttributes, className: clsx_m_default(styles_css_default19.root, styles_css_default19[`status-${type}`], __embedded && styles_css_default19.embedded, {
      [styles_css_default19[`color-override-${colorOverride}`]]: colorOverride
    }, baseProps.className), ref: __internalRootRef },
    React49.createElement(
      "span",
      { className: clsx_m_default(styles_css_default19.container, styles_css_default19[`display-${__display}`], wrapText === false && styles_css_default19["overflow-ellipsis"], __animate && styles_css_default19["container-fade-in"]) },
      React49.createElement(InternalStatusIcon, { type, iconAriaLabel, animate: __animate, display: __display, size: __size }),
      React49.createElement("span", null, children)
    )
  );
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/status-indicator/internal-do-not-use-core.js
function StatusIndicator2({ type = "success", wrapText = true, ...props }) {
  const baseComponentProps = useBaseComponent("StatusIndicator", {
    props: { colorOverride: props.colorOverride, type, wrapText }
  });
  return React50.createElement(StatusIndicator, { type, wrapText, ...props, ...baseComponentProps });
}
applyDisplayName(StatusIndicator2, "StatusIndicator");

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/status-indicator/index.js
var StatusIndicator3 = (props) => {
  validateProps("StatusIndicator", props, ["nativeAttributes"], {}, "console");
  return React51.createElement(StatusIndicator2, props);
};
applyDisplayName(StatusIndicator3, "StatusIndicator");
var status_indicator_default = StatusIndicator3;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/space-between/index.js
import React54 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/space-between/internal-do-not-use-core.js
import React53 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/space-between/internal.js
import React52, { forwardRef as forwardRef2 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/space-between/styles.css.js
var styles_css_default20 = {
  "root": "awsui_root_18582_1iw89_9",
  "child": "awsui_child_18582_1iw89_13",
  "horizontal": "awsui_horizontal_18582_1iw89_24",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_1iw89_28",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_1iw89_31",
  "horizontal-xs": "awsui_horizontal-xs_18582_1iw89_34",
  "horizontal-s": "awsui_horizontal-s_18582_1iw89_37",
  "horizontal-m": "awsui_horizontal-m_18582_1iw89_40",
  "horizontal-l": "awsui_horizontal-l_18582_1iw89_43",
  "horizontal-xl": "awsui_horizontal-xl_18582_1iw89_46",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_1iw89_49",
  "vertical": "awsui_vertical_18582_1iw89_56",
  "vertical-xxxs": "awsui_vertical-xxxs_18582_1iw89_59",
  "vertical-xxs": "awsui_vertical-xxs_18582_1iw89_62",
  "vertical-xs": "awsui_vertical-xs_18582_1iw89_65",
  "vertical-s": "awsui_vertical-s_18582_1iw89_68",
  "vertical-m": "awsui_vertical-m_18582_1iw89_71",
  "vertical-l": "awsui_vertical-l_18582_1iw89_74",
  "vertical-xl": "awsui_vertical-xl_18582_1iw89_77",
  "vertical-xxl": "awsui_vertical-xxl_18582_1iw89_80",
  "align-center": "awsui_align-center_18582_1iw89_84",
  "align-start": "awsui_align-start_18582_1iw89_88",
  "align-end": "awsui_align-end_18582_1iw89_92",
  "child-aligned": "awsui_child-aligned_18582_1iw89_96"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/space-between/internal.js
var InternalSpaceBetween = forwardRef2(({ direction = "vertical", size, children, alignItems, nativeAttributes, __internalRootRef, ...props }, ref) => {
  const mergedRef = useMergeRefs(ref, __internalRootRef);
  const baseProps = getBaseProps(props);
  const flattenedChildren = flattenChildren2(children, "SpaceBetween");
  const propagateAlignment = alignItems && direction === "horizontal";
  return React52.createElement(with_native_attributes_default, { ...baseProps, tag: "div", componentName: "SpaceBetween", nativeAttributes, className: clsx_m_default(baseProps.className, styles_css_default20.root, styles_css_default20[direction], styles_css_default20[`${direction}-${size}`], alignItems && styles_css_default20[`align-${alignItems}`]), ref: mergedRef }, flattenedChildren.map((child) => {
    const key = child && typeof child === "object" ? child.key : void 0;
    return React52.createElement("div", { key: key ? String(key) : void 0, className: clsx_m_default(styles_css_default20.child, propagateAlignment && styles_css_default20["child-aligned"]) }, child);
  }));
});
var internal_default7 = InternalSpaceBetween;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/space-between/internal-do-not-use-core.js
function SpaceBetween6({ direction = "vertical", ...props }) {
  const baseComponentProps = useBaseComponent("SpaceBetween", {
    props: { alignItems: props.alignItems, direction, size: props.size }
  });
  return React53.createElement(internal_default7, { direction, ...props, ...baseComponentProps });
}
applyDisplayName(SpaceBetween6, "SpaceBetween");

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/space-between/index.js
var SpaceBetween7 = (props) => {
  validateProps("SpaceBetween", props, ["nativeAttributes"], {}, "console");
  return React54.createElement(SpaceBetween6, props);
};
applyDisplayName(SpaceBetween7, "SpaceBetween");
var space_between_default = SpaceBetween7;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/text-content/index.js
import React55 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/text-content/styles.css.js
var styles_css_default21 = {
  "text-content": "awsui_text-content_6absk_b8nos_10"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/text-content/index.js
function TextContent({ children, ...props }) {
  const { __internalRootRef } = useBaseComponent("TextContent");
  const baseProps = getBaseProps(props);
  const className = clsx_m_default(baseProps.className, styles_css_default21["text-content"]);
  return React55.createElement("div", { ...baseProps, className, ref: __internalRootRef }, children);
}
applyDisplayName(TextContent, "TextContent");

// ../../node_modules/react-intl/index.js
import * as React56 from "react";

// ../../node_modules/@formatjs/intl/node_modules/@formatjs/fast-memoize/index.js
function memoize2(fn, options) {
  const cache = options && options.cache ? options.cache : cacheDefault2;
  const serializer = options && options.serializer ? options.serializer : serializerDefault2;
  return (options && options.strategy ? options.strategy : strategyDefault2)(fn, {
    cache,
    serializer
  });
}
function isPrimitive2(value) {
  return value == null || typeof value === "number" || typeof value === "boolean";
}
function monadic2(fn, cache, serializer, arg) {
  const cacheKey = isPrimitive2(arg) ? arg : serializer(arg);
  let computedValue = cache.get(cacheKey);
  if (typeof computedValue === "undefined") {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function variadic2(fn, cache, serializer) {
  const args = Array.prototype.slice.call(arguments, 3);
  const cacheKey = serializer(args);
  let computedValue = cache.get(cacheKey);
  if (typeof computedValue === "undefined") {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function assemble2(fn, context, strategy, cache, serialize) {
  return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault2(fn, options) {
  const strategy = fn.length === 1 ? monadic2 : variadic2;
  return assemble2(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic2(fn, options) {
  return assemble2(fn, this, variadic2, options.cache.create(), options.serializer);
}
function strategyMonadic2(fn, options) {
  return assemble2(fn, this, monadic2, options.cache.create(), options.serializer);
}
var serializerDefault2 = function() {
  return JSON.stringify(arguments);
};
var ObjectWithoutPrototypeCache2 = class {
  constructor() {
    this.cache = /* @__PURE__ */ Object.create(null);
  }
  get(key) {
    return this.cache[key];
  }
  set(key, value) {
    this.cache[key] = value;
  }
};
var cacheDefault2 = { create: function create2() {
  return new ObjectWithoutPrototypeCache2();
} };
var strategies2 = {
  variadic: strategyVariadic2,
  monadic: strategyMonadic2
};

// ../../node_modules/@formatjs/intl/node_modules/@formatjs/icu-skeleton-parser/index.js
var DATE_TIME_REGEX2 = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton2(skeleton) {
  const result = {};
  skeleton.replace(DATE_TIME_REGEX2, (match) => {
    const len = match.length;
    switch (match[0]) {
      case "G":
        result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
        break;
      case "y":
        result.year = len === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        result.month = [
          "numeric",
          "2-digit",
          "short",
          "long",
          "narrow"
        ][len - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        result.day = ["numeric", "2-digit"][len - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
        break;
      case "e":
        if (len < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        result.weekday = [
          "short",
          "long",
          "narrow",
          "short"
        ][len - 3];
        break;
      case "c":
        if (len < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        result.weekday = [
          "short",
          "long",
          "narrow",
          "short"
        ][len - 3];
        break;
      case "a":
        result.hour12 = true;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        result.hourCycle = "h12";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "H":
        result.hourCycle = "h23";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "K":
        result.hourCycle = "h11";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "k":
        result.hourCycle = "h24";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        result.minute = ["numeric", "2-digit"][len - 1];
        break;
      case "s":
        result.second = ["numeric", "2-digit"][len - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        result.timeZoneName = len < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  });
  return result;
}
var WHITE_SPACE_REGEX2 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function parseNumberSkeletonFromString2(skeleton) {
  if (skeleton.length === 0)
    throw new Error("Number skeleton cannot be empty");
  const stringTokens = skeleton.split(WHITE_SPACE_REGEX2).filter((x) => x.length > 0);
  const tokens = [];
  for (const stringToken of stringTokens) {
    let stemAndOptions = stringToken.split("/");
    if (stemAndOptions.length === 0)
      throw new Error("Invalid number skeleton");
    const [stem, ...options] = stemAndOptions;
    for (const option of options)
      if (option.length === 0)
        throw new Error("Invalid number skeleton");
    tokens.push({
      stem,
      options
    });
  }
  return tokens;
}
function icuUnitToEcma2(unit) {
  return unit.replace(/^(.*?)-/, "");
}
var FRACTION_PRECISION_REGEX2 = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX2 = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX2 = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX2 = /^(0+)$/;
function parseSignificantPrecision2(str) {
  const result = {};
  if (str[str.length - 1] === "r")
    result.roundingPriority = "morePrecision";
  else if (str[str.length - 1] === "s")
    result.roundingPriority = "lessPrecision";
  str.replace(SIGNIFICANT_PRECISION_REGEX2, function(_, g1, g2) {
    if (typeof g2 !== "string") {
      result.minimumSignificantDigits = g1.length;
      result.maximumSignificantDigits = g1.length;
    } else if (g2 === "+")
      result.minimumSignificantDigits = g1.length;
    else if (g1[0] === "#")
      result.maximumSignificantDigits = g1.length;
    else {
      result.minimumSignificantDigits = g1.length;
      result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
    }
    return "";
  });
  return result;
}
function parseSign2(str) {
  switch (str) {
    case "sign-auto":
      return { signDisplay: "auto" };
    case "sign-accounting":
    case "()":
      return { currencySign: "accounting" };
    case "sign-always":
    case "+!":
      return { signDisplay: "always" };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return { signDisplay: "exceptZero" };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return { signDisplay: "never" };
  }
}
function parseConciseScientificAndEngineeringStem2(stem) {
  let result;
  if (stem[0] === "E" && stem[1] === "E") {
    result = { notation: "engineering" };
    stem = stem.slice(2);
  } else if (stem[0] === "E") {
    result = { notation: "scientific" };
    stem = stem.slice(1);
  }
  if (result) {
    const signDisplay = stem.slice(0, 2);
    if (signDisplay === "+!") {
      result.signDisplay = "always";
      stem = stem.slice(2);
    } else if (signDisplay === "+?") {
      result.signDisplay = "exceptZero";
      stem = stem.slice(2);
    }
    if (!CONCISE_INTEGER_WIDTH_REGEX2.test(stem))
      throw new Error("Malformed concise eng/scientific notation");
    result.minimumIntegerDigits = stem.length;
  }
  return result;
}
function parseNotationOptions2(opt) {
  const result = {};
  const signOpts = parseSign2(opt);
  if (signOpts)
    return signOpts;
  return result;
}
function parseNumberSkeleton2(tokens) {
  let result = {};
  for (const token of tokens) {
    switch (token.stem) {
      case "percent":
      case "%":
        result.style = "percent";
        continue;
      case "%x100":
        result.style = "percent";
        result.scale = 100;
        continue;
      case "currency":
        result.style = "currency";
        result.currency = token.options[0];
        continue;
      case "group-off":
      case ",_":
        result.useGrouping = false;
        continue;
      case "precision-integer":
      case ".":
        result.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        result.style = "unit";
        result.unit = icuUnitToEcma2(token.options[0]);
        continue;
      case "compact-short":
      case "K":
        result.notation = "compact";
        result.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        result.notation = "compact";
        result.compactDisplay = "long";
        continue;
      case "scientific":
        result = {
          ...result,
          notation: "scientific",
          ...token.options.reduce((all, opt) => ({
            ...all,
            ...parseNotationOptions2(opt)
          }), {})
        };
        continue;
      case "engineering":
        result = {
          ...result,
          notation: "engineering",
          ...token.options.reduce((all, opt) => ({
            ...all,
            ...parseNotationOptions2(opt)
          }), {})
        };
        continue;
      case "notation-simple":
        result.notation = "standard";
        continue;
      case "unit-width-narrow":
        result.currencyDisplay = "narrowSymbol";
        result.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        result.currencyDisplay = "code";
        result.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        result.currencyDisplay = "name";
        result.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        result.currencyDisplay = "symbol";
        continue;
      case "scale":
        result.scale = parseFloat(token.options[0]);
        continue;
      case "rounding-mode-floor":
        result.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        result.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        result.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        result.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        result.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        result.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        result.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (token.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        token.options[0].replace(INTEGER_WIDTH_REGEX2, function(_, g1, g2, g3, g4, g5) {
          if (g1)
            result.minimumIntegerDigits = g2.length;
          else if (g3 && g4)
            throw new Error("We currently do not support maximum integer digits");
          else if (g5)
            throw new Error("We currently do not support exact integer digits");
          return "";
        });
        continue;
    }
    if (CONCISE_INTEGER_WIDTH_REGEX2.test(token.stem)) {
      result.minimumIntegerDigits = token.stem.length;
      continue;
    }
    if (FRACTION_PRECISION_REGEX2.test(token.stem)) {
      if (token.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      token.stem.replace(FRACTION_PRECISION_REGEX2, function(_, g1, g2, g3, g4, g5) {
        if (g2 === "*")
          result.minimumFractionDigits = g1.length;
        else if (g3 && g3[0] === "#")
          result.maximumFractionDigits = g3.length;
        else if (g4 && g5) {
          result.minimumFractionDigits = g4.length;
          result.maximumFractionDigits = g4.length + g5.length;
        } else {
          result.minimumFractionDigits = g1.length;
          result.maximumFractionDigits = g1.length;
        }
        return "";
      });
      const opt = token.options[0];
      if (opt === "w")
        result = {
          ...result,
          trailingZeroDisplay: "stripIfInteger"
        };
      else if (opt)
        result = {
          ...result,
          ...parseSignificantPrecision2(opt)
        };
      continue;
    }
    if (SIGNIFICANT_PRECISION_REGEX2.test(token.stem)) {
      result = {
        ...result,
        ...parseSignificantPrecision2(token.stem)
      };
      continue;
    }
    const signOpts = parseSign2(token.stem);
    if (signOpts)
      result = {
        ...result,
        ...signOpts
      };
    const conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem2(token.stem);
    if (conciseScientificAndEngineeringOpts)
      result = {
        ...result,
        ...conciseScientificAndEngineeringOpts
      };
  }
  return result;
}

// ../../node_modules/@formatjs/intl/node_modules/@formatjs/icu-messageformat-parser/index.js
var ErrorKind2 = /* @__PURE__ */ function(ErrorKind4) {
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
  ErrorKind4[ErrorKind4["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
  ErrorKind4[ErrorKind4["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
  ErrorKind4[ErrorKind4["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
  ErrorKind4[ErrorKind4["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
  ErrorKind4[ErrorKind4["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
  ErrorKind4[ErrorKind4["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
  ErrorKind4[ErrorKind4["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
  ErrorKind4[ErrorKind4["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
  ErrorKind4[ErrorKind4["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
  ErrorKind4[ErrorKind4["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
  ErrorKind4[ErrorKind4["INVALID_TAG"] = 23] = "INVALID_TAG";
  ErrorKind4[ErrorKind4["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
  ErrorKind4[ErrorKind4["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
  ErrorKind4[ErrorKind4["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
  return ErrorKind4;
}({});
var TYPE2 = /* @__PURE__ */ function(TYPE3) {
  TYPE3[TYPE3["literal"] = 0] = "literal";
  TYPE3[TYPE3["argument"] = 1] = "argument";
  TYPE3[TYPE3["number"] = 2] = "number";
  TYPE3[TYPE3["date"] = 3] = "date";
  TYPE3[TYPE3["time"] = 4] = "time";
  TYPE3[TYPE3["select"] = 5] = "select";
  TYPE3[TYPE3["plural"] = 6] = "plural";
  TYPE3[TYPE3["pound"] = 7] = "pound";
  TYPE3[TYPE3["tag"] = 8] = "tag";
  return TYPE3;
}({});
function isLiteralElement2(el) {
  return el.type === 0;
}
function isArgumentElement2(el) {
  return el.type === 1;
}
function isNumberElement2(el) {
  return el.type === 2;
}
function isDateElement2(el) {
  return el.type === 3;
}
function isTimeElement2(el) {
  return el.type === 4;
}
function isSelectElement2(el) {
  return el.type === 5;
}
function isPluralElement2(el) {
  return el.type === 6;
}
function isPoundElement2(el) {
  return el.type === 7;
}
function isTagElement2(el) {
  return el.type === 8;
}
function isNumberSkeleton2(el) {
  return !!(el && typeof el === "object" && el.type === 0);
}
function isDateTimeSkeleton2(el) {
  return !!(el && typeof el === "object" && el.type === 1);
}
var SPACE_SEPARATOR_REGEX2 = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var timeData2 = {
  "001": ["H", "h"],
  "419": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "AC": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "AD": ["H", "hB"],
  "AE": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "AF": [
    "H",
    "hb",
    "hB",
    "h"
  ],
  "AG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "AI": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "AL": [
    "h",
    "H",
    "hB"
  ],
  "AM": ["H", "hB"],
  "AO": ["H", "hB"],
  "AR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "AS": ["h", "H"],
  "AT": ["H", "hB"],
  "AU": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "AW": ["H", "hB"],
  "AX": ["H"],
  "AZ": [
    "H",
    "hB",
    "h"
  ],
  "BA": [
    "H",
    "hB",
    "h"
  ],
  "BB": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BD": [
    "h",
    "hB",
    "H"
  ],
  "BE": ["H", "hB"],
  "BF": ["H", "hB"],
  "BG": [
    "H",
    "hB",
    "h"
  ],
  "BH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "BI": ["H", "h"],
  "BJ": ["H", "hB"],
  "BL": ["H", "hB"],
  "BM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BN": [
    "hb",
    "hB",
    "h",
    "H"
  ],
  "BO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "BQ": ["H"],
  "BR": ["H", "hB"],
  "BS": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BT": ["h", "H"],
  "BW": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "BY": ["H", "h"],
  "BZ": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CA": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "CC": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CD": ["hB", "H"],
  "CF": [
    "H",
    "h",
    "hB"
  ],
  "CG": ["H", "hB"],
  "CH": [
    "H",
    "hB",
    "h"
  ],
  "CI": ["H", "hB"],
  "CK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CL": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CM": [
    "H",
    "h",
    "hB"
  ],
  "CN": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "CO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CP": ["H"],
  "CR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CU": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CV": ["H", "hB"],
  "CW": ["H", "hB"],
  "CX": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CY": [
    "h",
    "H",
    "hb",
    "hB"
  ],
  "CZ": ["H"],
  "DE": ["H", "hB"],
  "DG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "DJ": ["h", "H"],
  "DK": ["H"],
  "DM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "DO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "DZ": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "EA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "EC": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "EE": ["H", "hB"],
  "EG": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "EH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ER": ["h", "H"],
  "ES": [
    "H",
    "hB",
    "h",
    "hb"
  ],
  "ET": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "FI": ["H"],
  "FJ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "FK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "FM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "FO": ["H", "h"],
  "FR": ["H", "hB"],
  "GA": ["H", "hB"],
  "GB": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GD": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GE": [
    "H",
    "hB",
    "h"
  ],
  "GF": ["H", "hB"],
  "GG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GH": ["h", "H"],
  "GI": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GL": ["H", "h"],
  "GM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GN": ["H", "hB"],
  "GP": ["H", "hB"],
  "GQ": [
    "H",
    "hB",
    "h",
    "hb"
  ],
  "GR": [
    "h",
    "H",
    "hb",
    "hB"
  ],
  "GS": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GT": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "GU": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GW": ["H", "hB"],
  "GY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "HK": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "HN": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "HR": ["H", "hB"],
  "HU": ["H", "h"],
  "IC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ID": ["H"],
  "IE": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IL": ["H", "hB"],
  "IM": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IN": ["h", "H"],
  "IO": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IQ": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "IR": ["hB", "H"],
  "IS": ["H"],
  "IT": ["H", "hB"],
  "JE": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "JM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "JO": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "JP": [
    "H",
    "K",
    "h"
  ],
  "KE": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "KG": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "KH": [
    "hB",
    "h",
    "H",
    "hb"
  ],
  "KI": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KM": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "KN": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KP": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "KR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "KW": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "KY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KZ": ["H", "hB"],
  "LA": [
    "H",
    "hb",
    "hB",
    "h"
  ],
  "LB": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "LC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "LI": [
    "H",
    "hB",
    "h"
  ],
  "LK": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "LR": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "LS": ["h", "H"],
  "LT": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "LU": [
    "H",
    "h",
    "hB"
  ],
  "LV": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "LY": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "MC": ["H", "hB"],
  "MD": ["H", "hB"],
  "ME": [
    "H",
    "hB",
    "h"
  ],
  "MF": ["H", "hB"],
  "MG": ["H", "h"],
  "MH": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "ML": ["H"],
  "MM": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "MN": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "MO": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MP": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MQ": ["H", "hB"],
  "MR": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MS": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "MT": ["H", "h"],
  "MU": ["H", "h"],
  "MV": ["H", "h"],
  "MW": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MX": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "MY": [
    "hb",
    "hB",
    "h",
    "H"
  ],
  "MZ": ["H", "hB"],
  "NA": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "NC": ["H", "hB"],
  "NE": ["H"],
  "NF": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NI": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "NL": ["H", "hB"],
  "NO": ["H", "h"],
  "NP": [
    "H",
    "h",
    "hB"
  ],
  "NR": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NU": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NZ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "OM": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PA": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PE": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PF": [
    "H",
    "h",
    "hB"
  ],
  "PG": ["h", "H"],
  "PH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PK": [
    "h",
    "hB",
    "H"
  ],
  "PL": ["H", "h"],
  "PM": ["H", "hB"],
  "PN": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "PR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PS": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PT": ["H", "hB"],
  "PW": ["h", "H"],
  "PY": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "QA": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "RE": ["H", "hB"],
  "RO": ["H", "hB"],
  "RS": [
    "H",
    "hB",
    "h"
  ],
  "RU": ["H"],
  "RW": ["H", "h"],
  "SA": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SB": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SC": [
    "H",
    "h",
    "hB"
  ],
  "SD": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SE": ["H"],
  "SG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SH": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "SI": ["H", "hB"],
  "SJ": ["H"],
  "SK": ["H"],
  "SL": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SM": [
    "H",
    "h",
    "hB"
  ],
  "SN": [
    "H",
    "h",
    "hB"
  ],
  "SO": ["h", "H"],
  "SR": ["H", "hB"],
  "SS": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "ST": ["H", "hB"],
  "SV": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "SX": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "SY": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SZ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TA": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "TC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TD": [
    "h",
    "H",
    "hB"
  ],
  "TF": [
    "H",
    "h",
    "hB"
  ],
  "TG": ["H", "hB"],
  "TH": ["H", "h"],
  "TJ": ["H", "h"],
  "TL": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "TM": ["H", "h"],
  "TN": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "TO": ["h", "H"],
  "TR": ["H", "hB"],
  "TT": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TW": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "TZ": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "UA": [
    "H",
    "hB",
    "h"
  ],
  "UG": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "UM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "US": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "UY": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "UZ": [
    "H",
    "hB",
    "h"
  ],
  "VA": [
    "H",
    "h",
    "hB"
  ],
  "VC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VE": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "VG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VI": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VN": ["H", "h"],
  "VU": ["h", "H"],
  "WF": ["H", "hB"],
  "WS": ["h", "H"],
  "XK": [
    "H",
    "hB",
    "h"
  ],
  "YE": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "YT": ["H", "hB"],
  "ZA": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "ZM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "ZW": ["H", "h"],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-HK": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-IL": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "en-MY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ku-SY": ["H", "hB"],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function getBestPattern2(skeleton, locale) {
  let skeletonCopy = "";
  for (let patternPos = 0; patternPos < skeleton.length; patternPos++) {
    const patternChar = skeleton.charAt(patternPos);
    if (patternChar === "j") {
      let extraLength = 0;
      while (patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar) {
        extraLength++;
        patternPos++;
      }
      let hourLen = 1 + (extraLength & 1);
      let dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
      let dayPeriodChar = "a";
      let hourChar = getDefaultHourSymbolFromLocale2(locale);
      if (hourChar == "H" || hourChar == "k")
        dayPeriodLen = 0;
      while (dayPeriodLen-- > 0)
        skeletonCopy += dayPeriodChar;
      while (hourLen-- > 0)
        skeletonCopy = hourChar + skeletonCopy;
    } else if (patternChar === "J")
      skeletonCopy += "H";
    else
      skeletonCopy += patternChar;
  }
  return skeletonCopy;
}
function getDefaultHourSymbolFromLocale2(locale) {
  let hourCycle = locale.hourCycle;
  if (hourCycle === void 0 && locale.hourCycles && locale.hourCycles.length)
    hourCycle = locale.hourCycles[0];
  if (hourCycle)
    switch (hourCycle) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  const languageTag = locale.language;
  let regionTag;
  if (languageTag !== "root")
    regionTag = locale.maximize().region;
  return (timeData2[regionTag || ""] || timeData2[languageTag || ""] || timeData2[`${languageTag}-001`] || timeData2["001"])[0];
}
var SPACE_SEPARATOR_START_REGEX2 = new RegExp(`^${SPACE_SEPARATOR_REGEX2.source}*`);
var SPACE_SEPARATOR_END_REGEX2 = new RegExp(`${SPACE_SEPARATOR_REGEX2.source}*$`);
function createLocation2(start, end) {
  return {
    start,
    end
  };
}
var hasNativeFromEntries2 = !!Object.fromEntries;
var hasTrimStart2 = !!String.prototype.trimStart;
var hasTrimEnd2 = !!String.prototype.trimEnd;
var fromEntries3 = hasNativeFromEntries2 ? Object.fromEntries : function fromEntries4(entries) {
  const obj = {};
  for (const [k, v] of entries)
    obj[k] = v;
  return obj;
};
var trimStart4 = hasTrimStart2 ? function trimStart5(s) {
  return s.trimStart();
} : function trimStart6(s) {
  return s.replace(SPACE_SEPARATOR_START_REGEX2, "");
};
var trimEnd4 = hasTrimEnd2 ? function trimEnd5(s) {
  return s.trimEnd();
} : function trimEnd6(s) {
  return s.replace(SPACE_SEPARATOR_END_REGEX2, "");
};
var IDENTIFIER_PREFIX_RE = /* @__PURE__ */ new RegExp("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
function matchIdentifierAtIndex2(s, index) {
  IDENTIFIER_PREFIX_RE.lastIndex = index;
  return IDENTIFIER_PREFIX_RE.exec(s)[1] ?? "";
}
function plainTopLevelEndPosition(message) {
  if (message.length === 0)
    return null;
  let line = 1;
  let column = 1;
  for (let offset = 0; offset < message.length; ) {
    const code = message.charCodeAt(offset);
    switch (code) {
      case 35:
      case 39:
      case 60:
      case 123:
      case 125:
        return null;
    }
    if (code === 10) {
      line++;
      column = 1;
      offset++;
    } else {
      column++;
      if (code >= 55296 && code <= 56319 && offset + 1 < message.length) {
        const next = message.charCodeAt(offset + 1);
        offset += next >= 56320 && next <= 57343 ? 2 : 1;
      } else
        offset++;
    }
  }
  return {
    offset: message.length,
    line,
    column
  };
}
var Parser2 = class {
  constructor(message, options = {}) {
    this.message = message;
    this.position = {
      offset: 0,
      line: 1,
      column: 1
    };
    this.ignoreTag = !!options.ignoreTag;
    this.locale = options.locale;
    this.requiresOtherClause = !!options.requiresOtherClause;
    this.shouldParseSkeletons = !!options.shouldParseSkeletons;
  }
  parse() {
    if (this.offset() !== 0)
      throw Error("parser can only be used once");
    if (this.message.length > 0) {
      const firstCode = this.message.charCodeAt(0);
      if (firstCode !== 35 && firstCode !== 39 && firstCode !== 60 && firstCode !== 123 && firstCode !== 125) {
        const plainEndPosition = plainTopLevelEndPosition(this.message);
        if (plainEndPosition) {
          const start = this.clonePosition();
          this.position = plainEndPosition;
          return {
            val: [{
              type: 0,
              value: this.message,
              location: createLocation2(start, this.clonePosition())
            }],
            err: null
          };
        }
      }
    }
    return this.parseMessage(0, "", false);
  }
  parseMessage(nestingLevel, parentArgType, expectingCloseTag) {
    let elements = [];
    while (!this.isEOF()) {
      const char = this.char();
      if (char === 123) {
        const result = this.parseArgument(nestingLevel, expectingCloseTag);
        if (result.err)
          return result;
        elements.push(result.val);
      } else if (char === 125 && nestingLevel > 0)
        break;
      else if (char === 35 && (parentArgType === "plural" || parentArgType === "selectordinal")) {
        const position = this.clonePosition();
        this.bump();
        elements.push({
          type: 7,
          location: createLocation2(position, this.clonePosition())
        });
      } else if (char === 60 && !this.ignoreTag && this.peek() === 47)
        if (expectingCloseTag)
          break;
        else
          return this.error(26, createLocation2(this.clonePosition(), this.clonePosition()));
      else if (char === 60 && !this.ignoreTag && _isAlpha2(this.peek() || 0)) {
        const result = this.parseTag(nestingLevel, parentArgType);
        if (result.err)
          return result;
        elements.push(result.val);
      } else {
        const result = this.parseLiteral(nestingLevel, parentArgType);
        if (result.err)
          return result;
        elements.push(result.val);
      }
    }
    return {
      val: elements,
      err: null
    };
  }
  /**
  * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
  * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
  * are accepted:
  *
  * ```
  * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
  * tagName ::= [a-z] (PENChar)*
  * PENChar ::=
  *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
  *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
  *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
  * ```
  *
  * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
  * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
  * since other tag-based engines like React allow it
  */
  parseTag(nestingLevel, parentArgType) {
    const startPosition = this.clonePosition();
    this.bump();
    const tagName = this.parseTagName();
    this.bumpSpace();
    if (this.bumpIf("/>"))
      return {
        val: {
          type: 0,
          value: `<${tagName}/>`,
          location: createLocation2(startPosition, this.clonePosition())
        },
        err: null
      };
    else if (this.bumpIf(">")) {
      const childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
      if (childrenResult.err)
        return childrenResult;
      const children = childrenResult.val;
      const endTagStartPosition = this.clonePosition();
      if (this.bumpIf("</")) {
        if (this.isEOF() || !_isAlpha2(this.char()))
          return this.error(23, createLocation2(endTagStartPosition, this.clonePosition()));
        const closingTagNameStartPosition = this.clonePosition();
        if (tagName !== this.parseTagName())
          return this.error(26, createLocation2(closingTagNameStartPosition, this.clonePosition()));
        this.bumpSpace();
        if (!this.bumpIf(">"))
          return this.error(23, createLocation2(endTagStartPosition, this.clonePosition()));
        return {
          val: {
            type: 8,
            value: tagName,
            children,
            location: createLocation2(startPosition, this.clonePosition())
          },
          err: null
        };
      } else
        return this.error(27, createLocation2(startPosition, this.clonePosition()));
    } else
      return this.error(23, createLocation2(startPosition, this.clonePosition()));
  }
  /**
  * This method assumes that the caller has peeked ahead for the first tag character.
  */
  parseTagName() {
    const startOffset = this.offset();
    this.bump();
    while (!this.isEOF() && _isPotentialElementNameChar2(this.char()))
      this.bump();
    return this.message.slice(startOffset, this.offset());
  }
  parseLiteral(nestingLevel, parentArgType) {
    const start = this.clonePosition();
    let value = "";
    while (true) {
      const parseQuoteResult = this.tryParseQuote(parentArgType);
      if (parseQuoteResult) {
        value += parseQuoteResult;
        continue;
      }
      const parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
      if (parseUnquotedResult) {
        value += parseUnquotedResult;
        continue;
      }
      const parseLeftAngleResult = this.tryParseLeftAngleBracket();
      if (parseLeftAngleResult) {
        value += parseLeftAngleResult;
        continue;
      }
      break;
    }
    const location2 = createLocation2(start, this.clonePosition());
    return {
      val: {
        type: 0,
        value,
        location: location2
      },
      err: null
    };
  }
  tryParseLeftAngleBracket() {
    if (!this.isEOF() && this.char() === 60 && (this.ignoreTag || !_isAlphaOrSlash2(this.peek() || 0))) {
      this.bump();
      return "<";
    }
    return null;
  }
  /**
  * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
  * a character that requires quoting (that is, "only where needed"), and works the same in
  * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
  */
  tryParseQuote(parentArgType) {
    if (this.isEOF() || this.char() !== 39)
      return null;
    switch (this.peek()) {
      case 39:
        this.bump();
        this.bump();
        return "'";
      case 123:
      case 60:
      case 62:
      case 125:
        break;
      case 35:
        if (parentArgType === "plural" || parentArgType === "selectordinal")
          break;
        return null;
      default:
        return null;
    }
    this.bump();
    const codePoints = [this.char()];
    this.bump();
    while (!this.isEOF()) {
      const ch = this.char();
      if (ch === 39)
        if (this.peek() === 39) {
          codePoints.push(39);
          this.bump();
        } else {
          this.bump();
          break;
        }
      else
        codePoints.push(ch);
      this.bump();
    }
    return String.fromCodePoint(...codePoints);
  }
  tryParseUnquoted(nestingLevel, parentArgType) {
    if (this.isEOF())
      return null;
    const ch = this.char();
    if (ch === 60 || ch === 123 || ch === 35 && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 && nestingLevel > 0)
      return null;
    else {
      this.bump();
      return String.fromCodePoint(ch);
    }
  }
  parseArgument(nestingLevel, expectingCloseTag) {
    const openingBracePosition = this.clonePosition();
    this.bump();
    this.bumpSpace();
    if (this.isEOF())
      return this.error(1, createLocation2(openingBracePosition, this.clonePosition()));
    if (this.char() === 125) {
      this.bump();
      return this.error(2, createLocation2(openingBracePosition, this.clonePosition()));
    }
    let value = this.parseIdentifierIfPossible().value;
    if (!value)
      return this.error(3, createLocation2(openingBracePosition, this.clonePosition()));
    this.bumpSpace();
    if (this.isEOF())
      return this.error(1, createLocation2(openingBracePosition, this.clonePosition()));
    switch (this.char()) {
      case 125:
        this.bump();
        return {
          val: {
            type: 1,
            value,
            location: createLocation2(openingBracePosition, this.clonePosition())
          },
          err: null
        };
      case 44:
        this.bump();
        this.bumpSpace();
        if (this.isEOF())
          return this.error(1, createLocation2(openingBracePosition, this.clonePosition()));
        return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
      default:
        return this.error(3, createLocation2(openingBracePosition, this.clonePosition()));
    }
  }
  /**
  * Advance the parser until the end of the identifier, if it is currently on
  * an identifier character. Return an empty string otherwise.
  */
  parseIdentifierIfPossible() {
    const startingPosition = this.clonePosition();
    const startOffset = this.offset();
    const value = matchIdentifierAtIndex2(this.message, startOffset);
    const endOffset = startOffset + value.length;
    this.bumpTo(endOffset);
    return {
      value,
      location: createLocation2(startingPosition, this.clonePosition())
    };
  }
  parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition) {
    let typeStartPosition = this.clonePosition();
    let argType = this.parseIdentifierIfPossible().value;
    let typeEndPosition = this.clonePosition();
    switch (argType) {
      case "":
        return this.error(4, createLocation2(typeStartPosition, typeEndPosition));
      case "number":
      case "date":
      case "time": {
        this.bumpSpace();
        let styleAndLocation = null;
        if (this.bumpIf(",")) {
          this.bumpSpace();
          const styleStartPosition = this.clonePosition();
          const result = this.parseSimpleArgStyleIfPossible();
          if (result.err)
            return result;
          const style = trimEnd4(result.val);
          if (style.length === 0)
            return this.error(6, createLocation2(this.clonePosition(), this.clonePosition()));
          styleAndLocation = {
            style,
            styleLocation: createLocation2(styleStartPosition, this.clonePosition())
          };
        }
        const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
        if (argCloseResult.err)
          return argCloseResult;
        const location2 = createLocation2(openingBracePosition, this.clonePosition());
        if (styleAndLocation && styleAndLocation.style.startsWith("::")) {
          let skeleton = trimStart4(styleAndLocation.style.slice(2));
          if (argType === "number") {
            const result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
            if (result.err)
              return result;
            return {
              val: {
                type: 2,
                value,
                location: location2,
                style: result.val
              },
              err: null
            };
          } else {
            if (skeleton.length === 0)
              return this.error(10, location2);
            let dateTimePattern = skeleton;
            if (this.locale)
              dateTimePattern = getBestPattern2(skeleton, this.locale);
            const style = {
              type: 1,
              pattern: dateTimePattern,
              location: styleAndLocation.styleLocation,
              parsedOptions: this.shouldParseSkeletons ? parseDateTimeSkeleton2(dateTimePattern) : {}
            };
            return {
              val: {
                type: argType === "date" ? 3 : 4,
                value,
                location: location2,
                style
              },
              err: null
            };
          }
        }
        return {
          val: {
            type: argType === "number" ? 2 : argType === "date" ? 3 : 4,
            value,
            location: location2,
            style: styleAndLocation?.style ?? null
          },
          err: null
        };
      }
      case "plural":
      case "selectordinal":
      case "select": {
        const typeEndPosition2 = this.clonePosition();
        this.bumpSpace();
        if (!this.bumpIf(","))
          return this.error(12, createLocation2(typeEndPosition2, { ...typeEndPosition2 }));
        this.bumpSpace();
        let identifierAndLocation = this.parseIdentifierIfPossible();
        let pluralOffset = 0;
        if (argType !== "select" && identifierAndLocation.value === "offset") {
          if (!this.bumpIf(":"))
            return this.error(13, createLocation2(this.clonePosition(), this.clonePosition()));
          this.bumpSpace();
          const result = this.tryParseDecimalInteger(13, 14);
          if (result.err)
            return result;
          this.bumpSpace();
          identifierAndLocation = this.parseIdentifierIfPossible();
          pluralOffset = result.val;
        }
        const optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
        if (optionsResult.err)
          return optionsResult;
        const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
        if (argCloseResult.err)
          return argCloseResult;
        const location2 = createLocation2(openingBracePosition, this.clonePosition());
        if (argType === "select")
          return {
            val: {
              type: 5,
              value,
              options: fromEntries3(optionsResult.val),
              location: location2
            },
            err: null
          };
        else
          return {
            val: {
              type: 6,
              value,
              options: fromEntries3(optionsResult.val),
              offset: pluralOffset,
              pluralType: argType === "plural" ? "cardinal" : "ordinal",
              location: location2
            },
            err: null
          };
      }
      default:
        return this.error(5, createLocation2(typeStartPosition, typeEndPosition));
    }
  }
  tryParseArgumentClose(openingBracePosition) {
    if (this.isEOF() || this.char() !== 125)
      return this.error(1, createLocation2(openingBracePosition, this.clonePosition()));
    this.bump();
    return {
      val: true,
      err: null
    };
  }
  /**
  * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
  */
  parseSimpleArgStyleIfPossible() {
    let nestedBraces = 0;
    const startPosition = this.clonePosition();
    while (!this.isEOF())
      switch (this.char()) {
        case 39: {
          this.bump();
          let apostrophePosition = this.clonePosition();
          if (!this.bumpUntil("'"))
            return this.error(11, createLocation2(apostrophePosition, this.clonePosition()));
          this.bump();
          break;
        }
        case 123:
          nestedBraces += 1;
          this.bump();
          break;
        case 125:
          if (nestedBraces > 0)
            nestedBraces -= 1;
          else
            return {
              val: this.message.slice(startPosition.offset, this.offset()),
              err: null
            };
          break;
        default:
          this.bump();
          break;
      }
    return {
      val: this.message.slice(startPosition.offset, this.offset()),
      err: null
    };
  }
  parseNumberSkeletonFromString(skeleton, location2) {
    let tokens = [];
    try {
      tokens = parseNumberSkeletonFromString2(skeleton);
    } catch {
      return this.error(7, location2);
    }
    return {
      val: {
        type: 0,
        tokens,
        location: location2,
        parsedOptions: this.shouldParseSkeletons ? parseNumberSkeleton2(tokens) : {}
      },
      err: null
    };
  }
  /**
  * @param nesting_level The current nesting level of messages.
  *     This can be positive when parsing message fragment in select or plural argument options.
  * @param parent_arg_type The parent argument's type.
  * @param parsed_first_identifier If provided, this is the first identifier-like selector of
  *     the argument. It is a by-product of a previous parsing attempt.
  * @param expecting_close_tag If true, this message is directly or indirectly nested inside
  *     between a pair of opening and closing tags. The nested message will not parse beyond
  *     the closing tag boundary.
  */
  tryParsePluralOrSelectOptions(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
    let hasOtherClause = false;
    const options = [];
    const parsedSelectors = /* @__PURE__ */ new Set();
    let { value: selector, location: selectorLocation } = parsedFirstIdentifier;
    while (true) {
      if (selector.length === 0) {
        const startPosition = this.clonePosition();
        if (parentArgType !== "select" && this.bumpIf("=")) {
          const result = this.tryParseDecimalInteger(16, 19);
          if (result.err)
            return result;
          selectorLocation = createLocation2(startPosition, this.clonePosition());
          selector = this.message.slice(startPosition.offset, this.offset());
        } else
          break;
      }
      if (parsedSelectors.has(selector))
        return this.error(parentArgType === "select" ? 21 : 20, selectorLocation);
      if (selector === "other")
        hasOtherClause = true;
      this.bumpSpace();
      const openingBracePosition = this.clonePosition();
      if (!this.bumpIf("{"))
        return this.error(parentArgType === "select" ? 17 : 18, createLocation2(this.clonePosition(), this.clonePosition()));
      const fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
      if (fragmentResult.err)
        return fragmentResult;
      const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
      if (argCloseResult.err)
        return argCloseResult;
      options.push([selector, {
        value: fragmentResult.val,
        location: createLocation2(openingBracePosition, this.clonePosition())
      }]);
      parsedSelectors.add(selector);
      this.bumpSpace();
      ({ value: selector, location: selectorLocation } = this.parseIdentifierIfPossible());
    }
    if (options.length === 0)
      return this.error(parentArgType === "select" ? 15 : 16, createLocation2(this.clonePosition(), this.clonePosition()));
    if (this.requiresOtherClause && !hasOtherClause)
      return this.error(22, createLocation2(this.clonePosition(), this.clonePosition()));
    return {
      val: options,
      err: null
    };
  }
  tryParseDecimalInteger(expectNumberError, invalidNumberError) {
    let sign = 1;
    const startingPosition = this.clonePosition();
    if (this.bumpIf("+")) {
    } else if (this.bumpIf("-"))
      sign = -1;
    let hasDigits = false;
    let decimal = 0;
    while (!this.isEOF()) {
      const ch = this.char();
      if (ch >= 48 && ch <= 57) {
        hasDigits = true;
        decimal = decimal * 10 + (ch - 48);
        this.bump();
      } else
        break;
    }
    const location2 = createLocation2(startingPosition, this.clonePosition());
    if (!hasDigits)
      return this.error(expectNumberError, location2);
    decimal *= sign;
    if (!Number.isSafeInteger(decimal))
      return this.error(invalidNumberError, location2);
    return {
      val: decimal,
      err: null
    };
  }
  offset() {
    return this.position.offset;
  }
  isEOF() {
    return this.offset() === this.message.length;
  }
  clonePosition() {
    return {
      offset: this.position.offset,
      line: this.position.line,
      column: this.position.column
    };
  }
  /**
  * Return the code point at the current position of the parser.
  * Throws if the index is out of bound.
  */
  char() {
    const offset = this.position.offset;
    if (offset >= this.message.length)
      throw Error("out of bound");
    const code = this.message.codePointAt(offset);
    if (code === void 0)
      throw Error(`Offset ${offset} is at invalid UTF-16 code unit boundary`);
    return code;
  }
  error(kind, location2) {
    return {
      val: null,
      err: {
        kind,
        message: this.message,
        location: location2
      }
    };
  }
  /** Bump the parser to the next UTF-16 code unit. */
  bump() {
    if (this.isEOF())
      return;
    const code = this.char();
    if (code === 10) {
      this.position.line += 1;
      this.position.column = 1;
      this.position.offset += 1;
    } else {
      this.position.column += 1;
      this.position.offset += code < 65536 ? 1 : 2;
    }
  }
  /**
  * If the substring starting at the current position of the parser has
  * the given prefix, then bump the parser to the character immediately
  * following the prefix and return true. Otherwise, don't bump the parser
  * and return false.
  */
  bumpIf(prefix) {
    if (this.message.startsWith(prefix, this.offset())) {
      for (let i = 0; i < prefix.length; i++)
        this.bump();
      return true;
    }
    return false;
  }
  /**
  * Bump the parser until the pattern character is found and return `true`.
  * Otherwise bump to the end of the file and return `false`.
  */
  bumpUntil(pattern) {
    const currentOffset = this.offset();
    const index = this.message.indexOf(pattern, currentOffset);
    if (index >= 0) {
      this.bumpTo(index);
      return true;
    } else {
      this.bumpTo(this.message.length);
      return false;
    }
  }
  /**
  * Bump the parser to the target offset.
  * If target offset is beyond the end of the input, bump the parser to the end of the input.
  */
  bumpTo(targetOffset) {
    if (this.offset() > targetOffset)
      throw Error(`targetOffset ${targetOffset} must be greater than or equal to the current offset ${this.offset()}`);
    targetOffset = Math.min(targetOffset, this.message.length);
    while (true) {
      const offset = this.offset();
      if (offset === targetOffset)
        break;
      if (offset > targetOffset)
        throw Error(`targetOffset ${targetOffset} is at invalid UTF-16 code unit boundary`);
      this.bump();
      if (this.isEOF())
        break;
    }
  }
  /** advance the parser through all whitespace to the next non-whitespace code unit. */
  bumpSpace() {
    while (!this.isEOF() && _isWhiteSpace2(this.char()))
      this.bump();
  }
  /**
  * Peek at the *next* Unicode codepoint in the input without advancing the parser.
  * If the input has been exhausted, then this returns null.
  */
  peek() {
    if (this.isEOF())
      return null;
    const code = this.char();
    const offset = this.offset();
    return this.message.charCodeAt(offset + (code >= 65536 ? 2 : 1)) ?? null;
  }
};
function _isAlpha2(codepoint) {
  return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function _isAlphaOrSlash2(codepoint) {
  return _isAlpha2(codepoint) || codepoint === 47;
}
function _isPotentialElementNameChar2(c) {
  return c === 45 || c === 46 || c >= 48 && c <= 57 || c === 95 || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 183 || c >= 192 && c <= 214 || c >= 216 && c <= 246 || c >= 248 && c <= 893 || c >= 895 && c <= 8191 || c >= 8204 && c <= 8205 || c >= 8255 && c <= 8256 || c >= 8304 && c <= 8591 || c >= 11264 && c <= 12271 || c >= 12289 && c <= 55295 || c >= 63744 && c <= 64975 || c >= 65008 && c <= 65533 || c >= 65536 && c <= 983039;
}
function _isWhiteSpace2(c) {
  return c >= 9 && c <= 13 || c === 32 || c === 133 || c >= 8206 && c <= 8207 || c === 8232 || c === 8233;
}
function pruneLocation2(els) {
  els.forEach((el) => {
    delete el.location;
    if (isSelectElement2(el) || isPluralElement2(el))
      for (const k in el.options) {
        delete el.options[k].location;
        pruneLocation2(el.options[k].value);
      }
    else if (isNumberElement2(el) && isNumberSkeleton2(el.style))
      delete el.style.location;
    else if ((isDateElement2(el) || isTimeElement2(el)) && isDateTimeSkeleton2(el.style))
      delete el.style.location;
    else if (isTagElement2(el))
      pruneLocation2(el.children);
  });
}
function parse2(message, opts = {}) {
  opts = {
    shouldParseSkeletons: true,
    requiresOtherClause: true,
    ...opts
  };
  const result = new Parser2(message, opts).parse();
  if (result.err) {
    const error = SyntaxError(ErrorKind2[result.err.kind]);
    error.location = result.err.location;
    error.originalMessage = result.err.message;
    throw error;
  }
  if (!opts?.captureLocation)
    pruneLocation2(result.val);
  return result.val;
}

// ../../node_modules/@formatjs/intl/node_modules/intl-messageformat/index.js
var ErrorCode2 = /* @__PURE__ */ function(ErrorCode3) {
  ErrorCode3["MISSING_VALUE"] = "MISSING_VALUE";
  ErrorCode3["INVALID_VALUE"] = "INVALID_VALUE";
  ErrorCode3["MISSING_INTL_API"] = "MISSING_INTL_API";
  return ErrorCode3;
}({});
var FormatError2 = class extends Error {
  constructor(msg, code, originalMessage) {
    super(msg);
    this.code = code;
    this.originalMessage = originalMessage;
  }
  toString() {
    return `[formatjs Error: ${this.code}] ${this.message}`;
  }
};
var InvalidValueError2 = class extends FormatError2 {
  constructor(variableId, value, options, originalMessage) {
    super(`Invalid values for "${variableId}": "${value}". Options are "${Object.keys(options).join('", "')}"`, "INVALID_VALUE", originalMessage);
  }
};
var InvalidValueTypeError2 = class extends FormatError2 {
  constructor(value, type, originalMessage) {
    super(`Value for "${value}" must be of type ${type}`, "INVALID_VALUE", originalMessage);
  }
};
var MissingValueError2 = class extends FormatError2 {
  constructor(variableId, originalMessage) {
    super(`The intl string context variable "${variableId}" was not provided to the string "${originalMessage}"`, "MISSING_VALUE", originalMessage);
  }
};
function mergeLiteral2(parts) {
  if (parts.length < 2)
    return parts;
  return parts.reduce((all, part) => {
    const lastPart = all[all.length - 1];
    if (!lastPart || lastPart.type !== 0 || part.type !== 0)
      all.push(part);
    else
      lastPart.value += part.value;
    return all;
  }, []);
}
function isFormatXMLElementFn2(el) {
  return typeof el === "function";
}
function formatToParts2(els, locales, formatters, formats, values, currentPluralValue, originalMessage) {
  if (els.length === 1 && isLiteralElement2(els[0]))
    return [{
      type: 0,
      value: els[0].value
    }];
  const result = [];
  for (const el of els) {
    if (isLiteralElement2(el)) {
      result.push({
        type: 0,
        value: el.value
      });
      continue;
    }
    if (isPoundElement2(el)) {
      if (typeof currentPluralValue === "number")
        result.push({
          type: 0,
          value: formatters.getNumberFormat(locales).format(currentPluralValue)
        });
      continue;
    }
    const { value: varName } = el;
    if (!(values && varName in values))
      throw new MissingValueError2(varName, originalMessage);
    let value = values[varName];
    if (isArgumentElement2(el)) {
      if (!value || typeof value === "string" || typeof value === "number" || typeof value === "bigint")
        value = typeof value === "string" || typeof value === "number" || typeof value === "bigint" ? String(value) : "";
      result.push({
        type: typeof value === "string" ? 0 : 1,
        value
      });
      continue;
    }
    if (isDateElement2(el)) {
      const style = typeof el.style === "string" ? formats.date[el.style] : isDateTimeSkeleton2(el.style) ? el.style.parsedOptions : void 0;
      result.push({
        type: 0,
        value: formatters.getDateTimeFormat(locales, style).format(value)
      });
      continue;
    }
    if (isTimeElement2(el)) {
      const style = typeof el.style === "string" ? formats.time[el.style] : isDateTimeSkeleton2(el.style) ? el.style.parsedOptions : formats.time.medium;
      result.push({
        type: 0,
        value: formatters.getDateTimeFormat(locales, style).format(value)
      });
      continue;
    }
    if (isNumberElement2(el)) {
      const style = typeof el.style === "string" ? formats.number[el.style] : isNumberSkeleton2(el.style) ? el.style.parsedOptions : void 0;
      if (style && style.scale) {
        const scale = style.scale || 1;
        if (typeof value === "bigint") {
          if (!Number.isInteger(scale))
            throw new TypeError(`Cannot apply fractional scale ${scale} to bigint value. Scale must be an integer when formatting bigint.`);
          value = value * BigInt(scale);
        } else
          value = value * scale;
      }
      result.push({
        type: 0,
        value: formatters.getNumberFormat(locales, style).format(value)
      });
      continue;
    }
    if (isTagElement2(el)) {
      const { children, value: value2 } = el;
      const formatFn = values[value2];
      if (!isFormatXMLElementFn2(formatFn))
        throw new InvalidValueTypeError2(value2, "function", originalMessage);
      let chunks = formatFn(formatToParts2(children, locales, formatters, formats, values, currentPluralValue).map((p) => p.value));
      if (!Array.isArray(chunks))
        chunks = [chunks];
      result.push(...chunks.map((c) => {
        return {
          type: typeof c === "string" ? 0 : 1,
          value: c
        };
      }));
    }
    if (isSelectElement2(el)) {
      const key = value;
      const opt = (Object.prototype.hasOwnProperty.call(el.options, key) ? el.options[key] : void 0) || el.options.other;
      if (!opt)
        throw new InvalidValueError2(el.value, value, Object.keys(el.options), originalMessage);
      result.push(...formatToParts2(opt.value, locales, formatters, formats, values));
      continue;
    }
    if (isPluralElement2(el)) {
      const exactKey = `=${value}`;
      let opt = Object.prototype.hasOwnProperty.call(el.options, exactKey) ? el.options[exactKey] : void 0;
      if (!opt) {
        if (!Intl.PluralRules)
          throw new FormatError2(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, "MISSING_INTL_API", originalMessage);
        const numericValue2 = typeof value === "bigint" ? Number(value) : value;
        const rule = formatters.getPluralRules(locales, { type: el.pluralType }).select(numericValue2 - (el.offset || 0));
        opt = (Object.prototype.hasOwnProperty.call(el.options, rule) ? el.options[rule] : void 0) || el.options.other;
      }
      if (!opt)
        throw new InvalidValueError2(el.value, value, Object.keys(el.options), originalMessage);
      const numericValue = typeof value === "bigint" ? Number(value) : value;
      result.push(...formatToParts2(opt.value, locales, formatters, formats, values, numericValue - (el.offset || 0)));
      continue;
    }
  }
  return mergeLiteral2(result);
}
function mergeConfig2(c1, c2) {
  if (!c2)
    return c1;
  return {
    ...c1,
    ...c2,
    ...Object.keys(c1).reduce((all, k) => {
      all[k] = {
        ...c1[k],
        ...c2[k]
      };
      return all;
    }, {})
  };
}
function mergeConfigs2(defaultConfig, configs) {
  if (!configs)
    return defaultConfig;
  return Object.keys(defaultConfig).reduce((all, k) => {
    all[k] = mergeConfig2(defaultConfig[k], configs[k]);
    return all;
  }, { ...defaultConfig });
}
function createFastMemoizeCache2(store) {
  return { create() {
    return {
      get(key) {
        return store[key];
      },
      set(key, value) {
        store[key] = value;
      }
    };
  } };
}
function createDefaultFormatters2(cache = {
  number: {},
  dateTime: {},
  pluralRules: {}
}) {
  return {
    getNumberFormat: memoize2((...args) => new Intl.NumberFormat(...args), {
      cache: createFastMemoizeCache2(cache.number),
      strategy: strategies2.variadic
    }),
    getDateTimeFormat: memoize2((...args) => new Intl.DateTimeFormat(...args), {
      cache: createFastMemoizeCache2(cache.dateTime),
      strategy: strategies2.variadic
    }),
    getPluralRules: memoize2((...args) => new Intl.PluralRules(...args), {
      cache: createFastMemoizeCache2(cache.pluralRules),
      strategy: strategies2.variadic
    })
  };
}
var IntlMessageFormat2 = class IntlMessageFormat3 {
  constructor(message, locales = IntlMessageFormat3.defaultLocale, overrideFormats, opts) {
    this.formatterCache = {
      number: {},
      dateTime: {},
      pluralRules: {}
    };
    this.format = (values) => {
      const parts = this.formatToParts(values);
      if (parts.length === 1)
        return parts[0].value;
      const result = parts.reduce((all, part) => {
        if (!all.length || part.type !== 0 || typeof all[all.length - 1] !== "string")
          all.push(part.value);
        else
          all[all.length - 1] += part.value;
        return all;
      }, []);
      if (result.length <= 1)
        return result[0] || "";
      return result;
    };
    this.formatToParts = (values) => formatToParts2(this.ast, this.locales, this.formatters, this.formats, values, void 0, this.message);
    this.resolvedOptions = () => ({ locale: this.resolvedLocale?.toString() || Intl.NumberFormat.supportedLocalesOf(this.locales)[0] });
    this.getAst = () => this.ast;
    this.locales = locales;
    this.resolvedLocale = IntlMessageFormat3.resolveLocale(locales);
    if (typeof message === "string") {
      this.message = message;
      if (!IntlMessageFormat3.__parse)
        throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
      const { ...parseOpts } = opts || {};
      this.ast = IntlMessageFormat3.__parse(message, {
        ...parseOpts,
        locale: this.resolvedLocale
      });
    } else
      this.ast = message;
    if (!Array.isArray(this.ast))
      throw new TypeError("A message must be provided as a String or AST.");
    this.formats = mergeConfigs2(IntlMessageFormat3.formats, overrideFormats);
    this.formatters = opts && opts.formatters || createDefaultFormatters2(this.formatterCache);
  }
  static {
    this.memoizedDefaultLocale = null;
  }
  static get defaultLocale() {
    if (!IntlMessageFormat3.memoizedDefaultLocale)
      IntlMessageFormat3.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
    return IntlMessageFormat3.memoizedDefaultLocale;
  }
  static {
    this.resolveLocale = (locales) => {
      if (typeof Intl.Locale === "undefined")
        return;
      const supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
      if (supportedLocales.length > 0)
        return new Intl.Locale(supportedLocales[0]);
      return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
  }
  static {
    this.__parse = parse2;
  }
  static {
    this.formats = {
      number: {
        integer: { maximumFractionDigits: 0 },
        currency: { style: "currency" },
        percent: { style: "percent" }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    };
  }
};

// ../../node_modules/@formatjs/intl/index.js
var IntlError = class IntlError2 extends Error {
  constructor(code, message, exception) {
    const err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : void 0;
    super(`[@formatjs/intl Error ${code}] ${message}
${err ? `
${err.message}
${err.stack}` : ""}`);
    this.code = code;
    if (typeof Error.captureStackTrace === "function")
      Error.captureStackTrace(this, IntlError2);
  }
};
var UnsupportedFormatterError = class extends IntlError {
  constructor(message, exception) {
    super("UNSUPPORTED_FORMATTER", message, exception);
  }
};
var InvalidConfigError = class extends IntlError {
  constructor(message, exception) {
    super("INVALID_CONFIG", message, exception);
  }
};
var MissingDataError = class extends IntlError {
  constructor(message, exception) {
    super("MISSING_DATA", message, exception);
  }
};
var IntlFormatError = class extends IntlError {
  constructor(message, locale, exception) {
    super("FORMAT_ERROR", `${message}
Locale: ${locale}
`, exception);
    this.locale = locale;
  }
};
var MessageFormatError = class extends IntlFormatError {
  constructor(message, locale, descriptor, exception) {
    super(`${message}
MessageID: ${descriptor?.id}
Default Message: ${descriptor?.defaultMessage}
Description: ${descriptor?.description}
`, locale, exception);
    this.descriptor = descriptor;
    this.locale = locale;
  }
};
var MissingTranslationError = class extends IntlError {
  constructor(descriptor, locale) {
    super("MISSING_TRANSLATION", `Missing message: "${descriptor.id}" for locale "${locale}", using ${descriptor.defaultMessage ? `default message (${typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map((e) => e.value ?? JSON.stringify(e)).join()})` : "id"} as fallback.`);
    this.descriptor = descriptor;
  }
};
function invariant2(condition, message, Err = Error) {
  if (!condition)
    throw new Err(message);
}
function filterProps(props, allowlist, defaults = {}) {
  return allowlist.reduce((filtered, name) => {
    if (name in props)
      filtered[name] = props[name];
    else if (name in defaults)
      filtered[name] = defaults[name];
    return filtered;
  }, {});
}
var defaultErrorHandler = (error) => {
  if (true)
    console.error(error);
};
var defaultWarnHandler = (warning2) => {
  if (true)
    console.warn(warning2);
};
var DEFAULT_INTL_CONFIG = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: true,
  onError: defaultErrorHandler,
  onWarn: defaultWarnHandler
};
function createIntlCache() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function createFastMemoizeCache3(store) {
  return { create() {
    return {
      get(key) {
        return store[key];
      },
      set(key, value) {
        store[key] = value;
      }
    };
  } };
}
function createFormatters(cache = createIntlCache()) {
  const RelativeTimeFormat = Intl.RelativeTimeFormat;
  const ListFormat = Intl.ListFormat;
  const DisplayNames = Intl.DisplayNames;
  const getDateTimeFormat = memoize2((...args) => new Intl.DateTimeFormat(...args), {
    cache: createFastMemoizeCache3(cache.dateTime),
    strategy: strategies2.variadic
  });
  const getNumberFormat = memoize2((...args) => new Intl.NumberFormat(...args), {
    cache: createFastMemoizeCache3(cache.number),
    strategy: strategies2.variadic
  });
  const getPluralRules = memoize2((...args) => new Intl.PluralRules(...args), {
    cache: createFastMemoizeCache3(cache.pluralRules),
    strategy: strategies2.variadic
  });
  return {
    getDateTimeFormat,
    getNumberFormat,
    getMessageFormat: memoize2((message, locales, overrideFormats, opts) => new IntlMessageFormat2(message, locales, overrideFormats, {
      formatters: {
        getNumberFormat,
        getDateTimeFormat,
        getPluralRules
      },
      ...opts
    }), {
      cache: createFastMemoizeCache3(cache.message),
      strategy: strategies2.variadic
    }),
    getRelativeTimeFormat: memoize2((...args) => new RelativeTimeFormat(...args), {
      cache: createFastMemoizeCache3(cache.relativeTime),
      strategy: strategies2.variadic
    }),
    getPluralRules,
    getListFormat: memoize2((...args) => new ListFormat(...args), {
      cache: createFastMemoizeCache3(cache.list),
      strategy: strategies2.variadic
    }),
    getDisplayNames: memoize2((...args) => new DisplayNames(...args), {
      cache: createFastMemoizeCache3(cache.displayNames),
      strategy: strategies2.variadic
    })
  };
}
function getNamedFormat(formats, type, name, onError) {
  const formatType = formats && formats[type];
  let format;
  if (formatType)
    format = formatType[name];
  if (format)
    return format;
  onError(new UnsupportedFormatterError(`No ${type} format named: ${name}`));
}
function setTimeZoneInOptions(opts, timeZone) {
  return Object.keys(opts).reduce((all, k) => {
    all[k] = {
      timeZone,
      ...opts[k]
    };
    return all;
  }, {});
}
function deepMergeOptions(opts1, opts2) {
  return Object.keys({
    ...opts1,
    ...opts2
  }).reduce((all, k) => {
    all[k] = {
      ...opts1[k],
      ...opts2[k]
    };
    return all;
  }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
  if (!timeZone)
    return f1;
  const mfFormats = IntlMessageFormat2.formats;
  return {
    ...mfFormats,
    ...f1,
    date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)),
    time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone))
  };
}
function getMessageDescriptorContext(messageDescriptor) {
  const { defaultMessage } = messageDescriptor;
  try {
    return defaultMessage !== void 0 ? `
Default Message: ${typeof defaultMessage === "string" ? defaultMessage : JSON.stringify(defaultMessage)}` : `
Message Descriptor: ${JSON.stringify(messageDescriptor)}`;
  } catch {
    return "";
  }
}
var formatMessage = ({ locale, formats, messages, defaultLocale, defaultFormats, fallbackOnEmptyString, onError, timeZone, defaultRichTextElements }, state2, messageDescriptor = { id: "" }, values, opts) => {
  const { id: msgId, defaultMessage } = messageDescriptor;
  if (!msgId)
    invariant2(false, `[@formatjs/intl] An \`id\` must be provided to format a message. You can either:
1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)
or [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR
2. Configure your \`eslint\` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)
to autofix this issue${getMessageDescriptorContext(messageDescriptor)}`);
  const id = String(msgId);
  const message = messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
  if (Array.isArray(message) && message.length === 1 && message[0].type === TYPE2.literal)
    return message[0].value;
  values = {
    ...defaultRichTextElements,
    ...values
  };
  formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
  defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
  if (!message) {
    if (fallbackOnEmptyString === false && message === "")
      return message;
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase())
      onError(new MissingTranslationError(messageDescriptor, locale));
    if (defaultMessage)
      try {
        return state2.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts).format(values);
      } catch (e) {
        onError(new MessageFormatError(`Error formatting default message for: "${id}", rendering default message verbatim`, locale, messageDescriptor, e));
        return typeof defaultMessage === "string" ? defaultMessage : id;
      }
    return id;
  }
  try {
    return state2.getMessageFormat(message, locale, formats, {
      formatters: state2,
      ...opts
    }).format(values);
  } catch (e) {
    onError(new MessageFormatError(`Error formatting message: "${id}", using ${defaultMessage ? "default message" : "id"} as fallback.`, locale, messageDescriptor, e));
  }
  if (defaultMessage)
    try {
      return state2.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts).format(values);
    } catch (e) {
      onError(new MessageFormatError(`Error formatting the default message for: "${id}", rendering message verbatim`, locale, messageDescriptor, e));
    }
  if (typeof message === "string")
    return message;
  if (typeof defaultMessage === "string")
    return defaultMessage;
  return id;
};
var DATE_TIME_FORMAT_OPTIONS = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  "numberingSystem",
  "fractionalSecondDigits"
];
function getFormatter$2({ locale, formats, onError, timeZone }, type, getDateTimeFormat, options = {}) {
  const { format } = options;
  const defaults = {
    ...timeZone && { timeZone },
    ...format && getNamedFormat(formats, type, format, onError)
  };
  let filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
  if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle)
    filteredOptions = {
      ...filteredOptions,
      hour: "numeric",
      minute: "numeric"
    };
  return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat, value, options = {}) {
  const date = typeof value === "string" ? new Date(value || 0) : value;
  try {
    return getFormatter$2(config, "date", getDateTimeFormat, options).format(date);
  } catch (e) {
    config.onError(new IntlFormatError("Error formatting date.", config.locale, e));
  }
  return String(date);
}
function formatTime(config, getDateTimeFormat, value, options = {}) {
  const date = typeof value === "string" ? new Date(value || 0) : value;
  try {
    return getFormatter$2(config, "time", getDateTimeFormat, options).format(date);
  } catch (e) {
    config.onError(new IntlFormatError("Error formatting time.", config.locale, e));
  }
  return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat, from, to, options = {}) {
  const fromDate = typeof from === "string" ? new Date(from || 0) : from;
  const toDate = typeof to === "string" ? new Date(to || 0) : to;
  try {
    return getFormatter$2(config, "dateTimeRange", getDateTimeFormat, options).formatRange(fromDate, toDate);
  } catch (e) {
    config.onError(new IntlFormatError("Error formatting date time range.", config.locale, e));
  }
  return String(fromDate);
}
function formatDateToParts(config, getDateTimeFormat, value, options = {}) {
  const date = typeof value === "string" ? new Date(value || 0) : value;
  try {
    return getFormatter$2(config, "date", getDateTimeFormat, options).formatToParts(date);
  } catch (e) {
    config.onError(new IntlFormatError("Error formatting date.", config.locale, e));
  }
  return [];
}
function formatTimeToParts(config, getDateTimeFormat, value, options = {}) {
  const date = typeof value === "string" ? new Date(value || 0) : value;
  try {
    return getFormatter$2(config, "time", getDateTimeFormat, options).formatToParts(date);
  } catch (e) {
    config.onError(new IntlFormatError("Error formatting time.", config.locale, e));
  }
  return [];
}
var DISPLAY_NAMES_OPTONS = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function formatDisplayName({ locale, onError }, getDisplayNames, value, options) {
  if (!Intl.DisplayNames)
    onError(new FormatError2(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, ErrorCode2.MISSING_INTL_API));
  const filteredOptions = filterProps(options, DISPLAY_NAMES_OPTONS);
  try {
    return getDisplayNames(locale, filteredOptions).of(value);
  } catch (e) {
    onError(new IntlFormatError("Error formatting display name.", locale, e));
  }
}
var LIST_FORMAT_OPTIONS = ["type", "style"];
var now = Date.now();
function generateToken(i) {
  return `${now}_${i}_${now}`;
}
function formatList(opts, getListFormat, values, options = {}) {
  const results = formatListToParts(opts, getListFormat, values, options).reduce((all, el) => {
    const val = el.value;
    if (typeof val !== "string")
      all.push(val);
    else if (typeof all[all.length - 1] === "string")
      all[all.length - 1] += val;
    else
      all.push(val);
    return all;
  }, []);
  return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function formatListToParts({ locale, onError }, getListFormat, values, options = {}) {
  if (!Intl.ListFormat)
    onError(new FormatError2(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, ErrorCode2.MISSING_INTL_API));
  const filteredOptions = filterProps(options, LIST_FORMAT_OPTIONS);
  try {
    const richValues = {};
    const serializedValues = Array.from(values).map((v, i) => {
      if (typeof v === "object" && v !== null) {
        const id = generateToken(i);
        richValues[id] = v;
        return id;
      }
      return String(v);
    });
    return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map((part) => part.type === "literal" ? part : {
      ...part,
      value: richValues[part.value] || part.value
    });
  } catch (e) {
    onError(new IntlFormatError("Error formatting list.", locale, e));
  }
  return values;
}
var PLURAL_FORMAT_OPTIONS = ["type"];
function formatPlural({ locale, onError }, getPluralRules, value, options = {}) {
  if (!Intl.PluralRules)
    onError(new FormatError2(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, ErrorCode2.MISSING_INTL_API));
  const filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  try {
    return getPluralRules(locale, filteredOptions).select(value);
  } catch (e) {
    onError(new IntlFormatError("Error formatting plural.", locale, e));
  }
  return "other";
}
var RELATIVE_TIME_FORMAT_OPTIONS = ["numeric", "style"];
function getFormatter$1({ locale, formats, onError }, getRelativeTimeFormat, options = {}) {
  const { format } = options;
  const defaults = !!format && getNamedFormat(formats, "relative", format, onError) || {};
  return getRelativeTimeFormat(locale, filterProps(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults));
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options = {}) {
  if (!unit)
    unit = "second";
  if (!Intl.RelativeTimeFormat)
    config.onError(new FormatError2(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, ErrorCode2.MISSING_INTL_API));
  try {
    return getFormatter$1(config, getRelativeTimeFormat, options).format(value, unit);
  } catch (e) {
    config.onError(new IntlFormatError("Error formatting relative time.", config.locale, e));
  }
  return String(value);
}
var NUMBER_FORMAT_OPTIONS = [
  "style",
  "currency",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem",
  "trailingZeroDisplay",
  "roundingPriority",
  "roundingIncrement",
  "roundingMode"
];
function getFormatter({ locale, formats, onError }, getNumberFormat, options = {}) {
  const { format } = options;
  const defaults = format && getNamedFormat(formats, "number", format, onError) || {};
  return getNumberFormat(locale, filterProps(options, NUMBER_FORMAT_OPTIONS, defaults));
}
function formatNumber(config, getNumberFormat, value, options = {}) {
  try {
    return getFormatter(config, getNumberFormat, options).format(value);
  } catch (e) {
    config.onError(new IntlFormatError("Error formatting number.", config.locale, e));
  }
  return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options = {}) {
  try {
    return getFormatter(config, getNumberFormat, options).formatToParts(value);
  } catch (e) {
    config.onError(new IntlFormatError("Error formatting number.", config.locale, e));
  }
  return [];
}
function messagesContainString(messages) {
  return typeof (messages ? messages[Object.keys(messages)[0]] : void 0) === "string";
}
function verifyConfigMessages(config) {
  if (config.onWarn && config.defaultRichTextElements && messagesContainString(config.messages || {}))
    config.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.github.io/docs/getting-started/message-distribution`);
}
function createIntl(config, cache) {
  const formatters = createFormatters(cache);
  const resolvedConfig = {
    ...DEFAULT_INTL_CONFIG,
    ...config
  };
  const { locale, defaultLocale, onError } = resolvedConfig;
  if (!locale) {
    if (onError)
      onError(new InvalidConfigError(`"locale" was not configured, using "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details`));
    resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
  } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError)
    onError(new MissingDataError(`Missing locale data for locale: "${locale}" in Intl.NumberFormat. Using default locale: "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`));
  else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError)
    onError(new MissingDataError(`Missing locale data for locale: "${locale}" in Intl.DateTimeFormat. Using default locale: "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`));
  verifyConfigMessages(resolvedConfig);
  return {
    ...resolvedConfig,
    formatters,
    formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat),
    formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat),
    formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
    formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules),
    formatMessage: formatMessage.bind(null, resolvedConfig, formatters),
    $t: formatMessage.bind(null, resolvedConfig, formatters),
    formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat),
    formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat),
    formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames)
  };
}

// ../../node_modules/react-intl/index.js
import { Fragment as Fragment6, jsx as jsx13 } from "react/jsx-runtime";

// ../../node_modules/react-intl/node_modules/@formatjs/fast-memoize/index.js
function memoize3(fn, options) {
  const cache = options && options.cache ? options.cache : cacheDefault3;
  const serializer = options && options.serializer ? options.serializer : serializerDefault3;
  return (options && options.strategy ? options.strategy : strategyDefault3)(fn, {
    cache,
    serializer
  });
}
function isPrimitive3(value) {
  return value == null || typeof value === "number" || typeof value === "boolean";
}
function monadic3(fn, cache, serializer, arg) {
  const cacheKey = isPrimitive3(arg) ? arg : serializer(arg);
  let computedValue = cache.get(cacheKey);
  if (typeof computedValue === "undefined") {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function variadic3(fn, cache, serializer) {
  const args = Array.prototype.slice.call(arguments, 3);
  const cacheKey = serializer(args);
  let computedValue = cache.get(cacheKey);
  if (typeof computedValue === "undefined") {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }
  return computedValue;
}
function assemble3(fn, context, strategy, cache, serialize) {
  return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault3(fn, options) {
  const strategy = fn.length === 1 ? monadic3 : variadic3;
  return assemble3(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic3(fn, options) {
  return assemble3(fn, this, variadic3, options.cache.create(), options.serializer);
}
function strategyMonadic3(fn, options) {
  return assemble3(fn, this, monadic3, options.cache.create(), options.serializer);
}
var serializerDefault3 = function() {
  return JSON.stringify(arguments);
};
var ObjectWithoutPrototypeCache3 = class {
  constructor() {
    this.cache = /* @__PURE__ */ Object.create(null);
  }
  get(key) {
    return this.cache[key];
  }
  set(key, value) {
    this.cache[key] = value;
  }
};
var cacheDefault3 = { create: function create3() {
  return new ObjectWithoutPrototypeCache3();
} };
var strategies3 = {
  variadic: strategyVariadic3,
  monadic: strategyMonadic3
};

// ../../node_modules/react-intl/node_modules/@formatjs/icu-skeleton-parser/index.js
var DATE_TIME_REGEX3 = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton3(skeleton) {
  const result = {};
  skeleton.replace(DATE_TIME_REGEX3, (match) => {
    const len = match.length;
    switch (match[0]) {
      case "G":
        result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
        break;
      case "y":
        result.year = len === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        result.month = [
          "numeric",
          "2-digit",
          "short",
          "long",
          "narrow"
        ][len - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        result.day = ["numeric", "2-digit"][len - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
        break;
      case "e":
        if (len < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        result.weekday = [
          "short",
          "long",
          "narrow",
          "short"
        ][len - 3];
        break;
      case "c":
        if (len < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        result.weekday = [
          "short",
          "long",
          "narrow",
          "short"
        ][len - 3];
        break;
      case "a":
        result.hour12 = true;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        result.hourCycle = "h12";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "H":
        result.hourCycle = "h23";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "K":
        result.hourCycle = "h11";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "k":
        result.hourCycle = "h24";
        result.hour = ["numeric", "2-digit"][len - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        result.minute = ["numeric", "2-digit"][len - 1];
        break;
      case "s":
        result.second = ["numeric", "2-digit"][len - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        result.timeZoneName = len < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  });
  return result;
}
var WHITE_SPACE_REGEX3 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function parseNumberSkeletonFromString3(skeleton) {
  if (skeleton.length === 0)
    throw new Error("Number skeleton cannot be empty");
  const stringTokens = skeleton.split(WHITE_SPACE_REGEX3).filter((x) => x.length > 0);
  const tokens = [];
  for (const stringToken of stringTokens) {
    let stemAndOptions = stringToken.split("/");
    if (stemAndOptions.length === 0)
      throw new Error("Invalid number skeleton");
    const [stem, ...options] = stemAndOptions;
    for (const option of options)
      if (option.length === 0)
        throw new Error("Invalid number skeleton");
    tokens.push({
      stem,
      options
    });
  }
  return tokens;
}
function icuUnitToEcma3(unit) {
  return unit.replace(/^(.*?)-/, "");
}
var FRACTION_PRECISION_REGEX3 = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX3 = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX3 = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX3 = /^(0+)$/;
function parseSignificantPrecision3(str) {
  const result = {};
  if (str[str.length - 1] === "r")
    result.roundingPriority = "morePrecision";
  else if (str[str.length - 1] === "s")
    result.roundingPriority = "lessPrecision";
  str.replace(SIGNIFICANT_PRECISION_REGEX3, function(_, g1, g2) {
    if (typeof g2 !== "string") {
      result.minimumSignificantDigits = g1.length;
      result.maximumSignificantDigits = g1.length;
    } else if (g2 === "+")
      result.minimumSignificantDigits = g1.length;
    else if (g1[0] === "#")
      result.maximumSignificantDigits = g1.length;
    else {
      result.minimumSignificantDigits = g1.length;
      result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
    }
    return "";
  });
  return result;
}
function parseSign3(str) {
  switch (str) {
    case "sign-auto":
      return { signDisplay: "auto" };
    case "sign-accounting":
    case "()":
      return { currencySign: "accounting" };
    case "sign-always":
    case "+!":
      return { signDisplay: "always" };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return { signDisplay: "exceptZero" };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return { signDisplay: "never" };
  }
}
function parseConciseScientificAndEngineeringStem3(stem) {
  let result;
  if (stem[0] === "E" && stem[1] === "E") {
    result = { notation: "engineering" };
    stem = stem.slice(2);
  } else if (stem[0] === "E") {
    result = { notation: "scientific" };
    stem = stem.slice(1);
  }
  if (result) {
    const signDisplay = stem.slice(0, 2);
    if (signDisplay === "+!") {
      result.signDisplay = "always";
      stem = stem.slice(2);
    } else if (signDisplay === "+?") {
      result.signDisplay = "exceptZero";
      stem = stem.slice(2);
    }
    if (!CONCISE_INTEGER_WIDTH_REGEX3.test(stem))
      throw new Error("Malformed concise eng/scientific notation");
    result.minimumIntegerDigits = stem.length;
  }
  return result;
}
function parseNotationOptions3(opt) {
  const result = {};
  const signOpts = parseSign3(opt);
  if (signOpts)
    return signOpts;
  return result;
}
function parseNumberSkeleton3(tokens) {
  let result = {};
  for (const token of tokens) {
    switch (token.stem) {
      case "percent":
      case "%":
        result.style = "percent";
        continue;
      case "%x100":
        result.style = "percent";
        result.scale = 100;
        continue;
      case "currency":
        result.style = "currency";
        result.currency = token.options[0];
        continue;
      case "group-off":
      case ",_":
        result.useGrouping = false;
        continue;
      case "precision-integer":
      case ".":
        result.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        result.style = "unit";
        result.unit = icuUnitToEcma3(token.options[0]);
        continue;
      case "compact-short":
      case "K":
        result.notation = "compact";
        result.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        result.notation = "compact";
        result.compactDisplay = "long";
        continue;
      case "scientific":
        result = {
          ...result,
          notation: "scientific",
          ...token.options.reduce((all, opt) => ({
            ...all,
            ...parseNotationOptions3(opt)
          }), {})
        };
        continue;
      case "engineering":
        result = {
          ...result,
          notation: "engineering",
          ...token.options.reduce((all, opt) => ({
            ...all,
            ...parseNotationOptions3(opt)
          }), {})
        };
        continue;
      case "notation-simple":
        result.notation = "standard";
        continue;
      case "unit-width-narrow":
        result.currencyDisplay = "narrowSymbol";
        result.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        result.currencyDisplay = "code";
        result.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        result.currencyDisplay = "name";
        result.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        result.currencyDisplay = "symbol";
        continue;
      case "scale":
        result.scale = parseFloat(token.options[0]);
        continue;
      case "rounding-mode-floor":
        result.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        result.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        result.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        result.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        result.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        result.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        result.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (token.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        token.options[0].replace(INTEGER_WIDTH_REGEX3, function(_, g1, g2, g3, g4, g5) {
          if (g1)
            result.minimumIntegerDigits = g2.length;
          else if (g3 && g4)
            throw new Error("We currently do not support maximum integer digits");
          else if (g5)
            throw new Error("We currently do not support exact integer digits");
          return "";
        });
        continue;
    }
    if (CONCISE_INTEGER_WIDTH_REGEX3.test(token.stem)) {
      result.minimumIntegerDigits = token.stem.length;
      continue;
    }
    if (FRACTION_PRECISION_REGEX3.test(token.stem)) {
      if (token.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      token.stem.replace(FRACTION_PRECISION_REGEX3, function(_, g1, g2, g3, g4, g5) {
        if (g2 === "*")
          result.minimumFractionDigits = g1.length;
        else if (g3 && g3[0] === "#")
          result.maximumFractionDigits = g3.length;
        else if (g4 && g5) {
          result.minimumFractionDigits = g4.length;
          result.maximumFractionDigits = g4.length + g5.length;
        } else {
          result.minimumFractionDigits = g1.length;
          result.maximumFractionDigits = g1.length;
        }
        return "";
      });
      const opt = token.options[0];
      if (opt === "w")
        result = {
          ...result,
          trailingZeroDisplay: "stripIfInteger"
        };
      else if (opt)
        result = {
          ...result,
          ...parseSignificantPrecision3(opt)
        };
      continue;
    }
    if (SIGNIFICANT_PRECISION_REGEX3.test(token.stem)) {
      result = {
        ...result,
        ...parseSignificantPrecision3(token.stem)
      };
      continue;
    }
    const signOpts = parseSign3(token.stem);
    if (signOpts)
      result = {
        ...result,
        ...signOpts
      };
    const conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem3(token.stem);
    if (conciseScientificAndEngineeringOpts)
      result = {
        ...result,
        ...conciseScientificAndEngineeringOpts
      };
  }
  return result;
}

// ../../node_modules/react-intl/node_modules/@formatjs/icu-messageformat-parser/index.js
var ErrorKind3 = /* @__PURE__ */ function(ErrorKind4) {
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
  ErrorKind4[ErrorKind4["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
  ErrorKind4[ErrorKind4["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
  ErrorKind4[ErrorKind4["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
  ErrorKind4[ErrorKind4["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
  ErrorKind4[ErrorKind4["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
  ErrorKind4[ErrorKind4["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
  ErrorKind4[ErrorKind4["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
  ErrorKind4[ErrorKind4["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
  ErrorKind4[ErrorKind4["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
  ErrorKind4[ErrorKind4["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
  ErrorKind4[ErrorKind4["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
  ErrorKind4[ErrorKind4["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
  ErrorKind4[ErrorKind4["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
  ErrorKind4[ErrorKind4["INVALID_TAG"] = 23] = "INVALID_TAG";
  ErrorKind4[ErrorKind4["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
  ErrorKind4[ErrorKind4["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
  ErrorKind4[ErrorKind4["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
  return ErrorKind4;
}({});
function isLiteralElement3(el) {
  return el.type === 0;
}
function isArgumentElement3(el) {
  return el.type === 1;
}
function isNumberElement3(el) {
  return el.type === 2;
}
function isDateElement3(el) {
  return el.type === 3;
}
function isTimeElement3(el) {
  return el.type === 4;
}
function isSelectElement3(el) {
  return el.type === 5;
}
function isPluralElement3(el) {
  return el.type === 6;
}
function isPoundElement3(el) {
  return el.type === 7;
}
function isTagElement3(el) {
  return el.type === 8;
}
function isNumberSkeleton3(el) {
  return !!(el && typeof el === "object" && el.type === 0);
}
function isDateTimeSkeleton3(el) {
  return !!(el && typeof el === "object" && el.type === 1);
}
var SPACE_SEPARATOR_REGEX3 = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var timeData3 = {
  "001": ["H", "h"],
  "419": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "AC": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "AD": ["H", "hB"],
  "AE": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "AF": [
    "H",
    "hb",
    "hB",
    "h"
  ],
  "AG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "AI": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "AL": [
    "h",
    "H",
    "hB"
  ],
  "AM": ["H", "hB"],
  "AO": ["H", "hB"],
  "AR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "AS": ["h", "H"],
  "AT": ["H", "hB"],
  "AU": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "AW": ["H", "hB"],
  "AX": ["H"],
  "AZ": [
    "H",
    "hB",
    "h"
  ],
  "BA": [
    "H",
    "hB",
    "h"
  ],
  "BB": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BD": [
    "h",
    "hB",
    "H"
  ],
  "BE": ["H", "hB"],
  "BF": ["H", "hB"],
  "BG": [
    "H",
    "hB",
    "h"
  ],
  "BH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "BI": ["H", "h"],
  "BJ": ["H", "hB"],
  "BL": ["H", "hB"],
  "BM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BN": [
    "hb",
    "hB",
    "h",
    "H"
  ],
  "BO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "BQ": ["H"],
  "BR": ["H", "hB"],
  "BS": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "BT": ["h", "H"],
  "BW": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "BY": ["H", "h"],
  "BZ": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CA": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "CC": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CD": ["hB", "H"],
  "CF": [
    "H",
    "h",
    "hB"
  ],
  "CG": ["H", "hB"],
  "CH": [
    "H",
    "hB",
    "h"
  ],
  "CI": ["H", "hB"],
  "CK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CL": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CM": [
    "H",
    "h",
    "hB"
  ],
  "CN": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "CO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CP": ["H"],
  "CR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CU": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "CV": ["H", "hB"],
  "CW": ["H", "hB"],
  "CX": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "CY": [
    "h",
    "H",
    "hb",
    "hB"
  ],
  "CZ": ["H"],
  "DE": ["H", "hB"],
  "DG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "DJ": ["h", "H"],
  "DK": ["H"],
  "DM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "DO": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "DZ": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "EA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "EC": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "EE": ["H", "hB"],
  "EG": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "EH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ER": ["h", "H"],
  "ES": [
    "H",
    "hB",
    "h",
    "hb"
  ],
  "ET": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "FI": ["H"],
  "FJ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "FK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "FM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "FO": ["H", "h"],
  "FR": ["H", "hB"],
  "GA": ["H", "hB"],
  "GB": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GD": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GE": [
    "H",
    "hB",
    "h"
  ],
  "GF": ["H", "hB"],
  "GG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GH": ["h", "H"],
  "GI": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GL": ["H", "h"],
  "GM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GN": ["H", "hB"],
  "GP": ["H", "hB"],
  "GQ": [
    "H",
    "hB",
    "h",
    "hb"
  ],
  "GR": [
    "h",
    "H",
    "hb",
    "hB"
  ],
  "GS": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "GT": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "GU": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "GW": ["H", "hB"],
  "GY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "HK": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "HN": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "HR": ["H", "hB"],
  "HU": ["H", "h"],
  "IC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ID": ["H"],
  "IE": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IL": ["H", "hB"],
  "IM": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IN": ["h", "H"],
  "IO": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "IQ": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "IR": ["hB", "H"],
  "IS": ["H"],
  "IT": ["H", "hB"],
  "JE": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "JM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "JO": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "JP": [
    "H",
    "K",
    "h"
  ],
  "KE": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "KG": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "KH": [
    "hB",
    "h",
    "H",
    "hb"
  ],
  "KI": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KM": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "KN": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KP": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "KR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "KW": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "KY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "KZ": ["H", "hB"],
  "LA": [
    "H",
    "hb",
    "hB",
    "h"
  ],
  "LB": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "LC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "LI": [
    "H",
    "hB",
    "h"
  ],
  "LK": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "LR": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "LS": ["h", "H"],
  "LT": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "LU": [
    "H",
    "h",
    "hB"
  ],
  "LV": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "LY": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "MC": ["H", "hB"],
  "MD": ["H", "hB"],
  "ME": [
    "H",
    "hB",
    "h"
  ],
  "MF": ["H", "hB"],
  "MG": ["H", "h"],
  "MH": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MK": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "ML": ["H"],
  "MM": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "MN": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "MO": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MP": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MQ": ["H", "hB"],
  "MR": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "MS": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "MT": ["H", "h"],
  "MU": ["H", "h"],
  "MV": ["H", "h"],
  "MW": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "MX": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "MY": [
    "hb",
    "hB",
    "h",
    "H"
  ],
  "MZ": ["H", "hB"],
  "NA": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "NC": ["H", "hB"],
  "NE": ["H"],
  "NF": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NG": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NI": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "NL": ["H", "hB"],
  "NO": ["H", "h"],
  "NP": [
    "H",
    "h",
    "hB"
  ],
  "NR": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NU": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "NZ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "OM": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PA": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PE": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PF": [
    "H",
    "h",
    "hB"
  ],
  "PG": ["h", "H"],
  "PH": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PK": [
    "h",
    "hB",
    "H"
  ],
  "PL": ["H", "h"],
  "PM": ["H", "hB"],
  "PN": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "PR": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "PS": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "PT": ["H", "hB"],
  "PW": ["h", "H"],
  "PY": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "QA": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "RE": ["H", "hB"],
  "RO": ["H", "hB"],
  "RS": [
    "H",
    "hB",
    "h"
  ],
  "RU": ["H"],
  "RW": ["H", "h"],
  "SA": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SB": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SC": [
    "H",
    "h",
    "hB"
  ],
  "SD": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SE": ["H"],
  "SG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SH": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "SI": ["H", "hB"],
  "SJ": ["H"],
  "SK": ["H"],
  "SL": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "SM": [
    "H",
    "h",
    "hB"
  ],
  "SN": [
    "H",
    "h",
    "hB"
  ],
  "SO": ["h", "H"],
  "SR": ["H", "hB"],
  "SS": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "ST": ["H", "hB"],
  "SV": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "SX": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "SY": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "SZ": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TA": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "TC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TD": [
    "h",
    "H",
    "hB"
  ],
  "TF": [
    "H",
    "h",
    "hB"
  ],
  "TG": ["H", "hB"],
  "TH": ["H", "h"],
  "TJ": ["H", "h"],
  "TL": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "TM": ["H", "h"],
  "TN": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "TO": ["h", "H"],
  "TR": ["H", "hB"],
  "TT": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "TW": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "TZ": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "UA": [
    "H",
    "hB",
    "h"
  ],
  "UG": [
    "hB",
    "hb",
    "H",
    "h"
  ],
  "UM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "US": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "UY": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "UZ": [
    "H",
    "hB",
    "h"
  ],
  "VA": [
    "H",
    "h",
    "hB"
  ],
  "VC": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VE": [
    "h",
    "H",
    "hB",
    "hb"
  ],
  "VG": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VI": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "VN": ["H", "h"],
  "VU": ["h", "H"],
  "WF": ["H", "hB"],
  "WS": ["h", "H"],
  "XK": [
    "H",
    "hB",
    "h"
  ],
  "YE": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "YT": ["H", "hB"],
  "ZA": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "ZM": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "ZW": ["H", "h"],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-HK": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-IL": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "en-MY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ku-SY": ["H", "hB"],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function getBestPattern3(skeleton, locale) {
  let skeletonCopy = "";
  for (let patternPos = 0; patternPos < skeleton.length; patternPos++) {
    const patternChar = skeleton.charAt(patternPos);
    if (patternChar === "j") {
      let extraLength = 0;
      while (patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar) {
        extraLength++;
        patternPos++;
      }
      let hourLen = 1 + (extraLength & 1);
      let dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
      let dayPeriodChar = "a";
      let hourChar = getDefaultHourSymbolFromLocale3(locale);
      if (hourChar == "H" || hourChar == "k")
        dayPeriodLen = 0;
      while (dayPeriodLen-- > 0)
        skeletonCopy += dayPeriodChar;
      while (hourLen-- > 0)
        skeletonCopy = hourChar + skeletonCopy;
    } else if (patternChar === "J")
      skeletonCopy += "H";
    else
      skeletonCopy += patternChar;
  }
  return skeletonCopy;
}
function getDefaultHourSymbolFromLocale3(locale) {
  let hourCycle = locale.hourCycle;
  if (hourCycle === void 0 && locale.hourCycles && locale.hourCycles.length)
    hourCycle = locale.hourCycles[0];
  if (hourCycle)
    switch (hourCycle) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  const languageTag = locale.language;
  let regionTag;
  if (languageTag !== "root")
    regionTag = locale.maximize().region;
  return (timeData3[regionTag || ""] || timeData3[languageTag || ""] || timeData3[`${languageTag}-001`] || timeData3["001"])[0];
}
var SPACE_SEPARATOR_START_REGEX3 = new RegExp(`^${SPACE_SEPARATOR_REGEX3.source}*`);
var SPACE_SEPARATOR_END_REGEX3 = new RegExp(`${SPACE_SEPARATOR_REGEX3.source}*$`);
function createLocation3(start, end) {
  return {
    start,
    end
  };
}
var hasNativeFromEntries3 = !!Object.fromEntries;
var hasTrimStart3 = !!String.prototype.trimStart;
var hasTrimEnd3 = !!String.prototype.trimEnd;
var fromEntries5 = hasNativeFromEntries3 ? Object.fromEntries : function fromEntries6(entries) {
  const obj = {};
  for (const [k, v] of entries)
    obj[k] = v;
  return obj;
};
var trimStart7 = hasTrimStart3 ? function trimStart8(s) {
  return s.trimStart();
} : function trimStart9(s) {
  return s.replace(SPACE_SEPARATOR_START_REGEX3, "");
};
var trimEnd7 = hasTrimEnd3 ? function trimEnd8(s) {
  return s.trimEnd();
} : function trimEnd9(s) {
  return s.replace(SPACE_SEPARATOR_END_REGEX3, "");
};
var IDENTIFIER_PREFIX_RE2 = /* @__PURE__ */ new RegExp("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
function matchIdentifierAtIndex3(s, index) {
  IDENTIFIER_PREFIX_RE2.lastIndex = index;
  return IDENTIFIER_PREFIX_RE2.exec(s)[1] ?? "";
}
function plainTopLevelEndPosition2(message) {
  if (message.length === 0)
    return null;
  let line = 1;
  let column = 1;
  for (let offset = 0; offset < message.length; ) {
    const code = message.charCodeAt(offset);
    switch (code) {
      case 35:
      case 39:
      case 60:
      case 123:
      case 125:
        return null;
    }
    if (code === 10) {
      line++;
      column = 1;
      offset++;
    } else {
      column++;
      if (code >= 55296 && code <= 56319 && offset + 1 < message.length) {
        const next = message.charCodeAt(offset + 1);
        offset += next >= 56320 && next <= 57343 ? 2 : 1;
      } else
        offset++;
    }
  }
  return {
    offset: message.length,
    line,
    column
  };
}
var Parser3 = class {
  constructor(message, options = {}) {
    this.message = message;
    this.position = {
      offset: 0,
      line: 1,
      column: 1
    };
    this.ignoreTag = !!options.ignoreTag;
    this.locale = options.locale;
    this.requiresOtherClause = !!options.requiresOtherClause;
    this.shouldParseSkeletons = !!options.shouldParseSkeletons;
  }
  parse() {
    if (this.offset() !== 0)
      throw Error("parser can only be used once");
    if (this.message.length > 0) {
      const firstCode = this.message.charCodeAt(0);
      if (firstCode !== 35 && firstCode !== 39 && firstCode !== 60 && firstCode !== 123 && firstCode !== 125) {
        const plainEndPosition = plainTopLevelEndPosition2(this.message);
        if (plainEndPosition) {
          const start = this.clonePosition();
          this.position = plainEndPosition;
          return {
            val: [{
              type: 0,
              value: this.message,
              location: createLocation3(start, this.clonePosition())
            }],
            err: null
          };
        }
      }
    }
    return this.parseMessage(0, "", false);
  }
  parseMessage(nestingLevel, parentArgType, expectingCloseTag) {
    let elements = [];
    while (!this.isEOF()) {
      const char = this.char();
      if (char === 123) {
        const result = this.parseArgument(nestingLevel, expectingCloseTag);
        if (result.err)
          return result;
        elements.push(result.val);
      } else if (char === 125 && nestingLevel > 0)
        break;
      else if (char === 35 && (parentArgType === "plural" || parentArgType === "selectordinal")) {
        const position = this.clonePosition();
        this.bump();
        elements.push({
          type: 7,
          location: createLocation3(position, this.clonePosition())
        });
      } else if (char === 60 && !this.ignoreTag && this.peek() === 47)
        if (expectingCloseTag)
          break;
        else
          return this.error(26, createLocation3(this.clonePosition(), this.clonePosition()));
      else if (char === 60 && !this.ignoreTag && _isAlpha3(this.peek() || 0)) {
        const result = this.parseTag(nestingLevel, parentArgType);
        if (result.err)
          return result;
        elements.push(result.val);
      } else {
        const result = this.parseLiteral(nestingLevel, parentArgType);
        if (result.err)
          return result;
        elements.push(result.val);
      }
    }
    return {
      val: elements,
      err: null
    };
  }
  /**
  * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
  * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
  * are accepted:
  *
  * ```
  * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
  * tagName ::= [a-z] (PENChar)*
  * PENChar ::=
  *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
  *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
  *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
  * ```
  *
  * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
  * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
  * since other tag-based engines like React allow it
  */
  parseTag(nestingLevel, parentArgType) {
    const startPosition = this.clonePosition();
    this.bump();
    const tagName = this.parseTagName();
    this.bumpSpace();
    if (this.bumpIf("/>"))
      return {
        val: {
          type: 0,
          value: `<${tagName}/>`,
          location: createLocation3(startPosition, this.clonePosition())
        },
        err: null
      };
    else if (this.bumpIf(">")) {
      const childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
      if (childrenResult.err)
        return childrenResult;
      const children = childrenResult.val;
      const endTagStartPosition = this.clonePosition();
      if (this.bumpIf("</")) {
        if (this.isEOF() || !_isAlpha3(this.char()))
          return this.error(23, createLocation3(endTagStartPosition, this.clonePosition()));
        const closingTagNameStartPosition = this.clonePosition();
        if (tagName !== this.parseTagName())
          return this.error(26, createLocation3(closingTagNameStartPosition, this.clonePosition()));
        this.bumpSpace();
        if (!this.bumpIf(">"))
          return this.error(23, createLocation3(endTagStartPosition, this.clonePosition()));
        return {
          val: {
            type: 8,
            value: tagName,
            children,
            location: createLocation3(startPosition, this.clonePosition())
          },
          err: null
        };
      } else
        return this.error(27, createLocation3(startPosition, this.clonePosition()));
    } else
      return this.error(23, createLocation3(startPosition, this.clonePosition()));
  }
  /**
  * This method assumes that the caller has peeked ahead for the first tag character.
  */
  parseTagName() {
    const startOffset = this.offset();
    this.bump();
    while (!this.isEOF() && _isPotentialElementNameChar3(this.char()))
      this.bump();
    return this.message.slice(startOffset, this.offset());
  }
  parseLiteral(nestingLevel, parentArgType) {
    const start = this.clonePosition();
    let value = "";
    while (true) {
      const parseQuoteResult = this.tryParseQuote(parentArgType);
      if (parseQuoteResult) {
        value += parseQuoteResult;
        continue;
      }
      const parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
      if (parseUnquotedResult) {
        value += parseUnquotedResult;
        continue;
      }
      const parseLeftAngleResult = this.tryParseLeftAngleBracket();
      if (parseLeftAngleResult) {
        value += parseLeftAngleResult;
        continue;
      }
      break;
    }
    const location2 = createLocation3(start, this.clonePosition());
    return {
      val: {
        type: 0,
        value,
        location: location2
      },
      err: null
    };
  }
  tryParseLeftAngleBracket() {
    if (!this.isEOF() && this.char() === 60 && (this.ignoreTag || !_isAlphaOrSlash3(this.peek() || 0))) {
      this.bump();
      return "<";
    }
    return null;
  }
  /**
  * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
  * a character that requires quoting (that is, "only where needed"), and works the same in
  * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
  */
  tryParseQuote(parentArgType) {
    if (this.isEOF() || this.char() !== 39)
      return null;
    switch (this.peek()) {
      case 39:
        this.bump();
        this.bump();
        return "'";
      case 123:
      case 60:
      case 62:
      case 125:
        break;
      case 35:
        if (parentArgType === "plural" || parentArgType === "selectordinal")
          break;
        return null;
      default:
        return null;
    }
    this.bump();
    const codePoints = [this.char()];
    this.bump();
    while (!this.isEOF()) {
      const ch = this.char();
      if (ch === 39)
        if (this.peek() === 39) {
          codePoints.push(39);
          this.bump();
        } else {
          this.bump();
          break;
        }
      else
        codePoints.push(ch);
      this.bump();
    }
    return String.fromCodePoint(...codePoints);
  }
  tryParseUnquoted(nestingLevel, parentArgType) {
    if (this.isEOF())
      return null;
    const ch = this.char();
    if (ch === 60 || ch === 123 || ch === 35 && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 && nestingLevel > 0)
      return null;
    else {
      this.bump();
      return String.fromCodePoint(ch);
    }
  }
  parseArgument(nestingLevel, expectingCloseTag) {
    const openingBracePosition = this.clonePosition();
    this.bump();
    this.bumpSpace();
    if (this.isEOF())
      return this.error(1, createLocation3(openingBracePosition, this.clonePosition()));
    if (this.char() === 125) {
      this.bump();
      return this.error(2, createLocation3(openingBracePosition, this.clonePosition()));
    }
    let value = this.parseIdentifierIfPossible().value;
    if (!value)
      return this.error(3, createLocation3(openingBracePosition, this.clonePosition()));
    this.bumpSpace();
    if (this.isEOF())
      return this.error(1, createLocation3(openingBracePosition, this.clonePosition()));
    switch (this.char()) {
      case 125:
        this.bump();
        return {
          val: {
            type: 1,
            value,
            location: createLocation3(openingBracePosition, this.clonePosition())
          },
          err: null
        };
      case 44:
        this.bump();
        this.bumpSpace();
        if (this.isEOF())
          return this.error(1, createLocation3(openingBracePosition, this.clonePosition()));
        return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
      default:
        return this.error(3, createLocation3(openingBracePosition, this.clonePosition()));
    }
  }
  /**
  * Advance the parser until the end of the identifier, if it is currently on
  * an identifier character. Return an empty string otherwise.
  */
  parseIdentifierIfPossible() {
    const startingPosition = this.clonePosition();
    const startOffset = this.offset();
    const value = matchIdentifierAtIndex3(this.message, startOffset);
    const endOffset = startOffset + value.length;
    this.bumpTo(endOffset);
    return {
      value,
      location: createLocation3(startingPosition, this.clonePosition())
    };
  }
  parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition) {
    let typeStartPosition = this.clonePosition();
    let argType = this.parseIdentifierIfPossible().value;
    let typeEndPosition = this.clonePosition();
    switch (argType) {
      case "":
        return this.error(4, createLocation3(typeStartPosition, typeEndPosition));
      case "number":
      case "date":
      case "time": {
        this.bumpSpace();
        let styleAndLocation = null;
        if (this.bumpIf(",")) {
          this.bumpSpace();
          const styleStartPosition = this.clonePosition();
          const result = this.parseSimpleArgStyleIfPossible();
          if (result.err)
            return result;
          const style = trimEnd7(result.val);
          if (style.length === 0)
            return this.error(6, createLocation3(this.clonePosition(), this.clonePosition()));
          styleAndLocation = {
            style,
            styleLocation: createLocation3(styleStartPosition, this.clonePosition())
          };
        }
        const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
        if (argCloseResult.err)
          return argCloseResult;
        const location2 = createLocation3(openingBracePosition, this.clonePosition());
        if (styleAndLocation && styleAndLocation.style.startsWith("::")) {
          let skeleton = trimStart7(styleAndLocation.style.slice(2));
          if (argType === "number") {
            const result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
            if (result.err)
              return result;
            return {
              val: {
                type: 2,
                value,
                location: location2,
                style: result.val
              },
              err: null
            };
          } else {
            if (skeleton.length === 0)
              return this.error(10, location2);
            let dateTimePattern = skeleton;
            if (this.locale)
              dateTimePattern = getBestPattern3(skeleton, this.locale);
            const style = {
              type: 1,
              pattern: dateTimePattern,
              location: styleAndLocation.styleLocation,
              parsedOptions: this.shouldParseSkeletons ? parseDateTimeSkeleton3(dateTimePattern) : {}
            };
            return {
              val: {
                type: argType === "date" ? 3 : 4,
                value,
                location: location2,
                style
              },
              err: null
            };
          }
        }
        return {
          val: {
            type: argType === "number" ? 2 : argType === "date" ? 3 : 4,
            value,
            location: location2,
            style: styleAndLocation?.style ?? null
          },
          err: null
        };
      }
      case "plural":
      case "selectordinal":
      case "select": {
        const typeEndPosition2 = this.clonePosition();
        this.bumpSpace();
        if (!this.bumpIf(","))
          return this.error(12, createLocation3(typeEndPosition2, { ...typeEndPosition2 }));
        this.bumpSpace();
        let identifierAndLocation = this.parseIdentifierIfPossible();
        let pluralOffset = 0;
        if (argType !== "select" && identifierAndLocation.value === "offset") {
          if (!this.bumpIf(":"))
            return this.error(13, createLocation3(this.clonePosition(), this.clonePosition()));
          this.bumpSpace();
          const result = this.tryParseDecimalInteger(13, 14);
          if (result.err)
            return result;
          this.bumpSpace();
          identifierAndLocation = this.parseIdentifierIfPossible();
          pluralOffset = result.val;
        }
        const optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
        if (optionsResult.err)
          return optionsResult;
        const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
        if (argCloseResult.err)
          return argCloseResult;
        const location2 = createLocation3(openingBracePosition, this.clonePosition());
        if (argType === "select")
          return {
            val: {
              type: 5,
              value,
              options: fromEntries5(optionsResult.val),
              location: location2
            },
            err: null
          };
        else
          return {
            val: {
              type: 6,
              value,
              options: fromEntries5(optionsResult.val),
              offset: pluralOffset,
              pluralType: argType === "plural" ? "cardinal" : "ordinal",
              location: location2
            },
            err: null
          };
      }
      default:
        return this.error(5, createLocation3(typeStartPosition, typeEndPosition));
    }
  }
  tryParseArgumentClose(openingBracePosition) {
    if (this.isEOF() || this.char() !== 125)
      return this.error(1, createLocation3(openingBracePosition, this.clonePosition()));
    this.bump();
    return {
      val: true,
      err: null
    };
  }
  /**
  * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
  */
  parseSimpleArgStyleIfPossible() {
    let nestedBraces = 0;
    const startPosition = this.clonePosition();
    while (!this.isEOF())
      switch (this.char()) {
        case 39: {
          this.bump();
          let apostrophePosition = this.clonePosition();
          if (!this.bumpUntil("'"))
            return this.error(11, createLocation3(apostrophePosition, this.clonePosition()));
          this.bump();
          break;
        }
        case 123:
          nestedBraces += 1;
          this.bump();
          break;
        case 125:
          if (nestedBraces > 0)
            nestedBraces -= 1;
          else
            return {
              val: this.message.slice(startPosition.offset, this.offset()),
              err: null
            };
          break;
        default:
          this.bump();
          break;
      }
    return {
      val: this.message.slice(startPosition.offset, this.offset()),
      err: null
    };
  }
  parseNumberSkeletonFromString(skeleton, location2) {
    let tokens = [];
    try {
      tokens = parseNumberSkeletonFromString3(skeleton);
    } catch {
      return this.error(7, location2);
    }
    return {
      val: {
        type: 0,
        tokens,
        location: location2,
        parsedOptions: this.shouldParseSkeletons ? parseNumberSkeleton3(tokens) : {}
      },
      err: null
    };
  }
  /**
  * @param nesting_level The current nesting level of messages.
  *     This can be positive when parsing message fragment in select or plural argument options.
  * @param parent_arg_type The parent argument's type.
  * @param parsed_first_identifier If provided, this is the first identifier-like selector of
  *     the argument. It is a by-product of a previous parsing attempt.
  * @param expecting_close_tag If true, this message is directly or indirectly nested inside
  *     between a pair of opening and closing tags. The nested message will not parse beyond
  *     the closing tag boundary.
  */
  tryParsePluralOrSelectOptions(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
    let hasOtherClause = false;
    const options = [];
    const parsedSelectors = /* @__PURE__ */ new Set();
    let { value: selector, location: selectorLocation } = parsedFirstIdentifier;
    while (true) {
      if (selector.length === 0) {
        const startPosition = this.clonePosition();
        if (parentArgType !== "select" && this.bumpIf("=")) {
          const result = this.tryParseDecimalInteger(16, 19);
          if (result.err)
            return result;
          selectorLocation = createLocation3(startPosition, this.clonePosition());
          selector = this.message.slice(startPosition.offset, this.offset());
        } else
          break;
      }
      if (parsedSelectors.has(selector))
        return this.error(parentArgType === "select" ? 21 : 20, selectorLocation);
      if (selector === "other")
        hasOtherClause = true;
      this.bumpSpace();
      const openingBracePosition = this.clonePosition();
      if (!this.bumpIf("{"))
        return this.error(parentArgType === "select" ? 17 : 18, createLocation3(this.clonePosition(), this.clonePosition()));
      const fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
      if (fragmentResult.err)
        return fragmentResult;
      const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
      if (argCloseResult.err)
        return argCloseResult;
      options.push([selector, {
        value: fragmentResult.val,
        location: createLocation3(openingBracePosition, this.clonePosition())
      }]);
      parsedSelectors.add(selector);
      this.bumpSpace();
      ({ value: selector, location: selectorLocation } = this.parseIdentifierIfPossible());
    }
    if (options.length === 0)
      return this.error(parentArgType === "select" ? 15 : 16, createLocation3(this.clonePosition(), this.clonePosition()));
    if (this.requiresOtherClause && !hasOtherClause)
      return this.error(22, createLocation3(this.clonePosition(), this.clonePosition()));
    return {
      val: options,
      err: null
    };
  }
  tryParseDecimalInteger(expectNumberError, invalidNumberError) {
    let sign = 1;
    const startingPosition = this.clonePosition();
    if (this.bumpIf("+")) {
    } else if (this.bumpIf("-"))
      sign = -1;
    let hasDigits = false;
    let decimal = 0;
    while (!this.isEOF()) {
      const ch = this.char();
      if (ch >= 48 && ch <= 57) {
        hasDigits = true;
        decimal = decimal * 10 + (ch - 48);
        this.bump();
      } else
        break;
    }
    const location2 = createLocation3(startingPosition, this.clonePosition());
    if (!hasDigits)
      return this.error(expectNumberError, location2);
    decimal *= sign;
    if (!Number.isSafeInteger(decimal))
      return this.error(invalidNumberError, location2);
    return {
      val: decimal,
      err: null
    };
  }
  offset() {
    return this.position.offset;
  }
  isEOF() {
    return this.offset() === this.message.length;
  }
  clonePosition() {
    return {
      offset: this.position.offset,
      line: this.position.line,
      column: this.position.column
    };
  }
  /**
  * Return the code point at the current position of the parser.
  * Throws if the index is out of bound.
  */
  char() {
    const offset = this.position.offset;
    if (offset >= this.message.length)
      throw Error("out of bound");
    const code = this.message.codePointAt(offset);
    if (code === void 0)
      throw Error(`Offset ${offset} is at invalid UTF-16 code unit boundary`);
    return code;
  }
  error(kind, location2) {
    return {
      val: null,
      err: {
        kind,
        message: this.message,
        location: location2
      }
    };
  }
  /** Bump the parser to the next UTF-16 code unit. */
  bump() {
    if (this.isEOF())
      return;
    const code = this.char();
    if (code === 10) {
      this.position.line += 1;
      this.position.column = 1;
      this.position.offset += 1;
    } else {
      this.position.column += 1;
      this.position.offset += code < 65536 ? 1 : 2;
    }
  }
  /**
  * If the substring starting at the current position of the parser has
  * the given prefix, then bump the parser to the character immediately
  * following the prefix and return true. Otherwise, don't bump the parser
  * and return false.
  */
  bumpIf(prefix) {
    if (this.message.startsWith(prefix, this.offset())) {
      for (let i = 0; i < prefix.length; i++)
        this.bump();
      return true;
    }
    return false;
  }
  /**
  * Bump the parser until the pattern character is found and return `true`.
  * Otherwise bump to the end of the file and return `false`.
  */
  bumpUntil(pattern) {
    const currentOffset = this.offset();
    const index = this.message.indexOf(pattern, currentOffset);
    if (index >= 0) {
      this.bumpTo(index);
      return true;
    } else {
      this.bumpTo(this.message.length);
      return false;
    }
  }
  /**
  * Bump the parser to the target offset.
  * If target offset is beyond the end of the input, bump the parser to the end of the input.
  */
  bumpTo(targetOffset) {
    if (this.offset() > targetOffset)
      throw Error(`targetOffset ${targetOffset} must be greater than or equal to the current offset ${this.offset()}`);
    targetOffset = Math.min(targetOffset, this.message.length);
    while (true) {
      const offset = this.offset();
      if (offset === targetOffset)
        break;
      if (offset > targetOffset)
        throw Error(`targetOffset ${targetOffset} is at invalid UTF-16 code unit boundary`);
      this.bump();
      if (this.isEOF())
        break;
    }
  }
  /** advance the parser through all whitespace to the next non-whitespace code unit. */
  bumpSpace() {
    while (!this.isEOF() && _isWhiteSpace3(this.char()))
      this.bump();
  }
  /**
  * Peek at the *next* Unicode codepoint in the input without advancing the parser.
  * If the input has been exhausted, then this returns null.
  */
  peek() {
    if (this.isEOF())
      return null;
    const code = this.char();
    const offset = this.offset();
    return this.message.charCodeAt(offset + (code >= 65536 ? 2 : 1)) ?? null;
  }
};
function _isAlpha3(codepoint) {
  return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function _isAlphaOrSlash3(codepoint) {
  return _isAlpha3(codepoint) || codepoint === 47;
}
function _isPotentialElementNameChar3(c) {
  return c === 45 || c === 46 || c >= 48 && c <= 57 || c === 95 || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 183 || c >= 192 && c <= 214 || c >= 216 && c <= 246 || c >= 248 && c <= 893 || c >= 895 && c <= 8191 || c >= 8204 && c <= 8205 || c >= 8255 && c <= 8256 || c >= 8304 && c <= 8591 || c >= 11264 && c <= 12271 || c >= 12289 && c <= 55295 || c >= 63744 && c <= 64975 || c >= 65008 && c <= 65533 || c >= 65536 && c <= 983039;
}
function _isWhiteSpace3(c) {
  return c >= 9 && c <= 13 || c === 32 || c === 133 || c >= 8206 && c <= 8207 || c === 8232 || c === 8233;
}
function pruneLocation3(els) {
  els.forEach((el) => {
    delete el.location;
    if (isSelectElement3(el) || isPluralElement3(el))
      for (const k in el.options) {
        delete el.options[k].location;
        pruneLocation3(el.options[k].value);
      }
    else if (isNumberElement3(el) && isNumberSkeleton3(el.style))
      delete el.style.location;
    else if ((isDateElement3(el) || isTimeElement3(el)) && isDateTimeSkeleton3(el.style))
      delete el.style.location;
    else if (isTagElement3(el))
      pruneLocation3(el.children);
  });
}
function parse3(message, opts = {}) {
  opts = {
    shouldParseSkeletons: true,
    requiresOtherClause: true,
    ...opts
  };
  const result = new Parser3(message, opts).parse();
  if (result.err) {
    const error = SyntaxError(ErrorKind3[result.err.kind]);
    error.location = result.err.location;
    error.originalMessage = result.err.message;
    throw error;
  }
  if (!opts?.captureLocation)
    pruneLocation3(result.val);
  return result.val;
}

// ../../node_modules/react-intl/node_modules/intl-messageformat/index.js
var FormatError3 = class extends Error {
  constructor(msg, code, originalMessage) {
    super(msg);
    this.code = code;
    this.originalMessage = originalMessage;
  }
  toString() {
    return `[formatjs Error: ${this.code}] ${this.message}`;
  }
};
var InvalidValueError3 = class extends FormatError3 {
  constructor(variableId, value, options, originalMessage) {
    super(`Invalid values for "${variableId}": "${value}". Options are "${Object.keys(options).join('", "')}"`, "INVALID_VALUE", originalMessage);
  }
};
var InvalidValueTypeError3 = class extends FormatError3 {
  constructor(value, type, originalMessage) {
    super(`Value for "${value}" must be of type ${type}`, "INVALID_VALUE", originalMessage);
  }
};
var MissingValueError3 = class extends FormatError3 {
  constructor(variableId, originalMessage) {
    super(`The intl string context variable "${variableId}" was not provided to the string "${originalMessage}"`, "MISSING_VALUE", originalMessage);
  }
};
function mergeLiteral3(parts) {
  if (parts.length < 2)
    return parts;
  return parts.reduce((all, part) => {
    const lastPart = all[all.length - 1];
    if (!lastPart || lastPart.type !== 0 || part.type !== 0)
      all.push(part);
    else
      lastPart.value += part.value;
    return all;
  }, []);
}
function isFormatXMLElementFn3(el) {
  return typeof el === "function";
}
function formatToParts3(els, locales, formatters, formats, values, currentPluralValue, originalMessage) {
  if (els.length === 1 && isLiteralElement3(els[0]))
    return [{
      type: 0,
      value: els[0].value
    }];
  const result = [];
  for (const el of els) {
    if (isLiteralElement3(el)) {
      result.push({
        type: 0,
        value: el.value
      });
      continue;
    }
    if (isPoundElement3(el)) {
      if (typeof currentPluralValue === "number")
        result.push({
          type: 0,
          value: formatters.getNumberFormat(locales).format(currentPluralValue)
        });
      continue;
    }
    const { value: varName } = el;
    if (!(values && varName in values))
      throw new MissingValueError3(varName, originalMessage);
    let value = values[varName];
    if (isArgumentElement3(el)) {
      if (!value || typeof value === "string" || typeof value === "number" || typeof value === "bigint")
        value = typeof value === "string" || typeof value === "number" || typeof value === "bigint" ? String(value) : "";
      result.push({
        type: typeof value === "string" ? 0 : 1,
        value
      });
      continue;
    }
    if (isDateElement3(el)) {
      const style = typeof el.style === "string" ? formats.date[el.style] : isDateTimeSkeleton3(el.style) ? el.style.parsedOptions : void 0;
      result.push({
        type: 0,
        value: formatters.getDateTimeFormat(locales, style).format(value)
      });
      continue;
    }
    if (isTimeElement3(el)) {
      const style = typeof el.style === "string" ? formats.time[el.style] : isDateTimeSkeleton3(el.style) ? el.style.parsedOptions : formats.time.medium;
      result.push({
        type: 0,
        value: formatters.getDateTimeFormat(locales, style).format(value)
      });
      continue;
    }
    if (isNumberElement3(el)) {
      const style = typeof el.style === "string" ? formats.number[el.style] : isNumberSkeleton3(el.style) ? el.style.parsedOptions : void 0;
      if (style && style.scale) {
        const scale = style.scale || 1;
        if (typeof value === "bigint") {
          if (!Number.isInteger(scale))
            throw new TypeError(`Cannot apply fractional scale ${scale} to bigint value. Scale must be an integer when formatting bigint.`);
          value = value * BigInt(scale);
        } else
          value = value * scale;
      }
      result.push({
        type: 0,
        value: formatters.getNumberFormat(locales, style).format(value)
      });
      continue;
    }
    if (isTagElement3(el)) {
      const { children, value: value2 } = el;
      const formatFn = values[value2];
      if (!isFormatXMLElementFn3(formatFn))
        throw new InvalidValueTypeError3(value2, "function", originalMessage);
      let chunks = formatFn(formatToParts3(children, locales, formatters, formats, values, currentPluralValue).map((p) => p.value));
      if (!Array.isArray(chunks))
        chunks = [chunks];
      result.push(...chunks.map((c) => {
        return {
          type: typeof c === "string" ? 0 : 1,
          value: c
        };
      }));
    }
    if (isSelectElement3(el)) {
      const key = value;
      const opt = (Object.prototype.hasOwnProperty.call(el.options, key) ? el.options[key] : void 0) || el.options.other;
      if (!opt)
        throw new InvalidValueError3(el.value, value, Object.keys(el.options), originalMessage);
      result.push(...formatToParts3(opt.value, locales, formatters, formats, values));
      continue;
    }
    if (isPluralElement3(el)) {
      const exactKey = `=${value}`;
      let opt = Object.prototype.hasOwnProperty.call(el.options, exactKey) ? el.options[exactKey] : void 0;
      if (!opt) {
        if (!Intl.PluralRules)
          throw new FormatError3(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, "MISSING_INTL_API", originalMessage);
        const numericValue2 = typeof value === "bigint" ? Number(value) : value;
        const rule = formatters.getPluralRules(locales, { type: el.pluralType }).select(numericValue2 - (el.offset || 0));
        opt = (Object.prototype.hasOwnProperty.call(el.options, rule) ? el.options[rule] : void 0) || el.options.other;
      }
      if (!opt)
        throw new InvalidValueError3(el.value, value, Object.keys(el.options), originalMessage);
      const numericValue = typeof value === "bigint" ? Number(value) : value;
      result.push(...formatToParts3(opt.value, locales, formatters, formats, values, numericValue - (el.offset || 0)));
      continue;
    }
  }
  return mergeLiteral3(result);
}
function mergeConfig3(c1, c2) {
  if (!c2)
    return c1;
  return {
    ...c1,
    ...c2,
    ...Object.keys(c1).reduce((all, k) => {
      all[k] = {
        ...c1[k],
        ...c2[k]
      };
      return all;
    }, {})
  };
}
function mergeConfigs3(defaultConfig, configs) {
  if (!configs)
    return defaultConfig;
  return Object.keys(defaultConfig).reduce((all, k) => {
    all[k] = mergeConfig3(defaultConfig[k], configs[k]);
    return all;
  }, { ...defaultConfig });
}
function createFastMemoizeCache4(store) {
  return { create() {
    return {
      get(key) {
        return store[key];
      },
      set(key, value) {
        store[key] = value;
      }
    };
  } };
}
function createDefaultFormatters3(cache = {
  number: {},
  dateTime: {},
  pluralRules: {}
}) {
  return {
    getNumberFormat: memoize3((...args) => new Intl.NumberFormat(...args), {
      cache: createFastMemoizeCache4(cache.number),
      strategy: strategies3.variadic
    }),
    getDateTimeFormat: memoize3((...args) => new Intl.DateTimeFormat(...args), {
      cache: createFastMemoizeCache4(cache.dateTime),
      strategy: strategies3.variadic
    }),
    getPluralRules: memoize3((...args) => new Intl.PluralRules(...args), {
      cache: createFastMemoizeCache4(cache.pluralRules),
      strategy: strategies3.variadic
    })
  };
}
var IntlMessageFormat4 = class IntlMessageFormat5 {
  constructor(message, locales = IntlMessageFormat5.defaultLocale, overrideFormats, opts) {
    this.formatterCache = {
      number: {},
      dateTime: {},
      pluralRules: {}
    };
    this.format = (values) => {
      const parts = this.formatToParts(values);
      if (parts.length === 1)
        return parts[0].value;
      const result = parts.reduce((all, part) => {
        if (!all.length || part.type !== 0 || typeof all[all.length - 1] !== "string")
          all.push(part.value);
        else
          all[all.length - 1] += part.value;
        return all;
      }, []);
      if (result.length <= 1)
        return result[0] || "";
      return result;
    };
    this.formatToParts = (values) => formatToParts3(this.ast, this.locales, this.formatters, this.formats, values, void 0, this.message);
    this.resolvedOptions = () => ({ locale: this.resolvedLocale?.toString() || Intl.NumberFormat.supportedLocalesOf(this.locales)[0] });
    this.getAst = () => this.ast;
    this.locales = locales;
    this.resolvedLocale = IntlMessageFormat5.resolveLocale(locales);
    if (typeof message === "string") {
      this.message = message;
      if (!IntlMessageFormat5.__parse)
        throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
      const { ...parseOpts } = opts || {};
      this.ast = IntlMessageFormat5.__parse(message, {
        ...parseOpts,
        locale: this.resolvedLocale
      });
    } else
      this.ast = message;
    if (!Array.isArray(this.ast))
      throw new TypeError("A message must be provided as a String or AST.");
    this.formats = mergeConfigs3(IntlMessageFormat5.formats, overrideFormats);
    this.formatters = opts && opts.formatters || createDefaultFormatters3(this.formatterCache);
  }
  static {
    this.memoizedDefaultLocale = null;
  }
  static get defaultLocale() {
    if (!IntlMessageFormat5.memoizedDefaultLocale)
      IntlMessageFormat5.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
    return IntlMessageFormat5.memoizedDefaultLocale;
  }
  static {
    this.resolveLocale = (locales) => {
      if (typeof Intl.Locale === "undefined")
        return;
      const supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
      if (supportedLocales.length > 0)
        return new Intl.Locale(supportedLocales[0]);
      return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
  }
  static {
    this.__parse = parse3;
  }
  static {
    this.formats = {
      number: {
        integer: { maximumFractionDigits: 0 },
        currency: { style: "currency" },
        percent: { style: "percent" }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    };
  }
};

// ../../node_modules/react-intl/index.js
function invariant3(condition, message, Err = Error) {
  if (!condition)
    throw new Err(message);
}
function invariantIntlContext(intl) {
  invariant3(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var DEFAULT_INTL_CONFIG$1 = {
  ...DEFAULT_INTL_CONFIG,
  textComponent: React56.Fragment
};
var toKeyedReactNodeArray = (children) => {
  return React56.Children.toArray(children).map((child, index) => {
    if (React56.isValidElement(child))
      return /* @__PURE__ */ jsx13(React56.Fragment, { children: child }, index);
    return child;
  });
};
function assignUniqueKeysToParts(formatXMLElementFn) {
  return function(parts) {
    return formatXMLElementFn(toKeyedReactNodeArray(parts));
  };
}
function shallowEqual(objA, objB) {
  if (objA === objB)
    return true;
  if (!objA || !objB)
    return false;
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;
  if (bKeys.length !== len)
    return false;
  for (var i = 0; i < len; i++) {
    var key = aKeys[i];
    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key))
      return false;
  }
  return true;
}
var IntlContext = React56.createContext(null);
var Provider = IntlContext.Provider;
function useIntl() {
  const intl = React56.useContext(IntlContext);
  invariantIntlContext(intl);
  return intl;
}
var DisplayName = /* @__PURE__ */ function(DisplayName2) {
  DisplayName2["formatDate"] = "FormattedDate";
  DisplayName2["formatTime"] = "FormattedTime";
  DisplayName2["formatNumber"] = "FormattedNumber";
  DisplayName2["formatList"] = "FormattedList";
  DisplayName2["formatDisplayName"] = "FormattedDisplayName";
  return DisplayName2;
}(DisplayName || {});
var DisplayNameParts = /* @__PURE__ */ function(DisplayNameParts2) {
  DisplayNameParts2["formatDate"] = "FormattedDateParts";
  DisplayNameParts2["formatTime"] = "FormattedTimeParts";
  DisplayNameParts2["formatNumber"] = "FormattedNumberParts";
  DisplayNameParts2["formatList"] = "FormattedListParts";
  return DisplayNameParts2;
}(DisplayNameParts || {});
var FormattedNumberParts = (props) => {
  const intl = useIntl();
  const { value, children, ...formatProps } = props;
  return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = "FormattedNumberParts";
var FormattedListParts = (props) => {
  const intl = useIntl();
  const { value, children, ...formatProps } = props;
  return children(intl.formatListToParts(value, formatProps));
};
FormattedListParts.displayName = "FormattedListParts";
function createFormattedDateTimePartsComponent(name) {
  const ComponentParts = (props) => {
    const intl = useIntl();
    const { value, children, ...formatProps } = props;
    const date = typeof value === "string" ? new Date(value || 0) : value;
    return children(name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps));
  };
  ComponentParts.displayName = DisplayNameParts[name];
  return ComponentParts;
}
function createFormattedComponent(name) {
  const Component2 = (props) => {
    const intl = useIntl();
    const { value, children, ...formatProps } = props;
    const formattedValue = intl[name](value, formatProps);
    if (typeof children === "function")
      return children(formattedValue);
    return /* @__PURE__ */ jsx13(intl.textComponent || React56.Fragment, { children: formattedValue });
  };
  Component2.displayName = DisplayName[name];
  return Component2;
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
  if (!values)
    return values;
  return Object.keys(values).reduce((acc, k) => {
    const v = values[k];
    acc[k] = isFormatXMLElementFn3(v) ? assignUniqueKeysToParts(v) : v;
    return acc;
  }, {});
}
var formatMessage$1 = (config, formatters, descriptor, rawValues, ...rest) => {
  const chunks = formatMessage(config, formatters, descriptor, assignUniqueKeysToFormatXMLElementFnArgument(rawValues), ...rest);
  if (Array.isArray(chunks))
    return toKeyedReactNodeArray(chunks);
  return chunks;
};
var createIntl2 = ({ defaultRichTextElements: rawDefaultRichTextElements, ...config }, cache) => {
  const defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
  const coreIntl = createIntl({
    ...DEFAULT_INTL_CONFIG$1,
    ...config,
    defaultRichTextElements
  }, cache);
  const resolvedConfig = {
    locale: coreIntl.locale,
    timeZone: coreIntl.timeZone,
    fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
    formats: coreIntl.formats,
    defaultLocale: coreIntl.defaultLocale,
    defaultFormats: coreIntl.defaultFormats,
    messages: coreIntl.messages,
    onError: coreIntl.onError,
    defaultRichTextElements
  };
  return {
    ...coreIntl,
    formatMessage: formatMessage$1.bind(null, resolvedConfig, coreIntl.formatters),
    $t: formatMessage$1.bind(null, resolvedConfig, coreIntl.formatters)
  };
};
var FormattedDateTimeRange = (props) => {
  const intl = useIntl();
  const { from, to, children, ...formatProps } = props;
  const formattedValue = intl.formatDateTimeRange(from, to, formatProps);
  if (typeof children === "function")
    return children(formattedValue);
  return /* @__PURE__ */ jsx13(intl.textComponent || React56.Fragment, { children: formattedValue });
};
FormattedDateTimeRange.displayName = "FormattedDateTimeRange";
function areEqual(prevProps, nextProps) {
  const { values, ...otherProps } = prevProps;
  const { values: nextValues, ...nextOtherProps } = nextProps;
  return shallowEqual(nextValues, values) && shallowEqual(otherProps, nextOtherProps);
}
function FormattedMessage(props) {
  const { formatMessage: formatMessage2, textComponent: Text2 = React56.Fragment } = useIntl();
  const { id, description, defaultMessage, values, children, tagName: Component2 = Text2, ignoreTag } = props;
  const nodes = formatMessage2({
    id,
    description,
    defaultMessage
  }, values, { ignoreTag });
  if (typeof children === "function")
    return children(Array.isArray(nodes) ? nodes : [nodes]);
  if (Component2)
    return /* @__PURE__ */ jsx13(Component2, { children: nodes });
  return /* @__PURE__ */ jsx13(Fragment6, { children: nodes });
}
FormattedMessage.displayName = "FormattedMessage";
var MemoizedFormattedMessage = React56.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var FormattedPlural = (props) => {
  const { formatPlural: formatPlural2, textComponent: Text2 } = useIntl();
  const { value, other, children } = props;
  const formattedPlural = props[formatPlural2(value, props)] || other;
  if (typeof children === "function")
    return children(formattedPlural);
  if (Text2)
    return /* @__PURE__ */ jsx13(Text2, { children: formattedPlural });
  return formattedPlural;
};
FormattedPlural.displayName = "FormattedPlural";
function processIntlConfig(config) {
  return {
    locale: config.locale,
    timeZone: config.timeZone,
    fallbackOnEmptyString: config.fallbackOnEmptyString,
    formats: config.formats,
    textComponent: config.textComponent,
    messages: config.messages,
    defaultLocale: config.defaultLocale,
    defaultFormats: config.defaultFormats,
    onError: config.onError,
    onWarn: config.onWarn,
    wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
    defaultRichTextElements: config.defaultRichTextElements
  };
}
function IntlProviderImpl(props) {
  const cacheRef = React56.useRef(createIntlCache());
  const prevConfigRef = React56.useRef(void 0);
  const intlRef = React56.useRef(void 0);
  const filteredProps = {};
  for (const key in props)
    if (props[key] !== void 0)
      filteredProps[key] = props[key];
  const config = processIntlConfig({
    ...DEFAULT_INTL_CONFIG$1,
    ...filteredProps
  });
  if (!prevConfigRef.current || !shallowEqual(prevConfigRef.current, config)) {
    prevConfigRef.current = config;
    intlRef.current = createIntl2(config, cacheRef.current);
  }
  invariantIntlContext(intlRef.current);
  return /* @__PURE__ */ jsx13(Provider, {
    value: intlRef.current,
    children: props.children
  });
}
IntlProviderImpl.displayName = "IntlProvider";
var IntlProvider = IntlProviderImpl;
var MINUTE = 60;
var HOUR = 3600;
var DAY = 3600 * 24;
function selectUnit(seconds) {
  const absValue = Math.abs(seconds);
  if (absValue < MINUTE)
    return "second";
  if (absValue < HOUR)
    return "minute";
  if (absValue < DAY)
    return "hour";
  return "day";
}
function getDurationInSeconds(unit) {
  switch (unit) {
    case "second":
      return 1;
    case "minute":
      return MINUTE;
    case "hour":
      return HOUR;
    default:
      return DAY;
  }
}
function valueToSeconds(value, unit) {
  if (!value)
    return 0;
  switch (unit) {
    case "second":
      return value;
    case "minute":
      return value * MINUTE;
    default:
      return value * HOUR;
  }
}
var INCREMENTABLE_UNITS = [
  "second",
  "minute",
  "hour"
];
function canIncrement(unit = "second") {
  return INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var SimpleFormattedRelativeTime = (props) => {
  const { formatRelativeTime: formatRelativeTime2, textComponent: Text2 } = useIntl();
  const { children, value, unit, ...otherProps } = props;
  const formattedRelativeTime = formatRelativeTime2(value || 0, unit, otherProps);
  if (typeof children === "function")
    return children(formattedRelativeTime);
  if (Text2)
    return /* @__PURE__ */ jsx13(Text2, { children: formattedRelativeTime });
  return /* @__PURE__ */ jsx13(Fragment6, { children: formattedRelativeTime });
};
var FormattedRelativeTime = ({ value = 0, unit = "second", updateIntervalInSeconds, ...otherProps }) => {
  invariant3(!updateIntervalInSeconds || !!(updateIntervalInSeconds && canIncrement(unit)), "Cannot schedule update with unit longer than hour");
  const [prevUnit, setPrevUnit] = React56.useState();
  const [prevValue, setPrevValue] = React56.useState(0);
  const [currentValueInSeconds, setCurrentValueInSeconds] = React56.useState(0);
  const updateTimer = React56.useRef(void 0);
  if (unit !== prevUnit || value !== prevValue) {
    setPrevValue(value || 0);
    setPrevUnit(unit);
    setCurrentValueInSeconds(canIncrement(unit) ? valueToSeconds(value, unit) : 0);
  }
  React56.useEffect(() => {
    function clearUpdateTimer() {
      clearTimeout(updateTimer.current);
    }
    clearUpdateTimer();
    if (!updateIntervalInSeconds || !canIncrement(unit))
      return clearUpdateTimer;
    const nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
    const nextUnit = selectUnit(nextValueInSeconds);
    if (nextUnit === "day")
      return clearUpdateTimer;
    const unitDuration = getDurationInSeconds(nextUnit);
    const prevInterestingValueInSeconds = nextValueInSeconds - nextValueInSeconds % unitDuration;
    const nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
    const delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
    if (currentValueInSeconds !== nextInterestingValueInSeconds)
      updateTimer.current = setTimeout(() => setCurrentValueInSeconds(nextInterestingValueInSeconds), delayInSeconds * 1e3);
    return clearUpdateTimer;
  }, [
    currentValueInSeconds,
    updateIntervalInSeconds,
    unit
  ]);
  let currentValue = value || 0;
  let currentUnit = unit;
  if (canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
    currentUnit = selectUnit(currentValueInSeconds);
    const unitDuration = getDurationInSeconds(currentUnit);
    currentValue = Math.round(currentValueInSeconds / unitDuration);
  }
  return /* @__PURE__ */ jsx13(SimpleFormattedRelativeTime, {
    value: currentValue,
    unit: currentUnit,
    ...otherProps
  });
};
FormattedRelativeTime.displayName = "FormattedRelativeTime";
var FormattedDate = createFormattedComponent("formatDate");
var FormattedTime = createFormattedComponent("formatTime");
var FormattedNumber = createFormattedComponent("formatNumber");
var FormattedList = createFormattedComponent("formatList");
var FormattedDisplayName = createFormattedComponent("formatDisplayName");
var FormattedDateParts = createFormattedDateTimePartsComponent("formatDate");
var FormattedTimeParts = createFormattedDateTimePartsComponent("formatTime");

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/index.js
import React58 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/internal-do-not-use-core.js
import React57 from "react";
var Button3 = React57.forwardRef(({ children, iconName, iconAlign = "left", iconUrl, iconSvg, iconAlt, variant = "normal", loading = false, loadingText, disabled = false, disabledReason, wrapText = true, href, target, rel, external = false, download, formAction = "submit", ariaLabel, ariaDescribedby, onClick, onFollow, ariaExpanded, ariaHaspopup, ariaControls, fullWidth, form, i18nStrings, style, nativeButtonAttributes, nativeAnchorAttributes, ...props }, ref) => {
  const baseComponentProps = useBaseComponent("Button", {
    props: { formAction, fullWidth, iconAlign, iconName, rel, target, external, variant, wrapText },
    metadata: { hasDisabledReason: Boolean(disabledReason) }
  });
  const baseProps = getBaseProps(props);
  return React57.createElement(InternalButton, { ...baseProps, ...baseComponentProps, ref, iconName, iconAlign, iconUrl, iconSvg, iconAlt, variant, loading, loadingText, disabled, disabledReason, wrapText, href, target, rel, external, download, formAction, ariaLabel, ariaDescribedby, onClick, onFollow, ariaExpanded, ariaHaspopup, ariaControls, fullWidth, form, i18nStrings, style, styleClassNames: props.styleClassNames, nativeButtonAttributes, nativeAnchorAttributes, __injectAnalyticsComponentMetadata: true }, children);
});
applyDisplayName(Button3, "Button");
var internal_do_not_use_core_default2 = Button3;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/button/index.js
var Button4 = React58.forwardRef((props, ref) => {
  validateProps("Button", props, ["nativeAnchorAttributes", "nativeButtonAttributes", "style"], {}, "console");
  return React58.createElement(internal_do_not_use_core_default2, { ref, ...props });
});
applyDisplayName(Button4, "Button");
var button_default = Button4;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/link/index.js
import React61 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/link/internal-do-not-use-core.js
import React60 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/link/internal.js
import React59, { useContext as useContext11, useRef as useRef29 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/link/style.js
function getLinkStyles(style) {
  var _a3, _b, _c, _d, _e, _f, _g, _h;
  let properties = {};
  if ((style === null || style === void 0 ? void 0 : style.root) && SYSTEM === "core") {
    properties = {
      ...((_a3 = style === null || style === void 0 ? void 0 : style.root) === null || _a3 === void 0 ? void 0 : _a3.color) && {
        [custom_css_properties_default.styleColorActive]: (_b = style.root.color) === null || _b === void 0 ? void 0 : _b.active,
        [custom_css_properties_default.styleColorDefault]: (_c = style.root.color) === null || _c === void 0 ? void 0 : _c.default,
        [custom_css_properties_default.styleColorHover]: (_d = style.root.color) === null || _d === void 0 ? void 0 : _d.hover
      },
      ...((_e = style.root) === null || _e === void 0 ? void 0 : _e.focusRing) && {
        [custom_css_properties_default.styleFocusRingBorderColor]: (_f = style.root.focusRing) === null || _f === void 0 ? void 0 : _f.borderColor,
        [custom_css_properties_default.styleFocusRingBorderRadius]: (_g = style.root.focusRing) === null || _g === void 0 ? void 0 : _g.borderRadius,
        [custom_css_properties_default.styleFocusRingBorderWidth]: (_h = style.root.focusRing) === null || _h === void 0 ? void 0 : _h.borderWidth
      }
    };
  }
  return properties;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/link/styles.css.js
var styles_css_default22 = {
  "link": "awsui_link_4c84z_1w178_9",
  "variant-recovery": "awsui_variant-recovery_4c84z_1w178_77",
  "variant-secondary": "awsui_variant-secondary_4c84z_1w178_110",
  "variant-primary": "awsui_variant-primary_4c84z_1w178_145",
  "variant-info": "awsui_variant-info_4c84z_1w178_178",
  "variant-value-large": "awsui_variant-value-large_4c84z_1w178_213",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_1w178_245",
  "button": "awsui_button_4c84z_1w178_280",
  "color-inverted": "awsui_color-inverted_4c84z_1w178_354",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_1w178_385",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_1w178_393",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_1w178_400",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_1w178_408",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_1w178_416",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_1w178_424",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_1w178_432",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_1w178_440",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_1w178_448",
  "in-inline-token": "awsui_in-inline-token_4c84z_1w178_456",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_1w178_460",
  "icon": "awsui_icon_4c84z_1w178_460"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/link/internal.js
var InternalLink = React59.forwardRef(({ variant: providedVariant, fontSize = "body-m", color = "normal", external = false, target, href, rel, ariaLabel, externalIconAriaLabel, onFollow, onClick, children, nativeAttributes, __internalRootRef, style, styleClassNames, ...props }, ref) => {
  checkSafeUrl("Link", href);
  const isButton = !href;
  const { defaultVariant } = useContext11(LinkDefaultVariantContext);
  const variant = providedVariant || defaultVariant;
  const specialStyles = ["top-navigation", "link", "recovery", "info"];
  const hasSpecialStyle = specialStyles.indexOf(variant) > -1;
  const i18n = useInternalI18n("link");
  const baseProps = getBaseProps(props);
  const anchorTarget = target !== null && target !== void 0 ? target : external ? "_blank" : void 0;
  const anchorRel = rel !== null && rel !== void 0 ? rel : anchorTarget === "_blank" ? "noopener noreferrer" : void 0;
  const uniqueId = useUniqueId("link");
  const linkId = useUniqueId("link-self");
  const infoId = useUniqueId("link-info");
  const infoLinkLabelFromContext = useContext11(InfoLinkLabelContext);
  const { funnelIdentifier, funnelInteractionId } = useFunnel();
  const { stepIdentifier, stepNumber, stepNameSelector } = useFunnelStep();
  const { subStepIdentifier, subStepSelector, subStepNameSelector } = useFunnelSubStep();
  const fireFunnelEvent = (funnelInteractionId2) => {
    if (variant === "info") {
      const stepName = getTextFromSelector(stepNameSelector);
      const subStepName = getTextFromSelector(subStepNameSelector);
      FunnelMetrics.helpPanelInteracted({
        funnelIdentifier,
        funnelInteractionId: funnelInteractionId2,
        stepIdentifier,
        stepNumber,
        stepName,
        subStepIdentifier,
        stepNameSelector,
        subStepSelector,
        subStepName,
        subStepNameSelector,
        elementSelector: getFunnelValueSelector(uniqueId),
        subStepAllSelector: getSubStepAllSelector()
      });
    } else if (external) {
      const stepName = getTextFromSelector(stepNameSelector);
      const subStepName = getTextFromSelector(subStepNameSelector);
      FunnelMetrics.externalLinkInteracted({
        funnelIdentifier,
        funnelInteractionId: funnelInteractionId2,
        stepIdentifier,
        stepNumber,
        stepName,
        stepNameSelector,
        subStepIdentifier,
        subStepSelector,
        subStepName,
        subStepNameSelector,
        elementSelector: getFunnelValueSelector(uniqueId),
        subStepAllSelector: getSubStepAllSelector()
      });
    }
  };
  const fireFollowEvent = (event) => {
    if (funnelInteractionId) {
      fireFunnelEvent(funnelInteractionId);
    }
    fireCancelableEvent(onFollow, { href, external, target: anchorTarget }, event);
  };
  const fireClickEvent = (event) => {
    const { altKey, ctrlKey, metaKey, shiftKey } = event;
    const button = "button" in event ? event.button : 0;
    fireNonCancelableEvent(onClick, { altKey, button, ctrlKey, metaKey, shiftKey });
  };
  const handleLinkClick = (event) => {
    if (isPlainLeftClick(event)) {
      fireFollowEvent(event);
    }
    fireClickEvent(event);
  };
  const handleButtonClick = (event) => {
    fireFollowEvent(event);
    fireClickEvent(event);
  };
  const handleButtonKeyDown = (event) => {
    if (event.keyCode === KeyCode2.space || event.keyCode === KeyCode2.enter) {
      event.preventDefault();
      fireFollowEvent(event);
      fireClickEvent(event);
    }
  };
  const linkRef = useRef29(null);
  const isVisualRefresh = useVisualRefresh();
  const { isInlineToken } = useTokenInlineContext();
  useForwardFocus(ref, linkRef);
  const applyButtonStyles = isButton && isVisualRefresh && !hasSpecialStyle;
  const sharedProps = {
    id: linkId,
    ...baseProps,
    ref: useMergeRefs(linkRef, __internalRootRef),
    className: clsx_m_default(styles_css_default22.link, baseProps.className, styleClassNames === null || styleClassNames === void 0 ? void 0 : styleClassNames.root, applyButtonStyles ? styles_css_default22.button : null, styles_css_default22[getVariantStyle(variant)], styles_css_default22[getFontSizeStyle(variant, fontSize)], styles_css_default22[getColorStyle(variant, color)], isInlineToken && styles_css_default22["in-inline-token"]),
    style: getLinkStyles(style),
    "aria-label": ariaLabel,
    "aria-labelledby": void 0,
    [DATA_ATTR_FUNNEL_VALUE]: uniqueId,
    "data-awsui-motion-trigger": "hover",
    "data-awsui-motion-target": ""
  };
  if (variant === "info" && infoLinkLabelFromContext && !ariaLabel) {
    sharedProps["aria-labelledby"] = `${sharedProps.id} ${infoId} ${infoLinkLabelFromContext}`;
  }
  const renderedExternalIconAriaLabel = i18n("externalIconAriaLabel", externalIconAriaLabel);
  const content = React59.createElement(
    React59.Fragment,
    null,
    React59.createElement("span", null, children),
    external && React59.createElement(
      "span",
      { className: styles_css_default22["icon-wrapper"] },
      "\xA0",
      React59.createElement(
        "span",
        { className: styles_css_default22.icon, "aria-label": renderedExternalIconAriaLabel, role: renderedExternalIconAriaLabel ? "img" : void 0 },
        React59.createElement(internal_default, { name: "external", size: "inherit" })
      )
    ),
    variant === "info" && React59.createElement("span", { hidden: true, id: infoId }, ":")
  );
  const { tabIndex } = useSingleTabStopNavigation(linkRef, { tabIndex: isButton ? 0 : void 0 });
  if (isButton) {
    return React59.createElement(with_native_attributes_default, { ...sharedProps, tag: "a", componentName: "Link", nativeAttributes, role: "button", tabIndex, onKeyDown: handleButtonKeyDown, onClick: handleButtonClick }, content);
  }
  return React59.createElement(with_native_attributes_default, { ...sharedProps, tag: "a", componentName: "Link", nativeAttributes, tabIndex, target: anchorTarget, rel: anchorRel, href, onClick: handleLinkClick }, content);
});
function getVariantStyle(variant) {
  return `variant-${variant.replace(/^awsui-/, "")}`;
}
function getFontSizeStyle(variant, fontSize) {
  switch (variant) {
    case "info":
      return "font-size-body-s";
    case "awsui-value-large":
      return "font-size-display-l";
    default:
      return `font-size-${fontSize}`;
  }
}
function getColorStyle(variant, color) {
  return `color-${variant === "info" ? "normal" : color}`;
}
var internal_default8 = InternalLink;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/link/internal-do-not-use-core.js
var Link3 = React60.forwardRef(({ fontSize = "body-m", color = "normal", external = false, style, ...props }, ref) => {
  const baseComponentProps = useBaseComponent("Link", {
    props: { color, external, fontSize, rel: props.rel, target: props.target, variant: props.variant }
  });
  const analyticsMetadata = {
    action: "click",
    detail: {
      label: { root: "self" },
      external: `${external}`
    },
    component: {
      name: "awsui.Link",
      label: { root: "self" },
      properties: { variant: props.variant || "secondary" }
    }
  };
  if (props.href) {
    analyticsMetadata.detail.href = props.href;
  }
  return React60.createElement(internal_default8, { fontSize, color, external, ...props, ...baseComponentProps, ref, ...getAnalyticsMetadataAttribute(analyticsMetadata), style, styleClassNames: props.styleClassNames });
});
applyDisplayName(Link3, "Link");
var internal_do_not_use_core_default3 = Link3;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/link/index.js
var Link4 = React61.forwardRef((props, ref) => {
  validateProps("Link", props, ["nativeAttributes", "style"], {}, "console");
  return React61.createElement(internal_do_not_use_core_default3, { ref, ...props });
});
applyDisplayName(Link4, "Link");
var link_default = Link4;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/index.js
import React71 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/internal.js
import React70, { useCallback as useCallback16, useEffect as useEffect35, useRef as useRef32 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/chart-series-details/series-details-text.js
var screenReaderTextClass = "awsui-screenreader-text";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-controllable/index.js
import * as React62 from "react";
function useControllable2(controlledValue, handler, defaultValue4, { componentName: componentName2, changeHandler, controlledProp }) {
  const isControlled = React62.useState(controlledValue !== void 0)[0];
  if (isDevelopment2) {
    React62.useEffect(() => {
      if (isControlled && handler === void 0) {
        warnOnce(componentName2, `You provided a \`${controlledProp}\` prop without an \`${changeHandler}\` handler. This will render a non-interactive component.`);
      }
    }, [handler, isControlled, componentName2, changeHandler, controlledProp]);
    React62.useEffect(() => {
      const isControlledNow = controlledValue !== void 0;
      if (isControlled !== isControlledNow) {
        const initialMode = isControlled ? "controlled" : "uncontrolled";
        const modeNow = isControlledNow ? "controlled" : "uncontrolled";
        warnOnce(componentName2, `A component tried to change ${initialMode} '${controlledProp}' property to be ${modeNow}. This is not supported. Properties should not switch from ${initialMode} to ${modeNow} (or vice versa). Decide between using a controlled or uncontrolled mode for the lifetime of the component. More info: https://fb.me/react-controlled-components`);
      }
    }, [isControlled, controlledProp, componentName2, controlledValue]);
  }
  const [valueState, setValue] = React62.useState(defaultValue4);
  const [valueHasBeenSet, setValueHasBeenSet] = React62.useState(false);
  const currentUncontrolledValue = valueHasBeenSet ? valueState : defaultValue4;
  const setUncontrolledValue = React62.useCallback((newValue) => {
    setValue(newValue);
    setValueHasBeenSet(true);
  }, [setValue, setValueHasBeenSet]);
  if (isControlled) {
    return [controlledValue, defaultCallback];
  } else {
    return [currentUncontrolledValue, setUncontrolledValue];
  }
}
function defaultCallback() {
  return void 0;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/expandable-section-container.js
import React66 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/container/internal.js
import React64, { useImperativeHandle as useImperativeHandle7, useRef as useRef30, useState as useState26 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/container-header.js
import React63, { createContext as createContext13, useContext as useContext12 } from "react";
var ContainerHeaderContext = createContext13({ isInContainer: false });
var ContainerHeaderContextProvider = ({ children }) => {
  return React63.createElement(ContainerHeaderContext.Provider, { value: { isInContainer: true } }, children);
};
var useContainerHeader = () => {
  const { isInContainer } = useContext12(ContainerHeaderContext);
  return isInContainer;
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/hooks/use-mobile/index.js
var forceMobileModeSymbol = Symbol.for("awsui-force-mobile-mode");
function getIsMobile() {
  var _a3;
  const forceMobileMode = globalThis[forceMobileModeSymbol];
  if (typeof forceMobileMode !== "undefined") {
    return forceMobileMode;
  }
  if (typeof window === "undefined") {
    return false;
  }
  if (window.matchMedia) {
    return (_a3 = window.matchMedia(`(max-width: ${mobileBreakpoint}px)`)) === null || _a3 === void 0 ? void 0 : _a3.matches;
  }
  return getMatchingBreakpoint(window.innerWidth, ["xs"]) !== "xs";
}
var useMobile = createSingletonState({
  initialState: () => getIsMobile(),
  factory: (handler) => {
    const listener = () => handler(getIsMobile());
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
    };
  }
});

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/container/style.js
function getRootStyles(style) {
  var _a3, _b, _c, _d, _e, _f;
  if (SYSTEM !== "core") {
    return {};
  }
  return {
    background: (_a3 = style === null || style === void 0 ? void 0 : style.root) === null || _a3 === void 0 ? void 0 : _a3.background,
    borderColor: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderColor,
    // Set as a custom property, not inline `border-radius`, so stacked containers can still
    // flatten their adjacent corners in CSS.
    ...((_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.borderRadius) && { [custom_css_properties_default.containerStyleBorderRadius]: style.root.borderRadius },
    borderWidth: (_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.borderWidth,
    boxShadow: (_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.boxShadow,
    color: (_f = style === null || style === void 0 ? void 0 : style.root) === null || _f === void 0 ? void 0 : _f.color
  };
}
function getContentStyles(style) {
  var _a3, _b;
  if (SYSTEM !== "core") {
    return {};
  }
  return {
    paddingBlock: (_a3 = style === null || style === void 0 ? void 0 : style.content) === null || _a3 === void 0 ? void 0 : _a3.paddingBlock,
    paddingInline: (_b = style === null || style === void 0 ? void 0 : style.content) === null || _b === void 0 ? void 0 : _b.paddingInline
  };
}
function getHeaderStyles(style) {
  var _a3, _b, _c, _d;
  if (SYSTEM !== "core") {
    return {};
  }
  return {
    ...((_a3 = style === null || style === void 0 ? void 0 : style.root) === null || _a3 === void 0 ? void 0 : _a3.background) && { background: "transparent" },
    // Fix for AWSUI-61442
    // Same as the root: use a custom property so stacked headers can still flatten corners in CSS.
    ...((_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderRadius) && { [custom_css_properties_default.containerStyleBorderRadius]: style.root.borderRadius },
    paddingBlock: (_c = style === null || style === void 0 ? void 0 : style.header) === null || _c === void 0 ? void 0 : _c.paddingBlock,
    paddingInline: (_d = style === null || style === void 0 ? void 0 : style.header) === null || _d === void 0 ? void 0 : _d.paddingInline
  };
}
function getFooterStyles(style) {
  var _a3, _b, _c, _d, _e, _f, _g, _h;
  if (SYSTEM !== "core") {
    return {};
  }
  return {
    borderColor: (_b = (_a3 = style === null || style === void 0 ? void 0 : style.footer) === null || _a3 === void 0 ? void 0 : _a3.divider) === null || _b === void 0 ? void 0 : _b.borderColor,
    borderWidth: (_d = (_c = style === null || style === void 0 ? void 0 : style.footer) === null || _c === void 0 ? void 0 : _c.divider) === null || _d === void 0 ? void 0 : _d.borderWidth,
    paddingBlock: (_f = (_e = style === null || style === void 0 ? void 0 : style.footer) === null || _e === void 0 ? void 0 : _e.root) === null || _f === void 0 ? void 0 : _f.paddingBlock,
    paddingInline: (_h = (_g = style === null || style === void 0 ? void 0 : style.footer) === null || _g === void 0 ? void 0 : _g.root) === null || _h === void 0 ? void 0 : _h.paddingInline
  };
}
function getMediaStyles(mediaPosition, style) {
  var _a3;
  if (SYSTEM !== "core") {
    return {};
  }
  return {
    borderRadius: (_a3 = style === null || style === void 0 ? void 0 : style.root) === null || _a3 === void 0 ? void 0 : _a3.borderRadius,
    ...mediaPosition === "top" && { borderEndStartRadius: "0px", borderEndEndRadius: "0px" },
    ...mediaPosition === "side" && { borderStartEndRadius: "0px", borderEndEndRadius: "0px" }
  };
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/container/use-sticky-header.js
import { createContext as createContext14, useCallback as useCallback15, useEffect as useEffect32, useLayoutEffect as useLayoutEffect9, useState as useState25 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/generated/styles/tokens.js
var spaceScaledS = "var(--space-scaled-s-6x4245, 12px)";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/styles/global-vars.js
var globalVars = {
  stickyVerticalTopOffset: "--awsui-sticky-vertical-top-offset",
  stickyVerticalBottomOffset: "--awsui-sticky-vertical-bottom-offset"
};
var global_vars_default = globalVars;

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/container/use-sticky-header.js
function computeOffset({ isMobile, __stickyOffset, __mobileStickyOffset, hasInnerOverflowParents, __additionalOffset }) {
  const localOffset = isMobile ? (__stickyOffset !== null && __stickyOffset !== void 0 ? __stickyOffset : 0) - (__mobileStickyOffset !== null && __mobileStickyOffset !== void 0 ? __mobileStickyOffset : 0) : __stickyOffset !== null && __stickyOffset !== void 0 ? __stickyOffset : 0;
  if (hasInnerOverflowParents || __stickyOffset !== void 0) {
    return `${localOffset}px`;
  }
  const globalOffset = `var(${global_vars_default.stickyVerticalTopOffset}, 0px)`;
  return `calc(${globalOffset} + ${localOffset}px + ${__additionalOffset ? spaceScaledS : "0px"})`;
}
var StickyHeaderContext = createContext14({
  isStuck: false,
  isStuckAtBottom: false
});
var useStickyHeader = (rootRef, headerRef, __stickyHeader, __stickyOffset, __mobileStickyOffset, __disableMobile, __additionalOffset = false) => {
  const isMobile = useMobile();
  const disableSticky = isMobile && __disableMobile;
  const isSticky = !disableSticky && !!__stickyHeader;
  const [hasInnerOverflowParents, setHasInnerOverflowParents] = useState25(false);
  const [isStuck, setIsStuck] = useState25(false);
  const [isStuckAtBottom, setIsStuckAtBottom] = useState25(false);
  useLayoutEffect9(() => {
    if (rootRef.current) {
      const overflowParents = getOverflowParents(rootRef.current);
      const mainElement = findUpUntil(rootRef.current, (elem) => elem.tagName === "MAIN");
      setHasInnerOverflowParents(overflowParents.length > 0 && overflowParents[0] !== mainElement);
    }
  }, [rootRef]);
  const computedOffset = computeOffset({
    isMobile,
    __stickyOffset,
    __mobileStickyOffset,
    hasInnerOverflowParents,
    __additionalOffset
  });
  const stickyStyles = isSticky ? {
    style: {
      top: computedOffset
    }
  } : {};
  const checkIfStuck = useCallback15(({ isTrusted, target, type }) => {
    if (type === "resize" && target === window && !isTrusted) {
      return;
    }
    if (rootRef.current && headerRef.current) {
      const rootTopBorderWidth = parseFloat(getComputedStyle(rootRef.current).borderTopWidth) || 0;
      const rootTop = Math.round(rootRef.current.getBoundingClientRect().top + rootTopBorderWidth);
      const headerTop = Math.round(headerRef.current.getBoundingClientRect().top);
      if (rootTop < headerTop) {
        setIsStuck(true);
      } else {
        setIsStuck(false);
      }
      const rootBottom = Math.round(rootRef.current.getBoundingClientRect().bottom - rootTopBorderWidth);
      const headerBottom = Math.round(headerRef.current.getBoundingClientRect().bottom);
      if (rootBottom <= headerBottom) {
        setIsStuckAtBottom(true);
      } else {
        setIsStuckAtBottom(false);
      }
    }
  }, [rootRef, headerRef]);
  useEffect32(() => {
    if (isSticky) {
      const controller = new AbortController();
      window.addEventListener("scroll", checkIfStuck, { capture: true, signal: controller.signal });
      window.addEventListener("resize", checkIfStuck, { signal: controller.signal });
      return () => {
        controller.abort();
      };
    }
  }, [isSticky, checkIfStuck]);
  return {
    isSticky,
    isStuck,
    isStuckAtBottom,
    stickyStyles
  };
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/container/analytics-metadata/styles.css.js
var styles_css_default23 = {
  "header": "awsui_header_164jl_1ns0c_5"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/container/styles.css.js
var styles_css_default24 = {
  "root": "awsui_root_14iqq_z2ijf_13",
  "fit-height": "awsui_fit-height_14iqq_z2ijf_46",
  "with-side-media": "awsui_with-side-media_14iqq_z2ijf_51",
  "variant-default": "awsui_variant-default_14iqq_z2ijf_54",
  "variant-stacked": "awsui_variant-stacked_14iqq_z2ijf_54",
  "refresh": "awsui_refresh_14iqq_z2ijf_63",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_z2ijf_113",
  "with-stuck-sticky-header-at-bottom": "awsui_with-stuck-sticky-header-at-bottom_14iqq_z2ijf_119",
  "focus-ring": "awsui_focus-ring_14iqq_z2ijf_126",
  "with-top-media": "awsui_with-top-media_14iqq_z2ijf_150",
  "content-wrapper": "awsui_content-wrapper_14iqq_z2ijf_155",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_z2ijf_160",
  "media": "awsui_media_14iqq_z2ijf_167",
  "media-top": "awsui_media-top_14iqq_z2ijf_185",
  "media-side": "awsui_media-side_14iqq_z2ijf_190",
  "header": "awsui_header_14iqq_z2ijf_196",
  "header-full-page": "awsui_header-full-page_14iqq_z2ijf_201",
  "header-variant-embedded": "awsui_header-variant-embedded_14iqq_z2ijf_204",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_z2ijf_204",
  "header-with-media": "awsui_header-with-media_14iqq_z2ijf_207",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_z2ijf_213",
  "header-stuck": "awsui_header-stuck_14iqq_z2ijf_223",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_z2ijf_233",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_z2ijf_236",
  "with-paddings": "awsui_with-paddings_14iqq_z2ijf_242",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_z2ijf_251",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_z2ijf_309",
  "header-cover": "awsui_header-cover_14iqq_z2ijf_312",
  "content": "awsui_content_14iqq_z2ijf_155",
  "content-fit-height": "awsui_content-fit-height_14iqq_z2ijf_340",
  "content-inner": "awsui_content-inner_14iqq_z2ijf_346",
  "with-header": "awsui_with-header_14iqq_z2ijf_353",
  "footer": "awsui_footer_14iqq_z2ijf_357",
  "with-divider": "awsui_with-divider_14iqq_z2ijf_361"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/container/test-classes/styles.css.js
var styles_css_default25 = {
  "content-inner": "awsui_content-inner_1mwlm_oyjaq_5"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/container/internal.js
var InternalContainerAsSubstep = React64.forwardRef((props, ref) => {
  const { subStepRef, funnelSubStepProps } = useFunnelSubStep();
  const modalContext = useModalContext();
  return React64.createElement(InternalContainer, { ...props, ref, __subStepRef: (modalContext === null || modalContext === void 0 ? void 0 : modalContext.isInModal) ? { current: null } : subStepRef, __funnelSubStepProps: (modalContext === null || modalContext === void 0 ? void 0 : modalContext.isInModal) ? {} : funnelSubStepProps });
});
var InternalContainer = React64.forwardRef(function InternalContainer2({ header, footer, children, variant = "default", disableHeaderPaddings = false, disableContentPaddings = false, disableFooterPaddings = false, fitHeight, media, style, __stickyOffset, __mobileStickyOffset, __stickyHeader = false, __internalRootRef, __disableFooterDivider = false, __hiddenContent = false, __headerRef, __fullPage = false, __disableStickyMobile = true, __funnelSubStepProps, __subStepRef, __contentKey, ...restProps }, ref) {
  var _a3;
  const isMobile = useMobile();
  const isRefresh = useVisualRefresh();
  const baseProps = getBaseProps(restProps);
  const rootRef = useRef30(null);
  const headerRef = useRef30(null);
  const [showFocusRing, setShowFocusRing] = useState26(false);
  useImperativeHandle7(ref, () => ({
    focus: () => {
      if (rootRef.current) {
        rootRef.current.tabIndex = -1;
        rootRef.current.setAttribute("role", "group");
        if (header) {
          rootRef.current.setAttribute("aria-labelledby", headerId);
        }
        setShowFocusRing(true);
        rootRef.current.focus({ preventScroll: true });
        scrollElementIntoView(rootRef.current);
      }
    }
  }));
  const onRootBlur = (event) => {
    const funnelOnBlur = __funnelSubStepProps === null || __funnelSubStepProps === void 0 ? void 0 : __funnelSubStepProps.onBlur;
    funnelOnBlur === null || funnelOnBlur === void 0 ? void 0 : funnelOnBlur(event);
    if (event.target === rootRef.current) {
      rootRef.current.removeAttribute("tabindex");
      rootRef.current.removeAttribute("role");
      rootRef.current.removeAttribute("aria-labelledby");
      setShowFocusRing(false);
    }
  };
  const { isSticky, isStuck, isStuckAtBottom, stickyStyles } = useStickyHeader(rootRef, headerRef, __stickyHeader, __stickyOffset, __mobileStickyOffset, __disableStickyMobile, __fullPage && isRefresh && !isMobile);
  const contentId = useUniqueId();
  const headerId = useUniqueId("container-header-");
  const hasDynamicHeight = isRefresh && variant === "full-page";
  const mergedRef = useMergeRefs(rootRef, __internalRootRef);
  const headerMergedRef = useMergeRefs(headerRef, __headerRef);
  const shouldHaveStickyStyles = isSticky && !isMobile;
  const hasMedia = !!(media === null || media === void 0 ? void 0 : media.content);
  const mediaPosition = (_a3 = media === null || media === void 0 ? void 0 : media.position) !== null && _a3 !== void 0 ? _a3 : "top";
  return React64.createElement(
    "div",
    { ...baseProps, ...__funnelSubStepProps, className: clsx_m_default(baseProps.className, styles_css_default24.root, styles_css_default24[`variant-${variant}`], fitHeight && styles_css_default24["fit-height"], hasMedia && (mediaPosition === "side" ? styles_css_default24["with-side-media"] : styles_css_default24["with-top-media"]), shouldHaveStickyStyles && [styles_css_default24["sticky-enabled"]], shouldHaveStickyStyles && isStuck && isStuckAtBottom && [styles_css_default24["with-stuck-sticky-header-at-bottom"]], showFocusRing && styles_css_default24["focus-ring"], isRefresh && styles_css_default24.refresh), ref: mergedRef, onBlur: onRootBlur, ...getAnalyticsLabelAttribute(`.${styles_css_default23.header} h1, .${styles_css_default23.header} h2, .${styles_css_default23.header} h3`), style: getRootStyles(style) },
    hasMedia && React64.createElement("div", { className: clsx_m_default(styles_css_default24[`media-${mediaPosition === "side" ? "side" : "top"}`], styles_css_default24.media), style: mediaPosition === "top" ? { ...getMediaStyles(mediaPosition, style), height: (media === null || media === void 0 ? void 0 : media.height) || "" } : { ...getMediaStyles(mediaPosition, style), width: (media === null || media === void 0 ? void 0 : media.width) || "" } }, media.content),
    React64.createElement(
      "div",
      { id: contentId, ref: __subStepRef, key: __contentKey, className: clsx_m_default(styles_css_default24["content-wrapper"], fitHeight && styles_css_default24["content-wrapper-fit-height"]) },
      React64.createElement(
        BuiltInErrorBoundary,
        { wrapper: (content) => React64.createElement(InternalBox, { padding: "m" }, content) },
        header && React64.createElement(
          ContainerHeaderContextProvider,
          null,
          React64.createElement(
            StickyHeaderContext.Provider,
            { value: { isStuck, isStuckAtBottom } },
            React64.createElement(
              "div",
              { id: headerId, className: clsx_m_default(isRefresh && styles_css_default24.refresh, styles_css_default24.header, styles_css_default23.header, styles_css_default24[`header-variant-${variant}`], {
                [styles_css_default24["header-sticky-disabled"]]: __stickyHeader && !isSticky,
                [styles_css_default24["header-sticky-enabled"]]: isSticky,
                [styles_css_default24["header-dynamic-height"]]: hasDynamicHeight,
                [styles_css_default24["header-stuck"]]: isStuck,
                [styles_css_default24["with-paddings"]]: !disableHeaderPaddings,
                [styles_css_default24["with-hidden-content"]]: !children || __hiddenContent,
                [styles_css_default24["header-with-media"]]: hasMedia,
                [styles_css_default24["header-full-page"]]: __fullPage && isRefresh
              }), ref: headerMergedRef, style: {
                ...stickyStyles.style,
                ...getHeaderStyles(style)
              } },
              isStuck && !isMobile && isRefresh && __fullPage && React64.createElement("div", { className: styles_css_default24["header-cover"] }),
              header
            )
          )
        ),
        React64.createElement(
          "div",
          { className: clsx_m_default(styles_css_default24.content, fitHeight && styles_css_default24["content-fit-height"]) },
          React64.createElement(
            "div",
            { className: clsx_m_default(styles_css_default24["content-inner"], styles_css_default25["content-inner"], {
              [styles_css_default24["with-paddings"]]: !disableContentPaddings,
              [styles_css_default24["with-header"]]: !!header
            }), style: getContentStyles(style) },
            React64.createElement(BuiltInErrorBoundary, { wrapper: (content) => React64.createElement(InternalBox, { padding: disableContentPaddings ? "m" : void 0 }, content) }, children)
          )
        ),
        footer && React64.createElement("div", { className: clsx_m_default(styles_css_default24.footer, {
          [styles_css_default24["with-divider"]]: !__disableFooterDivider,
          [styles_css_default24["with-paddings"]]: !disableFooterPaddings
        }), style: getFooterStyles(style) }, footer)
      )
    )
  );
});

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/analytics/components/analytics-funnel.js
import React65, { useContext as useContext13, useEffect as useEffect33, useLayoutEffect as useLayoutEffect10, useRef as useRef31, useState as useState27 } from "react";
var AnalyticsFunnelSubStep = ({ children, subStepIdentifier, subStepErrorContext }) => {
  const subStepId = useUniqueId("substep");
  const subStepSelector = getSubStepSelector(subStepId);
  const subStepNameSelector = getSubStepNameSelector(subStepId);
  const subStepRef = useRef31(null);
  const { subStepCount, onStepChange } = useFunnelStep();
  const mousePressed = useRef31(false);
  const isFocusedSubStep = useRef31(false);
  const focusCleanupFunction = useRef31(void 0);
  const { funnelState, funnelInteractionId } = useFunnel();
  const { stepNumber, stepNameSelector } = useFunnelStep();
  const newContext = {
    subStepIdentifier,
    subStepErrorContext,
    subStepSelector,
    subStepNameSelector,
    subStepId,
    subStepRef,
    mousePressed,
    isFocusedSubStep,
    focusCleanupFunction,
    isNestedSubStep: false
  };
  const inheritedContext = { ...useContext13(FunnelSubStepContext), isNestedSubStep: true };
  const isNested = Boolean(inheritedContext.subStepId);
  useEffect33(() => {
    if (!isNested) {
      subStepCount.current++;
      onStepChange();
      return () => {
        subStepCount.current--;
        onStepChange();
      };
    }
  }, [isNested, subStepCount, onStepChange]);
  const context = isNested ? inheritedContext : newContext;
  useEffect33(() => {
    if (isNested || !subStepRef.current) {
      return;
    }
    const onMouseDown = () => mousePressed.current = true;
    const onMouseUp = async () => {
      var _a3;
      mousePressed.current = false;
      if (!isFocusedSubStep.current) {
        return;
      }
      await new Promise((r2) => setTimeout(r2, 1));
      if (!subStepRef.current || !document.activeElement || !nodeBelongs2(subStepRef.current, document.activeElement)) {
        isFocusedSubStep.current = false;
        (_a3 = focusCleanupFunction.current) === null || _a3 === void 0 ? void 0 : _a3.call(focusCleanupFunction);
      }
    };
    const controller = new AbortController();
    window.addEventListener("mousedown", onMouseDown, { signal: controller.signal });
    window.addEventListener("mouseup", onMouseUp, { signal: controller.signal });
    return () => {
      controller.abort();
    };
  }, [
    funnelInteractionId,
    funnelState,
    stepNameSelector,
    stepNumber,
    subStepNameSelector,
    subStepSelector,
    focusCleanupFunction,
    isNested,
    subStepRef
  ]);
  return React65.createElement(FunnelSubStepContext.Provider, { value: context }, typeof children === "function" ? children(context) : children);
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/analytics-metadata/styles.css.js
var styles_css_default26 = {
  "header-label": "awsui_header-label_4mvj3_1h74t_5",
  "root": "awsui_root_4mvj3_1h74t_6"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/expandable-section-container.js
var ExpandableSectionContainer = ({ className, children, header, variant, expanded, __internalRootRef, __injectAnalyticsComponentMetadata, ...rest }) => {
  const analyticsMetadata = getAnalyticsMetadataProps(rest);
  const analyticsComponentMetadata = {
    name: "awsui.ExpandableSection",
    label: { root: "self" },
    properties: { variant, expanded: `${!!expanded}` }
  };
  const metadataAttribute = __injectAnalyticsComponentMetadata ? getAnalyticsMetadataAttribute({ component: analyticsComponentMetadata }) : {};
  if (variant === "container" || variant === "stacked") {
    return React66.createElement(
      AnalyticsFunnelSubStep,
      { subStepIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier, subStepErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext },
      React66.createElement(InternalContainerAsSubstep, { ...rest, className, header, variant: variant === "stacked" ? "stacked" : "default", disableContentPaddings: true, disableHeaderPaddings: true, __hiddenContent: !expanded, __internalRootRef, ...metadataAttribute }, children)
    );
  }
  return React66.createElement(
    "div",
    { className, ...rest, ref: __internalRootRef, ...metadataAttribute, ...getAnalyticsLabelAttribute(`.${styles_css_default26["header-label"]}`) },
    header,
    children
  );
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/expandable-section-header.js
import React69 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/header/internal.js
import React67, { useContext as useContext15 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/header/analytics/use-table-integration.js
import { useEffect as useEffect34, useMemo as useMemo6 } from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/analytics/utils/parse-count-text.js
var parseCountValue = (countText) => {
  if (!countText || typeof countText !== "string") {
    return void 0;
  }
  const target = countText.includes("/") ? countText.split("/")[1] : countText;
  const match = target.match(/\d+/);
  return match ? parseInt(match[0], 10) : void 0;
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/context/table-component-context.js
import { createContext as createContext15, useContext as useContext14 } from "react";
var TableComponentsContext = createContext15(null);
var TableComponentsContextProvider = TableComponentsContext.Provider;
var useTableComponentsContext = () => {
  const tableComponentContext = useContext14(TableComponentsContext);
  return tableComponentContext;
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/header/analytics/use-table-integration.js
var useTableIntegration = (countText) => {
  const tableComponentContext = useTableComponentsContext();
  const countValue = useMemo6(() => {
    if (typeof countText === "string") {
      return parseCountValue(countText);
    } else {
      return void 0;
    }
  }, [countText]);
  useEffect34(() => {
    var _a3;
    if (((_a3 = tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.headerRef) === null || _a3 === void 0 ? void 0 : _a3.current) && countValue !== void 0) {
      tableComponentContext.headerRef.current.totalCount = countValue;
      return () => {
        var _a4;
        (_a4 = tableComponentContext.headerRef.current) === null || _a4 === void 0 ? true : delete _a4.totalCount;
      };
    }
  }, [tableComponentContext === null || tableComponentContext === void 0 ? void 0 : tableComponentContext.headerRef, countValue]);
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/header/analytics-metadata/styles.css.js
var styles_css_default27 = {
  "heading-text": "awsui_heading-text_105ke_268sp_5"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/header/styles.css.js
var styles_css_default28 = {
  "root": "awsui_root_2qdw9_1h35q_9",
  "refresh": "awsui_refresh_2qdw9_1h35q_45",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1h35q_45",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1h35q_48",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1h35q_48",
  "root-has-description": "awsui_root-has-description_2qdw9_1h35q_48",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1h35q_57",
  "main": "awsui_main_2qdw9_1h35q_67",
  "no-wrap": "awsui_no-wrap_2qdw9_1h35q_77",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1h35q_83",
  "actions": "awsui_actions_2qdw9_1h35q_91",
  "actions-centered": "awsui_actions-centered_2qdw9_1h35q_96",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1h35q_99",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1h35q_103",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1h35q_107",
  "title": "awsui_title_2qdw9_1h35q_123",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_1h35q_128",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1h35q_135",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1h35q_141",
  "title-in-expandable-section": "awsui_title-in-expandable-section_2qdw9_1h35q_154",
  "virtual-space": "awsui_virtual-space_2qdw9_1h35q_169",
  "info": "awsui_info_2qdw9_1h35q_175",
  "description": "awsui_description_2qdw9_1h35q_179",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1h35q_186",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1h35q_190",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1h35q_197",
  "heading": "awsui_heading_2qdw9_1h35q_208",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1h35q_233",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1h35q_238",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1h35q_243",
  "heading-text": "awsui_heading-text_2qdw9_1h35q_249",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_1h35q_252",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_1h35q_261",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_1h35q_270",
  "counter": "awsui_counter_2qdw9_1h35q_280"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/header/internal.js
function InternalHeader({ variant, headingTagOverride, children, actions, counter: counter2, description, info, __internalRootRef, __disableActionsWrapping, __headingTagRef, __headingTagTabIndex, __inExpandableSection, ...restProps }) {
  const isMobile = useMobile();
  const HeadingTag = headingTagOverride !== null && headingTagOverride !== void 0 ? headingTagOverride : variant === "awsui-h1-sticky" ? "h1" : variant;
  const { isStuck } = useContext15(StickyHeaderContext);
  const baseProps = getBaseProps(restProps);
  const isRefresh = useVisualRefresh();
  const assignHeaderId = useContext15(CollectionLabelContext).assignId;
  const isInContainer = useContainerHeader();
  const headingId = useUniqueId("heading");
  useTableIntegration(counter2);
  if (assignHeaderId !== void 0) {
    assignHeaderId(headingId);
  }
  const dynamicVariant = !isMobile && isStuck ? "h2" : "h1";
  const variantOverride = variant === "awsui-h1-sticky" ? isRefresh ? dynamicVariant : "h2" : variant;
  return React67.createElement(
    "div",
    { ...baseProps, className: clsx_m_default(styles_css_default28.root, baseProps.className, styles_css_default28[`root-variant-${variantOverride}`], isRefresh && styles_css_default28.refresh, !actions && [styles_css_default28[`root-no-actions`]], description && [styles_css_default28[`root-has-description`]]), ref: __internalRootRef },
    React67.createElement(
      "div",
      { className: clsx_m_default(styles_css_default28.main, styles_css_default28[`main-variant-${variantOverride}`], isRefresh && styles_css_default28.refresh, __disableActionsWrapping && [styles_css_default28["no-wrap"]]) },
      React67.createElement(
        "div",
        { className: clsx_m_default(styles_css_default28.title, styles_css_default28[`title-variant-${variantOverride}`], isRefresh && styles_css_default28.refresh, __inExpandableSection && styles_css_default28["title-in-expandable-section"]) },
        React67.createElement(
          HeadingTag,
          { className: clsx_m_default(styles_css_default28.heading, styles_css_default28[`heading-variant-${variantOverride}`]), ref: __headingTagRef, tabIndex: __headingTagTabIndex, ...getAnalyticsLabelAttribute(`.${styles_css_default27["heading-text"]}`) },
          React67.createElement("span", { ...isInContainer ? { [DATA_ATTR_FUNNEL_KEY]: FUNNEL_KEY_SUBSTEP_NAME } : {}, className: clsx_m_default(styles_css_default28["heading-text"], styles_css_default27["heading-text"], styles_css_default28[`heading-text-variant-${variantOverride}`]), id: headingId }, children),
          counter2 !== void 0 && React67.createElement(
            "span",
            { className: styles_css_default28.counter },
            " ",
            counter2
          )
        ),
        info && React67.createElement(
          InfoLinkLabelContext.Provider,
          { value: headingId },
          React67.createElement("span", { className: styles_css_default28["virtual-space"] }, " \xA0"),
          React67.createElement("span", { className: styles_css_default28.info }, info)
        )
      ),
      actions && React67.createElement("div", { className: clsx_m_default(styles_css_default28.actions, styles_css_default28[`actions-variant-${variantOverride}`], isRefresh && styles_css_default28.refresh, !__disableActionsWrapping && [styles_css_default28["actions-centered"]]) }, actions)
    ),
    React67.createElement(Description, { variantOverride }, description)
  );
}
function Description({ children, variantOverride }) {
  const isRefresh = useVisualRefresh();
  return children && React67.createElement("p", { className: clsx_m_default(styles_css_default28.description, styles_css_default28[`description-variant-${variantOverride}`], isRefresh && styles_css_default28.refresh) }, children) || null;
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon-provider/use-component-icons.js
import { useContext as useContext16 } from "react";
function useInternalComponentIcons(component) {
  return useContext16(InternalComponentIconsContext)[component];
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/internal/components/customizable-icon/index.js
import React68 from "react";
function CustomizableIcon({ customIcon, fallback, ...shared }) {
  if (customIcon) {
    return React68.createElement(internal_default, { ...shared, override: customIcon });
  }
  return React68.createElement(internal_default, { ...shared, ...fallback, className: clsx_m_default(shared.className, fallback === null || fallback === void 0 ? void 0 : fallback.className) });
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/utils.js
var variantIsOneOf = (variant, oneOf) => oneOf.includes(variant);
function variantSupportsDescription(variant) {
  return variantIsOneOf(variant, ["container", "default", "footer", "inline"]);
}
function variantSupportsActions(variant) {
  return variantIsOneOf(variant, ["container", "compact", "default", "inline"]);
}
function variantSupportsInfoLink(variant) {
  return variantIsOneOf(variant, ["container", "compact"]);
}
function variantRequiresActionsDivider(variant) {
  return variantIsOneOf(variant, ["default", "inline"]);
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/styles.css.js
var styles_css_default29 = {
  "root": "awsui_root_gwq0h_dmtr1_13",
  "expand-button": "awsui_expand-button_gwq0h_dmtr1_48",
  "icon": "awsui_icon_gwq0h_dmtr1_52",
  "expanded": "awsui_expanded_gwq0h_dmtr1_67",
  "icon-position": "awsui_icon-position_gwq0h_dmtr1_77",
  "icon-container": "awsui_icon-container_gwq0h_dmtr1_84",
  "icon-container-container": "awsui_icon-container-container_gwq0h_dmtr1_88",
  "wrapper": "awsui_wrapper_gwq0h_dmtr1_101",
  "wrapper-default": "awsui_wrapper-default_gwq0h_dmtr1_109",
  "wrapper-inline": "awsui_wrapper-inline_gwq0h_dmtr1_109",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_dmtr1_109",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_dmtr1_113",
  "wrapper-container": "awsui_wrapper-container_gwq0h_dmtr1_116",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_dmtr1_120",
  "header-deprecated": "awsui_header-deprecated_gwq0h_dmtr1_133",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_dmtr1_152",
  "wrapper-not-expanded-without-actions": "awsui_wrapper-not-expanded-without-actions_gwq0h_dmtr1_197",
  "header": "awsui_header_gwq0h_dmtr1_133",
  "header-wrapper": "awsui_header-wrapper_gwq0h_dmtr1_217",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_dmtr1_229",
  "header-button": "awsui_header-button_gwq0h_dmtr1_237",
  "header-container-button": "awsui_header-container-button_gwq0h_dmtr1_237",
  "header-button-icon-end": "awsui_header-button-icon-end_gwq0h_dmtr1_266",
  "header-container": "awsui_header-container_gwq0h_dmtr1_237",
  "header-navigation": "awsui_header-navigation_gwq0h_dmtr1_275",
  "icon-container-end": "awsui_icon-container-end_gwq0h_dmtr1_288",
  "header-text": "awsui_header-text_gwq0h_dmtr1_328",
  "content": "awsui_content_gwq0h_dmtr1_338",
  "content-expanded": "awsui_content-expanded_gwq0h_dmtr1_341",
  "content-compact": "awsui_content-compact_gwq0h_dmtr1_344",
  "content-inner": "awsui_content-inner_gwq0h_dmtr1_377",
  "content-inner-expanded": "awsui_content-inner-expanded_gwq0h_dmtr1_399",
  "content-inner-settled": "awsui_content-inner-settled_gwq0h_dmtr1_418",
  "content-inner-body-default": "awsui_content-inner-body-default_gwq0h_dmtr1_426",
  "content-inner-body-inline": "awsui_content-inner-body-inline_gwq0h_dmtr1_426",
  "content-inner-body-footer": "awsui_content-inner-body-footer_gwq0h_dmtr1_429",
  "content-inner-body-container": "awsui_content-inner-body-container_gwq0h_dmtr1_432",
  "disable-header-paddings": "awsui_disable-header-paddings_gwq0h_dmtr1_437",
  "disable-content-paddings": "awsui_disable-content-paddings_gwq0h_dmtr1_442",
  "focusable": "awsui_focusable_gwq0h_dmtr1_447",
  "click-target": "awsui_click-target_gwq0h_dmtr1_462",
  "header-icon-end": "awsui_header-icon-end_gwq0h_dmtr1_469",
  "header-content": "awsui_header-content_gwq0h_dmtr1_549",
  "header-navigation-content": "awsui_header-navigation-content_gwq0h_dmtr1_555"
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/expandable-section-header.js
var componentName = "ExpandableSection";
var ExpandIconButton = ({ icon, ariaLabel, ariaLabelledBy, ariaControls, expanded, onClick, stopPropagation, className }) => {
  const stopKeyPropagation = stopPropagation ? (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.stopPropagation();
    }
  } : void 0;
  return React69.createElement("button", { className: clsx_m_default(styles_css_default29["icon-container"], styles_css_default29["expand-button"], className), type: "button", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-controls": ariaControls, "aria-expanded": expanded, "data-awsui-motion-trigger": "hover", onClick: stopPropagation ? (event) => {
    event.stopPropagation();
    onClick(event);
  } : onClick, onKeyUp: stopKeyPropagation, onKeyDown: stopKeyPropagation, ...getExpandActionAnalyticsMetadataAttribute(expanded) }, icon);
};
var getExpandActionAnalyticsMetadataAttribute = (expanded) => {
  const metadata = {
    action: !expanded ? "expand" : "collapse",
    detail: {
      label: { rootSelector: `.${styles_css_default26.root}` }
    }
  };
  return getAnalyticsMetadataAttribute(metadata);
};
var ExpandableDeprecatedHeader = ({ id, className, onClick, ariaLabel, ariaControls, expanded, children, icon, onKeyUp, onKeyDown, variant }) => {
  return React69.createElement(
    "div",
    { id, role: "button", className: clsx_m_default(className, styles_css_default29["expand-button"], styles_css_default29["click-target"], styles_css_default29["header-deprecated"], styles_css_default26["header-label"]), tabIndex: 0, onKeyUp, onKeyDown, onClick, "aria-label": ariaLabel, "aria-controls": ariaControls, "aria-expanded": expanded, "data-awsui-motion-trigger": "hover", ...getExpandActionAnalyticsMetadataAttribute(expanded) },
    React69.createElement("div", { className: clsx_m_default(styles_css_default29["icon-container"], styles_css_default29[`icon-container-${variant}`]) }, icon),
    children
  );
};
var ExpandableNavigationHeader = ({ id, className, onClick, ariaLabelledBy, ariaLabel, ariaControls, expanded, children, icon, expandIconPosition, hideExpandIcon }) => {
  const expandButton = hideExpandIcon ? null : React69.createElement(ExpandIconButton, { icon, ariaLabelledBy, ariaLabel, ariaControls, expanded, onClick, className: expandIconPosition === "end" ? styles_css_default29["icon-container-end"] : void 0 });
  return React69.createElement("div", { id, className: clsx_m_default(className, styles_css_default26["header-label"], expandIconPosition === "end" && styles_css_default29["header-icon-end"]), "data-awsui-motion-trigger": "hover" }, expandIconPosition === "end" ? React69.createElement(
    React69.Fragment,
    null,
    children,
    expandButton
  ) : React69.createElement(
    React69.Fragment,
    null,
    expandButton,
    children
  ));
};
var ExpandableHeaderTextWrapper = ({ id, descriptionId, className, onClick, ariaLabel, ariaControls, expanded, children, icon, headerDescription, headerCounter, headerInfo, headerActions, variant, headingTagOverride, onKeyUp, onKeyDown, expandIconPosition }) => {
  const isContainer = variant === "container";
  const HeadingTag = headingTagOverride || "div";
  const supportsInteractiveElements = variantSupportsActions(variant);
  const restrictClickableArea = supportsInteractiveElements && (headerInfo || headerActions);
  const actions = supportsInteractiveElements && headerActions;
  const description = variantSupportsDescription(variant) && headerDescription && React69.createElement("span", { id: descriptionId, className: styles_css_default29[`description-${variant}`] }, headerDescription);
  const listeners = { onClick, onKeyDown, onKeyUp };
  const iconAtEnd = expandIconPosition === "end";
  const renderIconOutsideHeader = iconAtEnd && (isContainer || !!actions);
  const headerButtonListeners = restrictClickableArea ? listeners : void 0;
  const headingTagListeners = !headerButtonListeners && !isContainer && description ? listeners : void 0;
  const wrapperListeners = !headerButtonListeners && !headingTagListeners ? listeners : void 0;
  const motionTriggerAttribute = { "data-awsui-motion-trigger": "hover" };
  const headerButtonMotionTrigger = headerButtonListeners ? motionTriggerAttribute : void 0;
  const headingTagMotionTrigger = headingTagListeners ? motionTriggerAttribute : void 0;
  const wrapperMotionTrigger = wrapperListeners ? motionTriggerAttribute : void 0;
  const expandButton = React69.createElement(ExpandIconButton, { icon, ariaLabel, ariaLabelledBy: !ariaLabel ? id : void 0, ariaControls, expanded, onClick, stopPropagation: true, className: clsx_m_default(styles_css_default29[`icon-container-${variant}`], styles_css_default29["icon-container-end"]) });
  const expandIcon = React69.createElement("span", { className: clsx_m_default(styles_css_default29["icon-container"], styles_css_default29[`icon-container-${variant}`], iconAtEnd && styles_css_default29["icon-container-end"]) }, icon);
  const outsideIcon = renderIconOutsideHeader ? expandButton : null;
  const textElement = React69.createElement("span", { id, className: clsx_m_default(styles_css_default29["header-text"], styles_css_default26["header-label"]) }, children);
  const headerButton = React69.createElement("span", { className: clsx_m_default(styles_css_default29["expand-button"], isContainer ? styles_css_default29["header-container-button"] : styles_css_default29["header-button"], iconAtEnd && styles_css_default29["header-button-icon-end"], headerButtonListeners && styles_css_default29["click-target"]), role: "button", tabIndex: 0, "aria-label": ariaLabel, "aria-labelledby": !ariaLabel && description ? id : void 0, "aria-describedby": description ? descriptionId : void 0, "aria-controls": ariaControls, "aria-expanded": expanded, ...headerButtonListeners, ...headerButtonMotionTrigger, ...headerButtonListeners ? getExpandActionAnalyticsMetadataAttribute(expanded) : {} }, renderIconOutsideHeader ? textElement : iconAtEnd ? React69.createElement(
    React69.Fragment,
    null,
    textElement,
    expandIcon
  ) : React69.createElement(
    React69.Fragment,
    null,
    expandIcon,
    textElement
  ));
  return React69.createElement("div", { className: clsx_m_default(className, wrapperListeners && styles_css_default29["click-target"], iconAtEnd && styles_css_default29["header-icon-end"]), ...wrapperListeners, ...wrapperMotionTrigger, ...wrapperListeners ? getExpandActionAnalyticsMetadataAttribute(expanded) : {} }, isContainer ? React69.createElement(
    React69.Fragment,
    null,
    React69.createElement(InternalHeader, { variant: "h2", description, counter: headerCounter, info: headerInfo, actions, headingTagOverride, __inExpandableSection: true }, headerButton),
    outsideIcon
  ) : React69.createElement(
    React69.Fragment,
    null,
    React69.createElement(
      "div",
      { className: clsx_m_default(styles_css_default29["header-content"], actions && styles_css_default29["header-actions-wrapper"]) },
      React69.createElement(HeadingTag, { className: clsx_m_default(styles_css_default29["header-wrapper"], headingTagListeners && styles_css_default29["click-target"]), ...headingTagListeners, ...headingTagMotionTrigger, ...headingTagListeners ? getExpandActionAnalyticsMetadataAttribute(expanded) : {} }, headerButton),
      actions
    ),
    description && React69.createElement(Description, { variantOverride: "h3" }, description),
    outsideIcon
  ));
};
var ExpandableSectionHeader = ({ id, descriptionId, className, variant, header, headerText, headerDescription, headerCounter, headerInfo, headerActions, headingTagOverride, expanded, ariaControls, ariaLabel, ariaLabelledBy, onKeyUp, onKeyDown, onClick, expandIconPosition, hideExpandIcon }) => {
  var _a3;
  const alwaysShowDivider = variantRequiresActionsDivider(variant) && headerActions;
  const icons2 = useInternalComponentIcons("expandable-section");
  const icon = React69.createElement(CustomizableIcon, { customIcon: (_a3 = icons2 === null || icons2 === void 0 ? void 0 : icons2.expandToggle) === null || _a3 === void 0 ? void 0 : _a3.call(icons2, { expanded: !!expanded }), size: isThemeActive(Theme.OneTheme) ? "x-small" : variant === "container" ? "medium" : "normal", className: styles_css_default29["icon-position"], fallback: {
    name: isThemeActive(Theme.OneTheme) ? "angle-down" : "caret-down-filled",
    className: clsx_m_default(styles_css_default29.icon, expanded && styles_css_default29.expanded),
    nativeAttributes: { "data-awsui-motion-target": "" }
  } });
  const defaultHeaderProps = {
    id,
    icon,
    expanded,
    ariaControls,
    ariaLabel,
    onClick,
    variant,
    expandIconPosition
  };
  if ((headerCounter || headerInfo) && !variantSupportsInfoLink(variant) && isDevelopment2) {
    warnOnce(componentName, 'The `headerCounter` and `headerInfo` props are only supported for the "container" variant.');
  }
  if (headerActions && !variantSupportsActions(variant) && isDevelopment2) {
    warnOnce(componentName, `The \`headerActions\` prop is only supported for the "container" and "default" variants.`);
  }
  if (headerDescription && !variantSupportsDescription(variant) && isDevelopment2) {
    warnOnce(componentName, `The \`headerDescription\` prop is not supported for the ${variant} variant.`);
  }
  const wrapperClassName = clsx_m_default(styles_css_default29.wrapper, styles_css_default29[`wrapper-${variant}`], (expanded || alwaysShowDivider) && styles_css_default29["wrapper-expanded"]);
  if (variant === "navigation") {
    return React69.createElement(
      ExpandableNavigationHeader,
      { className: clsx_m_default(className, wrapperClassName), ariaLabelledBy, hideExpandIcon, ...defaultHeaderProps },
      React69.createElement("span", { className: styles_css_default29["header-navigation-content"] }, headerText !== null && headerText !== void 0 ? headerText : header)
    );
  }
  if (headerText || variant === "inline") {
    if (!headerText && header && variant === "inline") {
      warnOnce(componentName, "Only `headerText` instead of `header` is supported for `inline` variant.");
    }
    return React69.createElement(ExpandableHeaderTextWrapper, { className: clsx_m_default(className, wrapperClassName, expanded && styles_css_default29.expanded, !expanded && (!headerActions || headerDescription) && styles_css_default29["wrapper-not-expanded-without-actions"]), descriptionId, headerDescription, headerCounter, headerInfo, headerActions, headingTagOverride, onKeyUp, onKeyDown, ...defaultHeaderProps }, headerText);
  }
  if (variant === "container" && header && isDevelopment2) {
    warnOnce(componentName, "Use `headerText` instead of `header` to provide the button within the heading for a11y.");
  }
  return React69.createElement(ExpandableDeprecatedHeader, { className: clsx_m_default(className, wrapperClassName, styles_css_default29.focusable, expanded && styles_css_default29.expanded), onKeyUp, onKeyDown, ...defaultHeaderProps }, header);
};

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/internal.js
function InternalExpandableSection({ expanded: controlledExpanded, defaultExpanded, onChange, variant = "default", children, header, headerText, headerCounter, headerDescription, headerInfo, headerActions, headingTagOverride, disableContentPaddings, headerAriaLabel, __internalRootRef, __injectAnalyticsComponentMetadata, __expandIconPosition = "start", __disableHeaderPaddings = false, __hideExpandIcon = false, ...props }) {
  const contentInnerRef = useRef32(null);
  const isOneTheme = useOneTheme();
  const controlId = useUniqueId();
  const triggerControlId = `${controlId}-trigger`;
  const descriptionId = `${controlId}-description`;
  const baseProps = getBaseProps(props);
  const [expanded, setExpanded] = useControllable2(controlledExpanded, onChange, defaultExpanded, {
    componentName: "ExpandableSection",
    controlledProp: "expanded",
    changeHandler: "onChange"
  });
  const onExpandChange = useCallback16((newExpanded) => {
    setExpanded(newExpanded);
    fireNonCancelableEvent(onChange, { expanded: newExpanded });
  }, [onChange, setExpanded]);
  const onClick = useCallback16(() => {
    onExpandChange(!expanded);
  }, [onExpandChange, expanded]);
  const onKeyUp = useCallback16((event) => {
    const interactionKeys = [KeyCode2.enter, KeyCode2.space];
    if (interactionKeys.indexOf(event.keyCode) !== -1) {
      onExpandChange(!expanded);
    }
  }, [onExpandChange, expanded]);
  const onKeyDown = useCallback16((event) => {
    if (event.keyCode === KeyCode2.space) {
      event.preventDefault();
    }
  }, []);
  useEffect35(() => {
    if (contentInnerRef.current) {
      contentInnerRef.current.inert = !expanded;
    }
  }, [expanded]);
  const triggerProps = {
    ariaControls: controlId,
    ariaLabel: headerAriaLabel,
    ariaLabelledBy: headerAriaLabel ? void 0 : triggerControlId,
    onKeyUp,
    onKeyDown,
    onClick
  };
  const baseVariant = variant === "stacked" ? "container" : variant;
  return React70.createElement(
    ExpandableSectionContainer,
    { ...props, expanded, className: clsx_m_default(baseProps.className, styles_css_default29.root, styles_css_default26.root), variant, __injectAnalyticsComponentMetadata, header: React70.createElement(ExpandableSectionHeader, { id: triggerControlId, descriptionId, className: clsx_m_default(styles_css_default29.header, styles_css_default29[`header-${baseVariant}`], screenReaderTextClass, __disableHeaderPaddings && styles_css_default29["disable-header-paddings"]), variant: baseVariant, expanded: !!expanded, header, headerText, headerDescription, headerCounter, headerInfo, headerActions, headingTagOverride, expandIconPosition: __expandIconPosition, hideExpandIcon: __hideExpandIcon, ...triggerProps }), __internalRootRef },
    React70.createElement(Transition2, { in: !!expanded, disabled: !isOneTheme }, (transitionState, transitionEventsRef, motionDisabled) => {
      const contentSettled = !!expanded && (motionDisabled || transitionState === "entered");
      return React70.createElement(
        "div",
        { ref: transitionEventsRef, id: controlId, className: clsx_m_default(styles_css_default29.content, styles_css_default29[`content-${baseVariant}`], expanded && styles_css_default29["content-expanded"], disableContentPaddings && styles_css_default29["disable-content-paddings"]), role: "group", "aria-label": triggerProps.ariaLabel, "aria-labelledby": triggerProps.ariaLabelledBy, "aria-describedby": variantSupportsDescription(baseVariant) && headerDescription ? descriptionId : void 0 },
        React70.createElement(
          "div",
          { ref: contentInnerRef, className: clsx_m_default(styles_css_default29["content-inner"], expanded && styles_css_default29["content-inner-expanded"], contentSettled && styles_css_default29["content-inner-settled"]) },
          React70.createElement("div", { className: clsx_m_default(styles_css_default29["content-inner-body"], styles_css_default29[`content-inner-body-${baseVariant}`], disableContentPaddings && styles_css_default29["disable-content-paddings"]) }, children)
        )
      );
    })
  );
}

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/expandable-section/index.js
function ExpandableSection({ variant = "default", ...props }) {
  const analyticsMetadata = getAnalyticsMetadataProps(props);
  const baseComponentProps = useBaseComponent("ExpandableSection", {
    props: {
      disableContentPaddings: props.disableContentPaddings,
      headingTagOverride: props.headingTagOverride,
      variant
    },
    metadata: {
      hasInstanceIdentifier: Boolean(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier),
      hasHeaderActions: Boolean(props.headerActions)
    }
  }, analyticsMetadata);
  return React71.createElement(InternalExpandableSection, { variant, ...props, ...baseComponentProps, __injectAnalyticsComponentMetadata: true });
}
applyDisplayName(ExpandableSection, "ExpandableSection");

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon/index.js
import React73 from "react";

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon/internal-do-not-use-core.js
import React72 from "react";
function Icon({ size = "normal", variant = "normal", ...props }) {
  const baseComponentProps = useBaseComponent("Icon", { props: { name: props.name, size, variant } });
  return React72.createElement(internal_default, { size, variant, ...props, ...baseComponentProps });
}
applyDisplayName(Icon, "Icon");

// ../../node_modules/@amzn/awsui-components-react-v3/polaris/icon/index.js
var Icon2 = (props) => {
  validateProps("Icon", props, ["nativeAttributes"], {}, "console");
  return React73.createElement(Icon, props);
};
applyDisplayName(Icon2, "Icon");
var icon_default = Icon2;

// ../../node_modules/@amzn/access-denied-comp/dist/index.js
var import_aws_arn_util = __toESM(require_lib());
function ___$insertStyle(css) {
  if (!css || typeof window === "undefined") {
    return;
  }
  const style = document.createElement("style");
  style.setAttribute("type", "text/css");
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}
___$insertStyle(".InfoBoxGrid {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  word-break: break-all;\n  hyphens: auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: #ffffff;\n  flex: none;\n  order: 0;\n  flex-grow: 1;\n  position: relative;\n}\n\n.InfoBoxContainer {\n  display: flex;\n  background-color: #ffffff;\n  width: 100%;\n  overflow: auto;\n}\n.InfoBoxContainer .InfoBoxSpace {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  word-break: break-all;\n  max-height: 145px;\n  order: 0;\n  flex-grow: 1;\n}\n\n.CopyButton {\n  padding: 10px;\n}\n\n.InfoBoxContainer.background {\n  background-color: #f2f3f3;\n}\n\n.ExpandShift {\n  margin-top: -5.5px;\n}\n\n.access-denied-popover-container {\n  display: flex;\n}\n\n.access-denied-popover-content {\n  flex: 1;\n}\n\nbody.awsui-polaris-dark-mode .InfoBoxSpace,\nbody.awsui-polaris-dark-mode .InfoBoxSpace.popover,\nbody.awsui-polaris-dark-mode .InfoBoxGrid {\n  background-color: #1a2029; /* grey-800 https://polaris.a2z.com/foundation/visual-foundation/colors/ */\n}");
var NoResourceBox = function(_a3) {
  var user = _a3.user, service = _a3.service, action = _a3.action, context = _a3.context;
  return React74.createElement(
    box_default,
    { variant: "code", margin: "s", "data-testid": "NoResource" },
    React74.createElement(
      space_between_default,
      { size: "xxxs" },
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.userField", defaultMessage: "User:" })
        ),
        " ",
        user
      ),
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.actionField", defaultMessage: "Action:" })
        ),
        " ",
        "".concat(service, ":").concat(action)
      ),
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.contextField", defaultMessage: "Context:" })
        ),
        " ",
        context
      )
    )
  );
};
var NoContextBox = function(_a3) {
  var user = _a3.user, service = _a3.service, action = _a3.action, resource = _a3.resource;
  return React74.createElement(
    box_default,
    { variant: "code", margin: "s", "data-testid": "NoContext" },
    React74.createElement(
      space_between_default,
      { size: "xxxs" },
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.userField", defaultMessage: "User:" })
        ),
        " ",
        user
      ),
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.actionField", defaultMessage: "Action:" })
        ),
        " ",
        "".concat(service, ":").concat(action)
      ),
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.resourceField", defaultMessage: "On resource(s):" })
        ),
        " ",
        resource
      )
    )
  );
};
var AllFieldsBox = function(_a3) {
  var user = _a3.user, service = _a3.service, action = _a3.action, resource = _a3.resource, context = _a3.context;
  return React74.createElement(
    box_default,
    { variant: "code", margin: "s", "data-testid": "AllFields" },
    React74.createElement(
      space_between_default,
      { size: "xxxs" },
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.userField", defaultMessage: "User:" })
        ),
        " ",
        user
      ),
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.actionField", defaultMessage: "Action:" })
        ),
        " ",
        "".concat(service, ":").concat(action)
      ),
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.resourceField", defaultMessage: "On resource(s):" })
        ),
        " ",
        resource
      ),
      React74.createElement(
        TextContent,
        null,
        React74.createElement(
          box_default,
          { variant: "strong" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.contextField", defaultMessage: "Context:" })
        ),
        " ",
        context
      )
    )
  );
};
var __assign2 = function() {
  __assign2 = Object.assign || function __assign3(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign2.apply(this, arguments);
};
function __rest2(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function CopyButton(_a3) {
  var user = _a3.user, service = _a3.service, action = _a3.action, resource = _a3.resource, context = _a3.context, onCopy = _a3.onCopy, rest = __rest2(_a3, ["user", "service", "action", "resource", "context", "onCopy"]);
  var formatMessage2 = useIntl().formatMessage;
  function copyText() {
    var userTranslate = formatMessage2({ id: "accessDenied.userField" }) + " " + user;
    var actionTranslate = formatMessage2({ id: "accessDenied.actionField" }) + " " + "".concat(service, ":").concat(action);
    var resourceTranslate = formatMessage2({ id: "accessDenied.resourceField" }) + " " + resource;
    var contextTranslate = formatMessage2({ id: "accessDenied.contextField" }) + " " + context;
    var copy = "".concat(userTranslate, "\n").concat(actionTranslate, "\n");
    if (resource === "") {
      copy = "".concat(copy).concat(contextTranslate);
    } else if (context === "") {
      copy = "".concat(copy).concat(resourceTranslate);
    } else {
      copy = "".concat(copy).concat(resourceTranslate, "\n").concat(contextTranslate);
    }
    navigator.clipboard.writeText(copy);
    onCopy === null || onCopy === void 0 ? void 0 : onCopy(copy);
  }
  return React74.createElement(button_default, __assign2({ iconName: "copy", wrapText: false, onClick: copyText, "data-testid": "accessDenied.copyButton", formAction: "none", variant: "inline-icon", ariaLabel: formatMessage2({
    id: "accessDenied.copyButton"
  }) }, rest));
}
function LearnMoreLink(_a3) {
  var link = _a3.link, rest = __rest2(_a3, ["link"]);
  var _b = useState29(), absoluteLink = _b[0], setAbsoluteLink = _b[1];
  var formatMessage2 = useIntl().formatMessage;
  useEffect37(function() {
    link = link === null || link === void 0 ? void 0 : link.trim();
    if (!!link && link.indexOf("https://") === -1) {
      if (link[0] !== "/") {
        link = "/".concat(link);
      }
      link = "https://docs.aws.amazon.com".concat(link);
    }
    setAbsoluteLink(link);
  }, [link]);
  return React74.createElement(
    React74.Fragment,
    null,
    "\xA0",
    !!absoluteLink && React74.createElement(
      link_default,
      __assign2({ href: absoluteLink, external: true, "data-testid": "learn-more-link", externalIconAriaLabel: formatMessage2({
        id: "accessDenied.opensInNewTab"
      }) }, rest),
      React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.learnMore" })
    )
  );
}
var I18nContext = createContext16({});
var I18nProvider = function(_a3) {
  var initialValue = _a3.initialValue, children = _a3.children;
  return React__default.createElement(I18nContext.Provider, { value: initialValue !== null && initialValue !== void 0 ? initialValue : {} }, children);
};
var ExpandedContent = function(_a3) {
  var user = _a3.user, service = _a3.service, action = _a3.action, resource = _a3.resource, context = _a3.context, resourceEmpty = _a3.resourceEmpty, contextEmpty = _a3.contextEmpty, learnMoreLink = _a3.learnMoreLink, onCopy = _a3.onCopy;
  var i18nStrings = React74.useContext(I18nContext);
  return React74.createElement(
    space_between_default,
    { direction: "vertical", size: "s" },
    React74.createElement(
      TextContent,
      null,
      React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.defaultDeny", values: {
        service: React74.createElement("em", null, service),
        action: React74.createElement("em", null, action),
        customErrorMessagePlaceholder: i18nStrings.additionalErrorDetails
      } }),
      React74.createElement(LearnMoreLink, { link: learnMoreLink, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_learnMore_expandable" })
    ),
    React74.createElement(
      "div",
      { className: "InfoBoxContainer" },
      React74.createElement(
        "div",
        { className: "InfoBoxSpace" },
        resourceEmpty && !contextEmpty && React74.createElement(NoResourceBox, { user, service, action, context, "data-testid": "NoResource" }),
        contextEmpty && !resourceEmpty && React74.createElement(NoContextBox, { user, service, action, resource, "data-testid": "NoContext" }),
        !resourceEmpty && !contextEmpty && React74.createElement(AllFieldsBox, { user, service, action, resource, context, "data-testid": "AllFields" })
      ),
      React74.createElement(
        "div",
        { className: "CopyButton" },
        React74.createElement(
          popover_default,
          { size: "small", position: "top", triggerType: "custom", dismissButton: false, content: React74.createElement(
            status_indicator_default,
            { type: "success" },
            React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.requestCopied" })
          ) },
          React74.createElement(CopyButton, { user, service, action, resource, context, onCopy, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_copy_expandable" })
        )
      )
    )
  );
};
var AccessDeniedExpanded = function(_a3) {
  var error = _a3.error, learnMoreLink = _a3.learnMoreLink, onCopy = _a3.onCopy, onExpand = _a3.onExpand, _b = _a3.defaultExpanded, defaultExpanded = _b === void 0 ? false : _b;
  var _c = React74.useState(true), visible = _c[0], setVisible = _c[1];
  var message = error;
  var _d = useArcParse({
    eventContext: "accessDenied_variant_expandable",
    message
  }), user = _d[0], service = _d[1], action = _d[2], resource = _d[3], context = _d[4], breakFlag = _d[5];
  var resourceEmpty = !!(resource === "");
  var contextEmpty = !!(context === "");
  var formatMessage2 = useIntl().formatMessage;
  var messageSectionExpanded = function(_a4) {
    var detail = _a4.detail;
    var expanded = detail.expanded;
    if (expanded) {
      onExpand === null || onExpand === void 0 ? void 0 : onExpand();
    }
  };
  if (breakFlag) {
    return React74.createElement(
      alert_default,
      { onDismiss: function() {
        return setVisible(false);
      }, visible, dismissAriaLabel: formatMessage2({
        id: "accessDenied.closeAlert"
      }), type: "error", statusIconAriaLabel: formatMessage2({ id: "accessDenied.error" }), "data-analytics-render": true, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_variant_expandable" },
      React74.createElement(
        "div",
        { className: "ExpandShift" },
        React74.createElement(
          ExpandableSection,
          { headerText: React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.headerText", values: { serviceAction: "".concat(service, ":").concat(action) } }), onChange: messageSectionExpanded, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_toggle_expandable", defaultExpanded },
          React74.createElement(
            space_between_default,
            { size: "s" },
            React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.errorDeny" }),
            React74.createElement(
              "div",
              { className: "InfoBoxGrid" },
              React74.createElement(box_default, { variant: "code", margin: "s" }, message)
            )
          )
        )
      )
    );
  }
  return React74.createElement(
    box_default,
    { "data-alert-type": "collapsible" },
    React74.createElement(
      alert_default,
      { onDismiss: function() {
        return setVisible(false);
      }, visible, dismissAriaLabel: formatMessage2({
        id: "accessDenied.closeAlert"
      }), type: "error", statusIconAriaLabel: formatMessage2({ id: "accessDenied.error" }), "data-analytics-render": true, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_variant_expandable" },
      React74.createElement(
        "div",
        { className: "ExpandShift" },
        React74.createElement(
          ExpandableSection,
          { headerText: React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.headerText", values: { serviceAction: "".concat(service, ":").concat(action) } }), onChange: messageSectionExpanded, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_toggle_expandable" },
          React74.createElement(ExpandedContent, { user, action, service, resource, context, resourceEmpty, contextEmpty, learnMoreLink, onCopy })
        )
      )
    )
  );
};
function AccessDeniedPopover(_a3) {
  var error = _a3.error, learnMoreLink = _a3.learnMoreLink, onCopy = _a3.onCopy, onPopover = _a3.onPopover;
  var _b = React74.useState(true), visible = _b[0], setVisible = _b[1];
  var formatMessage2 = useIntl().formatMessage;
  var message = error;
  var _c = useArcParse({
    eventContext: "accessDenied_variant_popover",
    message
  }), user = _c[0], service = _c[1], action = _c[2], resource = _c[3], context = _c[4], breakFlag = _c[5];
  var resourceEmpty = !!(resource === "");
  var contextEmpty = !!(context === "");
  function popoverContentRendered() {
    onPopover === null || onPopover === void 0 ? void 0 : onPopover();
  }
  if (breakFlag) {
    return React74.createElement(
      box_default,
      { color: "text-status-error", "data-analytics-render": true, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_variant_popover" },
      React74.createElement(
        popover_default,
        { dismissAriaLabel: formatMessage2({
          id: "accessDenied.close"
        }), size: "medium", content: React74.createElement(
          alert_default,
          { onDismiss: function() {
            return setVisible(false);
          }, visible, dismissAriaLabel: formatMessage2({
            id: "accessDenied.closeAlert"
          }), type: "error", statusIconAriaLabel: formatMessage2({ id: "accessDenied.error" }), header: React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.header" }), "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_toggle_popover" },
          React74.createElement(
            space_between_default,
            { size: "s" },
            React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.errorDeny" }),
            React74.createElement(
              "div",
              { className: "InfoBoxGrid" },
              React74.createElement(box_default, { variant: "code", margin: "s" }, message)
            )
          )
        ) },
        React74.createElement(
          status_indicator_default,
          { type: "error" },
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.header" })
        )
      )
    );
  }
  return React74.createElement(
    box_default,
    { color: "text-status-error", "data-analytics-render": true, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_variant_popover" },
    React74.createElement(
      popover_default,
      { size: "large", content: React74.createElement(PopoverContent, { user, action, service, resource, context, resourceEmpty, contextEmpty, learnMoreLink, onCopy, onRender: popoverContentRendered }), "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_toggle_popover" },
      React74.createElement(
        status_indicator_default,
        { type: "error" },
        React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.header" })
      )
    )
  );
}
var PopoverContent = function(_a3) {
  var user = _a3.user, service = _a3.service, action = _a3.action, resourceEmpty = _a3.resourceEmpty, contextEmpty = _a3.contextEmpty, resource = _a3.resource, context = _a3.context, learnMoreLink = _a3.learnMoreLink, onCopy = _a3.onCopy, onRender = _a3.onRender;
  var i18nStrings = React74.useContext(I18nContext);
  React74.useEffect(function() {
    onRender === null || onRender === void 0 ? void 0 : onRender();
  }, [onRender]);
  return React74.createElement(
    "div",
    { className: "access-denied-popover-container" },
    React74.createElement(
      box_default,
      { margin: { top: "xxs", right: "s" } },
      React74.createElement(icon_default, { name: "status-negative", size: "big", variant: "error" })
    ),
    React74.createElement(
      "div",
      { className: "access-denied-popover-content" },
      React74.createElement(
        box_default,
        { variant: "strong", fontSize: "heading-s" },
        React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.header" })
      ),
      React74.createElement(
        space_between_default,
        { direction: "vertical", size: "s" },
        React74.createElement(
          TextContent,
          null,
          React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.defaultDeny", values: {
            service: React74.createElement("em", null, service),
            action: React74.createElement("em", null, action),
            customErrorMessagePlaceholder: i18nStrings.additionalErrorDetails
          } }),
          React74.createElement(LearnMoreLink, { link: learnMoreLink, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_learnMore_popover" })
        ),
        React74.createElement(
          "div",
          { className: "InfoBoxContainer background" },
          React74.createElement(
            "div",
            { className: "InfoBoxSpace" },
            resourceEmpty && !contextEmpty && React74.createElement(NoResourceBox, { user, service, action, context, "data-testid": "NoResource" }),
            contextEmpty && !resourceEmpty && React74.createElement(NoContextBox, { user, service, action, resource, "data-testid": "NoContext" }),
            !resourceEmpty && !contextEmpty && React74.createElement(AllFieldsBox, { user, service, action, resource, context, "data-testid": "AllFields" })
          ),
          React74.createElement(
            "div",
            { className: "CopyButton" },
            React74.createElement(
              popover_default,
              { size: "small", position: "top", triggerType: "custom", dismissButton: false, "data-testid": "CopyPopover", content: React74.createElement(
                status_indicator_default,
                { type: "success" },
                React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.requestCopied" })
              ) },
              React74.createElement(CopyButton, { user, service, action, resource, context, onCopy, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_copy_popover" })
            )
          )
        ),
        React74.createElement(box_default, { float: "right" })
      )
    )
  );
};
var isArn = function(str) {
  try {
    var arn = import_aws_arn_util.Arn.fromString(str);
    return !!arn;
  } catch (_a3) {
    return false;
  }
};
var isExplict = function(str) {
  var withAnExplicitDenytoken = " with an explicit deny";
  var becauseNoToken = " because no ";
  var withAnExplicitDenyIndex = str.lastIndexOf(withAnExplicitDenytoken);
  var becauseNoIndex = str.lastIndexOf(becauseNoToken);
  if (withAnExplicitDenyIndex <= -1 || becauseNoIndex > withAnExplicitDenyIndex) {
    return false;
  }
  return true;
};
function ARCParse(_a3) {
  var message = _a3.message;
  var result;
  try {
    var isNotAuthorizedToken_1 = " is not authorized to perform: ";
    var onResourceToken_1 = " on resource: ";
    var withAnExplicitDenytoken_1 = " with an explicit deny";
    var becauseNoToken_1 = " because no ";
    var VPCDenyThroughAnotherPolicyToken_1 = " transitively through ";
    var isExplictDeny_1 = isExplict(message);
    var userSplit = function(message2) {
      return message2.split(" ").find(isArn) || "";
    };
    var serviceSplit = function(message2) {
      var messageSplit = message2.split(isNotAuthorizedToken_1);
      var serviceString = messageSplit[1].split(":");
      return serviceString[0];
    };
    var actionSplit = function(message2) {
      var messageSplit = message2.split(isNotAuthorizedToken_1);
      var serviceAction = messageSplit[1].split(" ");
      var actionString = serviceAction[0].split(":");
      return actionString[1];
    };
    var resouceSplit = function(message2) {
      var resourceArn = "";
      var resourceString = message2.split(onResourceToken_1)[1];
      var startIndex = resourceString === null || resourceString === void 0 ? void 0 : resourceString.indexOf("arn:");
      if (!resourceString || startIndex <= -1)
        return resourceArn;
      var endIndex = isExplictDeny_1 ? resourceString.lastIndexOf(withAnExplicitDenytoken_1) : resourceString.lastIndexOf(becauseNoToken_1);
      if (endIndex > -1) {
        resourceArn = resourceString.substring(startIndex, endIndex);
      } else {
        resourceArn = resourceString.substring(startIndex);
      }
      return isArn(resourceArn) ? resourceArn : "";
    };
    var contextSplit = function(message2) {
      var splittedMessage = isExplictDeny_1 ? message2.split(withAnExplicitDenytoken_1) : message2.split(becauseNoToken_1);
      var contextStr = splittedMessage[splittedMessage.length - 1];
      if (isExplictDeny_1 && (contextStr === null || contextStr === void 0 ? void 0 : contextStr.lastIndexOf(VPCDenyThroughAnotherPolicyToken_1)) > -1) {
        var splitted = contextStr === null || contextStr === void 0 ? void 0 : contextStr.split(VPCDenyThroughAnotherPolicyToken_1);
        var anotherPolicyType = splitted[splitted.length - 1];
        return "a VPC endpoint policy explicitly denies the action through ".concat(anotherPolicyType);
      }
      if (!contextStr) {
        if (isExplictDeny_1)
          return "a policy explicitly denies the action";
        return "";
      }
      var policyTypes = [
        "identity-based policy",
        "permissions boundary",
        "resource-based policy",
        "service control policy",
        "session policy",
        "vpc endpoint policy",
        "role trust policy"
      ];
      var policyType = policyTypes.find(function(pt) {
        return contextStr.toLowerCase().includes(pt);
      });
      policyType = policyType === "vpc endpoint policy" ? policyType = "VPC endpoint policy" : policyType;
      if (isExplictDeny_1) {
        if (!policyType)
          return "a policy explicitly denies the action";
        if (policyType === "identity-based policy") {
          return "an identity-based policy explicitly denies the action";
        }
        return "a ".concat(policyType, " explicitly denies the action");
      } else {
        if (!policyType)
          return "";
        return "no ".concat(policyType, " allows the action");
      }
    };
    var user = userSplit(message);
    var service = serviceSplit(message);
    var action = actionSplit(message);
    var resource = resouceSplit(message);
    var context = contextSplit(message);
    var breakFlag = false;
    result = [user, service, action, resource, context, breakFlag];
  } catch (error) {
    result = ["", "", "", "", "", true];
  }
  return result;
}
var useArcParse = function(_a3) {
  var eventContext = _a3.eventContext, message = _a3.message;
  var parsedArc = ARCParse({
    message
  });
  var service = parsedArc[1], action = parsedArc[2], context = parsedArc[4];
  React74.useEffect(function() {
    var _a4, _b, _c;
    var timestamp = Date.now();
    (_a4 = window === null || window === void 0 ? void 0 : window.panorama) === null || _a4 === void 0 ? void 0 : _a4.call(window, "trackCustomEvent", {
      eventType: "custom",
      eventContext,
      eventDetail: "arcService",
      eventValue: service,
      timestamp
    });
    (_b = window === null || window === void 0 ? void 0 : window.panorama) === null || _b === void 0 ? void 0 : _b.call(window, "trackCustomEvent", {
      eventType: "custom",
      eventContext,
      eventDetail: "arcAction",
      eventValue: action,
      timestamp
    });
    (_c = window === null || window === void 0 ? void 0 : window.panorama) === null || _c === void 0 ? void 0 : _c.call(window, "trackCustomEvent", {
      eventType: "custom",
      eventContext,
      eventDetail: "arcContext",
      eventValue: context,
      timestamp
    });
  }, []);
  return parsedArc;
};
function AccessDenied(_a3) {
  var error = _a3.error, learnMoreLink = _a3.learnMoreLink, onCopy = _a3.onCopy;
  var _b = React74.useState(true), visible = _b[0], setVisible = _b[1];
  var message = error;
  var _c = useArcParse({
    eventContext: "accessDenied_variant_standard",
    message
  }), user = _c[0], service = _c[1], action = _c[2], resource = _c[3], context = _c[4], breakFlag = _c[5];
  var resourceEmpty = !!(resource === "");
  var contextEmpty = !!(context === "");
  var formatMessage2 = useIntl().formatMessage;
  var i18nStrings = React74.useContext(I18nContext);
  var ref = React74.useRef(null);
  var _d = React74.useState("center");
  _d[0];
  var setButtonAlignMent = _d[1];
  React74.useEffect(function() {
    if (ref.current) {
      var width = ref.current.offsetWidth;
      if (width > 688 - 20) {
        setButtonAlignMent("center");
      } else {
        setButtonAlignMent("end");
      }
    }
  }, [ref.current]);
  if (breakFlag) {
    return React74.createElement(
      alert_default,
      { onDismiss: function() {
        return setVisible(false);
      }, visible, dismissAriaLabel: formatMessage2({
        id: "accessDenied.closeAlert"
      }), type: "error", statusIconAriaLabel: formatMessage2({ id: "accessDenied.error" }), header: React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.header" }) },
      React74.createElement(
        space_between_default,
        { size: "s" },
        React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.errorDeny" }),
        React74.createElement(
          "div",
          { className: "InfoBoxGrid" },
          React74.createElement(box_default, { variant: "code", margin: "s" }, message)
        )
      )
    );
  }
  return React74.createElement(
    box_default,
    { "data-alert-type": "standard" },
    React74.createElement(
      alert_default,
      { onDismiss: function() {
        return setVisible(false);
      }, visible, dismissAriaLabel: formatMessage2({
        id: "accessDenied.closeAlert"
      }), type: "error", statusIconAriaLabel: formatMessage2({ id: "accessDenied.error" }), header: React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.header" }), "data-analytics-render": true, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_variant_standard" },
      React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.defaultDeny", values: {
        service: React74.createElement("em", null, service),
        action: React74.createElement("em", null, action),
        customErrorMessagePlaceholder: i18nStrings.additionalErrorDetails
      } }),
      React74.createElement(LearnMoreLink, { link: learnMoreLink, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_learnMore_standard" }),
      React74.createElement(
        box_default,
        { margin: { top: "s" } },
        React74.createElement(
          "div",
          { ref },
          React74.createElement(
            Grid,
            { gridDefinition: [
              {
                colspan: {
                  default: 12,
                  xs: 9,
                  s: 10,
                  l: 11
                }
              },
              {
                colspan: {
                  default: 12,
                  xs: 3,
                  s: 2,
                  l: 1
                }
              }
            ] },
            React74.createElement(
              "div",
              { className: "InfoBoxContainer" },
              React74.createElement(
                "div",
                { className: "InfoBoxGrid" },
                resourceEmpty && !contextEmpty && React74.createElement(NoResourceBox, { user, service, action, context, "data-testid": "NoResource" }),
                contextEmpty && !resourceEmpty && React74.createElement(NoContextBox, { user, service, action, resource, "data-testid": "NoContext" }),
                !resourceEmpty && !contextEmpty && React74.createElement(AllFieldsBox, { user, service, action, resource, context, "data-testid": "AllFields" })
              ),
              React74.createElement(
                "div",
                { className: "CopyButton" },
                React74.createElement(
                  popover_default,
                  { size: "small", position: "top", triggerType: "custom", dismissButton: false, content: React74.createElement(
                    status_indicator_default,
                    { type: "success" },
                    React74.createElement(MemoizedFormattedMessage, { id: "accessDenied.requestCopied" })
                  ) },
                  React74.createElement(CopyButton, { user, service, action, resource, context, onCopy, "data-analytics-type": "eventDetail", "data-analytics": "accessDenied_copy_standard" })
                )
              )
            )
          )
        )
      )
    )
  );
}
var messages_de = {
  "accessDenied.header": "Zugriff verweigert",
  "accessDenied.errorDeny": "Sie haben keine Berechtigung zum Ausf\xFChren dieser Aktion.",
  "accessDenied.defaultDeny": "Sie haben keine Berechtigung f\xFCr {service}:{action}. {customErrorMessagePlaceholder} Um Zugriff anzufordern, kopieren Sie den folgenden Text und senden Sie ihn an Ihren AWS-Administrator.",
  "accessDenied.userField": "Benutzer:",
  "accessDenied.serviceField": "Service:",
  "accessDenied.actionField": "Aktion:",
  "accessDenied.resourceField": "Auf Ressource(n):",
  "accessDenied.contextField": "Kontext:",
  "accessDenied.requestCopied": "Zugriffsdetails kopiert",
  "accessDenied.copyButton": "Kopieren",
  "accessDenied.learnMore": "Weitere Informationen zur Fehlerbehebung bei Zugriffsverweigerungsfehlern.",
  "accessDenied.close": "Schlie\xDFen",
  "accessDenied.closeAlert": "Warnung schlie\xDFen",
  "accessDenied.opensInNewTab": "Wird in einer neuen Registerkarte ge\xF6ffnet",
  "accessDenied.error": "Fehler"
};
var messages_en = {
  "accessDenied.header": "Access denied",
  "accessDenied.errorDeny": "You don't have permission to perform this action.",
  "accessDenied.defaultDeny": "You don't have permission to {service}:{action}. {customErrorMessagePlaceholder} To request access, copy the following text and send it to your AWS administrator.",
  "accessDenied.userField": "User:",
  "accessDenied.serviceField": "Service:",
  "accessDenied.actionField": "Action:",
  "accessDenied.resourceField": "On resource(s):",
  "accessDenied.contextField": "Context:",
  "accessDenied.requestCopied": "Access details copied",
  "accessDenied.copyButton": "Copy",
  "accessDenied.learnMore": "Learn more about troubleshooting access denied errors.",
  "accessDenied.close": "Close",
  "accessDenied.closeAlert": "Close alert",
  "accessDenied.opensInNewTab": "Opens in a new tab",
  "accessDenied.error": "Error"
};
var messages_es = {
  "accessDenied.header": "Acceso denegado",
  "accessDenied.errorDeny": "No tiene permiso para realizar esta acci\xF3n.",
  "accessDenied.defaultDeny": "No tiene permiso para {service}:{action} {customErrorMessagePlaceholder}. Para solicitar acceso, copie el siguiente texto y env\xEDelo a su administrador de AWS.",
  "accessDenied.userField": "Usuario:",
  "accessDenied.serviceField": "Servicio:",
  "accessDenied.actionField": "Acci\xF3n:",
  "accessDenied.resourceField": "En recursos:",
  "accessDenied.contextField": "Contexto:",
  "accessDenied.requestCopied": "Informaci\xF3n de acceso copiada",
  "accessDenied.copyButton": "Copiar",
  "accessDenied.learnMore": "M\xE1s informaci\xF3n sobre la soluci\xF3n de problemas de acceso denegado.",
  "accessDenied.close": "Cerrar",
  "accessDenied.closeAlert": "Cerrar alerta",
  "accessDenied.opensInNewTab": "Se abre en una pesta\xF1a nueva",
  "accessDenied.error": "Error"
};
var messages_fr = {
  "accessDenied.header": "Acc\xE8s refus\xE9",
  "accessDenied.errorDeny": "Vous n'\xEAtes pas autoris\xE9 \xE0 effectuer cette action.",
  "accessDenied.defaultDeny": "Vous ne disposez pas de l'autorisation de {service}:{action}. {customErrorMessagePlaceholder} Pour demander l'acc\xE8s, copiez le texte suivant et envoyez-le \xE0 votre administrateur AWS.",
  "accessDenied.userField": "Utilisateur:",
  "accessDenied.serviceField": "Service:",
  "accessDenied.actionField": "Action:",
  "accessDenied.resourceField": "Sur la ou les ressources:",
  "accessDenied.contextField": "Contexte:",
  "accessDenied.requestCopied": "D\xE9tails d'acc\xE8s copi\xE9s",
  "accessDenied.copyButton": "Copier",
  "accessDenied.learnMore": "En savoir plus sur le d\xE9pannage des erreurs d'acc\xE8s refus\xE9.",
  "accessDenied.close": "Fermer",
  "accessDenied.closeAlert": "Fermer l'alerte",
  "accessDenied.opensInNewTab": "S'ouvre dans un nouvel onglet",
  "accessDenied.error": "Erreur"
};
var messages_id = {
  "accessDenied.header": "Akses ditolak",
  "accessDenied.errorDeny": "AAnda tidak memiliki izin untuk melakukan tindakan ini.",
  "accessDenied.defaultDeny": "Anda tidak memiliki izin untuk {service}:{action}. {customErrorMessagePlaceholder} Untuk meminta akses, salin teks berikut dan mengirimkannya ke administrator AWS Anda.",
  "accessDenied.userField": "Pengguna:",
  "accessDenied.serviceField": "Layanan:",
  "accessDenied.actionField": "Tindakan:",
  "accessDenied.resourceField": "Di sumber daya:",
  "accessDenied.contextField": "Konteks:",
  "accessDenied.requestCopied": "Detail akses disalin",
  "accessDenied.copyButton": "Salin",
  "accessDenied.learnMore": "Pelajari selengkapnya tentang pemecahan masalah kesalahan akses ditolak.",
  "accessDenied.close": "Tutup",
  "accessDenied.closeAlert": "Tutup pemberitahuan",
  "accessDenied.opensInNewTab": "Buka di tab baru",
  "accessDenied.error": "Kesalahan"
};
var messages_it = {
  "accessDenied.header": "Accesso negato",
  "accessDenied.errorDeny": "Non disponi dell'autorizzazione per eseguire questa operazione.",
  "accessDenied.defaultDeny": "Non disponi dell'autorizzazione per {service}:{action}. {customErrorMessagePlaceholder} Per richiedere l'accesso, copia il testo seguente e invialo all'amministratore AWS.",
  "accessDenied.userField": "Utente:",
  "accessDenied.serviceField": "Servizio:",
  "accessDenied.actionField": "Operazione:",
  "accessDenied.resourceField": "Nelle risorse:",
  "accessDenied.contextField": "Contesto:",
  "accessDenied.requestCopied": "Dettagli di accesso copiati",
  "accessDenied.copyButton": "Copia",
  "accessDenied.learnMore": "Ulteriori informazioni sulla risoluzione dei problemi di accesso negato.",
  "accessDenied.close": "Chiudi",
  "accessDenied.closeAlert": "Chiudi avviso",
  "accessDenied.opensInNewTab": "Si apre in una nuova scheda",
  "accessDenied.error": "Errore"
};
var messages_ja = {
  "accessDenied.header": "\u30A2\u30AF\u30BB\u30B9\u62D2\u5426",
  "accessDenied.errorDeny": "\u3053\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3059\u308B\u8A31\u53EF\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
  "accessDenied.defaultDeny": "{service}:{action} \u306B\u5BFE\u3059\u308B\u8A31\u53EF\u304C\u3042\u308A\u307E\u305B\u3093\u3002{customErrorMessagePlaceholder} \u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u306B\u306F\u3001\u6B21\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u30B3\u30D4\u30FC\u3057\u3066 AWS \u7BA1\u7406\u8005\u306B\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "accessDenied.userField": "\u30E6\u30FC\u30B6\u30FC:",
  "accessDenied.serviceField": "\u30B5\u30FC\u30D3\u30B9:",
  "accessDenied.actionField": "\u30A2\u30AF\u30B7\u30E7\u30F3:",
  "accessDenied.resourceField": "\u30EA\u30BD\u30FC\u30B9 :",
  "accessDenied.contextField": "\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8:",
  "accessDenied.requestCopied": "\u30A2\u30AF\u30BB\u30B9\u306E\u8A73\u7D30\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
  "accessDenied.copyButton": "\u30B3\u30D4\u30FC",
  "accessDenied.learnMore": "\u30A2\u30AF\u30BB\u30B9\u62D2\u5426\u30A8\u30E9\u30FC\u306E\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0\u306B\u95A2\u3059\u308B\u8A73\u7D30\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "accessDenied.close": "\u9589\u3058\u308B",
  "accessDenied.closeAlert": "\u30A2\u30E9\u30FC\u30C8\u3092\u9589\u3058\u308Bfdg",
  "accessDenied.opensInNewTab": "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304D\u307E\u3059",
  "accessDenied.error": "\u30A8\u30E9\u30FC"
};
var messages_ko = {
  "accessDenied.header": "\uC561\uC138\uC2A4 \uAC70\uBD80\uB428",
  "accessDenied.errorDeny": "\uC774 \uC791\uC5C5\uC744 \uC218\uD589\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
  "accessDenied.defaultDeny": "{service}:{action}\uC5D0 \uB300\uD55C \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4. {customErrorMessagePlaceholder} \uC561\uC138\uC2A4\uB97C \uC694\uCCAD\uD558\uB824\uBA74 \uB2E4\uC74C \uD14D\uC2A4\uD2B8\uB97C \uBCF5\uC0AC\uD558\uC5EC AWS \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBCF4\uB0B4\uC138\uC694.",
  "accessDenied.userField": "\uC0AC\uC6A9\uC790:",
  "accessDenied.serviceField": "\uC11C\uBE44\uC2A4:",
  "accessDenied.actionField": "\uC791\uC5C5:",
  "accessDenied.resourceField": "\uB9AC\uC18C\uC2A4:",
  "accessDenied.contextField": "\uCEE8\uD14D\uC2A4\uD2B8:",
  "accessDenied.requestCopied": "\uC561\uC138\uC2A4 \uC138\uBD80 \uC815\uBCF4 \uBCF5\uC0AC\uB428",
  "accessDenied.copyButton": "\uBCF5\uC0AC",
  "accessDenied.learnMore": "\uC561\uC138\uC2A4 \uAC70\uBD80 \uC624\uB958 \uD574\uACB0\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.",
  "accessDenied.close": "\uB2EB\uAE30",
  "accessDenied.closeAlert": "\uC54C\uB9BC \uB2EB\uAE30",
  "accessDenied.opensInNewTab": "\uC0C8 \uD0ED\uC5D0\uC11C \uC5F4\uB9BC",
  "accessDenied.error": "\uC624\uB958"
};
var messages_pt_BR = {
  "accessDenied.header": "Acesso negado",
  "accessDenied.errorDeny": "Voc\xEA n\xE3o tem permiss\xE3o para executar esta a\xE7\xE3o.",
  "accessDenied.defaultDeny": "Voc\xEA n\xE3o tem permiss\xE3o para {service}:{action}. {customErrorMessagePlaceholder} Para solicitar acesso, copie o texto a seguir e envie-o para o administrador da AWS.",
  "accessDenied.userField": "Usu\xE1rio:",
  "accessDenied.serviceField": "Servi\xE7o:",
  "accessDenied.actionField": "A\xE7\xE3o:",
  "accessDenied.resourceField": "No(s) recurso(s):",
  "accessDenied.contextField": "Contexto:",
  "accessDenied.requestCopied": "Detalhes de acesso copiados",
  "accessDenied.copyButton": "Copiar",
  "accessDenied.learnMore": "Saiba mais sobre a solu\xE7\xE3o de problemas de erros de acesso negado.",
  "accessDenied.close": "Fechar",
  "accessDenied.closeAlert": "Fechar alerta",
  "accessDenied.opensInNewTab": "Abre em uma nova guia",
  "accessDenied.error": "Erro"
};
var messages_zh_CN = {
  "accessDenied.header": "\u8BBF\u95EE\u88AB\u62D2\u7EDD",
  "accessDenied.errorDeny": "\u60A8\u6CA1\u6709\u6267\u884C\u6B64\u64CD\u4F5C\u7684\u6743\u9650\u3002",
  "accessDenied.defaultDeny": "\u60A8\u6CA1\u6709\u8BBF\u95EE {service}:{action} \u7684\u6743\u9650\u3002{customErrorMessagePlaceholder} \u8981\u8BF7\u6C42\u8BBF\u95EE\u6743\u9650\uFF0C\u8BF7\u590D\u5236\u4EE5\u4E0B\u6587\u672C\u5E76\u53D1\u9001\u7ED9 AWS \u7BA1\u7406\u5458\u3002",
  "accessDenied.userField": "\u7528\u6237:",
  "accessDenied.serviceField": "\u670D\u52A1:",
  "accessDenied.actionField": "\u64CD\u4F5C:",
  "accessDenied.resourceField": "\u5728\u8D44\u6E90\u4E0A:",
  "accessDenied.contextField": "\u4E0A\u4E0B\u6587:",
  "accessDenied.requestCopied": "\u8BBF\u95EE\u8BE6\u7EC6\u4FE1\u606F\u5DF2\u590D\u5236",
  "accessDenied.copyButton": "\u590D\u5236",
  "accessDenied.learnMore": "\u4E86\u89E3\u6709\u5173\u6392\u67E5\u8BBF\u95EE\u88AB\u62D2\u7EDD\u9519\u8BEF\u7684\u66F4\u591A\u4FE1\u606F\u3002",
  "accessDenied.close": "\u5173\u95ED",
  "accessDenied.closeAlert": "\u5173\u95ED\u63D0\u9192",
  "accessDenied.opensInNewTab": "\u5728\u65B0\u9009\u9879\u5361\u4E2D\u6253\u5F00",
  "accessDenied.error": "\u9519\u8BEF"
};
var messages_zh_TW = {
  "accessDenied.header": "\u5B58\u53D6\u906D\u62D2",
  "accessDenied.errorDeny": "\u60A8\u6C92\u6709\u57F7\u884C\u6B64\u52D5\u4F5C\u7684\u8A31\u53EF\u3002",
  "accessDenied.defaultDeny": "\u60A8\u6C92\u6709 {service}:{action} \u7684\u8A31\u53EF\u3002{customErrorMessagePlaceholder} \u82E5\u8981\u8ACB\u6C42\u5B58\u53D6\uFF0C\u8ACB\u8907\u88FD\u4EE5\u4E0B\u6587\u5B57\u4E26\u5C07\u5176\u50B3\u9001\u7D66\u60A8\u7684 AWS \u7BA1\u7406\u54E1\u3002",
  "accessDenied.userField": "\u4F7F\u7528\u8005:",
  "accessDenied.serviceField": "\u670D\u52D9:",
  "accessDenied.actionField": "\u52D5\u4F5C:",
  "accessDenied.resourceField": "\u76EE\u6A19\u8CC7\u6E90\uFF1A",
  "accessDenied.contextField": "\u5167\u5BB9:",
  "accessDenied.requestCopied": "\u5B58\u53D6\u8A73\u7D30\u8CC7\u8A0A\u5DF2\u8907\u88FD",
  "accessDenied.copyButton": "\u8907\u88FD",
  "accessDenied.learnMore": "\u9032\u4E00\u6B65\u4E86\u89E3\u6545\u969C\u8A3A\u65B7\u5B58\u53D6\u906D\u62D2\u932F\u8AA4",
  "accessDenied.close": "\u95DC\u9589",
  "accessDenied.closeAlert": "\u95DC\u9589\u63D0\u9192",
  "accessDenied.opensInNewTab": "\u5728\u65B0\u7D22\u5F15\u6A19\u7C64\u4E2D\u958B\u555F",
  "accessDenied.error": "\u9519\u8BEF"
};
var AccessDeniedAlert = function(_a3) {
  var variant = _a3.variant, error = _a3.error, learnMoreLink = _a3.learnMoreLink, onCopy = _a3.onCopy, onExpand = _a3.onExpand, onPopover = _a3.onPopover, i18nStrings = _a3.i18nStrings, _b = _a3.defaultExpanded, defaultExpanded = _b === void 0 ? false : _b;
  var documentLanguage = document.documentElement.lang;
  var region = documentLanguage.split(/[-_]/)[0];
  var language = region;
  if (region === "zh") {
    language = documentLanguage.split(/[-_]/)[1];
    language = language.toLowerCase();
  }
  var messages = {
    de: messages_de,
    en: messages_en,
    es: messages_es,
    fr: messages_fr,
    id: messages_id,
    it: messages_it,
    ja: messages_ja,
    ko: messages_ko,
    pt: messages_pt_BR,
    cn: messages_zh_CN,
    tw: messages_zh_TW
  };
  var AccessDeniedComponent = function() {
    switch (variant) {
      case "collapsible":
      case "expandable":
        return React74.createElement(AccessDeniedExpanded, { error, "data-testid": "medium", learnMoreLink, onCopy, onExpand, defaultExpanded });
      case "popover":
        return React74.createElement(AccessDeniedPopover, { error, "data-testid": "small", learnMoreLink, onCopy, onPopover });
      case "standard":
      default:
        return React74.createElement(AccessDenied, { error, "data-testid": "large", learnMoreLink, onCopy });
    }
  };
  return React74.createElement(
    I18nProvider,
    { initialValue: i18nStrings },
    React74.createElement(
      IntlProvider,
      { messages: messages[language], locale: region, defaultLocale: "en" },
      React74.createElement(AccessDeniedComponent, null)
    )
  );
};

// src/results/AskUser/AccessDeniedStandard.tsx
import Box7 from "@cloudscape-design/components/box";
import Link5 from "@cloudscape-design/components/link";
import SpaceBetween8 from "@cloudscape-design/components/space-between";
import { useAppTranslation as useAppTranslation7 } from "@amzn/awsmp-max-translations";
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
var AccessDeniedStandard = ({ errorMessage }) => {
  const { t } = useAppTranslation7();
  return /* @__PURE__ */ jsxs8(SpaceBetween8, { size: "m", children: [
    /* @__PURE__ */ jsx14(Box7, { variant: "p", children: t("accessDeniedExplanation") }),
    /* @__PURE__ */ jsx14(
      AccessDeniedAlert,
      {
        variant: "standard",
        error: errorMessage,
        learnMoreLink: "https://docs.aws.amazon.com/IAM/latest/UserGuide/troubleshoot_access-denied.html",
        "data-testid": "access-denied-standard"
      }
    ),
    /* @__PURE__ */ jsx14(Link5, { href: "https://docs.aws.amazon.com/marketplace/latest/buyerguide/agent-mode.html", variant: "primary", external: true, children: t("accessDeniedViewPermissions") })
  ] });
};

// src/results/AskUser/AskUser.tsx
import { spaceStaticXs as spaceStaticXs2 } from "@cloudscape-design/design-tokens";
import { Fragment as Fragment8, jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var AskUserMultiselect = ({ options, sendMessage, isSubmitDisabled, logger }) => {
  const { t } = useAppTranslation8();
  const optionsValue = options || [];
  const [selectedOptions, setSelectedOptions] = React75.useState([]);
  const handleToggle = (option, checked) => {
    if (checked) {
      setSelectedOptions((prev) => [...prev, option]);
    } else {
      setSelectedOptions((prev) => prev.filter((opt) => opt !== option));
    }
  };
  const handleSubmit = () => {
    if (selectedOptions.length > 0 && !isSubmitDisabled) {
      emitAskUserSubmit(logger, BI_CLICK_ACT_SUBMIT);
      sendMessage(JSON.stringify(selectedOptions));
    }
  };
  return /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "xs", children: [
    /* @__PURE__ */ jsx15("div", { role: "group", "aria-label": t("selectOneOrMoreOptions"), children: optionsValue.map((option, index) => /* @__PURE__ */ jsx15("div", { className: AskUser_module_default.checkboxOption, children: /* @__PURE__ */ jsx15(
      Checkbox,
      {
        checked: selectedOptions.includes(option),
        onChange: ({ detail }) => handleToggle(option, detail.checked),
        disabled: isSubmitDisabled,
        children: option
      }
    ) }, index)) }),
    /* @__PURE__ */ jsx15(Button5, { variant: "primary", onClick: handleSubmit, disabled: selectedOptions.length === 0 || isSubmitDisabled, iconName: "send", children: t("continue") })
  ] });
};
var AskUserBoolean = ({ sendMessage, isSubmitDisabled, logger }) => {
  const { t } = useAppTranslation8();
  const [selectedValue, setSelectedValue] = React75.useState(null);
  const handleChange = (value) => {
    if (!isSubmitDisabled) {
      emitAskUserSubmit(logger, BI_CLICK_ACT_RADIO);
      setSelectedValue(value);
      sendMessage(value);
    }
  };
  return /* @__PURE__ */ jsx15(
    RadioGroup,
    {
      value: selectedValue,
      onChange: ({ detail }) => handleChange(detail.value),
      items: [
        { value: "true", label: t("yes"), disabled: isSubmitDisabled },
        { value: "false", label: t("no"), disabled: isSubmitDisabled }
      ]
    }
  );
};
var entryValue = (entry) => typeof entry === "object" && entry !== null ? entry.value : String(entry);
var entryOption = (entry) => typeof entry === "object" && entry !== null ? { label: entry.label || entry.value, value: entry.value, tags: entry.tags, labelTag: entry.labelTag } : { label: String(entry), value: String(entry) };
var ElicitationMultiSelect = ({
  entries,
  selected,
  label,
  onChange,
  isSubmitDisabled,
  isReadOnly,
  isRequired
}) => {
  const { t } = useAppTranslation8();
  const options = entries.map(entryOption);
  return /* @__PURE__ */ jsx15(
    Multiselect,
    {
      selectedOptions: options.filter((option) => selected.includes(option.value)),
      onChange: ({ detail }) => onChange(detail.selectedOptions.flatMap((option) => option.value === void 0 ? [] : [option.value])),
      options,
      filteringType: entries.length >= 10 ? "auto" : void 0,
      placeholder: t("selectOneOrMoreOptions"),
      disabled: isSubmitDisabled,
      readOnly: isReadOnly,
      ariaRequired: isRequired,
      ariaLabel: label
    }
  );
};
var AskUserElicitationForm = ({ data, toolUseId, sendMessage, isSubmitDisabled, initialData, logger }) => {
  const { t } = useAppTranslation8();
  const { requestedSchema } = data;
  const question = data.question;
  const [formData, setFormData] = React75.useState(initialData ?? {});
  const [errors, setErrors] = React75.useState({});
  const [customInputFields, setCustomInputFields] = React75.useState(/* @__PURE__ */ new Set());
  if (!requestedSchema || !requestedSchema.properties) {
    return /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "l", children: [
      question && /* @__PURE__ */ jsx15(MarkdownRenderer4, { variant: MessageRole3.Assistant, children: question }),
      /* @__PURE__ */ jsx15(Box8, { color: "text-body-secondary", children: t("loadingForm") })
    ] });
  }
  const handleFieldChange = (fieldName, value) => {
    setFormData((prev) => ({ ...prev, [fieldName]: value }));
    if (errors[fieldName]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };
  const validateAndSubmit = () => {
    if (!requestedSchema) {
      return;
    }
    const newErrors = {};
    requestedSchema.required?.forEach((fieldName) => {
      const property = requestedSchema.properties?.[fieldName];
      const effective = formData[fieldName] ?? property?.default;
      const isUntickedRequiredCheckbox = property?.type === "boolean" && effective !== true;
      if (isUntickedRequiredCheckbox || effective === void 0 || effective === "" || Array.isArray(effective) && effective.length === 0) {
        newErrors[fieldName] = t("formRequired");
      }
    });
    Object.entries(requestedSchema.properties).forEach(([fieldName, _property]) => {
      const value = formData[fieldName];
      if (value && typeof value === "string" && value.length > MAX_ASKUSER_FIELD_LENGTH) {
        newErrors[fieldName] = `Exceeds maximum length of ${MAX_ASKUSER_FIELD_LENGTH} characters`;
      }
      const customFieldName = `${fieldName}_custom`;
      const customValue = formData[customFieldName];
      if (customValue && typeof customValue === "string" && customValue.length > MAX_ASKUSER_FIELD_LENGTH) {
        newErrors[fieldName] = `Exceeds maximum length of ${MAX_ASKUSER_FIELD_LENGTH} characters`;
      }
    });
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    emitAskUserSubmit(logger, BI_CLICK_ACT_SUBMIT);
    const submitted = {};
    for (const [fieldName, property] of Object.entries(requestedSchema.properties)) {
      if (property.readOnly === true) {
        continue;
      }
      const value = formData[fieldName] ?? property.default;
      if (value !== void 0 && value !== "") {
        submitted[fieldName] = value;
      }
    }
    for (const [key, value] of Object.entries(formData)) {
      if (key.endsWith("_custom") && typeof value === "string" && value !== "") {
        submitted[key] = value;
      }
    }
    const dataToSend = Object.keys(submitted).length === 0 ? "User does not provide any answer." : submitted;
    sendMessage([
      {
        toolOutput: {
          toolUseId,
          name: "askUser",
          output: {
            askUser: {
              responseFormat: "accept",
              data: dataToSend
            }
          },
          status: "COMPLETE"
        }
      }
    ]);
  };
  const decline = () => {
    sendMessage([{ toolOutput: { toolUseId, name: "askUser", output: { askUser: { responseFormat: "decline" } }, status: "COMPLETE" } }]);
  };
  const renderField = (fieldName, property, label) => {
    const fieldDefault = property.default;
    const value = formData[fieldName] ?? fieldDefault ?? "";
    const isReadOnly = property.readOnly === true;
    if (property.type === "array") {
      const selected = formData[fieldName] ?? property.default ?? [];
      return /* @__PURE__ */ jsx15(
        ElicitationMultiSelect,
        {
          entries: property.items.enum,
          selected,
          label: property.label || fieldName,
          onChange: (picked) => handleFieldChange(fieldName, picked),
          isSubmitDisabled,
          isReadOnly,
          isRequired: requestedSchema.required?.includes(fieldName) ?? false
        }
      );
    }
    if ("enum" in property && property.enum) {
      const isCustomInput = value === "Other";
      if (isCustomInput) {
        const customFieldName = `${fieldName}_custom`;
        const customValue = formData[customFieldName] || "";
        const charCount2 = String(customValue).length;
        const isOverLimit2 = charCount2 > MAX_ASKUSER_FIELD_LENGTH;
        return /* @__PURE__ */ jsxs9("div", { style: { display: "flex", gap: spaceStaticXs2, alignItems: "flex-start" }, children: [
          /* @__PURE__ */ jsx15("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "xxs", children: [
            /* @__PURE__ */ jsx15(
              Textarea,
              {
                value: customValue,
                onChange: ({ detail }) => handleFieldChange(customFieldName, detail.value),
                placeholder: "Please specify...",
                disabled: isSubmitDisabled,
                invalid: isOverLimit2
              }
            ),
            /* @__PURE__ */ jsxs9(Box8, { fontSize: "body-s", color: isOverLimit2 ? "text-status-error" : "text-status-inactive", children: [
              charCount2,
              " / ",
              MAX_ASKUSER_FIELD_LENGTH,
              " characters"
            ] })
          ] }) }),
          /* @__PURE__ */ jsx15(
            Button5,
            {
              iconName: "close",
              variant: "icon",
              ariaLabel: "Clear custom input",
              onClick: () => {
                handleFieldChange(fieldName, "");
                handleFieldChange(customFieldName, "");
                const newSet = new Set(customInputFields);
                newSet.delete(fieldName);
                setCustomInputFields(newSet);
              },
              disabled: isSubmitDisabled
            }
          )
        ] });
      }
      const selectedEntry = property.enum.find((entry) => entryValue(entry) === value);
      const selectedOption = value ? selectedEntry !== void 0 ? entryOption(selectedEntry) : { label: value, value } : null;
      return /* @__PURE__ */ jsx15(
        Select,
        {
          selectedOption,
          onChange: ({ detail }) => {
            const newValue = detail.selectedOption.value || "";
            handleFieldChange(fieldName, newValue);
            if (newValue === "Other") {
              const newSet = new Set(customInputFields);
              newSet.add(fieldName);
              setCustomInputFields(newSet);
            }
          },
          options: property.enum.map(entryOption),
          filteringType: property.enum.length >= 10 ? "auto" : void 0,
          placeholder: property.placeholder || t("selectAnOption"),
          disabled: isSubmitDisabled || isReadOnly,
          ariaRequired: requestedSchema.required?.includes(fieldName)
        }
      );
    }
    if (property.type === "number" || property.type === "integer") {
      const raw = formData[fieldName] ?? fieldDefault;
      return /* @__PURE__ */ jsx15(
        Input,
        {
          value: raw === void 0 ? "" : String(raw),
          onChange: ({ detail }) => {
            const parsed = detail.value === "" ? "" : Number(detail.value);
            handleFieldChange(fieldName, typeof parsed === "number" && Number.isNaN(parsed) ? "" : parsed);
          },
          type: "number",
          placeholder: property.placeholder,
          disabled: isSubmitDisabled,
          readOnly: isReadOnly,
          ariaRequired: requestedSchema.required?.includes(fieldName)
        }
      );
    }
    if (property.type === "boolean") {
      const checked = formData[fieldName] ?? fieldDefault ?? false;
      return /* @__PURE__ */ jsx15(
        Checkbox,
        {
          checked,
          onChange: ({ detail }) => handleFieldChange(fieldName, detail.checked),
          disabled: isSubmitDisabled,
          readOnly: isReadOnly,
          ariaRequired: requestedSchema.required?.includes(fieldName),
          children: label
        }
      );
    }
    const charCount = String(value).length;
    const isOverLimit = charCount > MAX_ASKUSER_FIELD_LENGTH;
    if ("format" in property && property.format === "textArea") {
      return /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "xxs", children: [
        /* @__PURE__ */ jsx15(
          Textarea,
          {
            value,
            onChange: ({ detail }) => handleFieldChange(fieldName, detail.value),
            placeholder: property.placeholder,
            disabled: isSubmitDisabled || isReadOnly,
            invalid: isOverLimit,
            ariaRequired: requestedSchema.required?.includes(fieldName)
          }
        ),
        charCount > 0 && /* @__PURE__ */ jsxs9(Box8, { fontSize: "body-s", color: isOverLimit ? "text-status-error" : "text-status-inactive", children: [
          charCount,
          " / ",
          MAX_ASKUSER_FIELD_LENGTH,
          " characters"
        ] })
      ] });
    }
    return /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "xxs", children: [
      /* @__PURE__ */ jsx15(
        Input,
        {
          value,
          onChange: ({ detail }) => handleFieldChange(fieldName, detail.value),
          inputMode: "format" in property && property.format === "tel" ? "tel" : void 0,
          placeholder: property.placeholder,
          disabled: isSubmitDisabled,
          readOnly: isReadOnly,
          invalid: isOverLimit,
          ariaRequired: requestedSchema.required?.includes(fieldName)
        }
      ),
      charCount > 0 && /* @__PURE__ */ jsxs9(Box8, { fontSize: "body-s", color: isOverLimit ? "text-status-error" : "text-status-inactive", children: [
        charCount,
        " / ",
        MAX_ASKUSER_FIELD_LENGTH,
        " characters"
      ] })
    ] });
  };
  return /* @__PURE__ */ jsx15(
    Form,
    {
      actions: /* @__PURE__ */ jsxs9(SpaceBetween9, { direction: "horizontal", size: "xs", children: [
        /* @__PURE__ */ jsx15(Button5, { variant: "normal", formAction: "none", onClick: decline, disabled: isSubmitDisabled, children: t("skip") }),
        /* @__PURE__ */ jsx15(Button5, { variant: "primary", onClick: validateAndSubmit, disabled: isSubmitDisabled, children: data.submissionLabel || t("proceed") })
      ] }),
      children: /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "l", children: [
        question && /* @__PURE__ */ jsx15(MarkdownRenderer4, { variant: MessageRole3.Assistant, children: question }),
        requestedSchema.properties && Object.entries(requestedSchema.properties).map(([fieldName, property]) => {
          const isRequired = requestedSchema.required?.includes(fieldName);
          const baseLabel = property.label || fieldName;
          const labelWithOptional = isRequired ? baseLabel : /* @__PURE__ */ jsxs9(Fragment8, { children: [
            baseLabel,
            " ",
            /* @__PURE__ */ jsxs9("span", { style: { fontStyle: "italic" }, children: [
              "- ",
              t("optional")
            ] })
          ] });
          return /* @__PURE__ */ jsx15(
            FormField,
            {
              label: property.type === "boolean" ? void 0 : labelWithOptional,
              description: property.description,
              errorText: errors[fieldName],
              children: renderField(fieldName, property, labelWithOptional)
            },
            fieldName
          );
        })
      ] })
    }
  );
};
var isElicitationMode = (data) => {
  return data.mode === "elicitation";
};
var isToolAuthorizationMode = (data) => {
  return data.mode === "toolAuthorization";
};
var isAuthenticateMode = (data) => {
  return data.mode === "authenticate";
};
var isPredefinedMode = (data) => {
  return data.mode === "predefined";
};
var isAccessDeniedMode = (data) => {
  return data.mode === "accessDenied";
};
var ResponseRenderer = ({ output, layoutManager, navigationManager }) => {
  const { t } = useAppTranslation8();
  if (output.responseFormat === "accept") {
    return null;
  }
  let responseText;
  switch (output.responseFormat) {
    case "simple": {
      if (typeof output.value === "boolean") {
        responseText = output.value ? t("yes") : t("no");
      } else if (Array.isArray(output.value)) {
        responseText = output.value.join(", ");
      } else {
        responseText = output.value;
      }
      break;
    }
    case "decline": {
      responseText = t("skippedRequest");
      break;
    }
  }
  if (!responseText) {
    return null;
  }
  return /* @__PURE__ */ jsx15(
    Text,
    {
      data: { content: { text: responseText } },
      messageRole: MessageRole3.User,
      layoutManager,
      navigationManager
    }
  );
};
var AskUser = ({ data, toolUseId, rendererAPI }) => {
  const { t } = useAppTranslation8();
  const { sendMessage, layoutManager, navigationManager, logger } = rendererAPI;
  const inputData = data.input;
  const outputData = data.output;
  const [hasSubmitted, setHasSubmitted] = React75.useState(false);
  const handleSendMessage = React75.useCallback(
    (content) => {
      setHasSubmitted(true);
      sendMessage(content);
    },
    [sendMessage]
  );
  if (!inputData) {
    return null;
  }
  if (isToolAuthorizationMode(inputData)) {
    return null;
  }
  if (isAccessDeniedMode(inputData)) {
    let errorMessage;
    if (inputData.kind === "aws-exception") {
      errorMessage = inputData.errorMessage ?? "";
    } else {
      const principalArn = rendererAPI?.authManager?.getPrincipalArn() || "Unknown";
      errorMessage = `User: ${principalArn} is not authorized to perform: signin:CreateOAuth2Token because no identity-based policy allows signin:CreateOAuth2Token; if it is already granted, an account or organization policy is blocking it`;
    }
    return /* @__PURE__ */ jsx15(AccessDeniedStandard, { errorMessage });
  }
  if (isAuthenticateMode(inputData)) {
    return null;
  }
  if (isPredefinedMode(inputData)) {
    return null;
  }
  if (outputData) {
    if (isElicitationMode(inputData)) {
      return /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "m", children: [
        /* @__PURE__ */ jsx15(
          AskUserElicitationForm,
          {
            data: inputData,
            toolUseId,
            sendMessage,
            isSubmitDisabled: true,
            initialData: outputData.responseFormat === "accept" ? outputData.data : void 0,
            logger
          }
        ),
        outputData.responseFormat === "accept" && /* @__PURE__ */ jsx15(Box8, { color: "text-status-inactive", children: t("formAnswered") }),
        outputData.responseFormat === "decline" && /* @__PURE__ */ jsx15(Box8, { color: "text-status-inactive", children: t("formSkipped") })
      ] });
    }
    const { question: question2 } = inputData;
    return /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "m", children: [
      question2 && /* @__PURE__ */ jsx15(MarkdownRenderer4, { variant: MessageRole3.Assistant, children: question2 }),
      /* @__PURE__ */ jsx15(ResponseRenderer, { output: outputData, layoutManager, navigationManager })
    ] });
  }
  const isSubmitDisabled = hasSubmitted || !!outputData || rendererAPI.isLatestMessage !== void 0 && !rendererAPI.isLatestMessage;
  if (isElicitationMode(inputData)) {
    return /* @__PURE__ */ jsx15(
      AskUserElicitationForm,
      {
        data: inputData,
        toolUseId,
        sendMessage: handleSendMessage,
        isSubmitDisabled,
        initialData: void 0,
        logger
      }
    );
  }
  const { question, responseType, relatedQuestions, options } = inputData;
  return /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "m", children: [
    question && /* @__PURE__ */ jsx15(MarkdownRenderer4, { variant: MessageRole3.Assistant, children: question }),
    responseType === "select" && options && /* @__PURE__ */ jsx15(
      ClickableOptions2,
      {
        options,
        onSelect: handleSendMessage,
        disabled: isSubmitDisabled,
        ariaLabel: "Select an option",
        logger: rendererAPI.logger
      },
      "select"
    ),
    responseType === "multiselect" && /* @__PURE__ */ jsx15(AskUserMultiselect, { options, sendMessage: handleSendMessage, isSubmitDisabled, logger }, "multiselect"),
    responseType === "boolean" && /* @__PURE__ */ jsx15(AskUserBoolean, { sendMessage: handleSendMessage, isSubmitDisabled, logger }, "boolean"),
    relatedQuestions && relatedQuestions.length > 0 && /* @__PURE__ */ jsxs9(SpaceBetween9, { size: "xs", children: [
      /* @__PURE__ */ jsx15(Box8, { variant: "h3", color: "text-label", children: t("relatedQuestions") }),
      /* @__PURE__ */ jsx15(
        ClickableOptions2,
        {
          options: relatedQuestions,
          onSelect: handleSendMessage,
          disabled: isSubmitDisabled,
          ariaLabel: t("relatedQuestions"),
          logger: rendererAPI.logger
        }
      )
    ] }, "related")
  ] });
};

// src/results/AskUser/AccessDeniedPopover.tsx
import Box9 from "@cloudscape-design/components/box";
import CopyToClipboard from "@cloudscape-design/components/copy-to-clipboard";
import Icon3 from "@cloudscape-design/components/icon";
import Link6 from "@cloudscape-design/components/link";
import Popover2 from "@cloudscape-design/components/popover";
import SpaceBetween10 from "@cloudscape-design/components/space-between";
import * as React76 from "react";
import { useAppTranslation as useAppTranslation9 } from "@amzn/awsmp-max-translations";
import { describeCapability } from "@amzn/awsmp-max-model";

// src/results/AskUser/AccessDeniedPopover.module.scss
var AccessDeniedPopover_module_default = {
  accessDeniedWrapper: "AccessDeniedPopover_module_accessDeniedWrapper",
  triggerContent: "AccessDeniedPopover_module_triggerContent",
  popoverContainer: "AccessDeniedPopover_module_popoverContainer",
  contentColumn: "AccessDeniedPopover_module_contentColumn",
  title: "AccessDeniedPopover_module_title",
  fieldsBox: "AccessDeniedPopover_module_fieldsBox",
  fieldsContent: "AccessDeniedPopover_module_fieldsContent"
};

// src/analysis/AnalysisSteps/AnalysisSteps.module.scss
var AnalysisSteps_module_default = {
  fadeInScale: "AnalysisSteps_module_fadeInScale",
  shimmer: "AnalysisSteps_module_shimmer",
  thinkStep: "AnalysisSteps_module_thinkStep",
  iconColumn: "AnalysisSteps_module_iconColumn",
  textColumn: "AnalysisSteps_module_textColumn",
  thinkStepTitle: "AnalysisSteps_module_thinkStepTitle",
  shimmerText: "AnalysisSteps_module_shimmerText",
  thinkStepDescription: "AnalysisSteps_module_thinkStepDescription",
  idleMessage: "AnalysisSteps_module_idleMessage",
  loadingSpinner: "AnalysisSteps_module_loadingSpinner",
  dots: "AnalysisSteps_module_dots",
  isLastStep: "AnalysisSteps_module_isLastStep",
  textColumnSuccess: "AnalysisSteps_module_textColumnSuccess",
  textColumnError: "AnalysisSteps_module_textColumnError",
  textColumnStopped: "AnalysisSteps_module_textColumnStopped",
  textColumnLoading: "AnalysisSteps_module_textColumnLoading",
  fileTokenContainer: "AnalysisSteps_module_fileTokenContainer",
  fileToken: "AnalysisSteps_module_fileToken",
  fileLabel: "AnalysisSteps_module_fileLabel",
  productTokenContainer: "AnalysisSteps_module_productTokenContainer",
  fadeTransition: "AnalysisSteps_module_fadeTransition",
  tokenFade: "AnalysisSteps_module_tokenFade",
  analysisStepsWrapper: "AnalysisSteps_module_analysisStepsWrapper",
  analysisStepsContainer: "AnalysisSteps_module_analysisStepsContainer",
  hasTopFade: "AnalysisSteps_module_hasTopFade",
  hasBottomFade: "AnalysisSteps_module_hasBottomFade",
  scrollButtonContainer: "AnalysisSteps_module_scrollButtonContainer",
  fadeInButton: "AnalysisSteps_module_fadeInButton",
  authBlockItem: "AnalysisSteps_module_authBlockItem"
};

// src/results/AskUser/AccessDeniedPopover.tsx
import { spaceStaticXxxs } from "@cloudscape-design/design-tokens";
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
var AccessDeniedPopover2 = ({
  kind,
  toolName,
  user,
  service,
  action,
  resource,
  context,
  isLast = false
}) => {
  const { t } = useAppTranslation9();
  const triggerText = kind === "mint-permission" ? t("accessDeniedFailedAuthenticate") : toolName ? t("accessDeniedFailedAction", { action: describeCapability(toolName) }) : t("accessDeniedTitle");
  const serviceAction = `${service}:${action}`;
  const textToCopy = React76.useMemo(() => {
    return [
      `${t("accessDeniedUserLabel")}: [${user}]`,
      `${t("accessDeniedServiceLabel")}: [${service}]`,
      `${t("accessDeniedActionLabel")}: [${action}]`,
      resource ? `${t("accessDeniedResourceLabel")}: [${resource}]` : null,
      `${t("accessDeniedContextLabel")}: [${context}]`
    ].filter(Boolean).join("\n");
  }, [user, service, action, resource, context, t]);
  return /* @__PURE__ */ jsxs10("div", { className: `${AnalysisSteps_module_default.thinkStep} ${isLast ? AnalysisSteps_module_default.isLastStep : ""}`, children: [
    /* @__PURE__ */ jsx16("div", { className: AnalysisSteps_module_default.iconColumn, children: /* @__PURE__ */ jsx16(Icon3, { name: "status-negative", variant: "error", ariaLabel: t("errorIconAriaLabel") }) }),
    /* @__PURE__ */ jsx16(
      "div",
      {
        className: `${AnalysisSteps_module_default.textColumn} ${AnalysisSteps_module_default.textColumnError}`,
        style: { marginTop: spaceStaticXxxs },
        "data-testid": "access-denied-text-error",
        children: /* @__PURE__ */ jsx16(
          Popover2,
          {
            size: "large",
            fixedWidth: true,
            dismissButton: true,
            triggerType: "custom",
            content: /* @__PURE__ */ jsxs10(SpaceBetween10, { direction: "vertical", size: "m", children: [
              /* @__PURE__ */ jsxs10("div", { className: AccessDeniedPopover_module_default.popoverContainer, children: [
                /* @__PURE__ */ jsx16(Icon3, { name: "status-negative", size: "big", variant: "error", ariaLabel: t("accessDeniedTitle") }),
                /* @__PURE__ */ jsx16("div", { className: AccessDeniedPopover_module_default.contentColumn, children: /* @__PURE__ */ jsxs10(SpaceBetween10, { direction: "vertical", size: "l", children: [
                  /* @__PURE__ */ jsxs10(SpaceBetween10, { direction: "vertical", size: "xxxs", children: [
                    /* @__PURE__ */ jsx16("span", { className: AccessDeniedPopover_module_default.title, children: t("accessDeniedTitle") }),
                    /* @__PURE__ */ jsxs10(Box9, { color: "text-body-secondary", children: [
                      t("accessDeniedDescription", { serviceAction }),
                      " ",
                      /* @__PURE__ */ jsx16(
                        Link6,
                        {
                          href: "https://docs.aws.amazon.com/IAM/latest/UserGuide/troubleshoot_access-denied.html",
                          external: true,
                          variant: "primary",
                          children: t("accessDeniedLearnMore")
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs10(SpaceBetween10, { direction: "vertical", size: "s", children: [
                    /* @__PURE__ */ jsx16("div", { className: AccessDeniedPopover_module_default.fieldsBox, children: /* @__PURE__ */ jsx16("pre", { className: AccessDeniedPopover_module_default.fieldsContent, children: textToCopy }) }),
                    /* @__PURE__ */ jsx16(
                      CopyToClipboard,
                      {
                        variant: "button",
                        textToCopy,
                        copyButtonText: t("accessDeniedCopyButton"),
                        copySuccessText: t("accessDeniedCopied"),
                        copyErrorText: t("accessDeniedCopyError"),
                        popoverRenderWithPortal: true
                      }
                    )
                  ] })
                ] }) })
              ] }),
              /* @__PURE__ */ jsx16(Link6, { href: "https://docs.aws.amazon.com/marketplace/latest/buyerguide/agent-mode.html", external: true, children: t("accessDeniedViewPermissions") })
            ] }),
            children: /* @__PURE__ */ jsx16("span", { className: AccessDeniedPopover_module_default.triggerContent, children: triggerText })
          }
        )
      }
    )
  ] });
};

// src/results/RecommendUnits/RecommendUnits.tsx
import Button6 from "@amzn/awsui-components-react/polaris/button";
import Box10 from "@cloudscape-design/components/box";
import Modal from "@cloudscape-design/components/modal";
import Alert6 from "@cloudscape-design/components/alert";
import SpaceBetween11 from "@cloudscape-design/components/space-between";
import { colorBorderDividerDefault } from "@cloudscape-design/design-tokens";
import { useAppTranslation as useAppTranslation10 } from "@amzn/awsmp-max-translations";

// src/results/RecommendUnits/useRecommendUnits.ts
import * as React77 from "react";
var METRIC_COMPONENT = "RecommendUnits";
var useRecommendUnits = ({ dimensionSelections, rendererAPI, writeableArtifact }) => {
  const [isApplying, setIsApplying] = React77.useState(false);
  const [showConfirmModal, setShowConfirmModal] = React77.useState(false);
  const { logger } = rendererAPI;
  const isDisabled = isApplying || writeableArtifact.isArtifactLocked;
  const applyRecommendation = React77.useCallback(async () => {
    if (isDisabled)
      return;
    setIsApplying(true);
    const prev = writeableArtifact.artifact;
    const updated = {
      ...prev,
      offerRequest: {
        ...prev.offerRequest,
        configurableUpfrontDimensionSelections: dimensionSelections
      }
    };
    writeableArtifact.setArtifact(updated);
    try {
      await writeableArtifact.commitArtifactUpdate(updated);
    } catch (error) {
      writeableArtifact.setArtifact(prev);
      logger.error("RecommendUnits: failed to apply dimension selections", error instanceof Error ? error : new Error(String(error)));
      logger.opsMetric({
        metricName: CustomOpsMetricName.RecommendUnitsError,
        value: 1,
        unit: "Count",
        dimensions: { component: METRIC_COMPONENT, reason: "ApplyFailed" }
      });
    } finally {
      setIsApplying(false);
    }
  }, [isDisabled, writeableArtifact, logger, dimensionSelections]);
  const handleApply = React77.useCallback(async () => {
    const currentSelections = writeableArtifact.artifact.offerRequest.configurableUpfrontDimensionSelections;
    const hasNonZeroExisting = currentSelections?.some((d) => d.quantity > 0) ?? false;
    if (hasNonZeroExisting) {
      setShowConfirmModal(true);
    } else {
      await applyRecommendation();
    }
  }, [writeableArtifact, applyRecommendation]);
  const handleConfirm = React77.useCallback(async () => {
    setShowConfirmModal(false);
    await applyRecommendation();
  }, [applyRecommendation]);
  const dismissModal = React77.useCallback(() => {
    setShowConfirmModal(false);
  }, []);
  return { isApplying, isDisabled, showConfirmModal, handleApply, handleConfirm, dismissModal };
};

// src/results/RecommendUnits/RecommendUnits.tsx
import { Fragment as Fragment9, jsx as jsx17, jsxs as jsxs11 } from "react/jsx-runtime";
var RecommendUnits = ({ data, rendererAPI }) => {
  const epoBuyerWriteableArtifact = rendererAPI.writeableArtifact?.artifactType === "epoBuyerRequest" ? rendererAPI.writeableArtifact : void 0;
  if (!epoBuyerWriteableArtifact) {
    throw new Error("RecommendUnits requires a writeable epoBuyerRequest artifact");
  }
  const { t } = useAppTranslation10();
  const { dimensionSelections } = data.input;
  const { isApplying, isDisabled, showConfirmModal, handleApply, handleConfirm, dismissModal } = useRecommendUnits({
    dimensionSelections,
    rendererAPI,
    writeableArtifact: epoBuyerWriteableArtifact
  });
  return /* @__PURE__ */ jsxs11(Fragment9, { children: [
    /* @__PURE__ */ jsxs11(SpaceBetween11, { size: "xs", direction: "vertical", children: [
      /* @__PURE__ */ jsx17("div", { style: { borderTop: `2px solid ${colorBorderDividerDefault}` } }),
      /* @__PURE__ */ jsx17(Box10, { float: "right", children: /* @__PURE__ */ jsx17(Button6, { onClick: handleApply, loading: isApplying, disabled: isDisabled, "data-testid": "recommend-units-cta", children: t("recommendUnitsButton") }) })
    ] }),
    /* @__PURE__ */ jsx17(
      Modal,
      {
        visible: showConfirmModal,
        onDismiss: dismissModal,
        header: t("recommendUnitsConfirmTitle"),
        footer: /* @__PURE__ */ jsx17(Box10, { float: "right", children: /* @__PURE__ */ jsx17("div", { className: "awsui-visual-refresh", children: /* @__PURE__ */ jsxs11(SpaceBetween11, { direction: "horizontal", size: "xs", children: [
          /* @__PURE__ */ jsx17(Button6, { variant: "link", onClick: dismissModal, children: t("cancel") }),
          /* @__PURE__ */ jsx17(Button6, { variant: "primary", onClick: handleConfirm, loading: isApplying, disabled: isDisabled, "data-testid": "recommend-units-confirm", children: t("recommendUnitsConfirmProceed") })
        ] }) }) }),
        children: /* @__PURE__ */ jsx17(Alert6, { type: "info", header: t("recommendUnitsConfirmAlertTitle"), children: t("recommendUnitsConfirmAlertContent") })
      }
    )
  ] });
};

// src/results/Annotate/PrivateOfferThroughLeads.tsx
import Alert7 from "@cloudscape-design/components/alert";
import Box11 from "@cloudscape-design/components/box";
import Button7 from "@cloudscape-design/components/button";
import Link7 from "@cloudscape-design/components/link";
import SpaceBetween12 from "@cloudscape-design/components/space-between";
import { marketplaceLinks } from "@amzn/awsmp-max-link-catalog/browser";
import { jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var PRICING_CALCULATOR_HREF = "https://calculator.aws/";
var FALLBACK_ALERT_HEADER = "This request is outside our knowledge";
var FALLBACK_ALERT_MESSAGE = "This request is outside our knowledge and AI responses may include mistakes. Additional AWS infrastructure costs may apply. Use the AWS Pricing Calculator to estimate your infrastructure costs. To get a quote directly from the vendor, connect with them.";
var PRICING_CALCULATOR_LINK_TEXT = "AWS Pricing Calculator";
var VENDOR_CONTACT_LINK_TEXT = "connect with them";
var VENDOR_CONTACT_BUTTON_TEXT = "Connect with a representative";
var PrivateOfferThroughLeads = ({ input, logger }) => {
  const { reason, listingId } = input;
  const contactHref = marketplaceLinks.get("RequestPrivateOffer", { listingId });
  const emitClick = (clickAct) => {
    logger.biMetric({
      metricName: "Click",
      unit: "Count",
      value: 1,
      dimensions: {
        ClickFeat: BI_CLICK_FEAT,
        ClickObj: BI_CLICK_OBJ_PRIVATE_OFFER,
        ClickAct: clickAct
      }
    });
  };
  return /* @__PURE__ */ jsxs12(SpaceBetween12, { size: "m", children: [
    reason && /* @__PURE__ */ jsx18(Box11, { variant: "p", "data-testid": "annotate-reason", children: reason }),
    /* @__PURE__ */ jsx18(
      Alert7,
      {
        "data-testid": "annotate-alert",
        type: "info",
        header: FALLBACK_ALERT_HEADER,
        action: /* @__PURE__ */ jsx18(
          Button7,
          {
            "data-testid": "vendor-contact-button",
            href: contactHref,
            external: true,
            onFollow: () => emitClick(BI_CLICK_ACT_VENDOR_CONTACT_BUTTON),
            children: VENDOR_CONTACT_BUTTON_TEXT
          }
        ),
        children: renderMessageWithLinks(
          FALLBACK_ALERT_MESSAGE,
          [
            {
              text: PRICING_CALCULATOR_LINK_TEXT,
              href: PRICING_CALCULATOR_HREF,
              testId: "pricing-calculator-link",
              clickAct: BI_CLICK_ACT_PRICING_CALCULATOR_LINK
            },
            { text: VENDOR_CONTACT_LINK_TEXT, href: contactHref, testId: "vendor-contact-link", clickAct: BI_CLICK_ACT_VENDOR_CONTACT_LINK }
          ],
          emitClick
        )
      }
    )
  ] });
};
var renderMessageWithLinks = (message, links, emitClick) => {
  const parts = [];
  let remaining = message;
  let keyIndex = 0;
  for (const link of links) {
    const idx = remaining.indexOf(link.text);
    if (idx === -1)
      continue;
    if (idx > 0) {
      parts.push(remaining.slice(0, idx));
    }
    parts.push(
      /* @__PURE__ */ jsx18(Link7, { href: link.href, external: true, fontSize: "body-s", "data-testid": link.testId, onFollow: () => emitClick(link.clickAct), children: link.text }, keyIndex++)
    );
    remaining = remaining.slice(idx + link.text.length);
  }
  if (remaining) {
    parts.push(remaining);
  }
  return parts;
};

// src/results/Annotate/Annotate.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var Annotate = ({ data: { input }, rendererAPI }) => {
  if (input.type === "privateOfferThroughLeads" && input.privateOfferThroughLeadsInput) {
    return /* @__PURE__ */ jsx19(PrivateOfferThroughLeads, { input: input.privateOfferThroughLeadsInput, logger: rendererAPI.logger });
  }
  return null;
};

// src/results/Feedback/Feedback.tsx
import Alert8 from "@cloudscape-design/components/alert";
import Button9 from "@cloudscape-design/components/button";
import Box13 from "@cloudscape-design/components/box";
import * as React79 from "react";
import { useAppTranslation as useAppTranslation12 } from "@amzn/awsmp-max-translations";

// src/results/Feedback/FeedbackForm.tsx
import Button8 from "@cloudscape-design/components/button";
import Checkbox2 from "@cloudscape-design/components/checkbox";
import Textarea2 from "@cloudscape-design/components/textarea";
import Form2 from "@cloudscape-design/components/form";
import FormField2 from "@cloudscape-design/components/form-field";
import SpaceBetween13 from "@cloudscape-design/components/space-between";
import Box12 from "@cloudscape-design/components/box";
import * as React78 from "react";
import { useAppTranslation as useAppTranslation11 } from "@amzn/awsmp-max-translations";
import { FeedbackCategory, FEEDBACK_CATEGORIES } from "@amzn/awsmp-max-model";

// src/results/Feedback/types.ts
var MAX_FEEDBACK_TEXT_LENGTH = 1e3;
var DEFAULT_AUTO_DISMISS_MS = 5e3;

// src/results/Feedback/Feedback.module.scss
var Feedback_module_default = {
  controls: "Feedback_module_controls",
  controlsLabel: "Feedback_module_controlsLabel",
  buttonGroup: "Feedback_module_buttonGroup",
  iconButton: "Feedback_module_iconButton",
  iconButtonSelected: "Feedback_module_iconButtonSelected",
  form: "Feedback_module_form",
  formCloseButton: "Feedback_module_formCloseButton",
  checkboxGroup: "Feedback_module_checkboxGroup",
  checkboxItem: "Feedback_module_checkboxItem"
};

// src/results/Feedback/FeedbackForm.tsx
import { Fragment as Fragment10, jsx as jsx20, jsxs as jsxs13 } from "react/jsx-runtime";
var FeedbackForm = ({
  onSubmit,
  onClose,
  isSubmitting = false,
  disabled = false,
  initialCategories,
  initialFeedbackText
}) => {
  const { t } = useAppTranslation11();
  const [selectedCategories, setSelectedCategories] = React78.useState(initialCategories ?? [FeedbackCategory.Other]);
  const [feedbackText, setFeedbackText] = React78.useState(initialFeedbackText ?? "");
  const inputsDisabled = isSubmitting || disabled;
  const charCount = feedbackText.length;
  const isOverLimit = charCount > MAX_FEEDBACK_TEXT_LENGTH;
  const isSubmitDisabled = selectedCategories.length === 0 || isOverLimit || inputsDisabled;
  const handleCategoryToggle = (category, checked) => {
    if (checked) {
      setSelectedCategories((prev) => [...prev, category]);
    } else {
      setSelectedCategories((prev) => prev.filter((c) => c !== category));
    }
  };
  const handleSubmit = async () => {
    if (isSubmitDisabled)
      return;
    await onSubmit({
      categories: selectedCategories,
      feedbackText: feedbackText.trim() || void 0
    });
  };
  const getCategoryLabel = (category) => {
    switch (category) {
      case "Irrelevant":
        return t("feedbackCategoryIrrelevant");
      case "Incomplete":
        return t("feedbackCategoryIncomplete");
      case "Inaccurate":
        return t("feedbackCategoryInaccurate");
      case "Other":
        return t("feedbackCategoryOther");
      default:
        return category;
    }
  };
  return /* @__PURE__ */ jsxs13(
    "div",
    {
      className: Feedback_module_default.form,
      role: "form",
      "aria-label": t("feedbackFormLabel"),
      onKeyDown: (e) => {
        if (e.key === "Escape")
          onClose();
      },
      children: [
        /* @__PURE__ */ jsx20("div", { className: Feedback_module_default.formCloseButton, children: /* @__PURE__ */ jsx20(Button8, { variant: "icon", iconName: "close", ariaLabel: t("close"), onClick: onClose, disabled: inputsDisabled }) }),
        /* @__PURE__ */ jsx20(
          Form2,
          {
            actions: /* @__PURE__ */ jsx20(SpaceBetween13, { direction: "horizontal", size: "xs", children: /* @__PURE__ */ jsx20(Button8, { variant: "primary", onClick: handleSubmit, disabled: isSubmitDisabled, loading: isSubmitting, children: isSubmitting ? t("sending") : t("sendFeedback") }) }),
            children: /* @__PURE__ */ jsxs13(SpaceBetween13, { size: "l", children: [
              /* @__PURE__ */ jsx20(FormField2, { label: t("whatDidYouDislike"), errorText: selectedCategories.length === 0 ? t("selectAtLeastOneCategory") : void 0, children: /* @__PURE__ */ jsx20("div", { className: Feedback_module_default.checkboxGroup, role: "group", "aria-label": t("selectFeedbackCategories"), "aria-required": "true", children: FEEDBACK_CATEGORIES.map((category) => /* @__PURE__ */ jsx20("div", { className: Feedback_module_default.checkboxItem, children: /* @__PURE__ */ jsx20(
                Checkbox2,
                {
                  checked: selectedCategories.includes(category),
                  onChange: ({ detail }) => handleCategoryToggle(category, detail.checked),
                  disabled: inputsDisabled,
                  children: getCategoryLabel(category)
                }
              ) }, category)) }) }),
              /* @__PURE__ */ jsx20(
                FormField2,
                {
                  label: /* @__PURE__ */ jsxs13(Fragment10, { children: [
                    t("tellUsMore"),
                    " ",
                    /* @__PURE__ */ jsx20(Box12, { variant: "span", fontWeight: "normal", children: /* @__PURE__ */ jsxs13("i", { children: [
                      "- ",
                      t("optional")
                    ] }) })
                  ] }),
                  constraintText: t("characterCount", { current: charCount, max: MAX_FEEDBACK_TEXT_LENGTH }),
                  errorText: isOverLimit ? t("characterCount", { current: charCount, max: MAX_FEEDBACK_TEXT_LENGTH }) : void 0,
                  children: /* @__PURE__ */ jsx20(
                    Textarea2,
                    {
                      value: feedbackText,
                      onChange: ({ detail }) => setFeedbackText(detail.value),
                      placeholder: t("additionalFeedbackPlaceholder"),
                      disabled: inputsDisabled,
                      invalid: isOverLimit,
                      rows: 3
                    }
                  )
                }
              )
            ] })
          }
        )
      ]
    }
  );
};

// src/results/Feedback/Feedback.tsx
import { Fragment as Fragment11, jsx as jsx21, jsxs as jsxs14 } from "react/jsx-runtime";
var Feedback = ({ existingFeedback, onSubmitFeedback, disabled }) => {
  const { t } = useAppTranslation12();
  const [phase, setPhase] = React79.useState("idle");
  const [isSubmitting, setIsSubmitting] = React79.useState(false);
  const sentiment = existingFeedback?.sentiment ?? null;
  const isDisabled = isSubmitting || disabled;
  const isPositiveSelected = sentiment === "positive";
  const isNegativeSelected = sentiment === "negative";
  const handleThumbsUp = React79.useCallback(async () => {
    if (sentiment === "positive")
      return;
    setPhase("idle");
    setIsSubmitting(true);
    try {
      await onSubmitFeedback({ sentiment: "positive" });
    } catch {
    } finally {
      setIsSubmitting(false);
    }
  }, [sentiment, onSubmitFeedback]);
  const handleThumbsDown = React79.useCallback(() => {
    setPhase("form-open");
  }, []);
  const handleFormSubmit = React79.useCallback(
    async (formData) => {
      setIsSubmitting(true);
      try {
        await onSubmitFeedback({
          sentiment: "negative",
          categories: formData.categories,
          feedbackText: formData.feedbackText
        });
        setPhase("confirmation");
      } catch {
      } finally {
        setIsSubmitting(false);
      }
    },
    [onSubmitFeedback]
  );
  const handleDismiss = React79.useCallback(() => setPhase("idle"), []);
  return /* @__PURE__ */ jsxs14(Fragment11, { children: [
    /* @__PURE__ */ jsxs14("div", { className: Feedback_module_default.controls, children: [
      /* @__PURE__ */ jsx21(Box13, { variant: "span", className: Feedback_module_default.controlsLabel, children: t("helpful") }),
      /* @__PURE__ */ jsxs14("div", { className: Feedback_module_default.buttonGroup, children: [
        /* @__PURE__ */ jsx21(
          "div",
          {
            className: `${Feedback_module_default.iconButton} ${isPositiveSelected ? Feedback_module_default.iconButtonSelected : ""}`,
            "data-testid": isPositiveSelected ? "feedback-thumbs-up-selected" : "feedback-thumbs-up",
            children: /* @__PURE__ */ jsx21(
              Button9,
              {
                variant: "icon",
                iconName: isPositiveSelected ? "thumbs-up-filled" : "thumbs-up",
                ariaLabel: t("thumbsUp"),
                onClick: handleThumbsUp,
                disabled: isDisabled
              }
            )
          }
        ),
        /* @__PURE__ */ jsx21(
          "div",
          {
            className: `${Feedback_module_default.iconButton} ${isNegativeSelected ? Feedback_module_default.iconButtonSelected : ""}`,
            "data-testid": isNegativeSelected ? "feedback-thumbs-down-selected" : "feedback-thumbs-down",
            children: /* @__PURE__ */ jsx21(
              Button9,
              {
                variant: "icon",
                iconName: isNegativeSelected ? "thumbs-down-filled" : "thumbs-down",
                ariaLabel: t("thumbsDown"),
                onClick: handleThumbsDown,
                disabled: isDisabled
              }
            )
          }
        )
      ] })
    ] }),
    phase === "form-open" && /* @__PURE__ */ jsx21(
      FeedbackForm,
      {
        onSubmit: handleFormSubmit,
        onClose: () => setPhase("idle"),
        isSubmitting,
        disabled,
        initialCategories: existingFeedback?.categories,
        initialFeedbackText: existingFeedback?.feedbackText
      }
    ),
    phase === "confirmation" && /* @__PURE__ */ jsx21(FeedbackConfirmationBanner, { onDismiss: handleDismiss })
  ] });
};
var FeedbackConfirmationBanner = ({ onDismiss }) => {
  const { t } = useAppTranslation12();
  React79.useEffect(() => {
    const timer = setTimeout(onDismiss, DEFAULT_AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onDismiss]);
  return /* @__PURE__ */ jsx21(Alert8, { type: "success", dismissible: true, onDismiss, children: t("feedbackSent") });
};

// src/analysis/AnalysisSteps/AnalysisSteps.tsx
import Box16 from "@cloudscape-design/components/box";
import SpaceBetween17 from "@cloudscape-design/components/space-between";
import Button13 from "@cloudscape-design/components/button";
import Header2 from "@cloudscape-design/components/header";
import * as React85 from "react";
import { MessageStatus as MessageStatus2 } from "@amzn/awsmp-max-model";
import { useAppTranslation as useAppTranslation17 } from "@amzn/awsmp-max-translations";
import { TipCard, useTipCardTimer, AWS_MARKETPLACE_TIPS } from "@amzn/awsmp-max-ux-patterns/TipCard";

// src/analysis/AnalysisSteps/ThinkStep.tsx
import Icon4 from "@cloudscape-design/components/icon";
import Spinner2 from "@cloudscape-design/components/spinner";
import SpaceBetween14 from "@cloudscape-design/components/space-between";
import * as React80 from "react";
import { ProductToken } from "@amzn/awsmp-max-ux-patterns/ProductToken";
import { WebSearchToken } from "@amzn/awsmp-max-ux-patterns/WebSearchToken";
import { marketplaceLinks as marketplaceLinks2 } from "@amzn/awsmp-max-link-catalog/browser";
import { jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var convertListingCardToProduct = (card) => ({
  productId: card.id,
  productName: card.title,
  vendorName: card.vendor.name,
  productLogoUrl: card.logo.url,
  badges: card.badges
});
var ThinkStep = ({ step, isStreaming = false, isLast = false, idleMessage, children }) => {
  const [currentTokenIndex, setCurrentTokenIndex] = React80.useState(0);
  const [currentWebSearchIndex, setCurrentWebSearchIndex] = React80.useState(0);
  const showLoadingState = isLast && isStreaming;
  React80.useEffect(() => {
    if (!isStreaming || !step.listingCards || step.listingCards.length <= 1)
      return;
    const interval = setInterval(() => {
      setCurrentTokenIndex((prev) => (prev + 1) % step.listingCards.length);
    }, 1e4);
    return () => clearInterval(interval);
  }, [isStreaming, step.listingCards]);
  const webSearchCards = step.webSearchCards;
  React80.useEffect(() => {
    if (!isStreaming || !webSearchCards || webSearchCards.length <= 1)
      return;
    const interval = setInterval(() => {
      setCurrentWebSearchIndex((prev) => (prev + 1) % webSearchCards.length);
    }, 1e4);
    return () => clearInterval(interval);
  }, [isStreaming, webSearchCards]);
  return /* @__PURE__ */ jsxs15("div", { className: `${AnalysisSteps_module_default.thinkStep} ${isLast ? AnalysisSteps_module_default.isLastStep : ""}`, children: [
    /* @__PURE__ */ jsx22("div", { className: AnalysisSteps_module_default.iconColumn, children: showLoadingState ? /* @__PURE__ */ jsx22(Spinner2, { size: "normal" }) : /* @__PURE__ */ jsx22(Icon4, { name: "status-positive", variant: "success" }) }),
    /* @__PURE__ */ jsx22("div", { className: AnalysisSteps_module_default.textColumn, children: /* @__PURE__ */ jsxs15(SpaceBetween14, { direction: "vertical", size: "xs", children: [
      /* @__PURE__ */ jsxs15(SpaceBetween14, { direction: "vertical", size: "xxs", children: [
        /* @__PURE__ */ jsxs15("div", { className: `${AnalysisSteps_module_default.thinkStepTitle} ${showLoadingState ? AnalysisSteps_module_default.shimmerText : ""}`, children: [
          step.title,
          idleMessage && /* @__PURE__ */ jsxs15("span", { className: AnalysisSteps_module_default.idleMessage, children: [
            " \u2014 ",
            idleMessage
          ] })
        ] }),
        step.description && /* @__PURE__ */ jsx22("div", { className: AnalysisSteps_module_default.thinkStepDescription, children: step.description })
      ] }),
      step.files && step.files.length > 0 && /* @__PURE__ */ jsx22("div", { className: AnalysisSteps_module_default.fileTokenContainer, children: step.files.map((file, index) => /* @__PURE__ */ jsxs15("span", { className: AnalysisSteps_module_default.fileToken, children: [
        /* @__PURE__ */ jsx22(Icon4, { name: "file", size: "small" }),
        /* @__PURE__ */ jsx22("span", { className: AnalysisSteps_module_default.fileLabel, children: file })
      ] }, index)) }),
      isStreaming && step.listingCards && step.listingCards.length > 0 && /* @__PURE__ */ jsx22("div", { className: AnalysisSteps_module_default.productTokenContainer, children: /* @__PURE__ */ jsx22("div", { className: AnalysisSteps_module_default.fadeTransition, children: /* @__PURE__ */ jsx22(
        ProductToken,
        {
          product: convertListingCardToProduct(step.listingCards[currentTokenIndex]),
          productUrl: marketplaceLinks2.get("ListingDetails", { listingId: step.listingCards[currentTokenIndex].id })
        }
      ) }) }, `token-${currentTokenIndex}`),
      isStreaming && step.webSearchCards && step.webSearchCards.length > 0 && /* @__PURE__ */ jsx22("div", { className: AnalysisSteps_module_default.webSearchTokenContainer, children: /* @__PURE__ */ jsx22("div", { className: AnalysisSteps_module_default.fadeTransition, children: /* @__PURE__ */ jsx22(WebSearchToken, { card: step.webSearchCards[currentWebSearchIndex] }) }) }, `websearch-${currentWebSearchIndex}`),
      children
    ] }) })
  ] });
};

// src/analysis/AnalysisSteps/AnimatedDots.tsx
import Spinner3 from "@cloudscape-design/components/spinner";
import * as React81 from "react";
import { jsx as jsx23, jsxs as jsxs16 } from "react/jsx-runtime";
var AnimatedDots = ({ text }) => {
  const [dots, setDots] = React81.useState("");
  React81.useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev === "...")
          return "";
        return prev + ".";
      });
    }, 500);
    return () => clearInterval(interval);
  }, []);
  return /* @__PURE__ */ jsxs16("div", { className: AnalysisSteps_module_default.loadingSpinner, children: [
    /* @__PURE__ */ jsx23(Spinner3, {}),
    text && /* @__PURE__ */ jsx23("span", { children: text }),
    /* @__PURE__ */ jsx23("span", { className: AnalysisSteps_module_default.dots, children: dots })
  ] });
};

// src/analysis/AnalysisSteps/types.ts
var AGENT_WAIT_TIME_CONFIG = {
  search: {
    headerKey: "agentSearchWaitTimeHeader",
    descriptionKey: "agentSearchWaitTimeDescription",
    waitTimeMs: 3e4,
    value: 30,
    unitKey: "unitSeconds"
  },
  comparison: {
    headerKey: "agentComparisonWaitTimeHeader",
    descriptionKey: "agentComparisonWaitTimeDescription",
    waitTimeMs: 6e4,
    value: 1,
    unitKey: "unitMinute"
  },
  evaluation: {
    headerKey: "agentEvaluationWaitTimeHeader",
    descriptionKey: "agentEvaluationWaitTimeDescription",
    waitTimeMs: 12e4,
    value: 2,
    unitKey: "unitMinutes"
  }
};

// src/results/AskUser/access-denied-fields.ts
var MINT_SERVICE = "signin";
var MINT_ACTION = "CreateOAuth2Token";
var MINT_CONTEXT = "no identity-based policy allows signin:CreateOAuth2Token; if it is already granted, an account or organization policy is blocking it";
function resolveAccessDeniedFields(input) {
  if (input.kind === "mint-permission") {
    return {
      user: input.principalArn ?? "",
      service: MINT_SERVICE,
      action: MINT_ACTION,
      context: MINT_CONTEXT
    };
  }
  const [user, service, action, resource, context] = ARCParse({ message: input.errorMessage });
  return { user, service, action, resource: resource || void 0, context };
}

// src/results/AskUser/ToolAuthorizationPrompt.tsx
import Header from "@cloudscape-design/components/header";
import SpaceBetween16 from "@cloudscape-design/components/space-between";
import Button11 from "@cloudscape-design/components/button";
import StatusIndicator5 from "@cloudscape-design/components/status-indicator";
import Box15 from "@cloudscape-design/components/box";
import * as React83 from "react";
import { ContentBlockVisibility, describeCapability as describeCapability3 } from "@amzn/awsmp-max-model";
import { useAppTranslation as useAppTranslation15 } from "@amzn/awsmp-max-translations";

// src/results/AskUser/useImpressionMetric.ts
import * as React82 from "react";
function useImpressionMetric(logger, options) {
  const { clickAct, clickSelect, suppress = false, key } = options;
  const firedKeyRef = React82.useRef(void 0);
  React82.useEffect(() => {
    if (suppress)
      return;
    if (firedKeyRef.current === (key ?? "__default__"))
      return;
    firedKeyRef.current = key ?? "__default__";
    emitAskUserRender(logger, clickAct, clickSelect);
  }, [logger, clickAct, clickSelect, suppress, key]);
}

// src/analysis/AnalysisSteps/BaseStep.tsx
import Icon5 from "@cloudscape-design/components/icon";
import Spinner4 from "@cloudscape-design/components/spinner";
import StatusIndicator4 from "@cloudscape-design/components/status-indicator";
import { useAppTranslation as useAppTranslation13 } from "@amzn/awsmp-max-translations";
import { jsx as jsx24, jsxs as jsxs17 } from "react/jsx-runtime";
var BaseStep = ({ children, status = "neutral", isLast = false }) => {
  const { t } = useAppTranslation13();
  const stepClass = isLast ? `${AnalysisSteps_module_default.thinkStep} ${AnalysisSteps_module_default.isLastStep}` : AnalysisSteps_module_default.thinkStep;
  const textColumnClasses = [AnalysisSteps_module_default.textColumn];
  if (status === "success") {
    textColumnClasses.push(AnalysisSteps_module_default.textColumnSuccess);
  } else if (status === "error") {
    textColumnClasses.push(AnalysisSteps_module_default.textColumnError);
  } else if (status === "stopped") {
    textColumnClasses.push(AnalysisSteps_module_default.textColumnStopped);
  } else if (status === "loading" || status === "pending") {
    textColumnClasses.push(AnalysisSteps_module_default.textColumnLoading);
  }
  return /* @__PURE__ */ jsxs17("div", { className: stepClass, "data-testid": "base-step", children: [
    /* @__PURE__ */ jsxs17("div", { className: AnalysisSteps_module_default.iconColumn, children: [
      status === "loading" && /* @__PURE__ */ jsx24(Spinner4, { size: "normal" }),
      status === "pending" && /* @__PURE__ */ jsx24(StatusIndicator4, { type: "pending", iconAriaLabel: t("pendingIconAriaLabel") }),
      status === "success" && /* @__PURE__ */ jsx24(Icon5, { name: "status-positive", variant: "success", ariaLabel: t("successIconAriaLabel") }),
      status === "error" && /* @__PURE__ */ jsx24(Icon5, { name: "status-negative", variant: "error", ariaLabel: t("errorIconAriaLabel") }),
      status === "stopped" && /* @__PURE__ */ jsx24(StatusIndicator4, { type: "stopped", iconAriaLabel: t("stoppedIconAriaLabel") })
    ] }),
    /* @__PURE__ */ jsx24("div", { className: textColumnClasses.join(" "), style: { marginTop: 2 }, "data-testid": `base-step-text-${status}`, children })
  ] });
};

// src/results/AskUser/SignInPrompt.tsx
import Button10 from "@cloudscape-design/components/button";
import Box14 from "@cloudscape-design/components/box";
import Container from "@cloudscape-design/components/container";
import { useAppTranslation as useAppTranslation14 } from "@amzn/awsmp-max-translations";
import { describeCapability as describeCapability2 } from "@amzn/awsmp-max-model";

// src/results/AskUser/SignInPrompt.module.scss
var SignInPrompt_module_default = {
  fadeInScale: "SignInPrompt_module_fadeInScale",
  wrapper: "SignInPrompt_module_wrapper",
  container: "SignInPrompt_module_container",
  content: "SignInPrompt_module_content",
  buttonWrapper: "SignInPrompt_module_buttonWrapper"
};

// src/results/AskUser/SignInPrompt.tsx
import SpaceBetween15 from "@cloudscape-design/components/space-between";
import { jsx as jsx25, jsxs as jsxs18 } from "react/jsx-runtime";
var SignInPrompt = ({ onSignIn, trigger, sessionExpired = false }) => {
  const { t } = useAppTranslation14();
  const headerText = sessionExpired ? trigger ? t("authSessionExpireHeader", { action: describeCapability2(trigger) }) : t("authSessionExpireHeaderDefault") : trigger ? t("authSignInInlineHeader", { action: describeCapability2(trigger) }) : t("authSignInInlineHeaderDefault");
  return /* @__PURE__ */ jsx25(Container, { className: SignInPrompt_module_default.container, "data-testid": "sign-in-prompt", disableContentPaddings: true, children: /* @__PURE__ */ jsxs18("div", { className: SignInPrompt_module_default.content, children: [
    /* @__PURE__ */ jsxs18(SpaceBetween15, { size: "xxxs", children: [
      /* @__PURE__ */ jsx25(Box14, { fontSize: "body-m", fontWeight: "bold", children: headerText }),
      /* @__PURE__ */ jsx25(Box14, { fontSize: "body-m", color: "text-body-secondary", children: t("authSignInInlineSubtext") })
    ] }),
    /* @__PURE__ */ jsx25("div", { className: SignInPrompt_module_default.buttonWrapper, children: /* @__PURE__ */ jsx25(Button10, { iconName: "external", iconAlign: "right", onClick: onSignIn, "data-testid": "sign-in-button", children: t("authSignInButton") }) })
  ] }) });
};

// src/results/AskUser/ToolAuthorizationPrompt.module.scss
var ToolAuthorizationPrompt_module_default = {
  thinkingStep: "ToolAuthorizationPrompt_module_thinkingStep",
  iconColumn: "ToolAuthorizationPrompt_module_iconColumn",
  textColumn: "ToolAuthorizationPrompt_module_textColumn",
  textColumnSuccess: "ToolAuthorizationPrompt_module_textColumnSuccess",
  textColumnError: "ToolAuthorizationPrompt_module_textColumnError",
  toolAuthorizationWrapper: "ToolAuthorizationPrompt_module_toolAuthorizationWrapper",
  fadeInScale: "ToolAuthorizationPrompt_module_fadeInScale",
  toolAuthorizationContainer: "ToolAuthorizationPrompt_module_toolAuthorizationContainer",
  fieldLabel: "ToolAuthorizationPrompt_module_fieldLabel",
  fieldValue: "ToolAuthorizationPrompt_module_fieldValue",
  accountActionFields: "ToolAuthorizationPrompt_module_accountActionFields",
  buttonSection: "ToolAuthorizationPrompt_module_buttonSection"
};

// src/results/AskUser/ToolAuthorizationPrompt.tsx
import { Fragment as Fragment12, jsx as jsx26, jsxs as jsxs19 } from "react/jsx-runtime";
var ToolAuthorizationPrompt = ({
  status,
  data,
  output,
  toolUseId,
  sendMessage,
  authManager,
  logger,
  isTurnProcessing = false,
  isLast = false
}) => {
  if (status === "resolved" /* Resolved */) {
    return /* @__PURE__ */ jsx26(ResolvedToolAuthorization, { data, output, isLast });
  }
  return /* @__PURE__ */ jsx26(
    ActiveToolAuthorization,
    {
      data,
      toolUseId,
      sendMessage,
      authManager,
      logger,
      isTurnProcessing,
      isLast
    }
  );
};
var ActiveToolAuthorization = ({
  data,
  toolUseId,
  sendMessage,
  authManager,
  logger,
  isTurnProcessing,
  isLast = false
}) => {
  const { t } = useAppTranslation15();
  const [phase, setPhase] = React83.useState("user-approval-required" /* UserApprovalRequired */);
  const mountedRef = React83.useRef(true);
  React83.useEffect(
    () => () => {
      mountedRef.current = false;
    },
    []
  );
  const sendAnswer = React83.useCallback(
    (decisions) => {
      sendMessage([
        {
          toolOutput: {
            toolUseId,
            name: "askUser",
            output: { askUser: { responseFormat: "toolAuthorization", decisions } },
            status: "COMPLETE"
          },
          visibility: ContentBlockVisibility.DISPLAY_ONLY
        }
      ]);
    },
    [sendMessage, toolUseId]
  );
  const [stepIndex, setStepIndex] = React83.useState(0);
  const [collectedDecisions, setCollectedDecisions] = React83.useState([]);
  const currentHeldTool = data.heldTools[stepIndex];
  const actionDescription = describeCapability3(currentHeldTool.toolName);
  const capitalizedAction = actionDescription ? actionDescription.charAt(0).toUpperCase() + actionDescription.slice(1) : actionDescription;
  useImpressionMetric(logger, {
    clickAct: BI_CLICK_ACT_TOOL_AUTH_PROMPT_SHOWN,
    clickSelect: currentHeldTool.toolName,
    key: currentHeldTool.toolUseId
  });
  const decideAll = React83.useCallback(
    (decision) => data.heldTools.map((heldTool) => ({ toolUseId: heldTool.toolUseId, decision })),
    [data.heldTools]
  );
  const recordAndAdvance = React83.useCallback(
    (decision) => {
      const decided = [...collectedDecisions, { toolUseId: currentHeldTool.toolUseId, decision }];
      if (decided.length === data.heldTools.length) {
        setPhase("submitted-answer" /* SubmittedAnswer */);
        sendAnswer(decided);
        return;
      }
      setCollectedDecisions(decided);
      setStepIndex((index) => index + 1);
      setPhase("user-approval-required" /* UserApprovalRequired */);
    },
    [collectedDecisions, currentHeldTool, data.heldTools.length, sendAnswer]
  );
  const handleApprove = React83.useCallback(async () => {
    emitAskUserSubmit(logger, BI_CLICK_ACT_APPROVE);
    setPhase("creating-token" /* CreatingToken */);
    let outcome;
    try {
      outcome = await authManager.onAuthRequired();
    } catch (error) {
      logger.error("Sign-in token mint failed", error instanceof Error ? error : void 0);
      if (mountedRef.current) {
        setPhase("failed-token-creation" /* FailedTokenCreation */);
      }
      return;
    }
    if (!mountedRef.current) {
      return;
    }
    if (outcome.type === "token") {
      recordAndAdvance("approve");
    } else if (outcome.type === "permission-required") {
      setPhase("mint-permission-denied" /* MintPermissionDenied */);
    } else {
      setPhase("session-reset-required" /* SessionResetRequired */);
    }
  }, [authManager, logger, recordAndAdvance]);
  const handleResetAndSignIn = React83.useCallback(() => {
    emitAskUserSubmit(logger, BI_CLICK_ACT_SESSION_RESET_SIGN_IN);
    authManager.resetSessionAndSignIn();
  }, [authManager, logger]);
  const handleStepDecline = () => {
    emitAskUserSubmit(logger, BI_CLICK_ACT_DENY);
    recordAndAdvance("deny");
  };
  const handleDeclineAll = () => {
    emitAskUserSubmit(logger, BI_CLICK_ACT_DENY);
    setPhase("submitted-answer" /* SubmittedAnswer */);
    sendAnswer(decideAll("deny"));
  };
  const headerText = actionDescription ? t("toolAuthorizationHeader", { action: actionDescription }) : t("toolAuthorizationHeaderDefault");
  if (phase === "creating-token" /* CreatingToken */) {
    return /* @__PURE__ */ jsx26(StatusIndicator5, { type: "loading", children: t("toolAuthorizationChecking") });
  }
  if (phase === "submitted-answer" /* SubmittedAnswer */) {
    return /* @__PURE__ */ jsx26(BaseStep, { status: "loading", isLast, children: t("approvingAgentMode", { action: actionDescription || currentHeldTool.toolName }) });
  }
  if (phase === "failed-token-creation" /* FailedTokenCreation */) {
    return /* @__PURE__ */ jsx26(BaseStep, { status: "error", isLast, children: /* @__PURE__ */ jsxs19("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }, children: [
      /* @__PURE__ */ jsx26("span", { children: t("errorOccurredTryAgain") }),
      /* @__PURE__ */ jsx26(Button11, { variant: "normal", onClick: () => void handleApprove(), children: t("retry") })
    ] }) });
  }
  if (phase === "session-reset-required" /* SessionResetRequired */) {
    return /* @__PURE__ */ jsxs19(Fragment12, { children: [
      /* @__PURE__ */ jsx26(BaseStep, { status: "pending", isLast: true, children: t("waitingForApproval") }),
      /* @__PURE__ */ jsx26("div", { className: SignInPrompt_module_default.wrapper, children: /* @__PURE__ */ jsx26(SignInPrompt, { onSignIn: handleResetAndSignIn, trigger: currentHeldTool.toolName, sessionExpired: true }) })
    ] });
  }
  if (phase === "mint-permission-denied" /* MintPermissionDenied */) {
    return /* @__PURE__ */ jsxs19(SpaceBetween16, { size: "s", children: [
      /* @__PURE__ */ jsx26(StatusIndicator5, { type: "warning", children: t("signInPermissionRequired") }),
      /* @__PURE__ */ jsx26(SpaceBetween16, { direction: "horizontal", size: "xs", children: /* @__PURE__ */ jsx26(Button11, { variant: "link", onClick: handleDeclineAll, children: t("signInDecline") }) })
    ] });
  }
  const accountMatch = currentHeldTool.message.match(/account\s+([\d-]+)/i);
  const accountId = accountMatch ? accountMatch[1] : "\u2014";
  return /* @__PURE__ */ jsxs19(Fragment12, { children: [
    /* @__PURE__ */ jsx26(BaseStep, { status: "pending", isLast, children: t("waitingForApproval") }),
    /* @__PURE__ */ jsx26(
      "div",
      {
        "data-analytics": "tool-authorization-section",
        "data-analytics-type": "context",
        "data-analytics-render": true,
        className: ToolAuthorizationPrompt_module_default.toolAuthorizationWrapper,
        children: /* @__PURE__ */ jsxs19("div", { className: ToolAuthorizationPrompt_module_default.toolAuthorizationContainer, children: [
          /* @__PURE__ */ jsx26(Header, { variant: "h3", children: headerText }),
          /* @__PURE__ */ jsx26(Box15, { margin: { top: "s" }, children: /* @__PURE__ */ jsxs19(SpaceBetween16, { size: "s", children: [
            /* @__PURE__ */ jsxs19("div", { className: ToolAuthorizationPrompt_module_default.accountActionFields, children: [
              /* @__PURE__ */ jsxs19(Box15, { children: [
                /* @__PURE__ */ jsx26("span", { className: ToolAuthorizationPrompt_module_default.fieldLabel, children: t("fieldLabelAccount") }),
                " ",
                /* @__PURE__ */ jsx26("span", { className: ToolAuthorizationPrompt_module_default.fieldValue, children: accountId })
              ] }),
              /* @__PURE__ */ jsxs19(Box15, { children: [
                /* @__PURE__ */ jsx26("span", { className: ToolAuthorizationPrompt_module_default.fieldLabel, children: t("fieldLabelAction") }),
                " ",
                /* @__PURE__ */ jsx26("span", { className: ToolAuthorizationPrompt_module_default.fieldValue, children: capitalizedAction || currentHeldTool.toolName })
              ] })
            ] }),
            data.heldTools.length > 1 && /* @__PURE__ */ jsx26(Box15, { color: "text-body-secondary", children: t("toolAuthorizationStepCounter", { current: stepIndex + 1, total: data.heldTools.length }) }),
            /* @__PURE__ */ jsx26("div", { className: ToolAuthorizationPrompt_module_default.buttonSection, children: /* @__PURE__ */ jsxs19(SpaceBetween16, { direction: "horizontal", size: "xs", children: [
              /* @__PURE__ */ jsx26(Button11, { variant: "link", onClick: handleStepDecline, disabled: isTurnProcessing, children: t("signInDecline") }),
              /* @__PURE__ */ jsx26(Button11, { variant: "normal", onClick: () => void handleApprove(), disabled: isTurnProcessing, children: t("allow") })
            ] }) })
          ] }) })
        ] })
      }
    )
  ] });
};
var ResolvedToolAuthorization = ({
  data,
  output,
  isLast = false
}) => {
  const { t } = useAppTranslation15();
  if (!output) {
    return null;
  }
  const decisions = new Map(
    output.responseFormat === "toolAuthorization" ? output.decisions.map((decision) => [decision.toolUseId, decision.decision]) : []
  );
  const allApproved = data.heldTools.every((heldTool) => decisions.get(heldTool.toolUseId) === "approve");
  const allDenied = data.heldTools.every((heldTool) => decisions.get(heldTool.toolUseId) === "deny");
  const firstAction = data.heldTools.length > 0 ? describeCapability3(data.heldTools[0].toolName) : "";
  if (allApproved) {
    return /* @__PURE__ */ jsx26(BaseStep, { status: "success", isLast, children: t("allowedAgentMode", { action: firstAction }) });
  }
  if (allDenied) {
    return /* @__PURE__ */ jsx26(BaseStep, { status: "stopped", isLast, children: t("declinedAgentMode", { action: firstAction }) });
  }
  return /* @__PURE__ */ jsx26(Fragment12, { children: data.heldTools.map((heldTool, idx) => {
    const approved = decisions.get(heldTool.toolUseId) === "approve";
    const action = describeCapability3(heldTool.toolName);
    const isLastItem = isLast && idx === data.heldTools.length - 1;
    return /* @__PURE__ */ jsx26(BaseStep, { status: approved ? "success" : "stopped", isLast: isLastItem, children: approved ? t("allowedAgentMode", { action }) : t("declinedAgentMode", { action }) }, heldTool.toolUseId);
  }) });
};

// src/results/AskUser/AuthenticationRequestPrompt.tsx
import Button12 from "@cloudscape-design/components/button";
import * as React84 from "react";
import { ContentBlockVisibility as ContentBlockVisibility2, describeCapability as describeCapability4 } from "@amzn/awsmp-max-model";
import { useAppTranslation as useAppTranslation16 } from "@amzn/awsmp-max-translations";
import { Fragment as Fragment13, jsx as jsx27, jsxs as jsxs20 } from "react/jsx-runtime";
var AuthenticationRequestPrompt = ({
  status,
  data,
  output,
  toolUseId,
  sendMessage,
  authManager,
  logger,
  isTurnProcessing = false,
  isLast = false
}) => {
  if (status === "resolved" /* Resolved */) {
    return /* @__PURE__ */ jsx27(ResolvedAuthenticationRequest, { output, isLast });
  }
  return /* @__PURE__ */ jsx27(
    ActiveAuthenticationRequest,
    {
      data,
      toolUseId,
      sendMessage,
      authManager,
      logger,
      isTurnProcessing,
      isLast
    }
  );
};
var entryPhase = (authManager) => {
  if (authManager.isAuthenticatedWithMAX()) {
    return "continuing" /* Continuing */;
  }
  if (authManager.hasAwsSession()) {
    return "authenticate" /* Authenticate */;
  }
  return "sign-in" /* SignIn */;
};
var ActiveAuthenticationRequest = ({
  data,
  toolUseId,
  sendMessage,
  authManager,
  logger,
  isLast = false,
  isTurnProcessing
}) => {
  const { t } = useAppTranslation16();
  const [phase, setPhase] = React84.useState(() => entryPhase(authManager));
  const [sessionExpired, setSessionExpired] = React84.useState(false);
  const initialPhaseRef = React84.useRef(phase);
  const impressionClickAct = initialPhaseRef.current === "sign-in" /* SignIn */ ? BI_CLICK_ACT_SIGN_IN_PROMPT_SHOWN : BI_CLICK_ACT_SIGN_IN_COMPLETED;
  useImpressionMetric(logger, {
    clickAct: impressionClickAct,
    clickSelect: data.trigger,
    suppress: initialPhaseRef.current === "continuing" /* Continuing */
  });
  const mountedRef = React84.useRef(true);
  React84.useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const sendAnswer = React84.useCallback(
    (outcome) => {
      sendMessage([
        {
          toolOutput: {
            toolUseId,
            name: "askUser",
            output: { askUser: { responseFormat: "authenticate", outcome } },
            status: "COMPLETE"
          },
          visibility: ContentBlockVisibility2.DISPLAY_AND_INFERENCE
        }
      ]);
    },
    [sendMessage, toolUseId]
  );
  const answeredRef = React84.useRef(false);
  React84.useEffect(() => {
    if (answeredRef.current)
      return;
    if (isTurnProcessing)
      return;
    const outcome = phase === "continuing" /* Continuing */ ? "authenticated" : phase === "permission-required" /* PermissionRequired */ ? "permission-required" : void 0;
    if (outcome) {
      answeredRef.current = true;
      sendAnswer(outcome);
    }
  }, [phase, sendAnswer, isTurnProcessing]);
  const handleAuthenticate = React84.useCallback(async () => {
    setPhase("authenticating" /* Authenticating */);
    let outcome;
    try {
      outcome = await authManager.onAuthRequired();
    } catch (error) {
      logger.error("Authentication mint failed", error instanceof Error ? error : void 0);
      if (mountedRef.current) {
        setPhase("transport-failed" /* TransportFailed */);
      }
      return;
    }
    if (!mountedRef.current) {
      return;
    }
    if (outcome.type === "token") {
      emitAskUserRender(logger, BI_CLICK_ACT_AUTH_COMPLETED, data.trigger);
      setPhase("continuing" /* Continuing */);
    } else if (outcome.type === "permission-required") {
      emitAskUserRender(logger, BI_CLICK_ACT_AUTH_PERMISSION_REQUIRED, data.trigger);
      setPhase("permission-required" /* PermissionRequired */);
    } else {
      setSessionExpired(true);
      setPhase("sign-in" /* SignIn */);
    }
  }, [authManager, data.trigger, logger]);
  const startedRef = React84.useRef(false);
  React84.useEffect(() => {
    if (phase === "authenticate" /* Authenticate */ && !startedRef.current) {
      startedRef.current = true;
      void handleAuthenticate();
    }
  }, [phase, handleAuthenticate]);
  const handleSignIn = React84.useCallback(() => {
    if (sessionExpired) {
      emitAskUserSubmit(logger, BI_CLICK_ACT_SESSION_RESET_SIGN_IN, data.trigger);
      authManager.resetSessionAndSignIn();
      return;
    }
    emitAskUserSubmit(logger, BI_CLICK_ACT_SIGN_IN, data.trigger);
    authManager.startSignIn();
  }, [authManager, data.trigger, logger, sessionExpired]);
  if (phase === "permission-required" /* PermissionRequired */) {
    return null;
  }
  const actionText = data.trigger ? t("authContinuingAction", { action: describeCapability4(data.trigger) }) : t("authContinuing");
  if (phase === "authenticate" /* Authenticate */ || phase === "authenticating" /* Authenticating */ || phase === "continuing" /* Continuing */) {
    return /* @__PURE__ */ jsx27(BaseStep, { status: "loading", isLast, children: actionText });
  }
  if (phase === "transport-failed" /* TransportFailed */) {
    return /* @__PURE__ */ jsx27(BaseStep, { status: "error", isLast, children: /* @__PURE__ */ jsxs20("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }, children: [
      /* @__PURE__ */ jsx27("span", { children: t("errorOccurredTryAgain") }),
      /* @__PURE__ */ jsx27(
        Button12,
        {
          variant: "normal",
          onClick: () => {
            emitAskUserSubmit(logger, BI_CLICK_ACT_AUTHENTICATE_RETRY, data.trigger);
            void handleAuthenticate();
          },
          children: t("retry")
        }
      )
    ] }) });
  }
  return /* @__PURE__ */ jsxs20(Fragment13, { children: [
    /* @__PURE__ */ jsx27(BaseStep, { status: "pending", isLast: true, children: actionText }),
    /* @__PURE__ */ jsx27("div", { className: SignInPrompt_module_default.wrapper, children: /* @__PURE__ */ jsx27(SignInPrompt, { onSignIn: handleSignIn, trigger: data.trigger, sessionExpired }) })
  ] });
};
var ResolvedAuthenticationRequest = ({ output, isLast = false }) => {
  const { t } = useAppTranslation16();
  if (!output) {
    return null;
  }
  const outcome = output.responseFormat === "authenticate" ? output.outcome : void 0;
  if (outcome === "authenticated" || outcome === "permission-required") {
    return null;
  }
  return /* @__PURE__ */ jsx27(BaseStep, { isLast, status: "error", children: t("errorOccurred") });
};

// src/analysis/AnalysisSteps/AnalysisSteps.tsx
import { jsx as jsx28, jsxs as jsxs21 } from "react/jsx-runtime";
var AnalysisSteps = ({ data, status, isTurnProcessing = false, agent, logger, rendererAPI }) => {
  const { t } = useAppTranslation17();
  const timelineItems = data.items;
  const thinkStepCount = timelineItems.filter((item) => item.type === "thinkStep").length;
  const agentWaitTime = agent?.agentId && agent.agentId in AGENT_WAIT_TIME_CONFIG ? AGENT_WAIT_TIME_CONFIG[agent.agentId] : null;
  const containerRef = React85.useRef(null);
  const [showTopFade, setShowTopFade] = React85.useState(false);
  const [showBottomFade, setShowBottomFade] = React85.useState(false);
  const [showScrollButton, setShowScrollButton] = React85.useState(false);
  const shouldAutoScroll = React85.useRef(true);
  const isProgrammaticScroll = React85.useRef(false);
  const waitTimeMetricEmitted = React85.useRef(false);
  const isLatestMessage = rendererAPI?.isLatestMessage ?? true;
  const isStreaming = status === MessageStatus2.Streaming || isLatestMessage && isTurnProcessing;
  const { showIdleState, resetTimer } = useTipCardTimer({
    delayMs: 15e3,
    enabled: isStreaming
  });
  const [tipCardShown, setTipCardShown] = React85.useState(false);
  React85.useEffect(() => {
    if (showIdleState) {
      setTipCardShown(true);
    }
  }, [showIdleState]);
  React85.useEffect(() => {
    if (thinkStepCount > 0) {
      resetTimer();
    }
  }, [thinkStepCount, resetTimer]);
  React85.useEffect(() => {
    if (isStreaming) {
      waitTimeMetricEmitted.current = false;
    }
  }, [isStreaming]);
  React85.useEffect(() => {
    if (!isStreaming || !agentWaitTime || !logger || waitTimeMetricEmitted.current) {
      return;
    }
    const timer = setTimeout(() => {
      if (!waitTimeMetricEmitted.current) {
        waitTimeMetricEmitted.current = true;
        logger.opsMetric({
          metricName: "AgentWaitTimeExceeded",
          unit: "Count",
          value: 1,
          dimensions: {
            agentId: agent?.agentId ?? "unknown",
            expectedWaitTimeMs: String(agentWaitTime.waitTimeMs)
          }
        });
      }
    }, agentWaitTime.waitTimeMs);
    return () => clearTimeout(timer);
  }, [isStreaming, agentWaitTime, logger, agent?.agentId]);
  const updateFades = React85.useCallback(() => {
    if (containerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
      const hasOverflow = scrollHeight > clientHeight;
      if (!hasOverflow) {
        setShowTopFade(false);
        setShowBottomFade(false);
        setShowScrollButton(false);
      } else {
        const isAtTop = scrollTop <= 10;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
        setShowTopFade(!isAtTop);
        setShowBottomFade(!isAtBottom);
        setShowScrollButton(!shouldAutoScroll.current && !isAtBottom);
      }
    }
  }, []);
  React85.useEffect(() => {
    if (!shouldAutoScroll.current || !containerRef.current)
      return;
    isProgrammaticScroll.current = true;
    containerRef.current.scrollTop = containerRef.current.scrollHeight;
    updateFades();
    setTimeout(() => {
      isProgrammaticScroll.current = false;
    }, 100);
  }, [timelineItems.length, updateFades]);
  React85.useEffect(() => {
    const container = containerRef.current;
    if (!container)
      return;
    let isUserScrolling = false;
    const handleUserGesture = () => {
      isUserScrolling = true;
    };
    const handleScroll = () => {
      updateFades();
      if (isProgrammaticScroll.current)
        return;
      if (isUserScrolling) {
        shouldAutoScroll.current = false;
        isUserScrolling = false;
        updateFades();
      }
    };
    const handleKeyDown = (e) => {
      if (container.contains(document.activeElement) || container.contains(e.target)) {
        if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "].includes(e.key)) {
          handleUserGesture();
        }
      }
    };
    container.addEventListener("wheel", handleUserGesture, { passive: true });
    container.addEventListener("touchmove", handleUserGesture, { passive: true });
    container.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("keydown", handleKeyDown);
    updateFades();
    return () => {
      container.removeEventListener("wheel", handleUserGesture);
      container.removeEventListener("touchmove", handleUserGesture);
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [updateFades]);
  React85.useEffect(() => {
    if (isStreaming) {
      shouldAutoScroll.current = true;
      setShowScrollButton(false);
    }
  }, [isStreaming]);
  const handleScrollToBottom = React85.useCallback(() => {
    if (containerRef.current) {
      shouldAutoScroll.current = true;
      isProgrammaticScroll.current = true;
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth"
      });
      setShowScrollButton(false);
      updateFades();
      setTimeout(() => {
        isProgrammaticScroll.current = false;
      }, 100);
    }
  }, [updateFades]);
  const lastThinkStepIndex = React85.useMemo(
    () => timelineItems.reduce((last, item, idx) => item.type === "thinkStep" ? idx : last, -1),
    [timelineItems]
  );
  const isLastThinkStepFinal = lastThinkStepIndex === timelineItems.length - 1;
  if (timelineItems.length === 0 && !isStreaming) {
    return null;
  }
  return /* @__PURE__ */ jsxs21(Box16, { children: [
    agentWaitTime && isStreaming && /* @__PURE__ */ jsx28(Box16, { margin: { bottom: "s" }, children: /* @__PURE__ */ jsx28(Header2, { variant: "h3", description: t(agentWaitTime.descriptionKey, { value: agentWaitTime.value, unit: t(agentWaitTime.unitKey) }), children: t(agentWaitTime.headerKey) }) }),
    /* @__PURE__ */ jsxs21("div", { className: AnalysisSteps_module_default.analysisStepsWrapper, children: [
      /* @__PURE__ */ jsx28(
        "div",
        {
          ref: containerRef,
          "data-testid": "analysis-steps-scroll-container",
          className: `${AnalysisSteps_module_default.analysisStepsContainer} ${showTopFade ? AnalysisSteps_module_default.hasTopFade : ""} ${showBottomFade ? AnalysisSteps_module_default.hasBottomFade : ""}`,
          children: /* @__PURE__ */ jsxs21(SpaceBetween17, { size: "xxxs", children: [
            timelineItems.map((item, idx) => {
              if (item.type === "thinkStep") {
                const isLastThinkStep = idx === lastThinkStepIndex;
                const isLastInTimeline = isLastThinkStep && isLastThinkStepFinal;
                return /* @__PURE__ */ jsx28(
                  ThinkStep,
                  {
                    step: item.step,
                    isStreaming,
                    isLast: isLastInTimeline,
                    idleMessage: isLastInTimeline && showIdleState ? "I'm still working, but this might take a moment." : void 0,
                    children: isLastInTimeline && tipCardShown && /* @__PURE__ */ jsx28(Box16, { margin: { top: "xs" }, children: /* @__PURE__ */ jsx28(TipCard, { tips: AWS_MARKETPLACE_TIPS, autoRotateInterval: 1e4 }) })
                  },
                  `think-step-${item.index}`
                );
              }
              if (item.type === "toolAuth" && rendererAPI) {
                const isResolved = Boolean(item.block.output) || rendererAPI.isLatestMessage === false;
                const isLastItem = idx === timelineItems.length - 1;
                return /* @__PURE__ */ jsx28(
                  ToolAuthorizationPrompt,
                  {
                    status: isResolved ? "resolved" /* Resolved */ : "active" /* Active */,
                    data: item.block.data,
                    output: item.block.output,
                    toolUseId: item.block.toolUseId,
                    sendMessage: rendererAPI.sendMessage,
                    authManager: rendererAPI.authManager,
                    logger: rendererAPI.logger,
                    isLast: isLastItem,
                    isTurnProcessing
                  },
                  `tool-auth-${item.block.toolUseId}`
                );
              }
              if (item.type === "authenticate" && rendererAPI) {
                const isResolved = Boolean(item.block.output) || rendererAPI.isLatestMessage === false;
                const isLastItem = idx === timelineItems.length - 1;
                return /* @__PURE__ */ jsx28(
                  AuthenticationRequestPrompt,
                  {
                    status: isResolved ? "resolved" /* Resolved */ : "active" /* Active */,
                    data: item.block.data,
                    output: item.block.output,
                    toolUseId: item.block.toolUseId,
                    sendMessage: rendererAPI.sendMessage,
                    authManager: rendererAPI.authManager,
                    logger: rendererAPI.logger,
                    isLast: isLastItem,
                    isTurnProcessing
                  },
                  `authenticate-${item.block.toolUseId}`
                );
              }
              if (item.type === "accessDenied") {
                const isLastItem = idx === timelineItems.length - 1;
                const { kind, toolName, errorMessage } = item.block;
                const fields = kind === "mint-permission" ? resolveAccessDeniedFields({ kind, principalArn: rendererAPI?.authManager.getPrincipalArn() }) : resolveAccessDeniedFields({ kind, errorMessage: errorMessage ?? "" });
                return /* @__PURE__ */ jsx28("div", { className: AnalysisSteps_module_default.authBlockItem, children: /* @__PURE__ */ jsx28(AccessDeniedPopover2, { kind, toolName, ...fields, isLast: isLastItem }) }, `access-denied-${item.block.id}`);
              }
              return null;
            }),
            isStreaming && timelineItems.length === 0 && /* @__PURE__ */ jsx28(AnimatedDots, {})
          ] })
        }
      ),
      showScrollButton && /* @__PURE__ */ jsx28("div", { className: AnalysisSteps_module_default.scrollButtonContainer, "data-testid": "analysis-steps-scroll-button", children: /* @__PURE__ */ jsx28(Button13, { variant: "normal", iconName: "angle-down", onClick: handleScrollToBottom, ariaLabel: "Scroll to bottom" }) })
    ] })
  ] });
};
export {
  AccessDeniedPopover2 as AccessDeniedPopover,
  AnalysisSteps,
  Annotate,
  AskUser,
  ComparisonActions,
  ContentBlock,
  DEFAULT_AUTO_DISMISS_MS,
  Feedback,
  FeedbackForm,
  InlineThink,
  LinkToArtifact,
  MAX_FEEDBACK_TEXT_LENGTH,
  Message,
  NotificationBlock,
  PricingAnnotation,
  ProvideRequirementsAnnotation,
  RecommendUnits,
  RenderToDomWrapper,
  SEARCH_V2_ARTIFACT_TYPE,
  SourcesList,
  Text,
  ThinkStep,
  WebSearch,
  WebSearchDocument,
  chooseSearchRenderer,
  createArtifactThumbnailComponents,
  createSplitPanelArtifactComponents,
  useRecommendUnits
};
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

react-is/cjs/react-is.development.js:
  (**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

@amzn/awsui-component-toolkit-internal/lib/vendor/index.js:
  (*! Bundled license information:
  
  @amzn/awt-utils-internal/dist/i18n/index.js:
    (* istanbul ignore file -- @preserve *)
  
  @amzn/awt-module-api/dist/utils/module-utils.js:
    (* istanbul ignore next -- @preserve *)
  *)
*/
//# sourceMappingURL=main.js.map
